webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var core = __webpack_require__(68);
var hide = __webpack_require__(50);
var redefine = __webpack_require__(51);
var ctx = __webpack_require__(61);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(962), __esModule: true };

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(464);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(465);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(985);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(989);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(465);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(21)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint no-process-env:0 */var _=__webpack_require__(8);var _require=__webpack_require__(1069),createFpSignature=_require.createFpSignature;var defaultConfig=__webpack_require__(1170);var dev=__webpack_require__(1171);var prod=__webpack_require__(1172);var docker=__webpack_require__(1173);var stage=__webpack_require__(1174);/**
 * Get the current environment
 * @param   {String} env The current environment
 * @returns {JSON} Returns the application configuration
 */function getEnvironmentConfig(env){return{dev:dev,stage:stage,prod:prod,docker:docker}[env]||defaultConfig;}var appEnv=getEnvironmentConfig("prod");var fpData=createFpSignature(Object({"NODE_ENV":"production","APP_ENV":"prod","ENABLE_STATSD":false,"HEADER_BIDDING":true}).FP_SECRET);var port={server:{port:Object({"NODE_ENV":"production","APP_ENV":"prod","ENABLE_STATSD":false,"HEADER_BIDDING":true}).APP_PORT}};/**
 * Merges default, env, and custom props
 * @param   {Object} custom This parameter is a custom configuration object.
 * @returns {Object} The environmental configuration of the current build.
 */module.exports=function(){var custom=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _.merge({},defaultConfig,appEnv,custom,port,fpData);};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1070)
var ieee754 = __webpack_require__(1071)
var isArray = __webpack_require__(497)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setVirtualPageView=setVirtualPageView;exports.getGATags=getGATags;exports.getObitGAEventLabel=getObitGAEventLabel;exports.gaClickHandler=gaClickHandler;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _constants=__webpack_require__(41);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Pushes GA Virtual PageViews to the dataLayer
 * @param   {String}    pageViewPath The path for the GA pageview
 * @return  {Undefined} Returns nothing
 */function setVirtualPageView(pageViewPath){if(typeof window!=='undefined'){window.dataLayer.push({event:'analyticsVPV',vpvName:pageViewPath});}}/**
 * Pushes GA tags to the dataLayer
 * @param   {Object}    obj The GA tag infromation for a particular event
 * @return  {Undefined} Returns nothing
 */function getGATags(obj){if(_lodash2.default.isObject(obj)){var pushedTracking=_lodash2.default.cloneDeep(obj);pushedTracking.event='GAEvent';if(typeof window!=='undefined'){window.dataLayer.push(pushedTracking);}}}/**
 * Gets the ga event label from the obit
 * @method getObitGAEventLabel
 * @param  {Object}  obit The obituary to get affiliate information from
 * @return {String}  Returns the event label with type, name and id
 */function getObitGAEventLabel(obit){var eventLabel=null;var _ref=obit||{},gaSitename=_ref.gaSitename,funeralHomeId=_ref.funeralHomeId;if(gaSitename){if(gaSitename==='legacy'){eventLabel='legacy_obit';}else{var funeralHomes=['batesville',_constants.GA_SITENAMES.dignityMemorial,_constants.GA_SITENAMES.tributes];var affiliateType=_lodash2.default.find(funeralHomes,function(fh){return fh===gaSitename;})?'fh':'np';if(affiliateType==='fh'&&funeralHomeId){eventLabel=affiliateType+'_'+gaSitename+'_'+funeralHomeId+'_obit';}else{eventLabel=affiliateType+'_'+gaSitename+'_obit';}}}return eventLabel;}/**
 * A function to be placed in onClick for analytics tracking
 * @method gaClickHandler
 * @param  {String}          eventCategory Google event category
 * @param  {String}          eventAction   Google event action
 * @param  {Object|String}   eventLabel    Information about the event label
 * @return {Function} Returns a function that will run getGATags
 */function gaClickHandler(eventCategory,eventAction,eventLabel){return function(){getGATags({eventCategory:eventCategory,eventAction:eventAction,eventLabel:_lodash2.default.isString(eventLabel)?eventLabel:getObitGAEventLabel(eventLabel)});};}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(180)('wks');
var uid = __webpack_require__(101);
var Symbol = __webpack_require__(14).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.bindMethods=bindMethods;exports.handleAccessibleKeyDown=handleAccessibleKeyDown;exports.isInferiorBrowser=isInferiorBrowser;exports.setRef=setRef;exports.getMediaType=getMediaType;exports.getMediaExtension=getMediaExtension;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Utility method for binding methods in component constructors
 * @param  {Object} context context to bind to
 * @param  {Array} methods  methods The array of method names
 * @return {Undefined} Returns nothing
 */function bindMethods(context,methods){_lodash2.default.forEach(methods,function(method){if(_lodash2.default.isFunction(context[method])){context[method]=context[method].bind(context);}});}/**
 * Handler for the keydown event to add accessibility to non accessible html elements
 * @param  {Object}   e Event
 * @param  {Function} callback Function to call after keydown
 * @return {Undefined} Returns nothing
 */function handleAccessibleKeyDown(e,callback){var code=e.keyCode?e.keyCode:e.which;var ENTER=13;var SPACEBAR=32;if(code===ENTER||code===SPACEBAR){e.preventDefault();e.stopPropagation();return callback();}}/**
 * Detects if using an inferior browser or not
 * @param {Object} navigator The browser navigator object
 * @return {Boolean} If the current browser is inferior
 */function isInferiorBrowser(navigator){return!_lodash2.default.isObject(navigator)||navigator.userAgent.indexOf('MSIE ')>-1||navigator.appName==='Microsoft Internet Explorer'||navigator.appName==='Netscape'&&new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})').exec(navigator.userAgent)!==null||navigator.userAgent.indexOf('Firefox')>-1;}/**
 * Generic set ref method
 * @param {Element|Object} ref The ref to element/instance
 * @param {String} key The key to be stored on the instance
 * @param {Object} context The context to be set to
 * @returns {Undefined} Returns nothing
 */function setRef(ref,key,context){if(ref&&_lodash2.default.isString(key)){context[key]=ref;}}/**
 * Determines the file type
 * @method getMediaType
 * @param  {string} mimetype epxected format: <type>/<extension>
 * @return {string} returns the file type for display
 */function getMediaType(mimetype){var type=_lodash2.default.isString(mimetype)?mimetype.substr(0,mimetype.indexOf('/')):'default';var types={video:'Video',image:'Photo',audio:'Audio',default:'Item'};return types[type]||types.default;}/**
 * Determine the file extension via the mimetype
 * @method getMediaExtension
 * @param  {string} mimetype epxected format: <type>/<extension>
 * @return {string} returns the file extension
 */function getMediaExtension(mimetype){return _lodash2.default.isString(mimetype)?_lodash2.default.last(mimetype.split('/')):'';}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(220);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.buildUrl=buildUrl;exports.getMapUrl=getMapUrl;exports.updateHistory=updateHistory;exports.formatNameString=formatNameString;exports.buildObitFlowersUrl=buildObitFlowersUrl;exports.buildFuneralHomeFlowersUrl=buildFuneralHomeFlowersUrl;exports.buildAffiliateUrl=buildAffiliateUrl;exports.ensureProtocol=ensureProtocol;exports.addQueryParams=addQueryParams;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _url=__webpack_require__(540);var _url2=_interopRequireDefault(_url);var _qs=__webpack_require__(541);var _qs2=_interopRequireDefault(_qs);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var config=(0,_AppConfig2.default)();/**
 * Simple URL builder
 * @param  {String} fullDomain The full domain including protocol
 * @param  {String} pathName The path in the url
 * @param  {Array} queryParams Array of query param objects
 * @return {String} The built url
 */function buildUrl(fullDomain,pathName,queryParams){var url='';if(fullDomain){var builtDomain=fullDomain?fullDomain.replace(/[\/\\]+$/,''):'';var builtPathName=pathName?pathName.replace(/^[\/\\]+/,''):'';var queryParamStrings=[];_lodash2.default.each(queryParams,function(paramObj){if(paramObj.key&&paramObj.value){queryParamStrings.push(paramObj.key+'='+paramObj.value);}});var queryParamSeparator=queryParamStrings.length>0?'?':'';url=builtDomain+'/'+builtPathName+queryParamSeparator+queryParamStrings.join('&');}return url;}/**
 * Constructs a maps address link
 * @param  {String} address Address
 * @return {String} Formatted google maps address URL
 */function getMapUrl(address){if(address){return('https://www.google.com/maps/search/?api=1&query='+address).replace(/\s/g,'+');}return'';}/**
 * updates window history
 * @param  {Object} window            window object
 * @param  {Object} location          react router location object
 * @param  {string} layout            guestbook or obit
 * @param  {boolean} allowGuestBook   is guestbook allowed
 * @param  {number} pid               person id
 * @param  {number} page              current page number
 * @return {undefined}                returns nothing
 */function updateHistory(window,location,layout,allowGuestBook,pid,page){var url=window.location,history=window.history;var pathname=location.pathname,query=location.query;var params=_lodash2.default.clone(_lodash2.default.omit(query,['view','page']));if(history){var urlConfig={protocol:url.protocol,hostname:url.hostname,port:url.port,pathname:pathname};if(!params.pid&&pid){params.pid=pid;}if(allowGuestBook){if(layout!=='Obit'){params.view='guestbook';}if(page){params.page=page;}}urlConfig.query=params;var updatedUrl=_url2.default.format(urlConfig);history.replaceState(null,null,updatedUrl);}}/**
 * @param  {String} value String for formatting funeral, person name
 * @return {String} Formatted funeral, person name
 */function formatNameString(value){var string='';if(value){string=value.replace(/[^A-Za-z-]/g,' ').replace(/\s+/g,'-').toLowerCase();}return string;}/**
 * @param  {Object} options Options for building a flowers URL
 * @return {String} Formatted flowers URL
 */function buildObitFlowersUrl(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var defaultFlowerSettings={nodeMobilePersonLinkOverrideUrl:'',nodeDesktopPersonLinkOverrideUrl:''};var cultureCode=options.cultureCode||'en-us';var flowerSetting=options.flowerSettings&&options.flowerSettings.find(function(setting){return setting.cultureCode===cultureCode;})||defaultFlowerSettings;var affiliateId=options.affiliateId||'0';var personName=options.personName||'';var personId=options.personId||'0';var isMobile=options.isMobile||false;var flowersUrl=isMobile?flowerSetting.nodeMobilePersonLinkOverrideUrl:flowerSetting.nodeDesktopPersonLinkOverrideUrl;return flowersUrl.replace('##pid##',personId).replace('##pn##',formatNameString(personName)).replace('##affiliateid##',affiliateId);}/**
 * @param  {Object} options Options for building a flowers URL
 * @return {String} Formatted flowers URL
 */function buildFuneralHomeFlowersUrl(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var defaultFlowerSettings={nodeMobileLinkOverrideUrl:'',nodeDesktopLinkOverrideUrl:''};var cultureCode=options.cultureCode||'en-us';var flowerSetting=options.flowerSettings&&options.flowerSettings.find(function(setting){return setting.cultureCode===cultureCode;})||defaultFlowerSettings;var funeralHomeId=options.funeralHomeId||'0';var affiliateId=options.affiliateId||'0';var funeralHomeName=options.funeralHomeName||'';var isMobile=options.isMobile||false;var flowersUrl=isMobile?flowerSetting.nodeMobileLinkOverrideUrl:flowerSetting.nodeDesktopLinkOverrideUrl;return flowersUrl.replace('##fhid##',funeralHomeId).replace('##fhn##',formatNameString(funeralHomeName)).replace('##affiliateid##',affiliateId);}/**
 * @param  {String} sitename affiliate sitename
 * @return {String} Formatted affiliate url
 */function buildAffiliateUrl(sitename){var host=config.vanityDomain;var endpoint='obituaries/'+sitename;return buildUrl(host,endpoint);}/**
 * Returns a URL with a protocol. JSON LD Requires a valid url so
 * just www.domain.com doesn't fly.
 * @param {string} url url URL from the service
 * @return {string} Full url
 */function ensureProtocol(url){if(!url){return'';}// has protocol, send it along
if(url.startsWith('http://')||url.startsWith('https://')){return url;}// No protocol provided, add http: to be safe
// NOTE: this will handle both domain.com and www.domain.com which might
// not be desired
return'http://'+url;}/**
 * Add a query param to provided url
 * @param {string} urlToDecorate - Url to be decorated
 * @param {Object} queryParams - query name value pairs
 * @returns {string} Decorated Url
 */function addQueryParams(urlToDecorate,queryParams){var urlParts=urlToDecorate.split('?');var parsed=_qs2.default.parse(urlParts[1]);parsed=_lodash2.default.merge(parsed,queryParams||{});urlParts[1]=_qs2.default.stringify(parsed);return _lodash2.default.isEmpty(urlParts[1])?urlParts[0]:urlParts.join('?');}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(17)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(374);
var toPrimitive = __webpack_require__(69);
var dP = Object.defineProperty;

exports.f = __webpack_require__(29) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(71);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(1123).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(125)(module)))

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LikesHeart=exports.RightFollowLink=exports.UGCSearchIcon=exports.ErrorInfoIcon=exports.ModalArrow=exports.HeartIcon=exports.CloseXIcon=exports.ThankYouEmailIcon=exports.CondolenceQuotesIcon=exports.VideoPlayIcon=exports.InfoIcon=exports.EmailSignupSuccessIcon=exports.EmailSignupIcon=exports.GalleryAddIcon=exports.GalleryIcon=exports.SearchIcon=exports.LegacycomIcon=exports.VideoUploadIcon=exports.AdviceAndSupport=exports.FlowerIcon=exports.TrashcanIcon=exports.LightCandleIcon=exports.AddVideoIcon=exports.AddPhotoIcon=exports.GoogleIcon=exports.InstaIcon=exports.FlickrIcon=exports.FbIcon=exports.FbShareIcon=exports.TwitterShareIcon=exports.GooglePlusShareIcon=exports.EmailShareIcon=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable react/no-multi-comp */var EmailShareIcon=exports.EmailShareIcon=function EmailShareIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink',version:'1.1',id:'imgView',x:'0px',y:'0px',viewBox:'0 0 27.857 27.857',enableBackground:'new 0 0 27.857 27.857;',xmlSpace:'preserve'},_react2.default.createElement('g',null,_react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M2.203,5.331l10.034,7.948c0.455,0.36,1.082,0.52,1.691,0.49c0.608,0.03,1.235-0.129, 1.69-0.49l10.034-7.948c0.804-0.633,0.622-1.152-0.398-1.152H13.929H2.604C1.583,4.179,1.401,4.698,2.203, 5.331z'}),_react2.default.createElement('path',{d:'M26.377,7.428l-10.965,8.325c-0.41,0.308-0.947,0.458-1.482,0.451 c-0.536,0.007-1.073-0.144-1.483-0.451L1.48, 7.428C0.666,6.811,0,7.142,0,8.163v13.659c0,1.021,0.836, 1.857,1.857,1.857h12.071H26 c1.021,0,1.857-0.836,1.857-1.857V8.163C27.857,7.142,27.191, 6.811,26.377,7.428z'}))));};var GooglePlusShareIcon=exports.GooglePlusShareIcon=function GooglePlusShareIcon(){return _react2.default.createElement('svg',{version:'1.1',id:'Capa_1',xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink',x:'0px',y:'0px',viewBox:'0 0 96.828 96.827',enableBackground:'new 0 0 96.828 96.827',xmlSpace:'preserve'},_react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M62.617,0H39.525c-10.29,0-17.413,2.256-23.824,7.552c-5.042,4.35-8.051,10.672-8.051,16.912 c0,9.614, 7.33,19.831,20.913,19.831c1.306,0,2.752-0.134,4.028-0.253l-0.188,0.457c-0.546,1.308-1.063,2.542-1.063,4.468 c0, 3.75,1.809,6.063,3.558,8.298l0.22,0.283l-0.391,0.027c-5.609,0.384-16.049,1.1-23.675,5.787 c-9.007,5.355-9.707, 13.145-9.707,15.404c0,8.988,8.376,18.06,27.09,18.06c21.76,0,33.146-12.005,33.146-23.863 c0.002-8.771-5.141-13.101-10.6-17.698l-4.605-3.582c-1.423-1.179-3.195-2.646-3.195-5.364c0-2.672,1.772-4.436, 3.336-5.992 l0.163-0.165c4.973-3.917,10.609-8.358,10.609-17.964c0-9.658-6.035-14.649-8.937-17.048h7.663c0.094, 0,0.188-0.026,0.266-0.077 l6.601-4.15c0.188-0.119,0.276-0.348,0.214-0.562C63.037,0.147,62.839,0,62.617, 0z M34.614,91.535 c-13.264,0-22.176-6.195-22.176-15.416c0-6.021,3.645-10.396,10.824-12.997c5.749-1.935, 13.17-2.031,13.244-2.031 c1.257,0,1.889,0,2.893,0.126c9.281,6.605,13.743,10.073,13.743,16.678C53.141,86.309, 46.041,91.535,34.614,91.535z M34.489,40.756c-11.132,0-15.752-14.633-15.752-22.468c0-3.984,0.906-7.042, 2.77-9.351c2.023-2.531,5.487-4.166,8.825-4.166 c10.221,0,15.873,13.738,15.873,23.233c0,1.498,0,6.055-3.148, 9.22C40.94,39.337,37.497,40.756,34.489,40.756z'}),_react2.default.createElement('path',{d:'M94.982,45.223H82.814V33.098c0-0.276-0.225-0.5-0.5-0.5H77.08c-0.276,0-0.5,0.224-0.5,0.5v12.125H64.473 c-0.276,0-0.5,0.224-0.5,0.5v5.304c0,0.275,0.224,0.5,0.5,0.5H76.58V63.73c0,0.275,0.224,0.5,0.5,0.5h5.234 c0.275, 0,0.5-0.225,0.5-0.5V51.525h12.168c0.276,0,0.5-0.223,0.5-0.5v-5.302C95.482,45.446,95.259,45.223,94.982,45.223z'})));};var TwitterShareIcon=exports.TwitterShareIcon=function TwitterShareIcon(){return _react2.default.createElement('svg',{version:'1.1',id:'TWicon',xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink',x:'0px',y:'0px',viewBox:'0 0 18.001 18.001',enableBackground:'new 0 0 18.001 18.001',xmlSpace:'preserve'},_react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M15.891,4.013c0.808-0.496,1.343-1.173,1.605-2.034c-0.786,0.417-1.569,0.703-2.351,0.861 c-0.703-0.756-1.593-1.14-2.66-1.14c-1.043,0-1.924,0.366-2.643,1.078C9.127,3.495,8.766,4.366,8.766,5.383 c0, 0.309,0.039,0.585,0.117,0.819C5.807,6.097,3.261,4.821,1.255,2.365c-0.34,0.601-0.51,1.213-0.51,1.846 c0,1.301, 0.549,2.332,1.645,3.089C1.765,7.247,1.214,7.089,0.745,6.83c0,0.929,0.273,1.705,0.82,2.388 c0.549,0.676,1.254, 1.107,2.115,1.291c-0.312,0.08-0.641,0.118-0.979,0.118c-0.312,0-0.533-0.026-0.664-0.083 c0.23,0.757,0.664,1.371, 1.291,1.841c0.625,0.472,1.344,0.721,2.152,0.743c-1.332,1.045-2.855,1.562-4.578,1.562 c-0.422, 0-0.721-0.006-0.902-0.038c1.697,1.102,3.586,1.649,5.676,1.649c2.139,0,4.029-0.542,5.674-1.626 c1.645-1.078, 2.859-2.408,3.639-3.974c0.784-1.564,1.172-3.192,1.172-4.892V5.341c0.758-0.57,1.371-1.212,1.84-1.921 C17.321, 3.713,16.618,3.912,15.891,4.013z'})));};var FbShareIcon=exports.FbShareIcon=function FbShareIcon(){return _react2.default.createElement('svg',{version:'1.1',id:'FBicon',fill:'currentColor',xmlns:'https://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 23.101 23.101',enableBackground:'new 0 0 23.101 23.101',xmlSpace:'preserve'},_react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M8.258,4.458c0-0.144,0.02-0.455,0.06-0.931c0.043-0.477,0.223-0.976,0.546-1.5c0.32-0.522,0.839-0.991, 1.561-1.406 C11.144,0.208,12.183,0,13.539,0h3.82v4.163h-2.797c-0.277,0-0.535,0.104-0.768,0.309c-0.231,0.205-0.35, 0.4-0.35,0.581v2.59h3.914 c-0.041,0.507-0.086,1-0.138,1.476l-0.155,1.258c-0.062,0.425-0.125,0.819-0.187, 1.182h-3.462v11.542H8.258V11.558H5.742V7.643 h2.516V4.458z'})));};var FbIcon=exports.FbIcon=function FbIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'14.969',height:'31.97',viewBox:'0 0 14.969 31.97'},_react2.default.createElement('path',{fill:'#3d5898',fillRule:'evenodd',d:'M681.739,1389.29v-3.32a1.356,1.356,0,0,1, 1.417-1.54h3.6v-5.48l-4.955-.02c-5.5,0-6.752,4.09-6.752, 6.71v3.65h-3.181v5.65h3.181v15.98h6.692v-15.98h4.514l0.584-5.65h-5.1Z',transform:'translate(-671.875 -1378.94)'}));};var FlickrIcon=exports.FlickrIcon=function FlickrIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',viewBox:'0 0 31.65 13.94'},_react2.default.createElement('circle',{fill:'#ee3b95',cx:'24.68',cy:'6.97',r:'6.97'}),_react2.default.createElement('circle',{fill:'#367abf',cx:'6.97',cy:'6.97',r:'6.97'}));};var InstaIcon=exports.InstaIcon=function InstaIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'28',height:'28',viewBox:'0 0 28 28'},_react2.default.createElement('path',{fillRule:'evenodd',d:'M838.991,1383.52c3.74,0,4.182.02,5.659,0.09a7.747, 7.747,0,0,1,2.6.48,4.654,4.654,0,0,1,2.658,2.66,7.686,7.686, 0,0,1,.482,2.6c0.068,1.47.082,1.92,0.082,5.65s-0.014, 4.19-.082,5.66a7.686,7.686,0,0,1-.482,2.6,4.654,4.654,0,0, 1-2.658,2.66,7.747,7.747,0,0,1-2.6.48c-1.476.07-1.919,0.09-5.659, 0.09s-4.182-.02-5.658-0.09a7.741,7.741,0,0,1-2.6-.48,4.647, 4.647,0,0,1-2.658-2.66,7.686,7.686,0,0, 1-.482-2.6c-0.068-1.47-.082-1.92-0.082-5.66s0.014-4.18.082-5.65a7.686, 7.686,0,0,1,.482-2.6,4.647,4.647,0,0,1,2.658-2.66,7.741,7.741, 0,0,1,2.6-.48c1.476-.07,1.919-0.09,5.658-0.09m0-2.52c-3.8, 0-4.28.02-5.773,0.09a9.978,9.978,0,0,0-3.4.65,6.734,6.734,0,0, 0-2.481,1.61,6.891,6.891,0,0,0-1.615,2.48,10.286,10.286,0,0, 0-.651,3.4c-0.068,1.49-.084,1.97-0.084,5.77s0.016,4.28.084, 5.78a10.286,10.286,0,0,0,.651,3.4,6.891,6.891,0,0,0,1.615,2.48, 6.734,6.734,0,0,0,2.481,1.61,9.978,9.978,0,0,0,3.4.65c1.493,0.07, 1.97.09,5.773,0.09s4.28-.02,5.774-0.09a9.978,9.978,0,0,0,3.4-.65, 6.734,6.734,0,0,0,2.481-1.61,6.891,6.891,0,0,0,1.615-2.48,10.286, 10.286,0,0,0,.651-3.4c0.068-1.5.084-1.97, 0.084-5.78s-0.016-4.28-.084-5.77a10.286,10.286,0,0,0-.651-3.4,6.891, 6.891,0,0,0-1.615-2.48,6.734,6.734,0,0,0-2.481-1.61,9.978,9.978,0,0, 0-3.4-.65c-1.494-.07-1.97-0.09-5.774-0.09h0Zm0,6.81a7.2,7.2,0,1,0, 7.191,7.19A7.191,7.191,0,0,0,838.991,1387.81Zm0,11.86a4.665,4.665, 0,1,1,4.668-4.67A4.668,4.668,0,0,1,838.991,1399.67Zm9.156-12.14a1.681, 1.681,0,1,1-1.68-1.68A1.679,1.679,0,0,1,848.147,1387.53Z',transform:'translate(-825 -1381)'}));};var GoogleIcon=exports.GoogleIcon=function GoogleIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',viewBox:'0 0 37.17 37.06'},_react2.default.createElement('path',{fill:'#dd3e26',stroke:'#dd3e26',strokeMiterlimit:'22.93',strokeWidth:'0.07',fillRule:'evenodd',d:'M136.13,357.22a1.16,1.16,0,0,1,.27.23q4.48,4.5,9,9c-1.88,1.85-3.73, 3.73-5.6,5.59-0.7.71-1.42,1.4-2.11,2.13-0.52-1.26-1-2.53-1.52-3.79, 0-1.32,0-2.63,0-4C136.12,363.37,136.11,360.3,136.13,357.22Z',transform:'translate(-117.54 -357.16)'}),_react2.default.createElement('path',{fill:'#ed8122',stroke:'#ed8122',strokeMiterlimit:'22.93',strokeWidth:'0.07',fillRule:'evenodd',d:'M126.86,366.44h9.27c0,1.32,0,2.64,0,4q-0.77,1.87-1.5, 3.75a1.66,1.66,0,0,1-.4-0.35l-7.34-7.34Z',transform:'translate(-117.54 -357.16)'}),_react2.default.createElement('path',{fill:'#782b8e',stroke:'#782b8e',strokeMiterlimit:'22.93',strokeWidth:'0.07',fillRule:'evenodd',d:'M145.36,366.47l0,0q0,4.62,0,9.25h-4c-1.24-.52-2.5-1-3.75-1.51, 0.69-.72,1.41-1.42,2.11-2.13C141.63,370.2,143.48,368.32,145.36,366.47Z',transform:'translate(-117.54 -357.16)'}),_react2.default.createElement('path',{fill:'#fcb813',stroke:'#fcb813',strokeMiterlimit:'22.93',strokeWidth:'0.07',fillRule:'evenodd',d:'M125.35,368c0.52-.5,1-1,1.54-1.53l7.34,7.34a1.66,1.66,0,0,0,.4.35, 3.05,3.05,0,0,1-.56.25c-1.07.43-2.16,0.84-3.22,1.3-1.32,0-2.65,0-4, 0-3.08,0-6.16,0-9.25,0Q121.47,371.83,125.35,368Z',transform:'translate(-117.54 -357.16)'}),_react2.default.createElement('path',{fill:'#00835c',stroke:'#00835c',strokeMiterlimit:'22.93',strokeWidth:'0.07',fillRule:'evenodd',d:'M126.87,375.7c1.32,0,2.65,0,4,0,1.25,0.51,2.5,1,3.75,1.5-2.05, 2.08-4.13,4.14-6.19,6.21-0.52.49-1,1-1.54,1.5C126.86,381.85,126.85, 378.77,126.87,375.7Z',transform:'translate(-117.54 -357.16)'}),_react2.default.createElement('path',{fill:'#4874b9',stroke:'#4874b9',strokeMiterlimit:'22.93',strokeWidth:'0.07',fillRule:'evenodd',d:'M141.4,375.7h4c3.07,0,6.16,0,9.23,0-2,2-4,4-6,6-1.1, 1.09-2.18,2.2-3.28,3.28-2.46-2.49-5-4.95-7.42-7.44a1.5,1.5,0,0, 0-.33-0.27,4.51,4.51,0,0,1,.67-0.29C139.33,376.54,140.37,376.13, 141.4,375.7Z',transform:'translate(-117.54 -357.16)'}),_react2.default.createElement('path',{fill:'#5cae46',stroke:'#5cae46',strokeMiterlimit:'22.93',strokeWidth:'0.07',fillRule:'evenodd',d:'M134.59,377.21c0.53,1.26,1,2.53,1.53,3.79,0,1.32,0,2.64,0, 4v6.37c0,0.95,0,1.9,0,2.84a1.57,1.57,0,0, 1-.37-0.33q-4.44-4.46-8.88-8.91c0.55-.46,1-1,1.54-1.5C130.46,381.35, 132.54,379.29,134.59,377.21Z',transform:'translate(-117.54 -357.16)'}),_react2.default.createElement('path',{fill:'#353b96',stroke:'#353b96',strokeMiterlimit:'22.93',strokeWidth:'0.07',fillRule:'evenodd',d:'M137.62,377.25a1.5,1.5,0,0,1,.33.27c2.47,2.49,5,4.95,7.42, 7.44h-9.25c0-1.32,0-2.64,0-4C136.61,379.75,137.13,378.51,137.62,377.25Z',transform:'translate(-117.54 -357.16)'}));};var AddPhotoIcon=exports.AddPhotoIcon=function AddPhotoIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink',x:'0px',y:'0px',viewBox:'0 0 35.8 27.6',enableBackground:'new 0 0 35.8 27.6;',xmlSpace:'preserve'},_react2.default.createElement('g',null,_react2.default.createElement('path',{fill:'#0099CC',d:'M24.5,6.9c1.3,0,2.5,0,3.8,0c1.3,0,2.2,0.6,2.9,1.7c0.3,0.5,0.4, 1.1,0.4,1.7c0,3.2,0,6.5,0,9.7c0,1.8-1.5,3.3-3.3,3.3c-6.3,0-12.7, 0-19,0c-1.8,0-3.3-1.5-3.3-3.3c0-3.3,0-6.5,0-9.8c0-1.7,1.4-3.2, 3.2-3.3c1.2,0,2.4,0,3.6,0c0.1,0,0.3,0,0.4,0c0-0.3,0.1-0.6, 0.1-0.8c0.4-1.5,1.7-2.5,3.2-2.5c1.5,0,3.1,0,4.6,0c1.8,0,3.2, 1.4,3.3,3.2C24.4,6.8,24.4,6.8,24.5,6.9z M18.9,9.2c-3.3,0-5.9, 2.6-5.9,5.9c0,3.2,2.7,5.9,5.9,5.9c3.2,0,5.9-2.6,5.9-5.9C24.7, 11.8,22,9.2,18.9,9.2z'}),_react2.default.createElement('path',{fill:'#0099CC',d:'M18.8,18.4c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c1.8, 0,3.3,1.5,3.3,3.3C22.1,16.8,20.6,18.4,18.8,18.4z'})));};var AddVideoIcon=exports.AddVideoIcon=function AddVideoIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink',x:'0px',y:'0px',viewBox:'0 0 39.2 30.3',enableBackground:'new 0 0 39.2 30.3',xmlSpace:'preserve'},_react2.default.createElement('g',null,_react2.default.createElement('path',{fill:'#0099CC',d:'M16.9,6.6c3.2,0,6.5,0,9.7,0c0.9,0,1.2,0.2,1.2,1.2c0,4.7,0,9.4, 0,14c0,0.8-0.3,1.1-1.1,1.1c-6.5,0-13.1,0-19.6,0c-0.8, 0-1.1-0.3-1.1-1.1c0-4.7,0-9.4,0-14.1c0-0.8,0.3-1.1,1.1-1.1C10.4, 6.6,13.6,6.6,16.9,6.6z'}),_react2.default.createElement('path',{fill:'#0099CC',d:'M35,9.3c0,3.6,0,7.2,0,10.9c-0.8-0.1-1.6, 0.2-2.4-0.3c-1.2-0.8-2.4-1.5-3.6-2.2c-0.2-0.1-0.3-0.3-0.3-0.5c0-1.6, 0-3.1,0-4.7c0-0.3,0.1-0.4,0.3-0.5c1.3-0.8,2.7-1.6,4-2.4c0.1-0.1, 0.3-0.1,0.5-0.1C34,9.3,34.5,9.3,35,9.3z'})));};var LightCandleIcon=exports.LightCandleIcon=function LightCandleIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink',x:'0px',y:'0px',viewBox:'0 0 40.5 31.3',enableBackground:'new 0 0 40.5 31.3',xmlSpace:'preserve'},_react2.default.createElement('g',null,_react2.default.createElement('path',{fill:'#0099CC',d:'M24,14c0.4,0.4,0.6,0.8,0.6,1.3c0,3,0,6,0,8.9c0,0.5,0,1,0, 1.4c-0.1,0.9-0.8,1.6-1.7,1.6c-1.8,0-2.5,0-4.3,0c-1.2, 0-1.8-0.6-1.8-1.8c0-3.3,0-6.6,0-9.9c0-1.2,0.7-1.9,1.9-1.9c1.7, 0,2.4,0,4.2,0C23.3,13.6,23.7,13.7,24,14z'}),_react2.default.createElement('path',{fill:'#0099CC',d:'M18.6,11.8c-0.9-1-1.1-2.1-0.4-3.4c0.5-0.9,1.1-3.2,1.7-3.9c0.5-0.6, 1-0.5,1.5,0.1c0.7,0.8,1.3,3.1,1.7,4c0.6,1.1,0.4,2.2-0.4,3.2c-0.2, 0.2-0.4,0.4-0.7,0.3c-1,0-1.9,0-2.9,0C19,12,18.8,11.9,18.6,11.8C18.6, 11.9,18.6,11.8,18.6,11.8z'})));};var TrashcanIcon=exports.TrashcanIcon=function TrashcanIcon(){return _react2.default.createElement('svg',{width:'11px',height:'13px',viewBox:'0 0 11 13',version:'1.1',xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink'},_react2.default.createElement('g',{id:'iPhone-7-Plus',stroke:'none',strokeWidth:'1',fill:'none',fillRule:'evenodd'},_react2.default.createElement('g',{id:'05-add-caption-screen',transform:'translate(-273.000000, -328.000000)',fill:'#999999'},_react2.default.createElement('g',{id:'Thumbnails',transform:'translate(10.000000, 79.000000)'},_react2.default.createElement('g',{id:'Delete-Button',transform:'translate(263.000000, 246.000000)'},_react2.default.createElement('g',{id:'trashcan',transform:'translate(0.000000, 3.000000)'},_react2.default.createElement('g',{id:'noun_744232_cc'},_react2.default.createElement('path',{d:'M10.4811321,1.6877898 L7.61698113,1.6877898 L7.61698113,1.06491499 C7.61698113,0.482225657 7.11886792,0 6.51698113, 0 L4.46226415,0 C3.86037736,0 3.36226415,0.482225657 3.36226415,1.06491499 L3.36226415,1.6877898 L0.518867925, 1.6877898 C0.228301887,1.6877898 0,1.90880989 0,2.19010819 C0,2.47140649 0.228301887,2.69242658 0.518867925, 2.69242658 L0.975471698,2.69242658 L0.975471698,11.2921175 C0.975471698,12.236476 1.76415094,13 2.73962264,13 L8.23962264, 13 C9.21509434,13 10.0037736,12.236476 10.0037736,11.2921175 L10.0037736,2.69242658 L10.4811321,2.69242658 C10.7716981, 2.69242658 11,2.47140649 11,2.19010819 C11,1.90880989 10.7716981,1.6877898 10.4811321,1.6877898 Z M4.42075472, 1.06491499 C4.42075472,1.04482226 4.44150943,1.00463679 4.48301887,1.00463679 L6.53773585,1.00463679 C6.55849057, 1.00463679 6.6,1.02472952 6.6,1.06491499 L6.6,1.6877898 L4.42075472,1.6877898 L4.42075472,1.06491499 Z M8.98679245, 11.2921175 C8.98679245,11.6738794 8.65471698,11.9953632 8.26037736,11.9953632 L2.76037736,11.9953632 C2.36603774, 11.9953632 2.03396226,11.6738794 2.03396226,11.2921175 L2.03396226,2.69242658 L8.98679245,2.69242658 L8.98679245, 11.2921175 Z',id:'Shape'}),_react2.default.createElement('path',{d:'M5.5,11 C5.78,11 6,10.78 6,10.5 L6,4.5 C6,4.22 5.78,4 5.5,4 C5.22,4 5,4.22 5,4.5 L5,10.5 C5,10.76 5.22,11 5.5,11 Z',id:'Shape'}),_react2.default.createElement('path',{d:'M7.5,11 C7.78,11 8,10.78 8,10.5 L8,4.5 C8,4.22 7.78,4 7.5,4 C7.22,4 7,4.22 7,4.5 L7,10.5 C7,10.76 7.22,11 7.5,11 Z',id:'Shape'}),_react2.default.createElement('path',{d:'M3.5,11 C3.78,11 4,10.78 4,10.5 L4,4.5 C4,4.22 3.78,4 3.5,4 C3.22,4 3,4.22 3,4.5 L3,10.5 C3,10.76 3.22,11 3.5,11 Z',id:'Shape'}))))))));};var FlowerIcon=exports.FlowerIcon=function FlowerIcon(){return _react2.default.createElement('svg',{viewBox:'0 0 15 15',xmlns:'https://www.w3.org/2000/svg'},_react2.default.createElement('path',{d:'M391.85,294.31a1.41,1.41,0,0,1,1.05.52,5.1,5.1,0,0,1,1.14,2.43,0.65,0.65,0,0,1-.8.83,4.77,4.77,0,0, 1-2.52-1.21,1.43,1.43,0,0,1-.35-1.64A1.53,1.53,0,0,1,391.85,294.31Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}),_react2.default.createElement('path',{d:'M400.18,305.79a1.43,1.43,0,0,1-1-.5,5.09,5.09,0,0,1-1.16-2.42,0.67,0.67,0,0,1,.85-0.85,5,5,0,0,1,2.42, 1.16,1.46,1.46,0,0,1,.4,1.65A1.52,1.52,0,0,1,400.18,305.79Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}),_react2.default.createElement('path',{d:'M391.81,305.79a1.52,1.52,0,0,1-1.44-1,1.43,1.43,0,0,1,.35-1.61,4.88,4.88,0,0,1,2.54-1.22,0.64,0.64,0,0, 1,.79.74,4.76,4.76,0,0,1-1.27,2.63A1.35,1.35,0,0,1,391.81,305.79Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}),_react2.default.createElement('path',{d:'M401.74,295.86a1.44,1.44,0,0,1-.53,1.09,5.1,5.1,0,0,1-2.37,1.14,0.67,0.67,0,0,1-.87-0.83,4.77,4.77,0,0,1, 1.22-2.51,1.44,1.44,0,0,1,1.62-.32A1.53,1.53,0,0,1,401.74,295.86Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}),_react2.default.createElement('path',{d:'M397.49,305.83a1.55,1.55,0,0,1-1.32,1.72,1.46,1.46,0,0,1-1.6-1.14,3.42,3.42,0,0,1,.07-1.17,4.28,4.28,0,0, 1,.72-1.74,0.7,0.7,0,0,1,1.29,0A5.08,5.08,0,0,1,397.49,305.83Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}),_react2.default.createElement('path',{d:'M397.49,294.14a5.06,5.06,0,0,1-.86,2.51,0.68,0.68,0,0,1-1.24,0,4.66,4.66,0,0,1-.86-2.62,1.47,1.47,0,0,1, 1.48-1.47,1.49,1.49,0,0,1,1.49,1.47S397.49,294.1,397.49,294.14Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}),_react2.default.createElement('path',{d:'M390.05,301.54a1.49,1.49,0,0,1-1.54-1.33,1.47,1.47,0,0,1,1.13-1.59,2.06,2.06,0,0,1,1,0,16.27,16.27,0,0,1, 1.75.63,1.48,1.48,0,0,1,.49.38,0.56,0.56,0,0,1,0,.82,1.61,1.61,0,0,1-.25.23A5.15,5.15,0,0,1,390.05,301.54Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}),_react2.default.createElement('path',{d:'M401.78,301.54a5,5,0,0,1-2.38-.87,0.68,0.68,0,0,1,0-1.24,4.65,4.65,0,0,1,2.54-.86,1.47,1.47,0,0,1,1.55, 1.48A1.54,1.54,0,0,1,401.78,301.54Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}),_react2.default.createElement('path',{d:'M396,298.57a1.48,1.48,0,1,1-1.49,1.48A1.46,1.46,0,0,1,396,298.57Z',fill:'currentColor',transform:'translate(-388.5 -292.55)'}));};var AdviceAndSupport=exports.AdviceAndSupport=function AdviceAndSupport(){return _react2.default.createElement('svg',{width:'64px',height:'60px',viewBox:'0 0 64 60',xmlns:'https://www.w3.org/2000/svg'},_react2.default.createElement('g',{stroke:'none',strokeWidth:'1',fill:'none',fillRule:'evenodd'},_react2.default.createElement('g',{transform:'translate(-1168.000000, -1681.000000)',fillRule:'nonzero',fill:'#FFFFFF'},_react2.default.createElement('g',{transform:'translate(1000.000000, 1651.000000)'},_react2.default.createElement('g',{transform:'translate(168.000000, 30.000000)'},_react2.default.createElement('path',{d:'M63.8297872,19.0053191 C63.8297872,13.9289362 61.8529787,9.15574468 58.2638298, 5.56595745 C54.6740426,1.97680851 49.9021277,0 44.8257447,0 C39.966383,0 35.3885106, 1.81531915 31.8568085,5.11914894 C28.3397872,1.87978723 23.8059574, 0.102765957 18.996383,0.102765957 C13.92,0.102765957 9.14744681,2.07957447 5.55765957, 5.6693617 C-1.85234043,13.0787234 -1.85170213,25.1368085 5.55765957, 32.5474468 L10.3965957,37.3876596 C9.91340426,38.1019149 9.65234043, 38.9431915 9.65234043,39.8240426 C9.65234043,40.9876596 10.1048936, 42.0817021 10.9282979,42.9038298 C11.7504255,43.7265957 12.8438298, 44.1797872 14.0080851,44.1797872 C14.3470213,44.1797872 14.6782979,44.1376596 15, 44.0623404 C14.9253191,44.3846809 14.8825532,44.7153191 14.8825532, 45.0542553 C14.8825532,46.2178723 15.3357447,47.3112766 16.1591489, 48.1334043 C16.9806383,48.9568085 18.0746809,49.41 19.2382979,49.41 C19.5791489, 49.41 19.9110638,49.3665957 20.2340426,49.2912766 C19.9040426,50.7102128 20.286383, 52.2612766 21.3887234,53.3648936 C22.2114894,54.1870213 23.3048936, 54.6402128 24.4691489,54.6402128 C24.8080851,54.6402128 25.1406383, 54.5961702 25.4629787,54.5208511 C25.1329787,55.9385106 25.5153191, 57.4902128 26.6189362,58.5925532 C27.4410638,59.4153191 28.5344681, 59.8685106 29.6993617,59.8685106 C30.6089362,59.8685106 31.4751064,59.5889362 32.202766, 59.0738298 C32.9074468,59.5391489 33.7321277,59.7893617 34.5957447, 59.7893617 C35.7606383,59.7893617 36.8546809,59.3374468 37.6768085, 58.5153191 C38.6278723,57.5629787 39.0465957,56.2768085 38.9317021, 55.0314894 C39.4806383,55.277234 40.0825532,55.4048936 40.7023404,55.4048936 C41.8659574, 55.4048936 42.9612766,54.9517021 43.7834043,54.1295745 C44.8844681,53.0285106 45.2706383, 51.48 44.9444681,50.0642553 C45.2648936,50.1376596 45.5961702,50.1759574 45.9325532, 50.1759574 C47.0948936,50.1759574 48.1889362,49.722766 49.0129787,48.9012766 C49.8351064, 48.0778723 50.2882979,46.9838298 50.2882979,45.8202128 C50.2882979,45.2068085 50.1631915, 44.6138298 49.9244681,44.0693617 C51.1902128,44.1765957 52.4674468,43.7221277 53.3821277, 42.8093617 C54.2042553,41.9859574 54.6574468,40.8925532 54.6574468,39.7289362 C54.6574468, 38.7268085 54.3197872,37.7770213 53.7012766,37.007234 L58.2651064,32.4440426 C61.8529787, 28.8548936 63.8297872,24.0823404 63.8297872,19.0053191 Z M15.966383,41.783617 C15.7621277, 41.987234 15.527234,42.1429787 15.2782979,42.2725532 C14.8895745,42.4761702 14.4587234, 42.5955319 14.0068085,42.5955319 C13.266383,42.5955319 12.5712766,42.3070213 12.0485106, 41.7842553 C11.5251064,41.2614894 11.2365957,40.5651064 11.2365957,39.8246809 C11.2365957, 39.372766 11.3559574,38.9419149 11.5595745,38.5519149 C11.6891489,38.303617 11.8442553, 38.0693617 12.0485106,37.866383 L12.5814894,37.332766 L16.8434043,33.0702128 C17.3661702, 32.5474468 18.0619149,32.2589362 18.8017021,32.2589362 C19.5414894,32.2589362 20.2378723, 32.5474468 20.7612766,33.0702128 C21.8419149,34.1508511 21.8419149,35.9087234 20.7625532, 36.9887234 L16.4993617,41.2525532 L15.966383,41.783617 Z M21.1965957,47.0138298 C20.9929787, 47.2174468 20.7568085,47.3738298 20.507234,47.5040426 C20.1178723,47.7051064 19.6889362, 47.8251064 19.236383,47.8251064 C18.4959574,47.8251064 17.8002128,47.537234 17.2780851, 47.0138298 C16.403617,46.1393617 16.2497872,44.8270213 16.7891489,43.7834043 C16.9161702, 43.536383 17.0706383,43.3002128 17.2780851,43.0940426 L17.8097872,42.5623404 L23.7887234, 36.5840426 C24.3114894,36.06 25.0078723,35.7714894 25.7482979,35.7714894 C26.4880851, 35.7714894 27.1838298,36.06 27.7065957,36.5840426 C28.23,37.1068085 28.5178723, 37.8019149 28.5178723,38.5423404 C28.5178723,39.2821277 28.2293617,39.9785106 27.7065957, 40.5019149 L21.7276596,46.4814894 L21.1965957,47.0138298 Z M26.4268085,52.242766 C26.2219149, 52.4482979 25.9857447,52.6046809 25.7355319,52.7342553 C25.3461702, 52.937234 24.9178723,53.0559574 24.467234,53.0559574 C23.7268085,53.0559574 23.0310638, 52.7680851 22.5076596,52.2446809 C21.6344681,51.3721277 21.4806383,50.0597872 22.0187234, 49.0155319 C22.1457447,48.7685106 22.3008511,48.5317021 22.5076596,48.3255319 L23.0393617, 47.7938298 L26.9565957,43.8778723 L28.2842553,42.5502128 L28.5191489,42.3159574 C29.0419149, 41.7925532 29.7382979,41.5046809 30.4774468,41.5046809 C31.2178723,41.5046809 31.913617, 41.7925532 32.436383,42.3153191 C33.516383,43.3965957 33.516383,45.1551064 32.4370213, 46.2344681 L32.2014894,46.4680851 L30.8738298,47.7957447 L26.9565957,51.7142553 L26.4268085, 52.242766 Z M32.1848936,56.9438298 L31.6557447,57.4729787 C31.4508511,57.6778723 31.2140426, 57.8348936 30.9644681,57.9651064 C30.5757447,58.1655319 30.1474468,58.2842553 29.6974468, 58.2842553 C28.9557447,58.2842553 28.2612766,57.9957447 27.7378723,57.4729787 C26.8646809, 56.5997872 26.7095745,55.2893617 27.2476596,54.246383 C27.3746809,53.9980851 27.5297872, 53.7606383 27.7378723,53.5544681 L28.2676596,53.0246809 L32.1855319,49.1074468 L32.2697872, 49.0231915 C32.7312766,48.5597872 33.3293617,48.2955319 33.9708511,48.2368085 C34.0576596, 48.2278723 34.1419149,48.2119149 34.2280851,48.2119149 C34.9685106,48.2119149 35.6648936, 48.4997872 36.1889362,49.0225532 C36.7940426,49.6282979 37.0468085,50.4453191 36.9734043, 51.2393617 C36.9165957,51.8604255 36.6638298,52.4674468 36.1889362,52.9417021 L36.1034043, 53.0265957 L32.1848936,56.9438298 Z M36.5540426,57.3951064 C36.0312766,57.9178723 35.3361702, 58.2051064 34.5944681,58.2051064 C34.1853191,58.2051064 33.7914894,58.1093617 33.4314894, 57.9408511 L37.0991489,54.2731915 C37.572766,55.296383 37.397234,56.5506383 36.5540426, 57.3951064 Z M52.26,41.6885106 C51.7359574,42.2112766 51.0408511,42.4997872 50.3004255, 42.4997872 C49.5606383,42.4997872 48.8648936,42.2112766 48.3421277,41.6885106 L37.8095745, 31.1565957 C37.5,30.8470213 36.9982979,30.846383 36.6893617,31.1553191 L36.4985106, 31.3448936 C36.3491489,31.4929787 36.2661702,31.6946809 36.2661702,31.9059574 C36.2661702, 32.1159574 36.3491489,32.3176596 36.497234,32.4670213 L47.8914894,43.86 C48.4142553, 44.3834043 48.702766,45.0797872 48.702766,45.8195745 C48.702766,46.56 48.4142553,47.256383 47.8914894, 47.7791489 C47.3674468,48.3019149 46.6723404,48.5904255 45.9319149,48.5904255 C45.1921277, 48.5904255 44.496383,48.3019149 43.973617,47.7791489 L32.5787234,36.1812766 C32.4293617, 36.0325532 32.2282979,35.7446809 32.0176596,35.7446809 L32.016383,35.7446809 C31.806383, 35.7446809 31.6040426,36.0338298 31.4559574,36.1838298 L31.266383,36.4768085 C30.9587234, 36.786383 30.9593617,37.3385106 31.2676596,37.6468085 L42.6606383,49.0659574 C43.74, 50.1446809 43.74,51.9165957 42.6606383,52.997234 C42.1378723,53.5193617 41.4414894, 53.8142553 40.7010638,53.8142553 C39.9612766,53.8142553 39.2661702,53.5289362 38.7440426, 53.0055319 L38.2876596,52.5497872 C38.8876596,50.9929787 38.5640426,49.1565957 37.3091489, 47.9010638 C36.4857447,47.0776596 35.3917021,46.6251064 34.2280851,46.6251064 C34.1987234, 46.6251064 34.1687234,46.6289362 34.1393617,46.6302128 C35.2231915,44.9444681 35.0304255, 42.6682979 33.5565957,41.1931915 C32.7344681,40.3710638 31.6410638,39.9178723 30.4774468, 39.9178723 C30.27,39.9178723 30.0644681,39.9370213 29.8614894,39.9657447 C30.0185106, 39.5131915 30.1040426,39.0357447 30.1040426,38.5423404 C30.1040426,37.3787234 29.6502128, 36.2846809 28.8280851,35.4625532 C28.0053191,34.6397872 26.9119149,34.1865957 25.7482979, 34.1865957 C24.8004255,34.1865957 23.9010638,34.4917021 23.1555319,35.0476596 C23.16, 33.9255319 22.7368085,32.8021277 21.882766,31.9480851 C21.0593617,31.1259574 19.9659574, 30.672766 18.8023404,30.672766 C17.6393617,30.672766 16.5446809,31.1259574 15.7225532, 31.9480851 L11.4606383,36.21 L6.67851064,31.4259574 C-0.114255319,24.6338298 -0.114255319, 13.5817021 6.67723404,6.79021277 C9.96829787,3.49978723 14.3425532,1.68765957 18.9951064, 1.68765957 C23.3751064,1.68765957 27.5055319,3.29808511 30.7206383,6.23234043 L16.4891489, 20.4657447 C14.7906383,22.1642553 14.7848936,24.9223404 16.476383,26.6131915 L17.2308511, 27.3670213 C18.0434043,28.1795745 19.1317021,28.6270213 20.2953191,28.6270213 C21.4589362, 28.6270213 22.5529787,28.1738298 23.3744681,27.3517021 L32.6087234,18.1187234 L52.26, 37.7706383 C52.782766,38.2934043 53.0712766,38.9885106 53.0712766,39.7289362 C53.0719149, 40.4687234 52.782766,41.1657447 52.26,41.6885106 Z M52.6729787,35.7931915 L33.2323404, 16.3729787 C33.1417021,16.2829787 33.0338298,16.2268085 32.9202128,16.1891489 C32.8397872, 16.1623404 32.7568085,16.1406383 32.6719149,16.1406383 C32.4695745,16.1406383 32.2665957, 16.2185106 32.1114894,16.3723404 L31.487234,16.997234 L22.253617,26.2308511 C21.7308511, 26.753617 21.0357447,27.0421277 20.2953191,27.0421277 C19.5440426,27.0421277 18.8725532, 26.7670213 18.3517021,26.2461702 L17.5978723,25.4923404 C16.5242553,24.4193617 16.5306383, 22.667234 17.6112766,21.5865957 L31.0819149,8.11276596 L32.5078723,6.68680851 C32.5589362, 6.63510638 32.6131915,6.58723404 32.6648936,6.53680851 C35.9374468,3.34340426 40.2446809, 1.58425532 44.8257447,1.58425532 C49.4782979,1.58425532 53.8538298,3.39638298 57.1429787, 6.68680851 C60.4334043,9.97723404 62.2448936,14.3514894 62.2448936,19.0046809 C62.2448936, 23.6578723 60.4334043,28.0321277 57.1429787,31.3225532 L52.6729787,35.7931915 Z'}))))));};var VideoUploadIcon=exports.VideoUploadIcon=function VideoUploadIcon(){return _react2.default.createElement('svg',{width:'178px',height:'116px',viewBox:'0 0 178 116',version:'1.1',xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink'},_react2.default.createElement('g',{id:'videoUploadIcon',stroke:'none',strokeWidth:'1',fill:'none',fillRule:'evenodd'},_react2.default.createElement('g',{id:'PersonPage-video-preview',transform:'translate(-122.000000, -729.000000)',fillRule:'nonzero',fill:'#999999'},_react2.default.createElement('g',{id:'Add-Captions-Modal-Copy',transform:'translate(71.000000, 590.000000)'},_react2.default.createElement('g',{id:'Horizontal-Photo-Container',transform:'translate(20.000000, 80.000000)'},_react2.default.createElement('g',{id:'Group-4',transform:'translate(27.000000, 59.000000)'},_react2.default.createElement('g',{id:'noun_539437_cc',transform:'translate(4.000000, 0.000000)'},_react2.default.createElement('g',{id:'Group'},_react2.default.createElement('path',{id:'Shape',d:'M170.169923,0.645831243 L64.9435093, 0.645831243 C60.7081492,0.645831243 57.2483056, 4.11892372 57.2483056,8.34381975 L57.2483056, 107.623878 C57.2483056,111.868769 60.7081492, 115.321866 64.9435093,115.321866 L170.169923, 115.321866 C174.387295,115.321866 177.859131, 111.866769 177.859131,107.623878 L177.859131, 8.34581923 C177.859131,4.1209232 174.387295, 0.645831243 170.169923,0.645831243 Z M139.850821, 9.89341484 C139.850821,8.62774556 140.890173, 7.58801724 142.149388,7.58801724 L149.582755, 7.58801724 C150.845968,7.58801724 151.88532, 8.62774556 151.88532,9.89341484 L151.88532, 17.1035308 C151.88532,18.3751985 150.845968, 19.4089284 149.582755,19.4089284 L142.149388, 19.4089284 C140.892172,19.4089284 139.850821, 18.3751985 139.850821,17.1035308 L139.850821, 9.89341484 Z M168.405023,27.32486 C169.670235, 27.32486 170.703591,28.3525914 170.703591, 29.6242591 L170.703591,86.3554352 C170.703591, 87.6211045 169.670235,88.6608328 168.405023, 88.6608328 L123.31113,88.6608328 C122.039922, 88.6608328 121.00057,87.6211045 121.00057, 86.3554352 L121.00057,29.6222597 C121.00057, 28.350592 122.039922,27.3228605 123.31113, 27.3228605 L168.405023,27.3228605 L168.405023, 27.32486 Z M120.974586,9.89341484 C120.974586, 8.62774556 122.019935,7.58801724 123.27915, 7.58801724 L130.692529,7.58801724 C131.969733, 7.58801724 133.003089,8.62774556 133.003089, 9.89341484 L133.003089,17.1035308 C133.003089, 18.3751985 131.969733,19.4089284 130.692529, 19.4089284 L123.27915,19.4089284 C122.021933, 19.4089284 120.974586,18.3751985 120.974586, 17.1035308 L120.974586,9.89341484 Z M83.2241153, 9.89341484 C83.2241153,8.62774556 84.251475, 7.58801724 85.5226827,7.58801724 L92.9540508, 7.58801724 C94.2192622,7.58801724 95.2586144, 8.62774556 95.2586144,9.89341484 L95.2586144, 17.1035308 C95.2586144,18.3751985 94.2192622, 19.4089284 92.9540508,19.4089284 L85.5226827, 19.4089284 C84.251475,19.4089284 83.2241153, 18.3751985 83.2241153,17.1035308 L83.2241153, 9.89341484 L83.2241153,9.89341484 Z M64.3478806, 9.89341484 C64.3478806,8.62774556 65.3872328, 7.58801724 66.6524442,7.58801724 L74.0658235, 7.58801724 C75.3430275,7.58801724 76.3703871, 8.62774556 76.3703871,9.89341484 L76.3703871, 17.1035308 C76.3703871,18.3751985 75.3430275, 19.4089284 74.0658235,19.4089284 L66.6524442, 19.4089284 C65.3872328,19.4089284 64.3478806, 18.3751985 64.3478806,17.1035308 L64.3478806, 9.89341484 Z M64.3478806,29.6222597 C64.3478806, 28.350592 65.3872328,27.3228605 66.6524442, 27.3228605 L111.740342,27.3228605 C113.017546, 27.3228605 114.050901,28.350592 114.050901, 29.6222597 L114.050901,86.3534357 C114.050901, 87.619105 113.017546,88.6588333 111.740342, 88.6588333 L66.6524442,88.6588333 C65.3872328, 88.6588333 64.3478806,87.619105 64.3478806, 86.3534357 L64.3478806,29.6222597 Z M76.3683884, 106.08428 C76.3683884,107.355948 75.3410287, 108.389678 74.0638248,108.389678 L66.6504454, 108.389678 C65.385234,108.389678 64.3458818, 107.355948 64.3458818,106.08428 L64.3458818, 98.8741641 C64.3458818,97.6084948 65.385234, 96.5687665 66.6504454,96.5687665 L74.0638248, 96.5687665 C75.3410287,96.5687665 76.3683884, 97.6084948 76.3683884,98.8741641 L76.3683884, 106.08428 Z M95.2566157,106.08428 C95.2566157, 107.355948 94.2172635,108.389678 92.9520521, 108.389678 L85.5206839,108.389678 C84.2494762, 108.389678 83.2221166,107.355948 83.2221166, 106.08428 L83.2221166,98.8741641 C83.2221166, 97.6084948 84.2494762,96.5687665 85.5206839, 96.5687665 L92.9520521,96.5687665 C94.2172635, 96.5687665 95.2566157,97.6084948 95.2566157, 98.8741641 L95.2566157,106.08428 L95.2566157, 106.08428 Z M114.138847,106.08428 C114.138847, 107.355948 113.093498,108.389678 111.828287, 108.389678 L104.408911,108.389678 C103.137704, 108.389678 102.098351,107.355948 102.098351, 106.08428 L102.098351,98.8741641 C102.098351, 97.6084948 103.139702,96.5687665 104.408911, 96.5687665 L111.828287,96.5687665 C113.093498, 96.5687665 114.138847,97.6084948 114.138847, 98.8741641 L114.138847,106.08428 Z M114.138847, 17.1035308 C114.138847,18.3751985 113.093498, 19.4089284 111.828287,19.4089284 L104.408911, 19.4089284 C103.137704,19.4089284 102.098351, 18.3751985 102.098351,17.1035308 L102.098351, 9.89341484 C102.098351,8.62774556 103.139702, 7.58801724 104.408911,7.58801724 L111.828287, 7.58801724 C113.093498,7.58801724 114.138847, 8.62774556 114.138847,9.89341484 L114.138847, 17.1035308 Z M133.003089,106.08428 C133.003089, 107.355948 131.969733,108.389678 130.692529, 108.389678 L123.27915,108.389678 C122.021933, 108.389678 120.974586,107.355948 120.974586, 106.08428 L120.974586,98.8741641 C120.974586, 97.6084948 122.019935,96.5687665 123.27915, 96.5687665 L130.692529,96.5687665 C131.969733, 96.5687665 133.003089,97.6084948 133.003089, 98.8741641 L133.003089,106.08428 Z M151.88532, 106.08428 C151.88532,107.355948 150.845968, 108.389678 149.582755,108.389678 L142.149388, 108.389678 C140.892172,108.389678 139.850821, 107.355948 139.850821,106.08428 L139.850821, 98.8741641 C139.850821,97.6084948 140.890173, 96.5687665 142.149388,96.5687665 L149.582755, 96.5687665 C150.845968,96.5687665 151.88532, 97.6084948 151.88532,98.8741641 L151.88532, 106.08428 Z M170.767551,106.08428 C170.767551, 107.355948 169.734195,108.389678 168.462987, 108.389678 L161.037615,108.389678 C159.766408, 108.389678 158.727056,107.355948 158.727056, 106.08428 L158.727056,98.8741641 C158.727056, 97.6084948 159.766408,96.5687665 161.037615, 96.5687665 L168.462987,96.5687665 C169.734195, 96.5687665 170.767551,97.6084948 170.767551, 98.8741641 L170.767551,106.08428 Z M170.767551, 17.1035308 C170.767551,18.3751985 169.734195, 19.4089284 168.462987,19.4089284 L161.037615, 19.4089284 C159.766408,19.4089284 158.727056, 18.3751985 158.727056,17.1035308 L158.727056, 9.89341484 C158.727056,8.62774556 159.766408, 7.58801724 161.037615,7.58801724 L168.462987, 7.58801724 C169.734195,7.58801724 170.767551, 8.62774556 170.767551,9.89341484 L170.767551, 17.1035308 Z'}),_react2.default.createElement('path',{id:'Shape',d:'M113.085503,0.645831243 L7.85908913, 0.645831243 C3.62372897,0.645831243 0.16388543, 4.11892372 0.16388543,8.34381975 L0.16388543, 107.623878 C0.16388543,111.868769 3.62372897, 115.321866 7.85908913,115.321866 L113.085503, 115.321866 C117.302875,115.321866 120.774711, 111.866769 120.774711,107.623878 L120.774711, 8.34581923 C120.774711,4.1209232 117.302875, 0.645831243 113.085503,0.645831243 Z M82.7664006, 9.89341484 C82.7664006,8.62774556 83.8057528, 7.58801724 85.064968,7.58801724 L92.4983349, 7.58801724 C93.7615475,7.58801724 94.8008997, 8.62774556 94.8008997,9.89341484 L94.8008997, 17.1035308 C94.8008997,18.3751985 93.7615475, 19.4089284 92.4983349,19.4089284 L85.064968, 19.4089284 C83.8077516,19.4089284 82.7664006, 18.3751985 82.7664006,17.1035308 L82.7664006, 9.89341484 Z M111.320603,27.32486 C112.585815, 27.32486 113.619171,28.3525914 113.619171, 29.6242591 L113.619171,86.3554352 C113.619171, 87.6211045 112.585815,88.6608328 111.320603, 88.6608328 L66.2267095,88.6608328 C64.9555019, 88.6608328 63.9161497,87.6211045 63.9161497, 86.3554352 L63.9161497,29.6222597 C63.9161497, 28.350592 64.9555019,27.3228605 66.2267095, 27.3228605 L111.320603,27.3228605 L111.320603, 27.32486 Z M63.8901659,9.89341484 C63.8901659, 8.62774556 64.9355143,7.58801724 66.1947295, 7.58801724 L73.6081088,7.58801724 C74.8853128, 7.58801724 75.9186687,8.62774556 75.9186687, 9.89341484 L75.9186687,17.1035308 C75.9186687, 18.3751985 74.8853128,19.4089284 73.6081088, 19.4089284 L66.1947295,19.4089284 C64.9375131, 19.4089284 63.8901659,18.3751985 63.8901659, 17.1035308 L63.8901659,9.89341484 Z M26.1376964, 9.89341484 C26.1376964,8.62774556 27.165056, 7.58801724 28.4362637,7.58801724 L35.8676319, 7.58801724 C37.1328433,7.58801724 38.1721955, 8.62774556 38.1721955,9.89341484 L38.1721955, 17.1035308 C38.1721955,18.3751985 37.1328433, 19.4089284 35.8676319,19.4089284 L28.4362637, 19.4089284 C27.165056,19.4089284 26.1376964, 18.3751985 26.1376964,17.1035308 L26.1376964, 9.89341484 Z M7.26346038,9.89341484 C7.26346038, 8.62774556 8.30281257,7.58801724 9.56802398, 7.58801724 L16.9814033,7.58801724 C18.2586073, 7.58801724 19.2859669,8.62774556 19.2859669, 9.89341484 L19.2859669,17.1035308 C19.2859669, 18.3751985 18.2586073,19.4089284 16.9814033, 19.4089284 L9.56802398,19.4089284 C8.30281257, 19.4089284 7.26346038,18.3751985 7.26346038, 17.1035308 L7.26346038,9.89341484 Z M7.26346038, 29.6222597 C7.26346038,28.350592 8.30281257, 27.3228605 9.56802398,27.3228605 L54.6559214, 27.3228605 C55.9331254,27.3228605 56.9664813, 28.350592 56.9664813,29.6222597 L56.9664813, 86.3534357 C56.9664813,87.619105 55.9331254, 88.6588333 54.6559214,88.6588333 L9.56802398, 88.6588333 C8.30281257,88.6588333 7.26346038, 87.619105 7.26346038,86.3534357 L7.26346038, 29.6222597 Z M19.2839682,106.08428 C19.2839682, 107.355948 18.2566085,108.389678 16.9794046, 108.389678 L9.56602523,108.389678 C8.30081381, 108.389678 7.26146163,107.355948 7.26146163, 106.08428 L7.26146163,98.8741641 C7.26146163, 97.6084948 8.30081381,96.5687665 9.56602523, 96.5687665 L16.9794046,96.5687665 C18.2566085, 96.5687665 19.2839682,97.6084948 19.2839682, 98.8741641 L19.2839682,106.08428 Z M38.1721955, 106.08428 C38.1721955,107.355948 37.1328433, 108.389678 35.8676319,108.389678 L28.4362637, 108.389678 C27.165056,108.389678 26.1376964, 107.355948 26.1376964,106.08428 L26.1376964, 98.8741641 C26.1376964,97.6084948 27.165056, 96.5687665 28.4362637,96.5687665 L35.8676319, 96.5687665 C37.1328433,96.5687665 38.1721955, 97.6084948 38.1721955,98.8741641 L38.1721955, 106.08428 Z M57.0544265,106.08428 C57.0544265, 107.355948 56.009078,108.389678 54.7438666, 108.389678 L47.324491,108.389678 C46.0532833, 108.389678 45.0139311,107.355948 45.0139311, 106.08428 L45.0139311,98.8741641 C45.0139311, 97.6084948 46.0552821,96.5687665 47.324491, 96.5687665 L54.7438666,96.5687665 C56.009078, 96.5687665 57.0544265,97.6084948 57.0544265, 98.8741641 L57.0544265,106.08428 Z M57.0544265, 17.1035308 C57.0544265,18.3751985 56.009078, 19.4089284 54.7438666,19.4089284 L47.324491, 19.4089284 C46.0532833,19.4089284 45.0139311, 18.3751985 45.0139311,17.1035308 L45.0139311, 9.89341484 C45.0139311,8.62774556 46.0552821, 7.58801724 47.324491,7.58801724 L54.7438666, 7.58801724 C56.009078,7.58801724 57.0544265, 8.62774556 57.0544265,9.89341484 L57.0544265, 17.1035308 Z M75.9186687,106.08428 C75.9186687, 107.355948 74.8853128,108.389678 73.6081088, 108.389678 L66.1947295,108.389678 C64.9375131, 108.389678 63.8901659,107.355948 63.8901659, 106.08428 L63.8901659,98.8741641 C63.8901659, 97.6084948 64.9355143,96.5687665 66.1947295, 96.5687665 L73.6081088,96.5687665 C74.8853128, 96.5687665 75.9186687,97.6084948 75.9186687, 98.8741641 L75.9186687,106.08428 Z M94.798901, 106.08428 C94.798901,107.355948 93.7595488, 108.389678 92.4963361,108.389678 L85.0629692, 108.389678 C83.8057528,108.389678 82.7644019, 107.355948 82.7644019,106.08428 L82.7644019, 98.8741641 C82.7644019,97.6084948 83.8037541, 96.5687665 85.0629692,96.5687665 L92.4963361, 96.5687665 C93.7595488,96.5687665 94.798901, 97.6084948 94.798901,98.8741641 L94.798901, 106.08428 Z M113.681132,106.08428 C113.681132, 107.355948 112.647776,108.389678 111.376568, 108.389678 L103.951196,108.389678 C102.679989, 108.389678 101.640637,107.355948 101.640637, 106.08428 L101.640637,98.8741641 C101.640637, 97.6084948 102.679989,96.5687665 103.951196, 96.5687665 L111.376568,96.5687665 C112.647776, 96.5687665 113.681132,97.6084948 113.681132, 98.8741641 L113.681132,106.08428 L113.681132, 106.08428 Z M113.681132,17.1035308 C113.681132, 18.3751985 112.647776,19.4089284 111.376568, 19.4089284 L103.951196,19.4089284 C102.679989, 19.4089284 101.640637,18.3751985 101.640637, 17.1035308 L101.640637,9.89341484 C101.640637, 8.62774556 102.679989,7.58801724 103.951196, 7.58801724 L111.376568,7.58801724 C112.647776, 7.58801724 113.681132,8.62774556 113.681132, 9.89341484 L113.681132,17.1035308 L113.681132, 17.1035308 Z'})))))))));};var LegacycomIcon=exports.LegacycomIcon=function LegacycomIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',viewBox:'0 0 1100.9 200.9'},_react2.default.createElement('g',{fill:'#999'},_react2.default.createElement('path',{d:'M668.1 126c1.7-1.7 3.7-2.5 6.1-2.5 2.4 0 4.4.8 6.1 2.5 1.7 1.7, 2.5 3.7 2.5 6.1 0 2.4-.8 4.4-2.5 6-1.7 1.6-3.7 2.4-6.1 2.4-2.4, 0-4.4-.8-6.1-2.4-1.7-1.6-2.5-3.6-2.5-6-.1-2.4.8-4.4 2.5-6.1zM773.9, 137.7c-5.4 1.8-11.1 2.7-17.4 2.7-7.3, 0-14.1-1.3-20.4-3.9-6.2-2.6-11.6-6.3-16-10.9-4.5-4.6-8-10.1-10.6-16.3-2.6-6.2-3.8-12.9-3.8-20.1, 0-7.2 1.2-13.9 3.7-20.2 2.5-6.3 6-11.8 10.5-16.5 4.5-4.7 9.9-8.4 16.2-11.1 6.2-2.7, 13-4.1 20.4-4.1 6.2 0 12 .9 17.4 2.7 5.4 1.8 10.3 4.2 14.7 7.1l-4.1, 6c-4-2.6-8.3-4.7-12.8-6.4-4.6-1.7-9.6-2.5-15.2-2.5-6.4 0-12.2 1.2-17.5, 3.5-5.3 2.3-9.8 5.4-13.5 9.4-3.8 3.9-6.7 8.6-8.8 14-2.1 5.4-3.1 11.3-3.1, 17.5 0 6.2 1 12.1 3.1 17.6 2.1 5.5 5 10.3 8.8 14.4 3.8 4.1 8.3 7.3 13.5, 9.6 5.3 2.3 11.1 3.5 17.5 3.5 5.6 0 10.7-.8 15.2-2.5 4.6-1.7 8.8-3.8, 12.8-6.4l4.1 6c-4.5 2.7-9.4 5.1-14.7 6.9zM894.1 108.8c-2.5 6.4-5.9, 11.9-10.2 16.5-4.3 4.6-9.5 8.3-15.5 11-6 2.7-12.5 4.1-19.5, 4.1s-13.5-1.3-19.4-3.9c-5.9-2.6-11-6.3-15.2-10.9-4.2-4.6-7.6-10.1-9.9-16.4-2.4-6.3-3.6-13-3.6-20.2, 0-7.2 1.2-13.9 3.7-20.3 2.5-6.3 5.9-11.8 10.2-16.5 4.3-4.7, 9.4-8.4 15.3-11 5.9-2.6 12.4-3.9 19.4-3.9 7 0 13.5 1.3 19.4, 3.9 5.9 2.6 11 6.2 15.3 10.8 4.3 4.6 7.7 10 10.1 16.3 2.4 6.3, 3.6 13 3.6 20.2.1 7.2-1.2 14-3.7, 20.3zm-7-37.6c-1.9-5.4-4.7-10.1-8.3-14.1-3.6-4-7.9-7.1-12.9-9.5-5-2.3-10.6-3.5-16.6-3.5-6.1, 0-11.6 1.2-16.5 3.5-5 2.3-9.2 5.5-12.8 9.5-3.6 4-6.3 8.7-8.3, 14.1-1.9 5.4-2.9 11.3-2.9 17.5 0 6.2 1 12.1 2.9 17.6 1.9 5.5 4.6 10.3, 8.1 14.2 3.5 4 7.8 7.2 12.8 9.5 5 2.3 10.6 3.5 16.7 3.5s11.6-1.2, 16.5-3.5c5-2.3 9.2-5.5 12.8-9.6 3.6-4.1 6.4-8.8 8.4-14.3 2-5.4, 3-11.3 3-17.5 0-6.1-1-12-2.9-17.4zM1057.7 71.7c0-18.2-7.8-27.3-23.5-27.3-7.2, 0-14.1 2.1-20.6 6.2-6.5 4.2-12.4 9.7-17.5 16.5v71.4h-7.7V71.7c0-18.2-7.8-27.3-23.5-27.3-7.3 0-14.2, 2.1-20.5 6.2-6.3 4.2-12.2 9.3-17.6 15.3v72.6h-7.7V39.1h7.4v18.7c2.2-2.5, 4.8-5.1 7.7-7.5 2.9-2.5 6-4.7 9.2-6.6 3.3-1.9 6.8-3.5 10.7-4.7, 3.8-1.2 7.8-1.8 12-1.8 6.7 0 12.6 1.8 17.7 5.5s8.6 9.4 10.3 17c4.8-6.1, 10.8-11.4 18-15.8 7.2-4.5 14.9-6.7 23.2-6.7 4 0 7.8.6 11.4 1.9 3.6 1.3, 6.8 3.3 9.6 6.1s5 6.3 6.6 10.5c1.6 4.2 2.4 9.3 2.4 15.2v67.6h-7.7V71.7z'})),_react2.default.createElement('g',{fill:'#069'},_react2.default.createElement('path',{d:'M0 144.1c8.8-.9 14.5-2.5 17.1-4.7 2.6-2.2 3.9-7.8, 3.9-16.8V26c0-8.5-1.3-14.1-3.9-16.7C14.6 6.7 8.9 5.1 0, 4.5V0h67.6v4.5c-8.8.5-14.7 1.9-17.7 4.3s-4.5 7.6-4.5, 15.6v105.1c0 2.7.5 4.7 1.3 6.3.9 1.5 2.9 2.5 5.9 2.9, 1.8.2 3.7.4 5.7.5 2 .1 5.7.1 11.2.1 21.3 0 26.5-1.8, 34-5.3s14.8-12.5 21.8-26.9h6.1l-11.7 41.5H0v-4.5zM218.2, 50.2c8.3 7.6 12.4 18.4 12.4 32.3h-74.3c.8 18.1 4.9 31.2, 12.3 39.5 7.4 8.2 16.2 12.4 26.3 12.4 8.2 0 15.1-2.1, 20.7-6.4 5.6-4.3 10.8-10.3 15.6-18.2l4.1 1.4c-3.2 9.9-9.2, 19.1-18 27.5-8.8 8.4-19.5 12.6-32.2 12.6-14.7, 0-26-5.5-34-16.6-8-11.1-12-23.8-12-38.3 0-15.7 4.6-29.2, 13.9-40.6 9.3-11.4 21.4-17.1 36.3-17.1 11 .1 20.6 3.9 28.9, 11.5zm-56.1 9c-2.5 4.2-4.3 9.5-5.4, 15.9h49.4c-.9-7.8-2.3-13.6-4.4-17.4-3.8-6.9-10.2-10.3-19.2-10.3-8.9-.1-15.7 3.9-20.4, 11.8zM252.9 96.7c-3.9-6-5.9-12.8-5.9-20.2 0-9.1 3.6-17.8 10.9-26, 7.3-8.2 17.5-12.3 30.8-12.3 5.7 0 12 1.3 18.8 4 6.9 2.7 13.5 4, 19.8 4 1.6 0 4.1-.1 7.4-.2 3.3-.1 5.7-.2 7.2-.2h1.4v9.5h-20.2c1.4, 3.3 2.5 6.1 3.3 8.5 1.3 4.5 2 8.8 2 12.9 0 8.9-3.7 17.1-11.1, 24.5-7.4 7.5-17.3 11.2-29.8 11.2-1.9 0-5.5-.3-10.5-1-2.3 0-5.3, 1.9-9 5.7-3.7 3.8-5.6 6.9-5.6 9.4s2.7 4.3 8.2 5.5c3.6.8 7.6 1.2, 12 1.2 20.1 0 33.7 1.1 40.9 3.4 11.8 3.7 17.7 11.5 17.7 23.6 0, 12.3-6.9 22.2-20.6 29.5-13.8 7.3-27.7 11-41.7 11-12.8, 0-22.9-2.6-30.4-7.8-7.5-5.2-11.2-10.6-11.2-16.3 0-2.8 1-5.5 3-8.2, 2-2.7 5.9-6.7 11.7-12l7.7-6.9 1.4-1.4c-3.6-1.4-6.2-2.8-8-4.1-3.1-2.4-4.7-5.2-4.7-8.3, 0-2.9 1.4-6.1 4-9.5 2.7-3.5 8.4-9.1 17.3-16.9-7.3-2.4-12.8-6.6-16.8-12.6zm12.4, 87c7.4 2.5 15.8 3.7 25.3 3.7 12.9 0 23.5-2.2 31.6-6.7 8.1-4.5, 12.2-10 12.2-16.6 0-5.2-3.3-8.7-9.8-10.4-4.1-1-11.8-1.6-23.1-1.8-2.9-.1-5.9-.2-9.1-.3-3.2-.1-6.1-.3-8.8-.4-1.7-.1-4.5-.4-8.3-.9-3.8-.5-6.7-1-8.6-1.4-.9, 0-3.2 2.5-6.8 7.4-3.7 5-5.6 9.6-5.6 13.8 0 6.6 3.7 11.1 11, 13.6zm37.2-80.3c4.7-3.7 7-10.3 7-19.5 0-7.4-1.9-15.7-5.7-25C300, 49.6 293.7 45 284.9 45c-7.6 0-12.9 3.6-15.8 10.9-1.5 3.8-2.2, 8.5-2.2 14.2 0 9.5 2.3 18.1 6.9 25.6 4.6 7.6 10.6 11.3 17.9, 11.3 4.3-.1 7.9-1.3 10.8-3.6zM366.3 96.9c7.2-4.7 21.5-11, 42.9-19.1v-9.9c0-7.9-.8-13.5-2.3-16.6-2.7-5.2-8.1-7.8-16.5-7.8-4, 0-7.8 1-11.4 3-3.6 2.1-5.4 5-5.4 8.7 0 .9.2 2.5.6 4.7.4 2.2.6, 3.6.6 4.3 0 4.4-1.4 7.4-4.3 9.1-1.6 1-3.6 1.5-5.9 1.5-3.5, 0-6.2-1.2-8.1-3.5-1.9-2.3-2.8-4.9-2.8-7.7 0-5.5 3.4-11.2 10.1-17.1, 6.7-6 16.6-9 29.7-9 15.1 0 25.4 4.9 30.8 14.7 2.9 5.4 4.3 13.2 4.3, 23.5v46.9c0 4.5.3 7.6.9 9.4 1 3 3.1 4.6 6.3 4.6 1.8 0 3.3-.3, 4.4-.8 1.2-.5 3.2-1.9 6.1-4v6.1c-2.5 3-5.2 5.5-8.1 7.5-4.4, 3-8.8 4.4-13.3 4.4-5.3 0-9.1-1.7-11.5-5.2-2.4-3.4-3.7-7.5-3.9-12.3-5.9 5.2-11, 9-15.2 11.5-7.1 4.2-13.8 6.3-20.2 6.3-6.7 0-12.5-2.4-17.4-7.1-4.9-4.7-7.4-10.7-7.4-18 .1-11.1, 5.7-20.5 17-28.1zm42.9-13.2c-9 3-16.4 6.2-22.2 9.8-11.2 6.9-16.9, 14.8-16.9 23.6 0 7.1 2.3 12.3 7 15.7 3 2.2 6.4 3.3 10.2 3.3 5.1 0, 10.1-1.4 14.8-4.3 4.7-2.9 7.1-6.6 7.1-11V83.7zM531.7 45.7c7.1 5, 10.6 10.5 10.6 16.5 0 2.6-.9 4.9-2.7 7.2-1.8 2.2-4.6 3.3-8.3, 3.3-2.7 0-5.1-.9-7.2-2.8-2.1-1.9-3.6-4.6-4.5-8.2l-1.4-5.6c-1-4.1-2.8-7.1-5.3-8.8-2.6-1.6-6-2.4-10.2-2.4-8.9 0-16.4, 3.9-22.5 11.6-6.1 7.8-9.2 18.1-9.2 31 0 11.8 3.4 22.4 10.1, 31.7 6.7 9.4 15.9 14.1 27.3 14.1 8.1 0 15.3-2.7 21.6-8 3.6-3, 7.6-7.9 12.2-14.5l3.3 2c-4.4 9.4-9.1 16.8-14 22.3-9.4 10.5-20.4, 15.7-32.8 15.7-12.2 0-22.9-4.8-32.3-14.4-9.4-9.6-14-22.6-14-39.1, 0-16.1 5.1-30 15.3-41.6C478 44 490.9 38.2 506.5 38.2c9.7 0 18.1 2.5, 25.2 7.5zM546.6 41H596v3.3c-3.9.1-6.8.5-8.7 1.1-3.6 1-5.4 3.1-5.4, 6.1 0 1.1.2 2.3.6 3.4.4 1.2 1.1 2.9 2.1 5.2l27.1 58.6 22.3-59c.2-.6.6-2.1, 1.1-4.3.5-2.2.8-3.7.8-4.6 0-2.1-.7-3.6-2.1-4.5-1.4-1-3.2-1.5-5.4-1.7l-3.6-.2V41H657v3.3c-3.2.4-5.6 1.5-7.2 3.4-1.6 1.8-3, 4.4-4.2 7.7L608.7 153c-6.4 16.9-12.5 29.1-18.4 36.6-5.9 7.6-13.3, 11.3-22.2 11.3-4.4 0-8.5-1.1-12.3-3.3-3.8-2.2-5.7-5.7-5.7-10.4, 0-3.1 1.1-5.7 3.4-7.7s5.1-3 8.6-3c2 0 5 .7 9 2.2 4 1.5 6.8 2.2 8.5, 2.2 4.3 0 8.9-5.3 13.6-15.9 4.8-10.6 7.2-17.6 7.2-21, 0-.7-.1-1.5-.3-2.5-.2-1-.5-1.9-.8-2.7l-36.9-79.7c-2.6-5.8-5-9.6-7-11.4-2-1.8-4.9-3-8.8-3.6V41z'})),_react2.default.createElement('path',{fill:'#999',d:'M1075 26.2c0-2.3.6-4.4 1.7-6.5 1.1-2 2.7-3.6 4.7-4.8 2-1.2 4.2-1.7, 6.5-1.7s4.4.6 6.5 1.7c2 1.1 3.6 2.7 4.7 4.7 1.2 2 1.7 4.2 1.7 6.5s-.6, 4.4-1.7 6.4-2.7 3.6-4.7 4.8c-2 1.2-4.2 1.8-6.6 1.8-2.4, 0-4.6-.6-6.6-1.8-2-1.2-3.6-2.8-4.7-4.8-1-1.9-1.5-4-1.5-6.3zm1.6, 0c0 2 .5 3.9 1.5 5.7 1 1.7 2.4 3.1 4.1 4.1 1.7 1 3.6 1.5 5.7, 1.5s3.9-.5 5.7-1.5c1.7-1 3.1-2.4 4.1-4.1 1-1.7 1.5-3.6 1.5-5.7, 0-2-.5-3.9-1.5-5.6-1-1.7-2.4-3.1-4.1-4.2-1.8-1.1-3.7-1.6-5.8-1.6-2, 0-3.9.5-5.7 1.5-1.8 1-3.1 2.4-4.2 4.2-.8 1.8-1.3 3.7-1.3, 5.7zm15.9-3.2c0 .9-.2 1.7-.7 2.4-.4.7-1.1 1.2-1.9 1.6l4.1, 6.8h-2.1l-3.6-6.2h-2.9v6.2h-1.7V18.7h3.6c1.6 0 2.9.4 3.8 1.1, 1 .6 1.4 1.7 1.4 3.2zm-7 3.2h1.9c1 0 1.9-.3 2.5-.8.6-.5.9-1.3.9-2.3, 0-2-1.1-3-3.4-3h-1.9v6.1z'}));};var SearchIcon=exports.SearchIcon=function SearchIcon(){return _react2.default.createElement('svg',{version:'1.1',xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink',x:'0px',y:'0px',viewBox:'-596 381.8 30.2 30.2',enableBackground:'new -596 381.8 30.2 30.2',xmlSpace:'preserve'},_react2.default.createElement('g',null,_react2.default.createElement('path',{fill:'#FFFFFF',d:'M-575.8,385.2c-4.6-4.6-12.1-4.6-16.7,0c-4.6,4.6-4.6,12.1,0,16.7c4.1, 4.1,10.5,4.5,15.1,1.3 c0.1,0.5,0.3,0.9,0.7,1.3l6.7,6.7c1,1,2.6,1,3.5, 0c1-1,1-2.6,0-3.5l-6.7-6.7c-0.4-0.4-0.8-0.6-1.3-0.7 C-571.3,395.7-571.7, 389.3-575.8,385.2z M-577.9,399.8c-3.4,3.4-9,3.4-12.5,0c-3.4-3.4-3.4-9, 0-12.5c3.4-3.4,9-3.4,12.5,0 C-574.5,390.8-574.5,396.4-577.9,399.8z'})));};var GalleryIcon=exports.GalleryIcon=function GalleryIcon(){return _react2.default.createElement('svg',{width:'50',height:'50',viewBox:'0 0 50 50',xmlns:'https://www.w3.org/2000/svg'},_react2.default.createElement('path',{d:'M26 35.188L18.75 22.5 8.75 40H42.5l-10-13.75-6.5 8.938zM0 1.99C0 .89.89 0 1.99 0h46.02C49.108 0 50 .89 50 1.99v46.02c0 1.099-.89 1.99-1.99 1.99H1.99C.892 50 0 49.11 0 48.01V1.99zM30 20a5 5 0 1 0 0-10 5 5 0 0 0 0 10z',fill:'currentColor',fillRule:'evenodd'}));};var GalleryAddIcon=exports.GalleryAddIcon=function GalleryAddIcon(){return _react2.default.createElement('svg',{width:'15',height:'14',viewBox:'0 0 14 14',xmlns:'https://www.w3.org/2000/svg'},_react2.default.createElement('g',{fill:'none',fillRule:'evenodd'},_react2.default.createElement('path',{d:'M7-2.9L16.9 7 7 16.9-2.9 7z'}),_react2.default.createElement('path',{d:'M11.95 11.95a7 7 0 1 1-9.9-9.9 7 7 0 0 1 9.9 9.9zm-4.2-8.485a.75.75 0 1 0-1.5 0V6.25H3.464a.75.75 0 1 0 0 1.5H6.25v2.786a.75.75 0 1 0 1.5 0V7.75h2.786a.75.75 0 1 0 0-1.5H7.75V3.465z',fill:'currentColor'})));};var EmailSignupIcon=exports.EmailSignupIcon=function EmailSignupIcon(){return _react2.default.createElement('svg',{width:'142',height:'80',viewBox:'0 0 142 80'},_react2.default.createElement('g',{fill:'#FFF',fillRule:'evenodd'},_react2.default.createElement('path',{d:'M63.528 0h-.318c-4.124 0-7.479 3.387-7.479 7.55V8.93c-9.961 3.262-17.184 12.715-17.184 23.845v21.238c0 1.042-.84 1.89-1.871 1.89h-.096c-4.18 0-7.58 3.433-7.58 7.653v.115c0 4.22 3.4 7.653 7.58 7.653h17.898c.39 4.692 4.291 8.675 9.038 8.675h.145c4.747 0 8.647-3.983 9.038-8.675h18.413c3.963 0 6.625-3.075 6.625-7.653v-.115c0-4.578-2.662-7.653-6.625-7.653h-.096a1.882 1.882 0 0 1-1.87-1.89V33.017c0-11.528-7.678-21.273-18.14-24.316V7.55c0-4.163-3.355-7.55-7.478-7.55zM59.55 7.55c0-2.037 1.642-3.695 3.66-3.695h.317c2.018 0 3.66 1.658 3.66 3.695v.362a24.86 24.86 0 0 0-3.107-.201h-.706c-1.3 0-2.577.102-3.824.298v-.46zm4.11 68.595h-.145c-2.64 0-4.83-2.258-5.202-4.82h10.549c-.371 2.562-2.562 4.82-5.202 4.82zm27.395-16.386h.057c2.533 0 2.807 2.655 2.807 3.798v.115c0 1.142-.274 3.798-2.807 3.798H36.58c-2.073 0-3.761-1.704-3.761-3.798v-.115c0-2.094 1.688-3.798 3.761-3.798h54.475zm-5.728-26.742v20.997c0 .664.117 1.297.322 1.89H42.043a5.756 5.756 0 0 0 .323-1.89V32.776c0-11.696 9.424-21.21 21.008-21.21h.706c11.716 0 21.247 9.622 21.247 21.45zM102.95 12.986c-1.052 0-1.945.933-1.95 1.971v23.659c0 1.032.929 1.971 1.95 1.971h37.04c1.022 0 1.95-.94 1.95-1.971V14.957c0-1.032-.928-1.971-1.95-1.971h-37.04zm5.94 3.943h25.16l-12.58 9.365-12.58-9.365zm-3.99 1.91l15.413 11.49a1.932 1.932 0 0 0 2.315 0l15.413-11.49v17.805H104.9V18.84zM1.402 29.278c-.756 0-1.398.68-1.402 1.435v17.223c0 .751.668 1.435 1.402 1.435h26.63c.733 0 1.401-.684 1.401-1.435V30.713c0-.751-.668-1.435-1.402-1.435H1.401zm4.27 2.87h18.089l-9.044 6.818-9.045-6.817zM2.803 33.54l11.081 8.365c.495.373 1.17.373 1.665 0l11.08-8.365v12.962H2.804V33.539z'}),_react2.default.createElement('path',{d:'M91.99 2.19c-.534 0-.988.467-.99.985v11.807c0 .515.471.984.99.984h18.796c.518 0 .989-.469.989-.984V3.175c0-.515-.471-.984-.99-.984H91.99zm3.013 1.969h12.768l-6.384 4.673-6.384-4.673zm-2.024.953l7.821 5.734a.994.994 0 0 0 1.175 0l7.821-5.734v8.886H92.98V5.112z'})));};var EmailSignupSuccessIcon=exports.EmailSignupSuccessIcon=function EmailSignupSuccessIcon(){return _react2.default.createElement('svg',{width:'40',height:'42',viewBox:'0 0 40 40'},_react2.default.createElement('g',{fill:'none',fillRule:'evenodd'},_react2.default.createElement('circle',{cx:'20',cy:'20',r:'20',fill:'#FFF'}),_react2.default.createElement('path',{stroke:'#46BE6F',strokeWidth:'3',d:'M10 21.182l6.364 6.363L30.909 13'})));};var InfoIcon=exports.InfoIcon=function InfoIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'17',height:'17',viewBox:'0 0 17 17'},_react2.default.createElement('g',{fill:'none',fillRule:'evenodd',transform:'translate(1.326 1)'},_react2.default.createElement('circle',{cx:'7.5',cy:'7.5',r:'7.5',stroke:'#979797'}),_react2.default.createElement('text',{fill:'#999',fontFamily:'OpenSans-Bold, Open Sans, sans-serif',fontSize:'10',fontWeight:'bold'},_react2.default.createElement('tspan',{x:'5.415',y:'11'},'?'))));};var VideoPlayIcon=exports.VideoPlayIcon=function VideoPlayIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'75',height:'75',viewBox:'0 0 75 75'},_react2.default.createElement('g',{fill:'none',fillRule:'evenodd'},_react2.default.createElement('circle',{cx:'37.5',cy:'37.5',r:'37.5',fill:'#E1E1E1',fillOpacity:'.75'}),_react2.default.createElement('path',{fill:'#FFF',d:'M53.311 37.656c1.485.742 1.494 1.941 0 2.688L28.69 52.656C27.204 53.398 26 52.653 26 51V27c0-1.657 1.195-2.403 2.689-1.656L53.31 37.656z'})));};var CondolenceQuotesIcon=exports.CondolenceQuotesIcon=function CondolenceQuotesIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'47',height:'43',viewBox:'0 0 47 43'},_react2.default.createElement('g',{fill:'none',fillRule:'evenodd',transform:'translate(.372)'},_react2.default.createElement('ellipse',{cx:'23',cy:'21.5',fill:'#F5F5F5',rx:'23',ry:'21.5'}),_react2.default.createElement('path',{fill:'#828892',d:'M33.316 11.138v1.196c-1.81.618-3.23 1.591-4.257 2.917-1.027 1.327-1.54 2.706-1.54 4.139 0 .309.052.537.156.683.07.098.148.147.235.147s.218-.057.392-.171c.557-.375 1.262-.562 2.115-.562.993 0 1.872.379 2.638 1.136.766.756 1.15 1.656 1.15 2.697 0 1.09-.44 2.051-1.32 2.881-.879.83-1.945 1.245-3.199 1.245-1.463 0-2.725-.561-3.787-1.684-1.062-1.123-1.593-2.629-1.593-4.517 0-2.197.722-4.167 2.168-5.908 1.445-1.742 3.726-3.141 6.842-4.2zm-12.562 0v1.196c-1.81.618-3.23 1.591-4.257 2.917-1.028 1.327-1.541 2.706-1.541 4.139 0 .309.052.537.157.683.07.098.148.147.235.147s.217-.057.391-.171c.558-.375 1.263-.562 2.116-.562.992 0 1.872.379 2.638 1.136.766.756 1.149 1.656 1.149 2.697 0 1.09-.44 2.051-1.319 2.881-.88.83-1.946 1.245-3.2 1.245-1.462 0-2.724-.561-3.786-1.684-1.063-1.123-1.594-2.629-1.594-4.517 0-2.197.723-4.167 2.168-5.908 1.445-1.742 3.726-3.141 6.843-4.2z'})));};var ThankYouEmailIcon=exports.ThankYouEmailIcon=function ThankYouEmailIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'56',height:'40',viewBox:'0 0 56 40'},_react2.default.createElement('path',{fill:'#FFF',fillRule:'evenodd',d:'M51.8 12.8l-5.811 5.934c-1.89 1.932-3.781 3.863-5.673 5.793L28.832 12.788a6.025 6.025 0 0 1 0-8.486c1.12-1.143 2.599-1.772 4.163-1.772 1.565 0 3.044.629 4.163 1.771l2.28 2.336c.225.232.547.365.884.365.337 0 .659-.133.881-.363l2.27-2.325c1.12-1.142 2.598-1.771 4.164-1.771 1.565 0 3.044.629 4.164 1.77a6.022 6.022 0 0 1 0 8.487zM2.61 37.322V16.048l17.44 13.16c.463.35 1.085.35 1.547 0l11.378-8.585 6.063 6.199v10.5H2.61zm24.633-22.558l3.868 3.954-10.287 7.75L5.289 14.764h21.954zM53.55 2.514C51.97.902 49.869.014 47.637.014c-2.233 0-4.333.888-5.915 2.502l-1.395 1.43-1.432-1.457c-1.71-1.607-3.972-2.56-5.91-2.484a8.225 8.225 0 0 0-5.903 2.499c-2.536 2.587-3.105 6.433-1.707 9.583H1.305c-.68 0-1.301.64-1.305 1.343v25.232C0 39.337.646 40 1.305 40h39.038c.658 0 1.305-.663 1.305-1.339V26.756c1.94-1.98 3.879-3.961 5.817-5.942l6.086-6.215c3.265-3.332 3.265-8.753 0-12.084z'}));};var CloseXIcon=exports.CloseXIcon=function CloseXIcon(_ref){var primaryFill=_ref.primaryFill,size=_ref.size;var path='M13.22,12l8.84,8.8a.85.85,0,0,1,0,1.21l-.26.25a.88.88,0,0,1-1.22,0l-8.72-8.7L3.06,22.24a.86.86,0,0,1-1.22,0L1.56,22a.86.86,0,0,1,0-1.21L10.48,12,1.56,3.23A.86.86,0,0,1,1.56,2l.28-.26a.86.86,0,0,1,1.22,0l8.79,8.69,8.72-8.7a.88.88,0,0,1,1.22,0l.26.25a.85.85,0,0,1,0,1.21Z';// If the close icon is small, we want to use a heavier icon
if(size<18){path='M14.58,12,22,4.61a1.69,1.69,0,0,0,.5-1.21A1.64,1.64,0,0,0,22,2.2L21.74,2a1.7,1.7,0,0,0-2.38,0L12,9.3,4.65,2a1.67,1.67,0,0,0-1.2-.49A1.7,1.7,0,0,0,2.25,2L2,2.24a1.7,1.7,0,0,0-.5,1.2A1.68,1.68,0,0,0,2,4.64L9.48,12,2,19.36a1.69,1.69,0,0,0,0,2.4l.25.25a1.72,1.72,0,0,0,1.2.48A1.67,1.67,0,0,0,4.65,22L12,14.7,19.36,22a1.7,1.7,0,0,0,2.38,0L22,21.8a1.64,1.64,0,0,0,.52-1.2,1.66,1.66,0,0,0-.5-1.21Z';}return _react2.default.createElement('svg',{id:'icon-close','data-name':'Icon Close',xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24',width:size,height:size},_react2.default.createElement('title',null,'Close'),_react2.default.createElement('path',{id:'close',fill:primaryFill,d:path}));};CloseXIcon.defaultProps={primaryFill:'currentColor',size:21};CloseXIcon.propTypes={primaryFill:_propTypes2.default.string};var HeartIcon=exports.HeartIcon=function HeartIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'52',height:'45',viewBox:'0 0 52 45'},_react2.default.createElement('path',{fill:'none',fillRule:'evenodd',stroke:'#FFF',strokeWidth:'2',d:'M47.543 21.374c-2.588 2.648-4.82 4.932-9.223 9.442l-1.317 1.35-1.47 1.504c-4.163 4.264-6.338 6.49-8.82 9.029l-.715.732L4.454 21.353c-4.605-4.72-4.606-12.118 0-16.829C6.672 2.254 9.611 1 12.72 1c3.11 0 6.049 1.254 8.268 3.524l4.138 4.25c.217.225.54.359.883.359.342 0 .666-.134.882-.359l4.118-4.229c2.218-2.268 5.157-3.521 8.267-3.521 3.11 0 6.05 1.253 8.267 3.521 4.61 4.716 4.61 12.114 0 16.83z'}));};var ModalArrow=exports.ModalArrow=function ModalArrow(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'26',height:'50',viewBox:'0 0 25.45 48.78'},_react2.default.createElement('polygon',{fill:'currentColor',points:'24.39 48.78 0 24.39 24.39 0 25.45 1.06 2.12 24.39 25.45 47.72 24.39 48.78'}));};var ErrorInfoIcon=exports.ErrorInfoIcon=function ErrorInfoIcon(){return _react2.default.createElement('svg',{height:'50',viewBox:'0 0 51 50',width:'51',xmlns:'https://www.w3.org/2000/svg'},_react2.default.createElement('g',{fill:'#48565E',fillRule:'nonzero',transform:'translate(.372)'},_react2.default.createElement('path',{d:'M25 0C11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25S38.807 0 25 0zm0 46.667c-11.977 0-21.667-9.69-21.667-21.667 0-11.977 9.69-21.667 21.667-21.667 11.977 0 21.667 9.69 21.667 21.667 0 11.977-9.69 21.667-21.667 21.667z'}),_react2.default.createElement('path',{d:'M25 30.114a2.28 2.28 0 0 0 2.273-2.273V14.773A2.28 2.28 0 0 0 25 12.5a2.28 2.28 0 0 0-2.273 2.273V27.84A2.28 2.28 0 0 0 25 30.114z'}),_react2.default.createElement('circle',{cx:'25',cy:'35.398',r:'2.841'})));};var UGCSearchIcon=exports.UGCSearchIcon=function UGCSearchIcon(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'14',height:'14',viewBox:'0 0 14 15'},_react2.default.createElement('path',{fill:'currentColor',fillRule:'evenodd',d:'M2.05 11.95a7 7 0 1 1 9.9-9.9 7 7 0 0 1-9.9 9.9zm8.485-4.2a.75.75 0 1 0 0-1.5H7.75V3.464a.75.75 0 1 0-1.5 0V6.25H3.464a.75.75 0 1 0 0 1.5H6.25v2.786a.75.75 0 1 0 1.5 0V7.75h2.785z'}));};var RightFollowLink=exports.RightFollowLink=function RightFollowLink(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',xmlnsXlink:'https://www.w3.org/1999/xlink',width:'16',height:'16',viewBox:'0 0 16 16'},_react2.default.createElement('defs',null,_react2.default.createElement('path',{id:'a',d:'M14.678 3.503l-6.765 6.855-6.826-6.855L0 4.59l7.913 7.913 7.852-7.943z'})),_react2.default.createElement('use',{fill:'#48565E',fillRule:'nonzero',transform:'rotate(-90 7.883 8.003)',xlinkHref:'#a'}));};var LikesHeart=exports.LikesHeart=function LikesHeart(){return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:'24',height:'20',viewBox:'0 0 24 20'},_react2.default.createElement('defs',null,_react2.default.createElement('path',{d:'M6.003.072a6.016 6.016 0 0 0-4.24 1.73 5.865 5.865 0 0 0 0 8.378l9.932 9.814a.27.27 0 0 0 .38 0c3.314-3.267 6.625-6.538 9.94-9.805a5.853 5.853 0 0 0 0-8.37 6.046 6.046 0 0 0-8.48 0l-1.638 1.614-1.655-1.63A6.015 6.015 0 0 0 6.002.072z'})),_react2.default.createElement('g',{fill:'currentColor',fillRule:'evenodd'},_react2.default.createElement('path',{d:'M11.885 19.479l4.77-4.706.093-.092c2.428-2.396 3.546-3.499 4.916-4.848a5.353 5.353 0 0 0 0-7.657 5.546 5.546 0 0 0-7.777 0l-1.99 1.958-.35-.345L9.89 2.16A5.514 5.514 0 0 0 6.003.572a5.514 5.514 0 0 0-3.889 1.587 5.365 5.365 0 0 0 0 7.666l9.77 9.654zm0 0l.161.159a.23.23 0 0 0-.322 0l.16-.16z'})));};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.queryRequest=queryRequest;exports.mutationRequest=mutationRequest;exports.queryFailure=queryFailure;exports.mutationFailure=mutationFailure;exports.queryCondolencesSuccess=queryCondolencesSuccess;exports.queryGallerySuccess=queryGallerySuccess;exports.mutateCondolenceSuccess=mutateCondolenceSuccess;exports.mutatePersonAlertSuccess=mutatePersonAlertSuccess;exports.mutatePersonAlertFailure=mutatePersonAlertFailure;exports.resetMutationStatus=resetMutationStatus;exports.queryLocationSearchSuccess=queryLocationSearchSuccess;exports.mutatePersonUGCSuccess=mutatePersonUGCSuccess;exports.mutatePersonUGCFailure=mutatePersonUGCFailure;exports.mutateCondolenceLikesSuccess=mutateCondolenceLikesSuccess;exports.mutateCondolenceLikesFailure=mutateCondolenceLikesFailure;exports.isFromPlanning=isFromPlanning;exports.setTabIndex=setTabIndex;var QUERY_REQUEST=exports.QUERY_REQUEST='QUERY_REQUEST';var MUTATION_REQUEST=exports.MUTATION_REQUEST='MUTATION_REQUEST';var QUERY_FAILURE=exports.QUERY_FAILURE='QUERY_FAILURE';var MUTATION_FAILURE=exports.MUTATION_FAILURE='MUTATION_FAILURE';var QUERY_CONDOLENCES_SUCCESS=exports.QUERY_CONDOLENCES_SUCCESS='QUERY_CONDOLENCES_SUCCESS';var MUTATE_CONDOLENCE_SUCCESS=exports.MUTATE_CONDOLENCE_SUCCESS='MUTATE_CONDOLENCE_SUCCESS';var MUTATE_PERSON_ALERT_SUCCESS=exports.MUTATE_PERSON_ALERT_SUCCESS='MUTATE_PERSON_ALERT_SUCCESS';var MUTATE_PERSON_ALERT_FAILURE=exports.MUTATE_PERSON_ALERT_FAILURE='MUTATE_PERSON_ALERT_FAILURE';var RESET_MUTATION_STATUS=exports.RESET_MUTATION_STATUS='RESET_MUTATION_STATUS';var QUERY_GALLERY_SUCCESS=exports.QUERY_GALLERY_SUCCESS='QUERY_GALLERY_SUCCESS';var QUERY_LOCATION_SEARCH_SUCCESS=exports.QUERY_LOCATION_SEARCH_SUCCESS='QUERY_LOCATION_SEARCH_SUCCESS';var MUTATE_PERSON_UGC_SUCCESS=exports.MUTATE_PERSON_UGC_SUCCESS='MUTATE_PERSON_UGC_SUCCESS';var MUTATE_PERSON_UGC_FAILURE=exports.MUTATE_PERSON_UGC_FAILURE='MUTATE_PERSON_UGC_FAILURE';var MUTATE_LIKES_SUCCESS=exports.MUTATE_LIKES_SUCCESS='MUTATE_LIKES_SUCCESS';var MUTATE_LIKES_FAILURE=exports.MUTATE_LIKES_FAILURE='MUTATE_LIKES_FAILURE';var PLANNING_TOKEN_EXISTS=exports.PLANNING_TOKEN_EXISTS='PLANNING_TOKEN_EXISTS';var SET_TAB_INDEX=exports.SET_TAB_INDEX='SET_TAB_INDEX';var AD_SERVICE=exports.AD_SERVICE='AD_SERVICE';var AFFILIATE_STORE=exports.AFFILIATE_STORE='AFFILIATE_STORE';var FOOTER_STORE=exports.FOOTER_STORE='FOOTER_STORE';var FUNERAL_HOME_STORE=exports.FUNERAL_HOME_STORE='FUNERAL_HOME_STORE';var NEARBY_FUNERAL_HOMES_STORE=exports.NEARBY_FUNERAL_HOMES_STORE='NEARBY_FUNERAL_HOMES_STORE';var HEADER_STORE=exports.HEADER_STORE='HEADER_STORE';var OBITUARIES_REQUEST=exports.OBITUARIES_REQUEST='OBITUARIES_REQUEST';var OBITUARIES_SUCCESS=exports.OBITUARIES_SUCCESS='OBITUARIES_SUCCESS';var OBITUARIES_ERROR=exports.OBITUARIES_ERROR='OBITUARIES_ERROR';var UPCOMING_SERVICES_STORE=exports.UPCOMING_SERVICES_STORE='UPCOMING_SERVICES_STORE';var ERROR=exports.ERROR='ERROR';var MOBILE_DETAILS=exports.MOBILE_DETAILS='MOBILE_DETAILS';var SEARCH_FUNERAL_HOMES=exports.SEARCH_FUNERAL_HOMES='SEARCH_FUNERAL_HOMES';var PERSON_STORE_HYDRATION=exports.PERSON_STORE_HYDRATION='PERSON_STORE_HYDRATION';/**
 * Creates an action that sets the `loading` flag to `true` upon query start
 * @method queryRequest
 * @return {object} the action object
 */function queryRequest(){return{type:QUERY_REQUEST};}/**
 * Creates an action that sets the `loading` flag to `true` upon mutation start
 * @method mutationRequest
 * @return {object} the action object
 */function mutationRequest(){return{type:MUTATION_REQUEST};}/**
 * Creates an action that sets the `loading` flag to `false`
 * and passes the reason for query failure to the reducer
 * @method queryFailure
 * @param  {object} reason the reason for failure
 * @return {object} the action object
 */function queryFailure(reason){return{type:QUERY_FAILURE,reason:reason};}/**
 * Creates an action that sets the `loading` flag to `false`
 * and passes the reason for mutation failure to the reducer
 * @method mutationFailure
 * @param  {object} reason - the reason for the mutation failure
 * @return {object} the action object
 */function mutationFailure(reason){return{type:MUTATION_FAILURE,reason:reason};}/**
 * Creates an action that reduces the condolence query response
 * @method queryCondolencesSuccess
 * @param  {object} response - the addditional condolences
 * @return {object} the action object with the condolence query response
 */function queryCondolencesSuccess(response){return{type:QUERY_CONDOLENCES_SUCCESS,response:response};}/**
 * Creates an action that reduces the gallery query reponse
 * @method queryGallerySuccess
 * @param  {object} response - the additional gallery condolences
 * @return {object} the action object with the galley condolence response
 */function queryGallerySuccess(response){return{type:QUERY_GALLERY_SUCCESS,response:response};}/**
 * Creates an action that reduces the condolence mutation response
 * @method mutateCondolenceSuccess
 * @param  {object} response - the response for successful mutation
 * @return {object} the action object with the condolence mutation response
 */function mutateCondolenceSuccess(response){return{type:MUTATE_CONDOLENCE_SUCCESS,response:response};}/**
 * Creates an action that reduces the person alert response
 * @method mutatePersonAlertSuccess
 * @param  {object} response - the alertId from the successful mutation
 * @return {object} the action object with the person alert mutation response
 */function mutatePersonAlertSuccess(response){return{type:MUTATE_PERSON_ALERT_SUCCESS,response:response};}/**
 * Creates an action that reduces the person alert falure response
 * @method mutatePersonAlertFailure
 * @param  {object} reason - the reason for failure
 * @return {object} the action object with the person alert mutation mutation
 */function mutatePersonAlertFailure(reason){return{type:MUTATE_PERSON_ALERT_FAILURE,reason:reason};}/**
 * Creates an action that will reset the mutation status
 * @method resetMutationStatus
 * @return {object} the action object with the condolence mutation response
 */function resetMutationStatus(){return{type:RESET_MUTATION_STATUS};}/**
 * Creates an action that will fetch location results
 * @param  {object} response the location response from query
 * @return {object}          the action object with the location search query
 */function queryLocationSearchSuccess(response){return{type:QUERY_LOCATION_SEARCH_SUCCESS,response:response};}/**
 * Creates an action for a UGC write success
 * @param  {object} response the id of the newly inserted UGC data
 * @return {object}          the action object with the UGC success response
 */function mutatePersonUGCSuccess(response){return{type:MUTATE_PERSON_UGC_SUCCESS,response:response};}/**
 * Creates an action for a UGC write failure
 * @param  {object} reason   the reason for failure
 * @return {object}          the action object with the UGC failure reason
 */function mutatePersonUGCFailure(reason){return{type:MUTATE_PERSON_UGC_FAILURE,reason:reason};}/**
 * Creates an action for a LIKES write success
 * @param  {object} response the id and new likes count
 * @return {object}          the action object with the likes success response
 */function mutateCondolenceLikesSuccess(response){return{type:MUTATE_LIKES_SUCCESS,response:response};}/**
 * Creates an action for a LIKES write failure
 * @param  {object} reason   the reason for failure
 * @return {object}          the action object with the likes failure reason
 */function mutateCondolenceLikesFailure(reason){return{type:MUTATE_LIKES_FAILURE,reason:reason};}/**
 * Creates an action for updating whether the user came in via planning
 * @param  {object} planningExists  the planning token
 * @return {object}                 the action object with the planningTokenBoolean
 */function isFromPlanning(planningExists){return{type:PLANNING_TOKEN_EXISTS,planningExists:planningExists};}/**
 * Creates an action to update the tab index
 * @param  {object} tab        the tab index
 * @return {object}            the action object with the tabIndexNumber
 */function setTabIndex(tab){return{type:SET_TAB_INDEX,tab:tab};}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(70);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Audio=__webpack_require__(1035);Object.defineProperty(exports,'Audio',{enumerable:true,get:function get(){return _interopRequireDefault(_Audio).default;}});var _Collapse=__webpack_require__(1036);Object.defineProperty(exports,'Collapse',{enumerable:true,get:function get(){return _interopRequireDefault(_Collapse).default;}});var _Modal=__webpack_require__(1044);Object.defineProperty(exports,'Modal',{enumerable:true,get:function get(){return _interopRequireDefault(_Modal).default;}});var _IframedVideo=__webpack_require__(1046);Object.defineProperty(exports,'IframedVideo',{enumerable:true,get:function get(){return _interopRequireDefault(_IframedVideo).default;}});var _Video=__webpack_require__(1175);Object.defineProperty(exports,'Video',{enumerable:true,get:function get(){return _interopRequireDefault(_Video).default;}});var _FormControls=__webpack_require__(1176);Object.defineProperty(exports,'FormControls',{enumerable:true,get:function get(){return _interopRequireDefault(_FormControls).default;}});var _Spinner=__webpack_require__(1195);Object.defineProperty(exports,'Spinner',{enumerable:true,get:function get(){return _interopRequireDefault(_Spinner).default;}});var _FuneralHomeHeader=__webpack_require__(1197);Object.defineProperty(exports,'FuneralHomeHeader',{enumerable:true,get:function get(){return _interopRequireDefault(_FuneralHomeHeader).default;}});var _FuneralHomeFooter=__webpack_require__(1206);Object.defineProperty(exports,'FuneralHomeFooter',{enumerable:true,get:function get(){return _interopRequireDefault(_FuneralHomeFooter).default;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.GA_SITENAMES=exports.SUGGESTED_ENTRY_KEY=exports.PERSON_SIGNUP_KEY=exports.MEDIA_TYPES=exports.VIDEO_INPUT=exports.QUESTION_PARAM=exports.PROMO_ADVICE_AND_SUPPORT=exports.PERSON_PAGE_TYPE=exports.OBIT_TYPE_INTERNATIONAL_PAID=exports.OBIT_TYPE_INTERNATIONAL_UNPAID=exports.OBIT_TYPE_TRIBUTES_UNPAID=exports.OBIT_TYPE_MEMORIAM=exports.OBIT_TYPE_LEGACY=exports.IFRAME_VIDEO_KEY=exports.GUIDELINES_BASE_URL=exports.FUNERAL_HOME_TYPE=exports.FLOWER_TYPE_LEGACY=exports.FAQ_BASE_URL=exports.ENTRY_TEXT_AREA_KEY=exports.ENTRY_PANEL_KEY=exports.ENTRY_KEY=exports.BATESVILLE_LOCATION_TYPE_NONE=exports.AFFILIATE_PARAM=exports.AFFILIATE_COOKIE=exports.AD_PGB=exports.AD_DIGNITY_MEMORIAL=undefined;var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var vanityDomain=(0,_AppConfig2.default)().vanityDomain;var ENTRY_KEY='_entry';var ENTRY_PANEL_KEY='_entryPanel';var ENTRY_TEXT_AREA_KEY='_entryTextArea';var IFRAME_VIDEO_KEY='_iframeVideoKey';var VIDEO_INPUT='_videoInput';var PERSON_SIGNUP_KEY='_personSignupKey';var SUGGESTED_ENTRY_KEY='_suggestedEntryKey';var FAQ_BASE_URL=vanityDomain+'/guestbooks/faq.aspx';var GUIDELINES_BASE_URL=vanityDomain+'/guestbooks/posting-guidelines.aspx';var OBIT_TYPE_LEGACY='legacy';var OBIT_TYPE_MEMORIAM='memoriam';var OBIT_TYPE_TRIBUTES_UNPAID='tributes_unpaid';var OBIT_TYPE_INTERNATIONAL_UNPAID='international_unpaid';var OBIT_TYPE_INTERNATIONAL_PAID='international_paid';var FLOWER_TYPE_LEGACY='legacy';// this is a value used for mimetype identification AND display
var MEDIA_TYPES={video:'Video',image:'Photo',audio:'Audio',default:'Item'};var AD_PAGENAME='person';var AD_PGB={adSize:[[300,200]],clientLoadOnly:true,maxIdleAdRefreshes:0,pageName:AD_PAGENAME,positionId:'custom-1',slotName:'custom-1'};var AD_DIGNITY_MEMORIAL={adSize:[[1,1]],clientLoadOnly:true,maxIdleAdRefreshes:0,pageName:AD_PAGENAME,positionId:'tracking-1',slotName:'tracking-1'};var PROMO_ADVICE_AND_SUPPORT='adviceAndSupport';var PERSON_PAGE_TYPE={personPage:'person_page',batesvillePersonPage:'batesville_person_page',forestLawnPersonPage:'fl_person_page',tributesFhPersonPage:'tributes_fh_person_page'};var FUNERAL_HOME_TYPE={batesville:'batesville',forestlawn:'forestlawn',tributes:'tributes'};var BATESVILLE_LOCATION_TYPE_NONE='NONE';var QUESTION_PARAM='question';var AFFILIATE_PARAM='affiliateId';var AFFILIATE_COOKIE={name:'LegacyGlobal',idKey:'AffiliateId',urlKey:'AffiliateUrl',siteNameKey:'AffiliateSiteName'};// person-service changes only those two from real sitename to gaSitename, all the rest are the sitename
var GA_SITENAMES={dignityMemorial:'sci',tributes:'independent'};exports.AD_DIGNITY_MEMORIAL=AD_DIGNITY_MEMORIAL;exports.AD_PGB=AD_PGB;exports.AFFILIATE_COOKIE=AFFILIATE_COOKIE;exports.AFFILIATE_PARAM=AFFILIATE_PARAM;exports.BATESVILLE_LOCATION_TYPE_NONE=BATESVILLE_LOCATION_TYPE_NONE;exports.ENTRY_KEY=ENTRY_KEY;exports.ENTRY_PANEL_KEY=ENTRY_PANEL_KEY;exports.ENTRY_TEXT_AREA_KEY=ENTRY_TEXT_AREA_KEY;exports.FAQ_BASE_URL=FAQ_BASE_URL;exports.FLOWER_TYPE_LEGACY=FLOWER_TYPE_LEGACY;exports.FUNERAL_HOME_TYPE=FUNERAL_HOME_TYPE;exports.GUIDELINES_BASE_URL=GUIDELINES_BASE_URL;exports.IFRAME_VIDEO_KEY=IFRAME_VIDEO_KEY;exports.OBIT_TYPE_LEGACY=OBIT_TYPE_LEGACY;exports.OBIT_TYPE_MEMORIAM=OBIT_TYPE_MEMORIAM;exports.OBIT_TYPE_TRIBUTES_UNPAID=OBIT_TYPE_TRIBUTES_UNPAID;exports.OBIT_TYPE_INTERNATIONAL_UNPAID=OBIT_TYPE_INTERNATIONAL_UNPAID;exports.OBIT_TYPE_INTERNATIONAL_PAID=OBIT_TYPE_INTERNATIONAL_PAID;exports.PERSON_PAGE_TYPE=PERSON_PAGE_TYPE;exports.PROMO_ADVICE_AND_SUPPORT=PROMO_ADVICE_AND_SUPPORT;exports.QUESTION_PARAM=QUESTION_PARAM;exports.VIDEO_INPUT=VIDEO_INPUT;exports.MEDIA_TYPES=MEDIA_TYPES;exports.PERSON_SIGNUP_KEY=PERSON_SIGNUP_KEY;exports.SUGGESTED_ENTRY_KEY=SUGGESTED_ENTRY_KEY;exports.GA_SITENAMES=GA_SITENAMES;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(309)('wks');
var uid = __webpack_require__(205);
var Symbol = __webpack_require__(53).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(476);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(1129).version;
elliptic.utils = __webpack_require__(1130);
elliptic.rand = __webpack_require__(522);
elliptic.curve = __webpack_require__(230);
elliptic.curves = __webpack_require__(1135);

// Protocols
elliptic.ec = __webpack_require__(1143);
elliptic.eddsa = __webpack_require__(1147);


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30);
var createDesc = __webpack_require__(100);
module.exports = __webpack_require__(29) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var hide = __webpack_require__(50);
var has = __webpack_require__(49);
var SRC = __webpack_require__(101)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(68).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(17);
var defined = __webpack_require__(70);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.formatNameForUrl=formatNameForUrl;exports.formatExternalLink=formatExternalLink;exports.formatPhoneNumber=formatPhoneNumber;exports.formatPhrase=formatPhrase;exports.formatAddress=formatAddress;exports.formatDate=formatDate;exports.formatTitle=formatTitle;exports.truncateMessage=truncateMessage;exports.getName=getName;exports.simpleFormat=simpleFormat;exports.sanitizeText=sanitizeText;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(97);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CHAR_LIMIT_DEFAULT=500;/**
 * Format name for url
 * Replaces whitespace with hyphens, removes all but letters and hyphens
 * @param {String} name a name on a url
 * @return {String} name formatted for url
 */function formatNameForUrl(name){return(name||'').replace(/\s+/g,'-').replace(/[^A-Za-z-]/g,'').toLowerCase();}/**
 * Format an external url for use in a link
 * prepends with // if no protocol is on the url
 * @param {String} url Input url
 * @return {String} Formatted url
 */function formatExternalLink(url){if(!url){return null;}var lowercaseUrl=url.toLowerCase();if(lowercaseUrl.startsWith('http://')||lowercaseUrl.startsWith('https://')||lowercaseUrl.startsWith('//')){return url;}return'//'+url;}/**
 * Formats a phone number to a 10 digit format.
 * @param  {String} phoneNumber Input number.
 * @return {String} Formatted number as per (XXX) YYY-ZZZZ.
 */function formatPhoneNumber(phoneNumber){var formattedNumber=(phoneNumber||'').replace(/[^A-Z0-9]/g,'');if(!formattedNumber||formattedNumber.length<10||formattedNumber.length>12){return null;}if(formattedNumber.length===11){if(formattedNumber[0]==='1'){formattedNumber=formattedNumber.substr(1);}else{return null;}}return'('+formattedNumber.substr(0,3)+') '+formattedNumber.substr(3,3)+'-'+formattedNumber.substr(6,4);}/**
 * Formats a phrase to capitalize first letters.
 * @param  {String} phrase Input string.
 * @param  {String} wordSeparator The regex to determine how to break out the words
 * @return {String} Formatted string.
 */function formatPhrase(phrase){var wordSeparator=arguments.length>1&&arguments[1]!==undefined?arguments[1]:/[^ ]+/g;var formattedPhrase='';if(phrase){formattedPhrase=_lodash2.default.words(phrase,wordSeparator).map(function(word){var processedWords=word;var hyphenated=_lodash2.default.words(processedWords,/[^-]+/g);if(_lodash2.default.size(hyphenated)>1){processedWords=hyphenated.map(function(hyphenedWord){return _lodash2.default.capitalize(hyphenedWord);}).join('-');}else{processedWords=_lodash2.default.capitalize(processedWords);}return processedWords;}).join(' ');}return formattedPhrase;}/**
 * Formats Addresses
 * @param  {Object} addressObj Address object
 * @return {String} Formats address in 'address, city, state, country' using full display names.
 */function formatAddress(addressObj){var formattedAddress='';if(_lodash2.default.isObject(addressObj)){var address=addressObj.address,address1=addressObj.address1,address2=addressObj.address2,city=addressObj.city,state=addressObj.state,country=addressObj.country;var addressDetails=[address,address1,address2,city,state,country];var serviceAddress=addressDetails.filter(function(section){return section;});formattedAddress=serviceAddress.join(', ');}return formatPhrase(formattedAddress);}/**
 * Configure the condolence's date
 * @param {String} date the unformated date
 * @param {String} prevFormat The previous date format for proper parsing
 * @param {String} nextFormat The format you want outputted by moment
 * @returns {String} Returns a formated date string (e.g. June, 23, 2016)
 */function formatDate(date,prevFormat,nextFormat){var retVal=null;var validNextFormat=_lodash2.default.isString(nextFormat)?nextFormat:null;if(date){retVal=_lodash2.default.isString(prevFormat)?_moment2.default.utc(date,prevFormat).format(validNextFormat):date;}return retVal;}/**
 * Formats the page title
 * @param  {String} firstName The first name
 * @param  {String} lastName The last name
 * @param  {String} city The city
 * @param  {String} state The state
 * @return {String} The formatted title
 */function formatTitle(firstName,lastName,city,state){var displayFirstName=firstName?firstName+' ':'';var displayLastName=lastName?lastName+' ':'';var displayCity=city?''+city+(state?', ':' '):'';var displayState=state?state+' ':'';var divider=city||state?'| ':'';return''+displayFirstName+displayLastName+'Obituary - '+displayCity+displayState+divider+'Legacy.com';}/**
 * Truncate a message
 * @param {String} message the condolence's message
 * @param {Number} length The character limit for the message
 * @param {String} separator character to truncate to
 * @returns {String} Formatted Message
 */function truncateMessage(message){var length=arguments.length>1&&arguments[1]!==undefined?arguments[1]:CHAR_LIMIT_DEFAULT;var separator=arguments.length>2&&arguments[2]!==undefined?arguments[2]:' ';var messageLength=_lodash2.default.get(message,'length');var retMessage='';if(messageLength){retMessage=messageLength>length?_lodash2.default.truncate(message,{length:length,separator:separator}):message;}return retMessage;}/**
 * returns formatted name
 * @param  {Object} nameObj name object from person-service
 * @return {String}         formatted name
 */function getName(nameObj){return _lodash2.default.trim(_lodash2.default.reduce(_lodash2.default.pick(nameObj,['first','last']),function(acc,val){if(!_lodash2.default.isNil(val)){acc.push(val);}return acc;},[]).join(' '));}/**
 * returns a rough equivalent to the simple_format helper used with Rails
 * the purpose of the function is to take text and format with <p> and <br />
 * tags based on the presence of line breaks
 * @param  {Sting}   text string to format
 * @return {String}         formatted string
 */function simpleFormat(text){var formatted=text;if(formatted){formatted=_lodash2.default.trim(formatted);formatted=formatted.replace(/\r\n?/g,'\n');if(formatted.length>0){var formattedWithP=formatted.replace(/\n\n+/g,'</p><p>');if(formattedWithP!==formatted){formatted='<p>'+formattedWithP+'</p>';}formatted=formatted.replace(/\n/g,'<br />');}}return formatted;}/**
 * returns sanitized text and remove all html tags
 * @param  {text} text to be sanitized and remove all html tags
 * @param  {Array} tags list of tags to allow in html
 * @return {String} text without html
 */function sanitizeText(text){var tags=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];if(text){// strip all script and object content first from text
var scriptRegex=/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;var objectRegex=/<object\b[^<]*(?:(?!<\/object)<[^<]*)*<\/object>/gi;// remove attributes of <p> tag
var pTagRegex=/<p\s.*?>/gi;var returnText=text.replace(scriptRegex,'').replace(objectRegex,'').replace(pTagRegex,'<p>');var hasTags=tags.length>0;var tagsRegex="";if(hasTags){var tagsInRegEx=[];tags.forEach(function(tag){tagsInRegEx.push(tag+'|/'+tag);});tagsRegex=new RegExp('<(?!('+tagsInRegEx.join('|')+')(\\s|>)).*?>','gi');}var regex=tags.length>0?tagsRegex:/<[^>]*>/gi;return returnText.replace(regex,'');}return text;}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(146);
var defined = __webpack_require__(70);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(147);
var createDesc = __webpack_require__(100);
var toIObject = __webpack_require__(56);
var toPrimitive = __webpack_require__(69);
var has = __webpack_require__(49);
var IE8_DOM_DEFINE = __webpack_require__(374);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(29) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(49);
var toObject = __webpack_require__(38);
var IE_PROTO = __webpack_require__(249)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(42);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(17);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var core = __webpack_require__(35);
var ctx = __webpack_require__(131);
var hide = __webpack_require__(114);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getQueryObitSourceId=getQueryObitSourceId;exports.getViewObitSource=getViewObitSource;exports.getViewClass=getViewClass;exports.getViewPageType=getViewPageType;exports.isFuneralHomePageType=isFuneralHomePageType;exports.isBatesvillePageType=isBatesvillePageType;exports.isForestLawnPageType=isForestLawnPageType;exports.getPageTypeBackgroundImage=getPageTypeBackgroundImage;exports.getPageTypeFlowersCtaImage=getPageTypeFlowersCtaImage;exports.getPageTypeLayoutKey=getPageTypeLayoutKey;exports.getPageTypeLayoutMap=getPageTypeLayoutMap;exports.getAnalyticPageCategory=getAnalyticPageCategory;exports.useLegacyMenus=useLegacyMenus;exports.tailorMenu=tailorMenu;exports.allowPrintedGuestBookAd=allowPrintedGuestBookAd;exports.useButtonsWithoutDropdown=useButtonsWithoutDropdown;var _includes2=__webpack_require__(1209);var _includes3=_interopRequireDefault(_includes2);var _constants=__webpack_require__(41);var _menuHelpers=__webpack_require__(1214);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var funeralHomePageTypes=[_constants.PERSON_PAGE_TYPE.batesvillePersonPage,_constants.PERSON_PAGE_TYPE.forestLawnPersonPage,_constants.PERSON_PAGE_TYPE.tributesFhPersonPage];/** Get the obit source id required for a valid FH obit request
 * @param   {object} query person page query params
 * @returns {string} returns the obit source id for that view
 */function getQueryObitSourceId(query){switch(query.v){case _constants.FUNERAL_HOME_TYPE.forestlawn:case _constants.FUNERAL_HOME_TYPE.tributes:return query.sid;case _constants.FUNERAL_HOME_TYPE.batesville:return query.pid;default:return 0;}}/** Get the obit source (if not legacy) based on the requested view
 * @param   {string} view person page view
 * @returns {string} returns the obit source string
 */function getViewObitSource(view){if(view===_constants.FUNERAL_HOME_TYPE.forestlawn){return _constants.FUNERAL_HOME_TYPE.tributes;}return view;}/** Get the css class specific to the view
 * @param   {string} view person page view
 * @returns {string} returns the global css class
 */function getViewClass(view){if(view){return view+'View';}return null;}/** Translate the requested view into a Person Page Type key
 * @param   {string} view person page view
 * @returns {string} returns the person page type key
 */function getViewPageType(view){var pageTypes={tributes:_constants.PERSON_PAGE_TYPE.tributesFhPersonPage,forestlawn:_constants.PERSON_PAGE_TYPE.forestLawnPersonPage,batesville:_constants.PERSON_PAGE_TYPE.batesvillePersonPage,default:_constants.PERSON_PAGE_TYPE.personPage};return pageTypes[view]||pageTypes.default;}/** Determine if the given person page type key is for a funeral home person page
 * @param   {string}    pageType person page type key
 * @returns {boolean} returns indicator of person page supporting a funeral home
 */function isFuneralHomePageType(pageType){return(0,_includes3.default)(funeralHomePageTypes,pageType);}/** Determine if the given person page type key is for a Batesville person page
 * @param   {string}    pageType person page type key
 * @returns {boolean} returns indicator of person page being a Batesville type
 */function isBatesvillePageType(pageType){return pageType===_constants.PERSON_PAGE_TYPE.batesvillePersonPage;}/** Determine if the given person page type key is for a Forest Lawn person page
 * @param   {string}    pageType person page type key
 * @returns {boolean} returns indicator of person page being a FL type
 */function isForestLawnPageType(pageType){return pageType===_constants.PERSON_PAGE_TYPE.forestLawnPersonPage;}/** Get the background image for the given person page type key
 * @param   {string}    pageType person page type key
 * @returns {string} returns background image filename
 */function getPageTypeBackgroundImage(pageType){if(isBatesvillePageType(pageType)){return'batesville-hero-2x.jpg';}if(isForestLawnPageType(pageType)){return'forestlawn-hero-2x.jpg';}return'hero-img-2x.jpg';}/** Get the background image for the flowers CTA
 * @param   {string}    pageType person page type key
 * @returns {string} returns background image filename
 */function getPageTypeFlowersCtaImage(pageType){if(isForestLawnPageType(pageType)){return'forestlawn-flowers.png';}return'flowers.png';}/** Get the layout key for the given person page type key
 * @param   {string}    pageType person page type key
 * @param   {string}    timeBasedLayoutType layout type based on time
 * @returns {string} returns 'obit' or 'guestbook' layout indicator
 */function getPageTypeLayoutKey(pageType,timeBasedLayoutType){if(isBatesvillePageType(pageType)){return'guestbook';}return timeBasedLayoutType;}/**
 * Returns layout map based on person page type and layout type
 * @param   {string}  pageType person page type key
 * @param  {string}   layoutKey string representation of layout type
 * @return {object} layout map
 */function getPageTypeLayoutMap(pageType,layoutKey){var layouts=null;switch(pageType){case _constants.PERSON_PAGE_TYPE.forestLawnPersonPage:case _constants.PERSON_PAGE_TYPE.tributesFhPersonPage:layouts={guestbook:{dual:{left:['guestbook'],right:['obituary','gallery','mainService','serviceInfo','resourcesBlock']},single:['obituary','gallery','guestbook','mainService','serviceInfo','resourcesBlock']},obit:{dual:{left:['obituary','guestbook'],right:['mainService','flowers','serviceInfo','resourcesBlock','gallery']},single:['obituary','mainService','serviceInfo','gallery','guestbook','resourcesBlock']}};break;case _constants.PERSON_PAGE_TYPE.batesvillePersonPage:layouts={guestbook:{dual:{left:['guestbook','alerts'],right:['mainService','flowers','obituary','gallery','resourcesBlock']},single:['obituary','gallery','guestbook','alerts','mainService','resourcesBlock']}};break;default:layouts={guestbook:{dual:{left:['guestbook','alerts'],right:['obituary','gallery','resourcesBlock','mainService','serviceInfo']},single:['obituary','gallery','guestbook','mainService','alerts','serviceInfo','resourcesBlock']},obit:{dual:{left:['obituary','guestbook','alerts'],right:['mainService','flowers','serviceInfo','resourcesBlock','gallery']},single:['obituary','mainService','serviceInfo','gallery','guestbook','alerts','resourcesBlock']}};break;}return layouts[layoutKey.toLowerCase()];}/** Get the analyticPageCategory for the given person page type key
 * @param   {string}    pageType person page type key
 * @param   {string}    columnView column view key
 * @returns {string} returns analyticPageCategory for given page type and column view
 */function getAnalyticPageCategory(pageType,columnView){if(isBatesvillePageType(pageType)){return'fh_gb';}if(isFuneralHomePageType(pageType)){return'fh_obit_'+columnView;}return'person_page_'+columnView;}/** Does the person page type use Legacy Menus
 * @param   {string}    pageType person page type key
 * @returns {boolean} returns whether to use Legacy menus
 */function useLegacyMenus(pageType){return!isFuneralHomePageType(pageType)||isBatesvillePageType(pageType);}/** Tailors the menu header per obit/page type
 * @param   {Object}   headerData input header menu
 * @param   {string}   pageType person page type key
 * @param   {boolean}  disableFlowers obit flowers override switch
 * @returns {string} returns updated header menu
 */function tailorMenu(headerData,pageType,disableFlowers){var headerStore=(0,_menuHelpers.overrideMenuOptions)(headerData,'type','flowers',disableFlowers);headerStore=(0,_menuHelpers.overrideMenuOptions)(headerStore,'name','Send Flowers',isBatesvillePageType(pageType));headerStore=(0,_menuHelpers.overrideMenuOptions)(headerStore,'name','Funeral Homes',isBatesvillePageType(pageType));return headerStore;}/** Determines whether printed gb ad is viable for the person page type
 * @param   {string}    pageType person page type key
 * @returns {boolean} returns whether to use Printed GB Ad
 */function allowPrintedGuestBookAd(pageType){return!isForestLawnPageType(pageType);}/** Determines whether to emphasize buttons through a pure button layout
 * @param   {string}    pageType person page type key
 * @returns {boolean} returns whether to emphasize Read Obit CTA
 */function useButtonsWithoutDropdown(pageType){return isBatesvillePageType(pageType);}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(18);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(68);
var fails = __webpack_require__(17);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(61);
var IObject = __webpack_require__(146);
var toObject = __webpack_require__(38);
var toLength = __webpack_require__(31);
var asc = __webpack_require__(266);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(60);
var inherits = __webpack_require__(7);

exports.inherits = inherits;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi)
          res.push(hi, lo);
        else
          res.push(lo);
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(562);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(29)) {
  var LIBRARY = __webpack_require__(102);
  var global = __webpack_require__(14);
  var fails = __webpack_require__(17);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(190);
  var $buffer = __webpack_require__(272);
  var ctx = __webpack_require__(61);
  var anInstance = __webpack_require__(108);
  var propertyDesc = __webpack_require__(100);
  var hide = __webpack_require__(50);
  var redefineAll = __webpack_require__(110);
  var toInteger = __webpack_require__(71);
  var toLength = __webpack_require__(31);
  var toIndex = __webpack_require__(400);
  var toAbsoluteIndex = __webpack_require__(104);
  var toPrimitive = __webpack_require__(69);
  var has = __webpack_require__(49);
  var classof = __webpack_require__(148);
  var isObject = __webpack_require__(18);
  var toObject = __webpack_require__(38);
  var isArrayIter = __webpack_require__(263);
  var create = __webpack_require__(105);
  var getPrototypeOf = __webpack_require__(58);
  var gOPN = __webpack_require__(106).f;
  var getIterFn = __webpack_require__(265);
  var uid = __webpack_require__(101);
  var wks = __webpack_require__(23);
  var createArrayMethod = __webpack_require__(73);
  var createArrayIncludes = __webpack_require__(181);
  var speciesConstructor = __webpack_require__(188);
  var ArrayIterators = __webpack_require__(268);
  var Iterators = __webpack_require__(123);
  var $iterDetect = __webpack_require__(185);
  var setSpecies = __webpack_require__(107);
  var arrayFill = __webpack_require__(267);
  var arrayCopyWithin = __webpack_require__(390);
  var $DP = __webpack_require__(30);
  var $GOPD = __webpack_require__(57);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(395);
var $export = __webpack_require__(1);
var shared = __webpack_require__(180)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(398))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(77);
var IE8_DOM_DEFINE = __webpack_require__(463);
var toPrimitive = __webpack_require__(311);
var dP = Object.defineProperty;

exports.f = __webpack_require__(94) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(101)('meta');
var isObject = __webpack_require__(18);
var has = __webpack_require__(49);
var setDesc = __webpack_require__(30).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(17)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(23)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(50)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(132)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer
var Transform = __webpack_require__(335).Transform
var StringDecoder = __webpack_require__(339).StringDecoder
var inherits = __webpack_require__(7)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.14.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        return Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (utils_hooks__hooks.deprecationHandler != null) {
                utils_hooks__hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (utils_hooks__hooks.deprecationHandler != null) {
            utils_hooks__hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;
    utils_hooks__hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function units_month__handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = create_utc__createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return units_month__handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (typeof value !== 'number') {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function day_of_week__handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = create_utc__createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = create_utc__createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    // treat as if there is no base config
                    deprecateSimple('parentLocaleUndefined',
                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function locale_locales__listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (isDate(input)) {
            config._d = input;
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(matchOffset, this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = stringGet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = stringSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var prototype__proto = Locale.prototype;

    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto.ordinal         = ordinal;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    prototype__proto.weekdaysRegex       =        weekdaysRegex;
    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = lists__get(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = locale_locales__getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return lists__get(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function lists__listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function lists__listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function lists__listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function lists__listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.14.1';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.updateLocale          = updateLocale;
    utils_hooks__hooks.locales               = locale_locales__listLocales;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(125)(module)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Header=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1475);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Header=exports.Header=function(_React$Component){(0,_inherits3.default)(Header,_React$Component);function Header(){(0,_classCallCheck3.default)(this,Header);return(0,_possibleConstructorReturn3.default)(this,(Header.__proto__||(0,_getPrototypeOf2.default)(Header)).apply(this,arguments));}(0,_createClass3.default)(Header,[{key:'render',value:function render(){var _props=this.props,type=_props.type,title=_props.title,children=_props.children;return _react2.default.createElement('header',{className:'header__header '+type+' '+this.props.className},_react2.default.createElement('div',{className:'header__title'},title),_react2.default.createElement('div',{className:'header__childen'},children));}}]);return Header;}(_react2.default.Component);Header.propTypes={title:_react2.default.PropTypes.string.isRequired,children:_react2.default.PropTypes.object,type:_react2.default.PropTypes.string};exports.default=Header;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AdControl = __webpack_require__(589);

Object.defineProperty(exports, 'AdControl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AdControl).default;
  }
});

var _AdController = __webpack_require__(1524);

Object.defineProperty(exports, 'AdController', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AdController).default;
  }
});

var _LocalAdControl = __webpack_require__(599);

Object.defineProperty(exports, 'LocalAdControl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LocalAdControl).default;
  }
});

var _DfpMiddleware = __webpack_require__(1526);

Object.defineProperty(exports, 'DfpMiddleware', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DfpMiddleware).default;
  }
});

var _AdService = __webpack_require__(363);

Object.defineProperty(exports, 'AdService', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AdService).default;
  }
});

var _adRegistration = __webpack_require__(597);

Object.defineProperty(exports, 'adRegistration', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adRegistration).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OzhDQUFRQSxPOzs7Ozs7Ozs7aURBQ0FBLE87Ozs7Ozs7OzttREFDQUEsTzs7Ozs7Ozs7O2tEQUNBQSxPOzs7Ozs7Ozs7OENBQ0FBLE87Ozs7Ozs7OzttREFDQUEsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7ZGVmYXVsdCBhcyBBZENvbnRyb2x9IGZyb20gJy4vQ29tcG9uZW50L0FkQ29udHJvbCc7XG5leHBvcnQge2RlZmF1bHQgYXMgQWRDb250cm9sbGVyfSBmcm9tICcuL0NvbXBvbmVudC9BZENvbnRyb2xsZXInO1xuZXhwb3J0IHtkZWZhdWx0IGFzIExvY2FsQWRDb250cm9sfSBmcm9tICcuL0NvbXBvbmVudC9Mb2NhbEFkQ29udHJvbCc7XG5leHBvcnQge2RlZmF1bHQgYXMgRGZwTWlkZGxld2FyZX0gZnJvbSAnLi9NaWRkbGV3YXJlL2V4cHJlc3MvRGZwTWlkZGxld2FyZSc7XG5leHBvcnQge2RlZmF1bHQgYXMgQWRTZXJ2aWNlfSBmcm9tICcuL1NlcnZpY2VzL0FkU2VydmljZSc7XG5leHBvcnQge2RlZmF1bHQgYXMgYWRSZWdpc3RyYXRpb259IGZyb20gJy4vVGVtcGxhdGVzL2FkUmVnaXN0cmF0aW9uJztcbiJdfQ==

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(376);
var enumBugKeys = __webpack_require__(250);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(71);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(11);
var dPs = __webpack_require__(377);
var enumBugKeys = __webpack_require__(250);
var IE_PROTO = __webpack_require__(249)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(247)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(251).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(376);
var hiddenKeys = __webpack_require__(250).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var dP = __webpack_require__(30);
var DESCRIPTORS = __webpack_require__(29);
var SPECIES = __webpack_require__(23)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(61);
var call = __webpack_require__(388);
var isArrayIter = __webpack_require__(263);
var anObject = __webpack_require__(11);
var toLength = __webpack_require__(31);
var getIterFn = __webpack_require__(265);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(51);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(86);
var createDesc = __webpack_require__(157);
module.exports = __webpack_require__(94) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1008),
    getValue = __webpack_require__(1011);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var processNextTick = __webpack_require__(227);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(166);
util.inherits = __webpack_require__(7);
/*</replacement>*/

var Readable = __webpack_require__(498);
var Writable = __webpack_require__(338);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  processNextTick(cb, err);
};

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1337);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      endLineNumber = undefined,
      column = undefined,
      endColumn = undefined;

  if (loc) {
    line = loc.start.line;
    endLineNumber = loc.end.line;
    column = loc.start.column;
    endColumn = loc.end.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  try {
    if (loc) {
      this.lineNumber = line;
      this.endLineNumber = endLineNumber;

      // Work around issue under safari where we can't directly set the column value
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(this, 'column', {
          value: column,
          enumerable: true
        });
        Object.defineProperty(this, 'endColumn', {
          value: endColumn,
          enumerable: true
        });
      } else {
        this.column = column;
        this.endColumn = endColumn;
      }
    }
  } catch (nop) {
    /* Ignore if the browser is very particular */
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(30).f;
var has = __webpack_require__(49);
var TAG = __webpack_require__(23)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(70);
var fails = __webpack_require__(17);
var spaces = __webpack_require__(253);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(206);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(469);
var defined = __webpack_require__(307);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(474);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

module.exports = isFunction;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(136),
    isLength = __webpack_require__(322);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(9).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(43)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(543),
    baseKeys = __webpack_require__(1213),
    isArrayLike = __webpack_require__(137);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(324);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);__webpack_require__(1307);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Button=function Button(props){var _props$label=props.label,label=_props$label===undefined?'button':_props$label,className=props.className,href=props.href,style=props.style,type=props.type,action=props.action,key=props.key,dataAttr=props.dataAttr,_props$target=props.target,target=_props$target===undefined?'_self':_props$target,rest=(0,_objectWithoutProperties3.default)(props,['label','className','href','style','type','action','key','dataAttr','target']);return _react2.default.createElement('a',(0,_extends3.default)({key:key,'aria-label':label,onClick:action},dataAttr,{style:style,className:className?className+' '+type:type,href:href,target:target},rest),props.children);};Button.propTypes={label:_propTypes2.default.string,type:_propTypes2.default.string,className:_propTypes2.default.string,style:_propTypes2.default.object,key:_propTypes2.default.string,action:_propTypes2.default.func,href:_propTypes2.default.string,dataAttr:_propTypes2.default.object,children:_propTypes2.default.node};exports.default=Button;

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(62);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(62);
var TAG = __webpack_require__(23)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(307);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(968)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(466)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(468);
var enumBugKeys = __webpack_require__(315);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(217);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(479);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

module.exports = isArguments;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(46),
    isObjectLike = __webpack_require__(95);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(7)
var MD5 = __webpack_require__(334)
var RIPEMD160 = __webpack_require__(1083)
var sha = __webpack_require__(1084)
var Base = __webpack_require__(96)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);
var assert = __webpack_require__(60);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(33);

asn1.define = __webpack_require__(1151).define;
asn1.base = __webpack_require__(170);
asn1.constants = __webpack_require__(528);
asn1.decoders = __webpack_require__(1157);
asn1.encoders = __webpack_require__(1159);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(1154).Reporter;
base.DecoderBuffer = __webpack_require__(527).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(527).EncoderBuffer;
base.Node = __webpack_require__(1155);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1247), __esModule: true };

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setCookie=setCookie;exports.getCookie=getCookie;exports.getAspCookieSubValue=getAspCookieSubValue;/** Set a cookie to expire in given days
 * @param   {string}    cname cookie name
 * @param   {string}    cvalue cookie value
 * @param   {number}    exdays expiration in days
 * @returns {Object} undefined
 */function setCookie(cname,cvalue,exdays){var d=new Date();d.setTime(d.getTime()+exdays*24*60*60*1000);var expires='expires='+d.toUTCString();document.cookie=cname+'='+cvalue+';'+expires+';path=/';}/** Get a named cookie from the document cookie jar
 * @param   {string}    cname cookie name
 * @returns {Object} undefined
 */function getCookie(cname){if(typeof document==='undefined'){return;}var name=cname+'=';var ca=document.cookie.split(';');for(var i=0;i<ca.length;i++){var c=ca[i];while(c.charAt(0)===' '){c=c.substring(1);}if(c.indexOf(name)===0){return c.substring(name.length,c.length);}}return'';}/** Get a named cookie subvalue from the given ASP Cookie
 * @param   {string}  cookie  the Legacy Global cookie
 * @param   {string}  segmentName the part of the cookie we are seeking
 * @returns {string} the value of the requested segment of the Global cookie
 */function getAspCookieSubValue(cookie,segmentName){if(cookie){var segments=cookie.split('&').map(function(segment){return segment.trim();});var segmentKey=segmentName+'=';var affiliateIdSegment=segments.find(function(segment){return segment.startsWith(segmentKey);});if(affiliateIdSegment){if(affiliateIdSegment.endsWith('|')){affiliateIdSegment=affiliateIdSegment.slice(0,-1);}return affiliateIdSegment.slice(segmentKey.length);}}return null;}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap"};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1334);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SVGIcon=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _checkmark=__webpack_require__(1445);var _checkmark2=_interopRequireDefault(_checkmark);var _globe=__webpack_require__(1446);var _globe2=_interopRequireDefault(_globe);var _phone=__webpack_require__(1447);var _phone2=_interopRequireDefault(_phone);var _rightArrow=__webpack_require__(1448);var _rightArrow2=_interopRequireDefault(_rightArrow);var _leftArrow=__webpack_require__(1449);var _leftArrow2=_interopRequireDefault(_leftArrow);var _downArrow=__webpack_require__(1450);var _downArrow2=_interopRequireDefault(_downArrow);var _upArrow=__webpack_require__(1451);var _upArrow2=_interopRequireDefault(_upArrow);var _circle=__webpack_require__(1452);var _circle2=_interopRequireDefault(_circle);var _facebook=__webpack_require__(1453);var _facebook2=_interopRequireDefault(_facebook);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SVGIcon=exports.SVGIcon=function(_React$Component){(0,_inherits3.default)(SVGIcon,_React$Component);function SVGIcon(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,SVGIcon);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=SVGIcon.__proto__||(0,_getPrototypeOf2.default)(SVGIcon)).call.apply(_ref,[this].concat(args))),_this),_this.getViewBox=function(name){switch(name){case'facebook':return'0 0 12 12';case'globe':return'0 0 16 16';default:return'0 0 24 24';}},_this.getPath=function(name,fill){switch(name){case'rightArrow':return(0,_rightArrow2.default)(fill);case'leftArrow':return(0,_leftArrow2.default)(fill);case'downArrow':return(0,_downArrow2.default)(fill);case'upArrow':return(0,_upArrow2.default)(fill);case'checkmark':return(0,_checkmark2.default)(fill);case'circle':return(0,_circle2.default)(fill);case'facebook':return(0,_facebook2.default)(fill);case'globe':return(0,_globe2.default)(fill);case'phone':return(0,_phone2.default)(fill);default:return _react2.default.createElement('path',null);}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(SVGIcon,[{key:'render',value:function render(){var _props=this.props,_props$name=_props.name,name=_props$name===undefined?'':_props$name,_props$fill=_props.fill,fill=_props$fill===undefined?'#000':_props$fill,_props$size=_props.size,size=_props$size===undefined?'32px':_props$size,_props$transform=_props.transform,transform=_props$transform===undefined?'':_props$transform,style=_props.style;return _react2.default.createElement('svg',{className:name,height:size,width:size,style:style,transform:transform,xmlns:'http://www.w3.org/2000/svg',viewBox:this.getViewBox(name),xmlnsXlink:'http://www.w3.org/1999/xlink'},this.getPath(name,fill));}}]);return SVGIcon;}(_react2.default.Component);SVGIcon.propTypes={name:_propTypes2.default.string.isRequired,style:_propTypes2.default.object,fill:_propTypes2.default.string,size:_propTypes2.default.string};exports.default=SVGIcon;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=gatewayFetch;var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _api=__webpack_require__(580);var _api2=_interopRequireDefault(_api);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint no-process-env:0 */var conf=(0,_AppConfig2.default)();/**
 * @param  {string}  query  template graphql query
 * @param  {string}  type   'mutation' or 'query'
 * @return {promise} returns a promise of a result of the post to the gateway
 */function gatewayFetch(query,type){var isClient=typeof window!=='undefined'&&window.document;var gateway=isClient?conf.apiGateway:conf.internalApiGateway;var operationName=type==='query'?'LegacyApiQuery':'LegacyApiMutation';var requestPayload={query:query,operationName:operationName,variables:null};return _api2.default.post(gateway,requestPayload,conf.gatewayFetch.post.options,isClient);}

/***/ }),
/* 179 */,
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(56);
var toLength = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(104);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(62);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(18);
var cof = __webpack_require__(62);
var MATCH = __webpack_require__(23)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(23)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(11);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(50);
var redefine = __webpack_require__(51);
var fails = __webpack_require__(17);
var defined = __webpack_require__(70);
var wks = __webpack_require__(23);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(11);
var aFunction = __webpack_require__(42);
var SPECIES = __webpack_require__(23)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(51);
var redefineAll = __webpack_require__(110);
var meta = __webpack_require__(87);
var forOf = __webpack_require__(109);
var anInstance = __webpack_require__(108);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(17);
var $iterDetect = __webpack_require__(185);
var setToStringTag = __webpack_require__(121);
var inheritIfRequired = __webpack_require__(254);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var hide = __webpack_require__(50);
var uid = __webpack_require__(101);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(102) || !__webpack_require__(17)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(14)[K];
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(42);
var ctx = __webpack_require__(61);
var forOf = __webpack_require__(109);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(86).f;
var has = __webpack_require__(113);
var TAG = __webpack_require__(45)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(973);
var global = __webpack_require__(53);
var hide = __webpack_require__(114);
var Iterators = __webpack_require__(133);
var TO_STRING_TAG = __webpack_require__(45)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 210 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

module.exports = isHostObject;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1016),
    listCacheDelete = __webpack_require__(1017),
    listCacheGet = __webpack_require__(1018),
    listCacheHas = __webpack_require__(1019),
    listCacheSet = __webpack_require__(1020);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(161);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1022);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(47);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var isObjectLike = __webpack_require__(95);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(46),
    isSymbol = __webpack_require__(217);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1037), __esModule: true };

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(222),
    isObject = __webpack_require__(54);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

module.exports = baseCreate;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(9).Buffer
var Transform = __webpack_require__(335).Transform
var inherits = __webpack_require__(7)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(9).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer
var MD5 = __webpack_require__(334)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(1131);
curve.short = __webpack_require__(1132);
curve.mont = __webpack_require__(1133);
curve.edwards = __webpack_require__(1134);


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(1150)
var aesid = __webpack_require__(1162)
var fixProc = __webpack_require__(1163)
var ciphers = __webpack_require__(341)
var compat = __webpack_require__(509)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _Button=__webpack_require__(1177);var _Button2=_interopRequireDefault(_Button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Button module
 */var Button=function(_React$Component){(0,_inherits3.default)(Button,_React$Component);/**
   * Button Component Constructor
   * @param  {Object} props Passed in Properties
   * @return {Undefined} Returns nothing
   */function Button(props){(0,_classCallCheck3.default)(this,Button);var _this=(0,_possibleConstructorReturn3.default)(this,(Button.__proto__||(0,_getPrototypeOf2.default)(Button)).call(this,props));_this.handleClick=_this.handleClick.bind(_this);return _this;}/**
   * Constructs the class string for the button
   * @param  {String}  btnType    The type of button
   * @param  {Boolean} isDisabled If the button is disabled
   * @param  {String}  className  The appended classes
   * @return {String} The constructed class string
   */(0,_createClass3.default)(Button,[{key:'getClasses',value:function getClasses(btnType,isDisabled,className){var disabled=isDisabled?' '+_Button2.default.disabled:'';var appended=className?' '+className:'';var btnTypeClass=_Button2.default[btnType]?' '+_Button2.default[btnType]:'';return''+_Button2.default.button+btnTypeClass+disabled+appended;}/**
   * Formats the id if one is present in props
   * @param  {String} id The id string
   * @return {String} The constructed id
   */},{key:'getId',value:function getId(id){return id?id+'_button':null;}/**
   * Handler for when the button is clicked
   * @param  {Object} e The Event object
   * @return {Undefined} Returns nothing
   */},{key:'handleClick',value:function handleClick(e){if(this.props.disabled){e.preventDefault();}else if(_lodash2.default.isFunction(this.props.handleClick)){this.props.handleClick(e);}}/**
   * React Component render
   * @return {JSX} Button rendered
   */},{key:'render',value:function render(){return _react2.default.createElement('button',{'aria-expanded':this.props.ariaExpanded,'aria-haspopup':this.props.ariaHaspopup,'aria-hidden':this.props.ariaHidden,'aria-label':this.props.ariaLabel,'aria-pressed':this.props.ariaPressed,className:this.getClasses(this.props.btnType,this.props.disabled,this.props.className),disabled:this.props.disabled,id:this.getId(this.props.id),onClick:this.handleClick,type:this.props.type},this.props.children);}}]);return Button;}(_react2.default.Component);Button.propTypes={ariaExpanded:_react2.default.PropTypes.string,ariaHaspopup:_react2.default.PropTypes.string,ariaHidden:_react2.default.PropTypes.string,ariaLabel:_react2.default.PropTypes.string,ariaPressed:_react2.default.PropTypes.string,btnType:_react2.default.PropTypes.oneOf(['default','primary','secondary','none']),children:_react2.default.PropTypes.node,className:_react2.default.PropTypes.string,disabled:_react2.default.PropTypes.bool,handleClick:_react2.default.PropTypes.func,id:_react2.default.PropTypes.string,type:_react2.default.PropTypes.oneOf(['button','reset','submit'])};Button.defaultProps={btnType:'default',type:'button'};exports.default=Button;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(213),
    stackClear = __webpack_require__(1216),
    stackDelete = __webpack_require__(1217),
    stackGet = __webpack_require__(1218),
    stackHas = __webpack_require__(1219),
    stackSet = __webpack_require__(1220);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _CTABlock=__webpack_require__(1284);var _CTABlock2=_interopRequireDefault(_CTABlock);var _library=__webpack_require__(40);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Button=_library.FormControls.Button;var CTABlock=function CTABlock(props){var blurb=props.blurb,button=props.button,className=props.className,seo=props.seo,title=props.title,newWindow=props.newWindow;var handleClick=function handleClick(){if(newWindow){if(window){window.open(button.href,'_blank');}}else if(document&&document.location){document.location.href=button.href;}};return _react2.default.createElement('div',{className:(0,_classnames2.default)(_CTABlock2.default.CTABlock,_CTABlock2.default[className])},seo==='h2'?_react2.default.createElement('h2',{className:_CTABlock2.default.Title},title):_react2.default.createElement('div',{className:_CTABlock2.default.Title},title),_react2.default.createElement('div',{className:_CTABlock2.default.Blurb},blurb),button&&_react2.default.createElement(Button,{className:_CTABlock2.default[button.class||'Button'],handleClick:handleClick},button.text));};CTABlock.propTypes={blurb:_react2.default.PropTypes.string,button:_react2.default.PropTypes.object,className:_react2.default.PropTypes.string,seo:_react2.default.PropTypes.string,title:_react2.default.PropTypes.string,newWindow:_react2.default.PropTypes.bool};exports.default=CTABlock;

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(1326);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(560);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(79);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(117);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(1346);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(566);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(59);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  name: 'Default',

  bidHandlerCallback: function bidHandlerCallback(bidHandler) {
    if (bidHandler && typeof bidHandler === 'function') {
      window.googletag.cmd.push(function () {
        bidHandler();
      });
    }
  },

  bidHandlerRefreshCallback: function bidHandlerRefreshCallback(bidHandler, slot) {
    if (bidHandler && typeof bidHandler === 'function') {
      window.googletag.cmd.push(function () {
        bidHandler();
        window.googletag.pubads().refresh(slot);
      });
    }
  },

  refresh: function refresh() {
    return function (adId) {
      if (window.lago) {
        var slot = adId ? [window.lago.getAdSlot(adId)] : null;

        window.googletag.cmd.push(function () {
          window.googletag.pubads().refresh(slot);
        });
      }
    };
  },

  displayAdUnit: function displayAdUnit(adId) {
    window.googletag.cmd.push(function () {
      window.googletag.display(adId);
    });
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LOCATION_SEARCH_TEMPLATE=exports.GALLERY_QUERY_TEMPATE=exports.CONDOLENCES_QUERY_TEMPATE=exports.VIDDLER_AUTH_QUERY=undefined;exports.getNavsAndGDPR=getNavsAndGDPR;exports.getAffiliateQuery=getAffiliateQuery;exports.getPlanningQuery=getPlanningQuery;exports.searchFuneralHomesQuery=searchFuneralHomesQuery;exports.getObituariesFragment=getObituariesFragment;exports.getMoreObituariesQuery=getMoreObituariesQuery;exports.getFhProfileQuery=getFhProfileQuery;exports.getPersonQuery=getPersonQuery;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _personPageType=__webpack_require__(67);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var VIDDLER_AUTH_QUERY=exports.VIDDLER_AUTH_QUERY='query LegacyApiQuery {\n  video {\n    id\n    endpoint\n    token\n  }\n}';var CONDOLENCES_QUERY_TEMPATE=exports.CONDOLENCES_QUERY_TEMPATE=_lodash2.default.template('query LegacyApiQuery {\n  guestBooks(id: <%=sourceId%>, first: <%=count%>, after: "<%=cursor%>") {\n    isFallback\n    condolences {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        endCursor\n      }\n      edges {\n        node {\n          id\n          condolenceId\n          likes\n          name {\n            firstName\n            lastName\n          }\n          message\n          city\n          state {\n            code\n            name\n          }\n          date\n          relationship\n          photo {\n            url\n            width\n            height\n            caption\n          }\n          iconUrl\n          video {\n            id\n          }\n          audioUrl\n        }\n      }\n    }\n  }\n}');var GALLERY_QUERY_TEMPATE=exports.GALLERY_QUERY_TEMPATE=_lodash2.default.template('query LegacyApiQuery {\n  guestBookGallery(id: <%=sourceId%>, first: <%=count%>, after: "<%=cursor%>") {\n    totalCondolencesCount\n    condolences {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        endCursor\n      }\n      edges {\n        node {\n          id\n          condolenceId\n          likes\n          name {\n            firstName\n            lastName\n          }\n          message\n          city\n          state {\n            code\n            name\n          }\n          date\n          relationship\n          photo {\n            url\n            width\n            height\n            caption\n          }\n          iconUrl\n          video {\n            id\n          }\n          audioUrl\n        }\n      }\n    }\n  }\n}');var LOCATION_SEARCH_TEMPLATE=exports.LOCATION_SEARCH_TEMPLATE=_lodash2.default.template('query LegacyApiQuery {\n  locationSearch(location: "<%=location%>", state_id: "<%=stateId%>") {\n    totalResults\n    city {\n      id\n      name\n    }\n    state {\n      id\n      name\n      code\n    }\n  }\n}');/** Returns reusable navs and GDPR query elements
 * @returns {string} returns GraphQL partial query
 */function getNavsAndGDPR(){return'header: menu(type:"header") {\n      menu\n    }\n    footer: menu(type:"footer", siteType: "asr") {\n      menu\n    }\n    subfooter: menu(type:"subfooter", siteType: "asr") {\n      menu\n    }\n    globalSettings {\n      quantcastGDPRScript\n      funeralHomeClientAdGlobalSetting\n    }';}/** Returns GraphQL fragment for acquiring affiliate data
 * @param {string} affiliateIdentifier the affiliate id either as a sitename or an affiliateid
 * @returns {string} returns GraphQL partial query
 */function getAffiliateQuery(affiliateIdentifier){return affiliateIdentifier?'\n    affiliates(sitename:"'+affiliateIdentifier+'") {\n      sourceId\n      corporateId\n      description\n      siteName\n      active\n      affiliateType\n      logoUrl\n      location {\n        state {\n          code\n        }\n        country {\n          code\n        }\n      }\n    }':'';}/** Returns the GraphQL query needed for this planning page
 * @returns {string} returns GraphQL query
 */function getPlanningQuery(){return'query LegacyApiQuery {\n    '+getNavsAndGDPR()+'\n  }';}/** Returns the GraphQL query needed for funeral home search
 * @param   {string} searchBy   postal code or city state search
 * @param   {string} state      state
 * @param   {string} city       city
 * @param   {string} name       funeral home name
 * @param   {string} postalCode postal code
 * @param   {number} radius     radius of search from postalCode
 * @param   {number} count      number to return
 * @param   {string} cursor     node id of last fh returned in previous search
 * @returns {string} returns GraphQL query
 */function searchFuneralHomesQuery(searchBy,state,city,name,postalCode,radius,count,cursor){return'query LegacyApiQuery {\n    '+(cursor?'':getNavsAndGDPR())+'\n    searchFuneralHomes(seachBy:"'+searchBy+'", state:"'+state+'", city:"'+city+'", name:"'+name+'", postalCode:"'+postalCode+'", radius:'+radius+', first:'+count+', after:"'+cursor+'" ) {\n      sourceId\n      name\n      address1\n      address2\n      city\n      state\n      postalCode\n      country\n      phone\n      email\n      websiteName\n      logo\n      directoryUrl\n      premiumSubscriber\n      fax\n      url\n      allowFlorists\n      showFTD\n      spotlightFlowerUrl\n      defaultSpotlightImage\n      latitude\n      longitude\n      }\n    }\n    meta {\n      description\n      location {\n        city\n        state\n        postalCode\n      }\n    }\n  }';}/**
 * @param   {number} funeralHomeId funeral home id
 * @param   {object} parameters options used when fetching obitauries
 * @returns {string} returns GraphQL query
 */function getObituariesFragment(funeralHomeId){var parameters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var affiliateId=parameters.affiliateId||0;var count=parameters.count||10;var offset=parameters.offset||0;return'\n  funeralHomeObituaries(id: '+funeralHomeId+', count: '+count+', offset: '+offset+', affiliateId: '+affiliateId+') {\n    people {\n      personId\n      obituaries {\n        obituaryId\n        obituaryUrl\n        fullName\n        lifespan\n        descriptionHtml\n        imageUrl\n        publishedType\n        publishedStartDate\n        publishedCompleteDate\n        publisherDisplayName\n        ampUrl\n      }\n    }\n  }';}/**
 * @param   {number} funeralHomeId funeral home id
 * @param   {object} parameters options used when fetching obitauries
 * @returns {string} returns GraphQL query ready for a gateway fetch
 */function getMoreObituariesQuery(funeralHomeId,parameters){return'query LegacyApiQuery {\n'+getObituariesFragment(funeralHomeId,parameters)+'\n  }';}/** Returns the GraphQL query needed for the funeral home page
 * @param   {number} fhIndex funeral home id
 * @param   {number} affiliateId associated affiliate id
 * @returns {string} returns GraphQL query
 *
 */function getFhProfileQuery(fhIndex){var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},affiliateId=_ref.affiliateId,obitOffset=_ref.obitOffset;return'query LegacyApiQuery {\n    '+getNavsAndGDPR()+'\n    funeralHomeProfile(id: '+fhIndex+') {\n      funeralHomeId\n      name\n      active\n      isPremium\n      adData {\n        displayOverlayOnMobile\n      }\n      funeralHomeDateStarted\n      funeralHomeLastUpdateDate\n      profileData {\n        phone\n        fax\n        email\n        websiteUrl\n        address1\n        address2\n        displayPrePlanningForm\n        prePlanningFormValue\n        description\n        spotlightFlowerUrl\n        corporateType\n        fhco\n        sciBrandCode\n        customLinkUrl\n        customLinkText\n        suppressRatingsAndReviews\n      }\n      location {\n        city {\n          fullName\n          urlName\n        }\n        state {\n          code\n          fullName\n          urlName\n        }\n        country {\n          code\n          cultureCode\n        }\n        postalCode\n        latitude\n        longitude\n      }\n      images {\n        funeralHomeImageId\n        funeralHomeId\n        fileName\n        imageType\n        displayOrder\n        includeInCarousel\n        url\n      }\n      logoImageUrl\n      primaryImageUrl\n      attributesData {\n        category\n        name\n        value\n      }\n      flowerSettings {\n        cultureCode\n        showFlowerLink\n        nodeDesktopLinkOverrideUrl\n        nodeDesktopPersonLinkOverrideUrl\n        nodeMobileLinkOverrideUrl\n        nodeMobilePersonLinkOverrideUrl\n      }\n    }\n    upcomingServices(id: '+fhIndex+') {\n      people {\n       personId\n       obituaryId\n       fullName\n       flowersUrl\n       obituaryUrl\n\n       services {\n         serviceId\n         isPrivate\n         serviceDate\n         serviceType\n         isAtFuneralHome\n         location {\n           name\n           city\n           address\n           state\n          }\n        }\n      }\n    }\n    nearbyFuneralHomes(id: '+fhIndex+') {\n      funeralHomeId\n      isPremium\n      url\n      name\n      imageUrl\n      starRating\n      city\n      state\n    }'+getAffiliateQuery(affiliateId)+'\n    '+getObituariesFragment(fhIndex,{affiliateId:affiliateId,offset:obitOffset})+'\n  }';}/** Returns the GraphQL query needed for this obit/person page
 * @param   {string}    pageType person page type key
 * @param   {number}    personId person id
 * @param   {string}    source   source for obit id
 * @param   {string}    sourceId the source obit id
 * @param   {number}    count    number of condolences to fetch
 * @param   {string}    cursor   offset id of the condolence node
 * @returns {string} returns GraphQL query
 */function getPersonQuery(pageType,personId,source,sourceId,count,cursor){var legacyMenus=(0,_personPageType.useLegacyMenus)(pageType);var toReturn='query LegacyApiQuery {'+(legacyMenus?'\n  header: menu(type:"header") {\n    menu\n  }\n  footer: menu(type:"footer", siteType: "asr") {\n    menu\n  }\n  subfooter: menu(type:"subfooter", siteType: "asr") {\n    menu\n  }':'')+'\n  globalSettings {\n    quantcastGDPRScript\n  }\n  person(id: "'+personId+'", source: "'+source+'", sourceId: "'+sourceId+'") {\n    id\n    personId\n    sourceId\n    isFallback\n    displayText {\n      showReadMore\n      text\n      fullSanitized\n    }\n    name {\n      first\n      last\n      middle\n      nick\n      maiden\n      prefix\n      suffix\n      full\n      short\n    }\n    portraitImage {\n      attribution\n      href\n      name\n      width\n      height\n    }\n    age\n    byPageLink\n    fromToYears\n    dateOfBirth\n    dateOfDeath\n    obitSources {\n      displayText\n      person\n      location\n    }\n    location {\n      sourceId\n      city\n      state\n      stateCode\n      country\n    }\n    locationDisplay {\n      city\n      state\n      country\n    }\n    church {\n      sourceId\n      name\n      address\n      city\n      state\n      stateCode\n      postalCode\n      country\n      county\n      phone\n      areaCode\n      website\n      image\n    }\n    obituaries {\n      sourceId\n      href\n      affiliateId\n      funeralHomeId\n      dateCreated\n      obituaryText\n      obituaryType\n      gaSitename\n      personMaxDateEntered\n      showReadMore\n    }\n    funeralHomes {\n      sourceId\n      name\n      address1\n      address2\n      city\n      state\n      postalCode\n      country\n      phone\n      email\n      websiteName\n      logo\n      directoryUrl\n      premiumSubscriber\n    }\n    services {\n      personId\n      id\n      serviceType\n      dateTimeDescription\n      dateUTC\n      startTime\n      endTime\n      location\n      address\n      city\n      state\n      country\n      postalCode\n      isAtFuneralHome\n      isAtChurch\n      isTBD\n      isPrivate\n    }\n    affiliates {\n      affiliateType\n      active\n      sourceId\n      legacyId\n      description\n      logo\n    }\n    meta {\n      latestDate\n      description\n      seoCanonicalUrl\n    }\n    flowers {\n      sourceId\n      source\n      link\n      funeralHome {\n        sourceId\n        name\n        address1\n        address2\n        city\n        state\n        postalCode\n        country\n        phone\n        email\n        websiteName\n        logo\n        directoryUrl\n      }\n      church {\n        sourceId\n        name\n        address\n        city\n        state\n        stateCode\n        postalCode\n        country\n        county\n        phone\n        areaCode\n        website\n        image\n      }\n      eventTagDateRecieved {\n        label\n        value\n      }\n      eventTagDateDod {\n        label\n        value\n      }\n    }\n    customDimensions {\n      firstToFile\n      obitDaysActive\n      daysSinceZero\n    }\n    personLayout {\n      heroCTA\n      showReadMore\n      showFlowersAndGifts\n      fhShowFlowers\n      layout {\n        left\n        right\n      }\n      showPGBCTA\n      isNFGB\n    }\n    partnerOtherData\n    guestBook {\n      id\n      allowGuestBook\n      allowGuestBookEntry\n      allowGuestBookPhoto\n      allowPersonPagePosting\n      allowGuestBookVideo\n      guestBookGALabel\n      totalCondolencesCount\n      totalMediaCount\n      isFallback\n      guestBookLink {\n        href\n      }\n      sourceId\n      condolences (first: '+count+', after: "'+cursor+'") {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          node {\n            id\n            condolenceId\n            likes\n            name {\n              firstName\n              lastName\n            }\n            message\n            city\n            state {\n              code\n              name\n            }\n            date\n            relationship\n            photo {\n              url\n              width\n              height\n              caption\n            }\n            iconUrl\n            video {\n              id\n            }\n            audioUrl\n          }\n        }\n      }\n    }\n  }\n}';return toReturn;}

/***/ }),
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LIKES_MUTATION_TEMPLATE=exports.PERSON_UGC_MUTATION_TEMPLATE=exports.PERSON_ALERT_MUTATION_TEMPLATE=exports.CONDOLENCE_MUTATION_TEMPLATE=undefined;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CONDOLENCE_MUTATION_TEMPLATE=exports.CONDOLENCE_MUTATION_TEMPLATE=_lodash2.default.template('mutation LegacyApiMutation {\n  addCondolence(\n    <% _.forEach(filteredSubmission, function(value, key) { %>\n      <% if (_.isString(value)) { %>\n        <%- key %>: "<%- value %>"\n      <% } else { %>\n        <%- key %>: <%- value %>\n      <% } %>\n    <% }); %>\n    pictures: [\n      <% _.forEach(pictures, function(picture) { %>\n        {\n          <% _.forEach(picture, function(value, key) { %>\n            <% if (_.isString(value)) { %>\n              <%- key %>: "<%- value %>"\n            <% } else { %>\n              <%- key %>: <%- value %>\n            <% } %>\n          <% }); %>\n        }\n      <% }); %>\n    ]\n  ) {\n    addCondolenceResponse {\n      entryId\n    }\n  }\n}');var PERSON_ALERT_MUTATION_TEMPLATE=exports.PERSON_ALERT_MUTATION_TEMPLATE=_lodash2.default.template('mutation LegacyApiMutation {\n  addPersonAlert(\n    personId: "<%=personId%>",\n    email: "<%=email%>",\n    gbId: <%=guestBookId%>\n  ) {\n    addAlertResponse {\n      alertId\n    }\n  }\n}');var PERSON_UGC_MUTATION_TEMPLATE=exports.PERSON_UGC_MUTATION_TEMPLATE=_lodash2.default.template('mutation LegacyApiMutation {\n  addCharacteristicAnswer(\n    personId: "<%=personId%>",\n    obituaryId: "<%=obituaryId%>",\n    characteristicCode: "<%=characteristicCode%>",\n    answerType: "<%=answerType%>",\n    answer: "<%=answer%>"\n  ) {\n    addCharacteristicAnswerResponse {\n      answerId\n      characteristicId\n    }\n  }\n}');var LIKES_MUTATION_TEMPLATE=exports.LIKES_MUTATION_TEMPLATE=_lodash2.default.template('mutation LegacyApiMutation {\n  incrementCondolenceLike(\n    condolenceId: "<%=condolenceId%>"\n  ) {\n    incrementCondolenceLikeResponse {\n      condolenceId\n      likes\n    }\n  }\n}');

/***/ }),
/* 246 */,
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var document = __webpack_require__(14).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var core = __webpack_require__(68);
var LIBRARY = __webpack_require__(102);
var wksExt = __webpack_require__(375);
var defineProperty = __webpack_require__(30).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(180)('keys');
var uid = __webpack_require__(101);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(14).document;
module.exports = document && document.documentElement;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(11);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(61)(Function.call, __webpack_require__(57).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var setPrototypeOf = __webpack_require__(252).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(71);
var defined = __webpack_require__(70);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 256 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(71);
var defined = __webpack_require__(70);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(102);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(51);
var hide = __webpack_require__(50);
var has = __webpack_require__(49);
var Iterators = __webpack_require__(123);
var $iterCreate = __webpack_require__(260);
var setToStringTag = __webpack_require__(121);
var getPrototypeOf = __webpack_require__(58);
var ITERATOR = __webpack_require__(23)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(105);
var descriptor = __webpack_require__(100);
var setToStringTag = __webpack_require__(121);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(50)(IteratorPrototype, __webpack_require__(23)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(184);
var defined = __webpack_require__(70);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(23)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(123);
var ITERATOR = __webpack_require__(23)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(30);
var createDesc = __webpack_require__(100);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(148);
var ITERATOR = __webpack_require__(23)('iterator');
var Iterators = __webpack_require__(123);
module.exports = __webpack_require__(68).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(725);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(38);
var toAbsoluteIndex = __webpack_require__(104);
var toLength = __webpack_require__(31);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(88);
var step = __webpack_require__(391);
var Iterators = __webpack_require__(123);
var toIObject = __webpack_require__(56);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(259)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(61);
var invoke = __webpack_require__(381);
var html = __webpack_require__(251);
var cel = __webpack_require__(247);
var global = __webpack_require__(14);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(62)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var macrotask = __webpack_require__(269).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(62)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(42);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(29);
var LIBRARY = __webpack_require__(102);
var $typed = __webpack_require__(190);
var hide = __webpack_require__(50);
var redefineAll = __webpack_require__(110);
var fails = __webpack_require__(17);
var anInstance = __webpack_require__(108);
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(31);
var toIndex = __webpack_require__(400);
var gOPN = __webpack_require__(106).f;
var dP = __webpack_require__(30).f;
var arrayFill = __webpack_require__(267);
var setToStringTag = __webpack_require__(121);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(309)('keys');
var uid = __webpack_require__(205);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93);
var document = __webpack_require__(53).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(93);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 312 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(77);
var dPs = __webpack_require__(970);
var enumBugKeys = __webpack_require__(315);
var IE_PROTO = __webpack_require__(308)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(310)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(470).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(312);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 315 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(45);


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var core = __webpack_require__(35);
var LIBRARY = __webpack_require__(207);
var wksExt = __webpack_require__(316);
var defineProperty = __webpack_require__(86).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 318 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1005),
    mapCacheDelete = __webpack_require__(1021),
    mapCacheGet = __webpack_require__(1023),
    mapCacheHas = __webpack_require__(1024),
    mapCacheSet = __webpack_require__(1025);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1029),
    Map = __webpack_require__(320),
    Promise = __webpack_require__(1030),
    Set = __webpack_require__(1031),
    WeakMap = __webpack_require__(478),
    baseGetTag = __webpack_require__(1032),
    toSource = __webpack_require__(477);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(326),
    createWrap = __webpack_require__(1047),
    getHolder = __webpack_require__(332),
    replaceHolders = __webpack_require__(225);

/** Used to compose bitmasks for function metadata. */
var PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(327);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

module.exports = baseRest;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(222),
    baseLodash = __webpack_require__(330);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1067);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var inherits = __webpack_require__(7)
var HashBase = __webpack_require__(226)

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = new Buffer(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(336).EventEmitter;
var inherits = __webpack_require__(7);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(337);
Stream.Writable = __webpack_require__(1079);
Stream.Duplex = __webpack_require__(1080);
Stream.Transform = __webpack_require__(1081);
Stream.PassThrough = __webpack_require__(1082);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 336 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(498);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(338);
exports.Duplex = __webpack_require__(116);
exports.Transform = __webpack_require__(501);
exports.PassThrough = __webpack_require__(1078);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var processNextTick = __webpack_require__(227);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(166);
util.inherits = __webpack_require__(7);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(1077)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(499);
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(9).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/

var destroyImpl = __webpack_require__(500);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(116);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(116);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = _isUint8Array(chunk) && !state.objectMode;

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    processNextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    processNextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      processNextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43), __webpack_require__(1075).setImmediate, __webpack_require__(24)))

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(9).Buffer;

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return -1;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd'.repeat(p);
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd'.repeat(p + 1);
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd'.repeat(p + 2);
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character for each buffered byte of a (partial)
// character needs to be added to the output.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(1106);
exports.Cipher = __webpack_require__(1107);
exports.DES = __webpack_require__(1108);
exports.CBC = __webpack_require__(1109);
exports.EDE = __webpack_require__(1110);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(1112)
var deciphers = __webpack_require__(1120)
var modes = __webpack_require__(517)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(1113),
  CBC: __webpack_require__(1114),
  CFB: __webpack_require__(1115),
  CFB8: __webpack_require__(1116),
  CFB1: __webpack_require__(1117),
  OFB: __webpack_require__(1118),
  CTR: __webpack_require__(515),
  GCM: __webpack_require__(515)
}

var modes = __webpack_require__(517)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(33);
var randomBytes = __webpack_require__(138);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(78);
hash.common = __webpack_require__(168);
hash.sha = __webpack_require__(1136);
hash.ripemd = __webpack_require__(1140);
hash.hmac = __webpack_require__(1141);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(536),
    baseFlatten = __webpack_require__(1189),
    basePick = __webpack_require__(1191),
    baseRest = __webpack_require__(326),
    toKey = __webpack_require__(162);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = baseRest(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
});

module.exports = pick;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(545);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(547);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1262),
    baseUnary = __webpack_require__(1263),
    nodeUtil = __webpack_require__(1264);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _formik=__webpack_require__(559);var _Button=__webpack_require__(232);var _Button2=_interopRequireDefault(_Button);var _LeadForm=__webpack_require__(1398);var _LeadForm2=_interopRequireDefault(_LeadForm);var _SpinnerIcon=__webpack_require__(539);var _SpinnerIcon2=_interopRequireDefault(_SpinnerIcon);var _FormikTextInput=__webpack_require__(1399);var _FormikTextInput2=_interopRequireDefault(_FormikTextInput);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var cx=_classnames2.default.bind(_LeadForm2.default);var LeadForm=function(_Component){(0,_inherits3.default)(LeadForm,_Component);function LeadForm(){(0,_classCallCheck3.default)(this,LeadForm);return(0,_possibleConstructorReturn3.default)(this,(LeadForm.__proto__||(0,_getPrototypeOf2.default)(LeadForm)).apply(this,arguments));}(0,_createClass3.default)(LeadForm,[{key:'render',value:function render(){var _props=this.props,fields=_props.fields,submitText=_props.submitText,renderSuccess=_props.renderSuccess,onSubmit=_props.onSubmit,initialValues=_props.initialValues,styleMods=_props.styleMods;var classNames={LeadForm:true,EmailOnly:styleMods.emailOnly};return _react2.default.createElement(_formik.Formik,{onSubmit:onSubmit,initialValues:initialValues},function(_ref){var isSubmitting=_ref.isSubmitting,_ref$status=_ref.status,status=_ref$status===undefined?{}:_ref$status,dirty=_ref.dirty,isValid=_ref.isValid;if(status.success){return renderSuccess();}if(status.loading){return _react2.default.createElement('div',{style:{textAlign:'center'}},_react2.default.createElement(_SpinnerIcon2.default,{size:60}));}return _react2.default.createElement(_formik.Form,{className:cx(classNames)},status.error&&_react2.default.createElement('p',{className:_LeadForm2.default.FormError},'Sorry, something went wrong. Please try again later.'),fields.map(function(field){return _react2.default.createElement(_formik.Field,(0,_extends3.default)({key:field.name,component:_FormikTextInput2.default},field));}),_react2.default.createElement(_Button2.default,{type:'submit',disabled:dirty&&!isValid||isSubmitting},isSubmitting?'Submitting ...':submitText));});}}]);return LeadForm;}(_react.Component);LeadForm.propTypes={initialValues:_propTypes2.default.object.isRequired,onSubmit:_propTypes2.default.func.isRequired,submitText:_propTypes2.default.string.isRequired,renderSuccess:_propTypes2.default.func.isRequired,fields:_propTypes2.default.array.isRequired};LeadForm.defaultProps={styleMods:{}};exports.default=LeadForm;

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(79);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(571);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(562);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(204)(module)))

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(574);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(563);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(1377);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(144);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.buildSalesforcePayload=exports.sendToWebcollect=exports.getPlanningAttributes=undefined;var _assign=__webpack_require__(220);var _assign2=_interopRequireDefault(_assign);var _defineProperty2=__webpack_require__(1401);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _api=__webpack_require__(580);var _api2=_interopRequireDefault(_api);var _formatHelpers=__webpack_require__(55);var _ismobilejs=__webpack_require__(583);var _ismobilejs2=_interopRequireDefault(_ismobilejs);var _cookies=__webpack_require__(172);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getPlanningAttributes=exports.getPlanningAttributes=function getPlanningAttributes(){var planningCookie=(0,_cookies.getCookie)('_leg_LG');if(planningCookie){var jsonPlanningCookie=JSON.parse(decodeURIComponent(planningCookie));var cleanedPlanningCookie=jsonPlanningCookie.map(function(attribute){return(0,_defineProperty3.default)({},attribute.name,attribute.a);});var combinedAttributes={};cleanedPlanningCookie.forEach(function(attribute){return(0,_assign2.default)(combinedAttributes,attribute);});return combinedAttributes;}return{};};var sendToWebcollect=exports.sendToWebcollect=function sendToWebcollect(payload){return _api2.default.post('/funeral-homes/sf/webcollect',payload);};var determineDevice=function determineDevice(){if(_ismobilejs2.default.phone){return'Phone';}if(_ismobilejs2.default.tablet){return'Tablet';}return'Desktop';};var buildSalesforcePayload=exports.buildSalesforcePayload=function buildSalesforcePayload(_ref2){var _ref2$form=_ref2.form,form=_ref2$form===undefined?'helpPlanning':_ref2$form,formValues=_ref2.formValues,_ref2$funeralHome=_ref2.funeralHome,funeralHome=_ref2$funeralHome===undefined?{}:_ref2$funeralHome,_ref2$affiliate=_ref2.affiliate,affiliate=_ref2$affiliate===undefined?{}:_ref2$affiliate;var planningAttributes=getPlanningAttributes();var firstName=formValues.firstName,lastName=formValues.lastName,phoneNumber=formValues.phoneNumber,email=formValues.email;var zipCode=formValues.zipCode;var formattedPhoneNumber=(0,_formatHelpers.formatPhoneNumber)(phoneNumber)||phoneNumber;var keys={ContactEmail:email};if(form==='helpPlanning'){keys.FHID=funeralHome.funeralHomeId;}if(!zipCode&&funeralHome&&funeralHome.location){zipCode=funeralHome.location.postalCode;}var values={ContactFirstName:firstName,ContactLastName:lastName,ContactPhoneNumber:formattedPhoneNumber,ContactZip:zipCode||null,FuneralHomeName:funeralHome.name||null,FuneralHomeAddress:funeralHome.profileData?funeralHome.profileData.address1:null,FuneralHomeZip:funeralHome.location?funeralHome.location.postalCode:null,ImmediateNeedOrPreNeed:planningAttributes.q_preneed||null,PlanningFor:planningAttributes.q_who||null,Religion:planningAttributes.q_religion||null,ServiceType:planningAttributes.q_traditional||null,Budget:planningAttributes.q_budget||null,ServicePreferences:planningAttributes.q_body||null,SiteName:affiliate.description||'Legacy',DevicesSource:determineDevice()};if(form==='planningGuide'){values.FHID=funeralHome.funeralHomeId;}return[{keys:keys,values:values}];};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.GUIDE_LINK=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _LeadForm=__webpack_require__(350);var _LeadForm2=_interopRequireDefault(_LeadForm);var _Button=__webpack_require__(143);var _Button2=_interopRequireDefault(_Button);var _PlanningGuideLeadForm=__webpack_require__(1416);var _PlanningGuideLeadForm2=_interopRequireDefault(_PlanningGuideLeadForm);var _salesforceApi=__webpack_require__(360);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var cx=_classnames2.default.bind(_PlanningGuideLeadForm2.default);var GUIDE_LINK=exports.GUIDE_LINK='https://image.alerts.legacy.com/lib/fe3d157075640578751778/m/1/e4547d61-9371-4041-b78d-697954775c8f.pdf';var phoneRegExp=/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;var PlanningGuideLeadForm=function(_Component){(0,_inherits3.default)(PlanningGuideLeadForm,_Component);function PlanningGuideLeadForm(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,PlanningGuideLeadForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=PlanningGuideLeadForm.__proto__||(0,_getPrototypeOf2.default)(PlanningGuideLeadForm)).call.apply(_ref,[this].concat(args))),_this),_this.initialValues={firstName:'',lastName:'',email:'',phoneNumber:'',zipCode:_this.props.planning.funeralHomeZipcode},_this.fields=[{name:'firstName',title:'First Name',required:true},{name:'lastName',title:'Last Name',required:true},{name:'email',type:'email',title:'Email',required:true},{name:'zipCode',type:'tel',title:'Zip Code',required:true},{name:'phoneNumber',type:'tel',title:'Phone'}],_this.getFields=function(){var visibleFields=_this.props.visibleFields;return _this.fields.filter(function(field){return visibleFields.includes(field.name);});},_this.handleFormSubmit=function(formValues,formik){var funeralHome=_this.props.funeralHome;var _this$props=_this.props,affiliate=_this$props.affiliate,_this$props$webcollec=_this$props.webcollectKey,webcollectKey=_this$props$webcollec===undefined?'WebCollectFHD_standard':_this$props$webcollec,planning=_this$props.planning;if(!funeralHome&&planning.funeralHomeZipcode){funeralHome={location:{postalCode:planning.funeralHomeZipcode}};}formik.setStatus({loading:true,error:false});var body=(0,_salesforceApi.buildSalesforcePayload)({form:'planningGuide',formValues:formValues,funeralHome:funeralHome,affiliate:affiliate});(0,_salesforceApi.sendToWebcollect)({body:body,externalKey:webcollectKey}).then(function(json){var success=json.success,_json$error=json.error,error=_json$error===undefined?undefined:_json$error;// eslint-disable-line no-undefined
formik.setSubmitting(false);formik.setStatus({loading:false,success:success,error:error});}).catch(function(){formik.setSubmitting(false);formik.setStatus({loading:false,error:true,success:false});});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(PlanningGuideLeadForm,[{key:'render',value:function render(){var theme=this.props.theme;var classes={PlanningGuideLeadForm:true,Light:theme==='light',Dark:theme==='dark'};return _react2.default.createElement('div',{className:cx(classes)},_react2.default.createElement(_LeadForm2.default,{initialValues:this.initialValues,onSubmit:this.handleFormSubmit,submitText:'Download the Guide',fields:this.getFields(),theme:'dark',renderSuccess:function renderSuccess(){return _react2.default.createElement('div',null,_react2.default.createElement('p',{className:_PlanningGuideLeadForm2.default.SuccessMessage},'Success! Thank you.'),_react2.default.createElement(_Button2.default,{href:GUIDE_LINK,type:'large-button',className:_PlanningGuideLeadForm2.default.SuccessButton,target:'_blank',download:'Your Guide to Planning Ahead'},'Download Your Guide'));}}),_react2.default.createElement('p',null,'By submitting this form you agree to our',' ',_react2.default.createElement('a',{target:'_blank',href:'https://www.legacy.com/about/terms-of-use'},'Terms of Use.')));}}]);return PlanningGuideLeadForm;}(_react.Component);/* istanbul ignore next */PlanningGuideLeadForm.propTypes={visibleFields:_propTypes2.default.arrayOf(_propTypes2.default.string),theme:_propTypes2.default.oneOf(['light','dark'])};PlanningGuideLeadForm.defaultProps={visibleFields:['firstName','lastName','email'],theme:'light'};var mapStateToProps=function mapStateToProps(state){return{planning:state.planningStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(PlanningGuideLeadForm);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ShareIcons=ShareIcons;exports.HandleShareClick=HandleShareClick;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _Svgs=__webpack_require__(36);var _GAHelpers=__webpack_require__(22);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Share icon info
 * @param {string} canonical canonical url
 * @param {string} title     share title
 * @return {Array} array of share icon info
 */function ShareIcons(canonical,title){var encodedCanonical=encodeURIComponent(canonical);var encodedTitle=encodeURIComponent(title);return[{label:'facebook',shareUrl:'https://www.facebook.com/share.php?u='+encodedCanonical+'&title='+encodedTitle,svg:_react2.default.createElement(_Svgs.FbShareIcon,null)},{label:'twitter',shareUrl:'https://twitter.com/intent/tweet?text='+encodedTitle+'&url='+encodedCanonical,svg:_react2.default.createElement(_Svgs.TwitterShareIcon,null)},{label:'email',shareUrl:'mailto:?body=This obituary I found on Legacy.com may interest you: '+encodedCanonical,svg:_react2.default.createElement(_Svgs.EmailShareIcon,null)}];}/**
 * Handle clicking of share icons
 * @param  {Object} e The Event Object
 * @param  {String} url The share url
 * @param  {String} type The share type
 * @param  {Boolean} track Indication of whether or not to fire a GA event
 * @return {Undefined} Returns nothing
 */function HandleShareClick(e,url,type){var track=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;e.preventDefault();if(type==='email'){window.location.replace(url,'_blank');}else{window.open(url,_lodash2.default.upperFirst(type.replace('_',' '))+' Share','status = 1, height = 500, width = 500, resizable = 0');}if(track){(0,_GAHelpers.getGATags)({eventCategory:'Person_Page_Social_Buttons',eventAction:'click',eventLabel:type});}}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(8);

var _lodash2 = _interopRequireDefault(_lodash);

var _handlebars = __webpack_require__(1496);

var _handlebars2 = _interopRequireDefault(_handlebars);

__webpack_require__(1512);

var _CriteoExtension = __webpack_require__(1513);

var _CriteoExtension2 = _interopRequireDefault(_CriteoExtension);

var _DefaultExtension = __webpack_require__(594);

var _DefaultExtension2 = _interopRequireDefault(_DefaultExtension);

var _IndexExchangeExtension = __webpack_require__(1514);

var _IndexExchangeExtension2 = _interopRequireDefault(_IndexExchangeExtension);

var _RubiconExtension = __webpack_require__(1515);

var _RubiconExtension2 = _interopRequireDefault(_RubiconExtension);

var _QuantcastExtension = __webpack_require__(1516);

var _QuantcastExtension2 = _interopRequireDefault(_QuantcastExtension);

var _A9Extension = __webpack_require__(595);

var _A9Extension2 = _interopRequireDefault(_A9Extension);

var _InstartLogicExtension = __webpack_require__(1517);

var _InstartLogicExtension2 = _interopRequireDefault(_InstartLogicExtension);

var _AdLightningExtension = __webpack_require__(1518);

var _AdLightningExtension2 = _interopRequireDefault(_AdLightningExtension);

var _PrebidExtension = __webpack_require__(1519);

var _PrebidExtension2 = _interopRequireDefault(_PrebidExtension);

var _adRegistration = __webpack_require__(597);

var _adRegistration2 = _interopRequireDefault(_adRegistration);

var _endPageRegistration = __webpack_require__(1520);

var _endPageRegistration2 = _interopRequireDefault(_endPageRegistration);

var _DefaultExtension_beta = __webpack_require__(242);

var _DefaultExtension_beta2 = _interopRequireDefault(_DefaultExtension_beta);

var _IndexExchangeExtension_beta = __webpack_require__(1521);

var _IndexExchangeExtension_beta2 = _interopRequireDefault(_IndexExchangeExtension_beta);

var _A9Extension_beta = __webpack_require__(596);

var _A9Extension_beta2 = _interopRequireDefault(_A9Extension_beta);

var _PartnerA9Extension = __webpack_require__(1522);

var _PartnerA9Extension2 = _interopRequireDefault(_PartnerA9Extension);

var _AdmiralExtension = __webpack_require__(1523);

var _AdmiralExtension2 = _interopRequireDefault(_AdmiralExtension);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * extensionExists - Checks if a given extension is already present
 *
 * @param  {array} currentExtensions - Extensions already pushed
 * @param  {string} extensionName - Extension to search
 * @return {object} the extension if it is already present or null
 */
function extensionExists(currentExtensions, extensionName) {
  var existingExtension = _lodash2.default.find(currentExtensions, function (ext) {
    return ext.name === extensionName;
  });

  return existingExtension;
}

/**
 * AdService class.
 * Registers Ad placements and manages state for ads for a given page request.
 * This class is exported as a singleton.
 * @class AdService
 */

var AdService = function () {
  function AdService() {
    _classCallCheck(this, AdService);
  }

  _createClass(AdService, [{
    key: 'initialize',


    /**
     * initialize - Initializes for class with default data.  This should be called
     * for each request only 1x.
     *
     * @param  {object} adConfig - Advertising settings configuration
     * @return {void}
     */
    value: function initialize(adConfig) {

      /**
      * A variable for the config in the scope of this class
      * @type {object} Object confuration variables
      */
      this.config = adConfig;

      /**
      * A variable for the advertising data in the context of a single request
      * @type {object} Object of ad data
      */
      this.ads = {
        adPlacements: [],
        pageKeyValues: [],
        responsiveSizeMaps: this.config.responsiveSizeMaps,
        PreDfpScripts: [],
        PreAdSlotScripts: [],
        AdBlockingScripts: [],
        PageTargetScripts: [],
        EnableServicesScripts: [],
        PostRegistrationScripts: []
      };

      /**
      * A variable for the advertising data to be appended at the end of the page
      * in the context of a single request
      * @type {object} Object of ad data
      */
      this.endPage = {
        EndPageScripts: []
      };

      /**
      * An array of advertising extensions
      * @type {array} Array of ad extensions
      */
      this.extensions = this.loadExtensions(this.config);
    }

    /**
     * function for refreshing ad units that will refresh based on ad extension
     * implementations
     * @param  {String} adId Ad unit id to refresh.
     * @returns {funciton} reference to refresh function to be called at a later time.
     */

  }, {
    key: 'refreshAd',
    value: function refreshAd(adId) {
      return Reflect.apply(_lodash2.default.chain(this.extensions).map(function (ext) {
        return ext.refresh();
      }).compact().head().value(), this, [adId]);
    }

    /**
     * displayAdUnit - Evaluate all extensions such as header bidding and loadAd
     * for a given adUnit
     *
     * @param  {String} adId Ad unit id to load a given ad unit
     * @param  {Boolean} postPageLoad ad being displayed after initial page rendering
     * @return {void}
     */

  }, {
    key: 'displayAdUnit',
    value: function displayAdUnit(adId, postPageLoad) {
      if (!(adId && this.extensions)) {
        return;
      }

      var topExtension = this.extensions.find(function (ext) {
        return _lodash2.default.isFunction(ext.displayAdUnit);
      });

      if (topExtension) {
        topExtension.displayAdUnit(adId, postPageLoad);
      }
    }

    /**
     * registerAdPlacement - Registers a single ad placement to be defined in the header.
     *
     * @param  {String} containerId Friendly ad name for placement
     * @param  {String} pageName    Name to identify page for given ad request
     * @param  {String} adSize      Array of accepted sizes ex. [[w,h], [w,h]]
     * @param  {String} mappingName Key of size mapping defined within config
     * @param  {Array} slotKeyValues     Array of key/values to be registered to a given ad slot
     * @param  {String} slotName    Name to identify slot for given ad request
     * @param  {String} slotType define what type of slot should be registered (slot, outofpageslot)
     * @returns {void}
     */

  }, {
    key: 'registerAdPlacement',
    value: function registerAdPlacement(containerId, pageName, adSize, mappingName, slotKeyValues, slotName, slotType, usePartnerAdNetwork) {

      var definedSlotname = slotName || containerId;
      var slotKvs = slotKeyValues || [];
      var isOutOfPageSlot = _lodash2.default.isString(slotType) && slotType.toLowerCase() === 'outofpageslot';
      var isPartnerAd = usePartnerAdNetwork;

      if (!this.arrayKeyExists('containerId', slotKvs)) {
        slotKvs.push({ 'key': 'containerId', 'value': definedSlotname });
      }

      var networkId = this.config.networkId;
      var siteName = this.config.siteName;

      if (usePartnerAdNetwork) {
        for (var i = 0; i < slotKvs.length; i++) {
          if (slotKvs[i].key === 'cobrand' && slotKvs[i].value === 'qctimes') {
            networkId = '8438';
            siteName = slotKvs[i].value;
          }
          slotKvs[i].value = JSON.stringify(slotKvs[i].value);
        }
      }

      var placement = {
        containerId: definedSlotname,
        adSizes: JSON.stringify(adSize),
        adAlias: this.buildAlias(networkId, this.config.environment, siteName, pageName, containerId),
        mappingName: mappingName,
        slotKeyValues: slotKvs,
        isOutOfPageSlot: isOutOfPageSlot,
        isPartnerAd: usePartnerAdNetwork
      };

      if (!this.ads.adPlacements.find(function (ad) {
        return ad.containerId === placement.containerId;
      })) {
        this.ads.adPlacements.push(placement);
      }
    }

    /**
     * registerAdSlot - Registers a single ad to be rendered after the page has loaded
     *
     * @param  {String} containerId Friendly ad name for placement
     * @param  {String} pageName    Name to identify page for given ad request
     * @param  {String} adSize      Array of accepted sizes ex. [[w,h], [w,h]]
     * @param  {String} mappingName Key of size mapping defined within config
     * @param  {Array} slotKeyValues     Array of key/values to be registered to a given ad slot
     * @param  {String} slotName   Name to identify slot for given ad request
     * @param  {String} slotType define what type of slot should be registered (slot, outofpageslot)
     * @return {void}
     */

  }, {
    key: 'renderAdSlot',
    value: function renderAdSlot(containerId, pageName, adSize, mappingName, slotKeyValues, slotName, slotType, usePartnerAdNetwork) {
      var _this = this;

      var definedSlotname = slotName || containerId;

      if (window && window.lago) {
        window.googletag.cmd.push(function () {
          var networkId = _this.config.networkId;
          var siteName = _this.config.siteName;
          var slotKvs = slotKeyValues || [];

          if (usePartnerAdNetwork) {
            for (var i = 0; i < slotKvs.length; i++) {
              if (slotKvs[i].key === 'cobrand' && slotKvs[i].value === 'qctimes') {
                networkId = '8438';
                siteName = slotKvs[i].value;
              }
            }
          }

          var adAlias = _this.buildAlias(networkId, _this.config.environment, siteName, pageName, containerId);

          var slot = {};

          if (slotType && slotType.toLowerCase() === 'outofpageslot') {
            slot = window.googletag.defineOutOfPageSlot(adAlias, definedSlotname);
          } else {
            slot = window.googletag.defineSlot(adAlias, adSize, definedSlotname).setCollapseEmptyDiv(true);
          }

          if (mappingName) {
            slot.defineSizeMapping(window.lago.mappings[mappingName]);
          }

          if (!_this.arrayKeyExists('containerId', slotKeyValues)) {
            slotKvs.push({ 'key': 'containerId', 'value': definedSlotname });
          }

          _lodash2.default.each(slotKvs, function (kv) {
            if (_typeof(kv.value) === 'object' || kv.value.indexOf('[') !== -1) {
              slot.setTargeting(kv.key, kv.value);
            } else {
              slot.setTargeting(kv.key, escape('' + kv.value));
            }
          });

          slot.addService(window.googletag.pubads());
          window.lago.appendAdSlot(definedSlotname, slot);

          _this.displayAdUnit(definedSlotname, true);
        });
      }
    }

    /**
     * addPageKeyValue - Adds a page level Key/Variable pair as long as the key doesnt already exist.
     *
     * @param  {type} key   Key Name for page level variable
     * @param  {type} value Value to be defined for page level variable
     * @return {void}
     */

  }, {
    key: 'addPageKeyValue',
    value: function addPageKeyValue(key, value) {
      if (!this.arrayKeyExists(key, this.ads.pageKeyValues)) {
        this.ads.pageKeyValues.push({ key: key, value: value });
      }
    }

    /**
     * arrayKeyExists - description
     *
     * @param  {String} key   Key name to check if exists in array
     * @param  {Array} array  Array to check if a given key value already exits
     * @return {Boolean}         Boolean value if a given key already exists in an array.
     */

  }, {
    key: 'arrayKeyExists',
    value: function arrayKeyExists(key, array) {
      var result = _lodash2.default.find(array, function (kv) {
        return kv.key.toLowerCase() === key.toLowerCase();
      });

      return typeof result !== 'undefined';
    }

    /**
     * renderAdScript - Renders ad script with current advertising placements registered
     *
     * @return {string}  Ad registration script used within header.
     */

  }, {
    key: 'renderAdScript',
    value: function renderAdScript() {
      var templateFile = _adRegistration2.default;
      var template = _handlebars2.default.compile(templateFile);

      return template(this.getAdData());
    }

    /**
     * renderEndPageScript - Renders ad script with current advertising placements registered
     *
     * @return {string}  Ad registration script used within header.
     */

  }, {
    key: 'renderEndPageScript',
    value: function renderEndPageScript() {
      var templateFile = _endPageRegistration2.default;
      var template = _handlebars2.default.compile(templateFile);

      return template(this.getEndPageData());
    }
  }, {
    key: 'runPageUpdateScripts',
    value: function runPageUpdateScripts() {
      var method = 'pageUpdateScript';
      var handlers = this.extensions.filter(function (extension) {
        return Reflect.has(extension, method);
      });

      handlers.forEach(function (handler) {
        return handler[method]();
      });
    }

    /**
     * buildAlias - Builds advertising Alias to be used in slot definition
     *
     * @param  {String} networkId       DFP networkId
     * @param  {String} environmentName Name of current environment eg. (Prod, QA, Dev)
     * @param  {String} siteName        Name of current site eg. (obit-aff)
     * @param  {String} pageName        Name of current Page eg. (browse, obit)
     * @param  {String} position        Friendly ad Name of a given position eg. (display-right-1)
     * @return {String}                 Formatted string of advertising alias
     */

  }, {
    key: 'buildAlias',
    value: function buildAlias(networkId, environmentName, siteName, pageName, position) {
      if (pageName === 'lifestyles') {
        return '/8438/qctimes.com/lifestyles/announcements/obituaries';
      }
      return '/' + networkId + '/' + environmentName + '/' + siteName + '/' + pageName + '/' + position;
    }

    /**
     * getAdData - Returns reference to current adverting data
     *
     * @return {Object}  Advertising object.
     */

  }, {
    key: 'getAdData',
    value: function getAdData() {
      var adSlots = _lodash2.default.cloneDeep(this.ads.adPlacements);

      this.ads.PreDfpScripts = this.buildAdExtensionScript(this.extensions, 'preDfpScript', adSlots);
      this.ads.AdBlockingScripts = this.buildAdExtensionScript(this.extensions, 'adBlockingScript', adSlots);
      this.ads.PostRegistrationScripts = this.buildAdExtensionScript(this.extensions, 'postRegistrationScript', adSlots);
      this.ads.PreAdSlotScripts = this.buildAdExtensionScript(this.extensions, 'preAdSlotScript', adSlots);
      this.ads.PageTargetScripts = this.buildAdExtensionScript(this.extensions, 'pageTargetsScript', adSlots);
      this.ads.EnableServicesScripts = this.buildAdExtensionScript(this.extensions, 'enableServicesScript', adSlots);
      this.ads.lagoExtensionScripts = this.buildAdExtensionScript(this.extensions, 'lagoExtensionScript', adSlots);

      return this.ads;
    }

    /**
    * getEndPageData - Returns reference to current adverting data
    *
    * @return {Object}  Advertising object.
    */

  }, {
    key: 'getEndPageData',
    value: function getEndPageData() {
      this.endPage.EndPageScripts = this.buildAdExtensionScript(this.extensions, 'endPageScript');
      return this.endPage;
    }

    /**
     * buildAdExtensionScript - Iterate thru extensions and call provided function
     *
     * @param  {array} extensions to iterate for script output
     * @param  {string} functionName to invoke on extension
     * @param  {array} placements - ad placements to be passed into extension functions used in script generation
     * @return {array} array of string values to be added to final output script
     */

  }, {
    key: 'buildAdExtensionScript',
    value: function buildAdExtensionScript(extensions, functionName, placements, env) {
      return _lodash2.default.reduce(extensions, function (result, extension) {
        if (typeof extension[functionName] === 'function') {
          result.push(extension[functionName].call(null, placements, env));
        }
        return result;
      }, []);
    }

    /**
     * loadExtensions - Loads Ad Extensions based on list provided in configuration
     *
     * @param  {object} config Advertising configuration
     * @return {array} array of advertising Extensions
     */

  }, {
    key: 'loadExtensions',
    value: function loadExtensions(config) {
      var extensions = [];
      var existingExtension = null;

      if (config.AdExtensions) {
        _lodash2.default.forEach(config.AdExtensions, function (extension) {
          switch (extension) {
            case 'CriteoExtension':
              extensions.push(_CriteoExtension2.default);
              break;
            case 'IndexExchangeExtension':
              existingExtension = _lodash2.default.find(extensions, function (ext) {
                return ext.name === _PrebidExtension2.default.name;
              });
              if (!existingExtension) {
                extensions.push(_IndexExchangeExtension2.default);
              }
              break;
            case 'RubiconExtension':
              extensions.push(_RubiconExtension2.default);
              break;
            case 'QuantcastExtension':
              extensions.push(_QuantcastExtension2.default);
              break;
            case 'A9Extension':
              extensions.push(_A9Extension2.default);
              break;
            case 'InstartLogicExtension':
              extensions.push(_InstartLogicExtension2.default);
              break;
            case 'IndexExchangeExtension_beta':
              if (!extensionExists(extensions, _PrebidExtension2.default.name)) {
                extensions.push(_IndexExchangeExtension_beta2.default);
              }
              break;
            case 'A9Extension_beta':
              extensions.push(_A9Extension_beta2.default);
              break;
            case 'PartnerA9Extension':
              extensions.push(_PartnerA9Extension2.default);
              break;
            case 'BlockthroughExtension':
              if (!extensionExists(extensions, _AdmiralExtension2.default.name)) {
                // AdmiralExtension will re-use current Blockthrough configuration
                extensions.push(_AdmiralExtension2.default);
              }
              break;
            case 'AdLightningExtension':
              extensions.push(_AdLightningExtension2.default);
              break;
            case 'PrebidExtension':
              _lodash2.default.remove(extensions, function (ext) {
                return ext.name === _IndexExchangeExtension2.default.name || ext.name === _IndexExchangeExtension_beta2.default.name;
              });
              extensions.push(_PrebidExtension2.default);
              break;
            case 'DefaultExtension_beta':
              extensions.push(_DefaultExtension_beta2.default);
              break;
            case 'AdmiralExtension':
              if (!extensionExists(extensions, _AdmiralExtension2.default.name)) {
                extensions.push(_AdmiralExtension2.default);
              }
              break;
            default:
              break;
          }
        });
      }

      extensions.push(_DefaultExtension2.default);
      return extensions;
    }

    /**
     * setExtensions - Sets the Ad Extensions based on list provided in configuration
     *
     * @param  {object} config Advertising configuration
     * @return {array} the array of advertising Extensions
     */

  }, {
    key: 'setExtensions',
    value: function setExtensions(config) {
      var extensions = this.loadExtensions(config);

      this.extensions = extensions;
      return extensions;
    }

    /**
     * addExtension - Add extension to modify ad framework functionality
     *
     * @param  {object} extension object following the framework methods for a given extension.
     * @return {void}
     */

  }, {
    key: 'addExtension',
    value: function addExtension(extension) {
      if (extension) {
        this.extensions.push(extension);
      }
    }
  }]);

  return AdService;
}();

exports.default = AdService;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(365);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _stringify=__webpack_require__(171);var _stringify2=_interopRequireDefault(_stringify);exports.getRefValue=getRefValue;exports.getProfileDescription=getProfileDescription;exports.getProfileOgTitle=getProfileOgTitle;exports.getPersonOgTitle=getPersonOgTitle;exports.getCanonicalUrl=getCanonicalUrl;exports.buildDirectoryPath=buildDirectoryPath;exports.buildMetaTagObject=buildMetaTagObject;exports.buildMetaTags=buildMetaTags;exports.getDataLayer=getDataLayer;exports.getGlobalAdVars=getGlobalAdVars;exports.getProfileGlobalAdVars=getProfileGlobalAdVars;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _formatHelpers=__webpack_require__(55);var _personPageType=__webpack_require__(67);var _urlHelpers=__webpack_require__(28);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _constants=__webpack_require__(41);var _JsonLd=__webpack_require__(1536);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conf=(0,_AppConfig2.default)();/**
 * Gets the ref key for the global ad variables.
 * Originally implemented as part of EL-749 (https://legacycom.atlassian.net/browse/EL-749)
 * The majority of the logic is copied from getReferrerDomain method of the Legacy_Omaha repo.
 * https://bitbucket.org/legacycom/legacy_omaha/src/540956c5670cc9f7d694f95af314123c6c0203fb/Legacy.Omaha.WebUI/AdControls/OmahaAdControlDfp.cs#lines-171:187
 *
 * @param {string} referer request header referer
 * @return {string} ref string
 *//* eslint no-console: 0 *//* eslint no-warning-comments: 0 */function getRefValue(){var referer=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';if(!referer){return'none';}if(referer.includes('legacy.com')){if(referer.includes('/search')||referer.includes('obituary-search.aspx')){return'Legacy-Search';}if(referer.includes('/funeral-homes/')){return'Legacy-FHDirectory';}return'Legacy';}if(referer.includes('google.com')){return'google';}return'NonLegacy';}/**
 * Constructs the meta description for profile page
 * @method getProfileDescription
 * @param  {object} funeralHome   the funeral home object
 * @return {string} returns the fully formed meta description
 */function getProfileDescription(funeralHome){return'View upcoming funeral services, obituaries, and funeral flowers for '+funeralHome.name+' in '+funeralHome.location.city.fullName+', '+funeralHome.location.state.code+'. Find contact information, view maps, and more.';}/**
 * Constructs the og:title for the profile open graph usage
 * @method getProfileOgTitle
 * @param  {object} funeralHome   the funeral home object
 * @return {string} returns the fully open graph title
 */function getProfileOgTitle(funeralHome){return funeralHome.name+' - Planning, Obituaries, Services | Legacy.com';}/**
 * Constructs the og:title for facebook
 * @method getPersonOgTitle
 * @param  {object} name        name object
 * @return {string} returns the fully formed canonical url
 */function getPersonOgTitle(name){var _ref=name||{},first=_ref.first,last=_ref.last;var formattedName=_lodash2.default.trim(_lodash2.default.compact([first,last]).join(' '));if(formattedName.length===0){return'View Obituary and express your condolences';}return'View '+formattedName+'\'s Obituary and express your condolences';}/**
 * Constructs the canonical url eliminating unwanted query parameters
 * @method getCanonicalUrl
 * @param  {string}        vanity        vanity url
 * @param  {string}        originalUri   request uri
 * @return {string}        returns the fully formed canonical url
 */function getCanonicalUrl(vanity,originalUri){var original=originalUri.replace(/[?&]page=[0-9]+/,'').replace(/[?&]testWebcast=[^&]+/,'').replace(/[?&]view=[a-zA-z]+/,'').replace(/funeral-homes\/planning.*/,'funeral-homes/planning/home');return''+vanity+original;}/**
 * Constructs the canonical url for fh profile page.
 * If required data is missing, returns null
 * @method buildDirectoryPath
 * @param  {object}        funeralHome   funeral home object
 * @return {string}        returns the fully formed canonical url
 */function buildDirectoryPath(funeralHome){var _ref2=funeralHome||{},funeralHomeId=_ref2.funeralHomeId,_ref2$name=_ref2.name,name=_ref2$name===undefined?'':_ref2$name,_ref2$location=_ref2.location,location=_ref2$location===undefined?{}:_ref2$location;var _location$city=location.city,city=_location$city===undefined?{}:_location$city,_location$state=location.state,state=_location$state===undefined?{}:_location$state;var dashedFhName=(0,_formatHelpers.formatNameForUrl)(name);if(state.urlName&&city.urlName&&dashedFhName&&funeralHomeId){return'/funeral-homes/'+state.urlName+'/'+city.urlName+'/'+dashedFhName+'/fh-'+funeralHomeId;}return null;}/**
 * constructs basic page meta tags
 * @method buildMetaTagObject
 * @param  {string}        title   title
 * @param  {string}        ogTitle   ogTitle
 * @param  {string}        description   description
 * @param  {string}        imageUrl   imageUrl
 * @param  {string}        seoUrl   seoUrl
 * @param  {string}        canonicalUrl   canonicalUrl
 * @param  {string}        latestDate   latestDate
 * @param  {string}        publishDate   publishDate
 * @return {string}        returns the fully formed canonical url
 */function buildMetaTagObject(title,ogTitle,description,imageUrl,seoUrl,canonicalUrl,latestDate,publishDate){var metaTagObject={title:title,description:description,image_src:imageUrl,canonical:seoUrl,generator:'ReactJS','og:type':'article','og:url':canonicalUrl,'og:title':ogTitle,'og:description':description,'og:image':imageUrl,'og:site_name':'Legacy.com','og:updated_time':latestDate,'twitter:card':'summary','twitter:url':canonicalUrl,'twitter:site':'@LegacyObits','twitter:title':title,'twitter:description':description,'twitter:image':imageUrl,'dcterms.creator':'admin','dcterms.language':'en','dcterms.format':'text/html','dcterms.type':'Text','dcterms.title':title,'dcterms.description':description,'dcterms.identifier':canonicalUrl,'dcterms.date':publishDate,'article:modified_time':latestDate,'article:published_time':publishDate};metaTagObject.pageSchemaTags={title:title,description:description,image:imageUrl};return metaTagObject;}/**
 * builds schema tags for SEO
 * @param  {Object} tags - tags
 * @return {String} Compiled template strings.
 */function buildPageSchemaTags(tags){return _lodash2.default.map(tags,function(value,name){var content=value;content=(0,_formatHelpers.sanitizeText)(content);var template=_lodash2.default.template('<meta itemprop="<%= name %>" content="<%= content %>">');return template({name:name,content:content});}).join('\n');}/**
 * Semmantic wrapper for opengraph check
 * @param  {String}  key Meta tag name.
 * @return {Boolean} True if key starts with 'og:'.
 */function isOpenGraph(key){return _lodash2.default.startsWith(key,'og:');}/**
 * Build a JSON-LD tag
 * @param  {Object} dataObject JSON Object to input.
 * @return {String} A JSON-LD tag.
 */function buildJsonLdTag(dataObject){return'<script type="application/ld+json">'+(0,_stringify2.default)(dataObject)+'</script>';}/**
 * format meta object
 * @param  {Object} person person
 * @param  {String} canonicalUrl canonical url (usually current url)
 * @return {object} meta object
 */function formatObitMetaObject(person,canonicalUrl){var obitId=_lodash2.default.head(_lodash2.default.get(person,'obitSources.person'));var obit=_lodash2.default.find(_lodash2.default.get(person,'obituaries',[]),['sourceId',obitId]);var obitText=_lodash2.default.get(person,'displayText.text','');var imageUri=_lodash2.default.get(person,'portraitImage.href',null);if(obitText){var MAX_META_DESC_CHARS=165;obitText=_lodash2.default.truncate((0,_formatHelpers.sanitizeText)(obitText),{length:MAX_META_DESC_CHARS,separator:' '});}var seoUrl=_lodash2.default.get(person,'meta.seoCanonicalUrl')||canonicalUrl;var title=(0,_formatHelpers.formatTitle)(_lodash2.default.get(person,'name.first'),_lodash2.default.get(person,'name.last'),_lodash2.default.get(person,'location.city'),_lodash2.default.get(person,'location.state'));var ogTitle=getPersonOgTitle(_lodash2.default.get(person,'name'));var description=_lodash2.default.get(person,'meta.description')||obitText;var imageUrl=imageUri?(0,_urlHelpers.buildUrl)(conf.environmentalUrl.cacheUrl,imageUri)+'x?w=200&h=200&option=3&fc=fff':conf.vanityDomain+'/funeral-homes/obituaries/name/assets/share_candle.jpg';var publishDate=_lodash2.default.get(obit,'dateCreated','');var latestDate=_lodash2.default.get(person,'meta.latestDate',publishDate);var metaTagObject=buildMetaTagObject(title,ogTitle,description,imageUrl,seoUrl,canonicalUrl,latestDate,publishDate);if(!_lodash2.default.isEmpty(person)){var mainObitSitename=_lodash2.default.get(person,'obituaries[0].gaSitename','');var personPageType=_lodash2.default.get(person,'personLayout.personPageType');var isAggregatedOrFHObit=_lodash2.default.includes(['batesville',_constants.GA_SITENAMES.tributes,_constants.GA_SITENAMES.dignityMemorial],mainObitSitename.toLowerCase());var isAggregatedOrFHPageType=_lodash2.default.includes([_constants.PERSON_PAGE_TYPE.batesvillePersonPage,_constants.PERSON_PAGE_TYPE.forestLawnPersonPage,_constants.PERSON_PAGE_TYPE.tributesFhPersonPage],personPageType);var obitDaysActive=_lodash2.default.get(person,'customDimensions.obitDaysActive',null);if(obitDaysActive<30&&(isAggregatedOrFHObit||isAggregatedOrFHPageType)){metaTagObject.newsArticle=(0,_JsonLd.addNewsArticleSchema)(person);}metaTagObject.person=(0,_JsonLd.addPersonSchema)(person);var eventsSchema=(0,_JsonLd.addPersonEventsSchema)(person);var paidObitsItemListSchema=(0,_JsonLd.addItemListSchema)(person);if(eventsSchema.length>0){metaTagObject.personEvents=eventsSchema;}if(!_lodash2.default.isEmpty(paidObitsItemListSchema)){metaTagObject.paidObitsItemList=paidObitsItemListSchema;}}return metaTagObject;}/**
 * format meta object
 * @param  {Object} funeralHome funeralHome
 * @param  {Object} upcomingServices fh services
 * @param  {String} canonicalUrl canonical url (usually current url)
 * @return {object} meta object
 */function formatProfileMetaObject(funeralHome,upcomingServices,canonicalUrl){var title=funeralHome.name+' - '+funeralHome.location.city.fullName+' - '+funeralHome.location.state.code+' | Legacy.com';var ogTitle=getProfileOgTitle(funeralHome);var description=_lodash2.default.get(funeralHome,'meta.description')||getProfileDescription(funeralHome);var imageUrl=funeralHome.logoImageUrl;var seoUrl=(0,_urlHelpers.buildUrl)(conf.vanityDomain,buildDirectoryPath(funeralHome))||canonicalUrl;var latestDate=funeralHome.modifiedTime;var publishDate=funeralHome.funeralHomeDateStarted;var metaTagObject=buildMetaTagObject(title,ogTitle,description,imageUrl,seoUrl,canonicalUrl,latestDate,publishDate);if(!_lodash2.default.isEmpty(funeralHome)){var funeralHomeAndEventSchema=(0,_JsonLd.addFuneralHomeAndEventSchema)(funeralHome,upcomingServices);metaTagObject.funeralHome=funeralHomeAndEventSchema.funeralHome;metaTagObject.funeralHomeEvents=funeralHomeAndEventSchema.events;}return metaTagObject;}/**
 * format meta object
 * @param  {String} planningType planningType
 * @param  {String} canonicalUrl canonical url (usually current url)
 * @return {object} meta object
 */function formatPlanningMetaObject(planningType,canonicalUrl){var isGeneral=Boolean(planningType==='general');var title='Funeral Planning '+(isGeneral?'Guide | Legacy.com':'- Make Funeral Arrangements at Legacy.com');var description=isGeneral?'Get Answers About Planning Ahead. Download your free funeral planning guide & checklist':'Compare funeral planning providers and read our expert advice, free guides, forms and advanced planning tools that are convenient and easy to use.';var imageUrl=conf.vanityDomain+'/funeral-homes/obituaries/name/assets/planning.png';var date='2018-06-27T12:00:00.000Z';var metaTagObject=buildMetaTagObject(title,title,description,imageUrl,canonicalUrl,canonicalUrl,date,date);return metaTagObject;}/**
 * format meta object
 * @param  {Object} search search
 * @return {object} meta object
 */function formatSearchMetaObject(search){var title=search.meta.location.city+' Funeral Homes - Funeral Homes in '+search.meta.location.city+' | Legacy.com';// TODO for radius search, should this be title = `${search.meta.location.city} Funeral Homes - Funeral Homes in ${search.meta.location.city}, ${search.meta.location.state} for ${search.meta.location.postalCode} | Legacy.com`;
// TODO description should come from service as something like (verify with Brian Free and .NET code)
// `${search.meta.location.city} funeral homes on Legacy.com. Read recent obituaries, find service information, &amp; send flowers. Powered by Legacy.com`;
// `${search.meta.location.city}, ${search.meta.location.state} funeral homes on Legacy.com. Read recent obituaries, find service information, &amp; send flowers. Powered by Legacy.com`;
var description=_lodash2.default.get(search,'meta.description','');var metaTagObject={title:title,description:description,robots:'noindex,nofollow'};return metaTagObject;}/**
 * Updates metadata params to inclunde injected tockens if found
 * @param  {string} requestType page type requested
 * @param  {string} robotsMeta  index follow info
 * @param  {object} person      person
 * @param  {object} funeralHome  funeral home
 * @param  {object} upcomingServices  upcoming fh services
 * @param  {object} search    search
 * @param  {string} originalUrl req.originalUrl
 * @return {object}             meta object
 */function getMetaDataObject(requestType,robotsMeta,person,funeralHome,upcomingServices,search,// NOTE: this origionalUrl doens't include the host name
originalUrl){var canonicalUrl=getCanonicalUrl(conf.vanityDomain,originalUrl);var metaObject={title:'',description:'',robots:'noindex, nofollow'};if(requestType==='obit'){metaObject=formatObitMetaObject(person,canonicalUrl);metaObject.robots=robotsMeta;}else if(requestType==='profile'){metaObject=formatProfileMetaObject(funeralHome,upcomingServices,originalUrl);metaObject.robots=robotsMeta;}else if(requestType==='planning'){metaObject=formatPlanningMetaObject(null,canonicalUrl);metaObject.robots=robotsMeta;}else if(requestType==='generalPlanning'){metaObject=formatPlanningMetaObject('general',canonicalUrl);metaObject.robots=robotsMeta;}else if(requestType==='search'){metaObject=formatSearchMetaObject(search);}return metaObject;}/**
 * Takes metaData object and pushes rendered tags to metaTags array
 * @param  {string} requestType page type requested
 * @param  {string} robotsMeta  index follow info
 * @param  {object} person      person
 * @param  {object} funeralHome  funeral home
 * @param  {object} upcomingServices  upcoming fh events
 * @param  {object} search  search
 * @param  {string} reqOrigionalUrl req.originalUrl
 * @return {Array} Contains rendered meta tags
 */function buildMetaTags(requestType,robotsMeta,person,funeralHome,upcomingServices,search,reqOrigionalUrl){var metaData=getMetaDataObject(requestType,robotsMeta,person,funeralHome,upcomingServices,search,reqOrigionalUrl);var metaTags=[];_lodash2.default.forEach(metaData,function(value,key){if(key==='pageSchemaTags'){metaTags.push(buildPageSchemaTags(value));}else if(key==='newsArticle'){metaTags.push('<script data-schema="NewsArticle" type="application/ld+json">'+(0,_stringify2.default)(value)+'</script>');}else if(_lodash2.default.includes(['person','paidObitsItemList','funeralHome'],key)&&!_lodash2.default.isEmpty(value)){metaTags.push(buildJsonLdTag(value));}else if(_lodash2.default.includes(['personEvents','funeralHomeEvents'],key)){value.map(function(index){metaTags.push(buildJsonLdTag(index));});}else if(key==='title'){metaTags.push('<title>'+value+'</title>');}else if(_lodash2.default.isString(value)){if(_lodash2.default.includes(['image_src','canonical'],key)&&!isOpenGraph(key)// validUrl.isWebUri(value), we check it's a good url, but since we sometimes pass down only the path we can't
){metaTags.push('<link rel="'+key+'" href="'+value+'">');}else if(isOpenGraph(key)){metaTags.push('<meta property="'+key+'" content="'+value+'">');}else{metaTags.push('<meta name="'+key+'" content="'+value+'">');}}});return metaTags.join('\n');}/**
 * @param  {Object}        person       person Object
 * @param  {Object}        guestBook    guestBook Object
 * @param  {number|string} fhco         primary funeralHome affiliate
 * @param  {number}        fhid         primary funeral home id
 * @param  {number}        pid          person id
 * @param  {string}        requestView  requested view
 * @param  {string}        personPageType type of person page
 * @return {Object}        data layer object
 */function getDataLayer(person,guestBook,fhco,fhid,pid,requestView,personPageType){var dataLayer={};var isFuneralHomePage=(0,_personPageType.isFuneralHomePageType)(personPageType);/* Custom Dimensions */if(person.customDimensions){// obit days active - custom dimension #12
dataLayer.obitDaysActive=person.customDimensions.obitDaysActive;// page category - custom dimension #14
var columnView=person.customDimensions.obitDaysActive>6?'gb_view':'obit_view';dataLayer.analyticPageCategory=(0,_personPageType.getAnalyticPageCategory)(personPageType,columnView);// first to file - custom dimension #24
dataLayer.firstToFile=person.customDimensions.firstToFile;// days since zero - custom dimension #25
if(person.customDimensions.daysSinceZero===null){dataLayer.daysSinceZero='null';}else{dataLayer.daysSinceZero=person.customDimensions.daysSinceZero;}}else{// page category - fall back for custom dimension #14
dataLayer.analyticPageCategory=(0,_personPageType.getAnalyticPageCategory)(personPageType,'obit_view');}// pid
dataLayer.pid=pid;// page name - custom dimension #19
dataLayer.pageName='person';// product name - custom dimension #20
dataLayer.productName='obit-fhd';// person page view - custom dimension #28
if(isFuneralHomePage){dataLayer.personPageView=requestView;dataLayer.fhId=fhid;}// funeral home id - custom dimension #27
dataLayer.FHCo=fhco;// guest book ID if guestbook is active - custom dimension #23
if(guestBook.allowGuestBook){dataLayer.gbid=guestBook.sourceId;}return dataLayer;}/**
 * Gets the global advertising variables
 * @param   {object}  adConfig   global ad configuration data
 * @param   {object}  personData a subset of the person data
 * @param   {string}  referrer Referrer header value
 * @returns {object}  global variable object
 */function getGlobalAdVars(adConfig,personData,referrer){var _ref3=personData||{},affiliates=_ref3.affiliates,flowers=_ref3.flowers,guestBook=_ref3.guestBook,obituaries=_ref3.obituaries,personId=_ref3.personId,name=_ref3.name;var _ref4=name||{},first=_ref4.first,last=_ref4.last;var fhid=_lodash2.default.get(flowers,'funeralHome.sourceId');var ref=getRefValue(referrer);var fhAffiliates=_lodash2.default.reduce(obituaries,function(acc,obit){if(obit.funeralHomeId===fhid){var fhAffiliate=_lodash2.default.find(affiliates,['sourceId',obit.affiliateId]);if(_lodash2.default.get(fhAffiliate,'affiliateType')==='Funeral Home Publisher'){acc.push(fhAffiliate.sourceId);}}return acc;},[]);return _lodash2.default.merge.apply(_lodash2.default,[{},{pid:personId,gbentries:_lodash2.default.get(guestBook,'totalCondolencesCount')||'0',fn:first,ln:last,FHCo:_lodash2.default.head(fhAffiliates)||'0',fhid:fhid||'0',ref:ref}].concat((0,_toConsumableArray3.default)(adConfig)));}/**
 * Gets the global advertising variables
 * @param   {object}  fhProfileData the gateway fh profile data
 * @param   {object}  affiliateData the gateway affiliate data
 * @param   {string}  referer the referrer header string
 * @returns {object}  global variable object
 *
 * TODO need to define the values for
 * searchstate and ref
 * e.g., globalAdVars.searchstate = ?;
 * e.g., globalAdVars.ref = ?; defaults to 'Legacy?'
 */function getProfileGlobalAdVars(fhProfileData,affiliateData,referer){var _ref5=fhProfileData||{},funeralHomeId=_ref5.funeralHomeId,_ref5$location=_ref5.location,location=_ref5$location===undefined?{}:_ref5$location,_ref5$profileData=_ref5.profileData,profileData=_ref5$profileData===undefined?{}:_ref5$profileData;var _location$city2=location.city,city=_location$city2===undefined?{}:_location$city2,_location$state2=location.state,state=_location$state2===undefined?{}:_location$state2,postalCode=location.postalCode;var cityName=city.fullName;var stateCode=state.code;var _ref6=affiliateData||{},_ref6$location=_ref6.location,affiliateLocation=_ref6$location===undefined?{}:_ref6$location,siteName=_ref6.siteName,corporateId=_ref6.corporateId;var _affiliateLocation$st=affiliateLocation.state,affState=_affiliateLocation$st===undefined?{}:_affiliateLocation$st,_affiliateLocation$co=affiliateLocation.country,affCountry=_affiliateLocation$co===undefined?{}:_affiliateLocation$co;var affStateName=affState.code;var affCountryCode=affCountry.code;var ref=getRefValue(referer);return _lodash2.default.merge({},{category:'funeral-home-detail',cobrand:siteName||'Legacy',corp:corporateId||'0',affstate:affStateName||'0',country:affCountryCode||'0',fhid:funeralHomeId||'0',fhcity:cityName,fhstate:stateCode,fhzip:postalCode,FHCo:profileData.fhco,v:2,ref:ref});}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1532);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(367);
var ITERATOR = __webpack_require__(45)('iterator');
var Iterators = __webpack_require__(133);
module.exports = __webpack_require__(35).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(160);
var TAG = __webpack_require__(45)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/**
 * Checks to see if window smaller than breakpoint
 * @param {number} breakPoint for component to check
 * @returns {Boolean} returns true if the image has a height or width, otherwise return false
 */var breakPointChecker=function breakPointChecker(){var breakPoint=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1024;if(typeof window!=='undefined'){return window.matchMedia('(max-width: '+breakPoint+'px)').matches;}return false;};exports.breakPointChecker=breakPointChecker;

/***/ }),
/* 369 */,
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1609), __esModule: true };

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(206);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.easeInOut=easeInOut;exports.scrollToTop=scrollToTop;/**
 * Easing function
 * @param  {Number} currentTime Current time
 * @param  {Number} start       Start position
 * @param  {Number} change      Position difference
 * @param  {Number} duration    Tween time
 * @return {Number}             Next step of position change
 */function easeInOut(currentTime,start,change,duration){var _currTime=currentTime;_currTime/=duration/2;if(_currTime<1){return change/2*_currTime*_currTime+start;}_currTime-=1;return-change/2*(_currTime*(_currTime-2)-1)+start;}/**
 * Method for smooth scrolling page
 * @param  {Object} element    DOM Elemenet to target
 * @param  {Number} to         Target position
 * @param  {Number} duration   Time of tween
 * @param  {Function} callback Function to be called after animation
 * @return {Undefined} Returns nothing
 */function scrollToTop(element,to,duration,callback){var start=element.scrollTop,change=to-start,increment=20;var animateScroll=function animateScroll(elapsedTime){var elapsed=elapsedTime+increment;var position=easeInOut(elapsed,start,change,duration);element.scrollTop=position;if(elapsed<duration){setTimeout(function(){animateScroll(elapsed);},increment);}else if(callback){return callback();}};animateScroll(0);}

/***/ }),
/* 373 */,
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(29) && !__webpack_require__(17)(function () {
  return Object.defineProperty(__webpack_require__(247)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(23);


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(49);
var toIObject = __webpack_require__(56);
var arrayIndexOf = __webpack_require__(181)(false);
var IE_PROTO = __webpack_require__(249)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30);
var anObject = __webpack_require__(11);
var getKeys = __webpack_require__(103);

module.exports = __webpack_require__(29) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(56);
var gOPN = __webpack_require__(106).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(103);
var gOPS = __webpack_require__(182);
var pIE = __webpack_require__(147);
var toObject = __webpack_require__(38);
var IObject = __webpack_require__(146);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(17)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(42);
var isObject = __webpack_require__(18);
var invoke = __webpack_require__(381);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 381 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(14).parseInt;
var $trim = __webpack_require__(122).trim;
var ws = __webpack_require__(253);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(14).parseFloat;
var $trim = __webpack_require__(122).trim;

module.exports = 1 / $parseFloat(__webpack_require__(253) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(62);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(18);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 386 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(256);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(11);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(42);
var toObject = __webpack_require__(38);
var IObject = __webpack_require__(146);
var toLength = __webpack_require__(31);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(38);
var toAbsoluteIndex = __webpack_require__(104);
var toLength = __webpack_require__(31);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(29) && /./g.flags != 'g') __webpack_require__(30).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(186)
});


/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var isObject = __webpack_require__(18);
var newPromiseCapability = __webpack_require__(271);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(396);
var validate = __webpack_require__(124);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(189)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(30).f;
var create = __webpack_require__(105);
var redefineAll = __webpack_require__(110);
var ctx = __webpack_require__(61);
var anInstance = __webpack_require__(108);
var forOf = __webpack_require__(109);
var $iterDefine = __webpack_require__(259);
var step = __webpack_require__(391);
var setSpecies = __webpack_require__(107);
var DESCRIPTORS = __webpack_require__(29);
var fastKey = __webpack_require__(87).fastKey;
var validate = __webpack_require__(124);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(396);
var validate = __webpack_require__(124);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(189)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(73)(0);
var redefine = __webpack_require__(51);
var meta = __webpack_require__(87);
var assign = __webpack_require__(379);
var weak = __webpack_require__(399);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(17);
var validate = __webpack_require__(124);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(189)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(110);
var getWeak = __webpack_require__(87).getWeak;
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(18);
var anInstance = __webpack_require__(108);
var forOf = __webpack_require__(109);
var createArrayMethod = __webpack_require__(73);
var $has = __webpack_require__(49);
var validate = __webpack_require__(124);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(31);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(106);
var gOPS = __webpack_require__(182);
var anObject = __webpack_require__(11);
var Reflect = __webpack_require__(14).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(183);
var isObject = __webpack_require__(18);
var toLength = __webpack_require__(31);
var ctx = __webpack_require__(61);
var IS_CONCAT_SPREADABLE = __webpack_require__(23)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(31);
var repeat = __webpack_require__(255);
var defined = __webpack_require__(70);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(103);
var toIObject = __webpack_require__(56);
var isEnum = __webpack_require__(147).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(148);
var from = __webpack_require__(406);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(109);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(113);
var toObject = __webpack_require__(156);
var IE_PROTO = __webpack_require__(308)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(66);
var core = __webpack_require__(35);
var fails = __webpack_require__(132);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(94) && !__webpack_require__(132)(function () {
  return Object.defineProperty(__webpack_require__(310)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(964), __esModule: true };

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(966);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(976);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(207);
var $export = __webpack_require__(66);
var redefine = __webpack_require__(467);
var hide = __webpack_require__(114);
var has = __webpack_require__(113);
var Iterators = __webpack_require__(133);
var $iterCreate = __webpack_require__(969);
var setToStringTag = __webpack_require__(208);
var getPrototypeOf = __webpack_require__(461);
var ITERATOR = __webpack_require__(45)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(114);


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(113);
var toIObject = __webpack_require__(134);
var arrayIndexOf = __webpack_require__(971)(false);
var IE_PROTO = __webpack_require__(308)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(160);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(53).document;
module.exports = document && document.documentElement;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(468);
var hiddenKeys = __webpack_require__(315).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(210);
var createDesc = __webpack_require__(157);
var toIObject = __webpack_require__(134);
var toPrimitive = __webpack_require__(311);
var has = __webpack_require__(113);
var IE8_DOM_DEFINE = __webpack_require__(463);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(94) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 473 */
/***/ (function(module, exports) {



/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(475),
    isKey = __webpack_require__(218),
    toKey = __webpack_require__(162);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(46),
    stringToPath = __webpack_require__(1003);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

module.exports = castPath;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 477 */
/***/ (function(module, exports) {

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(137),
    isObjectLike = __webpack_require__(95);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(47),
    stubFalse = __webpack_require__(1033);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(125)(module)))

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(323);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(328),
    metaMap = __webpack_require__(484);

/**
 * The base implementation of `setData` without support for hot loop detection.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(478);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(486),
    composeArgsRight = __webpack_require__(487),
    countHolders = __webpack_require__(1050),
    createCtor = __webpack_require__(221),
    createRecurry = __webpack_require__(488),
    getHolder = __webpack_require__(332),
    reorder = __webpack_require__(1064),
    replaceHolders = __webpack_require__(225),
    root = __webpack_require__(47);

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    ARY_FLAG = 128,
    FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & ARY_FLAG,
      isBind = bitmask & BIND_FLAG,
      isBindKey = bitmask & BIND_KEY_FLAG,
      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
      isFlip = bitmask & FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(1051),
    setData = __webpack_require__(491),
    setWrapToString = __webpack_require__(493);

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

  if (!(bitmask & CURRY_BOUND_FLAG)) {
    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(484),
    noop = __webpack_require__(1052);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(222),
    baseLodash = __webpack_require__(330);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(483),
    now = __webpack_require__(492);

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 150,
    HOT_SPAN = 16;

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = (function() {
  var count = 0,
      lastCalled = 0;

  return function(key, value) {
    var stamp = now(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return key;
      }
    } else {
      count = 0;
    }
    return baseSetData(key, value);
  };
}());

module.exports = setData;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(47);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1057),
    defineProperty = __webpack_require__(1058),
    getWrapDetails = __webpack_require__(1059),
    identity = __webpack_require__(328),
    insertWrapDetails = __webpack_require__(1060),
    updateWrapDetails = __webpack_require__(1061);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
  var source = (reference + '');
  return defineProperty(wrapper, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
  });
};

module.exports = setWrapToString;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(495),
    baseIsNaN = __webpack_require__(1063);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOf;


/***/ }),
/* 495 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(136),
    isObject = __webpack_require__(54),
    isSymbol = __webpack_require__(217);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = isFunction(value.valueOf) ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 497 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var processNextTick = __webpack_require__(227);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(497);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(336).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(499);
/*</replacement>*/

// TODO(bmeurer): Change this back to const once hole checks are
// properly optimized away early in Ignition+TurboFan.
/*<replacement>*/
var Buffer = __webpack_require__(9).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(166);
util.inherits = __webpack_require__(7);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1073);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(1074);
var destroyImpl = __webpack_require__(500);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') {
    return emitter.prependListener(event, fn);
  } else {
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
  }
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(116);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(339).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(116);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(339).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(43)))

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(336).EventEmitter;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var processNextTick = __webpack_require__(227);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      processNextTick(emitErrorNT, this, err);
    }
    return;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      processNextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(116);

/*<replacement>*/
var util = __webpack_require__(166);
util.inherits = __webpack_require__(7);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return stream.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er, data) {
      done(stream, er, data);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data !== null && data !== undefined) stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(139)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(139)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(7)
var Legacy = __webpack_require__(1089)
var Base = __webpack_require__(96)
var Buffer = __webpack_require__(9).Buffer
var md5 = __webpack_require__(505)
var RIPEMD160 = __webpack_require__(1090)

var sha = __webpack_require__(1091)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(334)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(140)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(140)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = {
	"sha224WithRSAEncryption": {
		"sign": "rsa",
		"hash": "sha224",
		"id": "302d300d06096086480165030402040500041c"
	},
	"RSA-SHA224": {
		"sign": "ecdsa/rsa",
		"hash": "sha224",
		"id": "302d300d06096086480165030402040500041c"
	},
	"sha256WithRSAEncryption": {
		"sign": "rsa",
		"hash": "sha256",
		"id": "3031300d060960864801650304020105000420"
	},
	"RSA-SHA256": {
		"sign": "ecdsa/rsa",
		"hash": "sha256",
		"id": "3031300d060960864801650304020105000420"
	},
	"sha384WithRSAEncryption": {
		"sign": "rsa",
		"hash": "sha384",
		"id": "3041300d060960864801650304020205000430"
	},
	"RSA-SHA384": {
		"sign": "ecdsa/rsa",
		"hash": "sha384",
		"id": "3041300d060960864801650304020205000430"
	},
	"sha512WithRSAEncryption": {
		"sign": "rsa",
		"hash": "sha512",
		"id": "3051300d060960864801650304020305000440"
	},
	"RSA-SHA512": {
		"sign": "ecdsa/rsa",
		"hash": "sha512",
		"id": "3051300d060960864801650304020305000440"
	},
	"RSA-SHA1": {
		"sign": "rsa",
		"hash": "sha1",
		"id": "3021300906052b0e03021a05000414"
	},
	"ecdsa-with-SHA1": {
		"sign": "ecdsa",
		"hash": "sha1",
		"id": ""
	},
	"sha256": {
		"sign": "ecdsa",
		"hash": "sha256",
		"id": ""
	},
	"sha224": {
		"sign": "ecdsa",
		"hash": "sha224",
		"id": ""
	},
	"sha384": {
		"sign": "ecdsa",
		"hash": "sha384",
		"id": ""
	},
	"sha512": {
		"sign": "ecdsa",
		"hash": "sha512",
		"id": ""
	},
	"DSA-SHA": {
		"sign": "dsa",
		"hash": "sha1",
		"id": ""
	},
	"DSA-SHA1": {
		"sign": "dsa",
		"hash": "sha1",
		"id": ""
	},
	"DSA": {
		"sign": "dsa",
		"hash": "sha1",
		"id": ""
	},
	"DSA-WITH-SHA224": {
		"sign": "dsa",
		"hash": "sha224",
		"id": ""
	},
	"DSA-SHA224": {
		"sign": "dsa",
		"hash": "sha224",
		"id": ""
	},
	"DSA-WITH-SHA256": {
		"sign": "dsa",
		"hash": "sha256",
		"id": ""
	},
	"DSA-SHA256": {
		"sign": "dsa",
		"hash": "sha256",
		"id": ""
	},
	"DSA-WITH-SHA384": {
		"sign": "dsa",
		"hash": "sha384",
		"id": ""
	},
	"DSA-SHA384": {
		"sign": "dsa",
		"hash": "sha384",
		"id": ""
	},
	"DSA-WITH-SHA512": {
		"sign": "dsa",
		"hash": "sha512",
		"id": ""
	},
	"DSA-SHA512": {
		"sign": "dsa",
		"hash": "sha512",
		"id": ""
	},
	"DSA-RIPEMD160": {
		"sign": "dsa",
		"hash": "rmd160",
		"id": ""
	},
	"ripemd160WithRSA": {
		"sign": "rsa",
		"hash": "rmd160",
		"id": "3021300906052b2403020105000414"
	},
	"RSA-RIPEMD160": {
		"sign": "rsa",
		"hash": "rmd160",
		"id": "3021300906052b2403020105000414"
	},
	"md5WithRSAEncryption": {
		"sign": "rsa",
		"hash": "md5",
		"id": "3020300c06082a864886f70d020505000410"
	},
	"RSA-MD5": {
		"sign": "rsa",
		"hash": "md5",
		"id": "3020300c06082a864886f70d020505000410"
	}
};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(1097)
exports.pbkdf2Sync = __webpack_require__(512)


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(505)
var rmd160 = __webpack_require__(1098)
var sha = __webpack_require__(1099)

var checkParameters = __webpack_require__(510)
var defaultEncoding = __webpack_require__(511)
var Buffer = __webpack_require__(9).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(141)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(141)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(167)
var Buffer = __webpack_require__(9).Buffer
var incr32 = __webpack_require__(516)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 516 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = {
	"aes-128-ecb": {
		"cipher": "AES",
		"key": 128,
		"iv": 0,
		"mode": "ECB",
		"type": "block"
	},
	"aes-192-ecb": {
		"cipher": "AES",
		"key": 192,
		"iv": 0,
		"mode": "ECB",
		"type": "block"
	},
	"aes-256-ecb": {
		"cipher": "AES",
		"key": 256,
		"iv": 0,
		"mode": "ECB",
		"type": "block"
	},
	"aes-128-cbc": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes-192-cbc": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes-256-cbc": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes128": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes192": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes256": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes-128-cfb": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CFB",
		"type": "stream"
	},
	"aes-192-cfb": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CFB",
		"type": "stream"
	},
	"aes-256-cfb": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CFB",
		"type": "stream"
	},
	"aes-128-cfb8": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CFB8",
		"type": "stream"
	},
	"aes-192-cfb8": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CFB8",
		"type": "stream"
	},
	"aes-256-cfb8": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CFB8",
		"type": "stream"
	},
	"aes-128-cfb1": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CFB1",
		"type": "stream"
	},
	"aes-192-cfb1": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CFB1",
		"type": "stream"
	},
	"aes-256-cfb1": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CFB1",
		"type": "stream"
	},
	"aes-128-ofb": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "OFB",
		"type": "stream"
	},
	"aes-192-ofb": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "OFB",
		"type": "stream"
	},
	"aes-256-ofb": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "OFB",
		"type": "stream"
	},
	"aes-128-ctr": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CTR",
		"type": "stream"
	},
	"aes-192-ctr": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CTR",
		"type": "stream"
	},
	"aes-256-ctr": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CTR",
		"type": "stream"
	},
	"aes-128-gcm": {
		"cipher": "AES",
		"key": 128,
		"iv": 12,
		"mode": "GCM",
		"type": "auth"
	},
	"aes-192-gcm": {
		"cipher": "AES",
		"key": 192,
		"iv": 12,
		"mode": "GCM",
		"type": "auth"
	},
	"aes-256-gcm": {
		"cipher": "AES",
		"key": 256,
		"iv": 12,
		"mode": "GCM",
		"type": "auth"
	}
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(228)
var Buffer = __webpack_require__(9).Buffer
var Transform = __webpack_require__(96)
var inherits = __webpack_require__(7)
var GHASH = __webpack_require__(1119)
var xor = __webpack_require__(167)
var incr32 = __webpack_require__(516)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(228)
var Buffer = __webpack_require__(9).Buffer
var Transform = __webpack_require__(96)
var inherits = __webpack_require__(7)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(138);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(33);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(521);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(33);
var brorand = __webpack_require__(522);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(1124);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);
var common = __webpack_require__(168);
var shaCommon = __webpack_require__(524);
var assert = __webpack_require__(60);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);
var common = __webpack_require__(168);
var assert = __webpack_require__(60);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);
var Reporter = __webpack_require__(170).Reporter;
var Buffer = __webpack_require__(21).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(1156);


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);

var asn1 = __webpack_require__(169);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);
var Buffer = __webpack_require__(21).Buffer;

var asn1 = __webpack_require__(169);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = {
	"1.3.132.0.10": "secp256k1",
	"1.3.132.0.33": "p224",
	"1.2.840.10045.3.1.1": "p192",
	"1.2.840.10045.3.1.7": "p256",
	"1.3.132.0.34": "p384",
	"1.3.132.0.35": "p521"
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(165);
module.exports = function (seed, len) {
  var t = new Buffer('');
  var  i = 0, c;
  while (t.length < len) {
    c = i2ops(i++);
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()]);
  }
  return t.slice(0, len);
};

function i2ops(c) {
  var out = new Buffer(4);
  out.writeUInt32BE(c,0);
  return out;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = function xor(a, b) {
  var len = a.length;
  var i = -1;
  while (++i < len) {
    a[i] ^= b[i];
  }
  return a
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(33);
function withPublic(paddedMsg, key) {
  return new Buffer(paddedMsg
    .toRed(bn.mont(key.modulus))
    .redPow(new bn(key.publicExponent))
    .fromRed()
    .toArray());
}

module.exports = withPublic;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.EnhancedTextInput=exports.controlled=undefined;var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _pick2=__webpack_require__(345);var _pick3=_interopRequireDefault(_pick2);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _EnhancedTextInput=__webpack_require__(1193);var _EnhancedTextInput2=_interopRequireDefault(_EnhancedTextInput);var _Clear=__webpack_require__(1194);var _Clear2=_interopRequireDefault(_Clear);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input#Attributes_common_to_all_input_types
/* eslint-disable react/no-multi-comp */var validInputAttributes=['autoComplete','autoFocus','disabled','form','list','name','readOnly','tabIndex','type','value','maxLength','minLength'];/**
 * Gets display name of component
 *
 * @param {Component} WrappedComponent Component to get name from
 * @return {*|string} display name of component.
 */function getDisplayName(WrappedComponent){return WrappedComponent.displayName||WrappedComponent.name||'Component';}var controlled=exports.controlled=function controlled(WrappedComponent){var WrappedInput=function(_React$Component){(0,_inherits3.default)(WrappedInput,_React$Component);function WrappedInput(props){(0,_classCallCheck3.default)(this,WrappedInput);var _this=(0,_possibleConstructorReturn3.default)(this,(WrappedInput.__proto__||(0,_getPrototypeOf2.default)(WrappedInput)).call(this,props));_this.state={focus:false,touched:false,dirty:false,error:undefined,// eslint-disable-line
value:''};_this.handleFocus=_this.handleFocus.bind(_this);_this.handleBlur=_this.handleBlur.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleClear=_this.handleClear.bind(_this);_this.validateField=_this.validateField.bind(_this);return _this;}(0,_createClass3.default)(WrappedInput,[{key:'handleFocus',value:function handleFocus(){this.setState({focus:true});}},{key:'handleBlur',value:function handleBlur(evt){var value=evt.currentTarget.value;this.setState({hasFocus:false,error:this.validateField(value),touched:true});}},{key:'handleClear',value:function handleClear(){this.handleChange({currentTarget:{value:''},target:{value:''}});}},{key:'validateField',value:function validateField(value){var error=void 0;// eslint-disable-line
var _props=this.props,validate=_props.validate,required=_props.required;if(required&&!value){error='This field is required.';}if(validate){error=validate(value);}return error;}},{key:'handleChange',value:function handleChange(evt){var _props2=this.props,onChange=_props2.onChange,defaultValue=_props2.defaultValue;var value=evt.currentTarget.value;if(onChange){onChange(evt);}var dirty=value!==defaultValue;this.setState({error:null,dirty:dirty,value:value});}},{key:'render',value:function render(){return _react2.default.createElement(WrappedComponent,(0,_extends3.default)({},this.props,this.state,{onChange:this.handleChange,onBlur:this.handleBlur,onFocus:this.handleFocus,onClear:this.handleClear}));}}]);return WrappedInput;}(_react2.default.Component);WrappedInput.propTypes={validate:_propTypes2.default.func,onChange:_propTypes2.default.func,defaultValue:_propTypes2.default.string};WrappedInput.defaultProps={defaultValue:''};WrappedInput.displayName='Controlled('+getDisplayName(WrappedComponent);return WrappedInput;};/** EnhancedTextInput component
 * Has a placeholder and label that shifts upon receiving input
 */var EnhancedTextInput=exports.EnhancedTextInput=function(_React$Component2){(0,_inherits3.default)(EnhancedTextInput,_React$Component2);function EnhancedTextInput(){(0,_classCallCheck3.default)(this,EnhancedTextInput);return(0,_possibleConstructorReturn3.default)(this,(EnhancedTextInput.__proto__||(0,_getPrototypeOf2.default)(EnhancedTextInput)).apply(this,arguments));}(0,_createClass3.default)(EnhancedTextInput,[{key:'render',value:function render(){var _props3=this.props,name=_props3.name,title=_props3.title,required=_props3.required,touched=_props3.touched,error=_props3.error,focus=_props3.focus,value=_props3.value,onClear=_props3.onClear,onChange=_props3.onChange,onBlur=_props3.onBlur,onFocus=_props3.onFocus,defaultValue=_props3.defaultValue,placeholder=_props3.placeholder;var hasValue=Boolean(value);var showError=touched&&error;var dirty=hasValue&&defaultValue!==value;var blockClassNames=(0,_classnames2.default)({Field:true,'has-error':showError,'has-focus':focus,'is-dirty':dirty});var fieldTitle=required?title+'*':title;return _react2.default.createElement('div',{className:_EnhancedTextInput2.default.FieldWrap},_react2.default.createElement('div',{className:blockClassNames},_react2.default.createElement('label',{className:'FieldLabel',htmlFor:name},fieldTitle),_react2.default.createElement('input',(0,_extends3.default)({},(0,_pick3.default)(this.props,validInputAttributes),{id:'field-'+name,onChange:onChange,onBlur:onBlur,onFocus:onFocus,name:name,placeholder:placeholder||fieldTitle,className:_EnhancedTextInput2.default.FieldControl})),dirty&&_react2.default.createElement('button',{type:'button','data-id':'clear-button',className:_EnhancedTextInput2.default.FieldIcon,onClick:onClear,tabIndex:-1},_react2.default.createElement(_Clear2.default,{size:'15',fillColor:'#999'}))),showError&&_react2.default.createElement('div',{className:_EnhancedTextInput2.default.FieldError},error));}}]);return EnhancedTextInput;}(_react2.default.Component);EnhancedTextInput.propTypes={name:_propTypes2.default.string.isRequired,title:_propTypes2.default.string,required:_propTypes2.default.bool,touched:_propTypes2.default.bool,error:_propTypes2.default.string,focus:_propTypes2.default.bool,value:_propTypes2.default.string,onClear:_propTypes2.default.func,onChange:_propTypes2.default.func,onBlur:_propTypes2.default.func,onFocus:_propTypes2.default.func,defaultValue:_propTypes2.default.string,placeholder:_propTypes2.default.string};EnhancedTextInput.defaultProps={type:'text',tabIndex:'0',title:'',placeholder:'',disabled:false};exports.default=controlled(EnhancedTextInput);

/***/ }),
/* 536 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _Spinner=__webpack_require__(1196);var _Spinner2=_interopRequireDefault(_Spinner);var _SpinnerIcon=__webpack_require__(539);var _SpinnerIcon2=_interopRequireDefault(_SpinnerIcon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Spinner=function Spinner(_ref){var size=_ref.size;return _react2.default.createElement('div',{className:_Spinner2.default.Spinner},_react2.default.createElement(_SpinnerIcon2.default,{size:size}));};Spinner.propTypes={size:_propTypes2.default.number};exports.default=Spinner;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* istanbul ignore next *//* eslint-disable react/no-multi-comp */var SpinnerIcon=function SpinnerIcon(_ref){var _ref$size=_ref.size,size=_ref$size===undefined?120:_ref$size;return _react2.default.createElement('svg',{xmlns:'https://www.w3.org/2000/svg',width:size,height:size,viewBox:'0 0 100 100',preserveAspectRatio:'xMidYMid'},_react2.default.createElement('rect',{x:'0',y:'0',width:'100',height:'100',fill:'none'}),_react2.default.createElement('circle',{cx:'50',cy:'50',r:'40',stroke:'#f5f5f5',fill:'none',strokeWidth:'10',strokeLinecap:'round'}),_react2.default.createElement('circle',{cx:'50',cy:'50',r:'40',stroke:'#0099cc',fill:'none',strokeWidth:'6',strokeLinecap:'round'},_react2.default.createElement('animate',{attributeName:'stroke-dashoffset',dur:'3s',repeatCount:'indefinite',from:'0',to:'502'}),_react2.default.createElement('animate',{attributeName:'stroke-dasharray',dur:'3s',repeatCount:'indefinite',values:'225.9 25.099999999999994;1 250;225.9 25.099999999999994'})));};SpinnerIcon.propTypes={size:_propTypes2.default.number};exports.default=SpinnerIcon;

/***/ }),
/* 540 */,
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Stringify = __webpack_require__(1204);
var Parse = __webpack_require__(1205);


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};


/***/ }),
/* 542 */
/***/ (function(module, exports) {

// Load modules


// Declare internals

var internals = {};
internals.hexTable = new Array(256);
for (var h = 0; h < 256; ++h) {
    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
}


exports.arrayToObject = function (source, options) {

    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (typeof source[i] !== 'undefined') {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.merge = function (target, source, options) {

    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        }
        else if (typeof target === 'object') {
            target[source] = true;
        }
        else {
            target = [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        target = [target].concat(source);
        return target;
    }

    if (Array.isArray(target) &&
        !Array.isArray(source)) {

        target = exports.arrayToObject(target, options);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (!Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = value;
        }
        else {
            target[key] = exports.merge(target[key], value, options);
        }
    }

    return target;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {

    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    if (typeof str !== 'string') {
        str = '' + str;
    }

    var out = '';
    for (var i = 0, il = str.length; i < il; ++i) {
        var c = str.charCodeAt(i);

        if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A)) { // A-Z

            out += str[i];
            continue;
        }

        if (c < 0x80) {
            out += internals.hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        ++i;
        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, refs) {

    if (typeof obj !== 'object' ||
        obj === null) {

        return obj;
    }

    refs = refs || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0, il = obj.length; i < il; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};


exports.isRegExp = function (obj) {

    return Object.prototype.toString.call(obj) === '[object RegExp]';
};


exports.isBuffer = function (obj) {

    if (obj === null ||
        typeof obj === 'undefined') {

        return false;
    }

    return !!(obj.constructor &&
              obj.constructor.isBuffer &&
              obj.constructor.isBuffer(obj));
};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1212),
    isArguments = __webpack_require__(163),
    isArray = __webpack_require__(46),
    isIndex = __webpack_require__(224),
    isString = __webpack_require__(164);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var result = (isArray(value) || isString(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(233),
    arrayEach = __webpack_require__(331),
    assignValue = __webpack_require__(545),
    baseAssign = __webpack_require__(1221),
    cloneBuffer = __webpack_require__(1222),
    copyArray = __webpack_require__(223),
    copySymbols = __webpack_require__(1223),
    getAllKeys = __webpack_require__(1225),
    getTag = __webpack_require__(321),
    initCloneArray = __webpack_require__(1227),
    initCloneByTag = __webpack_require__(1228),
    initCloneObject = __webpack_require__(1237),
    isArray = __webpack_require__(46),
    isBuffer = __webpack_require__(480),
    isHostObject = __webpack_require__(212),
    isObject = __webpack_require__(54),
    keys = __webpack_require__(142);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(161);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

module.exports = assignValue;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(323),
    stubArray = __webpack_require__(1224);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

module.exports = getSymbols;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(47);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 548 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(323);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var questions=[{question:'What sort of funeral planning help do you need?',fieldName:'q_preneed',answers:['Immediate help','Future pre-planning'],help:'Pre-planning means making arrangements for a funeral someday in the future.',page:'preneed'},{question:'Who are you planning for?',fieldName:'q_who',answers:['Myself','Someone Else'],page:'who'},{question:'Religious guidelines',fieldName:'q_religion',answers:['Christian','Christian (Catholic)','Christian (Eastern Orthodox)','Christian (LDS)','Jewish','Muslim','Hindu','Buddhist','Other'],page:'religion'},{question:'What type of service?',fieldName:'q_traditional',answers:['Traditional','Unique'],page:'traditional'},{question:'What are your budget considerations?',fieldName:'q_budget',answers:['Open Budget','Moderate Budget','Tight Budget'],page:'budget'},{question:'What are your desired preferences?',fieldName:'q_body',answers:['Burial','Cremation','Donate to Science','Other'],page:'body'}];exports.default=questions;

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Question":"Question","QuestionText":"QuestionText","Answers":"Answers","Answer":"Answer","Hover":"Hover","Selected":"Selected","AnswerText":"AnswerText","AnswerSelect":"AnswerSelect","QuestionHelp":"QuestionHelp","Indicator":"Indicator","Progress":"Progress","Skip":"Skip","Nav":"Nav","Close":"Close","Back":"Back","Hidden":"Hidden"};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1255),
    isObject = __webpack_require__(54),
    isObjectLike = __webpack_require__(95);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1256),
    arraySome = __webpack_require__(1259);

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap","HeroBlock":"HeroBlock","Title":"Title","SubTitle":"SubTitle","Form":"Form","Field":"Field","Image":"Image","HeroContent":"HeroContent","HeroInner":"HeroInner","Alternate":"Alternate","HeroHeading":"HeroHeading"};

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Formik", function() { return Formik; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yupToFormErrors", function() { return yupToFormErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateYupSchema", function() { return validateYupSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return Field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withFormik", function() { return withFormik; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "move", function() { return move; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "swap", function() { return swap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insert", function() { return insert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FieldArray", function() { return FieldArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIn", function() { return getIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setIn", function() { return setIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNestedObjectValues", function() { return setNestedObjectValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInteger", function() { return isInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return isNaN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmptyChildren", function() { return isEmptyChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActiveElement", function() { return getActiveElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeCancelable", function() { return makeCancelable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FastField", function() { return FastField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormikProvider", function() { return FormikProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormikConsumer", function() { return FormikConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return connect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorMessage", function() { return ErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_context__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_cloneDeep__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_fast_compare__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_deepmerge__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_warning__ = __webpack_require__(1397);










var _a;
var FormikProvider = (_a =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_3_create_react_context___default()({}), _a.Provider),
    FormikConsumer = _a.Consumer;
function connect(Comp) {
  var C = function (props) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(FormikConsumer, null, function (formik) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Comp, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component';
  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Comp);
}

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__["a" /* default */])(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
function setIn(obj, path, value) {
  var res = {};
  var resVal = res;
  var i = 0;
  var pathArray = Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__["a" /* default */])(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (resVal[currentPath]) {
      resVal = resVal[currentPath];
    } else if (currentObj) {
      resVal = resVal[currentPath] = Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_cloneDeep__["a" /* default */])(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  }

  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  }

  var result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj, res);

  if (i === 0 && value === undefined) {
    delete result[pathArray[i]];
  }

  return result;
}
function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
    var k = _a[_i];
    var val = object[k];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true);
        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}
var isFunction = function (obj) {
  return typeof obj === 'function';
};
var isObject = function (obj) {
  return obj !== null && typeof obj === 'object';
};
var isInteger = function (obj) {
  return String(Math.floor(Number(obj))) === obj;
};
var isString = function (obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
var isNaN = function (obj) {
  return obj !== obj;
};
var isEmptyChildren = function (children) {
  return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children) === 0;
};
var isPromise = function (value) {
  return isObject(value) && isFunction(value.then);
};
function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
function makeCancelable(promise) {
  var hasCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return [wrappedPromise, function cancel() {
    hasCanceled = true;
  }];
}

var Formik =
/*#__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Formik, _super);

  function Formik(props) {
    var _this = _super.call(this, props) || this;

    _this.hcCache = {};
    _this.hbCache = {};

    _this.registerField = function (name, Comp) {
      _this.fields[name] = Comp;
    };

    _this.unregisterField = function (name) {
      delete _this.fields[name];
    };

    _this.setErrors = function (errors) {
      _this.setState({
        errors: errors
      });
    };

    _this.setTouched = function (touched) {
      _this.setState({
        touched: touched
      }, function () {
        if (_this.props.validateOnBlur) {
          _this.runValidations(_this.state.values);
        }
      });
    };

    _this.setValues = function (values) {
      _this.setState({
        values: values
      }, function () {
        if (_this.props.validateOnChange) {
          _this.runValidations(values);
        }
      });
    };

    _this.setStatus = function (status) {
      _this.setState({
        status: status
      });
    };

    _this.setError = function (error) {
      if (false) {
        console.warn("Warning: Formik's setError(error) is deprecated and may be removed in future releases. Please use Formik's setStatus(status) instead. It works identically. For more info see https://github.com/jaredpalmer/formik#setstatus-status-any--void");
      }

      _this.setState({
        error: error
      });
    };

    _this.setSubmitting = function (isSubmitting) {
      if (_this.didMount) {
        _this.setState({
          isSubmitting: isSubmitting
        });
      }
    };

    _this.validateField = function (field) {
      _this.setState({
        isValidating: true
      });

      return _this.runSingleFieldLevelValidation(field, getIn(_this.state.values, field)).then(function (error) {
        if (_this.didMount) {
          _this.setState({
            errors: setIn(_this.state.errors, field, error),
            isValidating: false
          });
        }

        return error;
      });
    };

    _this.runSingleFieldLevelValidation = function (field, value) {
      return new Promise(function (resolve) {
        return resolve(_this.fields[field].props.validate(value));
      }).then(function (x) {
        return x;
      }, function (e) {
        return e;
      });
    };

    _this.runValidationSchema = function (values) {
      return new Promise(function (resolve) {
        var validationSchema = _this.props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema() : validationSchema;
        validateYupSchema(values, schema).then(function () {
          resolve({});
        }, function (err) {
          resolve(yupToFormErrors(err));
        });
      });
    };

    _this.runValidations = function (values) {
      if (values === void 0) {
        values = _this.state.values;
      }

      if (_this.validator) {
        _this.validator();
      }

      var _a = makeCancelable(Promise.all([_this.runFieldLevelValidations(values), _this.props.validationSchema ? _this.runValidationSchema(values) : {}, _this.props.validate ? _this.runValidateHandler(values) : {}]).then(function (_a) {
        var fieldErrors = _a[0],
            schemaErrors = _a[1],
            handlerErrors = _a[2];
        return __WEBPACK_IMPORTED_MODULE_7_deepmerge__["a" /* default */].all([fieldErrors, schemaErrors, handlerErrors], {
          arrayMerge: arrayMerge
        });
      })),
          promise = _a[0],
          cancel = _a[1];

      _this.validator = cancel;
      return promise.then(function (errors) {
        _this.setState(function (prevState) {
          if (!__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(prevState.errors, errors)) {
            return {
              errors: errors
            };
          }

          return null;
        });

        return errors;
      }).catch(function (x) {
        return x;
      });
    };

    _this.handleChange = function (eventOrPath) {
      var executeChange = function (eventOrTextValue, maybePath) {
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed;

        if (!isString(eventOrTextValue)) {
          if (eventOrTextValue.persist) {
            eventOrTextValue.persist();
          }

          var _a = eventOrTextValue.target,
              type = _a.type,
              name_1 = _a.name,
              id = _a.id,
              value = _a.value,
              checked = _a.checked,
              outerHTML = _a.outerHTML;
          field = maybePath ? maybePath : name_1 ? name_1 : id;

          if (!field && "production" !== 'production') {
            warnAboutMissingIdentifier({
              htmlContent: outerHTML,
              documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
              handlerName: 'handleChange'
            });
          }

          val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) ? checked : value;
        }

        if (field) {
          _this.setState(function (prevState) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, {
              values: setIn(prevState.values, field, val)
            });
          }, function () {
            if (_this.props.validateOnChange) {
              _this.runValidations(setIn(_this.state.values, field, val));
            }
          });
        }
      };

      if (isString(eventOrPath)) {
        return isFunction(_this.hcCache[eventOrPath]) ? _this.hcCache[eventOrPath] : _this.hcCache[eventOrPath] = function (event) {
          return executeChange(event, eventOrPath);
        };
      } else {
        executeChange(eventOrPath);
      }
    };

    _this.setFieldValue = function (field, value, shouldValidate) {
      if (shouldValidate === void 0) {
        shouldValidate = true;
      }

      if (_this.didMount) {
        _this.setState(function (prevState) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, {
            values: setIn(prevState.values, field, value)
          });
        }, function () {
          if (_this.props.validateOnChange && shouldValidate) {
            _this.runValidations(_this.state.values);
          }
        });
      }
    };

    _this.handleSubmit = function (e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      if (false) {
        var activeElement = getActiveElement();

        if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
          process.env.NODE_ENV !== "production" ? warning(!!(activeElement.attributes && activeElement.attributes.getNamedItem('type')), 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : void 0;
        }
      }

      _this.submitForm();
    };

    _this.submitForm = function () {
      _this.setState(function (prevState) {
        return {
          touched: setNestedObjectValues(prevState.values, true),
          isSubmitting: true,
          isValidating: true,
          submitCount: prevState.submitCount + 1
        };
      });

      return _this.runValidations(_this.state.values).then(function (combinedErrors) {
        _this.setState({
          isValidating: false
        });

        var isValid = Object.keys(combinedErrors).length === 0;

        if (isValid) {
          _this.executeSubmit();
        } else if (_this.didMount) {
          _this.setState({
            isSubmitting: false
          });
        }
      });
    };

    _this.executeSubmit = function () {
      _this.props.onSubmit(_this.state.values, _this.getFormikActions());
    };

    _this.handleBlur = function (eventOrString) {
      var executeBlur = function (e, path) {
        if (e.persist) {
          e.persist();
        }

        var _a = e.target,
            name = _a.name,
            id = _a.id,
            outerHTML = _a.outerHTML;
        var field = path ? path : name ? name : id;

        if (!field && "production" !== 'production') {
          warnAboutMissingIdentifier({
            htmlContent: outerHTML,
            documentationAnchorLink: 'handleblur-e-any--void',
            handlerName: 'handleBlur'
          });
        }

        _this.setState(function (prevState) {
          return {
            touched: setIn(prevState.touched, field, true)
          };
        });

        if (_this.props.validateOnBlur) {
          _this.runValidations(_this.state.values);
        }
      };

      if (isString(eventOrString)) {
        return isFunction(_this.hbCache[eventOrString]) ? _this.hbCache[eventOrString] : _this.hbCache[eventOrString] = function (event) {
          return executeBlur(event, eventOrString);
        };
      } else {
        executeBlur(eventOrString);
      }
    };

    _this.setFieldTouched = function (field, touched, shouldValidate) {
      if (touched === void 0) {
        touched = true;
      }

      if (shouldValidate === void 0) {
        shouldValidate = true;
      }

      _this.setState(function (prevState) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, {
          touched: setIn(prevState.touched, field, touched)
        });
      }, function () {
        if (_this.props.validateOnBlur && shouldValidate) {
          _this.runValidations(_this.state.values);
        }
      });
    };

    _this.setFieldError = function (field, message) {
      _this.setState(function (prevState) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, {
          errors: setIn(prevState.errors, field, message)
        });
      });
    };

    _this.resetForm = function (nextValues) {
      var values = nextValues ? nextValues : _this.props.initialValues;
      _this.initialValues = values;

      _this.setState({
        isSubmitting: false,
        isValidating: false,
        errors: {},
        touched: {},
        error: undefined,
        status: undefined,
        values: values,
        submitCount: 0
      });
    };

    _this.handleReset = function () {
      if (_this.props.onReset) {
        var maybePromisedOnReset = _this.props.onReset(_this.state.values, _this.getFormikActions());

        if (isPromise(maybePromisedOnReset)) {
          maybePromisedOnReset.then(_this.resetForm);
        } else {
          _this.resetForm();
        }
      } else {
        _this.resetForm();
      }
    };

    _this.setFormikState = function (s, callback) {
      return _this.setState(s, callback);
    };

    _this.validateForm = function (values) {
      _this.setState({
        isValidating: true
      });

      return _this.runValidations(values).then(function (errors) {
        _this.setState({
          isValidating: false
        });

        return errors;
      });
    };

    _this.getFormikActions = function () {
      return {
        resetForm: _this.resetForm,
        submitForm: _this.submitForm,
        validateForm: _this.validateForm,
        validateField: _this.validateField,
        setError: _this.setError,
        setErrors: _this.setErrors,
        setFieldError: _this.setFieldError,
        setFieldTouched: _this.setFieldTouched,
        setFieldValue: _this.setFieldValue,
        setStatus: _this.setStatus,
        setSubmitting: _this.setSubmitting,
        setTouched: _this.setTouched,
        setValues: _this.setValues,
        setFormikState: _this.setFormikState
      };
    };

    _this.getFormikComputedProps = function () {
      var isInitialValid = _this.props.isInitialValid;
      var dirty = !__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(_this.initialValues, _this.state.values);
      return {
        dirty: dirty,
        isValid: dirty ? _this.state.errors && Object.keys(_this.state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(_this.props) : isInitialValid,
        initialValues: _this.initialValues
      };
    };

    _this.getFormikBag = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.state, _this.getFormikActions(), _this.getFormikComputedProps(), {
        registerField: _this.registerField,
        unregisterField: _this.unregisterField,
        handleBlur: _this.handleBlur,
        handleChange: _this.handleChange,
        handleReset: _this.handleReset,
        handleSubmit: _this.handleSubmit,
        validateOnChange: _this.props.validateOnChange,
        validateOnBlur: _this.props.validateOnBlur
      });
    };

    _this.getFormikContext = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.getFormikBag(), {
        validationSchema: _this.props.validationSchema,
        validate: _this.props.validate,
        initialValues: _this.initialValues
      });
    };

    _this.state = {
      values: props.initialValues || {},
      errors: {},
      touched: {},
      isSubmitting: false,
      isValidating: false,
      submitCount: 0
    };
    _this.didMount = false;
    _this.fields = {};
    _this.initialValues = props.initialValues || {};
     false ? warning(!(props.component && props.render), 'You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored') : void 0;
     false ? warning(!(props.component && props.children && !isEmptyChildren(props.children)), 'You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored') : void 0;
     false ? warning(!(props.render && props.children && !isEmptyChildren(props.children)), 'You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored') : void 0;
    return _this;
  }

  Formik.prototype.componentDidMount = function () {
    this.didMount = true;
  };

  Formik.prototype.componentWillUnmount = function () {
    this.didMount = false;

    if (this.validator) {
      this.validator();
    }
  };

  Formik.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.enableReinitialize && !__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(prevProps.initialValues, this.props.initialValues)) {
      this.initialValues = this.props.initialValues;
      this.resetForm(this.props.initialValues);
    }
  };

  Formik.prototype.runFieldLevelValidations = function (values) {
    var _this = this;

    var fieldKeysWithValidation = Object.keys(this.fields).filter(function (f) {
      return _this.fields && _this.fields[f] && _this.fields[f].props.validate && isFunction(_this.fields[f].props.validate);
    });
    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return _this.runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')];
    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (!!curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  };

  Formik.prototype.runValidateHandler = function (values) {
    var _this = this;

    return new Promise(function (resolve) {
      var maybePromisedErrors = _this.props.validate(values);

      if (maybePromisedErrors === undefined) {
        resolve({});
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function () {
          resolve({});
        }, function (errors) {
          resolve(errors);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  };

  Formik.prototype.render = function () {
    var _a = this.props,
        component = _a.component,
        render = _a.render,
        children = _a.children;
    var props = this.getFormikBag();
    var ctx = this.getFormikContext();
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(FormikProvider, {
      value: ctx
    }, component ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, props) : render ? render(props) : children ? isFunction(children) ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children) : null : null);
  };

  Formik.defaultProps = {
    validateOnChange: true,
    validateOnBlur: true,
    isInitialValid: false,
    enableReinitialize: false
  };
  return Formik;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function warnAboutMissingIdentifier(_a) {
  var htmlContent = _a.htmlContent,
      documentationAnchorLink = _a.documentationAnchorLink,
      handlerName = _a.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n\n    " + htmlContent + "\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}

function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner.length === 0) {
    return setIn(errors, yupError.path, yupError.message);
  }

  for (var _i = 0, _a = yupError.inner; _i < _a.length; _i++) {
    var err = _a[_i];

    if (!errors[err.path]) {
      errors = setIn(errors, err.path, err.message);
    }
  }

  return errors;
}
function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = {};

  for (var k in values) {
    if (values.hasOwnProperty(k)) {
      var key = String(k);
      validateData[key] = values[key] !== '' ? values[key] : undefined;
    }
  }

  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function (e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? Object(__WEBPACK_IMPORTED_MODULE_7_deepmerge__["a" /* default */])(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = Object(__WEBPACK_IMPORTED_MODULE_7_deepmerge__["a" /* default */])(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}

var FieldInner =
/*#__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FieldInner, _super);

  function FieldInner(props) {
    var _this = _super.call(this, props) || this;

    var render = props.render,
        children = props.children,
        component = props.component;
     false ? warning(!(component && render), 'You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored') : void 0;
     false ? warning(!(component && children && isFunction(children)), 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.') : void 0;
     false ? warning(!(render && children && !isEmptyChildren(children)), 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored') : void 0;
    return _this;
  }

  FieldInner.prototype.componentDidMount = function () {
    this.props.formik.registerField(this.props.name, this);
  };

  FieldInner.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, this);
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, this);
    }
  };

  FieldInner.prototype.componentWillUnmount = function () {
    this.props.formik.unregisterField(this.props.name);
  };

  FieldInner.prototype.render = function () {
    var _a = this.props,
        validate = _a.validate,
        name = _a.name,
        render = _a.render,
        children = _a.children,
        _b = _a.component,
        component = _b === void 0 ? 'input' : _b,
        formik = _a.formik,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["validate", "name", "render", "children", "component", "formik"]);

    var _validate = formik.validate,
        _validationSchema = formik.validationSchema,
        restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(formik, ["validate", "validationSchema"]);

    var field = {
      value: props.type === 'radio' || props.type === 'checkbox' ? props.value : getIn(formik.values, name),
      name: name,
      onChange: formik.handleChange,
      onBlur: formik.handleBlur
    };
    var bag = {
      field: field,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (isFunction(children)) {
      return children(bag);
    }

    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["innerRef"]);

      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
        ref: innerRef
      }, field, rest, {
        children: children
      }));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, bag, props, {
      children: children
    }));
  };

  return FieldInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var Field =
/*#__PURE__*/
connect(FieldInner);

var Form =
/*#__PURE__*/
connect(function (_a) {
  var _b = _a.formik,
      handleReset = _b.handleReset,
      handleSubmit = _b.handleSubmit,
      props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["formik"]);

  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("form", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
    onReset: handleReset,
    onSubmit: handleSubmit
  }, props));
});
Form.displayName = 'Form';

function withFormik(_a) {
  var _b = _a.mapPropsToValues,
      mapPropsToValues = _b === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _b,
      config = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["mapPropsToValues"]);

  return function createFormik(Component$$1) {
    var componentDisplayName = Component$$1.displayName || Component$$1.name || Component$$1.constructor && Component$$1.constructor.name || 'Component';

    var C = function (_super) {
      Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(C, _super);

      function C() {
        var _this = _super !== null && _super.apply(this, arguments) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, actions, {
            props: _this.props
          }));
        };

        _this.renderFormComponent = function (formikProps) {
          return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Component$$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.props, formikProps));
        };

        return _this;
      }

      C.prototype.render = function () {
        var _a = this.props,
            children = _a.children,
            props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children"]);

        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Formik, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          onSubmit: this.handleSubmit,
          render: this.renderFormComponent
        }));
      };

      C.displayName = "WithFormik(" + componentDisplayName + ")";
      return C;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component$$1);
  };
}

var move = function (array, from, to) {
  var copy = (array || []).slice();
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function (array, indexA, indexB) {
  var copy = (array || []).slice();
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function (array, index, value) {
  var copy = (array || []).slice();
  copy.splice(index, 0, value);
  return copy;
};
var replace = function (array, index, value) {
  var copy = (array || []).slice();
  copy[index] = value;
  return copy;
};

var FieldArrayInner =
/*#__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FieldArrayInner, _super);

  function FieldArrayInner(props) {
    var _this = _super.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _a = _this.props,
          name = _a.name,
          validateOnChange = _a.validateOnChange,
          _b = _a.formik,
          setFormikState = _b.setFormikState,
          validateForm = _b.validateForm;
      setFormikState(function (prevState) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, {
          values: setIn(prevState.values, name, fn(getIn(prevState.values, name))),
          errors: alterErrors ? setIn(prevState.errors, name, fn(getIn(prevState.errors, name))) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fn(getIn(prevState.touched, name))) : prevState.touched
        });
      }, function () {
        if (validateOnChange) {
          validateForm();
        }
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (array) {
        return (array || []).concat([Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_cloneDeep__["a" /* default */])(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, true, true);
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, true, true);

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    };

    _this.remove = _this.remove.bind(_this);
    _this.pop = _this.pop.bind(_this);
    return _this;
  }

  FieldArrayInner.prototype.remove = function (index) {
    var result;
    this.updateArrayField(function (array) {
      var copy = array ? array.slice() : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  FieldArrayInner.prototype.pop = function () {
    var result;
    this.updateArrayField(function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  FieldArrayInner.prototype.render = function () {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _a = this.props,
        component = _a.component,
        render = _a.render,
        children = _a.children,
        name = _a.name,
        _b = _a.formik,
        _validate = _b.validate,
        _validationSchema = _b.validationSchema,
        restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_b, ["validate", "validationSchema"]);

    var props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, props) : render ? render(props) : children ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children) : null : null;
  };

  FieldArrayInner.defaultProps = {
    validateOnChange: true
  };
  return FieldArrayInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var FieldArray =
/*#__PURE__*/
connect(FieldArrayInner);

var FastFieldInner =
/*#__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FastFieldInner, _super);

  function FastFieldInner(props) {
    var _this = _super.call(this, props) || this;

    var render = props.render,
        children = props.children,
        component = props.component;
     false ? warning(!(component && render), 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored') : void 0;
     false ? warning(!(component && children && isFunction(children)), 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.') : void 0;
     false ? warning(!(render && children && !isEmptyChildren(children)), 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored') : void 0;
    return _this;
  }

  FastFieldInner.prototype.shouldComponentUpdate = function (props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (getIn(this.props.formik.values, this.props.name) !== getIn(props.formik.values, this.props.name) || getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || this.props.formik.isSubmitting !== props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  FastFieldInner.prototype.componentDidMount = function () {
    this.props.formik.registerField(this.props.name, this);
  };

  FastFieldInner.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, this);
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, this);
    }
  };

  FastFieldInner.prototype.componentWillUnmount = function () {
    this.props.formik.unregisterField(this.props.name);
  };

  FastFieldInner.prototype.render = function () {
    var _a = this.props,
        validate = _a.validate,
        name = _a.name,
        render = _a.render,
        children = _a.children,
        _b = _a.component,
        component = _b === void 0 ? 'input' : _b,
        formik = _a.formik,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["validate", "name", "render", "children", "component", "formik"]);

    var _validate = formik.validate,
        _validationSchema = formik.validationSchema,
        restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(formik, ["validate", "validationSchema"]);

    var field = {
      value: props.type === 'radio' || props.type === 'checkbox' ? props.value : getIn(formik.values, name),
      name: name,
      onChange: formik.handleChange,
      onBlur: formik.handleBlur
    };
    var bag = {
      field: field,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (isFunction(children)) {
      return children(bag);
    }

    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["innerRef"]);

      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
        ref: innerRef
      }, field, rest, {
        children: children
      }));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, bag, props, {
      children: children
    }));
  };

  return FastFieldInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var FastField =
/*#__PURE__*/
connect(FastFieldInner);

var ErrorMessageImpl =
/*#__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ErrorMessageImpl, _super);

  function ErrorMessageImpl() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ErrorMessageImpl.prototype.shouldComponentUpdate = function (props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  ErrorMessageImpl.prototype.render = function () {
    var _a = this.props,
        component = _a.component,
        formik = _a.formik,
        render = _a.render,
        children = _a.children,
        name = _a.name,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var ErrorMessage =
/*#__PURE__*/
connect(ErrorMessageImpl);


//# sourceMappingURL=formik.esm.js.map


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(175);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(1349);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(560);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(1351);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(1358);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(1356);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(204)(module)))

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(569);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(571);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSymbols_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stubArray_js__ = __webpack_require__(574);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_3__stubArray_js__["a" /* default */] : function(object) {
  var result = [];
  while (object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, Object(__WEBPACK_IMPORTED_MODULE_2__getSymbols_js__["a" /* default */])(object));
    object = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object);
  }
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbolsIn);


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(570);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(176);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(1402);var _keys2=_interopRequireDefault(_keys);var _stringify=__webpack_require__(171);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.buildRequest=buildRequest;var _isomorphicFetch=__webpack_require__(1405);var _isomorphicFetch2=_interopRequireDefault(_isomorphicFetch);var _isString2=__webpack_require__(164);var _isString3=_interopRequireDefault(_isString2);var _merge2=__webpack_require__(1407);var _merge3=_interopRequireDefault(_merge2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import {logger} from 'legacy-logging-client';
var TIMEOUT_MS=15000;/**
 * Default values for the request object
 * @type {Object}
 */var DEFAULT_REQUEST={protocol:'http',domain:'localhost',port:'',path:['/'],query:{}};/**
 * Default values for the options object
 * @type {Object}
 */var DEFAULT_OPTIONS={logger:null,timeout:TIMEOUT_MS};/**
 * Builds a useable request object based off the request config
 * Protocol: Add a colon and forward slashes
 * Port: Add a colon if it exists
 * Path: Join the path array.
 *    i.e. [v1, people, 000] -> /v1/people/000
 * @param   {Object|String} reqConf The request configuration object or full URL string
 * @returns {Object} an object containing the url string and the query
 */function buildRequest(reqConf){var reqObj={};if((0,_isString3.default)(reqConf)){var splitReq=reqConf.split('?');reqObj.url=splitReq[0];reqObj.query=splitReq[1];}else{var req=(0,_merge3.default)({},DEFAULT_REQUEST,reqConf);reqObj.url=[req.protocol+'://',req.domain,req.port?':'+req.port:'',req.path.length===0?'/':'/'+req.path.join('/')].join('');reqObj.query=req.query;}return reqObj;}/**
 * Makes an http post request via superagent
 * @param  {Object|String} reqConf The request configuration object
 * @param  {Object}        body    The body of the post
 * @param  {Object}        options Options to choose from
 * @return {Promise} The superagent Object (NOTE: Call .then to fire the request)
 */function post(reqConf,body){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var _request=buildRequest(reqConf);var isClient=typeof window!=='undefined';var opts=(0,_merge3.default)({},DEFAULT_OPTIONS,options);var extras=(0,_extends3.default)({credentials:'same-origin',timeout:30000},opts);var httpPost=(0,_isomorphicFetch2.default)(_request.url,(0,_extends3.default)({method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:(0,_stringify2.default)(body)},isClient?{}:extras));return httpPost.then(function(resp){return resp.json();}).then(function(json){return json;});}/**
 * Makes an http get request via superagent
 * @param  {Object} reqConf The request configuration objec
 * @param  {Object} options Options to choose from
 * @return {Object} The superagent Object (NOTE: Call .then to fire the request)
 */function get(reqConf,options){var _request=buildRequest(reqConf);var isClient=typeof window!=='undefined';var opts=(0,_merge3.default)({},DEFAULT_OPTIONS,options);var extras=(0,_extends3.default)({credentials:'same-origin',timeout:30000},opts);var httpGet=(0,_isomorphicFetch2.default)(''+_request.url+((0,_keys2.default)(_request.query).length?'?'+(0,_keys2.default)(_request.query).map(function(el){return el+'='+_request.query[el];}).join('&'):''),(0,_extends3.default)({method:'GET',qs:_request.query,headers:{Accept:'application/json','Content-Type':'application/json'}},isClient?{}:extras));return httpGet.then(function(resp){return resp.json();}).then(function(json){return json;});}exports.default={post:post,get:get};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(161);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54),
    isPrototype = __webpack_require__(219),
    nativeKeysIn = __webpack_require__(1409);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 583 */,
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/* eslint-disable global-require */var GuideImage=exports.GuideImage={'1x':__webpack_require__(1417),'2x':__webpack_require__(1418),'3x':__webpack_require__(1419)};var bgImage=exports.bgImage={mobile:__webpack_require__(1420),desktop:__webpack_require__(1421)};/* eslint-enable */var getBgImage=function getBgImage(){if(typeof window!=='undefined'){return window.matchMedia('(min-width: 768px)').matches?'url('+bgImage.desktop+')':'url('+bgImage.mobile+')';}return'url('+bgImage.desktop+')';};var bgStyles=exports.bgStyles={backgroundImage:getBgImage()};

/***/ }),
/* 585 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","funeral-home-amenities":"funeral-home-amenities","funeral-home-amenities__header":"funeral-home-amenities__header","funeral-home-amenities__list":"funeral-home-amenities__list","funeral-home-amenities__item":"funeral-home-amenities__item","funeral-home-amenities__name":"funeral-home-amenities__name","funeral-home-amenities__svg":"funeral-home-amenities__svg"};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _icons=__webpack_require__(177);var _icons2=_interopRequireDefault(_icons);var _Button=__webpack_require__(143);var _Button2=_interopRequireDefault(_Button);var _GAHelpers=__webpack_require__(22);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PhoneButton=function(_Component){(0,_inherits3.default)(PhoneButton,_Component);function PhoneButton(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,PhoneButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=PhoneButton.__proto__||(0,_getPrototypeOf2.default)(PhoneButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={showPhoneNumber:_this.props.isPremium},_this.phoneIconStyle={top:'10px',position:'relative'},_this.handlePhoneToggle=function(event){if(_this.state.showPhoneNumber===false){event.preventDefault();(0,_GAHelpers.getGATags)({eventCategory:'fhd_phone',eventAction:'fhd_phone_call_click',eventLabel:'viewnumber'});_this.setState({showPhoneNumber:true});}else{(0,_GAHelpers.getGATags)({eventCategory:'fhd_phone',eventAction:'fhd_phone_call_click',eventLabel:_this.props.isPremium?'callprem':'callstandard'});}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(PhoneButton,[{key:'componentDidMount',value:function componentDidMount(){this.triggerDialogTechWhenReady();}},{key:'triggerDialogTechWhenReady',value:function triggerDialogTechWhenReady(){var triggerDialogTech=function triggerDialogTech(){if(window._st){window._st.triggerPageHit();}};document.readyState==='complete'?triggerDialogTech():window.addEventListener('load',triggerDialogTech());}},{key:'render',value:function render(){var showPhoneNumber=this.state.showPhoneNumber;var _props=this.props,phoneNumber=_props.phoneNumber,_props$showIcon=_props.showIcon,showIcon=_props$showIcon===undefined?true:_props$showIcon,className=_props.className;var phoneButtonClass=className?className:'spaced-button phone-button large-button';var clickablePhoneNumber=showPhoneNumber&&phoneNumber?'tel:'+phoneNumber.replace(/[()\- ]/g,''):null;var phoneButtonContents=showPhoneNumber?phoneNumber:'View Phone Number';return _react2.default.createElement(_Button2.default,{className:phoneButtonClass,href:clickablePhoneNumber,action:this.handlePhoneToggle},showIcon&&_react2.default.createElement(_icons2.default,{style:this.phoneIconStyle,size:'24px',fill:'currentColor',name:'phone'}),phoneButtonContents);}}]);return PhoneButton;}(_react.Component);exports.default=PhoneButton;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _icons=__webpack_require__(177);var _icons2=_interopRequireDefault(_icons);var _Button=__webpack_require__(143);var _Button2=_interopRequireDefault(_Button);var _shareHelpers=__webpack_require__(362);var _GAHelpers=__webpack_require__(22);var _moment=__webpack_require__(97);var _moment2=_interopRequireDefault(_moment);__webpack_require__(1493);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SocialButtons=function(_Component){(0,_inherits3.default)(SocialButtons,_Component);function SocialButtons(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,SocialButtons);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=SocialButtons.__proto__||(0,_getPrototypeOf2.default)(SocialButtons)).call.apply(_ref,[this].concat(args))),_this),_this.emailShare=function(event,options){var emailContents=_this.getEmailContents(options);var emailUrl=('mailto:?subject='+emailContents.subject+'&body='+emailContents.body).replace(' ','%20');(0,_shareHelpers.HandleShareClick)(event,emailUrl,'email',false);},_this.handleSendFlowersClick=function(type){var eventCategory={service:'fhd_obit',obituary:'fhd_obit',default:'flower'};var eventAction={service:'fhd_upcoming_flowers_click',obituary:'fhd_flowers_click',default:'flower'};var eventLabel={service:'fhd_obit_upcoming_flowers',obituary:'fhd_obit_flowers',default:'flower'};(0,_GAHelpers.getGATags)({eventCategory:eventCategory[type]||eventLabel.default,eventAction:eventAction[type]||eventLabel.default,eventLabel:eventLabel[type]||eventLabel.default});},_this.facebookShare=function(event,options){var productionUrl=new URL(options.obituaryUrl);productionUrl.host='www.legacy.com';productionUrl.port='';var sharerURL='http://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(productionUrl.href);(0,_shareHelpers.HandleShareClick)(event,sharerURL,'fb',false);},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(SocialButtons,[{key:'emailServiceShareContents',value:function emailServiceShareContents(options){var formattedDate=_moment2.default.utc(options.serviceDate).format('MM/DD/YYYY');return{subject:options.serviceType+' for '+options.fullName+' on '+formattedDate,body:'Hello, %0D%0A%0D%0APlease join me at the '+options.serviceType+' for '+options.fullName+' on '+formattedDate+'.%0D%0A%0D%0AFor complete details, visit '+options.obituaryUrl+('%0D%0A%0D%0AConsider sending hand-delivered sympathy flowers to those grieving a loss. '+encodeURIComponent(options.flowersUrl))};}},{key:'emailObituaryShareContents',value:function emailObituaryShareContents(options){return{subject:options.fullName+' Obituary - Legacy.com',body:'This obituary I found on Legacy.com may interest you: '+options.obituaryUrl};}},{key:'getEmailContents',value:function getEmailContents(options){if(options.type==='service'){return this.emailServiceShareContents(options);}if(options.type==='obituary'){return this.emailObituaryShareContents(options);}return{subject:'',body:''};}},{key:'render',value:function render(){var _this2=this;var _props$urls=this.props.urls,obituaryUrl=_props$urls.obituaryUrl,flowersUrl=_props$urls.flowersUrl;var _props$details=this.props.details,fullName=_props$details.fullName,serviceType=_props$details.serviceType,serviceDate=_props$details.serviceDate,isPlanning=_props$details.isPlanning;var facebookShareOptions={obituaryUrl:obituaryUrl};var emailShareOptions={type:this.props.type,fullName:fullName,serviceType:serviceType,serviceDate:serviceDate,obituaryUrl:obituaryUrl,flowersUrl:flowersUrl};return _react2.default.createElement('div',{className:'social-buttons'},_react2.default.createElement('div',{className:'social-buttons__facebook small-button',onClick:function onClick(event){return _this2.facebookShare(event,facebookShareOptions);}},_react2.default.createElement(_icons2.default,{className:'social-buttons__fb-svg',name:'facebook',size:'18'}),_react2.default.createElement('span',{className:'social-buttons__fb-span'},'Share')),_react2.default.createElement(_Button2.default,{className:'social-buttons__email',type:'small-button',action:function action(event){_this2.emailShare(event,emailShareOptions);}},'Email'),!isPlanning&&_react2.default.createElement(_Button2.default,{className:'btn social-buttons__flowers',type:'btn',href:flowersUrl,action:function action(){_this2.handleSendFlowersClick(_this2.props.type);}},'Send Flowers'));}}]);return SocialButtons;}(_react.Component);exports.default=SocialButtons;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdControl = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AdService = __webpack_require__(363);

var _AdService2 = _interopRequireDefault(_AdService);

var _lodash = __webpack_require__(8);

var _lodash2 = _interopRequireDefault(_lodash);

var _bindMethods = __webpack_require__(598);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React component that will register an ad placement in a page.
 * clientLoadOnly: Will cause the control to not render a typical header slot definition and will render the ad as soon as it loads on the client.
 * manualLoad: Will also not render a header slot definition and will not render and ad slot until the loadAd() method is called.
 */
var AdControl = exports.AdControl = function (_React$Component) {
  _inherits(AdControl, _React$Component);

  /**
   * constructor
   *
   * @param  {type} props injected into control instance
   * @return {Undefined} Returns nothing
   */
  function AdControl(props) {
    _classCallCheck(this, AdControl);

    /**
     * Unique Identifier for ad unit
     * @type {String}
     */
    var _this = _possibleConstructorReturn(this, (AdControl.__proto__ || Object.getPrototypeOf(AdControl)).call(this, props));

    _this.adId = _this.props.slotName || _this.props.positionId;

    /**
     * Unique Identifier for ad unit
     * @type {String}
     */
    _this.controlEventName = _this.adId + '_event';

    /**
     * Maintains the status if the ad is fetching or not
     * @type {Boolean}
     */
    _this.isFetching = false;

    /**
     * State of AdComponent
     * @type {String}
     */
    _this.state = { style: {} };

    (0, _bindMethods.bindMethods)(_this, ['initializeAd', 'retargetAd', 'removeAd', 'handleAdEvent', 'setAdControlRef', 'changeAdFetchStatus', 'refreshAd']);

    _this.refreshAd = _lodash2.default.throttle(_this.refreshAd, _this.props.refreshThrottle, { 'leading': true, 'trailing': false });
    return _this;
  }

  /**
   * componentWillMount - Runs after control properties have loaded advertising
   * registration will happen at this point
   * @returns {Undefined} Returns nothing
   */


  _createClass(AdControl, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!(this.props.manualLoad || this.props.clientLoadOnly)) {
        this.props.adService.registerAdPlacement(this.props.positionId, this.props.pageName, this.props.adSize, this.props.responsiveSizeMap, this.props.slotKeyValues, this.props.slotName, this.props.slotType, this.props.usePartnerAdNetwork);
      }
    }

    /**
     * componentDidMount - Runs on client after render is called.  This method
     * will instruct DFP to load a predefined ad slot.
     * @returns {Undefined} Returns nothing
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initializeAd();
    }

    /**
     * componentWillReceiveProps - called when component is about to receive props
     * @param {Object} nextProps the next props to receive
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (_lodash2.default.isEqual(this.props.slotKeyValues, nextProps.slotKeyValues) === false) {
        this.retargetAd();
      }
    }

    /**
     * componentWillUnmount - called when component is unmounted cleaning up event listners
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeAd();
    }

    /**
     * Reloads the ad by removing it and readding it
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'retargetAd',
    value: function retargetAd() {
      this.removeAd();
      this.initializeAd();
    }

    /**
     * Add and register the ad
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'initializeAd',
    value: function initializeAd() {
      if (!this.props.manualLoad) {
        if (!this.props.clientLoadOnly && window.lago && _lodash2.default.includes(window.lago.ssa, this.adId)) {
          this.props.adService.displayAdUnit(this.adId);
          this.changeAdFetchStatus(true);
        } else {
          this.loadAd();
        }
      }

      if (window) {
        window.addEventListener(this.controlEventName, this.handleAdEvent);
      }
    }

    /**
     * Remove the ad from the screen and unregister it
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'removeAd',
    value: function removeAd() {
      if (window && window.lago) {
        window.lago.removeAdSlot(this.adId);
        window.removeEventListener(this.controlEventName, this.handleAdEvent);

        if (this.props.cleanupIds) {
          _lodash2.default.each(this.props.cleanupIds, function (id) {
            var adCreative = document.querySelectorAll('#' + id);

            if (adCreative.length > 0) {
              _lodash2.default.each(adCreative, function (creative) {
                creative.parentNode.removeChild(creative);
              });
            }
          });
        }
      }
    }

    /**
     * handleAdEvent - invokes callback method if provided with event details.
     *
     * @param  {object} event object data containing even data
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'handleAdEvent',
    value: function handleAdEvent(event) {
      var eventName = event.detail.eventName;

      if (eventName === 'slotOnLoad') {
        this.changeAdFetchStatus(false);
      }

      if (this.props.onAdEvent && this.props.onAdEvent instanceof Function) {
        this.props.onAdEvent(event.detail.eventName, event.detail.data, this);
      }
    }

    /**
     * refreshAd - Calls function to refresh a single ad placement represented by
     * the instance of this ad control
     * @returns {Undefined} Returns nothing
     */

  }, {
    key: 'refreshAd',
    value: function refreshAd() {
      if (!(this.props.ensureLoadedRefresh && this.isFetching)) {
        this.props.adService.refreshAd(this.adId);
        this.setState({ style: {} });
        this.changeAdFetchStatus(true);
      }
    }

    /**
     * loadAd - Only to be called from browser to render and display ad unit.
     * @returns {Undefined} Returns nothing
     */

  }, {
    key: 'loadAd',
    value: function loadAd() {
      if (window) {
        this.props.adService.renderAdSlot(this.props.positionId, this.props.pageName, this.props.adSize, this.props.responsiveSizeMap, this.props.slotKeyValues, this.props.slotName, this.props.slotType, this.props.usePartnerAdNetwork);

        this.changeAdFetchStatus(true);
      }
    }

    /**
     * changeAdFetchStatus - set the status of ad fetching and setTimeout for ad Loading
     * @param  {bool} isFetching set the status of fetching of advertising
     * @return {Undefined} Returns Nothing
     */

  }, {
    key: 'changeAdFetchStatus',
    value: function changeAdFetchStatus(isFetching) {
      var _this2 = this;

      this.isFetching = isFetching;

      if (isFetching) {
        this.adtimeoutId = window.setTimeout(function () {
          _this2.changeAdFetchStatus(false);
        }, this.props.adLoadTimeout);
      } else {
        window.clearTimeout(this.adtimeoutId);
        this.adtimeoutId = 0;
      }
    }

    /**
     *unloadAd - removes ad unit from the DOM and sets the container to be the
     * same size of the current ad to prevent jerking of the page
     * @returns {Undefined} Returns nothing
     */

  }, {
    key: 'unloadAd',
    value: function unloadAd() {
      var element = this.adControlRef;
      var rect = element.getBoundingClientRect();

      element.innerHTML = '';
      this.setState({ style: { height: rect.height, width: rect.width } });
    }

    /**
     * setAdControlRef - pattern for setting the ref as a function for adControl
     *
     * @param  {object} adControl to add to reference
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'setAdControlRef',
    value: function setAdControlRef(adControl) {
      if (adControl) {
        this.adControlRef = adControl;
      }
    }

    /**
     * render - Renders the contents of the AdControl.
     *
     * @return {function} function to render control.
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'adControl' },
        _react2.default.createElement('div', { ref: this.setAdControlRef, id: this.adId, style: this.state.style })
      );
    }
  }]);

  return AdControl;
}(_react2.default.Component);

AdControl.propTypes = {
  adLoadTimeout: _propTypes2.default.number,
  adSize: _propTypes2.default.array,
  cleanupIds: _propTypes2.default.array,
  clientLoadOnly: _propTypes2.default.bool,
  ensureLoadedRefresh: _propTypes2.default.bool,
  manualLoad: _propTypes2.default.bool,
  onAdEvent: _propTypes2.default.func,
  pageName: _propTypes2.default.string.isRequired,
  positionId: _propTypes2.default.string.isRequired,
  refreshThrottle: _propTypes2.default.number,
  responsiveSizeMap: _propTypes2.default.string,
  slotKeyValues: _propTypes2.default.array,
  slotName: _propTypes2.default.string,
  slotType: _propTypes2.default.string,
  uniqueCounter: _propTypes2.default.number,
  adService: _propTypes2.default.instanceOf(_AdService2.default).isRequired,
  usePartnerAdNetwork: _propTypes2.default.bool
};
AdControl.defaultProps = {
  adLoadTimeout: 10000,
  ensureLoadedRefresh: true,
  refreshThrottle: 1000,
  usePartnerAdNetwork: false
};
exports.default = AdControl;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(80);

var _exception = __webpack_require__(118);

var _exception2 = _interopRequireDefault(_exception);

var _helpers = __webpack_require__(591);

var _decorators = __webpack_require__(1505);

var _logger = __webpack_require__(592);

var _logger2 = _interopRequireDefault(_logger);

var _internalProtoAccess = __webpack_require__(593);

var VERSION = '4.7.8';
exports.VERSION = VERSION;
var COMPILER_REVISION = 8;
exports.COMPILER_REVISION = COMPILER_REVISION;
var LAST_COMPATIBLE_COMPILER_REVISION = 7;

exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0 <4.3.0',
  8: '>= 4.3.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  },
  /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */
  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
    _internalProtoAccess.resetLoggedProperties();
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
exports.moveHelperToHooks = moveHelperToHooks;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = __webpack_require__(1498);

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = __webpack_require__(1499);

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = __webpack_require__(1500);

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = __webpack_require__(1501);

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = __webpack_require__(1502);

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = __webpack_require__(1503);

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = __webpack_require__(1504);

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}

function moveHelperToHooks(instance, helperName, keepHelper) {
  if (instance.helpers[helperName]) {
    instance.hooks[helperName] = instance.helpers[helperName];
    if (!keepHelper) {
      delete instance.helpers[helperName];
    }
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(80);

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      // eslint-disable-next-line no-console
      if (!console[method]) {
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createProtoAccessControl = createProtoAccessControl;
exports.resultIsAllowed = resultIsAllowed;
exports.resetLoggedProperties = resetLoggedProperties;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createNewLookupObject = __webpack_require__(1507);

var _logger = __webpack_require__(592);

var _logger2 = _interopRequireDefault(_logger);

var loggedProperties = Object.create(null);

function createProtoAccessControl(runtimeOptions) {
  var defaultMethodWhiteList = Object.create(null);
  defaultMethodWhiteList['constructor'] = false;
  defaultMethodWhiteList['__defineGetter__'] = false;
  defaultMethodWhiteList['__defineSetter__'] = false;
  defaultMethodWhiteList['__lookupGetter__'] = false;

  var defaultPropertyWhiteList = Object.create(null);
  // eslint-disable-next-line no-proto
  defaultPropertyWhiteList['__proto__'] = false;

  return {
    properties: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
    },
    methods: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
      defaultValue: runtimeOptions.allowProtoMethodsByDefault
    }
  };
}

function resultIsAllowed(result, protoAccessControl, propertyName) {
  if (typeof result === 'function') {
    return checkWhiteList(protoAccessControl.methods, propertyName);
  } else {
    return checkWhiteList(protoAccessControl.properties, propertyName);
  }
}

function checkWhiteList(protoAccessControlForType, propertyName) {
  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
    return protoAccessControlForType.whitelist[propertyName] === true;
  }
  if (protoAccessControlForType.defaultValue !== undefined) {
    return protoAccessControlForType.defaultValue;
  }
  logUnexpecedPropertyAccessOnce(propertyName);
  return false;
}

function logUnexpecedPropertyAccessOnce(propertyName) {
  if (loggedProperties[propertyName] !== true) {
    loggedProperties[propertyName] = true;
    _logger2['default'].log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
  }
}

function resetLoggedProperties() {
  Object.keys(loggedProperties).forEach(function (propertyName) {
    delete loggedProperties[propertyName];
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  name: 'Default',
  refresh: function refresh() {
    return function (adId) {
      if (window.lago) {
        var slot = adId ? [window.lago.getAdSlot(adId)] : null;

        window.googletag.cmd.push(function () {
          window.googletag.pubads().refresh(slot);
        });
      }
    };
  },
  displayAdUnit: function displayAdUnit(adId) {
    window.googletag.cmd.push(function () {
      window.googletag.display('' + adId);
    });
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvRGVmYXVsdEV4dGVuc2lvbi5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwibmFtZSIsInJlZnJlc2giLCJ3aW5kb3ciLCJsYWdvIiwic2xvdCIsImFkSWQiLCJnZXRBZFNsb3QiLCJnb29nbGV0YWciLCJjbWQiLCJwdXNoIiwicHViYWRzIiwiZGlzcGxheUFkVW5pdCIsImRpc3BsYXkiXSwibWFwcGluZ3MiOiI7O0FBQUFBLE9BQU9DLE9BQVAsR0FBaUI7QUFDZkMsUUFBTSxTQURTO0FBRWZDLFdBQVMsbUJBQU07QUFDYixXQUFPLGdCQUFRO0FBQ2IsVUFBSUMsT0FBT0MsSUFBWCxFQUFpQjtBQUNmLFlBQU1DLE9BQVFDLElBQUQsR0FBUyxDQUFDSCxPQUFPQyxJQUFQLENBQVlHLFNBQVosQ0FBc0JELElBQXRCLENBQUQsQ0FBVCxHQUF5QyxJQUF0RDs7QUFFQUgsZUFBT0ssU0FBUCxDQUFpQkMsR0FBakIsQ0FBcUJDLElBQXJCLENBQTBCLFlBQU07QUFBRVAsaUJBQU9LLFNBQVAsQ0FBaUJHLE1BQWpCLEdBQTBCVCxPQUExQixDQUFrQ0csSUFBbEM7QUFBMEMsU0FBNUU7QUFDRDtBQUNGLEtBTkQ7QUFPRCxHQVZjO0FBV2ZPLGlCQUFlLDZCQUFRO0FBQ3JCVCxXQUFPSyxTQUFQLENBQWlCQyxHQUFqQixDQUFxQkMsSUFBckIsQ0FBMEIsWUFBTTtBQUM5QlAsYUFBT0ssU0FBUCxDQUFpQkssT0FBakIsTUFBNEJQLElBQTVCO0FBQ0QsS0FGRDtBQUdEO0FBZmMsQ0FBakIiLCJmaWxlIjoiRGVmYXVsdEV4dGVuc2lvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0ge1xuICBuYW1lOiAnRGVmYXVsdCcsXG4gIHJlZnJlc2g6ICgpID0+IHtcbiAgICByZXR1cm4gYWRJZCA9PiB7XG4gICAgICBpZiAod2luZG93LmxhZ28pIHtcbiAgICAgICAgY29uc3Qgc2xvdCA9IChhZElkKSA/IFt3aW5kb3cubGFnby5nZXRBZFNsb3QoYWRJZCldIDogbnVsbDtcblxuICAgICAgICB3aW5kb3cuZ29vZ2xldGFnLmNtZC5wdXNoKCgpID0+IHsgd2luZG93Lmdvb2dsZXRhZy5wdWJhZHMoKS5yZWZyZXNoKHNsb3QpOyB9KTtcbiAgICAgIH1cbiAgICB9O1xuICB9LFxuICBkaXNwbGF5QWRVbml0OiBhZElkID0+IHtcbiAgICB3aW5kb3cuZ29vZ2xldGFnLmNtZC5wdXNoKCgpID0+IHtcbiAgICAgIHdpbmRvdy5nb29nbGV0YWcuZGlzcGxheShgJHthZElkfWApO1xuICAgIH0pO1xuICB9XG59O1xuIl19

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var accountId = '3116';

module.exports = {
  name: 'A9',
  refresh: function refresh() {
    var callGoogleRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return window.apstag ? function (adId) {
      var slot = adId ? [window.lago.getAdSlot(adId)] : null;

      window.lago.a9Slots = module.exports.buildA9SlotsFromGPT(window.lago.slots);
      var a9RefreshSlot = window.lago.a9Slots.filter(function (adSlot) {
        return adSlot.slotID === adId;
      });

      window.apstag.fetchBids({
        slots: a9RefreshSlot
      }, function () {
        window.googletag.cmd.push(function () {
          window.apstag.setDisplayBids();
          if (callGoogleRefresh) {
            window.googletag.pubads().refresh(slot);
          }
        });
      });
    } : null;
  },

  preAdSlotScript: function preAdSlotScript() {
    return '//lago A9 Extensions\n    lago.a9Slots = [];\n    window.googletag.cmd.push(function(){\n      window.googletag.pubads().disableInitialLoad();\n    });';
  },

  postRegistrationScript: function postRegistrationScript(adSlots) {
    return module.exports.buildA9Script(adSlots);
  },

  buildA9Slots: function buildA9Slots() {
    var adSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return adSlots.map(function (slot) {
      return { slotID: slot.containerId, sizes: JSON.parse(slot.adSizes), slotName: slot.adAlias };
    });
  },

  buildA9SlotsFromGPT: function buildA9SlotsFromGPT() {
    var gptSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return gptSlots.map(function (slot) {
      return { slotID: slot.key, sizes: module.exports.gptSlotSizeToArray(slot), slotName: slot.slot.getAdUnitPath() };
    });
  },

  gptSlotSizeToArray: function gptSlotSizeToArray(gptSlot) {
    return gptSlot.slot.getSizes().map(function (slot) {
      var keys = Object.keys(slot);

      return [slot[keys[0]], slot[keys[1]]];
    });
  },

  buildA9Script: function buildA9Script(adSlots) {
    var a9Slots = module.exports.buildA9Slots(adSlots);

    return '<!--A9 Request-->\r\n<script>!function(a9,a,p,s,t,A,g){if(a[a9])return;function q(c,r){a[a9]._Q.push([c,r])}a[a9]={init:function(){q("i",arguments)},fetchBids:function()\n{q("f",arguments)},setDisplayBids:function(){},_Q:[]};A=p.createElement(s);A.async=!0;A.src=t;g=p.getElementsByTagName(s)[0];g.parentNode.insertBefore(\nA,g)}("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");\n  apstag.init({\n    pubID: \'' + accountId + '\',\n    adServer: \'googletag\',\n    timeout: 2e3\n  });\n  apstag.fetchBids({\n    slots: ' + JSON.stringify(a9Slots) + '\n  }, function(bids) {   \n    window.googletag.cmd.push(function(){\n      apstag.setDisplayBids();\n        window.googletag.pubads().refresh();\n    });\n  });\n</script>\r\n<!--A9 Request-->';
  },

  displayAdUnit: function displayAdUnit(adId) {
    if (window.apstag) {
      window.lago.a9Slots = module.exports.buildA9SlotsFromGPT(window.lago.slots);
      var slot = adId ? [window.lago.getAdSlot(adId)] : null;
      var a9RefreshSlot = window.lago.a9Slots.filter(function (adSlot) {
        return adSlot.slotID === adId;
      });

      window.apstag.fetchBids({
        slots: a9RefreshSlot
      }, function () {
        window.googletag.cmd.push(function () {
          window.apstag.setDisplayBids();
          window.googletag.pubads().refresh(slot);
        });
      });
    }
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var accountId = '3116';
var defaultExtension = __webpack_require__(242);

module.exports = {
  name: 'A9',

  bidHandler: function bidHandler() {
    window.apstag.setDisplayBids();
  },

  refresh: function refresh(bidCallback) {
    return window.apstag ? function (adId) {
      window.lago.a9Slots = module.exports.buildA9SlotsFromGPT(window.lago.slots);
      var slot = adId ? [window.lago.getAdSlot(adId)] : null;
      var a9RefreshSlot = window.lago.a9Slots.filter(function (adSlot) {
        return adSlot.slotID === adId;
      });

      window.apstag.fetchBids({
        slots: a9RefreshSlot
      }, function (bids) {
        if (bidCallback && typeof bidCallback === 'function') {
          bidCallback(module.exports.bidHandler, slot);
        } else {
          defaultExtension.bidHandlerRefreshCallback(module.exports.bidHandler, slot);
        }
      });
    } : null;
  },

  postRegistrationScript: function postRegistrationScript(adSlots) {
    return module.exports.buildA9Script(adSlots);
  },

  buildA9Slots: function buildA9Slots() {
    var adSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return adSlots.map(function (slot) {
      return { slotID: slot.containerId, sizes: JSON.parse(slot.adSizes), slotName: slot.adAlias };
    });
  },

  buildA9SlotsFromGPT: function buildA9SlotsFromGPT() {
    var gptSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return gptSlots.map(function (slot) {
      return { slotID: slot.key, sizes: module.exports.gptSlotSizeToArray(slot), slotName: slot.slot.getAdUnitPath() };
    });
  },

  gptSlotSizeToArray: function gptSlotSizeToArray(gptSlot) {
    return gptSlot.slot.getSizes().map(function (slot) {
      var keys = Object.keys(slot);

      return [slot[keys[0]], slot[keys[1]]];
    });
  },

  buildA9Script: function buildA9Script(adSlots) {
    var a9Slots = module.exports.buildA9Slots(adSlots);

    return '<!--A9_beta Request-->\r\n<script>!function(a9,a,p,s,t,A,g){if(a[a9])return;function q(c,r){a[a9]._Q.push([c,r])}a[a9]={init:function(){q("i",arguments)},fetchBids:function()\n{q("f",arguments)},setDisplayBids:function(){},_Q:[]};A=p.createElement(s);A.async=!0;A.src=t;g=p.getElementsByTagName(s)[0];g.parentNode.insertBefore(\nA,g)}("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");\n  function getCookie (name) {\n    var value = \'; \' + document.cookie;\n    var parts = value.split(\'; \' + name + \'=\');\n\n    if (parts.length === 2) {\n      return parts.pop().split(\';\').shift();\n    }\n  }\n  var usPrivacyCookieValue = getCookie(\'usprivacy\');\n  var initParams = {\n    pubID: \'' + accountId + '\',\n    adServer: \'googletag\',\n    params: {},\n    timeout: 2e3\n  };\n  if (usPrivacyCookieValue && usPrivacyCookieValue.length === 4) {\n    initParams.params.us_privacy = usPrivacyCookieValue;\n  }\n  apstag.init(initParams);\n  apstag.fetchBids({\n    slots: ' + JSON.stringify(a9Slots) + '\n  }, function(bids) {\n    window.googletag.cmd.push(function(){\n      apstag.setDisplayBids();\n    });\n  });\n</script>\r\n<!--A9 Request-->';
  },

  displayAdUnit: function displayAdUnit(adId, postPageLoad) {
    if (postPageLoad && window.apstag) {
      window.lago.a9Slots = module.exports.buildA9SlotsFromGPT(window.lago.slots);
      var slot = adId ? [window.lago.getAdSlot(adId)] : null;
      var a9RefreshSlot = window.lago.a9Slots.filter(function (adSlot) {
        return adSlot.slotID === adId;
      });

      window.apstag.fetchBids({
        slots: a9RefreshSlot
      }, function (bids) {
        defaultExtension.bidHandlerCallback(module.exports.bidHandler);
      });
    }
    defaultExtension.displayAdUnit(adId);
  }

};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = "{{#each PreDfpScripts}}{{{this}}}{{/each}}\n\n<script type='text/javascript'>\n    var googletag = googletag || {};\n    googletag.cmd = googletag.cmd || [];\n\n    (function() {\n        var gads = document.createElement('script');\n        gads.async = true;\n        gads.type = 'text/javascript';\n        var useSSL = 'https:' == document.location.protocol;\n        gads.src = (useSSL ? 'https:' : 'http:') +\n                '//securepubads.g.doubleclick.net/tag/js/gpt.js';\n        var node = document.getElementsByTagName('script')[0];\n        node.parentNode.insertBefore(gads, node);\n    })();\n\n    (function () {\n      var webview = \"0\";\n      var userAgent = window.navigator.userAgent.toLowerCase();\n\n      // Detects if device is on iOS\n      var isIos = function isIos() {\n          return (/iphone|ipad|ipod/.test(userAgent) && !window.MSStream);\n      };\n\n      // Detects if 'safari' is in userAgent\n      var isSafari = function isSafari() {\n          return /safari/.test(userAgent);\n      };\n\n      // Detects if 'version' is in userAgent\n      var hasVersion = function hasVersion() {\n          return /version/.test(userAgent);\n      };\n\n      // Determines if browser session is running within installed iOS app\n      if (isIos() && !hasVersion() && !isSafari()) {\n          webview = \"1\";\n      }\n\n      googletag.cmd.push(function() {\n          googletag.pubads().setTargeting(\"webview\", webview);\n      });\n    })();\n</script>\n\n{{#each AdBlockingScripts}}{{{this}}}\n{{/each}}\n\n<script type='text/javascript'>\n    ; (function (lago, window, googletag) {\n        try {if (!window.location.origin) {window.location.origin = window.location.protocol + \"//\" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');}} catch (e) {}\n        var adSlots = [];\n        lago.ssa = [];\n        lago.slots = adSlots;\n        lago.pageTargets = [];\n        lago.mappings = {};\n        lago.getAdSlot = function (adId) { for (var i = 0; i < adSlots.length; i++) { var ad = adSlots[i]; if (ad.key === adId) return ad.slot; } return null; };\n        lago.appendAdSlot = function (adId, adSlot) { adSlots.push({ \"key\": adId, \"slot\": adSlot }); };\n        lago.loadAd = function (adId) { var ap = window.document.getElementById(adId); var lf = (ap) ? window[ap.getAttribute(\"data-loadScript\")] : undefined; if (lf != undefined && typeof lf === \"function\") lf.apply(); };\n        lago.addPageTarget = function(key, value) { this.pageTargets.push({ \"key\": key, \"value\": value}); };\n        lago.removeAdSlot = function (adId) {\n          for (var i = 0; i < adSlots.length; i++) {\n            var adSlot = adSlots[i];\n            if (adSlot.key === adId) {\n              var indexOfAd = adSlots.indexOf(adSlot);\n              if (indexOfAd >= 0) {\n                googletag.destroySlots([adSlot.slot]);\n                adSlots.splice(indexOfAd, 1);\n                lago.ssa.splice(lago.ssa.indexOf(adId), 1);\n              }\n            }\n          }\n        };\n        lago.onEvent = function OnEvent(containerId, eventName, data) {\n          var evt = new CustomEvent(containerId + '_event', {detail: {container: containerId, eventName: eventName, data: data}});\n          window.dispatchEvent(evt);\n        };\n        lago.resize = function(adId, height, width){\n            try {\n                var container = document.getElementById(adId);\n                var iframes = container.getElementsByTagName(\"iframe\");\n                for (var i = iframes.length - 1; i >= 0; i--) { iframes[i].setAttribute(\"width\", width); iframes[i].setAttribute(\"height\", height); };\n            } catch (e) {}\n\n        };\n        lago.setResponsiveContainer = function(adId) {\n          try {\n            var container = document.getElementById(adId);\n            var divs = container.getElementsByTagName(\"div\");\n            for (var i = divs.length - 1; i >= 0; i--) {\n              var div = divs[i]\n              div.setAttribute(\"style\", \"position: relative;padding-bottom: 57%; padding-top: 25px;height: 0;\");\n              var iframes = div.getElementsByTagName(\"iframe\");\n              for (var i = iframes.length - 1; i >= 0; i--) { iframes[i].setAttribute(\"style\", \"position: absolute;top: 0;left: 0;width: 100%;height: 100%;\"); };\n            };\n          } catch (e) {}\n        };\n        lago.message = function(message){\n            try { if (message.origin === window.location.origin)  { var requestObj = JSON.parse(message.data);\n                if (requestObj && requestObj.action) {\n                  if (requestObj.action === \"resize\") { lago.resize(requestObj.frameId, requestObj.height, requestObj.width);}\n                  if (requestObj.action === \"setResponsiveContainer\") { lago.setResponsiveContainer(requestObj.frameId);}\n                  if (requestObj.action === \"adEvent\") { lago.onEvent(requestObj.frameId, requestObj.eventName, requestObj.data); }\n                }}}catch(e){}\n        };\n        {{#each lagoExtensionScripts}}{{{this}}}\n        {{/each}}\n        if (window.addEventListener){window.addEventListener(\"message\", lago.message, false);}else{window.attachEvent(\"onmessage\", lago.message, false);}\n    }(window.lago = window.lago || {}, window, googletag));\n\n    {{#each PreAdSlotScripts}}{{{this}}}\n    {{/each}}\n\n    // Ad Server Side Ads\n    {{#each adPlacements}}\n    lago.ssa.push('{{containerId}}');\n    {{/each}}\n\n    googletag.cmd.push(function () {\n\n    //Setup slotRenderEnded Event handler\n    googletag.pubads().addEventListener(\"slotOnload\", function(event) {\n      var containerId = event.slot.getSlotElementId();\n      lago.onEvent(containerId, 'slotOnLoad')\n    });\n\n    googletag.pubads().addEventListener(\"slotRenderEnded\", function(event) {\n      var containerId = event.slot.getSlotElementId();\n      lago.onEvent(containerId, 'slotRenderEnded')\n    });\n\n    googletag.pubads().addEventListener(\"impressionViewable\", function(event) {\n      var containerId = event.slot.getSlotElementId();\n      lago.onEvent(containerId, 'impressionViewable')\n    });\n\n    //Size Mappings{{#each responsiveSizeMaps}}\n    lago.mappings.{{name}} = googletag.sizeMapping().{{#each sizes}}\n        addSize({{viewport}}, {{{adSizes}}}).{{/each}}\n        build();\n    {{/each}}\n\n    // AD SLOT DEFINITIONS\n    {{#each adPlacements}}{{#if isOutOfPageSlot}}\n    lago.appendAdSlot('{{containerId}}', googletag.defineOutOfPageSlot('{{adAlias}}', '{{containerId}}')\n      {{#each slotKeyValues}}.setTargeting('{{key}}','{{value}}'){{/each}}\n      .addService(googletag.pubads()));{{else}}\n    lago.appendAdSlot('{{containerId}}',\n        googletag.defineSlot('{{adAlias}}', {{{adSizes}}}, '{{containerId}}'){{#if mappingName}}\n        .defineSizeMapping(lago.mappings.{{mappingName}}){{/if}}\n        {{#if isPartnerAd}}{{#each slotKeyValues}}.setTargeting('{{key}}',{{{value}}}){{/each}}{{else}}{{#each slotKeyValues}}.setTargeting('{{key}}','{{value}}'){{/each}}{{/if}}\n        .addService(googletag.pubads()));{{/if}}\n    {{/each}}\n    {{#if pageKeyValues}}// Page-Level key-value\n    googletag.pubads(){{#each pageKeyValues }}\n    {{#if Value.Escape}}.setTargeting(\"{{key}}\",escape(\"{{value}}\")){{else}}.setTargeting(\"{{key}}\",\"{{value}}\"){{/if}}{{/each}};\n\n    {{#each pageKeyValues}}lago.addPageTarget(\"{{key}}\", escape(\"{{value}}\"));\n    {{/each}}{{/if}}\n    {{#each PageTargetScripts}}{{{this}}}\n    {{/each}}\n    googletag.pubads().collapseEmptyDivs();\n    });\n</script>\n{{#each EnableServicesScripts}}\n    {{#if @first}}{{{this}}}{{/if}}\n{{else}}\n  <script>\n    googletag.cmd.push(function () {\n    googletag.enableServices();\n  });\n  </script>\n{{/each}}\n{{#each PostRegistrationScripts}}{{{this}}}\n{{/each}}";
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhZFJlZ2lzdHJhdGlvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindMethods = bindMethods;

var _lodash = __webpack_require__(8);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utility method for binding methods in component constructors
 * @param  {Object} context context to bind to
 * @param  {Array} methods  methods The array of method names
 * @return {Undefined} Returns nothing
 */
function bindMethods(context, methods) {
  _lodash2.default.forEach(methods, function (method) {
    if (_lodash2.default.isFunction(context[method])) {
      context[method] = context[method].bind(context);
    }
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL1V0aWxzL2JpbmRNZXRob2RzLmpzIl0sIm5hbWVzIjpbImJpbmRNZXRob2RzIiwiY29udGV4dCIsIm1ldGhvZHMiLCJfIiwiZm9yRWFjaCIsImlzRnVuY3Rpb24iLCJtZXRob2QiLCJiaW5kIl0sIm1hcHBpbmdzIjoiOzs7OztRQVFnQkEsVyxHQUFBQSxXOztBQVJoQjs7Ozs7O0FBRUE7Ozs7OztBQU1PLFNBQVNBLFdBQVQsQ0FBc0JDLE9BQXRCLEVBQStCQyxPQUEvQixFQUF3QztBQUM3Q0MsbUJBQUVDLE9BQUYsQ0FBVUYsT0FBVixFQUFtQixrQkFBVTtBQUMzQixRQUFJQyxpQkFBRUUsVUFBRixDQUFhSixRQUFRSyxNQUFSLENBQWIsQ0FBSixFQUFtQztBQUNqQ0wsY0FBUUssTUFBUixJQUFrQkwsUUFBUUssTUFBUixFQUFnQkMsSUFBaEIsQ0FBcUJOLE9BQXJCLENBQWxCO0FBQ0Q7QUFDRixHQUpEO0FBS0QiLCJmaWxlIjoiYmluZE1ldGhvZHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgXyBmcm9tICdsb2Rhc2gnO1xuXG4vKipcbiAqIFV0aWxpdHkgbWV0aG9kIGZvciBiaW5kaW5nIG1ldGhvZHMgaW4gY29tcG9uZW50IGNvbnN0cnVjdG9yc1xuICogQHBhcmFtICB7T2JqZWN0fSBjb250ZXh0IGNvbnRleHQgdG8gYmluZCB0b1xuICogQHBhcmFtICB7QXJyYXl9IG1ldGhvZHMgIG1ldGhvZHMgVGhlIGFycmF5IG9mIG1ldGhvZCBuYW1lc1xuICogQHJldHVybiB7VW5kZWZpbmVkfSBSZXR1cm5zIG5vdGhpbmdcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGJpbmRNZXRob2RzIChjb250ZXh0LCBtZXRob2RzKSB7XG4gIF8uZm9yRWFjaChtZXRob2RzLCBtZXRob2QgPT4ge1xuICAgIGlmIChfLmlzRnVuY3Rpb24oY29udGV4dFttZXRob2RdKSkge1xuICAgICAgY29udGV4dFttZXRob2RdID0gY29udGV4dFttZXRob2RdLmJpbmQoY29udGV4dCk7XG4gICAgfVxuICB9KTtcbn1cbiJdfQ==

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalAdControl = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger*/


var DEFAULT_IFRAME_URL = 'about:blank';

/**
 * LocalAd Component responsible for rendering a local ad Unit
 * @class  LocalAd
 */

var LocalAdControl = exports.LocalAdControl = function (_React$Component) {
  _inherits(LocalAdControl, _React$Component);

  function LocalAdControl(props) {
    _classCallCheck(this, LocalAdControl);

    var _this = _possibleConstructorReturn(this, (LocalAdControl.__proto__ || Object.getPrototypeOf(LocalAdControl)).call(this, props));

    _this.state = {};
    _this.UpperRandomLimit = 999999;
    _this.setControlRef = _this.setControlRef.bind(_this);
    _this.defaultIframeUrl = '/obituaries/AffiliateAdvertisement.axd?affiliate=' + _this.props.affiliateSiteName + '&adid=2&preview=False&adtype=1&v=20160607';
    return _this;
  }

  /**
   * refreshAd - description
   *
   * @return {type}  description
   */


  _createClass(LocalAdControl, [{
    key: 'refreshAd',
    value: function refreshAd() {
      var frameSrc = this.adControl.src === DEFAULT_IFRAME_URL ? this.defaultIframeUrl : this.adControl.src;

      if (frameSrc && frameSrc.indexOf('rand=') >= 0) {
        frameSrc = frameSrc.substring(0, frameSrc.indexOf('rand='));
      }
      frameSrc = frameSrc + '&rand=' + Math.floor(Math.random() * this.UpperRandomLimit);
      this.adControl.src = frameSrc;
    }

    /**
     * unloadAd - Remove the current ad content from DOM
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'unloadAd',
    value: function unloadAd() {
      if (this.adControl) {
        this.adControl.src = DEFAULT_IFRAME_URL;
      }
    }

    /**
     * setControlRef - function to assign reference to local ad component
     *
     * @param  {object} adControl iframe reference
     * @return {Undefined} Returns nothing.
     */

  }, {
    key: 'setControlRef',
    value: function setControlRef(adControl) {
      if (adControl) {
        this.adControl = adControl;
      }
    }

    /**
     * Renders Component
     * @return {JSX} Rendered ResultsHeader Component
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('iframe', { ref: this.setControlRef,
          allowTransparency: 'true',
          scrolling: 'no',
          height: '' + this.props.height,
          width: '' + this.props.width,
          frameBorder: '0',
          src: this.defaultIframeUrl })
      );
    }
  }]);

  return LocalAdControl;
}(_react2.default.Component);

LocalAdControl.propTypes = {
  affiliateSiteName: _propTypes2.default.string,
  height: _propTypes2.default.number,
  width: _propTypes2.default.number
};
LocalAdControl.defaultProps = {
  width: 300,
  height: 250
};
exports.default = LocalAdControl;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/* global adRefs *//* eslint arrow-body-style: ["error", "as-needed"]*/var refreshAds=exports.refreshAds=function refreshAds(){var ids=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];ids.forEach(function(id){var adRef=adRefs.find(function(ad){return id===ad.positionId;});if(adRef&&adRef.hasOwnProperty('ref')){var adControlRef=adRef.ref.adControlRef;if(adControlRef){adControlRef.refreshAd();}}});};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(77);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(133);
var ITERATOR = __webpack_require__(45)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(45)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _FlowersCTA=__webpack_require__(1537);var _FlowersCTA2=_interopRequireDefault(_FlowersCTA);var _Header=__webpack_require__(98);var _Header2=_interopRequireDefault(_Header);var _urlHelpers=__webpack_require__(28);var _GAHelpers=__webpack_require__(22);var _breakPointChecker=__webpack_require__(368);__webpack_require__(1538);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FlowersAd=function(_Component){(0,_inherits3.default)(FlowersAd,_Component);function FlowersAd(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,FlowersAd);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=FlowersAd.__proto__||(0,_getPrototypeOf2.default)(FlowersAd)).call.apply(_ref,[this].concat(args))),_this),_this.state={tablet:false,largeMobile:false,smallMobile:false},_this.checkBreakPoint=function(){_this.setState({tablet:(0,_breakPointChecker.breakPointChecker)(),largeMobile:(0,_breakPointChecker.breakPointChecker)(500),smallMobile:(0,_breakPointChecker.breakPointChecker)(300)});},_this.handleSendFlowersClick=function(){(0,_GAHelpers.getGATags)({eventCategory:'fhd_flowers',eventAction:'fhd_flowersad_click',eventLabel:'fhd_flowerad'});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(FlowersAd,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.checkBreakPoint);this.checkBreakPoint();}},{key:'render',value:function render(){var _this2=this;var title=function title(){if(_this2.state.smallMobile){return'Flowers';}else if(_this2.state.largeMobile){return'Sympathy Flowers';}else if(_this2.state.tablet){return'Popular Sympathy Flowers';}return'Most Popular Sympathy Flowers';};return _react2.default.createElement('div',{className:'flowers-ad'},_react2.default.createElement('div',{className:'flowers-cta-header'},_react2.default.createElement(_Header2.default,{type:'normal',className:'flowers-ad__header',title:title()},_react2.default.createElement('a',{href:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(this.props.flowersUrlOptions),className:'flowers-cta-link','data-ga-no-auto-tag':true,onClick:this.handleSendFlowersClick},'View all'))),_react2.default.createElement('div',{className:'flowers-cta-items'},this.props.flowersAdItems.map(function(value,index){return _react2.default.createElement(_FlowersCTA2.default,{key:index,data:value});})));}}]);return FlowersAd;}(_react.Component);exports.default=FlowersAd;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/flower1.999164c4.jpg";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/flower2.b881c45c.jpg";

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/flower3.78943209.jpg";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SearchObituaries=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1539);var _reactRedux=__webpack_require__(12);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _get2=__webpack_require__(135);var _get3=_interopRequireDefault(_get2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var config=(0,_AppConfig2.default)();var SearchObituaries=exports.SearchObituaries=function(_Component){(0,_inherits3.default)(SearchObituaries,_Component);function SearchObituaries(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,SearchObituaries);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=SearchObituaries.__proto__||(0,_getPrototypeOf2.default)(SearchObituaries)).call.apply(_ref,[this].concat(args))),_this),_this.state={firstName:'',lastName:'',searchError:false},_this.buildSearchUrl=function(){if(_this.state.firstName||_this.state.lastName){return _this.setState({searchUrl:_this.generateUrl(),searchError:false});}return _this.setState({searchUrl:null,searchError:true});},_this.handleFirstNameChange=function(e){_this.setState({firstName:e.target.value});},_this.handleLastNameChange=function(e){_this.setState({lastName:e.target.value});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(SearchObituaries,[{key:'generateUrl',value:function generateUrl(){var _props=this.props,affiliateName=_props.affiliateName,funeralHome=_props.funeralHome;var funeralHomeId=funeralHome.funeralHomeId;if(affiliateName){return config.vanityDomain+'/obituaries/'+affiliateName+'/obituary-search.aspx?firstName='+this.state.firstName+'&lastName='+this.state.lastName+'&fhid='+funeralHomeId+'&daterange=30';}return config.vanityDomain+'/search?firstName='+this.state.firstName+'&lastName='+this.state.lastName+'&fhid='+funeralHomeId+'&daterange=Last30Days';}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:'search-obituaries__container'},_react2.default.createElement('div',{className:'search-obituaries__form'},_react2.default.createElement('div',{className:'search-obituaries__form-inner'},_react2.default.createElement('input',{className:'search-obituaries__first-name',name:'first_name',type:'text',value:this.state.firstName,onChange:this.handleFirstNameChange,placeholder:'First Name'}),_react2.default.createElement('input',{className:'search-obituaries__last-name',name:'last_name',type:'text',value:this.state.lastName,onChange:this.handleLastNameChange,placeholder:'Last Name'})),_react2.default.createElement('a',{onClick:this.buildSearchUrl,href:this.state.searchUrl,className:'large-button search-obituaries__button'},'Search')),this.state.searchError&&_react2.default.createElement('p',{className:'error'},'You must enter at least one value to proceed.'));}}]);return SearchObituaries;}(_react.Component);SearchObituaries.propTypes={affiliateName:_react2.default.PropTypes.string,funeralHome:_react2.default.PropTypes.object};var mapStateToProps=function mapStateToProps(state){return{affiliateName:(0,_get3.default)(state,'affiliateStore.siteName'),funeralHome:state.funeralHomeStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(SearchObituaries);

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CtaModule=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _HelpPlanningCta=__webpack_require__(1560);var _HelpPlanningCta2=_interopRequireDefault(_HelpPlanningCta);var _PlanningGuideCta=__webpack_require__(1564);var _PlanningGuideCta2=_interopRequireDefault(_PlanningGuideCta);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CtaModule=exports.CtaModule=function CtaModule(props){var _props$funeralHome$pr=props.funeralHome.profileData,displayPrePlanningForm=_props$funeralHome$pr.displayPrePlanningForm,prePlanningFormValue=_props$funeralHome$pr.prePlanningFormValue;if(displayPrePlanningForm&&prePlanningFormValue===0){return _react2.default.createElement(_PlanningGuideCta2.default,null);}if(displayPrePlanningForm&&prePlanningFormValue===1){return _react2.default.createElement(_HelpPlanningCta2.default,null);}return null;};CtaModule.propTypes={funeralHome:_propTypes2.default.object};CtaModule.defaultProps={funeralHome:{}};var mapStateToProps=function mapStateToProps(state){return{funeralHome:state.funeralHomeStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(CtaModule);

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1590);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1593);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(imageUrl){if(imageUrl){var image=new Image();image.src=imageUrl;if(image.naturalHeight+image.naturalWidth===0){return false;}else if(image.height+image.width===0){return false;}return true;}return false;};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/candle.1d4cd46b.jpg";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(77);
var aFunction = __webpack_require__(206);
var SPECIES = __webpack_require__(45)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(131);
var invoke = __webpack_require__(1613);
var html = __webpack_require__(470);
var cel = __webpack_require__(310);
var global = __webpack_require__(53);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(160)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(77);
var isObject = __webpack_require__(93);
var newPromiseCapability = __webpack_require__(371);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _CondolenceItem=__webpack_require__(1620);var _CondolenceItem2=_interopRequireDefault(_CondolenceItem);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _library=__webpack_require__(40);var _formatHelpers=__webpack_require__(55);var _componentHelpers=__webpack_require__(26);var _Svgs=__webpack_require__(36);var _legacyAdvertising=__webpack_require__(99);var _constants=__webpack_require__(41);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _Likes=__webpack_require__(1621);var _Likes2=_interopRequireDefault(_Likes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Each condolence displayed in the guestbook
 * @param {Object} props The condolence item in the guestbook
 * @returns {JSX} CondolenceItem
 */var CondolenceItem=function(_React$Component){(0,_inherits3.default)(CondolenceItem,_React$Component);/**
   * CondolenceItem Item Constructor
   * @param  {Object} props The Passed in props
   * @return {Undefined} Returns nothing
   */function CondolenceItem(props){(0,_classCallCheck3.default)(this,CondolenceItem);var _this=(0,_possibleConstructorReturn3.default)(this,(CondolenceItem.__proto__||(0,_getPrototypeOf2.default)(CondolenceItem)).call(this,props));(0,_componentHelpers.bindMethods)(_this,['getMediaComponents','getNameLabel','getStyles','handleClick','handleLoadComplete']);return _this;}/**
   * Configure the condolence's message
   * @param {String} message the condolence's message
   * @param {Boolean} isModal If this hubItem is inside a modal
   * @param {Boolean} isPhone If the device is a phone
   * @returns {JSX} React Element
   */(0,_createClass3.default)(CondolenceItem,[{key:'getMessage',value:function getMessage(message,isModal,isPhone){if(!message){return'';}var cleanMessage=(0,_formatHelpers.sanitizeText)(message,['br']);var retMessage=cleanMessage;if(!isModal&&!isPhone){var CHAR_LIMIT=500;if(cleanMessage&&cleanMessage.length>CHAR_LIMIT){retMessage=_lodash2.default.truncate(cleanMessage,{length:CHAR_LIMIT,separator:' '});}}return retMessage;}/**
   * Configure the condolence's location
   * @param    {string} city   The author's city
   * @param    {object} state  The author's full state name and state code
   * @returns  {string} Returns a formated location string
   */},{key:'getLocation',value:function getLocation(city,state){var _ref=state||{},code=_ref.code,name=_ref.name;return _lodash2.default.compact([city,code||name]).join(', ');}/**
   * Configure the items post information
   * @param   {string} date         The item date
   * @param   {string} location     The item location
   * @param   {string} relationship The item relationship
   * @returns {string} Returns the date, location, or relationship of the poster.
   */},{key:'getCondolenceDetails',value:function getCondolenceDetails(date,location,relationship){return _lodash2.default.compact([date,location,relationship]).join(' | ');}/**
   * Returns proper image if one exists
   * @param  {String} photo    The photo object
   * @param  {String} iconUrl  The icon url
   * @param  {String} audioUrl The audio url
   * @param  {Object} video    The video object
   * @return {Object}          Media object
   */},{key:'getImage',value:function getImage(photo,iconUrl,audioUrl,video){var photoUrl=_lodash2.default.get(photo,'url');var audioImg=audioUrl?__webpack_require__(1627):null;var videoImg=_lodash2.default.get(video,'id')?'https://cdn-thumbs.viddler.com/thumbnail_2_'+video.id+'_v1.jpg':null;var tukiosImg=_lodash2.default.get(video,'thumbnail',null);return{url:photoUrl||iconUrl||videoImg||tukiosImg||audioImg||false,isAudio:audioImg!==null,isCandle:!photoUrl&&_lodash2.default.isString(iconUrl)&&iconUrl.indexOf('/candle.jpg')>-1,isServiceVideo:_lodash2.default.get(video,'type')==='service_video',isTukios:tukiosImg!==null,isVideo:videoImg!==null};}/**
   * Returns proper caption if one existss
   * @param  {Object} photo The photo object
   * @return {String} Caption string or null
   */},{key:'getCaption',value:function getCaption(photo){return _lodash2.default.get(photo,'caption')?(0,_formatHelpers.sanitizeText)(photo.caption,['br']):null;}/**
   * Constructs an Id
   * @param  {String} id An id string
   * @return {String}    The constructed id
   */},{key:'getId',value:function getId(id){return id?'HubItem_'+id:null;}/**
   * Returns the full name
   * @param  {String} firstName The first name
   * @param  {String} lastName  The last name
   * @return {String} The constructed full name
   */},{key:'getFullName',value:function getFullName(firstName,lastName){var displayFirstName=_lodash2.default.isNil(firstName)?'':firstName;var displayLastName=_lodash2.default.isNil(lastName)?'':lastName;return displayFirstName||displayLastName?_lodash2.default.trim((0,_formatHelpers.sanitizeText)(displayFirstName+' '+displayLastName)):null;}/**
   * returns correct class names
   * @param  {Boolean} isModal  is it a modal
   * @param  {Boolean} isCandle is it a candle
   * @param  {Boolean} isAd     is this an ad
   * @return {Object}           classnames style grouping
   */},{key:'getCondolenceStyles',value:function getCondolenceStyles(isModal,isCandle,isAd){var conditionalClasses={};conditionalClasses[_CondolenceItem2.default.modal]=isModal;conditionalClasses[_CondolenceItem2.default.candle]=isCandle;conditionalClasses[_CondolenceItem2.default.isAd]=isAd;return(0,_classnames2.default)(_CondolenceItem2.default.CondolenceItem,conditionalClasses);}/**
   * returns correct class names
   * @param  {Boolean} isVideo            is it a video
   * @param  {Boolean} isAudio            is it audio
   * @param  {Boolean} isCandle           is it a candle
   * @param  {Boolean} isCandleNoMessage  is this a candle with no message
   * @return {Object}           classnames style grouping
   */},{key:'getFigureStyles',value:function getFigureStyles(isVideo,isAudio,isCandle,isCandleNoMessage){var conditionalClasses={};conditionalClasses[_CondolenceItem2.default.video]=isVideo;conditionalClasses[_CondolenceItem2.default.audio]=isAudio;conditionalClasses[_CondolenceItem2.default.candleFigure]=isCandle;conditionalClasses[_CondolenceItem2.default.noMessage]=isCandleNoMessage;return(0,_classnames2.default)(conditionalClasses);}/**
   * returns figure to render
   * @param  {Number} id        the id required for Viddler video
   * @param  {Object} image     the image object
   * @param  {String} audioUrl  the audio url
   * @param  {Object} video     the video object
   * @param  {Function} videoReadyCallback callback for video ready
   * @param  {Boolean} isModal  is it a modal render
   * @param  {Object} itemStyles    styles
   * @return {Object}           array of components for render
   */},{key:'getMediaComponents',value:function getMediaComponents(id,image,audioUrl,video,videoReadyCallback,isModal,itemStyles){var components=[];var media=null;if(image.isServiceVideo){media=_react2.default.createElement(_library.IframedVideo,{aspect:524/512,isModal:isModal,key:'media-figure',url:video.url,videoReadyCallback:videoReadyCallback});}else if(isModal){if(image.isVideo){media=_react2.default.createElement(_library.Video,{id:id||'HubItem',key:'media-figure',videoId:video.id,videoReadyCallback:videoReadyCallback});}else if(image.isTukios){media=_react2.default.createElement(_library.IframedVideo,{aspect:9/16,isModal:isModal,key:'media-figure',url:video.url,videoReadyCallback:videoReadyCallback});}else if(image.isAudio){media=_react2.default.createElement(_library.Audio,{key:'media-figure',tabIndex:'1000',url:audioUrl});}else{media=_react2.default.createElement('img',{key:'media-figure',src:image.url});}}else{media=_react2.default.createElement('img',{key:'media-figure',src:image.url});}components.push(media);if(!isModal&&(image.isVideo||image.isAudio||image.isTukios)){components.push(_react2.default.createElement('span',{className:itemStyles.icon,key:'play-icon'},_react2.default.createElement(_Svgs.VideoPlayIcon,null)));}if(!isModal&&image.isServiceVideo){components.push(_react2.default.createElement('span',{className:itemStyles.overlay,key:'media-overlay'}));}return components;}/**
   * returns name identifying the condolence
   * @param  {String} sanitizedFullName the deceased name
   * @param  {Boolean} isTukios         is it a Tukios video
   * @param  {Boolean} isServiceVideo   is it a Service video
   * @return {String}  name label for the condolence
   */},{key:'getNameLabel',value:function getNameLabel(sanitizedFullName,isTukios,isServiceVideo){if(isTukios){return sanitizedFullName+' Tribute Video';}if(isServiceVideo){return sanitizedFullName+' Service Video';}return sanitizedFullName;}/**
   * click handler - stop prop provided click handler from being called on Likes click
   * @param  {event} e    click event
   * @return {Undefined}  returns nothing
   */},{key:'handleClick',value:function handleClick(e){if(_lodash2.default.get(e,'target.attributes.id.value')!=='likes'&&_lodash2.default.isFunction(this.props.handleClick)){this.props.handleClick();}}/**
   * load complete handler
   * @return {Undefined} returns nothing
   */},{key:'handleLoadComplete',value:function handleLoadComplete(){var callbacks=_lodash2.default.get(this.props,'callbacks.load',[]);_lodash2.default.map(callbacks,function(func){if(_lodash2.default.isFunction(func)){func();}});}},{key:'render',value:function render(){var _props=this.props,audioUrl=_props.audioUrl,city=_props.city,condolenceId=_props.condolenceId,date=_props.date,handleClick=_props.handleClick,firstName=_props.firstName,iconUrl=_props.iconUrl,isAd=_props.isAd,isModal=_props.isModal,isPhone=_props.isPhone,lastName=_props.lastName,likesCount=_props.likesCount,message=_props.message,photo=_props.photo,primaryFuneralHome=_props.primaryFuneralHome,relationship=_props.relationship,sourceId=_props.sourceId,state=_props.state,video=_props.video,videoReadyCallback=_props.videoReadyCallback;var image=this.getImage(photo,iconUrl,audioUrl,video);var sanitizedCaption=this.getCaption(photo);var sanitizedMessage=this.getMessage(message,isModal,isPhone);var sanitizedFullName=this.getFullName(firstName,lastName);var condolenceDetails=this.getCondolenceDetails((0,_formatHelpers.formatDate)(date,'MM\\\\DD\\\\YYYY','MMMM DD, YYYY'),this.getLocation(city,state),image.isTukios?_lodash2.default.get(primaryFuneralHome,'name'):relationship);var hasMedia=_lodash2.default.some(image,Boolean);var id=this.getId(this.props.id);var handleOnKeyDown=isModal||_lodash2.default.isNull(handleClick)?null:_lodash2.default.partial(_componentHelpers.handleAccessibleKeyDown,_lodash2.default,handleClick);var tabIndex=isModal?null:'0';return isAd?_react2.default.createElement('article',{className:this.getCondolenceStyles(isModal,image.isCandle,true),id:id,onKeyDown:handleOnKeyDown,ref:'container',tabIndex:tabIndex},_react2.default.createElement('div',{className:_CondolenceItem2.default.content},_react2.default.createElement(_legacyAdvertising.AdControl,{adService:this.props.adService,adSize:_constants.AD_PGB.adSize,clientLoadOnly:_constants.AD_PGB.clientLoadOnly,maxIdleAdRefreshes:_constants.AD_PGB.maxIdleAdRefreshes,pageName:_constants.AD_PGB.pageName,positionId:_constants.AD_PGB.positionId,slotKeyValues:[{key:'pid',value:sourceId.toString()}],slotName:_constants.AD_PGB.slotName})),_react2.default.createElement('div',{className:_CondolenceItem2.default.clear})):_react2.default.createElement('article',{className:this.getCondolenceStyles(isModal,image.isCandle,false),id:id,onClick:this.handleClick,onKeyDown:handleOnKeyDown,onLoad:this.handleLoadComplete,ref:'container',tabIndex:tabIndex},hasMedia?_react2.default.createElement('figure',{className:this.getFigureStyles(image.isVideo,image.isAudio,image.isCandle,!sanitizedMessage&&image.isCandle)},_react2.default.createElement('div',{className:_CondolenceItem2.default.imageBackground,ref:'figure'},this.getMediaComponents(id,image,audioUrl,video,videoReadyCallback,isModal,_CondolenceItem2.default)),sanitizedCaption?_react2.default.createElement('figcaption',null,_react2.default.createElement('p',{dangerouslySetInnerHTML:{__html:sanitizedCaption}})):null):null,sanitizedMessage?_react2.default.createElement('div',{className:_CondolenceItem2.default.body},hasMedia?null:_react2.default.createElement(_Svgs.CondolenceQuotesIcon,null),_react2.default.createElement('p',{dangerouslySetInnerHTML:{__html:sanitizedMessage}})):null,_react2.default.createElement('div',{className:_CondolenceItem2.default.postInfo},!sanitizedMessage&&!hasMedia&&_react2.default.createElement('p',{className:_CondolenceItem2.default.rememberedBy},'Remembered By'),_react2.default.createElement('div',{className:_CondolenceItem2.default.divider}),sanitizedFullName?_react2.default.createElement('p',{className:_CondolenceItem2.default.name,dangerouslySetInnerHTML:{__html:this.getNameLabel(sanitizedFullName,image.isTukios,image.isServiceVideo)}}):null,_react2.default.createElement('p',{className:_CondolenceItem2.default.details},condolenceDetails)),_react2.default.createElement(_Likes2.default,{condolenceId:condolenceId,likesCount:likesCount,sourceId:sourceId}));}}]);return CondolenceItem;}(_react2.default.Component);/* eslint-disable react/no-danger *//* eslint-disable global-require */CondolenceItem.propTypes={adService:_react2.default.PropTypes.object.isRequired,audioUrl:_react2.default.PropTypes.string,callbacks:_react2.default.PropTypes.object,city:_react2.default.PropTypes.string,condolenceId:_react2.default.PropTypes.number,date:_react2.default.PropTypes.string,firstName:_react2.default.PropTypes.string,handleClick:_react2.default.PropTypes.func,iconUrl:_react2.default.PropTypes.string,id:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number,_react2.default.PropTypes.string]),isAd:_react2.default.PropTypes.bool,isModal:_react2.default.PropTypes.bool,isPhone:_react2.default.PropTypes.bool,lastName:_react2.default.PropTypes.string,likesCount:_react2.default.PropTypes.number,message:_react2.default.PropTypes.string,photo:_react2.default.PropTypes.shape({caption:_react2.default.PropTypes.string,url:_react2.default.PropTypes.string}),primaryFuneralHome:_react2.default.PropTypes.object,relationship:_react2.default.PropTypes.string,sourceId:_react2.default.PropTypes.number,state:_react2.default.PropTypes.shape({code:_react2.default.PropTypes.string,name:_react2.default.PropTypes.string}),video:_react2.default.PropTypes.shape({id:_react2.default.PropTypes.string,url:_react2.default.PropTypes.string}),videoReadyCallback:_react2.default.PropTypes.func};exports.default=CondolenceItem;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var stub = __webpack_require__(1624);
var tracking = __webpack_require__(1625);
var ls = 'localStorage' in global && global.localStorage ? global.localStorage : stub;

function accessor (key, value) {
  if (arguments.length === 1) {
    return get(key);
  }
  return set(key, value);
}

function get (key) {
  return JSON.parse(ls.getItem(key));
}

function set (key, value) {
  try {
    ls.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    return false;
  }
}

function remove (key) {
  return ls.removeItem(key);
}

function clear () {
  return ls.clear();
}

accessor.set = set;
accessor.get = get;
accessor.remove = remove;
accessor.clear = clear;
accessor.on = tracking.on;
accessor.off = tracking.off;

module.exports = accessor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _promise=__webpack_require__(370);var _promise2=_interopRequireDefault(_promise);exports.default=seedHelperFn;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _gatewayFetch=__webpack_require__(178);var _gatewayFetch2=_interopRequireDefault(_gatewayFetch);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Seeds the functions that fetch information from graphQL
 * @param  {function}   template  lodash template function for grahQL request
 * @param  {string}     queryType type of graphQL call 'mutation' or 'query'
 * @param  {function}   request action creator that initiates the request
 * @param  {function}   success action creator that creates the success action
 * @param  {function}   failure action creator that creates the failure action
 * @return {function}   the function to make the call to graphQL
 */function seedHelperFn(template,queryType,request,success,failure){return function(templateParams){return function(dispatch){dispatch(request());var resolver={fetch:function fetch(){return(0,_gatewayFetch2.default)(template(templateParams),queryType).then(function(data){return dispatch(success(data));}).catch(function(reason){return dispatch(failure(reason));});},abort:function abort(){return _promise2.default.resolve(dispatch(failure('no template parameters present')));}};return resolver[_lodash2.default.isEmpty(templateParams)?'abort':'fetch']();};};}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","SourceGroup":"SourceGroup","readFullLink":"readFullLink","sourceWrapper":"sourceWrapper","sourceItem":"sourceItem","imageHolder":"imageHolder","noWrap":"noWrap","ObituaryRight":"ObituaryRight"};

/***/ }),
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(633);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(59);var _reactRouter=__webpack_require__(298);var _reactRedux=__webpack_require__(12);var _Error=__webpack_require__(961);var _Error2=_interopRequireDefault(_Error);var _reactRoutes=__webpack_require__(1000);var _reactRoutes2=_interopRequireDefault(_reactRoutes);var _configureStore=__webpack_require__(1699);var _configureStore2=_interopRequireDefault(_configureStore);var _legacyAdvertising=__webpack_require__(99);var _actions=__webpack_require__(37);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Checks to see if the DOM is ready
 * @param  {function}   fn A callback to run after the DOM is ready.
 * @return {undefined}  returns nothing
 *//* eslint no-process-env:0 */function checkDom(fn){if(document.readyState!=='loading'){fn();}else if(document.addEventListener){document.addEventListener('DOMContentLoaded',fn);}else{document.attachEvent('onreadystatechange',function(){if(document.readyState!=='loading'){fn();}});}}/**
 * Creates the react components with bootstrapped data on the client side.
 * @return {undefined} returns nothing
 */function startup(){var config=(0,_AppConfig2.default)();var renderElement=null;var preloadedState=window.__PRELOADED_STATE__;var hasError=_lodash2.default.get(preloadedState,'errorStore.errorCode',false);var store=(0,_configureStore2.default)(preloadedState);// inject an instance of the AdService
var adService=new _legacyAdvertising.AdService();adService.initialize(config.advertising);store.dispatch({type:_actions.AD_SERVICE,data:{adService:adService}});if(hasError){renderElement=_react2.default.createElement(_reactRedux.Provider,{store:store},_react2.default.createElement(_Error2.default,null));}else{renderElement=_react2.default.createElement(_reactRedux.Provider,{store:store},_react2.default.createElement(_reactRouter.Router,{history:_reactRouter.browserHistory,routes:_reactRoutes2.default}));}(0,_reactDom.render)(renderElement,document.getElementById('root'));}checkDom(startup);

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(634);

__webpack_require__(831);

__webpack_require__(832);

/* eslint max-len: 0 */

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

// Should be removed in the next major release:

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(635);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(726);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(731);
__webpack_require__(732);
__webpack_require__(733);
__webpack_require__(734);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(738);
__webpack_require__(268);
__webpack_require__(739);
__webpack_require__(740);
__webpack_require__(392);
__webpack_require__(741);
__webpack_require__(742);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(745);
__webpack_require__(395);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(758);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
module.exports = __webpack_require__(68);


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(14);
var has = __webpack_require__(49);
var DESCRIPTORS = __webpack_require__(29);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(51);
var META = __webpack_require__(87).KEY;
var $fails = __webpack_require__(17);
var shared = __webpack_require__(180);
var setToStringTag = __webpack_require__(121);
var uid = __webpack_require__(101);
var wks = __webpack_require__(23);
var wksExt = __webpack_require__(375);
var wksDefine = __webpack_require__(248);
var enumKeys = __webpack_require__(636);
var isArray = __webpack_require__(183);
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(18);
var toIObject = __webpack_require__(56);
var toPrimitive = __webpack_require__(69);
var createDesc = __webpack_require__(100);
var _create = __webpack_require__(105);
var gOPNExt = __webpack_require__(378);
var $GOPD = __webpack_require__(57);
var $DP = __webpack_require__(30);
var $keys = __webpack_require__(103);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(106).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(147).f = $propertyIsEnumerable;
  __webpack_require__(182).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(102)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(50)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(103);
var gOPS = __webpack_require__(182);
var pIE = __webpack_require__(147);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(105) });


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(29), 'Object', { defineProperty: __webpack_require__(30).f });


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(29), 'Object', { defineProperties: __webpack_require__(377) });


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(56);
var $getOwnPropertyDescriptor = __webpack_require__(57).f;

__webpack_require__(72)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(38);
var $getPrototypeOf = __webpack_require__(58);

__webpack_require__(72)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(38);
var $keys = __webpack_require__(103);

__webpack_require__(72)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(72)('getOwnPropertyNames', function () {
  return __webpack_require__(378).f;
});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(87).onFreeze;

__webpack_require__(72)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(87).onFreeze;

__webpack_require__(72)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(87).onFreeze;

__webpack_require__(72)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(18);

__webpack_require__(72)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(18);

__webpack_require__(72)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(18);

__webpack_require__(72)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(379) });


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(652) });


/***/ }),
/* 652 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(252).set });


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(148);
var test = {};
test[__webpack_require__(23)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(51)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(380) });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(29) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(58);
var HAS_INSTANCE = __webpack_require__(23)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(30).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(382);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(383);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var has = __webpack_require__(49);
var cof = __webpack_require__(62);
var inheritIfRequired = __webpack_require__(254);
var toPrimitive = __webpack_require__(69);
var fails = __webpack_require__(17);
var gOPN = __webpack_require__(106).f;
var gOPD = __webpack_require__(57).f;
var dP = __webpack_require__(30).f;
var $trim = __webpack_require__(122).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(105)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(29) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(51)(global, NUMBER, $Number);
}


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(71);
var aNumberValue = __webpack_require__(384);
var repeat = __webpack_require__(255);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(17)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(17);
var aNumberValue = __webpack_require__(384);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(14).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(385) });


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(385);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(383);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(382);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(386);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(256);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(257);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(387) });


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(17)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(386) });


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(256) });


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(257);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(17)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(257);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(104);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(56);
var toLength = __webpack_require__(31);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(122)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(258)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(259)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(258)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(31);
var context = __webpack_require__(261);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(262)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(261);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(262)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(255)
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(31);
var context = __webpack_require__(261);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(262)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(52)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(52)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(52)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(52)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(52)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(52)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(52)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(52)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(52)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(52)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(52)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(52)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(52)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(69);

$export($export.P + $export.F * __webpack_require__(17)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(714);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(17);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(51)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(23)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(50)(proto, TO_PRIMITIVE, __webpack_require__(717));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(69);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(183) });


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(61);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(38);
var call = __webpack_require__(388);
var isArrayIter = __webpack_require__(263);
var toLength = __webpack_require__(31);
var createProperty = __webpack_require__(264);
var getIterFn = __webpack_require__(265);

$export($export.S + $export.F * !__webpack_require__(185)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(264);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(17)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(56);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(146) != Object || !__webpack_require__(63)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(251);
var cof = __webpack_require__(62);
var toAbsoluteIndex = __webpack_require__(104);
var toLength = __webpack_require__(31);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(17)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(42);
var toObject = __webpack_require__(38);
var fails = __webpack_require__(17);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(63)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(73)(0);
var STRICT = __webpack_require__(63)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var isArray = __webpack_require__(183);
var SPECIES = __webpack_require__(23)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(73)(1);

$export($export.P + $export.F * !__webpack_require__(63)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(73)(2);

$export($export.P + $export.F * !__webpack_require__(63)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(73)(3);

$export($export.P + $export.F * !__webpack_require__(63)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(73)(4);

$export($export.P + $export.F * !__webpack_require__(63)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(389);

$export($export.P + $export.F * !__webpack_require__(63)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(389);

$export($export.P + $export.F * !__webpack_require__(63)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(181)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(63)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(56);
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(31);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(63)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(390) });

__webpack_require__(88)('copyWithin');


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(267) });

__webpack_require__(88)('fill');


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(73)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(88)(KEY);


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(73)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(88)(KEY);


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107)('Array');


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var inheritIfRequired = __webpack_require__(254);
var dP = __webpack_require__(30).f;
var gOPN = __webpack_require__(106).f;
var isRegExp = __webpack_require__(184);
var $flags = __webpack_require__(186);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(29) && (!CORRECT_NEW || __webpack_require__(17)(function () {
  re2[__webpack_require__(23)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(51)(global, 'RegExp', $RegExp);
}

__webpack_require__(107)('RegExp');


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(392);
var anObject = __webpack_require__(11);
var $flags = __webpack_require__(186);
var DESCRIPTORS = __webpack_require__(29);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(51)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(17)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(187)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(187)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(187)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(187)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(184);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(102);
var global = __webpack_require__(14);
var ctx = __webpack_require__(61);
var classof = __webpack_require__(148);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(18);
var aFunction = __webpack_require__(42);
var anInstance = __webpack_require__(108);
var forOf = __webpack_require__(109);
var speciesConstructor = __webpack_require__(188);
var task = __webpack_require__(269).set;
var microtask = __webpack_require__(270)();
var newPromiseCapabilityModule = __webpack_require__(271);
var perform = __webpack_require__(393);
var promiseResolve = __webpack_require__(394);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(23)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(110)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(121)($Promise, PROMISE);
__webpack_require__(107)(PROMISE);
Wrapper = __webpack_require__(68)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(185)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(399);
var validate = __webpack_require__(124);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(189)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(190);
var buffer = __webpack_require__(272);
var anObject = __webpack_require__(11);
var toAbsoluteIndex = __webpack_require__(104);
var toLength = __webpack_require__(31);
var isObject = __webpack_require__(18);
var ArrayBuffer = __webpack_require__(14).ArrayBuffer;
var speciesConstructor = __webpack_require__(188);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(17)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(107)(ARRAY_BUFFER);


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(190).ABV, {
  DataView: __webpack_require__(272).DataView
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(42);
var anObject = __webpack_require__(11);
var rApply = (__webpack_require__(14).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(17)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(105);
var aFunction = __webpack_require__(42);
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(17);
var bind = __webpack_require__(380);
var rConstruct = (__webpack_require__(14).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(30);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(69);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(17)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(57).f;
var anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(11);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(260)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(58);
var has = __webpack_require__(49);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(11);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(57);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(58);
var anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(11);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(401) });


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(11);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(30);
var gOPD = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(58);
var has = __webpack_require__(49);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(100);
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(18);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(252);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(181)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(88)('includes');


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(402);
var toObject = __webpack_require__(38);
var toLength = __webpack_require__(31);
var aFunction = __webpack_require__(42);
var arraySpeciesCreate = __webpack_require__(266);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(88)('flatMap');


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(402);
var toObject = __webpack_require__(38);
var toLength = __webpack_require__(31);
var toInteger = __webpack_require__(71);
var arraySpeciesCreate = __webpack_require__(266);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(88)('flatten');


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(258)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(403);
var userAgent = __webpack_require__(273);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(403);
var userAgent = __webpack_require__(273);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(122)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(122)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(70);
var toLength = __webpack_require__(31);
var isRegExp = __webpack_require__(184);
var getFlags = __webpack_require__(186);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(260)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(248)('asyncIterator');


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(248)('observable');


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(401);
var toIObject = __webpack_require__(56);
var gOPD = __webpack_require__(57);
var createProperty = __webpack_require__(264);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(404)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(404)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(38);
var aFunction = __webpack_require__(42);
var $defineProperty = __webpack_require__(30);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(29) && $export($export.P + __webpack_require__(191), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(38);
var aFunction = __webpack_require__(42);
var $defineProperty = __webpack_require__(30);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(29) && $export($export.P + __webpack_require__(191), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(58);
var getOwnPropertyDescriptor = __webpack_require__(57).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(29) && $export($export.P + __webpack_require__(191), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(58);
var getOwnPropertyDescriptor = __webpack_require__(57).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(29) && $export($export.P + __webpack_require__(191), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(405)('Map') });


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(405)('Set') });


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(192)('Map');


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(192)('Set');


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(192)('WeakMap');


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(192)('WeakSet');


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(193)('Map');


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(193)('Set');


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(193)('WeakMap');


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(193)('WeakSet');


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(14) });


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(14) });


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(62);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(407);
var fround = __webpack_require__(387);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(407) });


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(68);
var global = __webpack_require__(14);
var speciesConstructor = __webpack_require__(188);
var promiseResolve = __webpack_require__(394);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(271);
var perform = __webpack_require__(393);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(58);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(397);
var from = __webpack_require__(406);
var metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(58);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(58);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(83);
var anObject = __webpack_require__(11);
var aFunction = __webpack_require__(42);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(270)();
var process = __webpack_require__(14).process;
var isNode = __webpack_require__(62)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(14);
var core = __webpack_require__(68);
var microtask = __webpack_require__(270)();
var OBSERVABLE = __webpack_require__(23)('observable');
var aFunction = __webpack_require__(42);
var anObject = __webpack_require__(11);
var anInstance = __webpack_require__(108);
var redefineAll = __webpack_require__(110);
var hide = __webpack_require__(50);
var forOf = __webpack_require__(109);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(107)('Observable');


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(14);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(273);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(269);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(268);
var getKeys = __webpack_require__(103);
var redefine = __webpack_require__(51);
var global = __webpack_require__(14);
var hide = __webpack_require__(50);
var Iterators = __webpack_require__(123);
var wks = __webpack_require__(23);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var hasOwn = Object.prototype.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `value instanceof AwaitArgument` to determine if the yielded value is
  // meant to be awaited. Some may consider the name of this method too
  // cutesy, but they are curmudgeons.
  runtime.awrap = function(arg) {
    return new AwaitArgument(arg);
  };

  function AwaitArgument(arg) {
    this.arg = arg;
  }

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value instanceof AwaitArgument) {
          return Promise.resolve(value.arg).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          if (method === "return" ||
              (method === "throw" && delegate.iterator[method] === undefined)) {
            // A return or throw (when the delegate iterator has no throw
            // method) always terminates the yield* loop.
            context.delegate = null;

            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            var returnMethod = delegate.iterator["return"];
            if (returnMethod) {
              var record = tryCatch(returnMethod, delegate.iterator, arg);
              if (record.type === "throw") {
                // If the return method threw an exception, let that
                // exception prevail over the original return or throw.
                method = "throw";
                arg = record.arg;
                continue;
              }
            }

            if (method === "return") {
              // Continue with the outer return, now that the delegate
              // iterator has been terminated.
              continue;
            }
          }

          var record = tryCatch(
            delegate.iterator[method],
            delegate.iterator,
            arg
          );

          if (record.type === "throw") {
            context.delegate = null;

            // Like returning generator.throw(uncaught), but without the
            // overhead of an extra function call.
            method = "throw";
            arg = record.arg;
            continue;
          }

          // Delegate generator ran and handled its own exceptions so
          // regardless of what the method was, we continue as if it is
          // "next" with an undefined arg.
          method = "next";
          arg = undefined;

          var info = record.arg;
          if (info.done) {
            context[delegate.resultName] = info.value;
            context.next = delegate.nextLoc;
          } else {
            state = GenStateSuspendedYield;
            return info;
          }

          context.delegate = null;
        }

        if (method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = arg;

        } else if (method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw arg;
          }

          if (context.dispatchException(arg)) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            method = "next";
            arg = undefined;
          }

        } else if (method === "return") {
          context.abrupt("return", arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          var info = {
            value: record.arg,
            done: context.done
          };

          if (record.arg === ContinueSentinel) {
            if (context.delegate && method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              arg = undefined;
            }
          } else {
            return info;
          }

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(arg) call above.
          method = "throw";
          arg = record.arg;
        }
      }
    };
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.next = finallyEntry.finallyLoc;
      } else {
        this.complete(record);
      }

      return ContinueSentinel;
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = record.arg;
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(43)))

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(833);
module.exports = __webpack_require__(68).RegExp.escape;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(834)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Error=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _componentHelpers=__webpack_require__(26);var _Error=__webpack_require__(992);var _Error2=_interopRequireDefault(_Error);var _Svgs=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var logoObituaries=__webpack_require__(995);/* eslint-disable react/no-danger*//* eslint curly: 0*/var logoFuneralHomes=__webpack_require__(996);var logoNewspapers=__webpack_require__(997);var logoHistory=__webpack_require__(998);var logoCelebrity=__webpack_require__(999);/**
 * Error page module
 * @class   Person
 * @return  {JSX} Returns the rendered module
 */var Error=exports.Error=function(_React$Component){(0,_inherits3.default)(Error,_React$Component);/**
   * constructs values for the class to use
   * @param  {object}     props - passed in props
   * @return {undefined}  returns nothing
   */function Error(props){(0,_classCallCheck3.default)(this,Error);var _this=(0,_possibleConstructorReturn3.default)(this,(Error.__proto__||(0,_getPrototypeOf2.default)(Error)).call(this,props));_this.state={referrer:'none',IE:0,slim:false};(0,_componentHelpers.bindMethods)(_this,['handleResize','handleGoBack']);return _this;}/**
   * Lifecycle method
   * @return {Undefined} Returns nothing
   */(0,_createClass3.default)(Error,[{key:'componentDidMount',value:function componentDidMount(){var WAIT=500;window.addEventListener('resize',this.handleResize);this.setReferrer();this.checkIE();setTimeout(this.handleResize,WAIT);}/**
   * Remove event listeners.
   * @return {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);}},{key:'checkIE',value:function checkIE(){var undef=null;var div=document.createElement('div');var all=div.getElementsByTagName('i');var version=3;while(div.innerHTML='<!--[if gt IE '+ ++version+']><i></i><![endif]-->',all[0]){}this.setState({IE:version>4?version:undef});}},{key:'setReferrer',value:function setReferrer(){var referrer=document.referrer;if(document.referrer.indexOf('legacy.com')===-1){referrer='none';}this.setState({referrer:referrer});}},{key:'handleResize',value:function handleResize(){var header=this.refs.header.offsetHeight;var content=this.refs.content.offsetHeight;var footer=this.refs.footer.offsetHeight;var body=this.refs.body.offsetHeight;var padding=100;var minWidth=750;if(window.outerWidth>minWidth){if(header+content+footer+padding>body){if(this.state.slim!==true){this.setState({slim:true});}}else if(this.state.slim!==false){this.setState({slim:false});}}}/**
   * Click handler for go back button
   * @return {void} redirects to legacy OR referrer
   */},{key:'handleGoBack',value:function handleGoBack(){window.open(this.state.referrer==='none'?'https://www.legacy.com':this.state.referrer,'_self');}/**
   * React Module render.
   * @return {jsx} Error module rendered.
   */},{key:'render',value:function render(){var _props$mobileDetails=this.props.mobileDetails;_props$mobileDetails=_props$mobileDetails===undefined?{device:false}:_props$mobileDetails;var isAndroid=_props$mobileDetails.android.device;return _react2.default.createElement('div',{className:_Error2.default.Error+(this.state.slim?' '+_Error2.default.slim:'')+(this.state.IE===9?' '+_Error2.default.ie9:''),ref:'body'},_react2.default.createElement('header',{ref:'header'},_react2.default.createElement('div',{className:_Error2.default.content},_react2.default.createElement('a',{href:'https://www.legacy.com'},_react2.default.createElement('span',{className:_Error2.default.logo},_react2.default.createElement(_Svgs.LegacycomIcon,null))),_react2.default.createElement('a',{href:'https://www.legacy.com/ns/obitfinder/obituary-search.aspx'},_react2.default.createElement('div',{className:_Error2.default.searchBtn+(isAndroid?' '+_Error2.default.android:'')+(this.state.IE===9?' '+_Error2.default.ie9:'')},_react2.default.createElement('div',{className:_Error2.default.icon},_react2.default.createElement(_Svgs.SearchIcon,null)),_react2.default.createElement('p',null,'Search'))))),_react2.default.createElement('section',{className:this.state.slim?' '+_Error2.default.slim:' '+_Error2.default.normal,ref:'content'},_react2.default.createElement('div',{className:_Error2.default.content},_react2.default.createElement('h1',null,'We\'re sorry, but this page is not available. The error has been reported to our site, and our best people are investigating.'),_react2.default.createElement('p',null,'Error Code:',' ',_react2.default.createElement('span',{className:_Error2.default.errorCode},this.props.error.errorStore.errorCode)),_react2.default.createElement('p',null,'In the meantime, we invite you to browse obituaries or explore our content.'),_react2.default.createElement('a',{onClick:this.handleGoBack},this.state.referrer==='none'?'Go to Home Page':'Go Back'))),_react2.default.createElement('footer',{ref:'footer'},_react2.default.createElement('ul',null,_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'https://www.legacy.com/obituaries/local'},_react2.default.createElement('img',{src:logoObituaries}),_react2.default.createElement('p',null,'Browse',_react2.default.createElement('br',null),'Obituaries'),_react2.default.createElement('div',{className:_Error2.default.divider}))),_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'https://www.legacy.com/funeral-homes'},_react2.default.createElement('img',{src:logoFuneralHomes}),_react2.default.createElement('p',null,'Browse',_react2.default.createElement('br',null),'Funeral Homes'),_react2.default.createElement('div',{className:_Error2.default.divider}))),_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'https://www.legacy.com/ns/about/newspapers'},_react2.default.createElement('img',{src:logoNewspapers}),_react2.default.createElement('p',null,'Browse',_react2.default.createElement('br',null),'Newspapers'),_react2.default.createElement('div',{className:_Error2.default.divider}))),_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'https://www.legacy.com/news/explore-history'},_react2.default.createElement('img',{src:logoHistory}),_react2.default.createElement('p',null,'Explore',_react2.default.createElement('br',null),'History'),_react2.default.createElement('div',{className:_Error2.default.divider}))),_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'https://www.legacy.com/news/celebrity-deaths'},_react2.default.createElement('img',{src:logoCelebrity}),_react2.default.createElement('p',null,'Celebrity',_react2.default.createElement('br',null),'Deaths'))))));}}]);return Error;}(_react2.default.Component);Error.propTypes={error:_react2.default.PropTypes.object,mobileDetails:_react2.default.PropTypes.object};var mapStateToProps=function mapStateToProps(state){return{error:state.errorStore,mobileDetails:state.mobileDetailsStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Error);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(963);
module.exports = __webpack_require__(35).Object.getPrototypeOf;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(156);
var $getPrototypeOf = __webpack_require__(461);

__webpack_require__(462)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(965);
var $Object = __webpack_require__(35).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(66);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(94), 'Object', { defineProperty: __webpack_require__(86).f });


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(967), __esModule: true };

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158);
__webpack_require__(209);
module.exports = __webpack_require__(316).f('iterator');


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(312);
var defined = __webpack_require__(307);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(313);
var descriptor = __webpack_require__(157);
var setToStringTag = __webpack_require__(208);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(114)(IteratorPrototype, __webpack_require__(45)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(86);
var anObject = __webpack_require__(77);
var getKeys = __webpack_require__(159);

module.exports = __webpack_require__(94) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(134);
var toLength = __webpack_require__(314);
var toAbsoluteIndex = __webpack_require__(972);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(312);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(974);
var step = __webpack_require__(975);
var Iterators = __webpack_require__(133);
var toIObject = __webpack_require__(134);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(466)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(977), __esModule: true };

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(978);
__webpack_require__(473);
__webpack_require__(983);
__webpack_require__(984);
module.exports = __webpack_require__(35).Symbol;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(53);
var has = __webpack_require__(113);
var DESCRIPTORS = __webpack_require__(94);
var $export = __webpack_require__(66);
var redefine = __webpack_require__(467);
var META = __webpack_require__(979).KEY;
var $fails = __webpack_require__(132);
var shared = __webpack_require__(309);
var setToStringTag = __webpack_require__(208);
var uid = __webpack_require__(205);
var wks = __webpack_require__(45);
var wksExt = __webpack_require__(316);
var wksDefine = __webpack_require__(317);
var enumKeys = __webpack_require__(980);
var isArray = __webpack_require__(981);
var anObject = __webpack_require__(77);
var isObject = __webpack_require__(93);
var toIObject = __webpack_require__(134);
var toPrimitive = __webpack_require__(311);
var createDesc = __webpack_require__(157);
var _create = __webpack_require__(313);
var gOPNExt = __webpack_require__(982);
var $GOPD = __webpack_require__(472);
var $DP = __webpack_require__(86);
var $keys = __webpack_require__(159);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(471).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(210).f = $propertyIsEnumerable;
  __webpack_require__(318).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(207)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(114)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(205)('meta');
var isObject = __webpack_require__(93);
var has = __webpack_require__(113);
var setDesc = __webpack_require__(86).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(132)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(159);
var gOPS = __webpack_require__(318);
var pIE = __webpack_require__(210);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(160);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(134);
var gOPN = __webpack_require__(471).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(317)('asyncIterator');


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(317)('observable');


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(986), __esModule: true };

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(987);
module.exports = __webpack_require__(35).Object.setPrototypeOf;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(66);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(988).set });


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(93);
var anObject = __webpack_require__(77);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(131)(Function.call, __webpack_require__(472).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(990), __esModule: true };

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(991);
var $Object = __webpack_require__(35).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(66);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(313) });


/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Error":"Error","ie9":"ie9","content":"content","logo":"logo","searchBtn":"searchBtn","icon":"icon","android":"android","normal":"normal","slim":"slim","errorCode":"errorCode","divider":"divider"};

/***/ }),
/* 993 */,
/* 994 */,
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/obituaries.32b9e9a1.png";

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/funeral_homes.f1936007.png";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/newspapers.f8b8d028.png";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/history.bbc84733.png";

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/celebrity.cab30175.png";

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouter=__webpack_require__(298);var _App=__webpack_require__(1001);var _App2=_interopRequireDefault(_App);var _NotFound=__webpack_require__(1240);var _NotFound2=_interopRequireDefault(_NotFound);var _Planning=__webpack_require__(1242);var _Planning2=_interopRequireDefault(_Planning);var _GeneralPlanning=__webpack_require__(1298);var _GeneralPlanning2=_interopRequireDefault(_GeneralPlanning);var _Search=__webpack_require__(1423);var _Search2=_interopRequireDefault(_Search);var _Profile=__webpack_require__(1425);var _Profile2=_interopRequireDefault(_Profile);var _Person=__webpack_require__(1585);var _Person2=_interopRequireDefault(_Person);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// eslint-disable-next-line
// TODO: currently we load all this code for every app below, this means we load the entire JS tree for each route, this is super inefficient and should be handled on the server side
exports.default=_react2.default.createElement(_reactRouter.Route,{component:_App2.default,path:'/'},_react2.default.createElement(_reactRouter.Route,{component:_GeneralPlanning2.default,path:'/funeral-homes/planning/guide'}),_react2.default.createElement(_reactRouter.Route,{component:_Planning2.default,path:'/funeral-homes/planning(/:sitename)'}),_react2.default.createElement(_reactRouter.Route,{component:_Person2.default,path:'/funeral-homes/obituaries/name/:personName-obituary'}),_react2.default.createElement(_reactRouter.Route,{component:_Profile2.default,path:'/funeral-homes/:state/:city/:fhname/fh-:fhindex'}),_react2.default.createElement(_reactRouter.Route,{component:_Profile2.default,path:'/funeral-homes/:fhname/fh-:fhindex'}),_react2.default.createElement(_reactRouter.Route,{component:_Profile2.default,path:'/beta/funeral-homes/:state/:city/:fhname/fh-:fhindex'}),_react2.default.createElement(_reactRouter.Route,{component:_Profile2.default,path:'/beta/funeral-homes/:fhname/fh-:fhindex'}),_react2.default.createElement(_reactRouter.Route,{component:_Search2.default,path:'/funeral-homes/directory/search'}),_react2.default.createElement(_reactRouter.Route,{component:_Search2.default,path:'/beta/funeral-homes/directory/search'}),_react2.default.createElement(_reactRouter.Route,{component:_NotFound2.default,path:'*'}));

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);__webpack_require__(1002);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _get2=__webpack_require__(135);var _get3=_interopRequireDefault(_get2);var _isEmpty2=__webpack_require__(1028);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _legacyReactNavigation=__webpack_require__(1034);var _library=__webpack_require__(40);var _activateOptimizely=__webpack_require__(1208);var _activateOptimizely2=_interopRequireDefault(_activateOptimizely);var _personPageType=__webpack_require__(67);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var mobileDomain=(0,_AppConfig2.default)().mobileDomain;/**
 * App module - shared
 * @class  App
 */var App=function(_React$Component){(0,_inherits3.default)(App,_React$Component);function App(){(0,_classCallCheck3.default)(this,App);return(0,_possibleConstructorReturn3.default)(this,(App.__proto__||(0,_getPrototypeOf2.default)(App)).apply(this,arguments));}(0,_createClass3.default)(App,[{key:'componentDidMount',/**
   * Lifecycle method
   * @return {undefined} returns nothing
   */value:function componentDidMount(){(0,_activateOptimizely2.default)(0,_activateOptimizely2.default);}/**
   * Renders Component
   * @return {JSX} Rendered App Module
   */},{key:'render',value:function render(){var personPageType=(0,_get3.default)(this.props,'person.personLayout.personPageType');return(0,_personPageType.useLegacyMenus)(personPageType)?_react2.default.createElement('div',null,!(0,_isEmpty3.default)(this.props.headerState)&&_react2.default.createElement(_legacyReactNavigation.Header,{data:this.props.headerState,isMobile:this.props.isMobile,mobileDomain:mobileDomain}),this.props.children,!(0,_isEmpty3.default)(this.props.footerState)&&_react2.default.createElement(_legacyReactNavigation.Footer,{data:this.props.footerState})):_react2.default.createElement('div',null,!(0,_isEmpty3.default)(this.props.headerState)&&_react2.default.createElement(_library.FuneralHomeHeader,{data:this.props.headerState,isMobile:this.props.isMobile}),this.props.children,!(0,_isEmpty3.default)(this.props.footerState)&&_react2.default.createElement(_library.FuneralHomeFooter,{data:this.props.footerState}));}}]);return App;}(_react2.default.Component);App.propTypes={children:_react2.default.PropTypes.object.isRequired,headerState:_react2.default.PropTypes.object.isRequired,footerState:_react2.default.PropTypes.object.isRequired,isMobile:_react2.default.PropTypes.bool.isRequired};App.defaultProps={isMobile:true};var mapStateToProps=function mapStateToProps(state){return{headerState:state.headerStore,footerState:state.footerStore,person:(0,_get3.default)(state,'personStore.person'),isMobile:(0,_get3.default)(state,'mobileDetailsStore').any};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(App);

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly"};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1004),
    toString = __webpack_require__(1026);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(319);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1006),
    ListCache = __webpack_require__(213),
    Map = __webpack_require__(320);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1007),
    hashDelete = __webpack_require__(1012),
    hashGet = __webpack_require__(1013),
    hashHas = __webpack_require__(1014),
    hashSet = __webpack_require__(1015);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(211);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

module.exports = hashClear;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(136),
    isHostObject = __webpack_require__(212),
    isMasked = __webpack_require__(1009),
    isObject = __webpack_require__(54),
    toSource = __webpack_require__(477);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1010);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(47);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

module.exports = hashDelete;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(211);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(211);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(211);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

module.exports = listCacheClear;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(214);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(214);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(214);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(214);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(215);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

module.exports = mapCacheDelete;


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(215);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(215);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(215);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1027);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216),
    isSymbol = __webpack_require__(217);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(321),
    isArguments = __webpack_require__(163),
    isArray = __webpack_require__(46),
    isArrayLike = __webpack_require__(137),
    isBuffer = __webpack_require__(480),
    isFunction = __webpack_require__(136),
    isObjectLike = __webpack_require__(95),
    isPrototype = __webpack_require__(219),
    isString = __webpack_require__(164),
    nativeKeys = __webpack_require__(481);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || isString(value) || isFunction(value.splice) ||
        isArguments(value) || isBuffer(value))) {
    return !value.length;
  }
  if (isObjectLike(value)) {
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) {
      return !value.size;
    }
  }
  var isProto = isPrototype(value);
  for (var key in value) {
    if (hasOwnProperty.call(value, key) &&
        !(isProto && key == 'constructor')) {
      return false;
    }
  }
  return !(nonEnumShadows && nativeKeys(value).length);
}

module.exports = isEmpty;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

module.exports = baseGetTag;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.LegacyReactNavigation=t(require("react")):e.LegacyReactNavigation=t(e.React)}(this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=24)}([function(t,n){t.exports=e},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function a(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function o(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function l(){m&&p&&(m=!1,p.length?h=p.concat(h):v=-1,h.length&&i())}function i(){if(!m){var e=a(l);m=!0;for(var t=h.length;t;){for(p=h,h=[];++v<t;)p&&p[v].run();v=-1,t=h.length}p=null,m=!1,o(e)}}function u(e,t){this.fun=e,this.array=t}function c(){}var s,f,d=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var p,h=[],m=!1,v=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new u(e,t)),1!==h.length||m||a(i)},u.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=c,d.addListener=c,d.once=c,d.off=c,d.removeListener=c,d.removeAllListeners=c,d.emit=c,d.prependListener=c,d.prependOnceListener=c,d.listeners=function(e){return[]},d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){(function(t){if("production"!==t.env.NODE_ENV){var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,a=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r};e.exports=n(26)(a,!0)}else e.exports=n(28)()}).call(t,n(1))},function(e,t){function n(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}e.exports=n},function(e,t){var n=Array.isArray;e.exports=n},function(e,t,n){function r(e,t){for(var n=e.length;n--;)if(a(e[n][0],t))return n;return-1}var a=n(20);e.exports=r},function(e,t,n){function r(e,t,n,r){var l=!n;n||(n={});for(var i=-1,u=t.length;++i<u;){var c=t[i],s=r?r(n[c],e[c],c,n,e):void 0;void 0===s&&(s=e[c]),l?o(n,c,s):a(n,c,s)}return n}var a=n(21),o=n(22);e.exports=r},function(e,t,n){"use strict";function r(e){return function(){return e}}var a=function(){};a.thatReturns=r,a.thatReturnsFalse=r(!1),a.thatReturnsTrue=r(!0),a.thatReturnsNull=r(null),a.thatReturnsThis=function(){return this},a.thatReturnsArgument=function(e){return e},e.exports=a},function(e,t,n){"use strict";(function(t){function n(e,t,n,a,o,l,i,u){if(r(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var s=[n,a,o,l,i,u],f=0;c=new Error(t.replace(/%s/g,function(){return s[f++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var r=function(e){};"production"!==t.env.NODE_ENV&&(r=function(e){if(void 0===e)throw new Error("invariant requires an error message argument")}),e.exports=n}).call(t,n(1))},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t){function n(e,t){return function(n){return e(t(n))}}e.exports=n},function(e,t,n){"use strict";(function(t){var r=n(7),a=r;if("production"!==t.env.NODE_ENV){var o=function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var a=0,o="Warning: "+e.replace(/%s/g,function(){return n[a++]});"undefined"!=typeof console&&console.error(o);try{throw new Error(o)}catch(e){}};a=function(e,t){if(void 0===t)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==t.indexOf("Failed Composite propType: ")&&!e){for(var n=arguments.length,r=Array(n>2?n-2:0),a=2;a<n;a++)r[a-2]=arguments[a];o.apply(void 0,[t].concat(r))}}}e.exports=a}).call(t,n(1))},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"0 0 1100.9 200.9"},this.props),u.default.createElement("path",{d:"M668.1 126c1.7-1.7 3.7-2.5 6.1-2.5s4.4.8 6.1 2.5 2.5 3.7 2.5 6.1-.8 4.4-2.5 6-3.7 2.4-6.1 2.4-4.4-.8-6.1-2.4-2.5-3.6-2.5-6c-.1-2.4.8-4.4 2.5-6.1zm105.8 11.7c-5.4 1.8-11.1 2.7-17.4 2.7-7.3 0-14.1-1.3-20.4-3.9-6.2-2.6-11.6-6.3-16-10.9-4.5-4.6-8-10.1-10.6-16.3s-3.8-12.9-3.8-20.1 1.2-13.9 3.7-20.2 6-11.8 10.5-16.5 9.9-8.4 16.2-11.1c6.2-2.7 13-4.1 20.4-4.1 6.2 0 12 .9 17.4 2.7s10.3 4.2 14.7 7.1l-4.1 6c-4-2.6-8.3-4.7-12.8-6.4-4.6-1.7-9.6-2.5-15.2-2.5-6.4 0-12.2 1.2-17.5 3.5s-9.8 5.4-13.5 9.4c-3.8 3.9-6.7 8.6-8.8 14s-3.1 11.3-3.1 17.5 1 12.1 3.1 17.6 5 10.3 8.8 14.4 8.3 7.3 13.5 9.6a43.4 43.4 0 0 0 17.5 3.5c5.6 0 10.7-.8 15.2-2.5 4.6-1.7 8.8-3.8 12.8-6.4l4.1 6c-4.5 2.7-9.4 5.1-14.7 6.9zm120.2-28.9c-2.5 6.4-5.9 11.9-10.2 16.5s-9.5 8.3-15.5 11-12.5 4.1-19.5 4.1-13.5-1.3-19.4-3.9-11-6.3-15.2-10.9-7.6-10.1-9.9-16.4c-2.4-6.3-3.6-13-3.6-20.2s1.2-13.9 3.7-20.3c2.5-6.3 5.9-11.8 10.2-16.5s9.4-8.4 15.3-11 12.4-3.9 19.4-3.9 13.5 1.3 19.4 3.9 11 6.2 15.3 10.8 7.7 10 10.1 16.3 3.6 13 3.6 20.2c.1 7.2-1.2 14-3.7 20.3zm-7-37.6c-1.9-5.4-4.7-10.1-8.3-14.1s-7.9-7.1-12.9-9.5c-5-2.3-10.6-3.5-16.6-3.5a38.38 38.38 0 0 0-29.3 13c-3.6 4-6.3 8.7-8.3 14.1-1.9 5.4-2.9 11.3-2.9 17.5s1 12.1 2.9 17.6 4.6 10.3 8.1 14.2c3.5 4 7.8 7.2 12.8 9.5s10.6 3.5 16.7 3.5 11.6-1.2 16.5-3.5c5-2.3 9.2-5.5 12.8-9.6s6.4-8.8 8.4-14.3c2-5.4 3-11.3 3-17.5 0-6.1-1-12-2.9-17.4zm170.6.5c0-18.2-7.8-27.3-23.5-27.3-7.2 0-14.1 2.1-20.6 6.2a68.1 68.1 0 0 0-17.5 16.5v71.4h-7.7V71.7c0-18.2-7.8-27.3-23.5-27.3-7.3 0-14.2 2.1-20.5 6.2-6.3 4.2-12.2 9.3-17.6 15.3v72.6h-7.7V39.1h7.4v18.7c2.2-2.5 4.8-5.1 7.7-7.5 2.9-2.5 6-4.7 9.2-6.6 3.3-1.9 6.8-3.5 10.7-4.7 3.8-1.2 7.8-1.8 12-1.8 6.7 0 12.6 1.8 17.7 5.5s8.6 9.4 10.3 17c4.8-6.1 10.8-11.4 18-15.8 7.2-4.5 14.9-6.7 23.2-6.7 4 0 7.8.6 11.4 1.9s6.8 3.3 9.6 6.1 5 6.3 6.6 10.5 2.4 9.3 2.4 15.2v67.6h-7.7V71.7zM0 144.1c8.8-.9 14.5-2.5 17.1-4.7s3.9-7.8 3.9-16.8V26c0-8.5-1.3-14.1-3.9-16.7C14.6 6.7 8.9 5.1 0 4.5V0h67.6v4.5c-8.8.5-14.7 1.9-17.7 4.3s-4.5 7.6-4.5 15.6v105.1c0 2.7.5 4.7 1.3 6.3.9 1.5 2.9 2.5 5.9 2.9 1.8.2 3.7.4 5.7.5s5.7.1 11.2.1c21.3 0 26.5-1.8 34-5.3s14.8-12.5 21.8-26.9h6.1l-11.7 41.5H0v-4.5zm218.2-93.9c8.3 7.6 12.4 18.4 12.4 32.3h-74.3c.8 18.1 4.9 31.2 12.3 39.5 7.4 8.2 16.2 12.4 26.3 12.4 8.2 0 15.1-2.1 20.7-6.4s10.8-10.3 15.6-18.2l4.1 1.4c-3.2 9.9-9.2 19.1-18 27.5s-19.5 12.6-32.2 12.6c-14.7 0-26-5.5-34-16.6s-12-23.8-12-38.3c0-15.7 4.6-29.2 13.9-40.6s21.4-17.1 36.3-17.1c11 .1 20.6 3.9 28.9 11.5zm-56.1 9c-2.5 4.2-4.3 9.5-5.4 15.9h49.4c-.9-7.8-2.3-13.6-4.4-17.4-3.8-6.9-10.2-10.3-19.2-10.3-8.9-.1-15.7 3.9-20.4 11.8zm90.8 37.5c-3.9-6-5.9-12.8-5.9-20.2 0-9.1 3.6-17.8 10.9-26s17.5-12.3 30.8-12.3c5.7 0 12 1.3 18.8 4 6.9 2.7 13.5 4 19.8 4 1.6 0 4.1-.1 7.4-.2s5.7-.2 7.2-.2h1.4v9.5h-20.2c1.4 3.3 2.5 6.1 3.3 8.5 1.3 4.5 2 8.8 2 12.9 0 8.9-3.7 17.1-11.1 24.5-7.4 7.5-17.3 11.2-29.8 11.2-1.9 0-5.5-.3-10.5-1-2.3 0-5.3 1.9-9 5.7s-5.6 6.9-5.6 9.4 2.7 4.3 8.2 5.5c3.6.8 7.6 1.2 12 1.2 20.1 0 33.7 1.1 40.9 3.4 11.8 3.7 17.7 11.5 17.7 23.6 0 12.3-6.9 22.2-20.6 29.5-13.8 7.3-27.7 11-41.7 11-12.8 0-22.9-2.6-30.4-7.8s-11.2-10.6-11.2-16.3c0-2.8 1-5.5 3-8.2s5.9-6.7 11.7-12l7.7-6.9 1.4-1.4c-3.6-1.4-6.2-2.8-8-4.1-3.1-2.4-4.7-5.2-4.7-8.3 0-2.9 1.4-6.1 4-9.5 2.7-3.5 8.4-9.1 17.3-16.9-7.3-2.4-12.8-6.6-16.8-12.6zm12.4 87c7.4 2.5 15.8 3.7 25.3 3.7 12.9 0 23.5-2.2 31.6-6.7s12.2-10 12.2-16.6c0-5.2-3.3-8.7-9.8-10.4-4.1-1-11.8-1.6-23.1-1.8l-9.1-.3c-3.2-.1-6.1-.3-8.8-.4-1.7-.1-4.5-.4-8.3-.9s-6.7-1-8.6-1.4c-.9 0-3.2 2.5-6.8 7.4-3.7 5-5.6 9.6-5.6 13.8 0 6.6 3.7 11.1 11 13.6zm37.2-80.3c4.7-3.7 7-10.3 7-19.5 0-7.4-1.9-15.7-5.7-25S293.7 45 284.9 45c-7.6 0-12.9 3.6-15.8 10.9-1.5 3.8-2.2 8.5-2.2 14.2 0 9.5 2.3 18.1 6.9 25.6 4.6 7.6 10.6 11.3 17.9 11.3 4.3-.1 7.9-1.3 10.8-3.6zm63.8-6.5c7.2-4.7 21.5-11 42.9-19.1v-9.9c0-7.9-.8-13.5-2.3-16.6-2.7-5.2-8.1-7.8-16.5-7.8-4 0-7.8 1-11.4 3-3.6 2.1-5.4 5-5.4 8.7 0 .9.2 2.5.6 4.7s.6 3.6.6 4.3c0 4.4-1.4 7.4-4.3 9.1a11 11 0 0 1-5.9 1.5c-3.5 0-6.2-1.2-8.1-3.5s-2.8-4.9-2.8-7.7c0-5.5 3.4-11.2 10.1-17.1 6.7-6 16.6-9 29.7-9 15.1 0 25.4 4.9 30.8 14.7 2.9 5.4 4.3 13.2 4.3 23.5v46.9c0 4.5.3 7.6.9 9.4 1 3 3.1 4.6 6.3 4.6 1.8 0 3.3-.3 4.4-.8 1.2-.5 3.2-1.9 6.1-4v6.1c-2.5 3-5.2 5.5-8.1 7.5-4.4 3-8.8 4.4-13.3 4.4-5.3 0-9.1-1.7-11.5-5.2-2.4-3.4-3.7-7.5-3.9-12.3-5.9 5.2-11 9-15.2 11.5-7.1 4.2-13.8 6.3-20.2 6.3-6.7 0-12.5-2.4-17.4-7.1s-7.4-10.7-7.4-18c.1-11.1 5.7-20.5 17-28.1zm42.9-13.2c-9 3-16.4 6.2-22.2 9.8-11.2 6.9-16.9 14.8-16.9 23.6 0 7.1 2.3 12.3 7 15.7 3 2.2 6.4 3.3 10.2 3.3 5.1 0 10.1-1.4 14.8-4.3s7.1-6.6 7.1-11V83.7zm122.5-38c7.1 5 10.6 10.5 10.6 16.5 0 2.6-.9 4.9-2.7 7.2-1.8 2.2-4.6 3.3-8.3 3.3-2.7 0-5.1-.9-7.2-2.8s-3.6-4.6-4.5-8.2l-1.4-5.6c-1-4.1-2.8-7.1-5.3-8.8-2.6-1.6-6-2.4-10.2-2.4-8.9 0-16.4 3.9-22.5 11.6-6.1 7.8-9.2 18.1-9.2 31a53 53 0 0 0 10.1 31.7c6.7 9.4 15.9 14.1 27.3 14.1 8.1 0 15.3-2.7 21.6-8 3.6-3 7.6-7.9 12.2-14.5l3.3 2c-4.4 9.4-9.1 16.8-14 22.3-9.4 10.5-20.4 15.7-32.8 15.7-12.2 0-22.9-4.8-32.3-14.4s-14-22.6-14-39.1c0-16.1 5.1-30 15.3-41.6C478 44 490.9 38.2 506.5 38.2c9.7 0 18.1 2.5 25.2 7.5zm14.9-4.7H596v3.3c-3.9.1-6.8.5-8.7 1.1-3.6 1-5.4 3.1-5.4 6.1 0 1.1.2 2.3.6 3.4.4 1.2 1.1 2.9 2.1 5.2l27.1 58.6 22.3-59c.2-.6.6-2.1 1.1-4.3s.8-3.7.8-4.6c0-2.1-.7-3.6-2.1-4.5-1.4-1-3.2-1.5-5.4-1.7l-3.6-.2V41H657v3.3c-3.2.4-5.6 1.5-7.2 3.4-1.6 1.8-3 4.4-4.2 7.7L608.7 153c-6.4 16.9-12.5 29.1-18.4 36.6-5.9 7.6-13.3 11.3-22.2 11.3-4.4 0-8.5-1.1-12.3-3.3s-5.7-5.7-5.7-10.4c0-3.1 1.1-5.7 3.4-7.7s5.1-3 8.6-3c2 0 5 .7 9 2.2s6.8 2.2 8.5 2.2c4.3 0 8.9-5.3 13.6-15.9 4.8-10.6 7.2-17.6 7.2-21 0-.7-.1-1.5-.3-2.5s-.5-1.9-.8-2.7l-36.9-79.7c-2.6-5.8-5-9.6-7-11.4s-4.9-3-8.8-3.6V41zM1075 26.2c0-2.3.6-4.4 1.7-6.5 1.1-2 2.7-3.6 4.7-4.8s4.2-1.7 6.5-1.7 4.4.6 6.5 1.7c2 1.1 3.6 2.7 4.7 4.7 1.2 2 1.7 4.2 1.7 6.5s-.6 4.4-1.7 6.4-2.7 3.6-4.7 4.8-4.2 1.8-6.6 1.8-4.6-.6-6.6-1.8-3.6-2.8-4.7-4.8c-1-1.9-1.5-4-1.5-6.3zm1.6 0c0 2 .5 3.9 1.5 5.7 1 1.7 2.4 3.1 4.1 4.1s3.6 1.5 5.7 1.5a11.3 11.3 0 0 0 9.8-5.6c1-1.7 1.5-3.6 1.5-5.7 0-2-.5-3.9-1.5-5.6s-2.4-3.1-4.1-4.2a10.8 10.8 0 0 0-5.8-1.6 11.29 11.29 0 0 0-9.9 5.7c-.8 1.8-1.3 3.7-1.3 5.7zm15.9-3.2a4.3 4.3 0 0 1-2.6 4l4.1 6.8h-2.1l-3.6-6.2h-2.9v6.2h-1.7V18.7h3.6c1.6 0 2.9.4 3.8 1.1 1 .6 1.4 1.7 1.4 3.2zm-7 3.2h1.9c1 0 1.9-.3 2.5-.8s.9-1.3.9-2.3c0-2-1.1-3-3.4-3h-1.9v6.1z"}))},t}(u.default.Component);t.default=c},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"0 0 30.239 30.239"},this.props),u.default.createElement("path",{d:"M20.2 3.46a11.85 11.85 0 0 0-16.74 0 11.85 11.85 0 0 0 0 16.73c4.1 4.11 10.5 4.55 15.12 1.34.1.46.31.9.67 1.26l6.72 6.72a2.5 2.5 0 1 0 3.53-3.54l-6.71-6.72a2.5 2.5 0 0 0-1.26-.67c3.21-4.61 2.77-11.01-1.34-15.12zm-2.13 14.61A8.84 8.84 0 0 1 5.58 5.58a8.85 8.85 0 0 1 12.5 12.5z"}))},t}(u.default.Component);t.default=c},function(e,t,n){var r=n(31),a=n(35),o=n(39),l=n(40),i=r(function(e,t){var n=l(t,o(i));return a(e,32,void 0,t,n)});i.placeholder={},e.exports=i},function(e,t){function n(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}e.exports=n},function(e,t,n){var r=n(3),a=Object.create,o=function(){function e(){}return function(t){if(!r(t))return{};if(a)return a(t);e.prototype=t;var n=new e;return e.prototype=void 0,n}}();e.exports=o},function(e,t,n){var r=n(37),a="object"==typeof self&&self&&self.Object===Object&&self,o=r||a||Function("return this")();e.exports=o},function(e,t,n){function r(e,t){return a(e)?e:o(e,t)?[e]:l(i(e))}var a=n(4),o=n(48),l=n(50),i=n(52);e.exports=r},function(e,t){function n(e){return e}e.exports=n},function(e,t){function n(e,t){return e===t||e!==e&&t!==t}e.exports=n},function(e,t,n){function r(e,t,n){var r=e[t];i.call(e,t)&&o(r,n)&&(void 0!==n||t in e)||a(e,t,n)}var a=n(22),o=n(20),l=Object.prototype,i=l.hasOwnProperty;e.exports=r},function(e,t,n){function r(e,t,n){"__proto__"==t&&a?a(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n}var a=n(62);e.exports=r},function(e,t,n){var r=n(10),a=r(Object.keys,Object);e.exports=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.AffiliateFooter=t.Header=t.Footer=t.AlphaFooter=void 0;var a=n(25),o=r(a),l=n(30),i=r(l),u=n(45),c=r(u),s=n(99),f=r(s);t.AlphaFooter=o.default,t.Footer=i.default,t.Header=c.default,t.AffiliateFooter=f.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),s=r(c),f=n(2),d=r(f),p=n(29),h=r(p),m=n(12),v=r(m),y=n(13),b=r(y),g=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),r=e.data;r=void 0===r?{}:r;var l=r.data;l=void 0===l?{}:l;var u=l.menu,c=void 0===u?[]:u;return n.state=i({},e.data||{},{menu:c,layout:""}),n.html=s.default.createElement("div",{className:h.default.footerLeftSide},s.default.createElement("p",{className:h.default.footerLogo},s.default.createElement(v.default,null)),s.default.createElement("p",null,"©",(new Date).getFullYear()+" Legacy.com. All rights reserved.")),n.handleBlur=n.handleBlur.bind(n),n.handleFocus=n.handleFocus.bind(n),n.handleMailerSubmit=n.handleMailerSubmit.bind(n),n.handleResize=n.handleResize.bind(n),n.handleSearchSubmit=n.handleSearchSubmit.bind(n),n}return l(t,e),u(t,[{key:"componentDidMount",value:function(){window.addEventListener("resize",this.handleResize),setTimeout(this.handleResize,300)}},{key:"componentWillUnmount",value:function(){window.removeEventListener("resize",this.handleResize)}},{key:"handleBlur",value:function(e){""===e.target.value&&this.setState({showPlaceholder:!0})}},{key:"handleFocus",value:function(){this.setState({showPlaceholder:!1})}},{key:"handleMailerSubmit",value:function(e){e.preventDefault();var t=e.target.mailer.value;window&&window.dataLayer&&window.dataLayer.push({event:"GAEvent",eventCategory:"navigation_footer",eventAction:"footer",eventLabel:"sign_up_and_receive_email_alerts"}),window.open("https://www.legacy.com/obit-messenger/sign-up.aspx?email="+t,"_self")}},{key:"handleResize",value:function(){window.innerWidth>=1100?this.setState({layout:"desktop"}):window.innerWidth<=1e3?this.setState({layout:"mobile"}):this.setState({layout:"tablet"})}},{key:"handleSearchSubmit",value:function(e){e.preventDefault();var t=e.target.search.value;window.open("https://www.legacy.com/search?daterange=Last30Days&keyword="+t,"_self")}},{key:"render",value:function(){var e=this,t=null,n="",r="",a="";return this.state.layout&&"tablet"===this.state.layout?(r=this.html,n=null):this.state.layout&&"mobile"===this.state.layout?(r=this.html,n=null):(r=null,n=this.html),this.state&&0!==this.state.menu.length?s.default.createElement("div",{className:h.default.AlphaFooter},s.default.createElement("div",{className:h.default.firstRow},s.default.createElement("div",{className:h.default.footCol},s.default.createElement("div",{className:h.default.footerSearch},s.default.createElement("form",{onSubmit:this.handleSearchSubmit},s.default.createElement("p",null,s.default.createElement("input",{className:h.default.input,type:"search",name:"search",placeholder:"Keyword Search",onFocus:this.handleFocus,onBlur:this.handleBlur}),s.default.createElement("button",null,s.default.createElement(b.default,null)))))),s.default.createElement("div",{className:h.default.footCol},s.default.createElement("div",{className:h.default.footerNewsletter},s.default.createElement("form",{onSubmit:this.handleMailerSubmit},s.default.createElement("div",{className:h.default.inputWrapper},s.default.createElement("input",{type:"search",name:"mailer",placeholder:"email"})),s.default.createElement("button",null,"Sign Up & Receive Email Alerts"))))),s.default.createElement("div",{className:h.default.secondRow},n,s.default.createElement("div",{className:h.default.footerRightSide},s.default.createElement("nav",{className:h.default.footerNav},this.state.menu.map(function(n,r){return r===Math.floor(e.state.menu.length/2)?(t="navsplit",a=null):(t=null,a=null),s.default.createElement("span",{key:r,className:h.default[t]},s.default.createElement("a",{id:n.name,href:n.url,"data-ga-evt-action":"navigation_footer","data-ga-evt-label":n.name.toLowerCase().split(" ").join("_"),"data-ga-evt-cat":"footer"},n.name),a)})),s.default.createElement("nav",{className:h.default.alphaNav},s.default.createElement("span",null,"People: "),["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"].map(function(e,t){return s.default.createElement("a",{key:t,href:"/directory/people-"+e},e)}))),r)):s.default.createElement("div",null)}}]),t}(s.default.Component);g.propTypes={data:d.default.object,styles:d.default.object},t.default=g},function(e,t,n){"use strict";(function(t){var r=n(7),a=n(8),o=n(11),l=n(9),i=n(27);e.exports=function(e,n){function u(e){var t=e&&(S&&e[S]||e[j]);if("function"==typeof t)return t}function c(e,t){return e===t?0!==e||1/e==1/t:e!==e&&t!==t}function s(e){this.message=e,this.stack=""}function f(e){function r(r,c,f,d,p,h,m){if(d=d||k,h=h||f,m!==l)if(n)a(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==t.env.NODE_ENV&&"undefined"!=typeof console){var v=d+":"+f;!i[v]&&u<3&&(o(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",h,d),i[v]=!0,u++)}return null==c[f]?r?new s(null===c[f]?"The "+p+" `"+h+"` is marked as required in `"+d+"`, but its value is `null`.":"The "+p+" `"+h+"` is marked as required in `"+d+"`, but its value is `undefined`."):null:e(c,f,d,p,h)}if("production"!==t.env.NODE_ENV)var i={},u=0;var c=r.bind(null,!1);return c.isRequired=r.bind(null,!0),c}function d(e){function t(t,n,r,a,o,l){var i=t[n];if(E(i)!==e)return new s("Invalid "+a+" `"+o+"` of type `"+O(i)+"` supplied to `"+r+"`, expected `"+e+"`.");return null}return f(t)}function p(e){function t(t,n,r,a,o){if("function"!=typeof e)return new s("Property `"+o+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var i=t[n];if(!Array.isArray(i)){return new s("Invalid "+a+" `"+o+"` of type `"+E(i)+"` supplied to `"+r+"`, expected an array.")}for(var u=0;u<i.length;u++){var c=e(i,u,r,a,o+"["+u+"]",l);if(c instanceof Error)return c}return null}return f(t)}function h(e){function t(t,n,r,a,o){if(!(t[n]instanceof e)){var l=e.name||k;return new s("Invalid "+a+" `"+o+"` of type `"+_(t[n])+"` supplied to `"+r+"`, expected instance of `"+l+"`.")}return null}return f(t)}function m(e){function n(t,n,r,a,o){for(var l=t[n],i=0;i<e.length;i++)if(c(l,e[i]))return null;return new s("Invalid "+a+" `"+o+"` of value `"+l+"` supplied to `"+r+"`, expected one of "+JSON.stringify(e)+".")}return Array.isArray(e)?f(n):("production"!==t.env.NODE_ENV&&o(!1,"Invalid argument supplied to oneOf, expected an instance of array."),r.thatReturnsNull)}function v(e){function t(t,n,r,a,o){if("function"!=typeof e)return new s("Property `"+o+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var i=t[n],u=E(i);if("object"!==u)return new s("Invalid "+a+" `"+o+"` of type `"+u+"` supplied to `"+r+"`, expected an object.");for(var c in i)if(i.hasOwnProperty(c)){var f=e(i,c,r,a,o+"."+c,l);if(f instanceof Error)return f}return null}return f(t)}function y(e){function n(t,n,r,a,o){for(var i=0;i<e.length;i++){if(null==(0,e[i])(t,n,r,a,o,l))return null}return new s("Invalid "+a+" `"+o+"` supplied to `"+r+"`.")}if(!Array.isArray(e))return"production"!==t.env.NODE_ENV&&o(!1,"Invalid argument supplied to oneOfType, expected an instance of array."),r.thatReturnsNull;for(var a=0;a<e.length;a++){var i=e[a];if("function"!=typeof i)return o(!1,"Invalid argument supplid to oneOfType. Expected an array of check functions, but received %s at index %s.",A(i),a),r.thatReturnsNull}return f(n)}function b(e){function t(t,n,r,a,o){var i=t[n],u=E(i);if("object"!==u)return new s("Invalid "+a+" `"+o+"` of type `"+u+"` supplied to `"+r+"`, expected `object`.");for(var c in e){var f=e[c];if(f){var d=f(i,c,r,a,o+"."+c,l);if(d)return d}}return null}return f(t)}function g(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(g);if(null===t||e(t))return!0;var n=u(t);if(!n)return!1;var r,a=n.call(t);if(n!==t.entries){for(;!(r=a.next()).done;)if(!g(r.value))return!1}else for(;!(r=a.next()).done;){var o=r.value;if(o&&!g(o[1]))return!1}return!0;default:return!1}}function w(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function E(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":w(t,e)?"symbol":t}function O(e){if(void 0===e||null===e)return""+e;var t=E(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function A(e){var t=O(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function _(e){return e.constructor&&e.constructor.name?e.constructor.name:k}var S="function"==typeof Symbol&&Symbol.iterator,j="@@iterator",k="<<anonymous>>",N={array:d("array"),bool:d("boolean"),func:d("function"),number:d("number"),object:d("object"),string:d("string"),symbol:d("symbol"),any:function(){return f(r.thatReturnsNull)}(),arrayOf:p,element:function(){function t(t,n,r,a,o){var l=t[n];if(!e(l)){return new s("Invalid "+a+" `"+o+"` of type `"+E(l)+"` supplied to `"+r+"`, expected a single ReactElement.")}return null}return f(t)}(),instanceOf:h,node:function(){function e(e,t,n,r,a){return g(e[t])?null:new s("Invalid "+r+" `"+a+"` supplied to `"+n+"`, expected a ReactNode.")}return f(e)}(),objectOf:v,oneOf:m,oneOfType:y,shape:b};return s.prototype=Error.prototype,N.checkPropTypes=i,N.PropTypes=N,N}}).call(t,n(1))},function(e,t,n){"use strict";(function(t){function r(e,n,r,u,c){if("production"!==t.env.NODE_ENV)for(var s in e)if(e.hasOwnProperty(s)){var f;try{a("function"==typeof e[s],"%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.",u||"React class",r,s),f=e[s](n,s,u,r,null,l)}catch(e){f=e}if(o(!f||f instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",u||"React class",r,s,typeof f),f instanceof Error&&!(f.message in i)){i[f.message]=!0;var d=c?c():"";o(!1,"Failed %s type: %s%s",r,f.message,null!=d?d:"")}}}if("production"!==t.env.NODE_ENV)var a=n(8),o=n(11),l=n(9),i={};e.exports=r}).call(t,n(1))},function(e,t,n){"use strict";var r=n(7),a=n(8),o=n(9);e.exports=function(){function e(e,t,n,r,l,i){i!==o&&a(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t){e.exports={AlphaFooter:"AlphaFooter",footCol:"footCol",firstRow:"firstRow",footerSearch:"footerSearch",footerNewsletter:"footerNewsletter",inputWrapper:"inputWrapper",secondRow:"secondRow",footSide:"footSide",footerLeftSide:"footerLeftSide",footerRightSide:"footerRightSide",footerNav:"footerNav",alphaNav:"alphaNav",footerLogo:"footerLogo"}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(14),s=r(c),f=n(0),d=r(f),p=n(2),h=r(p),m=n(41),v=r(m),y=n(12),b=r(y),g=n(13),w=r(g),E=n(42),O=r(E),A=n(43),_=r(A),S=n(44),j=r(S),k=[{label:"Facebook",link:"https://www.facebook.com/Legacycom",svg:_.default},{label:"Google_Plus",link:"https://plus.google.com/+legacycom/posts",svg:j.default},{label:"Twitter",link:"https://twitter.com/LegacyObits",svg:O.default}],N=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),r=e.data;r=void 0===r?{}:r;var l=r.Menu;l=void 0===l?{}:l;var u=l.data;u=void 0===u?{}:u;var c=u.menu,s=void 0===c?[]:c,f=r.SubMenu;f=void 0===f?{}:f;var p=f.data;p=void 0===p?{}:p;var h=p.menu,m=void 0===h?[]:h;return n.state=i({},e.data||{},{subMenu:m,menu:s,layout:""}),n.html=d.default.createElement("div",{className:v.default.footerLeftSide},d.default.createElement("p",{className:v.default.footerLogo},d.default.createElement(b.default,null)),d.default.createElement("p",null,"©",(new Date).getFullYear()+" Legacy.com. All rights reserved.")),n.handleBlur=n.handleBlur.bind(n),n.handleFocus=n.handleFocus.bind(n),n.handleFollowClick=n.handleFollowClick.bind(n),n.handleMailerSubmit=n.handleMailerSubmit.bind(n),n.handleResize=n.handleResize.bind(n),n.handleSearchSubmit=n.handleSearchSubmit.bind(n),n}return l(t,e),u(t,[{key:"componentDidMount",value:function(){window.addEventListener("resize",this.handleResize),setTimeout(this.handleResize,300)}},{key:"componentWillUnmount",value:function(){window.removeEventListener("resize",this.handleResize)}},{key:"handleBlur",value:function(e){""===e.target.value&&this.setState({showPlaceholder:!0})}},{key:"handleFocus",value:function(){this.setState({showPlaceholder:!1})}},{key:"handleFollowClick",value:function(e){var t=k[e].label.toLowerCase(),n=k[e].link;window&&window.dataLayer&&window.dataLayer.push({event:"GAEvent",eventCategory:"navigation_footer",eventAction:"footer",eventLabel:t}),window.open(n,"_blank")}},{key:"handleMailerSubmit",value:function(e){e.preventDefault();var t=e.target.mailer.value;window&&window.dataLayer&&window.dataLayer.push({event:"GAEvent",eventCategory:"navigation_footer",eventAction:"footer",eventLabel:"sign_up_and_receive_email_alerts"}),window.open("https://www.legacy.com/obit-messenger/sign-up.aspx?email="+t,"_self")}},{key:"handleResize",value:function(){window.innerWidth>=1100?this.setState({layout:"desktop"}):window.innerWidth<=1e3?this.setState({layout:"mobile"}):this.setState({layout:"tablet"})}},{key:"handleSearchSubmit",value:function(e){e.preventDefault();var t=e.target.search.value;window.open("https://www.legacy.com/search?daterange=Last30Days&keyword="+t,"_self")}},{key:"render",value:function(){var e=this,t=null,n="",r="",a="";return this.state.layout&&"tablet"===this.state.layout?(r=this.html,n=null):this.state.layout&&"mobile"===this.state.layout?(r=this.html,n=null):(r=null,n=this.html),this.state&&0!==this.state.menu.length?d.default.createElement("div",{className:v.default.Footer},d.default.createElement("div",{className:v.default.firstRow},d.default.createElement("div",{className:v.default.footerSearch+" "+v.default.footCol},d.default.createElement("form",{onSubmit:this.handleSearchSubmit},d.default.createElement("p",null,d.default.createElement("input",{className:v.default.input,type:"search",name:"search",placeholder:"Keyword",onFocus:this.handleFocus,onBlur:this.handleBlur}),d.default.createElement("button",null,d.default.createElement(w.default,null))))),d.default.createElement("div",{className:v.default.footerFollow+" "+v.default.footCol},k.map(function(t,n){var r=(0,s.default)(e.handleFollowClick,n),a=t.svg;return d.default.createElement("div",{className:v.default.followSpacer,key:n},d.default.createElement("div",{className:v.default.followIcon,onClick:r},d.default.createElement("span",{className:v.default[t.label]},d.default.createElement(a,null))))})),d.default.createElement("div",{className:v.default.footerNewsletter+" "+v.default.footCol},d.default.createElement("form",{onSubmit:this.handleMailerSubmit},d.default.createElement("div",{className:v.default.inputWrapper},d.default.createElement("input",{type:"search",name:"mailer",placeholder:"email"})),d.default.createElement("button",null,"Sign Up & Receive Email Alerts")))),d.default.createElement("div",{className:v.default.secondRow},n,d.default.createElement("div",{className:v.default.footerRightSide},d.default.createElement("nav",{className:v.default.footerNav},this.state.menu.map(function(n,r){return r===Math.floor(e.state.menu.length/2)?(t="navsplit",a=null):(t=null,a=null),d.default.createElement("span",{key:r},d.default.createElement("span",{className:v.default[t]},d.default.createElement("a",{id:n.name,href:n.url,"data-ga-evt-action":"navigation_footer","data-ga-evt-label":n.name.toLowerCase().split(" ").join("_"),"data-ga-evt-cat":"footer"},n.name.toUpperCase())),a)})),d.default.createElement("nav",{className:v.default.footerLegalNav},this.state.subMenu.map(function(e,t){return d.default.createElement("span",{key:t},d.default.createElement("a",{id:e.name,href:e.url,"data-ga-evt-action":"navigation_footer","data-ga-evt-label":e.name.toLowerCase().split(" ").join("_").replace("&","and"),"data-ga-evt-cat":"footer"},e.name.toUpperCase()))}))),r)):d.default.createElement("div",null)}}]),t}(d.default.Component);N.propTypes={data:h.default.object,styles:h.default.object},t.default=N},function(e,t,n){function r(e,t){return l(o(e,t,a),e+"")}var a=n(32),o=n(33),l=n(34);e.exports=r},function(e,t){function n(e){return e}e.exports=n},function(e,t,n){function r(e,t,n){return t=o(void 0===t?e.length-1:t,0),function(){for(var r=arguments,l=-1,i=o(r.length-t,0),u=Array(i);++l<i;)u[l]=r[t+l];l=-1;for(var c=Array(t+1);++l<t;)c[l]=r[l];return c[t]=n(u),a(e,this,c)}}var a=n(15),o=Math.max;e.exports=r},function(e,t){function n(e){return e}e.exports=n},function(e,t,n){function r(e,t,n,r){function u(){for(var t=-1,o=arguments.length,i=-1,f=r.length,d=Array(f+o),p=this&&this!==l&&this instanceof u?s:e;++i<f;)d[i]=r[i];for(;o--;)d[i++]=arguments[++t];return a(p,c?n:this,d)}var c=t&i,s=o(e);return u}var a=n(15),o=n(36),l=n(17),i=1;e.exports=r},function(e,t,n){function r(e){return function(){var t=arguments;switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);case 5:return new e(t[0],t[1],t[2],t[3],t[4]);case 6:return new e(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new e(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var n=a(e.prototype),r=e.apply(n,t);return o(r)?r:n}}var a=n(16),o=n(3);e.exports=r},function(e,t,n){(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.exports=n}).call(t,n(38))},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t){function n(){}e.exports=n},function(e,t){function n(){return[]}e.exports=n},function(e,t){e.exports={hideMobile:"hideMobile",hideSmallMobile:"hideSmallMobile",srOnly:"srOnly",Footer:"Footer",footCol:"footCol",firstRow:"firstRow",footerSearch:"footerSearch",footerFollow:"footerFollow",followSpacer:"followSpacer",followIcon:"followIcon",Facebook:"Facebook",Twitter:"Twitter",Google_Plus:"Google_Plus",footerNewsletter:"footerNewsletter",inputWrapper:"inputWrapper",secondRow:"secondRow",footSide:"footSide",footerLeftSide:"footerLeftSide",footerRightSide:"footerRightSide",footerNav:"footerNav",navsplit:"navsplit",footerLegalNav:"footerLegalNav",last:"last",footerLogo:"footerLogo"}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"0 0 18.001 18.001"},this.props),u.default.createElement("path",{d:"M15.9 4.01c.8-.5 1.33-1.17 1.6-2.03-.79.42-1.57.7-2.36.86a3.49 3.49 0 0 0-2.66-1.14c-1.04 0-1.92.37-2.64 1.08a3.56 3.56 0 0 0-.96 3.42 9.9 9.9 0 0 1-7.63-3.84A3.7 3.7 0 0 0 2.4 7.3a4.09 4.09 0 0 1-1.65-.47 3.67 3.67 0 0 0 2.94 3.68c-.31.08-.64.12-.98.12-.31 0-.53-.03-.66-.09a3.65 3.65 0 0 0 3.44 2.58A7.2 7.2 0 0 1 .9 14.7c-.42 0-.72 0-.9-.04 1.7 1.1 3.59 1.65 5.68 1.65 2.13 0 4.02-.54 5.67-1.63a10.18 10.18 0 0 0 3.64-3.97c.78-1.56 1.17-3.2 1.17-4.9v-.46A7.79 7.79 0 0 0 18 3.42c-.68.3-1.38.5-2.1.6z"}))},t}(u.default.Component);t.default=c},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"0 0 23.101 23.101"},this.props),u.default.createElement("path",{d:"M8.26 4.46l.06-.93c.04-.48.22-.98.54-1.5.32-.52.84-1 1.56-1.4A6.34 6.34 0 0 1 13.54 0h3.82v4.16h-2.8c-.28 0-.53.1-.77.31-.23.2-.35.4-.35.58v2.6h3.92l-.14 1.47-.16 1.26-.18 1.18h-3.46V23.1H8.26V11.56H5.74V7.64h2.52V4.46z"}))},t}(u.default.Component);t.default=c},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"0 0 96.828 96.827"},this.props),u.default.createElement("path",{d:"M62.62 0h-23.1C29.23 0 22.13 2.26 15.7 7.55c-5.04 4.35-8.05 10.67-8.05 16.91 0 9.62 7.33 19.83 20.91 19.83 1.3 0 2.75-.13 4.03-.25l-.19.46c-.54 1.3-1.06 2.54-1.06 4.47 0 3.75 1.8 6.06 3.56 8.3l.22.28-.4.03c-5.6.38-16.04 1.1-23.67 5.78-9 5.36-9.7 13.15-9.7 15.4 0 9 8.37 18.07 27.08 18.07 21.76 0 33.15-12 33.15-23.87 0-8.77-5.14-13.1-10.6-17.7l-4.6-3.58c-1.43-1.18-3.2-2.64-3.2-5.36 0-2.67 1.77-4.44 3.34-6l.16-.16c4.97-3.91 10.6-8.36 10.6-17.96 0-9.66-6.03-14.65-8.93-17.05h7.66c.1 0 .2-.03.27-.08l6.6-4.15a.5.5 0 0 0-.26-.92zm-28 91.53c-13.27 0-22.18-6.19-22.18-15.41 0-6.02 3.64-10.4 10.82-13 5.75-1.93 13.17-2.03 13.25-2.03 1.25 0 1.89 0 2.89.13 9.28 6.6 13.74 10.07 13.74 16.68 0 8.4-7.1 13.63-18.53 13.63zm-.13-50.77c-11.13 0-15.75-14.64-15.75-22.47 0-3.99.9-7.04 2.77-9.35a11.67 11.67 0 0 1 8.82-4.17C40.55 4.77 46.2 18.51 46.2 28c0 1.5 0 6.06-3.14 9.22a12.91 12.91 0 0 1-8.57 3.54zM94.98 45.22H82.81V33.1a.5.5 0 0 0-.5-.5h-5.23a.5.5 0 0 0-.5.5v12.12h-12.1a.5.5 0 0 0-.5.5v5.3c0 .28.22.5.5.5h12.1v12.21c0 .28.22.5.5.5h5.23a.5.5 0 0 0 .5-.5v-12.2h12.17a.5.5 0 0 0 .5-.5v-5.3a.5.5 0 0 0-.5-.5z"}))},t}(u.default.Component);t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(46),s=r(c),f=n(53),d=r(f),p=n(83),h=r(p),m=n(84),v=r(m),y=n(14),b=r(y),g=n(0),w=r(g),E=n(2),O=r(E),A=n(90),_=r(A),S=n(91),j=r(S),k=n(92),N=r(k),x=n(93),M=r(x),C=n(94),P=r(C),T=n(95),L="navigation_header",z="small",R="large",B=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state=i({},(0,d.default)(e.data)||{},{hoverPosition:0,hoverWidth:0,hoverColor:"#006699",hoverOpacity:0,currentIndex:-1,layout:e.isMobile?z:R,submenuHeight:0,hamburgerActive:!1,mobileMenuHeight:0,mobileSubMenuHeight:0,currentOpenSubMenu:"",currentFinalSubMenu:"",headerWidth:"100%",currentId:"",sticky:{activated:!1,collapsed:!0,previousPageYOffset:0,originalOffsetTop:""}}),n.state.errorState=n.checkData(),n.desktopUrl=n.state.url,n.isAffiliate=n.state.data&&n.state.data.affiliateId>1,(0,T.bindMethods)(n,["clearFinalSubMenu","handleMouseOut","handleHamburgerClick","handleBackdropClick","handleResize","handleScroll","handleMobileSubMenuClick","handleMobileMenuClick"]),n}return l(t,e),u(t,[{key:"componentDidMount",value:function(){if(window&&!(0,h.default)(this.state.data)){if(window.addEventListener("resize",this.handleResize),!this.props.isMobile&&window.innerWidth<850){setTimeout(this.handleResize,500)}this.state.data.allowSticky&&(this.state.sticky.previousPageYOffset=window.pageYOffset,this.state.sticky.originalOffsetTop=this.refs.header.getBoundingClientRect().top,window.addEventListener("scroll",this.handleScroll))}else(0,h.default)(this.state.data)||console.log("data missing for header")}},{key:"componentWillUnmount",value:function(){window.removeEventListener("resize",this.handleResize),window.removeEventListener("scroll",this.handleScroll)}},{key:"checkData",value:function(){var e=(0,s.default)(this.state,"data.menu");if((0,h.default)(e))return{error:!0,message:"no data returned"};for(var t=0;t<e.length;t++)if(e[t].menu)for(var n=0;n<e[t].menu.length;n++)if(!e[t].menu[n].menu)return{error:!0,message:e[t].name};return{}}},{key:"hideLogo",value:function(){return this.state.data.hideLogo}},{key:"getSubMenu",value:function(e,t){var n=this;if(e.menu){var r=function(e,r){var a=Boolean((0,s.default)(e,"breakout",!1));return e.menu?w.default.createElement("div",{key:r,className:_.default.column},w.default.createElement("div",{className:_.default.columnInner+(a?" "+_.default.hasBottom:"")},w.default.createElement("p",{className:_.default.subMenuHeading},e.name.toUpperCase()),w.default.createElement("ul",null,e.menu.map(function(e,r){return w.default.createElement("li",{key:r},w.default.createElement("a",i({href:e.url},(0,T.getAnalyticsTags)(L,n.state.data.menu[t].name,e.name)),e.name))}))),a&&w.default.createElement("div",{className:_.default.bottom},w.default.createElement("a",i({href:e.breakout[0].url,style:{color:n.hoverColor}},(0,T.getAnalyticsTags)(L,e.name,e.breakout[0].name)),e.breakout[0].name," › ")),w.default.createElement("div",{className:_.default.verticalBreak})):w.default.createElement("div",null)};return w.default.createElement("div",{ref:e.name.split(" ")[0].toLowerCase()+"Container",key:t,className:_.default.container+(t===this.state.currentIndex?"":" "+_.default.hidden)},e.menu.map(function(e,t){return r(e,t)}))}return w.default.createElement("div",{ref:e.name.toLowerCase()+"ContainerEmpty",key:t})}},{key:"getMobileSubSection",value:function(e,t){var n=this;if(e.menu){return w.default.createElement("div",{key:1e3*t,className:_.default.subNavContainerOuter,style:{height:e.name.split(" ")[0].toLowerCase()===this.currentId?this.state.mobileSubMenuHeight:0}},w.default.createElement("div",{ref:e.name.split(" ")[0].toLowerCase()+"Container",className:_.default.subNavContainer},e.menu.map(function(t,r){return w.default.createElement("div",{key:r,className:_.default.subNavSection+(""===n.state.currentFinalSubMenu?"":" "+_.default.hidden)},w.default.createElement("a",{onClick:(0,b.default)(n.handleMobileSubMenuClick,e.name.split(" ")[0].toLowerCase()+t.name.split(" ")[0])},t.name.toUpperCase()),w.default.createElement("span",{className:_.default.marker},"›"))})))}return w.default.createElement("div",{key:100*Math.random()})}},{key:"getMobileSecondarySubSections",value:function(e,t){var n=this,r=this.state.currentFinalSubMenu,a=this.state.mobileMenuHeight,o=e.name,l=function(t){return null!==t.mUrl&&"/"!==t.mUrl?t.mUrl:e.url&&0===e.url.indexOf("http")?t.url:n.desktopUrl.concat(t.url)};if(e.menu)return w.default.createElement("div",{key:t+1,className:_.default.secondarySubNavContainerOuter},e.menu.map(function(e,t){var u=o.split(" ")[0].toLowerCase()+e.name.split(" ")[0];return w.default.createElement("div",{key:t+1,className:_.default.finalSubMenu+(u===r?" "+_.default.active:"")},w.default.createElement("div",{className:_.default.default+" "+_.default.backRow+" "+(n.currentId===o.split(" ")[0].toLowerCase()?_.default.active:""),onClick:n.clearFinalSubMenu},w.default.createElement("div",{className:_.default.backBlockArrow}),w.default.createElement("div",{className:_.default.backBlock+" "+(n.currentId===o.split(" ")[0].toLowerCase()?_.default.active:"")},w.default.createElement("p",null,"BACK")),w.default.createElement("h2",null,o.toUpperCase())),e.menu.map(function(e,t){return w.default.createElement("div",{key:t+1,className:_.default.default},e.name&&w.default.createElement("a",i({href:l(e)},(0,T.getAnalyticsTags)(L,o,e.name)),e.name.toUpperCase()))}),w.default.createElement("div",{id:"finalNavFiller",className:_.default.filler,style:{height:a}}))}));return w.default.createElement("div",{key:1e3*Math.random()})}},{key:"handleHamburgerClick",value:function(){var e=!this.state.hamburgerActive;return this.currentId="",this.setState({hamburgerActive:!this.state.hamburgerActive,mobileMenuHeight:e?this.refs.mobileNavInner.offsetHeight:0,mobileSubMenuHeight:0,currentOpenSubMenu:"",currentFinalSubMenu:""}),!1}},{key:"handleBackdropClick",value:function(e){"backdrop"!==e.target.id&&"finalNavFiller"!==e.target.id||this.handleHamburgerClick()}},{key:"handleMobileMenuClick",value:function(e,t,n){var r=0,a="";t?this.state.currentOpenSubMenu!==n.target.id&&(a=n.target.id,r=this.refs[a+"Container"].offsetHeight):window.open(e,"_self"),this.currentId=a,this.setState({hoverPosition:Math.random(),mobileSubMenuHeight:r,mobileMenuHeight:this.state.mobileMenuHeight+r,currentOpenSubMenu:a,currentFinalSubMenu:""})}},{key:"handleMobileSubMenuClick",value:function(e){this.setState({currentFinalSubMenu:e})}},{key:"clearFinalSubMenu",value:function(){this.setState({currentFinalSubMenu:""})}},{key:"closeSubmenu",value:function(){this.setState({submenuHeight:0,hoverOpacity:0,hoverPosition:0})}},{key:"handleMouseOver",value:function(){var e=arguments[0],t=arguments[1],n=e.target.offsetLeft+(0===t?0:18),r=e.target.offsetWidth+(0===t?0:-16),a=0;this.currentId=e.target.id,a=this.refs[this.currentId+"Container"]?""===this.currentId?0:this.refs[this.currentId+"Container"].offsetHeight+20:0,this.setState({submenuHeight:a,currentIndex:t,hoverPosition:n,hoverWidth:r,hoverOpacity:1})}},{key:"handleMouseOut",value:function(e){var t=this.refs.header.offsetHeight+this.refs.submenu.offsetHeight,n=this.refs.header.getBoundingClientRect(),r=n.top+t;(e.clientY>=r||e.clientY<n.top||e.clientX<n.left||e.clientX>n.right)&&this.closeSubmenu()}},{key:"handleResize",value:function(){var e=this.refs.header.offsetWidth;if(window){var t={headerWidth:e};t.layout=window.innerWidth>850?R:z,this.setState(t)}}},{key:"handleScroll",value:function(){var e=this,t=this.state.sticky,n=this.refs.header,r=n.offsetHeight+this.state.sticky.originalOffsetTop>window.pageYOffset,a=t.previousPageYOffset>window.pageYOffset&&t.previousPageYOffset>n.offsetHeight&&0!==window.pageYOffset;if(r)t.collapsed=!1,t.activated=!1;else if(a){t.activated||(t.collapsed=!0,t.activated=!0),setTimeout(function(){n.offsetHeight+n.offsetTop>window.pageYOffset&&(t.activated=!1),t.collapsed=!1,e.setState({sticky:t})},300)}else t.collapsed=!0,this.closeSubmenu();t.previousPageYOffset=window.pageYOffset,this.setState({sticky:t})}},{key:"render",value:function(){var e=this;if((0,v.default)(this.state,"data.menu")){if(this.state.errorState.error)return w.default.createElement("div",{className:_.default.error},w.default.createElement("span",{className:_.default.emphasis},"ERROR: Invalid Nesting"),w.default.createElement("p",null,"Header data structure problem at item: ",this.state.errorState.message,"."));if(this.state.data.variant&&"Alternate1"===this.state.data.variant)return w.default.createElement("div",{ref:"header",className:_.default.HeaderAlternate},w.default.createElement("div",{className:_.default.HeaderLarge+(this.isAffiliate?" "+_.default.formatHeader:"")+(this.hideLogo()?" "+_.default.formatNoLogo:"")+(this.state.sticky.collapsed?" "+_.default.collapse:""),onMouseOut:this.handleMouseOut},w.default.createElement("header",null,w.default.createElement("nav",{className:_.default.mainNav+(this.isAffiliate?" "+_.default.formatNav:"")},w.default.createElement("div",{className:_.default.itemsAlt},this.state.data.menu.map(function(e,t){return w.default.createElement("div",{key:t,className:_.default[e.name.split(" ")[0].toLowerCase()]+" "+_.default.default},w.default.createElement("a",i({id:e.name.split(" ")[0].toLowerCase(),href:e.url},(0,T.getAnalyticsTags)(L,e.name,"top_level")),e.name.toUpperCase()))})),w.default.createElement("div",{className:_.default.searchBtnAlt+" "+_.default.headerElement,onClick:this.handleSearchClick},w.default.createElement("a",i({href:this.state.data.search.url,target:"_self"},(0,T.getAnalyticsTags)(L,"search_icon","top_level")),w.default.createElement("span",null,w.default.createElement(M.default,null))))))));if(this.state.layout===R)return w.default.createElement("div",{ref:"header",className:_.default.Header+(this.state.sticky.activated?" "+_.default.stickyNav:"")},w.default.createElement("div",{style:{width:this.state.headerWidth}},w.default.createElement("div",{className:_.default.HeaderLarge+(this.isAffiliate?" "+_.default.formatHeader:"")+(this.hideLogo()?" "+_.default.formatNoLogo:"")+(this.state.sticky.collapsed?" "+_.default.collapse:""),onMouseOut:this.handleMouseOut},w.default.createElement("header",null,w.default.createElement("div",{className:_.default.logoWrapper+(this.isAffiliate?" "+_.default.affiliateLogo:"")+(this.hideLogo()?" "+_.default.hideLogo:"")},w.default.createElement("a",i({href:this.state.data.logo.url},(0,T.getAnalyticsTags)(L,"logo","top_level")),w.default.createElement("span",{className:_.default.logo},this.isAffiliate?w.default.createElement(N.default,null):w.default.createElement(j.default,null)))),w.default.createElement("nav",{className:_.default.mainNav+(this.isAffiliate?" "+_.default.formatNav:"")},w.default.createElement("div",{className:_.default.items},this.state.data.menu.map(function(t,n){return w.default.createElement("div",{key:n,onMouseOver:function(t){e.handleMouseOver(t,n)},onMouseOut:e.handleMouseOut,className:_.default[t.name.split(" ")[0].toLowerCase()]+" "+_.default.default},w.default.createElement("a",i({id:t.name.split(" ")[0].toLowerCase(),href:t.url},(0,T.getAnalyticsTags)(L,t.name,"top_level")),t.name.toUpperCase()))}))),w.default.createElement("a",i({href:this.state.data.search.url},(0,T.getAnalyticsTags)(L,"search_icon","top_level"),{target:"_self"}),w.default.createElement("div",{className:_.default.searchBtn+" "+_.default.headerElement},w.default.createElement("span",null,w.default.createElement(M.default,null)),w.default.createElement("p",null,"Search"))),w.default.createElement("div",{className:_.default.navBlock,style:{width:this.state.hoverWidth,left:this.state.hoverPosition,backgroundColor:this.hoverColor,opacity:this.state.hoverOpacity}})),w.default.createElement("nav",{ref:"submenu",className:_.default.submenu,style:{height:this.state.submenuHeight,width:this.state.headerWidth}},w.default.createElement("div",{className:_.default.container},this.state.data.menu&&this.state.data.menu.map(function(t,n){return e.getSubMenu(t,n)}))))));if(this.state.layout===z){return w.default.createElement("div",{ref:"header",className:_.default.HeaderSmall,onClick:this.handleBackdropClick},w.default.createElement("div",{id:"backdrop",className:_.default.backDrop,style:{height:this.state.hamburgerActive?"100%":0,opacity:this.state.hamburgerActive?.55:0}}),w.default.createElement("header",null,w.default.createElement("div",{className:_.default.headerTop},w.default.createElement("button",{className:_.default.hamburger+" "+_.default.hamburgerHtx+(this.state.hamburgerActive?" "+_.default.isActive:""),type:"button",onClick:this.handleHamburgerClick},w.default.createElement("span",null)),w.default.createElement("a",i({href:this.state.data.logo.mUrl},(0,T.getAnalyticsTags)(L,"logo","top_level"),{className:_.default.logoWrapper+(this.isAffiliate?" "+_.default.affiliateLogo:"")+(this.hideLogo()?" "+_.default.hideLogo:"")}),w.default.createElement("span",{className:_.default.logo+(this.hideLogo()?" "+_.default.hideLogo:"")},this.isAffiliate?w.default.createElement(N.default,null):w.default.createElement(j.default,null))),w.default.createElement("a",i({className:_.default.searchBtn,href:this.state.data.search.mUrl},(0,T.getAnalyticsTags)(L,"search_icon","top_level"),{target:"_self"}),w.default.createElement("div",{className:_.default.backgroundFill}),w.default.createElement("span",null,w.default.createElement(P.default,null)))),w.default.createElement("div",{ref:"mobileNavOuter",className:_.default.navOuter,style:{height:this.state.mobileMenuHeight}},w.default.createElement("nav",{id:"mainNav",ref:"mobileNavInner",className:_.default.mainNav},w.default.createElement("div",{className:_.default.items+(""===this.state.currentFinalSubMenu?"":" "+_.default.hidden)},this.state.data.menu&&this.state.data.menu.map(function(t,n){return w.default.createElement("div",{key:n},w.default.createElement("div",{className:_.default[t.name.split(" ")[0].toLowerCase()]+" "+_.default.default+(""===e.state.currentFinalSubMenu?"":" "+_.default.hidden)},w.default.createElement("div",{className:_.default.leftIdentifier+" "+_.default[t.name.split(" ")[0].toLowerCase()]}),w.default.createElement("a",i({id:t.name.split(" ")[0].toLowerCase()},(0,T.getAnalyticsTags)(L,e.state.data.menu[n].name,"top_level"),{onClick:(0,b.default)(e.handleMobileMenuClick,t.url,Boolean(t.menu)),className:_.default[t.name.split(" ")[0].toLowerCase()]+(e.currentId===t.name.split(" ")[0].toLowerCase()?" "+_.default.active:"")}),t.name.toUpperCase()),t.menu&&w.default.createElement("span",{className:_.default.marker+(e.currentId===t.name.split(" ")[0].toLowerCase()?" "+_.default.active:"")},"› ")),e.getMobileSubSection(t,n),e.getMobileSecondarySubSections(t,n))}))))))}return w.default.createElement("div",{ref:"header",className:_.default.Header})}var t={display:"none"};return w.default.createElement("div",{style:t},"load error")}}]),t}(w.default.Component);B.propTypes={data:O.default.object,mobileDomain:O.default.string,isMobile:O.default.bool},t.default=B},function(e,t,n){function r(e,t,n){var r=null==e?void 0:a(e,t);return void 0===r?n:r}var a=n(47);e.exports=r},function(e,t,n){function r(e,t){t=a(t,e);for(var n=0,r=t.length;null!=e&&n<r;)e=e[o(t[n++])];return n&&n==r?e:void 0}var a=n(18),o=n(19);e.exports=r},function(e,t,n){function r(e,t){if(a(e))return!1;var n=typeof e;return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=e&&!o(e))||(i.test(e)||!l.test(e)||null!=t&&e in Object(t))}var a=n(4),o=n(49),l=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,i=/^\w*$/;e.exports=r},function(e,t){function n(){return!1}e.exports=n},function(e,t,n){var r=n(51),a=/^\./,o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,l=/\\(\\)?/g,i=r(function(e){var t=[];return a.test(e)&&t.push(""),e.replace(o,function(e,n,r,a){t.push(r?a.replace(l,"$1"):n||e)}),t});e.exports=i},function(e,t){function n(e){return e}e.exports=n},function(e,t){function n(e){return e}e.exports=n},function(e,t,n){function r(e){return a(e,o|l)}var a=n(54),o=1,l=4;e.exports=r},function(e,t,n){function r(e,t,n,C,P,T){var L,z=t&A,R=t&_,B=t&S;if(n&&(L=P?n(e,C,P,T):n(e)),void 0!==L)return L;if(!E(e))return e;var F=g(e);if(F){if(L=v(e),!z)return s(e,L)}else{var H=m(e),V=H==k||H==N;if(w(e))return c(e,z);if(H==x||H==j||V&&!P){if(L=R||V?{}:b(e),!z)return R?d(e,u(L,e)):f(e,i(L,e))}else{if(!M[H])return P?e:{};L=y(e,H,r,z)}}T||(T=new a);var I=T.get(e);if(I)return I;T.set(e,L);var W=B?R?h:p:R?keysIn:O,D=F?void 0:W(e);return o(D||e,function(a,o){D&&(o=a,a=e[o]),l(L,o,r(a,t,n,o,e,T))}),L}var a=n(55),o=n(61),l=n(21),i=n(64),u=n(65),c=n(67),s=n(69),f=n(70),d=n(72),p=n(74),h=n(75),m=n(76),v=n(77),y=n(78),b=n(79),g=n(4),w=n(82),E=n(3),O=n(23),A=1,_=2,S=4,j="[object Arguments]",k="[object Function]",N="[object GeneratorFunction]",x="[object Object]",M={};M[j]=M["[object Array]"]=M["[object ArrayBuffer]"]=M["[object DataView]"]=M["[object Boolean]"]=M["[object Date]"]=M["[object Float32Array]"]=M["[object Float64Array]"]=M["[object Int8Array]"]=M["[object Int16Array]"]=M["[object Int32Array]"]=M["[object Map]"]=M["[object Number]"]=M[x]=M["[object RegExp]"]=M["[object Set]"]=M["[object String]"]=M["[object Symbol]"]=M["[object Uint8Array]"]=M["[object Uint8ClampedArray]"]=M["[object Uint16Array]"]=M["[object Uint32Array]"]=!0,M["[object Error]"]=M[k]=M["[object WeakMap]"]=!1,e.exports=r},function(e,t,n){function r(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}var a=n(56),o=n(57),l=n(58),i=n(59),u=n(60);r.prototype.clear=a,r.prototype.delete=o,r.prototype.get=l,r.prototype.has=i,r.prototype.set=u,e.exports=r},function(e,t){function n(){this.__data__=[],this.size=0}e.exports=n},function(e,t,n){function r(e){var t=this.__data__,n=a(t,e);return!(n<0)&&(n==t.length-1?t.pop():l.call(t,n,1),--this.size,!0)}var a=n(5),o=Array.prototype,l=o.splice;e.exports=r},function(e,t,n){function r(e){var t=this.__data__,n=a(t,e);return n<0?void 0:t[n][1]}var a=n(5);e.exports=r},function(e,t,n){function r(e){return a(this.__data__,e)>-1}var a=n(5);e.exports=r},function(e,t,n){function r(e,t){var n=this.__data__,r=a(n,e);return r<0?(++this.size,n.push([e,t])):n[r][1]=t,this}var a=n(5);e.exports=r},function(e,t){function n(e,t){for(var n=-1,r=null==e?0:e.length;++n<r&&!1!==t(e[n],n,e););return e}e.exports=n},function(e,t,n){var r=n(63),a=function(){try{var e=r(Object,"defineProperty");return e({},"",{}),e}catch(e){}}();e.exports=a},function(e,t){function n(e,t){return null==e?void 0:e[t]}e.exports=n},function(e,t,n){function r(e,t){return e&&a(t,o(t),e)}var a=n(6),o=n(23);e.exports=r},function(e,t,n){function r(e,t){return e&&a(t,o(t),e)}var a=n(6),o=n(66);e.exports=r},function(e,t){function n(e){var t=[];if(null!=e)for(var n in Object(e))t.push(n);return t}e.exports=n},function(e,t,n){(function(e){function r(e,t){if(t)return e.slice();var n=e.length,r=c?c(n):new e.constructor(n);return e.copy(r),r}var a=n(17),o="object"==typeof t&&t&&!t.nodeType&&t,l=o&&"object"==typeof e&&e&&!e.nodeType&&e,i=l&&l.exports===o,u=i?a.Buffer:void 0,c=u?u.allocUnsafe:void 0;e.exports=r}).call(t,n(68)(e))},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t){function n(e,t){var n=-1,r=e.length;for(t||(t=Array(r));++n<r;)t[n]=e[n];return t}e.exports=n},function(e,t,n){function r(e,t){return a(e,o(e),t)}var a=n(6),o=n(71);e.exports=r},function(e,t){function n(){return[]}e.exports=n},function(e,t,n){function r(e,t){return a(e,o(e),t)}var a=n(6),o=n(73);e.exports=r},function(e,t){function n(){return[]}e.exports=n},function(e,t,n){var r=n(10),a=r(Object.keys,Object);e.exports=a},function(e,t){function n(e){var t=[];if(null!=e)for(var n in Object(e))t.push(n);return t}e.exports=n},function(e,t){function n(e){return a.call(e)}var r=Object.prototype,a=r.toString;e.exports=n},function(e,t){function n(e){var t=e.length,n=e.constructor(t);return t&&"string"==typeof e[0]&&a.call(e,"index")&&(n.index=e.index,n.input=e.input),n}var r=Object.prototype,a=r.hasOwnProperty;e.exports=n},function(e,t){function n(e){return e}e.exports=n},function(e,t,n){function r(e){return"function"!=typeof e.constructor||l(e)?{}:a(o(e))}var a=n(16),o=n(80),l=n(81);e.exports=r},function(e,t,n){var r=n(10),a=r(Object.getPrototypeOf,Object);e.exports=a},function(e,t){function n(){return!1}e.exports=n},function(e,t){function n(){return!1}e.exports=n},function(e,t){function n(e){return null==e}e.exports=n},function(e,t,n){function r(e,t){return null!=e&&o(e,t,a)}var a=n(85),o=n(86);e.exports=r},function(e,t){function n(e,t){return null!=e&&a.call(e,t)}var r=Object.prototype,a=r.hasOwnProperty;e.exports=n},function(e,t,n){function r(e,t,n){t=a(t,e);for(var r=-1,s=t.length,f=!1;++r<s;){var d=c(t[r]);if(!(f=null!=e&&n(e,d)))break;e=e[d]}return f||++r!=s?f:!!(s=null==e?0:e.length)&&u(s)&&i(d,s)&&(l(e)||o(e))}var a=n(18),o=n(87),l=n(4),i=n(88),u=n(89),c=n(19);e.exports=r},function(e,t){function n(){return!1}e.exports=n},function(e,t){function n(e,t){return!!(t=null==t?r:t)&&("number"==typeof e||a.test(e))&&e>-1&&e%1==0&&e<t}var r=9007199254740991,a=/^(?:0|[1-9]\d*)$/;e.exports=n},function(e,t){function n(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=r}var r=9007199254740991;e.exports=n},function(e,t){e.exports={hideMobile:"hideMobile",hideSmallMobile:"hideSmallMobile",srOnly:"srOnly",error:"error",emphasis:"emphasis",Header:"Header",HeaderAlternate:"HeaderAlternate",HeaderLarge:"HeaderLarge",mainNav:"mainNav",itemsAlt:"itemsAlt",searchBtnAlt:"searchBtnAlt",HeaderSmall:"HeaderSmall",backDrop:"backDrop",headerTop:"headerTop",hamburger:"hamburger",hamburgerHtx:"hamburgerHtx",isActive:"isActive",logoWrapper:"logoWrapper",affiliateLogo:"affiliateLogo",logo:"logo",hideLogo:"hideLogo",searchBtn:"searchBtn",backgroundFill:"backgroundFill",active:"active",navOuter:"navOuter",items:"items",backRow:"backRow",default:"default",hidden:"hidden",marker:"marker",leftIdentifier:"leftIdentifier",subNavContainerOuter:"subNavContainerOuter",subNavSection:"subNavSection",secondarySubNavContainerOuter:"secondarySubNavContainerOuter",backBlockArrow:"backBlockArrow",backBlock:"backBlock",finalSubMenu:"finalSubMenu",filler:"filler",searchBox:"searchBox",content:"content",obituaries:"obituaries",funeral:"funeral",newspapers:"newspapers",memorials:"memorials",features:"features",sympathy:"sympathy",advice:"advice",formatNav:"formatNav",navBlock:"navBlock",submenu:"submenu",container:"container",column:"column",columnInner:"columnInner",subMenuHeading:"subMenuHeading",bottom:"bottom",verticalBreak:"verticalBreak",formatNoLogo:"formatNoLogo",stickyNav:"stickyNav",collapse:"collapse"}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"0 0 1100.9 200.9"},this.props),u.default.createElement("path",{d:"M668.1 126c1.7-1.7 3.7-2.5 6.1-2.5s4.4.8 6.1 2.5 2.5 3.7 2.5 6.1-.8 4.4-2.5 6-3.7 2.4-6.1 2.4-4.4-.8-6.1-2.4-2.5-3.6-2.5-6c-.1-2.4.8-4.4 2.5-6.1zm105.8 11.7c-5.4 1.8-11.1 2.7-17.4 2.7-7.3 0-14.1-1.3-20.4-3.9-6.2-2.6-11.6-6.3-16-10.9-4.5-4.6-8-10.1-10.6-16.3s-3.8-12.9-3.8-20.1 1.2-13.9 3.7-20.2 6-11.8 10.5-16.5 9.9-8.4 16.2-11.1c6.2-2.7 13-4.1 20.4-4.1 6.2 0 12 .9 17.4 2.7s10.3 4.2 14.7 7.1l-4.1 6c-4-2.6-8.3-4.7-12.8-6.4-4.6-1.7-9.6-2.5-15.2-2.5-6.4 0-12.2 1.2-17.5 3.5s-9.8 5.4-13.5 9.4c-3.8 3.9-6.7 8.6-8.8 14s-3.1 11.3-3.1 17.5 1 12.1 3.1 17.6 5 10.3 8.8 14.4 8.3 7.3 13.5 9.6a43.4 43.4 0 0 0 17.5 3.5c5.6 0 10.7-.8 15.2-2.5 4.6-1.7 8.8-3.8 12.8-6.4l4.1 6c-4.5 2.7-9.4 5.1-14.7 6.9zm120.2-28.9c-2.5 6.4-5.9 11.9-10.2 16.5s-9.5 8.3-15.5 11-12.5 4.1-19.5 4.1-13.5-1.3-19.4-3.9-11-6.3-15.2-10.9-7.6-10.1-9.9-16.4c-2.4-6.3-3.6-13-3.6-20.2s1.2-13.9 3.7-20.3c2.5-6.3 5.9-11.8 10.2-16.5s9.4-8.4 15.3-11 12.4-3.9 19.4-3.9 13.5 1.3 19.4 3.9 11 6.2 15.3 10.8 7.7 10 10.1 16.3 3.6 13 3.6 20.2c.1 7.2-1.2 14-3.7 20.3zm-7-37.6c-1.9-5.4-4.7-10.1-8.3-14.1s-7.9-7.1-12.9-9.5c-5-2.3-10.6-3.5-16.6-3.5a38.38 38.38 0 0 0-29.3 13c-3.6 4-6.3 8.7-8.3 14.1-1.9 5.4-2.9 11.3-2.9 17.5s1 12.1 2.9 17.6 4.6 10.3 8.1 14.2c3.5 4 7.8 7.2 12.8 9.5s10.6 3.5 16.7 3.5 11.6-1.2 16.5-3.5c5-2.3 9.2-5.5 12.8-9.6s6.4-8.8 8.4-14.3c2-5.4 3-11.3 3-17.5 0-6.1-1-12-2.9-17.4zm170.6.5c0-18.2-7.8-27.3-23.5-27.3-7.2 0-14.1 2.1-20.6 6.2a68.1 68.1 0 0 0-17.5 16.5v71.4h-7.7V71.7c0-18.2-7.8-27.3-23.5-27.3-7.3 0-14.2 2.1-20.5 6.2-6.3 4.2-12.2 9.3-17.6 15.3v72.6h-7.7V39.1h7.4v18.7c2.2-2.5 4.8-5.1 7.7-7.5 2.9-2.5 6-4.7 9.2-6.6 3.3-1.9 6.8-3.5 10.7-4.7 3.8-1.2 7.8-1.8 12-1.8 6.7 0 12.6 1.8 17.7 5.5s8.6 9.4 10.3 17c4.8-6.1 10.8-11.4 18-15.8 7.2-4.5 14.9-6.7 23.2-6.7 4 0 7.8.6 11.4 1.9s6.8 3.3 9.6 6.1 5 6.3 6.6 10.5 2.4 9.3 2.4 15.2v67.6h-7.7V71.7z",fill:"#999"}),u.default.createElement("path",{d:"M0 144.1c8.8-.9 14.5-2.5 17.1-4.7s3.9-7.8 3.9-16.8V26c0-8.5-1.3-14.1-3.9-16.7C14.6 6.7 8.9 5.1 0 4.5V0h67.6v4.5c-8.8.5-14.7 1.9-17.7 4.3s-4.5 7.6-4.5 15.6v105.1c0 2.7.5 4.7 1.3 6.3.9 1.5 2.9 2.5 5.9 2.9 1.8.2 3.7.4 5.7.5s5.7.1 11.2.1c21.3 0 26.5-1.8 34-5.3s14.8-12.5 21.8-26.9h6.1l-11.7 41.5H0v-4.5zm218.2-93.9c8.3 7.6 12.4 18.4 12.4 32.3h-74.3c.8 18.1 4.9 31.2 12.3 39.5 7.4 8.2 16.2 12.4 26.3 12.4 8.2 0 15.1-2.1 20.7-6.4s10.8-10.3 15.6-18.2l4.1 1.4c-3.2 9.9-9.2 19.1-18 27.5s-19.5 12.6-32.2 12.6c-14.7 0-26-5.5-34-16.6s-12-23.8-12-38.3c0-15.7 4.6-29.2 13.9-40.6s21.4-17.1 36.3-17.1c11 .1 20.6 3.9 28.9 11.5zm-56.1 9c-2.5 4.2-4.3 9.5-5.4 15.9h49.4c-.9-7.8-2.3-13.6-4.4-17.4-3.8-6.9-10.2-10.3-19.2-10.3-8.9-.1-15.7 3.9-20.4 11.8zm90.8 37.5c-3.9-6-5.9-12.8-5.9-20.2 0-9.1 3.6-17.8 10.9-26s17.5-12.3 30.8-12.3c5.7 0 12 1.3 18.8 4 6.9 2.7 13.5 4 19.8 4 1.6 0 4.1-.1 7.4-.2s5.7-.2 7.2-.2h1.4v9.5h-20.2c1.4 3.3 2.5 6.1 3.3 8.5 1.3 4.5 2 8.8 2 12.9 0 8.9-3.7 17.1-11.1 24.5-7.4 7.5-17.3 11.2-29.8 11.2-1.9 0-5.5-.3-10.5-1-2.3 0-5.3 1.9-9 5.7s-5.6 6.9-5.6 9.4 2.7 4.3 8.2 5.5c3.6.8 7.6 1.2 12 1.2 20.1 0 33.7 1.1 40.9 3.4 11.8 3.7 17.7 11.5 17.7 23.6 0 12.3-6.9 22.2-20.6 29.5-13.8 7.3-27.7 11-41.7 11-12.8 0-22.9-2.6-30.4-7.8s-11.2-10.6-11.2-16.3c0-2.8 1-5.5 3-8.2s5.9-6.7 11.7-12l7.7-6.9 1.4-1.4c-3.6-1.4-6.2-2.8-8-4.1-3.1-2.4-4.7-5.2-4.7-8.3 0-2.9 1.4-6.1 4-9.5 2.7-3.5 8.4-9.1 17.3-16.9-7.3-2.4-12.8-6.6-16.8-12.6zm12.4 87c7.4 2.5 15.8 3.7 25.3 3.7 12.9 0 23.5-2.2 31.6-6.7s12.2-10 12.2-16.6c0-5.2-3.3-8.7-9.8-10.4-4.1-1-11.8-1.6-23.1-1.8l-9.1-.3c-3.2-.1-6.1-.3-8.8-.4-1.7-.1-4.5-.4-8.3-.9s-6.7-1-8.6-1.4c-.9 0-3.2 2.5-6.8 7.4-3.7 5-5.6 9.6-5.6 13.8 0 6.6 3.7 11.1 11 13.6zm37.2-80.3c4.7-3.7 7-10.3 7-19.5 0-7.4-1.9-15.7-5.7-25S293.7 45 284.9 45c-7.6 0-12.9 3.6-15.8 10.9-1.5 3.8-2.2 8.5-2.2 14.2 0 9.5 2.3 18.1 6.9 25.6 4.6 7.6 10.6 11.3 17.9 11.3 4.3-.1 7.9-1.3 10.8-3.6zm63.8-6.5c7.2-4.7 21.5-11 42.9-19.1v-9.9c0-7.9-.8-13.5-2.3-16.6-2.7-5.2-8.1-7.8-16.5-7.8-4 0-7.8 1-11.4 3-3.6 2.1-5.4 5-5.4 8.7 0 .9.2 2.5.6 4.7s.6 3.6.6 4.3c0 4.4-1.4 7.4-4.3 9.1a11 11 0 0 1-5.9 1.5c-3.5 0-6.2-1.2-8.1-3.5s-2.8-4.9-2.8-7.7c0-5.5 3.4-11.2 10.1-17.1 6.7-6 16.6-9 29.7-9 15.1 0 25.4 4.9 30.8 14.7 2.9 5.4 4.3 13.2 4.3 23.5v46.9c0 4.5.3 7.6.9 9.4 1 3 3.1 4.6 6.3 4.6 1.8 0 3.3-.3 4.4-.8 1.2-.5 3.2-1.9 6.1-4v6.1c-2.5 3-5.2 5.5-8.1 7.5-4.4 3-8.8 4.4-13.3 4.4-5.3 0-9.1-1.7-11.5-5.2-2.4-3.4-3.7-7.5-3.9-12.3-5.9 5.2-11 9-15.2 11.5-7.1 4.2-13.8 6.3-20.2 6.3-6.7 0-12.5-2.4-17.4-7.1s-7.4-10.7-7.4-18c.1-11.1 5.7-20.5 17-28.1zm42.9-13.2c-9 3-16.4 6.2-22.2 9.8-11.2 6.9-16.9 14.8-16.9 23.6 0 7.1 2.3 12.3 7 15.7 3 2.2 6.4 3.3 10.2 3.3 5.1 0 10.1-1.4 14.8-4.3s7.1-6.6 7.1-11V83.7zm122.5-38c7.1 5 10.6 10.5 10.6 16.5 0 2.6-.9 4.9-2.7 7.2-1.8 2.2-4.6 3.3-8.3 3.3-2.7 0-5.1-.9-7.2-2.8s-3.6-4.6-4.5-8.2l-1.4-5.6c-1-4.1-2.8-7.1-5.3-8.8-2.6-1.6-6-2.4-10.2-2.4-8.9 0-16.4 3.9-22.5 11.6-6.1 7.8-9.2 18.1-9.2 31a53 53 0 0 0 10.1 31.7c6.7 9.4 15.9 14.1 27.3 14.1 8.1 0 15.3-2.7 21.6-8 3.6-3 7.6-7.9 12.2-14.5l3.3 2c-4.4 9.4-9.1 16.8-14 22.3-9.4 10.5-20.4 15.7-32.8 15.7-12.2 0-22.9-4.8-32.3-14.4s-14-22.6-14-39.1c0-16.1 5.1-30 15.3-41.6C478 44 490.9 38.2 506.5 38.2c9.7 0 18.1 2.5 25.2 7.5zm14.9-4.7H596v3.3c-3.9.1-6.8.5-8.7 1.1-3.6 1-5.4 3.1-5.4 6.1 0 1.1.2 2.3.6 3.4.4 1.2 1.1 2.9 2.1 5.2l27.1 58.6 22.3-59c.2-.6.6-2.1 1.1-4.3s.8-3.7.8-4.6c0-2.1-.7-3.6-2.1-4.5-1.4-1-3.2-1.5-5.4-1.7l-3.6-.2V41H657v3.3c-3.2.4-5.6 1.5-7.2 3.4-1.6 1.8-3 4.4-4.2 7.7L608.7 153c-6.4 16.9-12.5 29.1-18.4 36.6-5.9 7.6-13.3 11.3-22.2 11.3-4.4 0-8.5-1.1-12.3-3.3s-5.7-5.7-5.7-10.4c0-3.1 1.1-5.7 3.4-7.7s5.1-3 8.6-3c2 0 5 .7 9 2.2s6.8 2.2 8.5 2.2c4.3 0 8.9-5.3 13.6-15.9 4.8-10.6 7.2-17.6 7.2-21 0-.7-.1-1.5-.3-2.5s-.5-1.9-.8-2.7l-36.9-79.7c-2.6-5.8-5-9.6-7-11.4s-4.9-3-8.8-3.6V41z",fill:"#069"}),u.default.createElement("path",{d:"M1075 26.2c0-2.3.6-4.4 1.7-6.5 1.1-2 2.7-3.6 4.7-4.8s4.2-1.7 6.5-1.7 4.4.6 6.5 1.7c2 1.1 3.6 2.7 4.7 4.7 1.2 2 1.7 4.2 1.7 6.5s-.6 4.4-1.7 6.4-2.7 3.6-4.7 4.8-4.2 1.8-6.6 1.8-4.6-.6-6.6-1.8-3.6-2.8-4.7-4.8c-1-1.9-1.5-4-1.5-6.3zm1.6 0c0 2 .5 3.9 1.5 5.7 1 1.7 2.4 3.1 4.1 4.1s3.6 1.5 5.7 1.5a11.3 11.3 0 0 0 9.8-5.6c1-1.7 1.5-3.6 1.5-5.7 0-2-.5-3.9-1.5-5.6s-2.4-3.1-4.1-4.2a10.8 10.8 0 0 0-5.8-1.6 11.29 11.29 0 0 0-9.9 5.7c-.8 1.8-1.3 3.7-1.3 5.7zm15.9-3.2a4.3 4.3 0 0 1-2.6 4l4.1 6.8h-2.1l-3.6-6.2h-2.9v6.2h-1.7V18.7h3.6c1.6 0 2.9.4 3.8 1.1 1 .6 1.4 1.7 1.4 3.2zm-7 3.2h1.9c1 0 1.9-.3 2.5-.8s.9-1.3.9-2.3c0-2-1.1-3-3.4-3h-1.9v6.1z",fill:"#999"}))},t}(u.default.Component);t.default=c},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"0 0 192.82 52.03"},this.props),u.default.createElement("path",{d:"M118.36 38.54a1.48 1.48 0 0 0-1.05.42 1.4 1.4 0 0 0-.42 1.05 1.44 1.44 0 0 0 1.47 1.47 1.48 1.48 0 0 0 1.05-.42 1.43 1.43 0 0 0 .42-1.05 1.48 1.48 0 0 0-.42-1.05 1.43 1.43 0 0 0-1.05-.42zM127.33 26.91a7.09 7.09 0 0 1 2.35-1.65 7.75 7.75 0 0 1 3-.6 8 8 0 0 1 2.66.42 12.19 12.19 0 0 1 2.24 1.12l.74-1.05a11.51 11.51 0 0 0-2.56-1.23 9.58 9.58 0 0 0-3-.46 9.05 9.05 0 0 0-6.38 2.66 8.73 8.73 0 0 0-1.81 2.88 9.71 9.71 0 0 0-.63 3.5 9 9 0 0 0 .67 3.5 9.26 9.26 0 0 0 1.86 2.84 7.64 7.64 0 0 0 2.77 1.89 9.11 9.11 0 0 0 3.54.7 9.43 9.43 0 0 0 3-.46 10.87 10.87 0 0 0 2.56-1.26l-.74-1.05a12.19 12.19 0 0 1-2.24 1.12 7.87 7.87 0 0 1-2.66.42 7.75 7.75 0 0 1-3-.6 6.58 6.58 0 0 1-2.35-1.68 8 8 0 0 1-1.54-2.52 8.17 8.17 0 0 1-.56-3.08 8 8 0 0 1 .56-3 7.15 7.15 0 0 1 1.52-2.41zM156.73 28.9a8.62 8.62 0 0 0-1.73-2.84 8 8 0 0 0-2.66-1.89 8.26 8.26 0 0 0-3.36-.7 8.14 8.14 0 0 0-3.36.7 7.77 7.77 0 0 0-2.66 1.93 9.24 9.24 0 0 0-2.42 6.41 9.58 9.58 0 0 0 .63 3.5 8.16 8.16 0 0 0 1.72 2.87 7.55 7.55 0 0 0 2.66 1.89 8.14 8.14 0 0 0 3.36.7 7.79 7.79 0 0 0 3.4-.74 8.41 8.41 0 0 0 2.7-1.93 9.5 9.5 0 0 0 1.79-2.87 9.19 9.19 0 0 0 .63-3.54 10.72 10.72 0 0 0-.7-3.49zm-1.19 6.59a7.67 7.67 0 0 1-1.47 2.51 6.21 6.21 0 0 1-2.24 1.68 7 7 0 0 1-2.87.6A6.72 6.72 0 0 1 143.8 38a7.18 7.18 0 0 1-1.4-2.49 8.9 8.9 0 0 1-.53-3.08 8.71 8.71 0 0 1 .53-3 7.43 7.43 0 0 1 1.44-2.45 6.54 6.54 0 0 1 2.24-1.65 7 7 0 0 1 2.87-.6 7.19 7.19 0 0 1 2.91.6 6.66 6.66 0 0 1 2.24 1.65 6.87 6.87 0 0 1 1.44 2.45 10.68 10.68 0 0 1 .53 3 8.71 8.71 0 0 1-.53 3.06zM185 24.87a4.26 4.26 0 0 0-1.68-1.05 6.29 6.29 0 0 0-2-.35 7.6 7.6 0 0 0-4.06 1.16 10.86 10.86 0 0 0-3.12 2.77 4.67 4.67 0 0 0-1.79-2.94 5.26 5.26 0 0 0-3.08-.95 6.94 6.94 0 0 0-2.1.32 9 9 0 0 0-1.86.81 17 17 0 0 0-1.61 1.16 11.77 11.77 0 0 0-1.33 1.3v-3.28h-1.3v17.35h1.33V28.48a15.73 15.73 0 0 1 3.08-2.66 6.22 6.22 0 0 1 3.57-1.09c2.73 0 4.1 1.61 4.1 4.76v11.64h1.33V28.69a12.38 12.38 0 0 1 3-2.87 6.49 6.49 0 0 1 3.61-1.09c2.73 0 4.1 1.61 4.1 4.76v11.64h1.33V29.36a7.45 7.45 0 0 0-.42-2.66 5.08 5.08 0 0 0-1.1-1.83zM191.66 19.58a2.71 2.71 0 0 0-1.12-.32 2.17 2.17 0 0 0-1.12.32 2.07 2.07 0 0 0-.81.84 2.71 2.71 0 0 0-.32 1.12 2.14 2.14 0 0 0 .28 1.12 2.07 2.07 0 0 0 .81.84 2.28 2.28 0 0 0 2.31 0 2.07 2.07 0 0 0 .81-.84 2.57 2.57 0 0 0 .32-1.12 2.33 2.33 0 0 0-1.16-2zm.56 3a1.86 1.86 0 0 1-.74.74 1.94 1.94 0 0 1-1 .25 1.78 1.78 0 0 1-1-.25 1.86 1.86 0 0 1-.74-.74 1.94 1.94 0 0 1-.25-1 2.88 2.88 0 0 1 .21-1 1.86 1.86 0 0 1 .74-.74 1.94 1.94 0 0 1 1-.25 1.71 1.71 0 0 1 1 .28 1.92 1.92 0 0 1 1 1.72 1.6 1.6 0 0 1-.22.97z",fill:"#999"}),u.default.createElement("path",{d:"M191.2 21.41a.56.56 0 0 0 .14-.42.54.54 0 0 0-.28-.56.94.94 0 0 0-.67-.18h-.63v2.63h.32v-1.09h.53l.63 1.09h.39l-.74-1.19a.8.8 0 0 0 .31-.28zm-.77.18h-.35v-1.1h.35c.39 0 .6.18.6.53 0 .18 0 .32-.18.39a.52.52 0 0 1-.42.17z",fill:"#999"}),u.default.createElement("path",{d:"M18.86 40.36c-1.3.6-2.21.91-5.92.91H11a8.61 8.61 0 0 1-1-.07 1.24 1.24 0 0 1-1-.53 2.46 2.46 0 0 1-.21-1.12V21.23c0-1.4.25-2.31.77-2.73a5.66 5.66 0 0 1 3.08-.74V17H.82v.77c1.54.11 2.56.39 3 .84a4.31 4.31 0 0 1 .7 2.91v16.84c0 1.58-.25 2.56-.7 2.94a5.86 5.86 0 0 1-3 .81v.81h20.84l2-7.22h-1.02c-1.19 2.49-2.45 4.06-3.78 4.66zM38.41 39.31a5.9 5.9 0 0 1-3.61 1.12 6 6 0 0 1-4.59-2.17c-1.3-1.47-2-3.75-2.14-6.9H41a7.34 7.34 0 0 0-2.17-5.64 7.16 7.16 0 0 0-5-2 7.77 7.77 0 0 0-6.34 3 10.71 10.71 0 0 0-2.42 7.08 11 11 0 0 0 2.1 6.66 6.89 6.89 0 0 0 5.92 2.91 7.8 7.8 0 0 0 5.61-2.21 11.24 11.24 0 0 0 3.12-4.8l-.74-.25a10.14 10.14 0 0 1-2.67 3.2zm-9.32-12a3.9 3.9 0 0 1 3.54-2.07A3.45 3.45 0 0 1 36 27a8.65 8.65 0 0 1 .77 3h-8.63a8 8 0 0 1 .95-2.67zM59.22 25h-1.3a9.87 9.87 0 0 1-3.47-.7 8.58 8.58 0 0 0-3.29-.7 6.86 6.86 0 0 0-5.36 2.14 6.62 6.62 0 0 0-1.89 4.52 6.32 6.32 0 0 0 1 3.5 5.39 5.39 0 0 0 2.94 2.21 27 27 0 0 0-3 2.94 2.86 2.86 0 0 0-.7 1.65 1.86 1.86 0 0 0 .85 1.52 7.11 7.11 0 0 0 1.4.74l-.25.25-1.33 1.19a16.89 16.89 0 0 0-2 2.1 2.27 2.27 0 0 0-.53 1.44c0 1 .63 1.93 2 2.84A9 9 0 0 0 49.48 52a15.23 15.23 0 0 0 7.29-1.93c2.42-1.3 3.61-3 3.61-5.15a3.93 3.93 0 0 0-3.08-4.1 28.59 28.59 0 0 0-7.15-.6A9.71 9.71 0 0 1 48 40c-.95-.21-1.44-.53-1.44-.95a2.9 2.9 0 0 1 1-1.65 2.51 2.51 0 0 1 1.58-1 11.93 11.93 0 0 0 1.82.18 7.24 7.24 0 0 0 5.22-1.89 5.94 5.94 0 0 0 1.93-4.27 8.52 8.52 0 0 0-.35-2.24c-.14-.42-.35-.91-.56-1.47h3.5v-1.63h-.25a4.6 4.6 0 0 0-1.23-.08zM47.31 43c.35.07.84.14 1.51.25s1.12.14 1.44.18c.49 0 1 0 1.54.07s1.09 0 1.58 0a21.69 21.69 0 0 1 4 .32c1.12.28 1.72.91 1.72 1.82 0 1.16-.74 2.1-2.14 2.91a11.05 11.05 0 0 1-5.5 1.16 14.29 14.29 0 0 1-4.4-.71 2.4 2.4 0 0 1-1.93-2.38 4.23 4.23 0 0 1 1-2.38c.62-.87 1.04-1.24 1.18-1.24zm6.24-8a3 3 0 0 1-1.89.6 3.55 3.55 0 0 1-3.12-2 8.3 8.3 0 0 1-1.19-4.45 7.27 7.27 0 0 1 .39-2.49 2.72 2.72 0 0 1 2.77-1.89 3.4 3.4 0 0 1 3.29 2.42 11.75 11.75 0 0 1 1 4.38A4.11 4.11 0 0 1 53.55 35zM76.85 40.78a1.12 1.12 0 0 1-1.13-.78 5.6 5.6 0 0 1-.18-1.65V30.2a9.12 9.12 0 0 0-.74-4.1c-.95-1.72-2.73-2.56-5.36-2.56a7.52 7.52 0 0 0-5.19 1.58 4.25 4.25 0 0 0-1.75 3 2.08 2.08 0 0 0 .5 1.31 1.75 1.75 0 0 0 1.4.6 1.9 1.9 0 0 0 1-.25 1.59 1.59 0 0 0 .74-1.58 4.43 4.43 0 0 0-.11-.74 5.52 5.52 0 0 1-.11-.81 1.67 1.67 0 0 1 .95-1.51 4.05 4.05 0 0 1 2-.53c1.47 0 2.42.46 2.87 1.37a7.84 7.84 0 0 1 .39 2.91v1.72a45.79 45.79 0 0 0-7.5 3.33 5.83 5.83 0 0 0-2.94 4.87A4.17 4.17 0 0 0 63 41.94a4.32 4.32 0 0 0 3 1.23A6.84 6.84 0 0 0 69.56 42a16.29 16.29 0 0 0 2.66-2 3.89 3.89 0 0 0 .7 2.14 2.29 2.29 0 0 0 2 .91 4.06 4.06 0 0 0 2.31-.77 6.92 6.92 0 0 0 1.4-1.3V40a4.71 4.71 0 0 1-1.05.7 1.92 1.92 0 0 1-.73.08zm-4.7-9.18V38a2.28 2.28 0 0 1-1.23 2 4.63 4.63 0 0 1-2.59.74 2.93 2.93 0 0 1-1.79-.56 3.19 3.19 0 0 1-1.23-2.73q0-2.31 2.94-4.1a20.42 20.42 0 0 1 3.89-1.72zM93.28 38.85a5.72 5.72 0 0 1-3.75 1.4 5.61 5.61 0 0 1-4.76-2.45A9.37 9.37 0 0 1 83 32.27a8.53 8.53 0 0 1 1.61-5.4 4.88 4.88 0 0 1 3.92-2 3.37 3.37 0 0 1 1.79.42 2.57 2.57 0 0 1 .91 1.54l.25 1a3.12 3.12 0 0 0 .77 1.44 1.69 1.69 0 0 0 1.26.49 1.75 1.75 0 0 0 1.49-.61 1.93 1.93 0 0 0 .46-1.26 3.64 3.64 0 0 0-1.9-2.89 7.42 7.42 0 0 0-4.38-1.3 8.6 8.6 0 0 0-6.76 3 10.6 10.6 0 0 0-2.67 7.3 9.33 9.33 0 0 0 2.45 6.83 7.65 7.65 0 0 0 5.64 2.52 7.43 7.43 0 0 0 5.71-2.73A15.2 15.2 0 0 0 96 36.75l-.56-.35a18.48 18.48 0 0 1-2.16 2.45zM109.78 24.73h.63a1.89 1.89 0 0 1 .95.32.89.89 0 0 1 .39.77 6.49 6.49 0 0 1-.14.81c-.07.39-.18.63-.18.74l-3.89 10.3-4.76-10.23c-.18-.39-.32-.7-.39-.91a1.64 1.64 0 0 1-.11-.6q0-.79.95-1.05a5.35 5.35 0 0 1 1.51-.18v-.56h-8.62v.53a2.85 2.85 0 0 1 1.54.63 6.38 6.38 0 0 1 1.23 2l6.45 13.91a1.73 1.73 0 0 1 .14.46 2 2 0 0 1 0 .42 12.09 12.09 0 0 1-1.26 3.68c-.81 1.86-1.61 2.77-2.38 2.77a5.3 5.3 0 0 1-1.47-.39 5.5 5.5 0 0 0-1.58-.39 2.19 2.19 0 0 0-1.51.53 1.75 1.75 0 0 0-.6 1.33 2 2 0 0 0 1 1.82 4.15 4.15 0 0 0 2.14.56 4.75 4.75 0 0 0 3.89-2 24.53 24.53 0 0 0 3.22-6.38l6.45-17a4.29 4.29 0 0 1 .74-1.33 1.8 1.8 0 0 1 1.26-.6v-.56h-5.61z",fill:"#069"}),u.default.createElement("text",{transform:"translate(0 10.28)",fill:"#ccc"},"Powered By"))},t}(u.default.Component);t.default=c},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"-596 381.8 30.2 30.2"},this.props),u.default.createElement("path",{d:"M-575.8 385.2c-4.6-4.6-12.1-4.6-16.7 0s-4.6 12.1 0 16.7c4.1 4.1 10.5 4.5 15.1 1.3.1.5.3.9.7 1.3l6.7 6.7c1 1 2.6 1 3.5 0 1-1 1-2.6 0-3.5l-6.7-6.7c-.4-.4-.8-.6-1.3-.7 3.2-4.6 2.8-11-1.3-15.1zm-2.1 14.6c-3.4 3.4-9 3.4-12.5 0-3.4-3.4-3.4-9 0-12.5 3.4-3.4 9-3.4 12.5 0 3.4 3.5 3.4 9.1 0 12.5z",fill:"#fff"}))},t}(u.default.Component);t.default=c},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({viewBox:"-596 381.8 30.2 30.2"},this.props),u.default.createElement("path",{d:"M-575.8 385.2c-4.6-4.6-12.1-4.6-16.7 0s-4.6 12.1 0 16.7c4.1 4.1 10.5 4.5 15.1 1.3.1.5.3.9.7 1.3l6.7 6.7c1 1 2.6 1 3.5 0 1-1 1-2.6 0-3.5l-6.7-6.7c-.4-.4-.8-.6-1.3-.7 3.2-4.6 2.8-11-1.3-15.1zm-2.1 14.6c-3.4 3.4-9 3.4-12.5 0-3.4-3.4-3.4-9 0-12.5 3.4-3.4 9-3.4 12.5 0 3.4 3.5 3.4 9.1 0 12.5z",fill:"#069"}))},t}(u.default.Component);t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){var t="";return e&&(t=e.toString().replace(/ /g,"_").replace(/\./g,"").replace("&","and").toLowerCase()),t}function o(e,t,n){return{"data-ga-evt-cat":a(e),"data-ga-evt-action":a(t),"data-ga-evt-label":a(n)}}function l(e,t){(0,u.default)(t,function(t){(0,s.default)(e[t])&&(e[t]=e[t].bind(e))})}Object.defineProperty(t,"__esModule",{value:!0}),t.formatLabelText=a,t.getAnalyticsTags=o,t.bindMethods=l;var i=n(96),u=r(i),c=n(97),s=r(c)},function(e,t){function n(e,t){for(var n=-1,r=null==e?0:e.length;++n<r&&!1!==t(e[n],n,e););return e}e.exports=n},function(e,t,n){function r(e){if(!o(e))return!1;var t=a(e);return t==i||t==u||t==l||t==c}var a=n(98),o=n(3),l="[object AsyncFunction]",i="[object Function]",u="[object GeneratorFunction]",c="[object Proxy]";e.exports=r},function(e,t){function n(e){return a.call(e)}var r=Object.prototype,a=r.toString;e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),c=r(u),s=n(2),f=r(s),d=n(100),p=r(d),h=n(101),m=r(h),v=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.copyrightText=(new Date).getFullYear()+" Legacy.com. All rights reserved.",n}return l(t,e),i(t,[{key:"render",value:function(){return this.props.data.data?c.default.createElement("div",{className:p.default.OuterContainer},c.default.createElement("div",{className:p.default.InnerContainer},c.default.createElement("a",{className:p.default.PoweredByLogo,href:this.props.data.url},c.default.createElement(m.default,null)),c.default.createElement("div",{className:p.default.RightContent},c.default.createElement("nav",{className:p.default.LegalNav},this.props.data.data.menu.map(function(e,t){return c.default.createElement("span",{key:t},c.default.createElement("a",{href:e.url},e.name.toUpperCase()))}),c.default.createElement("p",{className:p.default.Copyright},"© ",this.copyrightText))))):c.default.createElement("div",{ref:"affiliateFooter"})}}]),t}(c.default.Component);v.propTypes={data:f.default.object},t.default=v},function(e,t){e.exports={OuterContainer:"OuterContainer",InnerContainer:"InnerContainer",PoweredByLogo:"PoweredByLogo",RightContent:"RightContent",LegalNav:"LegalNav",Copyright:"Copyright"}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(0),u=function(e){return e&&e.__esModule?e:{default:e}}(i),c=function(e){function t(){return r(this,t),a(this,e.apply(this,arguments))}return o(t,e),t.prototype.render=function(){return u.default.createElement("svg",l({preserveAspectRatio:"xMidYMid",width:"174",height:"23",viewBox:"0 0 174 23"},this.props),u.default.createElement("image",{xlinkHref:"data:image/png;base64,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",x:"3",y:"3",width:"171",height:"18"}))},t}(u.default.Component);t.default=c}])});

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Audio Component
 * @param  {Object} props The passed in props
 * @return {JSX} Audio Component
 */var Audio=function Audio(_ref){var tabIndex=_ref.tabIndex,type=_ref.type,url=_ref.url;return _react2.default.createElement('audio',{controls:true,tabIndex:tabIndex},_react2.default.createElement('source',{src:url,type:type}),'Your browser does not support the audio element.');};Audio.propTypes={tabIndex:_react2.default.PropTypes.string,type:_react2.default.PropTypes.string,url:_react2.default.PropTypes.string.isRequired};Audio.defaultProps={tabIndex:'0',type:'audio/mpeg'};exports.default=Audio;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(324);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _Transition=__webpack_require__(1040);var _Transition2=_interopRequireDefault(_Transition);var _Collapse=__webpack_require__(1043);var _Collapse2=_interopRequireDefault(_Collapse);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Collapse Component
 * @class Collapse
 */var Collapse=function(_React$Component){(0,_inherits3.default)(Collapse,_React$Component);/**
   * Collapse component constructor
   * @param  {object}     props passed in properties
   * @return {undefined}  returns nothing
   */function Collapse(props){(0,_classCallCheck3.default)(this,Collapse);var _this=(0,_possibleConstructorReturn3.default)(this,(Collapse.__proto__||(0,_getPrototypeOf2.default)(Collapse)).call(this,props));_this.handleEnter=_this.handleEnter.bind(_this);_this.handleEntered=_this.handleEntered.bind(_this);_this.handleEntering=_this.handleEntering.bind(_this);_this.handleExit=_this.handleExit.bind(_this);_this.handleExiting=_this.handleExiting.bind(_this);return _this;}/**
   * Callback for when entering begins
   * @param  {element}    elem the animated element
   * @return {undefined}  returns nothing
   */(0,_createClass3.default)(Collapse,[{key:'handleEnter',value:function handleEnter(elem){elem.style.height='0';if(_lodash2.default.isFunction(this.props.onEnter)){this.props.onEnter();}}/**
   * Callback for when entering ends
   * @param  {element}    elem The animated element
   * @return {undefined}  returns nothing
   */},{key:'handleEntered',value:function handleEntered(elem){elem.style.height=null;if(_lodash2.default.isFunction(this.props.onEntered)){this.props.onEntered();}}/**
   * Callback for when entering
   * @param  {element}    elem the animated element
   * @return {undefined}  returns nothing
   */},{key:'handleEntering',value:function handleEntering(elem){elem.style.height=elem.scrollHeight+'px';if(_lodash2.default.isFunction(this.props.onEntering)){this.props.onEntering();}}/**
   * Callback for when exiting begins
   * @param  {element}    elem the animated element
   * @return {undefined}  returns nothing
   */},{key:'handleExit',value:function handleExit(elem){var height=elem.offsetHeight+elem.style.marginTop+elem.style.marginBottom;elem.style.height=height+'px';if(_lodash2.default.isFunction(this.props.onExit)){this.props.onExit();}}/**
   * Callback for when exiting
   * @param  {element}    elem        the animated element
   * @param  {number}     baseHeight  minimum starting height
   * @return {undefined}  Returns nothing
   */},{key:'handleExiting',value:function handleExiting(elem,baseHeight){// eslint-disable-next-line no-unused-expressions
elem.offsetHeight;elem.style.height=baseHeight+'px';if(_lodash2.default.isFunction(this.props.onExiting)){this.props.onExiting();}}/**
   * React component render
   * @return {JSX} Collapse rendered
   */},{key:'render',value:function render(){var _props=this.props,baseHeight=_props.baseHeight,rest=(0,_objectWithoutProperties3.default)(_props,['baseHeight']);var exitingClasses=baseHeight?_Collapse2.default.Collapse+' '+_Collapse2.default.teaser:_Collapse2.default.Collapse;return _react2.default.createElement(_Transition2.default,(0,_extends3.default)({},rest,{enteredClassName:_Collapse2.default.in,enteringClassName:_Collapse2.default.collapsing,exitedClassName:exitingClasses,exitingClassName:_Collapse2.default.collapsing,onEnter:this.handleEnter,onEntered:this.handleEntered,onEntering:this.handleEntering,onExit:this.handleExit,onExiting:_lodash2.default.partial(this.handleExiting,_lodash2.default,this.props.baseHeight)}));}}]);return Collapse;}(_react2.default.Component);Collapse.propTypes={ariaRole:_react2.default.PropTypes.string,baseHeight:_react2.default.PropTypes.number,children:_react2.default.PropTypes.node,in:_react2.default.PropTypes.bool,onEnter:_react2.default.PropTypes.func,onEntered:_react2.default.PropTypes.func,onEntering:_react2.default.PropTypes.func,onExit:_react2.default.PropTypes.func,onExited:_react2.default.PropTypes.func,onExiting:_react2.default.PropTypes.func,timeout:_react2.default.PropTypes.number,transitionAppear:_react2.default.PropTypes.bool,unmountOnExit:_react2.default.PropTypes.bool};Collapse.defaultProps={baseHeight:0,in:false,timeout:300,transitionAppear:false,unmountOnExit:false};exports.default=Collapse;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1038);
module.exports = __webpack_require__(35).Object.assign;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(66);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1039) });


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(159);
var gOPS = __webpack_require__(318);
var pIE = __webpack_require__(210);
var toObject = __webpack_require__(156);
var IObject = __webpack_require__(469);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(132)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(59);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _properties = __webpack_require__(1041);

var _properties2 = _interopRequireDefault(_properties);

var _on = __webpack_require__(1042);

var _on2 = _interopRequireDefault(_on);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var transitionEndEvent = _properties2.default.end;

var UNMOUNTED = exports.UNMOUNTED = 0;
var EXITED = exports.EXITED = 1;
var ENTERING = exports.ENTERING = 2;
var ENTERED = exports.ENTERED = 3;
var EXITING = exports.EXITING = 4;

/**
 * The Transition component lets you define and run css transitions with a simple declarative api.
 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
 * but is specifically optimized for transitioning a single child "in" or "out".
 *
 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
 * The extensive set of lifecyle callbacks means you have control over
 * the transitioning now at each step of the way.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Transition).call(this, props, context));

    var initialStatus = void 0;
    if (props.in) {
      // Start enter transition in componentDidMount.
      initialStatus = props.transitionAppear ? EXITED : ENTERED;
    } else {
      initialStatus = props.unmountOnExit ? UNMOUNTED : EXITED;
    }
    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  _createClass(Transition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.transitionAppear && this.props.in) {
        this.performEnter(this.props);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.in && this.props.unmountOnExit) {
        if (this.state.status === UNMOUNTED) {
          // Start enter transition in componentDidUpdate.
          this.setState({ status: EXITED });
        }
      } else {
        this._needsUpdate = true;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var status = this.state.status;

      if (this.props.unmountOnExit && status === EXITED) {
        // EXITED is always a transitional state to either ENTERING or UNMOUNTED
        // when using unmountOnExit.
        if (this.props.in) {
          this.performEnter(this.props);
        } else {
          this.setState({ status: UNMOUNTED });
        }

        return;
      }

      // guard ensures we are only responding to prop changes
      if (this._needsUpdate) {
        this._needsUpdate = false;

        if (this.props.in) {
          if (status === EXITING) {
            this.performEnter(this.props);
          } else if (status === EXITED) {
            this.performEnter(this.props);
          }
          // Otherwise we're already entering or entered.
        } else {
          if (status === ENTERING || status === ENTERED) {
            this.performExit(this.props);
          }
          // Otherwise we're already exited or exiting.
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cancelNextCallback();
    }
  }, {
    key: 'performEnter',
    value: function performEnter(props) {
      var _this2 = this;

      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      // Not this.props, because we might be about to receive new props.
      props.onEnter(node);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node);

        _this2.onTransitionEnd(node, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node);
          });
        });
      });
    }
  }, {
    key: 'performExit',
    value: function performExit(props) {
      var _this3 = this;

      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      // Not this.props, because we might be about to receive new props.
      props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    }
  }, {
    key: 'cancelNextCallback',
    value: function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    }
  }, {
    key: 'safeSetState',
    value: function safeSetState(nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      this.setState(nextState, this.setNextCallback(callback));
    }
  }, {
    key: 'setNextCallback',
    value: function setNextCallback(callback) {
      var _this4 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this4.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    }
  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd(node, handler) {
      this.setNextCallback(handler);

      if (node) {
        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
        setTimeout(this.nextCallback, this.props.timeout);
      } else {
        setTimeout(this.nextCallback, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props;
      var children = _props.children;
      var className = _props.className;

      var childProps = _objectWithoutProperties(_props, ['children', 'className']);

      Object.keys(Transition.propTypes).forEach(function (key) {
        return delete childProps[key];
      });

      var transitionClassName = void 0;
      if (status === EXITED) {
        transitionClassName = this.props.exitedClassName;
      } else if (status === ENTERING) {
        transitionClassName = this.props.enteringClassName;
      } else if (status === ENTERED) {
        transitionClassName = this.props.enteredClassName;
      } else if (status === EXITING) {
        transitionClassName = this.props.exitingClassName;
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, _extends({}, childProps, {
        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
      }));
    }
  }]);

  return Transition;
}(_react2.default.Component);

Transition.propTypes = {
  /**
   * Show the component; triggers the enter or exit animation
   */
  in: _react2.default.PropTypes.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is not shown
   */
  unmountOnExit: _react2.default.PropTypes.bool,

  /**
   * Run the enter animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: _react2.default.PropTypes.bool,

  /**
   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
   * transition indefinately if the browser transitionEnd events are
   * canceled or interrupted.
   *
   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
   * setting this to the duration of your animation (or a bit above it).
   */
  timeout: _react2.default.PropTypes.number,

  /**
   * CSS class or classes applied when the component is exited
   */
  exitedClassName: _react2.default.PropTypes.string,
  /**
   * CSS class or classes applied while the component is exiting
   */
  exitingClassName: _react2.default.PropTypes.string,
  /**
   * CSS class or classes applied when the component is entered
   */
  enteredClassName: _react2.default.PropTypes.string,
  /**
   * CSS class or classes applied while the component is entering
   */
  enteringClassName: _react2.default.PropTypes.string,

  /**
   * Callback fired before the "entering" classes are applied
   */
  onEnter: _react2.default.PropTypes.func,
  /**
   * Callback fired after the "entering" classes are applied
   */
  onEntering: _react2.default.PropTypes.func,
  /**
   * Callback fired after the "enter" classes are applied
   */
  onEntered: _react2.default.PropTypes.func,
  /**
   * Callback fired before the "exiting" classes are applied
   */
  onExit: _react2.default.PropTypes.func,
  /**
   * Callback fired after the "exiting" classes are applied
   */
  onExiting: _react2.default.PropTypes.func,
  /**
   * Callback fired after the "exited" classes are applied
   */
  onExited: _react2.default.PropTypes.func
};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.displayName = 'Transition';

Transition.defaultProps = {
  in: false,
  unmountOnExit: false,
  transitionAppear: false,

  timeout: 5000,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

exports.default = Transition;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var canUseDOM = __webpack_require__(482);

var has = Object.prototype.hasOwnProperty,
    transform = 'transform',
    transition = {},
    transitionTiming,
    transitionDuration,
    transitionProperty,
    transitionDelay;

if (canUseDOM) {
  transition = getTransitionProperties();

  transform = transition.prefix + transform;

  transitionProperty = transition.prefix + 'transition-property';
  transitionDuration = transition.prefix + 'transition-duration';
  transitionDelay = transition.prefix + 'transition-delay';
  transitionTiming = transition.prefix + 'transition-timing-function';
}

module.exports = {
  transform: transform,
  end: transition.end,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};

function getTransitionProperties() {
  var endEvent,
      prefix = '',
      transitions = {
    O: 'otransitionend',
    Moz: 'transitionend',
    Webkit: 'webkitTransitionEnd',
    ms: 'MSTransitionEnd'
  };

  var element = document.createElement('div');

  for (var vendor in transitions) if (has.call(transitions, vendor)) {
    if (element.style[vendor + 'TransitionProperty'] !== undefined) {
      prefix = '-' + vendor.toLowerCase() + '-';
      endEvent = transitions[vendor];
      break;
    }
  }

  if (!endEvent && element.style.transitionProperty !== undefined) endEvent = 'transitionend';

  return { end: endEvent, prefix: prefix };
}

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var canUseDOM = __webpack_require__(482);
var on = function on() {};

if (canUseDOM) {
  on = (function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, handler);
    };
  })();
}

module.exports = on;

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Collapse":"Collapse","teaser":"teaser","in":"in","collapsing":"collapsing"};

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(59);var _reactDom2=_interopRequireDefault(_reactDom);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _Modal=__webpack_require__(1045);var _Modal2=_interopRequireDefault(_Modal);var _Svgs=__webpack_require__(36);var _componentHelpers=__webpack_require__(26);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Modal module
 *//* eslint-disable react/no-danger */var Modal=function(_React$Component){(0,_inherits3.default)(Modal,_React$Component);/**
   * Modal Component constructor
   * @param  {Object} props   Passed in properties.
   * @return {Undefined}           Returns nothing.
   */function Modal(props){(0,_classCallCheck3.default)(this,Modal);/**
     * Component state, not a Flux object.
     * @type {Object}
     */var _this=(0,_possibleConstructorReturn3.default)(this,(Modal.__proto__||(0,_getPrototypeOf2.default)(Modal)).call(this,props));_this.state={};/**
     * Container height, used to set inline style for animation
     * @type {Number}
     */_this.state.containerHeight=0;/**
     * X Position of swipe touch
     * @type {Number}
     */_this.touchStartX=0;/**
     * Y Position of swipe touch
     * @type {Number}
     */_this.touchStartY=0;/**
     * check if swipe is avialable
     * @type {Bool}
     */_this.isSwipe=false;/**
     * Binds these methods to an instance of this Modal
     * @method bindMethods
     * @returns {Undefined} Returns nothing
     */(0,_componentHelpers.bindMethods)(_this,['updateHeight','updateIndex','handleBackgroundClick','handleFirstElementTab','handleKeyDown','handleLastElementTab','handleResize','handleCloseKeyDown','handleTouchEnd','handleTouchStart']);return _this;}/**
   * Lifecycle method
   * @return {Undefined} Returns nothing
   */(0,_createClass3.default)(Modal,[{key:'componentDidMount',value:function componentDidMount(){var wait=100;document.body.style.overflow='hidden';window.addEventListener('resize',this.handleResize);window.addEventListener('orientationchange',this.handleResize);window.addEventListener('keydown',this.handleKeyDown);window.addEventListener('click',this.handleBackgroundClick);setTimeout(this.handleResize,wait);this.refs.container.focus();}/**
   * Lifecycle method
   * @return {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.style.overflow='visible';window.removeEventListener('resize',this.handleResize);window.removeEventListener('orientationchange',this.handleResize);window.removeEventListener('keydown',this.handleKeyDown);window.removeEventListener('click',this.handleBackgroundClick);}/**
   * Determines if this modal shows the navigation
   * @return {Boolean} Whether or not to show navigation
   */},{key:'hasNavigation',value:function hasNavigation(){return this.props.contentLength>0;}/**
   * Updates height of container based on content
   * @return {Undefined} Returns nothing
   */},{key:'updateHeight',value:function updateHeight(){var container=_reactDom2.default.findDOMNode(this.refs.container);if(this.props.resizeCallback){this.props.resizeCallback();}if(container){/* this will go to offsetHeight if clientHeight is 0 */var containerHeight=container.clientHeight||container.offsetHeight;this.setState({containerHeight:containerHeight});}}/**
   * Updates index for pagination
   * @param  {String} dir String representing direction
   * @return {Undefined} Returns nothing
   */},{key:'updateIndex',value:function updateIndex(dir){var currentIndex=this.props.currentIndex;var wait=10;var nextIndex=0;if(dir==='next'){nextIndex=currentIndex+1<this.props.contentLength?currentIndex+1:0;}else{nextIndex=currentIndex-1>=0?currentIndex-1:this.props.contentLength-1;}this.props.handleSetContentIndex(nextIndex,dir);setTimeout(this.updateHeight,wait);setTimeout(this.handleResize,wait*2);}/**
   * Handles window clicking for closing the modal
   * @param  {Object} e Event Object
   * @return {Undefined} Returns nothing
   */},{key:'handleBackgroundClick',value:function handleBackgroundClick(e){if(e.target===this.refs.modal){this.props.handleClose();}}/**
   * Key event handler
   * @param  {e} e Key Event
   * @return {Undefined} Returns nothing
   */},{key:'handleKeyDown',value:function handleKeyDown(e){var code=e.keyCode?e.keyCode:e.which;var LEFT_ARROW=37;var RIGHT_ARROW=39;var ESC=27;if(code===ESC){this.props.handleClose();}else if(this.hasNavigation()){if(code===RIGHT_ARROW){this.updateIndex('next');}else if(code===LEFT_ARROW){this.updateIndex('previous');}}}/**
   * Event handler for window resizing
   * @return {Undefined} Returns nothing
   */},{key:'handleResize',value:function handleResize(){this.updateHeight();}/**
   * Checks touch end location for condolence swipe.
   * @param  {Object} event Touch event
   * @return {Undefined} Returns nothing
   */},{key:'handleTouchEnd',value:function handleTouchEnd(event){if(this.isSwipe){var touchEndX=event.nativeEvent.changedTouches[0].clientX;var touchEndY=event.nativeEvent.changedTouches[0].clientY;var TOUCH_DISTANCE=100;if(Math.abs(touchEndX-this.touchStartX)>=TOUCH_DISTANCE&&Math.abs(touchEndY-this.touchStartY)<TOUCH_DISTANCE){if(touchEndX>this.touchStartX){this.updateIndex('previous');}else{this.updateIndex('next');}this.isSwipe=false;}}}/**
   * Checks touch start location for condolence swipe
   * @param  {Object} event Touch event
   * @return {Undefined} Returns nothing
   */},{key:'handleTouchStart',value:function handleTouchStart(event){if(this.hasNavigation()){this.touchStartX=event.nativeEvent.touches[0].clientX;this.touchStartY=event.nativeEvent.touches[0].clientY;this.isSwipe=true;}}/**
   * Handles tabbing forwards past the last element to prevent exiting the modal focus
   * @param  {Object}   e The Event object
   * @param  {Function} callback Callback to be fired if tab not pressed
   * @return {Undefined} Returns nothing
   */},{key:'handleLastElementTab',value:function handleLastElementTab(e,callback){var code=e.keyCode?e.keyCode:e.which;var TAB=9;if(code===TAB&&!e.shiftKey){e.preventDefault();this.refs.container.focus();}else if(callback){return callback(e);}}/**
   * Handles Tabbing backwards from the first element to prevent exiting the modal focus
   * @param  {Object} e The Event object
   * @param {Boolean} hasNavigation If the modal has navigation
   * @return {Undefined} Returns nothing
   */},{key:'handleFirstElementTab',value:function handleFirstElementTab(e,hasNavigation){var code=e.keyCode?e.keyCode:e.which;var TAB=9;if(code===TAB&&e.shiftKey&&this.refs.container===e.target){e.preventDefault();if(hasNavigation){this.refs.previous.focus();}else{this.refs.closeModal.focus();}}}/**
   * Gets the Close Button Handler
   * @param  {Boolean} hasNavigation If the modal has navigation
   * @param  {Function}  handler The close button handler
   * @return {Function} The function to handle closing the button
   */},{key:'getCloseButtonHandler',value:function getCloseButtonHandler(hasNavigation,handler){return hasNavigation?handler:_lodash2.default.partial(this.handleLastElementTab,_lodash2.default,handler);}/**
   * Gets the styles object - height animation not needed for mobile
   * @param  {Number}  containerHeight The container height
   * @param  {Boolean} isPhone If on a phone
   * @return {Object} The Styles object
   */},{key:'getStyles',value:function getStyles(containerHeight,isPhone){var height=isPhone?'auto':containerHeight;return{height:height};}/**
   * React Component render
   * High tab indexes are set for Viddler children
   * @return {JSX} Modal rendered
   */},{key:'render',value:function render(){var _props=this.props,className=_props.className,classNameContent=_props.classNameContent,classNameCloseBtn=_props.classNameCloseBtn,classNameItem=_props.classNameItem;var navigation=null;var hasNavigation=this.hasNavigation();if(hasNavigation){var handleNextClick=_lodash2.default.partial(this.updateIndex,'next');var handlePrevClick=_lodash2.default.partial(this.updateIndex,'previous');navigation=_react2.default.createElement('div',{className:_Modal2.default.ModalNavigation},_react2.default.createElement('div',{'aria-label':'Next',className:_Modal2.default.ModalNavButton+' '+_Modal2.default.ModalNavNext,id:'next',onClick:handleNextClick,onKeyDown:_lodash2.default.partial(_componentHelpers.handleAccessibleKeyDown,_lodash2.default,handleNextClick),role:'button',tabIndex:'1001'},_react2.default.createElement(_Svgs.ModalArrow,null)),_react2.default.createElement('div',{'aria-label':'Previous',className:_Modal2.default.ModalNavButton,id:'previous',onClick:handlePrevClick,onKeyDown:_lodash2.default.partial(this.handleLastElementTab,_lodash2.default,_lodash2.default.partial(_componentHelpers.handleAccessibleKeyDown,_lodash2.default,handlePrevClick)),ref:'previous',role:'button',tabIndex:'1001'},_react2.default.createElement(_Svgs.ModalArrow,null)));}return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:_Modal2.default.ModalBackground}),_react2.default.createElement('div',{'aria-label':'Modal',className:''+_Modal2.default.Modal+(className?' '+className:''),onTouchEnd:this.handleTouchEnd,onTouchStart:this.handleTouchStart,ref:'modal',role:'dialog',tabIndex:'-1'},_react2.default.createElement('div',{className:''+_Modal2.default.ModalContent+(classNameContent?' '+classNameContent:''),role:'document'},this.props.showCloseButton&&_react2.default.createElement('button',{'aria-label':'Close Modal',className:''+_Modal2.default.closeButton+(classNameCloseBtn?' '+classNameCloseBtn:''),id:'closeModal',onClick:this.props.handleClose,onKeyDown:this.getCloseButtonHandler(hasNavigation,_lodash2.default.partial(_componentHelpers.handleAccessibleKeyDown,_lodash2.default,this.props.handleClose)),ref:'closeModal',role:'button',tabIndex:'1001'},_react2.default.createElement(_Svgs.CloseXIcon,{primaryColor:'#48565e'})),_react2.default.createElement('div',{className:''+_Modal2.default.ModalNavItem+(classNameItem?' '+classNameItem:''),style:this.getStyles(this.state.containerHeight,this.props.isPhone)},_react2.default.createElement('div',{'aria-label':'Modal Content Container',onKeyDown:_lodash2.default.partial(this.handleFirstElementTab,_lodash2.default,hasNavigation),ref:'container',tabIndex:'1000'},_lodash2.default.isFunction(_lodash2.default.get(this.props.children,'type',false))?_react2.default.cloneElement(this.props.children,{callbacks:{load:[this.handleResize]}}):this.props.children))),navigation));}}]);return Modal;}(_react2.default.Component);Modal.propTypes={children:_react2.default.PropTypes.node,className:_react2.default.PropTypes.string,classNameCloseBtn:_react2.default.PropTypes.string,classNameContent:_react2.default.PropTypes.string,classNameItem:_react2.default.PropTypes.string,contentLength:_react2.default.PropTypes.number,currentIndex:_react2.default.PropTypes.number,handleClose:_react2.default.PropTypes.func,handleSetContentIndex:_react2.default.PropTypes.func,isPhone:_react2.default.PropTypes.bool,resizeCallback:_react2.default.PropTypes.func,showCloseButton:_react2.default.PropTypes.bool};Modal.defaultProps={showCloseButton:true};exports.default=Modal;

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Modal":"Modal","fadein":"fadein","ModalContent":"ModalContent","ModalNavItem":"ModalNavItem","closeButton":"closeButton","ModalNavigation":"ModalNavigation","ModalNavButton":"ModalNavButton","ModalNavNext":"ModalNavNext","closePanel":"closePanel","ModalBackground":"ModalBackground","fadeinBg":"fadeinBg"};

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _partial2=__webpack_require__(325);var _partial3=_interopRequireDefault(_partial2);var _debounce2=__webpack_require__(1068);var _debounce3=_interopRequireDefault(_debounce2);var _componentHelpers=__webpack_require__(26);var _constants=__webpack_require__(41);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RESIZE_TIMEOUT=50;/**
 * IframedVideo Component
 */var IframedVideo=function(_React$Component){(0,_inherits3.default)(IframedVideo,_React$Component);/**
   * IframedVideo Component Constructor
   * @param  {Object} props Passed in properties
   * @return {Undefined} Returns nothing
   */function IframedVideo(props){(0,_classCallCheck3.default)(this,IframedVideo);/* refs */var _this=(0,_possibleConstructorReturn3.default)(this,(IframedVideo.__proto__||(0,_getPrototypeOf2.default)(IframedVideo)).call(this,props));_this[_constants.IFRAME_VIDEO_KEY]=null;_this.setVideoRef=(0,_partial3.default)(_componentHelpers.setRef,_partial3.default.placeholder,_constants.IFRAME_VIDEO_KEY,_this);(0,_componentHelpers.bindMethods)(_this,['handleOnLoad','handleResize']);_this.handleResize=(0,_debounce3.default)(_this.handleResize,RESIZE_TIMEOUT);return _this;}/**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */(0,_createClass3.default)(IframedVideo,[{key:'componentDidMount',value:function componentDidMount(){this.handleResize();window.addEventListener('resize',this.handleResize);setTimeout(this.handleResize,RESIZE_TIMEOUT);this[_constants.IFRAME_VIDEO_KEY].addEventListener('load',this.handleOnLoad);}/**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);this[_constants.IFRAME_VIDEO_KEY].removeEventListener('load',this.handleOnLoad);}/**
   * Triggers frame sizing upon load of the video
   * @return {Undefined} Returns nothing
   */},{key:'handleOnLoad',value:function handleOnLoad(){this.handleResize();if(this.props.videoReadyCallback&&typeof this.props.videoReadyCallback==='function'){this.props.videoReadyCallback();}}/**
   * Maintains the aspect of the Iframed video
   * @return {Undefined} Returns nothing
   */},{key:'handleResize',value:function handleResize(){var width=this[_constants.IFRAME_VIDEO_KEY].clientWidth;this[_constants.IFRAME_VIDEO_KEY].height=width*this.props.aspect;}/**
   * React Component render
   * @return {JSX} IframedVideo rendered
   */},{key:'render',value:function render(){var _props=this.props,isModal=_props.isModal,url=_props.url;return _react2.default.createElement('div',null,_react2.default.createElement('iframe',{allowFullScreen:isModal,ref:this.setVideoRef,src:url,width:'100%'}));}}]);return IframedVideo;}(_react2.default.Component);IframedVideo.propTypes={aspect:_react2.default.PropTypes.number.isRequired,isModal:_react2.default.PropTypes.bool,url:_react2.default.PropTypes.string.isRequired,videoReadyCallback:_react2.default.PropTypes.func};exports.default=IframedVideo;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(483),
    createBind = __webpack_require__(1048),
    createCurry = __webpack_require__(1049),
    createHybrid = __webpack_require__(485),
    createPartial = __webpack_require__(1065),
    getData = __webpack_require__(489),
    mergeData = __webpack_require__(1066),
    setData = __webpack_require__(491),
    setWrapToString = __webpack_require__(493),
    toInteger = __webpack_require__(333);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 *   512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] == null
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(221),
    root = __webpack_require__(47);

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(327),
    createCtor = __webpack_require__(221),
    createHybrid = __webpack_require__(485),
    createRecurry = __webpack_require__(488),
    getHolder = __webpack_require__(332),
    replaceHolders = __webpack_require__(225),
    root = __webpack_require__(47);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      result++;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(329),
    getData = __webpack_require__(489),
    getFuncName = __webpack_require__(1053),
    lodash = __webpack_require__(1055);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1054);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(329),
    LodashWrapper = __webpack_require__(490),
    baseLodash = __webpack_require__(330),
    isArray = __webpack_require__(46),
    isObjectLike = __webpack_require__(95),
    wrapperClone = __webpack_require__(1056);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array of at least `200` elements
 * and any iteratees accept only one argument. The heuristic for whether a
 * section qualifies for shortcut fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(329),
    LodashWrapper = __webpack_require__(490),
    copyArray = __webpack_require__(223);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1057 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(115);

/* Used to set `toString` methods. */
var defineProperty = (function() {
  var func = getNative(Object, 'defineProperty'),
      name = getNative.name;

  return (name && name.length > 2) ? func : undefined;
}());

module.exports = defineProperty;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 1060 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length,
      lastIndex = length - 1;

  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(331),
    arrayIncludes = __webpack_require__(1062);

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    REARG_FLAG = 256,
    FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', ARY_FLAG],
  ['bind', BIND_FLAG],
  ['bindKey', BIND_KEY_FLAG],
  ['curry', CURRY_FLAG],
  ['curryRight', CURRY_RIGHT_FLAG],
  ['flip', FLIP_FLAG],
  ['partial', PARTIAL_FLAG],
  ['partialRight', PARTIAL_RIGHT_FLAG],
  ['rearg', REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(494);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to search.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(223),
    isIndex = __webpack_require__(224);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(327),
    createCtor = __webpack_require__(221),
    root = __webpack_require__(47);

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(486),
    composeArgsRight = __webpack_require__(487),
    replaceHolders = __webpack_require__(225);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    ARY_FLAG = 128,
    REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);

  var isCombo =
    ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
    ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(496);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54),
    now = __webpack_require__(492),
    toNumber = __webpack_require__(496);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {var crypto=__webpack_require__(1072);/**
 * Creates a base64 encoded policy and hashed signature
 * @method createFpSignature
 * @param  {string}  secret     FilePicker secret
 * @param  {number}  expiration Time of expiration of signature in UNIX Epoch
 * @return {object}  The resulting policy and signature
 */var createFpSignature=function createFpSignature(secret){var expiration=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var fpData=null;if(secret){var oneHourFromNow=Math.floor(new Date().getTime()/1000+60*60);var expiry=expiration||oneHourFromNow;var jsonPolicy='{"call": ["read", "pick"],"expiry":'+expiry+'}';// Keyed-Hash Message Authentication Code
var hmac=crypto.createHmac('sha256',secret);var policy=new Buffer(jsonPolicy).toString('base64');var signature=hmac.update(policy).digest('hex');if(policy&&signature){fpData={fpData:{policy:policy,signature:signature}};}}return fpData;};module.exports={createFpSignature:createFpSignature};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 1071 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(138)
exports.createHash = exports.Hash = __webpack_require__(165)
exports.createHmac = exports.Hmac = __webpack_require__(504)

var algos = __webpack_require__(1096)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(509)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(1104)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(1122)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(1127)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(1165)

var publicEncrypt = __webpack_require__(1166)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(1169)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 1073 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(9).Buffer;
/*</replacement>*/

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1076);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(43)))

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(501);

/*<replacement>*/
var util = __webpack_require__(166);
util.inherits = __webpack_require__(7);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(338);


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(116);


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(337).Transform


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(337).PassThrough


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(21).Buffer
var inherits = __webpack_require__(7)
var HashBase = __webpack_require__(226)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(1085)
exports.sha1 = __webpack_require__(1086)
exports.sha224 = __webpack_require__(1087)
exports.sha256 = __webpack_require__(502)
exports.sha384 = __webpack_require__(1088)
exports.sha512 = __webpack_require__(503)


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(139)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(139)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(7)
var Sha256 = __webpack_require__(502)
var Hash = __webpack_require__(139)
var Buffer = __webpack_require__(9).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7)
var SHA512 = __webpack_require__(503)
var Hash = __webpack_require__(139)
var Buffer = __webpack_require__(9).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(7)
var Buffer = __webpack_require__(9).Buffer

var Base = __webpack_require__(96)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(21).Buffer
var inherits = __webpack_require__(7)
var HashBase = __webpack_require__(226)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(1092)
exports.sha1 = __webpack_require__(1093)
exports.sha224 = __webpack_require__(1094)
exports.sha256 = __webpack_require__(506)
exports.sha384 = __webpack_require__(1095)
exports.sha512 = __webpack_require__(507)


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(140)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(140)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(7)
var Sha256 = __webpack_require__(506)
var Hash = __webpack_require__(140)
var Buffer = __webpack_require__(9).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7)
var SHA512 = __webpack_require__(507)
var Hash = __webpack_require__(140)
var Buffer = __webpack_require__(9).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(508)


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(510)
var defaultEncoding = __webpack_require__(511)
var sync = __webpack_require__(512)
var Buffer = __webpack_require__(9).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(43)))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(21).Buffer
var inherits = __webpack_require__(7)
var HashBase = __webpack_require__(226)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(1100)
exports.sha1 = __webpack_require__(1101)
exports.sha224 = __webpack_require__(1102)
exports.sha256 = __webpack_require__(513)
exports.sha384 = __webpack_require__(1103)
exports.sha512 = __webpack_require__(514)


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(141)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(141)
var Buffer = __webpack_require__(9).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(7)
var Sha256 = __webpack_require__(513)
var Hash = __webpack_require__(141)
var Buffer = __webpack_require__(9).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7)
var SHA512 = __webpack_require__(514)
var Hash = __webpack_require__(141)
var Buffer = __webpack_require__(9).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(1105)
var aes = __webpack_require__(341)
var aesModes = __webpack_require__(342)
var desModes = __webpack_require__(1121)
var ebtk = __webpack_require__(229)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(96)
var des = __webpack_require__(340)
var inherits = __webpack_require__(7)
var Buffer = __webpack_require__(1111).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(60);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(60);
var inherits = __webpack_require__(7);

var des = __webpack_require__(340);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(60);
var inherits = __webpack_require__(7);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(60);
var inherits = __webpack_require__(7);

var des = __webpack_require__(340);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(21)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(342)
var AuthCipher = __webpack_require__(518)
var Buffer = __webpack_require__(9).Buffer
var StreamCipher = __webpack_require__(519)
var Transform = __webpack_require__(96)
var aes = __webpack_require__(228)
var ebtk = __webpack_require__(229)
var inherits = __webpack_require__(7)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 1113 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(167)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer
var xor = __webpack_require__(167)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(167)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(9).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(518)
var Buffer = __webpack_require__(9).Buffer
var MODES = __webpack_require__(342)
var StreamCipher = __webpack_require__(519)
var Transform = __webpack_require__(96)
var aes = __webpack_require__(228)
var ebtk = __webpack_require__(229)
var inherits = __webpack_require__(7)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 1121 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(520)
var primes = __webpack_require__(1125)

var DH = __webpack_require__(1126)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports = {
	"modp1": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
	},
	"modp2": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
	},
	"modp5": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
	},
	"modp14": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
	},
	"modp15": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
	},
	"modp16": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
	},
	"modp17": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
	},
	"modp18": {
		"gen": "02",
		"prime": "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"
	}
};

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(33);
var MillerRabin = __webpack_require__(521);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(520);
var randomBytes = __webpack_require__(138);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(165)
var stream = __webpack_require__(335)
var inherits = __webpack_require__(7)
var sign = __webpack_require__(1128)
var verify = __webpack_require__(1164)

var algorithms = __webpack_require__(508)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(504)
var crt = __webpack_require__(343)
var EC = __webpack_require__(48).ec
var BN = __webpack_require__(33)
var parseKeys = __webpack_require__(231)
var curves = __webpack_require__(531)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports = {
	"name": "elliptic",
	"version": "6.4.0",
	"description": "EC cryptography",
	"main": "lib/elliptic.js",
	"files": [
		"lib"
	],
	"scripts": {
		"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"lint": "npm run jscs && npm run jshint",
		"unit": "istanbul test _mocha --reporter=spec test/index.js",
		"test": "npm run lint && npm run unit",
		"version": "grunt dist && git add dist/"
	},
	"repository": {
		"type": "git",
		"url": "git@github.com:indutny/elliptic"
	},
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"author": "Fedor Indutny <fedor@indutny.com>",
	"license": "MIT",
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"homepage": "https://github.com/indutny/elliptic",
	"devDependencies": {
		"brfs": "^1.4.3",
		"coveralls": "^2.11.3",
		"grunt": "^0.4.5",
		"grunt-browserify": "^5.0.0",
		"grunt-cli": "^1.2.0",
		"grunt-contrib-connect": "^1.0.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-uglify": "^1.0.1",
		"grunt-mocha-istanbul": "^3.0.1",
		"grunt-saucelabs": "^8.6.2",
		"istanbul": "^0.4.2",
		"jscs": "^2.9.0",
		"jshint": "^2.6.0",
		"mocha": "^2.1.0"
	},
	"dependencies": {
		"bn.js": "^4.4.0",
		"brorand": "^1.0.1",
		"hash.js": "^1.0.0",
		"hmac-drbg": "^1.0.0",
		"inherits": "^2.0.1",
		"minimalistic-assert": "^1.0.0",
		"minimalistic-crypto-utils": "^1.0.0"
	},
	"_resolved": "http://sinopia.legacyobit.int:4873/elliptic/-/elliptic-6.4.0.tgz",
	"_integrity": "sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=",
	"_from": "elliptic@6.4.0"
};

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(33);
var minAssert = __webpack_require__(60);
var minUtils = __webpack_require__(523);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var elliptic = __webpack_require__(48);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(230);
var elliptic = __webpack_require__(48);
var BN = __webpack_require__(33);
var inherits = __webpack_require__(7);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
  return false;
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(230);
var BN = __webpack_require__(33);
var inherits = __webpack_require__(7);
var Base = curve.base;

var elliptic = __webpack_require__(48);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(230);
var elliptic = __webpack_require__(48);
var BN = __webpack_require__(33);
var inherits = __webpack_require__(7);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - 1) / (d y^2 + 1)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.one);
  var rhs = y2.redMul(this.d).redAdd(this.one);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
         this.y.cmp(this.z) === 0;
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
  return false;
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(344);
var elliptic = __webpack_require__(48);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(1142);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(1137);
exports.sha224 = __webpack_require__(1138);
exports.sha256 = __webpack_require__(525);
exports.sha384 = __webpack_require__(1139);
exports.sha512 = __webpack_require__(526);


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);
var common = __webpack_require__(168);
var shaCommon = __webpack_require__(524);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);
var SHA256 = __webpack_require__(525);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);

var SHA512 = __webpack_require__(526);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);
var common = __webpack_require__(168);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(78);
var assert = __webpack_require__(60);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 1142 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var HmacDRBG = __webpack_require__(1144);
var elliptic = __webpack_require__(48);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(1145);
var Signature = __webpack_require__(1146);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(344);
var utils = __webpack_require__(523);
var assert = __webpack_require__(60);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var elliptic = __webpack_require__(48);
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);

var elliptic = __webpack_require__(48);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(344);
var elliptic = __webpack_require__(48);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(1148);
var Signature = __webpack_require__(1149);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(48);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var elliptic = __webpack_require__(48);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(169)

exports.certificate = __webpack_require__(1161)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(169);
var inherits = __webpack_require__(7);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(1152).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(1153);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 1153 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(170).Reporter;
var EncoderBuffer = __webpack_require__(170).EncoderBuffer;
var DecoderBuffer = __webpack_require__(170).DecoderBuffer;
var assert = __webpack_require__(60);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(528);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(529);
decoders.pem = __webpack_require__(1158);


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);
var Buffer = __webpack_require__(21).Buffer;

var DERDecoder = __webpack_require__(529);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(530);
encoders.pem = __webpack_require__(1160);


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);

var DEREncoder = __webpack_require__(530);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(169)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports = {
	"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
	"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
	"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
	"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
	"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
	"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
	"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
	"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
	"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
	"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
	"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
	"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(229)
var ciphers = __webpack_require__(341)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(33)
var EC = __webpack_require__(48).ec
var parseKeys = __webpack_require__(231)
var curves = __webpack_require__(531)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(48)
var BN = __webpack_require__(33)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(1167);
exports.privateDecrypt = __webpack_require__(1168);

exports.privateEncrypt = function privateEncrypt(key, buf) {
  return exports.publicEncrypt(key, buf, true);
};

exports.publicDecrypt = function publicDecrypt(key, buf) {
  return exports.privateDecrypt(key, buf, true);
};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var parseKeys = __webpack_require__(231);
var randomBytes = __webpack_require__(138);
var createHash = __webpack_require__(165);
var mgf = __webpack_require__(532);
var xor = __webpack_require__(533);
var bn = __webpack_require__(33);
var withPublic = __webpack_require__(534);
var crt = __webpack_require__(343);

var constants = {
  RSA_PKCS1_OAEP_PADDING: 4,
  RSA_PKCS1_PADDIN: 1,
  RSA_NO_PADDING: 3
};

module.exports = function publicEncrypt(public_key, msg, reverse) {
  var padding;
  if (public_key.padding) {
    padding = public_key.padding;
  } else if (reverse) {
    padding = 1;
  } else {
    padding = 4;
  }
  var key = parseKeys(public_key);
  var paddedMsg;
  if (padding === 4) {
    paddedMsg = oaep(key, msg);
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse);
  } else if (padding === 3) {
    paddedMsg = new bn(msg);
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus');
    }
  } else {
    throw new Error('unknown padding');
  }
  if (reverse) {
    return crt(paddedMsg, key);
  } else {
    return withPublic(paddedMsg, key);
  }
};

function oaep(key, msg){
  var k = key.modulus.byteLength();
  var mLen = msg.length;
  var iHash = createHash('sha1').update(new Buffer('')).digest();
  var hLen = iHash.length;
  var hLen2 = 2 * hLen;
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long');
  }
  var ps = new Buffer(k - mLen - hLen2 - 2);
  ps.fill(0);
  var dblen = k - hLen - 1;
  var seed = randomBytes(hLen);
  var maskedDb = xor(Buffer.concat([iHash, ps, new Buffer([1]), msg], dblen), mgf(seed, dblen));
  var maskedSeed = xor(seed, mgf(maskedDb, hLen));
  return new bn(Buffer.concat([new Buffer([0]), maskedSeed, maskedDb], k));
}
function pkcs1(key, msg, reverse){
  var mLen = msg.length;
  var k = key.modulus.byteLength();
  if (mLen > k - 11) {
    throw new Error('message too long');
  }
  var ps;
  if (reverse) {
    ps = new Buffer(k - mLen - 3);
    ps.fill(0xff);
  } else {
    ps = nonZero(k - mLen - 3);
  }
  return new bn(Buffer.concat([new Buffer([0, reverse?1:2]), ps, new Buffer([0]), msg], k));
}
function nonZero(len, crypto) {
  var out = new Buffer(len);
  var i = 0;
  var cache = randomBytes(len*2);
  var cur = 0;
  var num;
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len*2);
      cur = 0;
    }
    num = cache[cur++];
    if (num) {
      out[i++] = num;
    }
  }
  return out;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var parseKeys = __webpack_require__(231);
var mgf = __webpack_require__(532);
var xor = __webpack_require__(533);
var bn = __webpack_require__(33);
var crt = __webpack_require__(343);
var createHash = __webpack_require__(165);
var withPublic = __webpack_require__(534);
module.exports = function privateDecrypt(private_key, enc, reverse) {
  var padding;
  if (private_key.padding) {
    padding = private_key.padding;
  } else if (reverse) {
    padding = 1;
  } else {
    padding = 4;
  }
  
  var key = parseKeys(private_key);
  var k = key.modulus.byteLength();
  if (enc.length > k || new bn(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error');
  }
  var msg;
  if (reverse) {
    msg = withPublic(new bn(enc), key);
  } else {
    msg = crt(enc, key);
  }
  var zBuffer = new Buffer(k - msg.length);
  zBuffer.fill(0);
  msg = Buffer.concat([zBuffer, msg], k);
  if (padding === 4) {
    return oaep(key, msg);
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse);
  } else if (padding === 3) {
    return msg;
  } else {
    throw new Error('unknown padding');
  }
};

function oaep(key, msg){
  var n = key.modulus;
  var k = key.modulus.byteLength();
  var mLen = msg.length;
  var iHash = createHash('sha1').update(new Buffer('')).digest();
  var hLen = iHash.length;
  var hLen2 = 2 * hLen;
  if (msg[0] !== 0) {
    throw new Error('decryption error');
  }
  var maskedSeed = msg.slice(1, hLen + 1);
  var maskedDb =  msg.slice(hLen + 1);
  var seed = xor(maskedSeed, mgf(maskedDb, hLen));
  var db = xor(maskedDb, mgf(seed, k - hLen - 1));
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error');
  }
  var i = hLen;
  while (db[i] === 0) {
    i++;
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error');
  }
  return db.slice(i);
}

function pkcs1(key, msg, reverse){
  var p1 = msg.slice(0, 2);
  var i = 2;
  var status = 0;
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++;
      break;
    }
  }
  var ps = msg.slice(2, i - 1);
  var p2 = msg.slice(i - 1, i);

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)){
    status++;
  }
  if (ps.length < 8) {
    status++;
  }
  if (status) {
    throw new Error('decryption error');
  }
  return  msg.slice(i);
}
function compare(a, b){
  a = new Buffer(a);
  b = new Buffer(b);
  var dif = 0;
  var len = a.length;
  if (a.length !== b.length) {
    dif++;
    len = Math.min(a.length, b.length);
  }
  var i = -1;
  while (++i < len) {
    dif += (a[i] ^ b[i]);
  }
  return dif;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer))

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(9)
var randombytes = __webpack_require__(138)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(43)))

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports = {
	"env": "default",
	"vanityDomain": "http://localhost:80",
	"mobileDomain": "http://localhost:80",
	"server": {
		"port": 80
	},
	"googleTagManager": {
		"id": "GTM-KTHH2N"
	},
	"dataLayer": {
		"id": "GTM-KTHH2N"
	},
	"optimizely": {
		"id": "1991061092"
	},
	"assetsPath": "/funeral-homes/obituaries/name",
	"baseUrl": {
		"protocol": "http",
		"hostname": "localhost",
		"beta": "",
		"pathname": "funeral-homes/obituaries/name",
		"port": "80"
	},
	"environmentalUrl": {
		"cacheUrl": "https://cache.dev-legacy.net/",
		"flowersUrl": "https://sympathy.dev-legacy.com/",
		"staticCacheUrl": "https://static.legacy.net/"
	},
	"apiGateway": {
		"protocol": "http",
		"domain": "apiswarm.dev-legacy.com",
		"port": "",
		"path": [
			"graphql"
		]
	},
	"internalApiGateway": {
		"protocol": "http",
		"domain": "apiswarm.dev-legacy.com",
		"port": "",
		"path": [
			"graphql"
		]
	},
	"gatewayFetch": {
		"post": {
			"options": {}
		}
	},
	"printedGuestBookUrl": "https://sympathy.dev-legacy.com/printed-obituary-guestbook/gallery/pm69/",
	"advertising": {
		"networkId": 423686928,
		"environment": "dev",
		"siteName": "obit-fhd",
		"appKeyValues": [
			{
				"cobrand": "Legacy"
			},
			{
				"country": "0"
			},
			{
				"corp": "0"
			},
			{
				"affstate": "0"
			}
		],
		"responsiveSizeMaps": [],
		"AdExtensions": []
	},
	"directoryAdvertising": {
		"networkId": 423686928,
		"environment": "dev",
		"siteName": "obit-fhd",
		"responsiveSizeMaps": [
			{
				"name": "mapping728x90Header",
				"sizes": [
					{
						"viewport": "[980,0]",
						"adSizes": "[[728,90],'fluid']",
						"description": "Desktop"
					},
					{
						"viewport": "[737,0]",
						"adSizes": "[[728,90],'fluid']",
						"description": "Tablet"
					},
					{
						"viewport": "[0,0]",
						"adSizes": "[[320,50],'fluid']",
						"description": "Fallback"
					}
				]
			},
			{
				"name": "mapping728x90Footer",
				"sizes": [
					{
						"viewport": "[980,0]",
						"adSizes": "[[728,90]]",
						"description": "Desktop"
					},
					{
						"viewport": "[737,0]",
						"adSizes": "[[728,90]]",
						"description": "Tablet"
					},
					{
						"viewport": "[0,0]",
						"adSizes": "[[300,250]]",
						"description": "Fallback"
					}
				]
			},
			{
				"name": "mapping300x250RightRail",
				"sizes": [
					{
						"viewport": "[980,0]",
						"adSizes": "[[300,250],'fluid']",
						"description": "Desktop"
					},
					{
						"viewport": "[737,0]",
						"adSizes": "[[300,250],'fluid']",
						"description": "Tablet"
					},
					{
						"viewport": "[0,0]",
						"adSizes": "[]",
						"description": "Fallback"
					}
				]
			},
			{
				"name": "mapping320x250DisplayOverlay1",
				"sizes": [
					{
						"viewport": "[980,0]",
						"adSizes": "[[1,1],[728,90],[970,90],[320,50]]",
						"description": "Desktop"
					},
					{
						"viewport": "[737,0]",
						"adSizes": "[[1,1],[320,50],[728,90],'fluid']",
						"description": "Tablet"
					},
					{
						"viewport": "[0,0]",
						"adSizes": "[[1,1],[320,50],'fluid']",
						"description": "Fallback"
					}
				]
			}
		],
		"AdExtensions": []
	},
	"filepicker": {
		"key": "AivazPCCT90xpkMondIwGz"
	},
	"statsd": {
		"host": "statsd.hostedgraphite.com",
		"port": 8125,
		"apiKey": "61e3533c-03ed-43f5-911d-6197a41e4e8e.funeral-home-client.dev",
		"enableLogging": false
	},
	"logging": {
		"level": "silly"
	},
	"scriptInjector": {
		"scriptsPath": "scripts",
		"scriptLocations": [
			"head",
			"top",
			"bottom"
		]
	},
	"yotpo": {
		"apiKey": "wxikOpgP5wtGLV7R5iW76o4gQdDBgS6ICVeir6Jd"
	},
	"googleApi": {
		"apiKey": "AIzaSyCNy3AOO8BgFGoeDGZ9gh41CJtE9fAs5LQ"
	},
	"salesforce": {
		"webcollect": {
			"clientId": "r0u5kw2q5lhpz9sgsu3k7k9d",
			"clientSecret": "KGyZg4Uch5mwFT8qw3alqqXS"
		}
	}
};

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports = {
	"env": "dev",
	"vanityDomain": "https://www.dev-legacy.com",
	"mobileDomain": "https://m.dev-legacy.com",
	"baseUrl": {
		"protocol": "https",
		"hostname": "www.dev-legacy.com",
		"beta": "/beta",
		"pathname": "funeral-homes/obituaries/name",
		"port": ""
	},
	"apiGateway": {
		"protocol": "https",
		"domain": "api-gateway.dev.legint.net",
		"port": ""
	},
	"internalApiGateway": {
		"protocol": "https",
		"domain": "api-gateway.dev.legint.net",
		"port": ""
	},
	"advertising": {
		"environment": "dev"
	},
	"directoryAdvertising": {
		"environment": "dev"
	},
	"statsd": {
		"apiKey": "61e3533c-03ed-43f5-911d-6197a41e4e8e.funeral-home-client.dev",
		"enableLogging": false
	}
};

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports = {
	"env": "prod",
	"vanityDomain": "https://www.legacy.com",
	"mobileDomain": "https://m.legacy.com",
	"googleTagManager": {
		"id": "GTM-TDQHZW"
	},
	"dataLayer": {
		"id": "GTM-TDQHZW"
	},
	"optimizely": {
		"id": "1736730124"
	},
	"baseUrl": {
		"protocol": "https",
		"hostname": "www.legacy.com",
		"beta": "",
		"pathname": "funeral-homes/obituaries/name",
		"port": ""
	},
	"environmentalUrl": {
		"cacheUrl": "https://cache.legacy.net/",
		"flowersUrl": "https://sympathy.legacy.com/",
		"bypageUrl": "https://www.legacy.com/",
		"staticCacheUrl": "https://static.legacy.net/"
	},
	"apiGateway": {
		"protocol": "https",
		"domain": "apiswarm.legacy.com",
		"port": ""
	},
	"internalApiGateway": {
		"protocol": "https",
		"domain": "api-gateway.prod.legint.net",
		"port": ""
	},
	"printedGuestBookUrl": "https://sympathy.legacy.com/printed-obituary-guestbook/gallery/pm69/",
	"statsd": {
		"apiKey": "61e3533c-03ed-43f5-911d-6197a41e4e8e.funeral-home-client.prod",
		"enableLogging": false
	},
	"logging": {
		"level": "warn"
	},
	"advertising": {
		"environment": "prod"
	},
	"yotpo": {
		"apiKey": "MH73jrTWzDMghSfjsyuxMEtqRbhjTOEjj4gllNmc"
	},
	"helpPlanningHubspotFormId": "7d70b9b5-a252-416f-9fc2-08cfa96ab1fd",
	"directoryAdvertising": {
		"environment": "prod"
	}
};

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

module.exports = {
	"env": "dev",
	"vanityDomain": "https://dev.legacy.com",
	"baseUrl": {
		"protocol": "https",
		"hostname": "dev.legacy.com",
		"beta": "/beta",
		"pathname": "funeral-homes/obituaries/name",
		"port": ""
	},
	"apiGateway": {
		"protocol": "https",
		"domain": "dev.legacy.com",
		"port": "",
		"pathname": "graphql"
	},
	"internalApiGateway": {
		"domain": "api-gateway"
	},
	"advertising": {
		"environment": "dev"
	},
	"directoryAdvertising": {
		"environment": "dev"
	},
	"statsd": {
		"apiKey": "61e3533c-03ed-43f5-911d-6197a41e4e8e.person-client.dev",
		"enableLogging": false
	}
};

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports = {
	"env": "stage",
	"vanityDomain": "https://www.qa-legacy.com",
	"mobileDomain": "https://m.qa-legacy.com",
	"baseUrl": {
		"protocol": "https",
		"hostname": "www.qa-legacy.com",
		"beta": "/beta",
		"pathname": "funeral-homes/obituaries/name",
		"port": ""
	},
	"environmentalUrl": {
		"cacheUrl": "https://cache.qa-legacy.net/",
		"flowersUrl": "https://sympathy.qa-legacy.com/",
		"bypageUrl": "https://www.qa-legacy.com/",
		"staticCacheUrl": "https://static.qa-legacy.net/"
	},
	"apiGateway": {
		"protocol": "https",
		"domain": "apiswarm.qa-legacy.com",
		"port": ""
	},
	"internalApiGateway": {
		"protocol": "https",
		"domain": "api-gateway.stage.legint.net",
		"port": ""
	},
	"printedGuestBookUrl": "https://sympathy.qa-legacy.com/printed-obituary-guestbook/gallery/pm69/",
	"statsd": {
		"apiKey": "61e3533c-03ed-43f5-911d-6197a41e4e8e.funeral-home-client.qa",
		"enableLogging": false
	},
	"advertising": {
		"environment": "qa"
	},
	"directoryAdvertising": {
		"environment": "qa"
	}
};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Video Component
 */var Video=function(_React$Component){(0,_inherits3.default)(Video,_React$Component);/**
   * Video Component Constructor
   * @param  {Object} props Passed in properties
   * @return {Undefined} Returns nothing
   */function Video(props){(0,_classCallCheck3.default)(this,Video);/**
     * Instance of the Viddler Player
     * @type {Object}
     */var _this=(0,_possibleConstructorReturn3.default)(this,(Video.__proto__||(0,_getPrototypeOf2.default)(Video)).call(this,props));_this.player=null;/**
     * The selector that Viddler will use to mount the player
     * @type {String}
     */_this.selector=_this.getId(props.id);/**
     * The height of the video - used to prevent the modal resizing to zero
     * @type {Number}
     */_this.videoHeight=300;_this.videoReadyCallback=_this.videoReadyCallback.bind(_this);return _this;}/**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */(0,_createClass3.default)(Video,[{key:'componentDidMount',value:function componentDidMount(){this.refs.videoContainer.style.height=this.videoHeight+'px';this.player=new ViddlerEmbed({target:'#'+this.selector,videoId:this.props.videoId,width:this.props.width});this.player.manager.events.on('gui:ready',this.videoReadyCallback);}/**
   * Lifecycle Method
   * @param {Object} newProps The new passed in props
   * @return {Undefined} Returns nothing
   */},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){if(this.props.videoId!==newProps.videoId){this.refs.videoContainer.style.height=this.videoHeight+'px';this.refs.videoContainer.innerHTML='';}}/**
   * Lifecycle Method
   * @param {Object} prevProps The previous passed in props
   * @return {Undefined} Returns nothing
   */},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.videoId!==prevProps.videoId){this.player=new ViddlerEmbed({target:'#'+this.selector,videoId:this.props.videoId,width:this.props.width});this.player.manager.events.on('gui:ready',this.videoReadyCallback);}}/**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){this.player=null;}/**
   * Constructs the id selector for the Viddler player
   * @param  {String} id The main id
   * @return {String} The constructed id
   */},{key:'getId',value:function getId(id){var displayId=id?id:'Video';return displayId+'_video';}/**
   * Callback for Viddler for when it's ready to play
   * @return {Undefined} Returns nothing
   */},{key:'videoReadyCallback',value:function videoReadyCallback(){if(this.refs.videoContainer){this.videoHeight=this.refs.videoContainer.clientHeight;this.refs.videoContainer.style.height='auto';if(this.props.videoReadyCallback){this.props.videoReadyCallback();}}}/**
   * React Component render
   * @return {JSX} Video rendered
   */},{key:'render',value:function render(){return _react2.default.createElement('div',{id:this.selector,ref:'videoContainer'});}}]);return Video;}(_react2.default.Component);/* global ViddlerEmbed */Video.propTypes={id:_react2.default.PropTypes.string.isRequired,videoId:_react2.default.PropTypes.string.isRequired,videoReadyCallback:_react2.default.PropTypes.func,width:_react2.default.PropTypes.string};Video.defaultProps={width:'100%'};exports.default=Video;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Button=__webpack_require__(232);var _Button2=_interopRequireDefault(_Button);var _Dropdown=__webpack_require__(1178);var _Dropdown2=_interopRequireDefault(_Dropdown);var _SelectList=__webpack_require__(1183);var _SelectList2=_interopRequireDefault(_SelectList);var _TextArea=__webpack_require__(1185);var _TextArea2=_interopRequireDefault(_TextArea);var _TextInput=__webpack_require__(1187);var _TextInput2=_interopRequireDefault(_TextInput);var _EnhancedTextInput=__webpack_require__(535);var _EnhancedTextInput2=_interopRequireDefault(_EnhancedTextInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={Button:_Button2.default,Dropdown:_Dropdown2.default,SelectList:_SelectList2.default,TextArea:_TextArea2.default,TextInput:_TextInput2.default,EnhancedTextInput:_EnhancedTextInput2.default};

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled"};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactTether=__webpack_require__(1179);var _reactTether2=_interopRequireDefault(_reactTether);var _Dropdown=__webpack_require__(1182);var _Dropdown2=_interopRequireDefault(_Dropdown);var _Button=__webpack_require__(232);var _Button2=_interopRequireDefault(_Button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Dropdown module
 *//* eslint-disable react/no-danger */var Dropdown=function(_React$Component){(0,_inherits3.default)(Dropdown,_React$Component);/**
   * Dropdown Component Constructor
   * @param  {Object} props Passed in Properties
   * @return {Undefined} Returns nothing
   */function Dropdown(props){(0,_classCallCheck3.default)(this,Dropdown);var _this=(0,_possibleConstructorReturn3.default)(this,(Dropdown.__proto__||(0,_getPrototypeOf2.default)(Dropdown)).call(this,props));_this.focusedIndex=-1;_this.closeDropdown=_this.closeDropdown.bind(_this);_this.handleClick=_this.handleClick.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);return _this;}/**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */(0,_createClass3.default)(Dropdown,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('click',this.closeDropdown);window.addEventListener('keydown',this.handleKeyDown);}/**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.closeDropdown);window.removeEventListener('keydown',this.handleKeyDown);}/**
   * Creates string containing the proper classes
   * @param  {String} classes Additional classes to be appended
   * @return {String} The formatted class string
   */},{key:'getBtnClasses',value:function getBtnClasses(classes){var open=this.props.isDropdownToggled?' '+_Dropdown2.default.open:'';var appended=classes?' '+classes:'';return''+_Dropdown2.default.dropdownBtn+open+appended;}/**
   * Returns the chevron to display based on dropdown state
   * @param  {Boolean} isDropdownToggled If the dropdown is open or closed
   * @return {String} SVG source
   */},{key:'getChevron',value:function getChevron(){return'<svg version="1.1" id="Layer_1" xmlns="https://www.w3.org/2000/svg"\n        xmlns:xlink="https://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.3 8.3"\n        style="enable-background:new 0 0 12.3 8.3;" xml:space="preserve">\n        <style type="text/css">\n    \t    .st3{fill:currentColor;}\n        </style>\n        <g>\n    \t    <polygon class="st3" points="6.2,7.8 0.5,2.7 2.5,0.5 6.2,3.8 9.8,0.5 11.8,2.7 \t"/>\n        </g>\n      </svg>';}/**
   * Formats the id if one is present in props
   * @param  {String} id The id string
   * @return {String} The constructed id
   */},{key:'getId',value:function getId(id){return id?id+'_dropdown':'';}/**
   * Handler for when the dropdown button is clicked
   * @param  {Object} e The click event
   * @return {Undefined} Returns nothing
   */},{key:'handleClick',value:function handleClick(e){if(this.props.isDropdownToggled){this.focusedIndex=-1;}this.props.toggleDropdown(e);}/**
   * Handler for tracking keyboard events related to dropdown actions
   * Escape closes the dropdown, and the arrow keys and tabbing navigates through the menu
   * @param  {Object} e The Event object
   * @return {Undefined} Returns nothing
   */},{key:'handleKeyDown',value:function handleKeyDown(e){var code=e.keyCode?e.keyCode:e.which;var ARROW_UP=38;var ARROW_DOWN=40;var ESC=27;var TAB=9;if(this.props.isDropdownToggled){if(code===ESC){this.focusedIndex=-1;this.refs.dropdown.getElementsByTagName('button')[0].focus();this.props.toggleDropdown(e);}else if(code===ARROW_UP||code===ARROW_DOWN){e.preventDefault();var links=this.refs.dropdownList.getElementsByTagName('a');this.focusedIndex=this.calcFocusedIndex(this.focusedIndex,links.length,code===ARROW_UP);links[this.focusedIndex].focus();}else if(code===TAB){e.preventDefault();var _links=this.refs.dropdownList.getElementsByTagName('a');var length=_links.length-1;if(e.shiftKey){this.focusedIndex--;}else{this.focusedIndex++;}if(this.focusedIndex>length||this.focusedIndex<0){this.focusedIndex=-1;this.refs.dropdown.getElementsByTagName('button')[0].focus();this.props.toggleDropdown(e);}else{_links[this.focusedIndex].focus();}}}}/**
   * Calculates the index that should be focused on
   * @param  {Number}  currIndex The current focused index
   * @param  {Number}  length    The length of dropdown items
   * @param  {Boolean} isUp      If the direction of focus should be up or down
   * @return {Number} The new index
   */},{key:'calcFocusedIndex',value:function calcFocusedIndex(currIndex,length,isUp){var newIndex=isUp?currIndex-1:currIndex+1;if(newIndex<0){newIndex=0;}else if(newIndex>length-1){newIndex=length-1;}return newIndex;}/**
   * Handler for closing the dropdown when outside the dropdown is clicked
   * @param  {Object} e The Event object
   * @return {Undefined} Returns nothing
   */},{key:'closeDropdown',value:function closeDropdown(e){if(this.props.isDropdownToggled){var dropdown=this.refs.dropdown;if(!dropdown.contains(e.target)){this.focusedIndex=-1;this.props.toggleDropdown(e);}}}/**
   * React Component render
   * @return {JSX} Modal rendered
   */},{key:'render',value:function render(){var _props=this.props,btnClassName=_props.btnClassName,className=_props.className,displayText=_props.displayText,id=_props.id,isDropdownToggled=_props.isDropdownToggled;var displayId=this.getId(id);return _react2.default.createElement('div',{className:''+_Dropdown2.default.Dropdown+(className?' '+className:null),id:displayId,ref:'dropdown'},_react2.default.createElement(_reactTether2.default,{attachment:this.props.tetherAttachment,classes:this.props.tetherClasses,offset:this.props.tetherOffset,targetAttachment:this.props.tetherTargetAttachment},_react2.default.createElement(_Button2.default,{ariaExpanded:''+isDropdownToggled,ariaHaspopup:'true',className:this.getBtnClasses(btnClassName),handleClick:this.handleClick,id:displayId},displayText?displayText+' ':'',_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:this.getChevron()}})),isDropdownToggled?_react2.default.createElement('ul',{'aria-labelledby':displayId+'_button',ref:'dropdownList'},this.props.dropdownItems.map(function(item,key){return _react2.default.createElement('li',{key:'dropdown-item-'+key},_react2.default.createElement('a',item.props,item.displayText));})):null));}}]);return Dropdown;}(_react2.default.Component);Dropdown.propTypes={btnClassName:_react2.default.PropTypes.string,className:_react2.default.PropTypes.string,displayText:_react2.default.PropTypes.string,dropdownItems:_react2.default.PropTypes.array,id:_react2.default.PropTypes.string,isDropdownToggled:_react2.default.PropTypes.bool,tetherAttachment:_react2.default.PropTypes.string,tetherClasses:_react2.default.PropTypes.object,tetherOffset:_react2.default.PropTypes.string,tetherTargetAttachment:_react2.default.PropTypes.string,toggleDropdown:_react2.default.PropTypes.func.isRequired};Dropdown.defaultProps={isDropdownToggled:false,tetherAttachment:'top left',tetherClasses:{element:_Dropdown2.default.dropdown},tetherOffset:'0 0',tetherTargetAttachment:'bottom left'};exports.default=Dropdown;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _TetherComponent = __webpack_require__(1180);

var _TetherComponent2 = _interopRequireDefault(_TetherComponent);

exports['default'] = _TetherComponent2['default'];
module.exports = exports['default'];

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(59);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _tether = __webpack_require__(1181);

var _tether2 = _interopRequireDefault(_tether);

if (!_tether2['default']) {
  console.error('It looks like Tether has not been included. Please load this dependency first https://github.com/HubSpot/tether');
}

var renderElementToPropTypes = [_react.PropTypes.string, _react.PropTypes.shape({
  appendChild: _react.PropTypes.func.isRequired
})];

var childrenPropType = function childrenPropType(_ref, propName, componentName) {
  var children = _ref.children;

  var childCount = _react.Children.count(children);
  if (childCount <= 0) {
    return new Error(componentName + ' expects at least one child to use as the target element.');
  } else if (childCount > 2) {
    return new Error('Only a max of two children allowed in ' + componentName + '.');
  }
};

var attachmentPositions = ['top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right'];

var TetherComponent = (function (_Component) {
  _inherits(TetherComponent, _Component);

  function TetherComponent() {
    _classCallCheck(this, TetherComponent);

    _get(Object.getPrototypeOf(TetherComponent.prototype), 'constructor', this).apply(this, arguments);

    this._targetNode = null;
    this._elementParentNode = null;
    this._tether = false;
  }

  _createClass(TetherComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._targetNode = _reactDom2['default'].findDOMNode(this);
      this._update();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this._update();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroy();
    }
  }, {
    key: 'disable',
    value: function disable() {
      this._tether.disable();
    }
  }, {
    key: 'enable',
    value: function enable() {
      this._tether.enable();
    }
  }, {
    key: 'position',
    value: function position() {
      this._tether.position();
    }
  }, {
    key: '_destroy',
    value: function _destroy() {
      if (this._elementParentNode) {
        _reactDom2['default'].unmountComponentAtNode(this._elementParentNode);
        this._elementParentNode.parentNode.removeChild(this._elementParentNode);
      }

      if (this._tether) {
        this._tether.destroy();
      }

      this._elementParentNode = null;
      this._tether = null;
    }
  }, {
    key: '_update',
    value: function _update() {
      var _this = this;

      var _props = this.props;
      var children = _props.children;
      var renderElementTag = _props.renderElementTag;

      var elementComponent = _react.Children.toArray(children)[1];

      // if no element component provided, bail out
      if (!elementComponent) {
        // destroy Tether element if it has been created
        if (this._tether) {
          this._destroy();
        }
        return;
      }

      // create element node container if it hasn't been yet
      if (!this._elementParentNode) {
        // create a node that we can stick our content Component in
        this._elementParentNode = document.createElement(renderElementTag);

        // append node to the render node
        this._renderNode.appendChild(this._elementParentNode);
      }

      // render element component into the DOM
      _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, elementComponent, this._elementParentNode, function () {
        // don't update Tether until the subtree has finished rendering
        _this._updateTether();
      });
    }
  }, {
    key: '_updateTether',
    value: function _updateTether() {
      var _this2 = this;

      var _props2 = this.props;
      var children = _props2.children;
      var renderElementTag = _props2.renderElementTag;
      var renderElementTo = _props2.renderElementTo;
      var id = _props2.id;
      var className = _props2.className;
      var style = _props2.style;

      var options = _objectWithoutProperties(_props2, ['children', 'renderElementTag', 'renderElementTo', 'id', 'className', 'style']);

      var tetherOptions = _extends({
        target: this._targetNode,
        element: this._elementParentNode
      }, options);

      if (id) {
        this._elementParentNode.id = id;
      }

      if (className) {
        this._elementParentNode.className = className;
      }

      if (style) {
        Object.keys(style).forEach(function (key) {
          _this2._elementParentNode.style[key] = style[key];
        });
      }

      if (!this._tether) {
        this._tether = new _tether2['default'](tetherOptions);
      } else {
        this._tether.setOptions(tetherOptions);
      }

      this._tether.position();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.toArray(this.props.children)[0];
    }
  }, {
    key: '_renderNode',
    get: function get() {
      var renderElementTo = this.props.renderElementTo;

      if (typeof renderElementTo === 'string') {
        return document.querySelector(renderElementTo);
      } else {
        return renderElementTo || document.body;
      }
    }
  }], [{
    key: 'propTypes',
    value: {
      renderElementTag: _react.PropTypes.string,
      renderElementTo: _react.PropTypes.oneOfType(renderElementToPropTypes),
      attachment: _react.PropTypes.oneOf(attachmentPositions).isRequired,
      targetAttachment: _react.PropTypes.oneOf(attachmentPositions),
      offset: _react.PropTypes.string,
      targetOffset: _react.PropTypes.string,
      targetModifier: _react.PropTypes.string,
      enabled: _react.PropTypes.bool,
      classes: _react.PropTypes.object,
      classPrefix: _react.PropTypes.string,
      optimizations: _react.PropTypes.object,
      constraints: _react.PropTypes.array,
      id: _react.PropTypes.string,
      className: _react.PropTypes.string,
      style: _react.PropTypes.object,
      children: childrenPropType
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      renderElementTag: 'div',
      renderElementTo: null
    },
    enumerable: true
  }]);

  return TetherComponent;
})(_react.Component);

exports['default'] = TetherComponent;
module.exports = exports['default'];

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 1.4.3 */

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require, exports, module);
  } else {
    root.Tether = factory();
  }
}(this, function(require, exports, module) {

'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var TetherBase = undefined;
if (typeof TetherBase === 'undefined') {
  TetherBase = { modules: [] };
}

var zeroElement = null;

// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
// if the element lies within a nested document (<frame> or <iframe>-like).
function getActualBoundingClientRect(node) {
  var boundingRect = node.getBoundingClientRect();

  // The original object returned by getBoundingClientRect is immutable, so we clone it
  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
  var rect = {};
  for (var k in boundingRect) {
    rect[k] = boundingRect[k];
  }

  if (node.ownerDocument !== document) {
    var _frameElement = node.ownerDocument.defaultView.frameElement;
    if (_frameElement) {
      var frameRect = getActualBoundingClientRect(_frameElement);
      rect.top += frameRect.top;
      rect.bottom += frameRect.top;
      rect.left += frameRect.left;
      rect.right += frameRect.left;
    }
  }

  return rect;
}

function getScrollParents(el) {
  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  var computedStyle = getComputedStyle(el) || {};
  var position = computedStyle.position;
  var parents = [];

  if (position === 'fixed') {
    return [el];
  }

  var parent = el;
  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
    var style = undefined;
    try {
      style = getComputedStyle(parent);
    } catch (err) {}

    if (typeof style === 'undefined' || style === null) {
      parents.push(parent);
      return parents;
    }

    var _style = style;
    var overflow = _style.overflow;
    var overflowX = _style.overflowX;
    var overflowY = _style.overflowY;

    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
        parents.push(parent);
      }
    }
  }

  parents.push(el.ownerDocument.body);

  // If the node is within a frame, account for the parent window scroll
  if (el.ownerDocument !== document) {
    parents.push(el.ownerDocument.defaultView);
  }

  return parents;
}

var uniqueId = (function () {
  var id = 0;
  return function () {
    return ++id;
  };
})();

var zeroPosCache = {};
var getOrigin = function getOrigin() {
  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
  // jitter as the user scrolls that messes with our ability to detect if two positions
  // are equivilant or not.  We place an element at the top left of the page that will
  // get the same jitter, so we can cancel the two out.
  var node = zeroElement;
  if (!node || !document.body.contains(node)) {
    node = document.createElement('div');
    node.setAttribute('data-tether-id', uniqueId());
    extend(node.style, {
      top: 0,
      left: 0,
      position: 'absolute'
    });

    document.body.appendChild(node);

    zeroElement = node;
  }

  var id = node.getAttribute('data-tether-id');
  if (typeof zeroPosCache[id] === 'undefined') {
    zeroPosCache[id] = getActualBoundingClientRect(node);

    // Clear the cache when this position call is done
    defer(function () {
      delete zeroPosCache[id];
    });
  }

  return zeroPosCache[id];
};

function removeUtilElements() {
  if (zeroElement) {
    document.body.removeChild(zeroElement);
  }
  zeroElement = null;
};

function getBounds(el) {
  var doc = undefined;
  if (el === document) {
    doc = document;
    el = document.documentElement;
  } else {
    doc = el.ownerDocument;
  }

  var docEl = doc.documentElement;

  var box = getActualBoundingClientRect(el);

  var origin = getOrigin();

  box.top -= origin.top;
  box.left -= origin.left;

  if (typeof box.width === 'undefined') {
    box.width = document.body.scrollWidth - box.left - box.right;
  }
  if (typeof box.height === 'undefined') {
    box.height = document.body.scrollHeight - box.top - box.bottom;
  }

  box.top = box.top - docEl.clientTop;
  box.left = box.left - docEl.clientLeft;
  box.right = doc.body.clientWidth - box.width - box.left;
  box.bottom = doc.body.clientHeight - box.height - box.top;

  return box;
}

function getOffsetParent(el) {
  return el.offsetParent || document.documentElement;
}

var _scrollBarSize = null;
function getScrollBarSize() {
  if (_scrollBarSize) {
    return _scrollBarSize;
  }
  var inner = document.createElement('div');
  inner.style.width = '100%';
  inner.style.height = '200px';

  var outer = document.createElement('div');
  extend(outer.style, {
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });

  outer.appendChild(inner);

  document.body.appendChild(outer);

  var widthContained = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var widthScroll = inner.offsetWidth;

  if (widthContained === widthScroll) {
    widthScroll = outer.clientWidth;
  }

  document.body.removeChild(outer);

  var width = widthContained - widthScroll;

  _scrollBarSize = { width: width, height: width };
  return _scrollBarSize;
}

function extend() {
  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var args = [];

  Array.prototype.push.apply(args, arguments);

  args.slice(1).forEach(function (obj) {
    if (obj) {
      for (var key in obj) {
        if (({}).hasOwnProperty.call(obj, key)) {
          out[key] = obj[key];
        }
      }
    }
  });

  return out;
}

function removeClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.remove(cls);
      }
    });
  } else {
    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
    var className = getClassName(el).replace(regex, ' ');
    setClassName(el, className);
  }
}

function addClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.add(cls);
      }
    });
  } else {
    removeClass(el, name);
    var cls = getClassName(el) + (' ' + name);
    setClassName(el, cls);
  }
}

function hasClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    return el.classList.contains(name);
  }
  var className = getClassName(el);
  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
}

function getClassName(el) {
  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
  // completely separately SVGAnimatedString base classes
  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
    return el.className.baseVal;
  }
  return el.className;
}

function setClassName(el, className) {
  el.setAttribute('class', className);
}

function updateClasses(el, add, all) {
  // Of the set of 'all' classes, we need the 'add' classes, and only the
  // 'add' classes to be set.
  all.forEach(function (cls) {
    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
      removeClass(el, cls);
    }
  });

  add.forEach(function (cls) {
    if (!hasClass(el, cls)) {
      addClass(el, cls);
    }
  });
}

var deferred = [];

var defer = function defer(fn) {
  deferred.push(fn);
};

var flush = function flush() {
  var fn = undefined;
  while (fn = deferred.pop()) {
    fn();
  }
};

var Evented = (function () {
  function Evented() {
    _classCallCheck(this, Evented);
  }

  _createClass(Evented, [{
    key: 'on',
    value: function on(event, handler, ctx) {
      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

      if (typeof this.bindings === 'undefined') {
        this.bindings = {};
      }
      if (typeof this.bindings[event] === 'undefined') {
        this.bindings[event] = [];
      }
      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
    }
  }, {
    key: 'once',
    value: function once(event, handler, ctx) {
      this.on(event, handler, ctx, true);
    }
  }, {
    key: 'off',
    value: function off(event, handler) {
      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
        return;
      }

      if (typeof handler === 'undefined') {
        delete this.bindings[event];
      } else {
        var i = 0;
        while (i < this.bindings[event].length) {
          if (this.bindings[event][i].handler === handler) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(event) {
      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
        var i = 0;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        while (i < this.bindings[event].length) {
          var _bindings$event$i = this.bindings[event][i];
          var handler = _bindings$event$i.handler;
          var ctx = _bindings$event$i.ctx;
          var once = _bindings$event$i.once;

          var context = ctx;
          if (typeof context === 'undefined') {
            context = this;
          }

          handler.apply(context, args);

          if (once) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }]);

  return Evented;
})();

TetherBase.Utils = {
  getActualBoundingClientRect: getActualBoundingClientRect,
  getScrollParents: getScrollParents,
  getBounds: getBounds,
  getOffsetParent: getOffsetParent,
  extend: extend,
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  updateClasses: updateClasses,
  defer: defer,
  flush: flush,
  uniqueId: uniqueId,
  Evented: Evented,
  getScrollBarSize: getScrollBarSize,
  removeUtilElements: removeUtilElements
};
/* globals TetherBase, performance */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (typeof TetherBase === 'undefined') {
  throw new Error('You must include the utils.js file before tether.js');
}

var _TetherBase$Utils = TetherBase.Utils;
var getScrollParents = _TetherBase$Utils.getScrollParents;
var getBounds = _TetherBase$Utils.getBounds;
var getOffsetParent = _TetherBase$Utils.getOffsetParent;
var extend = _TetherBase$Utils.extend;
var addClass = _TetherBase$Utils.addClass;
var removeClass = _TetherBase$Utils.removeClass;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;
var flush = _TetherBase$Utils.flush;
var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
var removeUtilElements = _TetherBase$Utils.removeUtilElements;

function within(a, b) {
  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

  return a + diff >= b && b >= a - diff;
}

var transformKey = (function () {
  if (typeof document === 'undefined') {
    return '';
  }
  var el = document.createElement('div');

  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
  for (var i = 0; i < transforms.length; ++i) {
    var key = transforms[i];
    if (el.style[key] !== undefined) {
      return key;
    }
  }
})();

var tethers = [];

var position = function position() {
  tethers.forEach(function (tether) {
    tether.position(false);
  });
  flush();
};

function now() {
  if (typeof performance === 'object' && typeof performance.now === 'function') {
    return performance.now();
  }
  return +new Date();
}

(function () {
  var lastCall = null;
  var lastDuration = null;
  var pendingTimeout = null;

  var tick = function tick() {
    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
      // We voluntarily throttle ourselves if we can't manage 60fps
      lastDuration = Math.min(lastDuration - 16, 250);

      // Just in case this is the last event, remember to position just once more
      pendingTimeout = setTimeout(tick, 250);
      return;
    }

    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
      // Some browsers call events a little too frequently, refuse to run more than is reasonable
      return;
    }

    if (pendingTimeout != null) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }

    lastCall = now();
    position();
    lastDuration = now() - lastCall;
  };

  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
      window.addEventListener(event, tick);
    });
  }
})();

var MIRROR_LR = {
  center: 'center',
  left: 'right',
  right: 'left'
};

var MIRROR_TB = {
  middle: 'middle',
  top: 'bottom',
  bottom: 'top'
};

var OFFSET_MAP = {
  top: 0,
  left: 0,
  middle: '50%',
  center: '50%',
  bottom: '100%',
  right: '100%'
};

var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (left === 'auto') {
    left = MIRROR_LR[relativeToAttachment.left];
  }

  if (top === 'auto') {
    top = MIRROR_TB[relativeToAttachment.top];
  }

  return { left: left, top: top };
};

var attachmentToOffset = function attachmentToOffset(attachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
    left = OFFSET_MAP[attachment.left];
  }

  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
    top = OFFSET_MAP[attachment.top];
  }

  return { left: left, top: top };
};

function addOffset() {
  var out = { top: 0, left: 0 };

  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
    offsets[_key] = arguments[_key];
  }

  offsets.forEach(function (_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (typeof top === 'string') {
      top = parseFloat(top, 10);
    }
    if (typeof left === 'string') {
      left = parseFloat(left, 10);
    }

    out.top += top;
    out.left += left;
  });

  return out;
}

function offsetToPx(offset, size) {
  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
  }
  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
  }

  return offset;
}

var parseOffset = function parseOffset(value) {
  var _value$split = value.split(' ');

  var _value$split2 = _slicedToArray(_value$split, 2);

  var top = _value$split2[0];
  var left = _value$split2[1];

  return { top: top, left: left };
};
var parseAttachment = parseOffset;

var TetherClass = (function (_Evented) {
  _inherits(TetherClass, _Evented);

  function TetherClass(options) {
    var _this = this;

    _classCallCheck(this, TetherClass);

    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
    this.position = this.position.bind(this);

    tethers.push(this);

    this.history = [];

    this.setOptions(options, false);

    TetherBase.modules.forEach(function (module) {
      if (typeof module.initialize !== 'undefined') {
        module.initialize.call(_this);
      }
    });

    this.position();
  }

  _createClass(TetherClass, [{
    key: 'getClass',
    value: function getClass() {
      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
      var classes = this.options.classes;

      if (typeof classes !== 'undefined' && classes[key]) {
        return this.options.classes[key];
      } else if (this.options.classPrefix) {
        return this.options.classPrefix + '-' + key;
      } else {
        return key;
      }
    }
  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      var _this2 = this;

      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

      var defaults = {
        offset: '0 0',
        targetOffset: '0 0',
        targetAttachment: 'auto auto',
        classPrefix: 'tether'
      };

      this.options = extend(defaults, options);

      var _options = this.options;
      var element = _options.element;
      var target = _options.target;
      var targetModifier = _options.targetModifier;

      this.element = element;
      this.target = target;
      this.targetModifier = targetModifier;

      if (this.target === 'viewport') {
        this.target = document.body;
        this.targetModifier = 'visible';
      } else if (this.target === 'scroll-handle') {
        this.target = document.body;
        this.targetModifier = 'scroll-handle';
      }

      ['element', 'target'].forEach(function (key) {
        if (typeof _this2[key] === 'undefined') {
          throw new Error('Tether Error: Both element and target must be defined');
        }

        if (typeof _this2[key].jquery !== 'undefined') {
          _this2[key] = _this2[key][0];
        } else if (typeof _this2[key] === 'string') {
          _this2[key] = document.querySelector(_this2[key]);
        }
      });

      addClass(this.element, this.getClass('element'));
      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('target'));
      }

      if (!this.options.attachment) {
        throw new Error('Tether Error: You must provide an attachment');
      }

      this.targetAttachment = parseAttachment(this.options.targetAttachment);
      this.attachment = parseAttachment(this.options.attachment);
      this.offset = parseOffset(this.options.offset);
      this.targetOffset = parseOffset(this.options.targetOffset);

      if (typeof this.scrollParents !== 'undefined') {
        this.disable();
      }

      if (this.targetModifier === 'scroll-handle') {
        this.scrollParents = [this.target];
      } else {
        this.scrollParents = getScrollParents(this.target);
      }

      if (!(this.options.enabled === false)) {
        this.enable(pos);
      }
    }
  }, {
    key: 'getTargetBounds',
    value: function getTargetBounds() {
      if (typeof this.targetModifier !== 'undefined') {
        if (this.targetModifier === 'visible') {
          if (this.target === document.body) {
            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
          } else {
            var bounds = getBounds(this.target);

            var out = {
              height: bounds.height,
              width: bounds.width,
              top: bounds.top,
              left: bounds.left
            };

            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
            out.height = Math.min(innerHeight, out.height);
            out.height -= 2;

            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
            out.width = Math.min(innerWidth, out.width);
            out.width -= 2;

            if (out.top < pageYOffset) {
              out.top = pageYOffset;
            }
            if (out.left < pageXOffset) {
              out.left = pageXOffset;
            }

            return out;
          }
        } else if (this.targetModifier === 'scroll-handle') {
          var bounds = undefined;
          var target = this.target;
          if (target === document.body) {
            target = document.documentElement;

            bounds = {
              left: pageXOffset,
              top: pageYOffset,
              height: innerHeight,
              width: innerWidth
            };
          } else {
            bounds = getBounds(target);
          }

          var style = getComputedStyle(target);

          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;

          var scrollBottom = 0;
          if (hasBottomScroll) {
            scrollBottom = 15;
          }

          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;

          var out = {
            width: 15,
            height: height * 0.975 * (height / target.scrollHeight),
            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
          };

          var fitAdj = 0;
          if (height < 408 && this.target === document.body) {
            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
          }

          if (this.target !== document.body) {
            out.height = Math.max(out.height, 24);
          }

          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);

          if (this.target === document.body) {
            out.height = Math.max(out.height, 24);
          }

          return out;
        }
      } else {
        return getBounds(this.target);
      }
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this._cache = {};
    }
  }, {
    key: 'cache',
    value: function cache(k, getter) {
      // More than one module will often need the same DOM info, so
      // we keep a cache which is cleared on each position call
      if (typeof this._cache === 'undefined') {
        this._cache = {};
      }

      if (typeof this._cache[k] === 'undefined') {
        this._cache[k] = getter.call(this);
      }

      return this._cache[k];
    }
  }, {
    key: 'enable',
    value: function enable() {
      var _this3 = this;

      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('enabled'));
      }
      addClass(this.element, this.getClass('enabled'));
      this.enabled = true;

      this.scrollParents.forEach(function (parent) {
        if (parent !== _this3.target.ownerDocument) {
          parent.addEventListener('scroll', _this3.position);
        }
      });

      if (pos) {
        this.position();
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      var _this4 = this;

      removeClass(this.target, this.getClass('enabled'));
      removeClass(this.element, this.getClass('enabled'));
      this.enabled = false;

      if (typeof this.scrollParents !== 'undefined') {
        this.scrollParents.forEach(function (parent) {
          parent.removeEventListener('scroll', _this4.position);
        });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this5 = this;

      this.disable();

      tethers.forEach(function (tether, i) {
        if (tether === _this5) {
          tethers.splice(i, 1);
        }
      });

      // Remove any elements we were using for convenience from the DOM
      if (tethers.length === 0) {
        removeUtilElements();
      }
    }
  }, {
    key: 'updateAttachClasses',
    value: function updateAttachClasses(elementAttach, targetAttach) {
      var _this6 = this;

      elementAttach = elementAttach || this.attachment;
      targetAttach = targetAttach || this.targetAttachment;
      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];

      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
        // updateAttachClasses can be called more than once in a position call, so
        // we need to clean up after ourselves such that when the last defer gets
        // ran it doesn't add any extra classes from previous calls.
        this._addAttachClasses.splice(0, this._addAttachClasses.length);
      }

      if (typeof this._addAttachClasses === 'undefined') {
        this._addAttachClasses = [];
      }
      var add = this._addAttachClasses;

      if (elementAttach.top) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
      }
      if (elementAttach.left) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
      }
      if (targetAttach.top) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
      }
      if (targetAttach.left) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
      }

      var all = [];
      sides.forEach(function (side) {
        all.push(_this6.getClass('element-attached') + '-' + side);
        all.push(_this6.getClass('target-attached') + '-' + side);
      });

      defer(function () {
        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
          return;
        }

        updateClasses(_this6.element, _this6._addAttachClasses, all);
        if (!(_this6.options.addTargetClasses === false)) {
          updateClasses(_this6.target, _this6._addAttachClasses, all);
        }

        delete _this6._addAttachClasses;
      });
    }
  }, {
    key: 'position',
    value: function position() {
      var _this7 = this;

      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
      // tethers (in which case call Tether.Utils.flush yourself when you're done)

      if (!this.enabled) {
        return;
      }

      this.clearCache();

      // Turn 'auto' attachments into the appropriate corner or edge
      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);

      this.updateAttachClasses(this.attachment, targetAttachment);

      var elementPos = this.cache('element-bounds', function () {
        return getBounds(_this7.element);
      });

      var width = elementPos.width;
      var height = elementPos.height;

      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
        var _lastSize = this.lastSize;

        // We cache the height and width to make it possible to position elements that are
        // getting hidden.
        width = _lastSize.width;
        height = _lastSize.height;
      } else {
        this.lastSize = { width: width, height: height };
      }

      var targetPos = this.cache('target-bounds', function () {
        return _this7.getTargetBounds();
      });
      var targetSize = targetPos;

      // Get an actual px offset from the attachment
      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);

      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);

      // Add the manually provided offset
      offset = addOffset(offset, manualOffset);
      targetOffset = addOffset(targetOffset, manualTargetOffset);

      // It's now our goal to make (element position + offset) == (target position + target offset)
      var left = targetPos.left + targetOffset.left - offset.left;
      var top = targetPos.top + targetOffset.top - offset.top;

      for (var i = 0; i < TetherBase.modules.length; ++i) {
        var _module2 = TetherBase.modules[i];
        var ret = _module2.position.call(this, {
          left: left,
          top: top,
          targetAttachment: targetAttachment,
          targetPos: targetPos,
          elementPos: elementPos,
          offset: offset,
          targetOffset: targetOffset,
          manualOffset: manualOffset,
          manualTargetOffset: manualTargetOffset,
          scrollbarSize: scrollbarSize,
          attachment: this.attachment
        });

        if (ret === false) {
          return false;
        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
          continue;
        } else {
          top = ret.top;
          left = ret.left;
        }
      }

      // We describe the position three different ways to give the optimizer
      // a chance to decide the best possible way to position the element
      // with the fewest repaints.
      var next = {
        // It's position relative to the page (absolute positioning when
        // the element is a child of the body)
        page: {
          top: top,
          left: left
        },

        // It's position relative to the viewport (fixed positioning)
        viewport: {
          top: top - pageYOffset,
          bottom: pageYOffset - top - height + innerHeight,
          left: left - pageXOffset,
          right: pageXOffset - left - width + innerWidth
        }
      };

      var doc = this.target.ownerDocument;
      var win = doc.defaultView;

      var scrollbarSize = undefined;
      if (win.innerHeight > doc.documentElement.clientHeight) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.bottom -= scrollbarSize.height;
      }

      if (win.innerWidth > doc.documentElement.clientWidth) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.right -= scrollbarSize.width;
      }

      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
        next.page.bottom = doc.body.scrollHeight - top - height;
        next.page.right = doc.body.scrollWidth - left - width;
      }

      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
        (function () {
          var offsetParent = _this7.cache('target-offsetparent', function () {
            return getOffsetParent(_this7.target);
          });
          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
            return getBounds(offsetParent);
          });
          var offsetParentStyle = getComputedStyle(offsetParent);
          var offsetParentSize = offsetPosition;

          var offsetBorder = {};
          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
          });

          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;

          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
              // We're within the visible part of the target's scroll parent
              var scrollTop = offsetParent.scrollTop;
              var scrollLeft = offsetParent.scrollLeft;

              // It's position relative to the target's offset parent (absolute positioning when
              // the element is moved to be a child of the target's offset parent).
              next.offset = {
                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
              };
            }
          }
        })();
      }

      // We could also travel up the DOM and try each containing context, rather than only
      // looking at the body, but we're gonna get diminishing returns.

      this.move(next);

      this.history.unshift(next);

      if (this.history.length > 3) {
        this.history.pop();
      }

      if (flushChanges) {
        flush();
      }

      return true;
    }

    // THE ISSUE
  }, {
    key: 'move',
    value: function move(pos) {
      var _this8 = this;

      if (!(typeof this.element.parentNode !== 'undefined')) {
        return;
      }

      var same = {};

      for (var type in pos) {
        same[type] = {};

        for (var key in pos[type]) {
          var found = false;

          for (var i = 0; i < this.history.length; ++i) {
            var point = this.history[i];
            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
              found = true;
              break;
            }
          }

          if (!found) {
            same[type][key] = true;
          }
        }
      }

      var css = { top: '', left: '', right: '', bottom: '' };

      var transcribe = function transcribe(_same, _pos) {
        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
        if (gpu !== false) {
          var yPos = undefined,
              xPos = undefined;
          if (_same.top) {
            css.top = 0;
            yPos = _pos.top;
          } else {
            css.bottom = 0;
            yPos = -_pos.bottom;
          }

          if (_same.left) {
            css.left = 0;
            xPos = _pos.left;
          } else {
            css.right = 0;
            xPos = -_pos.right;
          }

          if (window.matchMedia) {
            // HubSpot/tether#207
            var retina = window.matchMedia('only screen and (min-resolution: 1.3dppx)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3)').matches;
            if (!retina) {
              xPos = Math.round(xPos);
              yPos = Math.round(yPos);
            }
          }

          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';

          if (transformKey !== 'msTransform') {
            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
            // but IE9 doesn't support 3d transforms and will choke.
            css[transformKey] += " translateZ(0)";
          }
        } else {
          if (_same.top) {
            css.top = _pos.top + 'px';
          } else {
            css.bottom = _pos.bottom + 'px';
          }

          if (_same.left) {
            css.left = _pos.left + 'px';
          } else {
            css.right = _pos.right + 'px';
          }
        }
      };

      var moved = false;
      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
        css.position = 'absolute';
        transcribe(same.page, pos.page);
      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
        css.position = 'fixed';
        transcribe(same.viewport, pos.viewport);
      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
        (function () {
          css.position = 'absolute';
          var offsetParent = _this8.cache('target-offsetparent', function () {
            return getOffsetParent(_this8.target);
          });

          if (getOffsetParent(_this8.element) !== offsetParent) {
            defer(function () {
              _this8.element.parentNode.removeChild(_this8.element);
              offsetParent.appendChild(_this8.element);
            });
          }

          transcribe(same.offset, pos.offset);
          moved = true;
        })();
      } else {
        css.position = 'absolute';
        transcribe({ top: true, left: true }, pos.page);
      }

      if (!moved) {
        if (this.options.bodyElement) {
          if (this.element.parentNode !== this.options.bodyElement) {
            this.options.bodyElement.appendChild(this.element);
          }
        } else {
          var offsetParentIsBody = true;
          var currentNode = this.element.parentNode;
          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY') {
            if (getComputedStyle(currentNode).position !== 'static') {
              offsetParentIsBody = false;
              break;
            }

            currentNode = currentNode.parentNode;
          }

          if (!offsetParentIsBody) {
            this.element.parentNode.removeChild(this.element);
            this.element.ownerDocument.body.appendChild(this.element);
          }
        }
      }

      // Any css change will trigger a repaint, so let's avoid one if nothing changed
      var writeCSS = {};
      var write = false;
      for (var key in css) {
        var val = css[key];
        var elVal = this.element.style[key];

        if (elVal !== val) {
          write = true;
          writeCSS[key] = val;
        }
      }

      if (write) {
        defer(function () {
          extend(_this8.element.style, writeCSS);
          _this8.trigger('repositioned');
        });
      }
    }
  }]);

  return TetherClass;
})(Evented);

TetherClass.modules = [];

TetherBase.position = position;

var Tether = extend(TetherClass, TetherBase);
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var extend = _TetherBase$Utils.extend;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];

function getBoundingRect(tether, to) {
  if (to === 'scrollParent') {
    to = tether.scrollParents[0];
  } else if (to === 'window') {
    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
  }

  if (to === document) {
    to = to.documentElement;
  }

  if (typeof to.nodeType !== 'undefined') {
    (function () {
      var node = to;
      var size = getBounds(to);
      var pos = size;
      var style = getComputedStyle(to);

      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];

      // Account any parent Frames scroll offset
      if (node.ownerDocument !== document) {
        var win = node.ownerDocument.defaultView;
        to[0] += win.pageXOffset;
        to[1] += win.pageYOffset;
        to[2] += win.pageXOffset;
        to[3] += win.pageYOffset;
      }

      BOUNDS_FORMAT.forEach(function (side, i) {
        side = side[0].toUpperCase() + side.substr(1);
        if (side === 'Top' || side === 'Left') {
          to[i] += parseFloat(style['border' + side + 'Width']);
        } else {
          to[i] -= parseFloat(style['border' + side + 'Width']);
        }
      });
    })();
  }

  return to;
}

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;
    var targetAttachment = _ref.targetAttachment;

    if (!this.options.constraints) {
      return true;
    }

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
      var _lastSize = this.lastSize;

      // Handle the item getting hidden as a result of our positioning without glitching
      // the classes in and out
      width = _lastSize.width;
      height = _lastSize.height;
    }

    var targetSize = this.cache('target-bounds', function () {
      return _this.getTargetBounds();
    });

    var targetHeight = targetSize.height;
    var targetWidth = targetSize.width;

    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];

    this.options.constraints.forEach(function (constraint) {
      var outOfBoundsClass = constraint.outOfBoundsClass;
      var pinnedClass = constraint.pinnedClass;

      if (outOfBoundsClass) {
        allClasses.push(outOfBoundsClass);
      }
      if (pinnedClass) {
        allClasses.push(pinnedClass);
      }
    });

    allClasses.forEach(function (cls) {
      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
        allClasses.push(cls + '-' + side);
      });
    });

    var addClasses = [];

    var tAttachment = extend({}, targetAttachment);
    var eAttachment = extend({}, this.attachment);

    this.options.constraints.forEach(function (constraint) {
      var to = constraint.to;
      var attachment = constraint.attachment;
      var pin = constraint.pin;

      if (typeof attachment === 'undefined') {
        attachment = '';
      }

      var changeAttachX = undefined,
          changeAttachY = undefined;
      if (attachment.indexOf(' ') >= 0) {
        var _attachment$split = attachment.split(' ');

        var _attachment$split2 = _slicedToArray(_attachment$split, 2);

        changeAttachY = _attachment$split2[0];
        changeAttachX = _attachment$split2[1];
      } else {
        changeAttachX = changeAttachY = attachment;
      }

      var bounds = getBoundingRect(_this, to);

      if (changeAttachY === 'target' || changeAttachY === 'both') {
        if (top < bounds[1] && tAttachment.top === 'top') {
          top += targetHeight;
          tAttachment.top = 'bottom';
        }

        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
          top -= targetHeight;
          tAttachment.top = 'top';
        }
      }

      if (changeAttachY === 'together') {
        if (tAttachment.top === 'top') {
          if (eAttachment.top === 'bottom' && top < bounds[1]) {
            top += targetHeight;
            tAttachment.top = 'bottom';

            top += height;
            eAttachment.top = 'top';
          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
            top -= height - targetHeight;
            tAttachment.top = 'bottom';

            eAttachment.top = 'bottom';
          }
        }

        if (tAttachment.top === 'bottom') {
          if (eAttachment.top === 'top' && top + height > bounds[3]) {
            top -= targetHeight;
            tAttachment.top = 'top';

            top -= height;
            eAttachment.top = 'bottom';
          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
            top += height - targetHeight;
            tAttachment.top = 'top';

            eAttachment.top = 'top';
          }
        }

        if (tAttachment.top === 'middle') {
          if (top + height > bounds[3] && eAttachment.top === 'top') {
            top -= height;
            eAttachment.top = 'bottom';
          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
            top += height;
            eAttachment.top = 'top';
          }
        }
      }

      if (changeAttachX === 'target' || changeAttachX === 'both') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          left += targetWidth;
          tAttachment.left = 'right';
        }

        if (left + width > bounds[2] && tAttachment.left === 'right') {
          left -= targetWidth;
          tAttachment.left = 'left';
        }
      }

      if (changeAttachX === 'together') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          if (eAttachment.left === 'right') {
            left += targetWidth;
            tAttachment.left = 'right';

            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'left') {
            left += targetWidth;
            tAttachment.left = 'right';

            left -= width;
            eAttachment.left = 'right';
          }
        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
          if (eAttachment.left === 'left') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'right') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left += width;
            eAttachment.left = 'left';
          }
        } else if (tAttachment.left === 'center') {
          if (left + width > bounds[2] && eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (left < bounds[0] && eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          }
        }
      }

      if (changeAttachY === 'element' || changeAttachY === 'both') {
        if (top < bounds[1] && eAttachment.top === 'bottom') {
          top += height;
          eAttachment.top = 'top';
        }

        if (top + height > bounds[3] && eAttachment.top === 'top') {
          top -= height;
          eAttachment.top = 'bottom';
        }
      }

      if (changeAttachX === 'element' || changeAttachX === 'both') {
        if (left < bounds[0]) {
          if (eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'center') {
            left += width / 2;
            eAttachment.left = 'left';
          }
        }

        if (left + width > bounds[2]) {
          if (eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'center') {
            left -= width / 2;
            eAttachment.left = 'right';
          }
        }
      }

      if (typeof pin === 'string') {
        pin = pin.split(',').map(function (p) {
          return p.trim();
        });
      } else if (pin === true) {
        pin = ['top', 'left', 'right', 'bottom'];
      }

      pin = pin || [];

      var pinned = [];
      var oob = [];

      if (top < bounds[1]) {
        if (pin.indexOf('top') >= 0) {
          top = bounds[1];
          pinned.push('top');
        } else {
          oob.push('top');
        }
      }

      if (top + height > bounds[3]) {
        if (pin.indexOf('bottom') >= 0) {
          top = bounds[3] - height;
          pinned.push('bottom');
        } else {
          oob.push('bottom');
        }
      }

      if (left < bounds[0]) {
        if (pin.indexOf('left') >= 0) {
          left = bounds[0];
          pinned.push('left');
        } else {
          oob.push('left');
        }
      }

      if (left + width > bounds[2]) {
        if (pin.indexOf('right') >= 0) {
          left = bounds[2] - width;
          pinned.push('right');
        } else {
          oob.push('right');
        }
      }

      if (pinned.length) {
        (function () {
          var pinnedClass = undefined;
          if (typeof _this.options.pinnedClass !== 'undefined') {
            pinnedClass = _this.options.pinnedClass;
          } else {
            pinnedClass = _this.getClass('pinned');
          }

          addClasses.push(pinnedClass);
          pinned.forEach(function (side) {
            addClasses.push(pinnedClass + '-' + side);
          });
        })();
      }

      if (oob.length) {
        (function () {
          var oobClass = undefined;
          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
            oobClass = _this.options.outOfBoundsClass;
          } else {
            oobClass = _this.getClass('out-of-bounds');
          }

          addClasses.push(oobClass);
          oob.forEach(function (side) {
            addClasses.push(oobClass + '-' + side);
          });
        })();
      }

      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
        eAttachment.left = tAttachment.left = false;
      }
      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
        eAttachment.top = tAttachment.top = false;
      }

      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
        _this.updateAttachClasses(eAttachment, tAttachment);
        _this.trigger('update', {
          attachment: eAttachment,
          targetAttachment: tAttachment
        });
      }
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return { top: top, left: left };
  }
});
/* globals TetherBase */

'use strict';

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    var targetPos = this.getTargetBounds();

    var bottom = top + height;
    var right = left + width;

    var abutted = [];
    if (top <= targetPos.bottom && bottom >= targetPos.top) {
      ['left', 'right'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === left || targetPosSide === right) {
          abutted.push(side);
        }
      });
    }

    if (left <= targetPos.right && right >= targetPos.left) {
      ['top', 'bottom'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === top || targetPosSide === bottom) {
          abutted.push(side);
        }
      });
    }

    var allClasses = [];
    var addClasses = [];

    var sides = ['left', 'top', 'right', 'bottom'];
    allClasses.push(this.getClass('abutted'));
    sides.forEach(function (side) {
      allClasses.push(_this.getClass('abutted') + '-' + side);
    });

    if (abutted.length) {
      addClasses.push(this.getClass('abutted'));
    }

    abutted.forEach(function (side) {
      addClasses.push(_this.getClass('abutted') + '-' + side);
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return true;
  }
});
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

TetherBase.modules.push({
  position: function position(_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (!this.options.shift) {
      return;
    }

    var shift = this.options.shift;
    if (typeof this.options.shift === 'function') {
      shift = this.options.shift.call(this, { top: top, left: left });
    }

    var shiftTop = undefined,
        shiftLeft = undefined;
    if (typeof shift === 'string') {
      shift = shift.split(' ');
      shift[1] = shift[1] || shift[0];

      var _shift = shift;

      var _shift2 = _slicedToArray(_shift, 2);

      shiftTop = _shift2[0];
      shiftLeft = _shift2[1];

      shiftTop = parseFloat(shiftTop, 10);
      shiftLeft = parseFloat(shiftLeft, 10);
    } else {
      shiftTop = shift.top;
      shiftLeft = shift.left;
    }

    top += shiftTop;
    left += shiftLeft;

    return { top: top, left: left };
  }
});
return Tether;

}));


/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Dropdown":"Dropdown","dropdownBtn":"dropdownBtn","open":"open","dropdown":"dropdown"};

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _SelectList=__webpack_require__(1184);var _SelectList2=_interopRequireDefault(_SelectList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * SelectList Component
 * @param {Object} props Component Properties
 * @returns {JSX} SelectList JSX
 */var SelectList=function(_React$Component){(0,_inherits3.default)(SelectList,_React$Component);/**
   * SelectList Component Constructor
   * @param  {Object} props Passed in Properties
   * @return {Undefined} Returns nothing
   */function SelectList(props){(0,_classCallCheck3.default)(this,SelectList);var _this=(0,_possibleConstructorReturn3.default)(this,(SelectList.__proto__||(0,_getPrototypeOf2.default)(SelectList)).call(this,props));_this.id=props.id?props.id+'_selectlist':null;_this._textInput=null;_this.setRefSelectList=_this.setRefSelectList.bind(_this);return _this;}/**
   * Constructs the className string
   * @param  {Boolean} isDisabled If the component is disabled
   * @param  {Boolean} isInvalid  If the component is inValid
   * @param  {Boolean} hasValue   If something other than the default value is selected
   * @return {String} The classname string
   */(0,_createClass3.default)(SelectList,[{key:'getClasses',value:function getClasses(isDisabled,isInvalid,hasValue){var conditionalClasses={};conditionalClasses[_SelectList2.default.disabled]=isDisabled;conditionalClasses[_SelectList2.default.error]=isInvalid;conditionalClasses[_SelectList2.default.hasValue]=hasValue;return(0,_classnames2.default)(conditionalClasses);}/**
   * Filter function to determine if an option is valid
   * @param  {Object} option The option to check
   * @return {Boolean} Whether or not it's valid
   */},{key:'filterBadOption',value:function filterBadOption(option){return option.name&&(_lodash2.default.isString(option.value)||_lodash2.default.isNumber(option.value));}/**
   * Setter for select list ref
   * @param {Element} selectList The selectlist element
   * @returns {Undefined} Returns nothing
   */},{key:'setRefSelectList',value:function setRefSelectList(selectList){if(selectList){this._selectList=selectList;}}/**
   * Returns the chevron to display based on selectlist state
   * @return {String} SVG source
   */},{key:'getChevron',value:function getChevron(){return'<svg version="1.1" id="Layer_1" xmlns="https://www.w3.org/2000/svg"\n        xmlns:xlink="https://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.3 8.3"\n        style="enable-background:new 0 0 12.3 8.3;" xml:space="preserve">\n        <style type="text/css">\n          .st3{fill:currentColor;}\n        </style>\n        <g>\n          <polygon class="st3" points="6.2,7.8 0.5,2.7 2.5,0.5 6.2,3.8 9.8,0.5 11.8,2.7 \t"/>\n        </g>\n      </svg>';}/**
   * React Component render
   * @return {JSX} TextArea rendered
   */},{key:'render',value:function render(){var filteredOptions=this.props.options.filter(this.filterBadOption);var hasValue=this.props.value!==this.props.defaultValue;var className=this.getClasses(this.props.disabled,this.props.isInvalid,hasValue);return _react2.default.createElement('div',{className:(0,_classnames2.default)(_SelectList2.default.SelectList,this.props.className)},_react2.default.createElement('span',{className:hasValue?_SelectList2.default.hasValue:null},_react2.default.createElement('svg',{fill:'currentColor',viewBox:'0 0 12.3 8.3',x:'0px',y:'0px'},_react2.default.createElement('polygon',{className:'st3',points:'6.2,7.8 0.5,2.7 2.5,0.5 6.2,3.8 9.8,0.5 11.8,2.7'}))),_react2.default.createElement('select',{'aria-describedby':this.props.ariaDescribedBy,'aria-label':this.props.ariaLabel,'aria-required':this.props.ariaRequired,className:className,disabled:this.props.disabled,id:this.id,name:this.props.name,onBlur:this.props.handleBlur,onChange:this.props.handleChange,onFocus:this.props.handleFocus,ref:this.setRefSelectList,value:this.props.value},filteredOptions.map(function(option,key){return _react2.default.createElement('option',{key:key,value:option.value},option.name);})));}}]);return SelectList;}(_react2.default.Component);SelectList.propTypes={ariaDescribedBy:_react2.default.PropTypes.string,ariaLabel:_react2.default.PropTypes.string,ariaRequired:_react2.default.PropTypes.string,className:_react2.default.PropTypes.string,defaultValue:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number.isRequired,_react2.default.PropTypes.string.isRequired]),disabled:_react2.default.PropTypes.bool,handleBlur:_react2.default.PropTypes.func,handleChange:_react2.default.PropTypes.func.isRequired,handleFocus:_react2.default.PropTypes.func,id:_react2.default.PropTypes.string,isInvalid:_react2.default.PropTypes.bool,name:_react2.default.PropTypes.string,options:_react2.default.PropTypes.array.isRequired,value:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number.isRequired,_react2.default.PropTypes.string.isRequired])};exports.default=SelectList;

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","SelectList":"SelectList","error":"error","hasValue":"hasValue"};

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _TextArea=__webpack_require__(1186);var _TextArea2=_interopRequireDefault(_TextArea);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * TextArea Component
 * @param {Object} props Component Properties
 * @returns {JSX} Text Area JSX
 */var TextArea=function(_React$Component){(0,_inherits3.default)(TextArea,_React$Component);/**
   * TextArea Component Constructor
   * @param  {Object} props Passed in Properties
   * @return {Undefined} Returns nothing
   */function TextArea(props){(0,_classCallCheck3.default)(this,TextArea);var _this=(0,_possibleConstructorReturn3.default)(this,(TextArea.__proto__||(0,_getPrototypeOf2.default)(TextArea)).call(this,props));_this.id=props.id?props.id+'_textarea':null;_this._textArea=null;_this.setRefTextArea=_this.setRefTextArea.bind(_this);return _this;}/**
   * Constructs the className string
   * @param  {String}  className  The className prop
   * @param  {Boolean} isDisabled If the component is disabled
   * @param  {Boolean} isInvalid  If the component is inValid
   * @return {String} The classname string
   */(0,_createClass3.default)(TextArea,[{key:'getClasses',value:function getClasses(className,isDisabled,isInvalid){var conditionalClasses={};conditionalClasses[_TextArea2.default.disabled]=isDisabled;conditionalClasses[_TextArea2.default.error]=isInvalid;return(0,_classnames2.default)(_TextArea2.default.TextArea,className,conditionalClasses);}/**
   * Setter for textarea ref
   * @param {Element} textArea The text area element
   * @returns {Undefined} Returns nothing
   */},{key:'setRefTextArea',value:function setRefTextArea(textArea){if(textArea){this._textArea=textArea;if(this.props.onInit){this.props.onInit(textArea);}}}/**
   * React Component render
   * @return {JSX} TextArea rendered
   */},{key:'render',value:function render(){var className=this.getClasses(this.props.className,this.props.disabled,this.props.isInvalid);return _react2.default.createElement('textarea',{'aria-describedby':this.props.ariaDescribedBy,'aria-label':this.props.ariaLabel,'aria-required':this.props.ariaRequired,className:className,disabled:this.props.disabled,id:this.id,maxLength:this.props.maxLength,onBlur:this.props.handleBlur,onChange:this.props.handleChange,onFocus:this.props.handleFocus,onKeyUp:this.props.handleKeyUp,placeholder:this.props.placeholder,ref:this.setRefTextArea,value:this.props.value});}}]);return TextArea;}(_react2.default.Component);TextArea.propTypes={ariaDescribedBy:_react2.default.PropTypes.string,ariaLabel:_react2.default.PropTypes.string,ariaRequired:_react2.default.PropTypes.string,className:_react2.default.PropTypes.string,disabled:_react2.default.PropTypes.bool,handleBlur:_react2.default.PropTypes.func,handleChange:_react2.default.PropTypes.func.isRequired,handleFocus:_react2.default.PropTypes.func,handleKeyUp:_react2.default.PropTypes.func,id:_react2.default.PropTypes.string,isInvalid:_react2.default.PropTypes.string,maxLength:_react2.default.PropTypes.number,onInit:_react2.default.PropTypes.func,placeholder:_react2.default.PropTypes.string,value:_react2.default.PropTypes.string.isRequired};exports.default=TextArea;

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","TextArea":"TextArea","error":"error"};

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _TextInput=__webpack_require__(1188);var _TextInput2=_interopRequireDefault(_TextInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * TextInput Component
 * @param {Object} props Component Properties
 * @returns {JSX} Text Input JSX
 */var TextInput=function(_React$Component){(0,_inherits3.default)(TextInput,_React$Component);/**
   * TextInput Component Constructor
   * @param  {Object} props Passed in Properties
   * @return {Undefined} Returns nothing
   */function TextInput(props){(0,_classCallCheck3.default)(this,TextInput);var _this=(0,_possibleConstructorReturn3.default)(this,(TextInput.__proto__||(0,_getPrototypeOf2.default)(TextInput)).call(this,props));_this.id=props.id?props.id+'_textinput':null;_this._textInput=null;_this.setRefTextInput=_this.setRefTextInput.bind(_this);return _this;}/**
   * Constructs the className string
   * @param  {String}  className  The className prop
   * @param  {Boolean} isDisabled If the component is disabled
   * @param  {Boolean} isInvalid  If the component is inValid
   * @return {String} The classname string
   */(0,_createClass3.default)(TextInput,[{key:'getClasses',value:function getClasses(className,isDisabled,isInvalid){var conditionalClasses={};conditionalClasses[_TextInput2.default.disabled]=isDisabled;conditionalClasses[_TextInput2.default.error]=isInvalid;return(0,_classnames2.default)(_TextInput2.default.TextInput,className,conditionalClasses);}/**
   * Setter for text input ref
   * @param {Element} textInput The text input element
   * @returns {Undefined} Returns nothing
   */},{key:'setRefTextInput',value:function setRefTextInput(textInput){if(textInput){this._textInput=textInput;}}/**
   * React Component render
   * @return {JSX} TextArea rendered
   */},{key:'render',value:function render(){var className=this.getClasses(this.props.className,this.props.disabled,this.props.isInvalid);return _react2.default.createElement('input',{'aria-describedby':this.props.ariaDescribedBy,'aria-label':this.props.ariaLabel,'aria-required':this.props.ariaRequired,className:className,disabled:this.props.disabled,id:this.id,name:this.props.name,onBlur:this.props.handleBlur,onChange:this.props.handleChange,onFocus:this.props.handleFocus,onKeyUp:this.props.handleKeyUp,placeholder:this.props.placeholder,ref:this.setRefTextInput,type:this.props.type,value:this.props.value});}}]);return TextInput;}(_react2.default.Component);TextInput.propTypes={ariaDescribedBy:_react2.default.PropTypes.string,ariaLabel:_react2.default.PropTypes.string,ariaRequired:_react2.default.PropTypes.string,className:_react2.default.PropTypes.string,disabled:_react2.default.PropTypes.bool,handleBlur:_react2.default.PropTypes.func,handleChange:_react2.default.PropTypes.func.isRequired,handleFocus:_react2.default.PropTypes.func,handleKeyUp:_react2.default.PropTypes.func,id:_react2.default.PropTypes.string,isInvalid:_react2.default.PropTypes.bool,name:_react2.default.PropTypes.string,placeholder:_react2.default.PropTypes.string,type:_react2.default.PropTypes.string,value:_react2.default.PropTypes.string.isRequired};TextInput.defaultProps={type:'text'};exports.default=TextInput;

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","TextInput":"TextInput","error":"error"};

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(537),
    isFlattenable = __webpack_require__(1190);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216),
    isArguments = __webpack_require__(163),
    isArray = __webpack_require__(46);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(1192);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

module.exports = basePick;


/***/ }),
/* 1192 */
/***/ (function(module, exports) {

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","FieldWrap":"FieldWrap","checkbox":"checkbox","Field":"Field","has-focus":"has-focus","has-error":"has-error","is-hidden":"is-hidden","is-disabled":"is-disabled","FieldLabel":"FieldLabel","is-dirty":"is-dirty","FieldMeta":"FieldMeta","FieldIcon":"FieldIcon","FieldMeta--hidden":"FieldMeta--hidden","FieldError":"FieldError","FieldRequired":"FieldRequired","FieldControl":"FieldControl"};

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Clear=function(_React$Component){(0,_inherits3.default)(Clear,_React$Component);function Clear(){(0,_classCallCheck3.default)(this,Clear);return(0,_possibleConstructorReturn3.default)(this,(Clear.__proto__||(0,_getPrototypeOf2.default)(Clear)).apply(this,arguments));}(0,_createClass3.default)(Clear,[{key:'render',value:function render(){return _react2.default.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',width:this.props.size,height:this.props.size,viewBox:'0 0 16 16'},_react2.default.createElement('title',null,'Clear'),_react2.default.createElement('path',{fill:this.props.fillColor,d:'M15.5,8A7.5,7.5,0,1,1,8,.5,7.5,7.5,0,0,1,15.5,8ZM5.9,4.8A.8.8,0,0,0,4.8,5.9L6.9,8,4.8,10.1a.8.8,0,0,0,1.1,1.1L8,9.1l2.1,2.1a.8.8,0,1,0,1.4-.8l-.3-.3h0L9.1,8l2.1-2.1a.8.8,0,0,0-1.1-1.1h0L8,6.9Z'}));}}]);return Clear;}(_react2.default.Component);Clear.defaultProps={size:'15',fillColor:'#000'};Clear.propTypes={size:_propTypes2.default.string,fillColor:_propTypes2.default.string};exports.default=Clear;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Spinner=__webpack_require__(538);var _Spinner2=_interopRequireDefault(_Spinner);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Spinner2.default;

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Spinner":"Spinner"};

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _FuneralHomeHeader=__webpack_require__(1198);var _FuneralHomeHeader2=_interopRequireDefault(_FuneralHomeHeader);var _isNil2=__webpack_require__(346);var _isNil3=_interopRequireDefault(_isNil2);var _partial2=__webpack_require__(325);var _partial3=_interopRequireDefault(_partial2);var _pick2=__webpack_require__(345);var _pick3=_interopRequireDefault(_pick2);var _componentHelpers=__webpack_require__(26);var _urlHelpers=__webpack_require__(28);var _Svgs=__webpack_require__(36);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var cacheUrl=(0,_AppConfig2.default)().environmentalUrl.cacheUrl;var mobileBreakpoint=850;var LAYOUT_SMALL='small';var LAYOUT_LARGE='large';var FuneralHomeHeader=function(_React$Component){(0,_inherits3.default)(FuneralHomeHeader,_React$Component);function FuneralHomeHeader(props){(0,_classCallCheck3.default)(this,FuneralHomeHeader);var _this=(0,_possibleConstructorReturn3.default)(this,(FuneralHomeHeader.__proto__||(0,_getPrototypeOf2.default)(FuneralHomeHeader)).call(this,props));_this.state={hamburgerActive:false,layout:props.isMobile?LAYOUT_SMALL:LAYOUT_LARGE,mobileMenuHeight:0};_this.setInnerNavRef=(0,_partial3.default)(_componentHelpers.setRef,_partial3.default.placeholder,'mobileNavInner',_this);(0,_componentHelpers.bindMethods)(_this,['handleHamburgerClick','handleResize']);return _this;}/**
   * Make sure there is a window object and data before adding event listeners.
   * @return {Void} Returns nothing.
   */(0,_createClass3.default)(FuneralHomeHeader,[{key:'componentDidMount',value:function componentDidMount(){if(!(0,_isNil3.default)(this.props.data)&&window){window.addEventListener('resize',this.handleResize);// graceful fallback for when an app isn't passing the isMobile flag
// but needs the mobile menu to display on page load.
if(!this.props.isMobile&&window.innerWidth<mobileBreakpoint){var timeout=500;setTimeout(this.handleResize,timeout);}}}/**
   * Remove event listeners.
   * @return {Void} Returns nothing.
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);}/**
   * Sets the layout (large or small) based on screen side
   * @return {Void} Returns nothing.
   */},{key:'handleResize',value:function handleResize(){if(window){var nextState={};nextState.layout=window.innerWidth>mobileBreakpoint?LAYOUT_LARGE:LAYOUT_SMALL;this.setState(nextState);}}/**
   * Set the states for the hamburger icon click.
   * @return {Void} Returns nothing.
   */},{key:'handleHamburgerClick',value:function handleHamburgerClick(){var nextActive=!this.state.hamburgerActive;this.setState({hamburgerActive:!this.state.hamburgerActive,mobileMenuHeight:nextActive?this.mobileNavInner.offsetHeight:0});}},{key:'render',value:function render(){var data=this.props.data.data;if(data){var _data$logo=data.logo,_data$logo$url=_data$logo.url,logoUrl=_data$logo$url===undefined?null:_data$logo$url,_data$logo$src=_data$logo.src,logoSrc=_data$logo$src===undefined?null:_data$logo$src,_data$logo$target=_data$logo.target,logoTarget=_data$logo$target===undefined?'_self':_data$logo$target,_data$styles=data.styles,headerStyles=_data$styles===undefined?{}:_data$styles;var backgroundStyle=(0,_pick3.default)(headerStyles,['backgroundColor']);var fontStyle=(0,_pick3.default)(headerStyles,['color']);var borderRightColorStyle=fontStyle.color?{borderRightColor:fontStyle.color}:{};if(this.state.layout===LAYOUT_LARGE){return _react2.default.createElement('div',{className:_FuneralHomeHeader2.default.FuneralHeaderLarge,style:backgroundStyle},_react2.default.createElement('div',{className:_FuneralHomeHeader2.default.innerContainer},_react2.default.createElement('div',{className:_FuneralHomeHeader2.default.leftContent},logoUrl&&logoSrc&&_react2.default.createElement('a',{className:_FuneralHomeHeader2.default.logo,href:logoUrl,target:logoTarget},_react2.default.createElement('img',{src:''+(0,_urlHelpers.buildUrl)(cacheUrl,logoSrc)}))),_react2.default.createElement('div',{className:_FuneralHomeHeader2.default.rightContent},_react2.default.createElement('nav',{className:_FuneralHomeHeader2.default.navLinks},data.menu.map(function(obj,index){return _react2.default.createElement('span',{key:index,style:borderRightColorStyle},_react2.default.createElement('a',{href:obj.url,style:fontStyle,target:obj.target},obj.name));})))));}var HAMBURGER_OPACITY=0.55;return _react2.default.createElement('div',{className:_FuneralHomeHeader2.default.FuneralHeaderSmall},_react2.default.createElement('header',{style:backgroundStyle},_react2.default.createElement('div',{className:_FuneralHomeHeader2.default.headerTop},this.state.hamburgerActive?_react2.default.createElement('span',{className:_FuneralHomeHeader2.default.closeX,onClick:this.handleHamburgerClick},_react2.default.createElement(_Svgs.CloseXIcon,null)):_react2.default.createElement('button',{className:_FuneralHomeHeader2.default.hamburger,onClick:this.handleHamburgerClick,style:backgroundStyle,type:'button'},_react2.default.createElement('span',null)),logoUrl&&logoSrc&&_react2.default.createElement('a',{href:logoUrl,target:logoTarget},_react2.default.createElement('span',{className:_FuneralHomeHeader2.default.logo},_react2.default.createElement('img',{src:''+(0,_urlHelpers.buildUrl)(cacheUrl,logoSrc)})))),_react2.default.createElement('div',{className:_FuneralHomeHeader2.default.navOuter,style:{height:this.state.mobileMenuHeight}},_react2.default.createElement('nav',{className:_FuneralHomeHeader2.default.mainNav,ref:this.setInnerNavRef},_react2.default.createElement('div',{className:_FuneralHomeHeader2.default.items},data.menu&&data.menu.map(function(obj,i){return _react2.default.createElement('div',{key:i},_react2.default.createElement('div',{className:_FuneralHomeHeader2.default.default},_react2.default.createElement('a',{href:obj.mUrl,target:obj.target},obj.name)));})))),_react2.default.createElement('div',{className:_FuneralHomeHeader2.default.backDrop,onClick:this.handleHamburgerClick,style:{height:this.state.hamburgerActive?'1400px':0,opacity:this.state.hamburgerActive?HAMBURGER_OPACITY:0}})));}var noData={display:'none'};return _react2.default.createElement('div',{style:noData},'load error');}}]);return FuneralHomeHeader;}(_react2.default.Component);FuneralHomeHeader.propTypes={data:_propTypes2.default.object,isMobile:_propTypes2.default.bool};exports.default=FuneralHomeHeader;

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","FuneralHeaderLarge":"FuneralHeaderLarge","innerContainer":"innerContainer","leftContent":"leftContent","logo":"logo","rightContent":"rightContent","navLinks":"navLinks","FuneralHeaderSmall":"FuneralHeaderSmall","headerTop":"headerTop","closeX":"closeX","hamburger":"hamburger","navOuter":"navOuter","items":"items","default":"default","backDrop":"backDrop"};

/***/ }),
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__(542);


// Declare internals

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix, key) {

            return prefix + '[]';
        },
        indices: function (prefix, key) {

            return prefix + '[' + key + ']';
        },
        repeat: function (prefix, key) {

            return prefix;
        }
    },
    strictNullHandling: false,
    skipNulls: false,
    encode: true
};


internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort) {

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    }
    else if (Utils.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        if (strictNullHandling) {
            return encode ? Utils.encode(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        if (encode) {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
        }
        return [prefix + '=' + obj];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
        else {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
    }

    return values;
};


module.exports = function (obj, options) {

    options = options || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    }
    else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' ||
        obj === null) {

        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    }
    else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    }
    else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort));
    }

    return keys.join(delimiter);
};


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__(542);


// Declare internals

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false
};


internals.parseValues = function (str, options) {

    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = Utils.decode(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = Utils.decode(part.slice(0, pos));
            val = Utils.decode(part.slice(pos + 1));
        }
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};


internals.parseObject = function (chain, val, options) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    }
    else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        var indexString = '' + index;
        if (!isNaN(index) &&
            root !== cleanRoot &&
            indexString === cleanRoot &&
            index >= 0 &&
            (options.parseArrays &&
             index <= options.arrayLimit)) {

            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, options) {

    if (!key) {
        return;
    }

    // Transform dot notation to bracket notation

    if (options.allowDots) {
        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
    }

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1])) {

            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {

        ++i;
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {

            if (!options.allowPrototypes) {
                continue;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};


module.exports = function (str, options) {

    options = options || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _FuneralHomeFooter=__webpack_require__(1207);var _FuneralHomeFooter2=_interopRequireDefault(_FuneralHomeFooter);var _pick2=__webpack_require__(345);var _pick3=_interopRequireDefault(_pick2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FuneralHomeFooter=function FuneralHomeFooter(props){var data=props.data.data;if(data){var _data$copyright$text=data.copyright.text,text=_data$copyright$text===undefined?null:_data$copyright$text,_data$locations=data.locations,locations=_data$locations===undefined?{}:_data$locations,_data$socials=data.socials,socials=_data$socials===undefined?[]:_data$socials,_data$styles=data.styles,footerStyles=_data$styles===undefined?{}:_data$styles;var copyrightText=text?new Date().getFullYear()+' '+text:null;var _locations$corporate=locations.corporate,corporate=_locations$corporate===undefined?null:_locations$corporate,_locations$locations=locations.locations,locationsLinks=_locations$locations===undefined?[]:_locations$locations;var backgroundStyle=(0,_pick3.default)(footerStyles,['backgroundColor']);return _react2.default.createElement('div',{className:_FuneralHomeFooter2.default.FuneralFooterLarge,style:backgroundStyle},_react2.default.createElement('div',{className:_FuneralHomeFooter2.default.leftContent},_react2.default.createElement('div',{className:_FuneralHomeFooter2.default.copyright},'\xA9 ',copyrightText),_react2.default.createElement('nav',{className:_FuneralHomeFooter2.default.navLinks},_react2.default.createElement('span',null,corporate,locationsLinks.length>0?' | ':null,locationsLinks.map(function(obj,index){return _react2.default.createElement('span',{key:index},_react2.default.createElement('a',{href:obj.url,target:obj.target},obj.name),index<locationsLinks.length-1?' | ':null);}))),_react2.default.createElement('nav',{className:_FuneralHomeFooter2.default.navLinks},_react2.default.createElement('span',null,socials.map(function(obj,index){return _react2.default.createElement('a',{key:index,href:obj.url,target:obj.target},_react2.default.createElement('img',{src:obj.backgroundImageUrl,style:{margin:'5px 10px 0 0',height:'20px'}}));}))),_react2.default.createElement('nav',{className:_FuneralHomeFooter2.default.navLinks},_react2.default.createElement('span',null,data.menu.map(function(obj,index){return _react2.default.createElement('span',{key:index},_react2.default.createElement('a',{href:obj.url,target:obj.target},obj.name),index<data.menu.length-1?_react2.default.createElement('span',{style:{paddingLeft:'20px',paddingRight:'20px'}},' | '):null);})))),_react2.default.createElement('div',{className:_FuneralHomeFooter2.default.rightContent},_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:data.disclaimer}})));}var noData={display:'none'};return _react2.default.createElement('div',{style:noData},'load error');};FuneralHomeFooter.propTypes={data:_propTypes2.default.object};exports.default=FuneralHomeFooter;

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","FuneralFooterLarge":"FuneralFooterLarge","copyright":"copyright","leftContent":"leftContent","rightContent":"rightContent"};

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(counter,activateOptimizely){var WAIT=100;var MAX_COUNT=20;if(typeof window!=='undefined'&&window.optimizely){window.optimizely.push(['activate']);}else if(counter<MAX_COUNT){setTimeout(function(){activateOptimizely(counter+1,activateOptimizely);},WAIT);}};

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(494),
    isArrayLike = __webpack_require__(137),
    isString = __webpack_require__(164),
    toInteger = __webpack_require__(333),
    values = __webpack_require__(1210);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to search.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1211),
    keys = __webpack_require__(142);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object ? baseValues(object, keys(object)) : [];
}

module.exports = values;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(536);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1212 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(219),
    nativeKeys = __webpack_require__(481);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getFuneralHomeHeaderData=getFuneralHomeHeaderData;exports.getFuneralHomeFooterData=getFuneralHomeFooterData;exports.getHeaderData=getHeaderData;exports.getFooterData=getFooterData;exports.overrideMenuOptions=overrideMenuOptions;var _cloneDeep2=__webpack_require__(1215);var _cloneDeep3=_interopRequireDefault(_cloneDeep2);var _personPageType=__webpack_require__(67);var _forestLawnHeader=__webpack_require__(1238);var _forestLawnHeader2=_interopRequireDefault(_forestLawnHeader);var _forestLawnFooter=__webpack_require__(1239);var _forestLawnFooter2=_interopRequireDefault(_forestLawnFooter);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/** Get the Header data for Funeral Home branded person
 * @param   {string}    pageType person page type key
 * @param   {number}    fhId funeral home id
 * @returns {Object} Menu data
 */function getFuneralHomeHeaderData(pageType,fhId){if((0,_personPageType.isForestLawnPageType)(pageType)){var key=null;try{key=fhId.toString();}catch(err){key='default';}return _forestLawnHeader2.default[key]||_forestLawnHeader2.default.default;}return{};}/** Get the Footer data for Funeral Home branded person
 * @param   {string}    pageType person page type key
 * @param   {number}    fhId funeral home id
 * @returns {Object} Footer data
 */function getFuneralHomeFooterData(pageType,fhId){if((0,_personPageType.isForestLawnPageType)(pageType)){var key=null;try{key=fhId.toString();}catch(err){key='default';}return _forestLawnFooter2.default[key]||_forestLawnFooter2.default.default;}return{};}/** Get the Header data for the given person page type key
 * @param   {string}    pageType person page type key
 * @param   {Object}    legacyHeader the legacy standard header
 * @param   {number}    fhId funeral home id
 * @returns {Object} header data
 */function getHeaderData(pageType,legacyHeader,fhId){if((0,_personPageType.useLegacyMenus)(pageType)){return legacyHeader;}return getFuneralHomeHeaderData(pageType,fhId);}/** Get the Footer data for the given person page type key
 * @param   {string}    pageType person page type key
 * @param   {Object}    legacyFooter the legacy standard footer
 * @param   {Object}    legacySubFooter the legacy standard subfooter
 * @param   {number}    fhId funeral home id
 * @returns {Object} footer data
 */function getFooterData(pageType,legacyFooter,legacySubFooter,fhId){if((0,_personPageType.useLegacyMenus)(pageType)){return{Menu:legacyFooter,SubMenu:legacySubFooter};}return getFuneralHomeFooterData(pageType,fhId);}/** Removes any disabled links from Header/Footer input data
 * @param   {Object}    data header/footer data
 * @param   {String}    linkKey link attr to test
 * @param   {String}    linkValue link attr value to test
 * @param   {Boolean}   disable disable flag
 * @returns {Object}    updated header data
 */function overrideMenuOptions(data,linkKey,linkValue,disable){if(!disable){return data;}var menuData=(0,_cloneDeep3.default)(data||{});var _menuData$data=menuData.data;_menuData$data=_menuData$data===undefined?{}:_menuData$data;var _menuData$data$menu=_menuData$data.menu,links=_menuData$data$menu===undefined?[]:_menuData$data$menu;for(var i=links.length-1;i>=0;--i){if(links[i][linkKey]===linkValue){links.splice(i,1);}}return menuData;}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(544);

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

module.exports = cloneDeep;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(213);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

module.exports = stackClear;


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

module.exports = stackDelete;


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(213),
    Map = __webpack_require__(320),
    MapCache = __webpack_require__(319);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(347),
    keys = __webpack_require__(142);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(347),
    getSymbols = __webpack_require__(546);

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1224 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1226),
    getSymbols = __webpack_require__(546),
    keys = __webpack_require__(142);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(537),
    isArray = __webpack_require__(46);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(348),
    cloneDataView = __webpack_require__(1229),
    cloneMap = __webpack_require__(1230),
    cloneRegExp = __webpack_require__(1232),
    cloneSet = __webpack_require__(1233),
    cloneSymbol = __webpack_require__(1235),
    cloneTypedArray = __webpack_require__(1236);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(348);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(1231),
    arrayReduce = __webpack_require__(548),
    mapToArray = __webpack_require__(549);

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 1231 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(1234),
    arrayReduce = __webpack_require__(548),
    setToArray = __webpack_require__(550);

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(348);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(222),
    getPrototype = __webpack_require__(551),
    isPrototype = __webpack_require__(219);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

module.exports = {
	"24088": {
		"url": "http://douglassandzook.com",
		"mUrl": "http://douglassandzook.com",
		"data": {
			"menu": [
				{
					"name": "Cremation",
					"url": "http://www.douglassandzook.com/cremation/",
					"mUrl": "http://www.douglassandzook.com/cremation/",
					"target": "_blank"
				},
				{
					"name": "Traditional Services",
					"url": "http://www.douglassandzook.com/traditional-services/",
					"mUrl": "http://www.douglassandzook.com/traditional-services/",
					"target": "_blank"
				},
				{
					"name": "Forms",
					"url": "http://www.douglassandzook.com/forms/",
					"mUrl": "http://www.douglassandzook.com/forms/",
					"target": "_blank"
				},
				{
					"name": "About Us",
					"url": "http://www.douglassandzook.com/about-us/",
					"mUrl": "http://www.douglassandzook.com/about-us/",
					"target": "_blank"
				},
				{
					"name": "Legacy.com",
					"url": "https://www.legacy.com/",
					"mUrl": "https://www.legacy.com/",
					"target": "_self"
				},
				{
					"name": "Douglass & Zook",
					"url": "http://douglassandzook.com/",
					"mUrl": "http://douglassandzook.com/",
					"target": "_blank"
				}
			],
			"logo": {
				"alt": "Douglass & Zook",
				"src": "legacy/images/fhheader/24088headerlogo.png",
				"url": "http://douglassandzook.com/",
				"mUrl": "http://douglassandzook.com/",
				"target": "_blank"
			},
			"styles": {
				"backgroundColor": "#0e416b"
			}
		}
	},
	"default": {
		"url": "https://forestlawn.com",
		"mUrl": "https://forestlawn.com",
		"data": {
			"menu": [
				{
					"name": "Parks",
					"url": "https://forestlawn.com/locations/",
					"mUrl": "https://forestlawn.com/locations/",
					"target": "_blank"
				},
				{
					"name": "Making Arrangements",
					"url": "https://forestlawn.com/time-of-loss/",
					"mUrl": "https://forestlawn.com/time-of-loss/",
					"target": "_blank"
				},
				{
					"name": "About Us",
					"url": "https://forestlawn.com/our-team/",
					"mUrl": "https://forestlawn.com/our-team/",
					"target": "_blank"
				},
				{
					"name": "Museum & Events",
					"url": "https://forestlawn.com/events/",
					"mUrl": "https://forestlawn.com/events/",
					"target": "_blank"
				},
				{
					"name": "Contact",
					"url": "https://forestlawn.com/contact/",
					"mUrl": "https://forestlawn.com/contact/",
					"target": "_blank"
				},
				{
					"name": "Flowers",
					"type": "flowers",
					"url": "https://forestlawnflowershop.com/",
					"mUrl": "https://forestlawnflowershop.com/",
					"target": "_blank"
				},
				{
					"name": "Legacy.com",
					"url": "https://www.legacy.com/",
					"mUrl": "https://www.legacy.com/",
					"target": "_self"
				},
				{
					"name": "Forest Lawn",
					"url": "https://forestlawn.com/",
					"mUrl": "https://forestlawn.com/",
					"target": "_blank"
				}
			],
			"logo": {
				"alt": "Forest Lawn",
				"src": "legacy/images/fhheader/forestlawnheaderlogo.png",
				"url": "https://forestlawn.com/",
				"mUrl": "https://forestlawn.com/",
				"target": "_blank"
			}
		}
	}
};

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports = {
	"24088": {
		"url": "http://douglassandzook.com",
		"data": {
			"copyright": {
				"text": "Forest Lawn Memorial-Park Association"
			},
			"disclaimer": "We respect your privacy and will not sell your personal information. Your information will be used to periodically communicate with you about our offerings and events. Please check our <a href='https://douglassandzook.com/privacy/'><u>Douglass & Zook Privacy Policy and Terms of Use</u></a> by clicking here, or visit <a href='https://douglassandzook.com/privacy/'><u>www.douglassandzook.com/privacy</u></a>.",
			"locations": {
				"corporate": "DOUGLASS & ZOOK FUNERAL AND CREMATION SERVICES · 600 E. FOOTHILL BOULEVARD, MONROVIA, CA 91016 · FD 221"
			},
			"menu": [
				{
					"name": "Privacy Policy",
					"url": "http://www.douglassandzook.com/privacy-policy/",
					"target": "_blank"
				},
				{
					"name": "Terms and Conditions",
					"url": "http://www.douglassandzook.com/terms-and-conditions/",
					"target": "_blank"
				}
			],
			"styles": {
				"backgroundColor": "#0e416b"
			}
		}
	},
	"default": {
		"url": "https://forestlawn.com",
		"data": {
			"copyright": {
				"text": "Forest Lawn Memorial-Park Association"
			},
			"disclaimer": "We respect your privacy and will not sell your personal information. Forest Lawn will collect and use the information you provide here to periodically email, call or text you with information about products, services, and events according to the terms of the Forest Lawn <a href='https://forestlawn.com/privacy/'><u>Privacy Policy and Terms of Use</u></a>   until you change your communication preferences at <a href='https://forestlawn.com/preferences/'><u>www.forestlawn.com/preferences</u></a>.",
			"locations": {
				"corporate": "FOREST LAWN MEMORIAL-PARKS & MORTUARIES",
				"locations": [
					{
						"name": "Arcadia – FD 2186",
						"url": "https://forestlawn.com/parks/arcadia",
						"target": "_blank"
					},
					{
						"name": "Cathedral City – FD 1847",
						"url": "https://flcoachellavalley.com/",
						"target": "_blank"
					},
					{
						"name": "City of Industry – FD 2121",
						"url": "https://forestlawn.com/parks/city-of-industry",
						"target": "_blank"
					},
					{
						"name": "Coachella – FD 640",
						"url": "https://flcoachellavalley.com/",
						"target": "_blank"
					},
					{
						"name": "Covina Hills – FD 1150",
						"url": "https://forestlawn.com/parks/covina-hills",
						"target": "_blank"
					},
					{
						"name": "Cypress – FD 1051",
						"url": "https://forestlawn.com/parks/cypress",
						"target": "_blank"
					},
					{
						"name": "Glendale – FD 656",
						"url": "https://forestlawn.com/parks/glendale",
						"target": "_blank"
					},
					{
						"name": "Hollywood Hills – FD 904",
						"url": "https://forestlawn.com/parks/hollywood-hills",
						"target": "_blank"
					},
					{
						"name": "Indio – FD 967",
						"url": "https://flcoachellavalley.com/",
						"target": "_blank"
					},
					{
						"name": "Long Beach – FD 1151",
						"url": "https://forestlawn.com/parks/long-beach/",
						"target": "_blank"
					},
					{
						"name": "Whittier – FD 2302",
						"url": "https://forestlawn.com/parks/whittier",
						"target": "_blank"
					}
				]
			},
			"menu": [
				{
					"name": "Privacy Policy",
					"url": "https://forestlawn.com/privacy/",
					"target": "_blank"
				},
				{
					"name": "Emergency Portal",
					"url": "https://fl-emergency-portal.appspot.com/",
					"target": "_blank"
				}
			],
			"socials": [
				{
					"name": "Instagram",
					"url": "https://www.instagram.com/forestlawnmemorial/",
					"backgroundImageUrl": "https://forest-lawn.s3-us-west-1.amazonaws.com/wp-content/uploads/2018/03/logo-instagram.svg",
					"target": "_blank"
				},
				{
					"name": "Facebook",
					"url": "https://www.facebook.com/ForestLawn/",
					"backgroundImageUrl": "https://forest-lawn.s3-us-west-1.amazonaws.com/wp-content/uploads/2018/03/logo-fb-simple.svg",
					"target": "_blank"
				}
			]
		}
	}
};

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _NotFound=__webpack_require__(1241);var _NotFound2=_interopRequireDefault(_NotFound);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * NotFoundPage Module
 * @class NotFoundPage
 */var NotFoundPage=function(_React$Component){(0,_inherits3.default)(NotFoundPage,_React$Component);/**
   * Constructor
   * @param  {Object} props   Passed in props
   * @param  {Object} context Flux context
   * @return {Undefined} Returns nothing
   */function NotFoundPage(props,context){(0,_classCallCheck3.default)(this,NotFoundPage);return(0,_possibleConstructorReturn3.default)(this,(NotFoundPage.__proto__||(0,_getPrototypeOf2.default)(NotFoundPage)).call(this,props,context));}/**
   * Render Component
   * @return {JSX} Rendered NotFoundPage Component
   */(0,_createClass3.default)(NotFoundPage,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:_NotFound2.default.NotFound},_react2.default.createElement('div',{className:_NotFound2.default.content},_react2.default.createElement('h1',null,'Page Not Found'),_react2.default.createElement('p',null,'Sorry, but the page you were trying to view does not exist.'),_react2.default.createElement('a',{className:_NotFound2.default.button,href:'/'},'Go To Home Page')));}}]);return NotFoundPage;}(_react2.default.Component);NotFoundPage.contextTypes={flux:_react2.default.PropTypes.object.isRequired};exports.default=NotFoundPage;

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","NotFound":"NotFound","content":"content","button":"button"};

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Planning=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _Planning=__webpack_require__(1243);var _Planning2=_interopRequireDefault(_Planning);var _Planner=__webpack_require__(1244);var _Planner2=_interopRequireDefault(_Planner);var _ReasonsBlock=__webpack_require__(1275);var _ReasonsBlock2=_interopRequireDefault(_ReasonsBlock);var _Pricing=__webpack_require__(1280);var _Pricing2=_interopRequireDefault(_Pricing);var _ArticlesCTA=__webpack_require__(1282);var _ArticlesCTA2=_interopRequireDefault(_ArticlesCTA);var _ArticlesBlock=__webpack_require__(1285);var _ArticlesBlock2=_interopRequireDefault(_ArticlesBlock);var _FindFuneralHomeCTA=__webpack_require__(1292);var _FindFuneralHomeCTA2=_interopRequireDefault(_FindFuneralHomeCTA);var _ObitWriterCTA=__webpack_require__(1294);var _ObitWriterCTA2=_interopRequireDefault(_ObitWriterCTA);var _SearchCTA=__webpack_require__(1296);var _SearchCTA2=_interopRequireDefault(_SearchCTA);var _cookies=__webpack_require__(172);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Planning module
 * @class   Planning
 * @return  {JSX}     Returns the rendered module
 */var Planning=exports.Planning=function(_React$Component){(0,_inherits3.default)(Planning,_React$Component);/**
   * Planning React Component constructor
   * @param       {Object}    props   Passed in props
   * @param       {Object}    context Used for flux store
   * @constructs  {Planning}
   * @return      {Undefined} Returns nothing
   */function Planning(props){(0,_classCallCheck3.default)(this,Planning);return(0,_possibleConstructorReturn3.default)(this,(Planning.__proto__||(0,_getPrototypeOf2.default)(Planning)).call(this,props));}(0,_createClass3.default)(Planning,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.location.pathname){var pathParts=this.props.location.pathname.split('/');if(pathParts.length>3){var affiliateCookie=(0,_cookies.getCookie)('LegacyGlobal');var cookieValue='AffiliateSiteName='+pathParts[3].split('?')[0];if(!affiliateCookie.includes(cookieValue)){(0,_cookies.setCookie)('LegacyGlobal',cookieValue,4/24);}}}}/**
   * React Component render.
   * @return {JSX} Planning page rendered.
   */},{key:'render',value:function render(){return _react2.default.createElement('div',{className:_Planning2.default.Planning},_react2.default.createElement('div',{className:_Planning2.default.Content},_react2.default.createElement('div',{className:_Planning2.default.Container},_react2.default.createElement(_Planner2.default,null),_react2.default.createElement(_ReasonsBlock2.default,null),_react2.default.createElement(_Pricing2.default,null),_react2.default.createElement(_ArticlesCTA2.default,null),_react2.default.createElement(_ArticlesBlock2.default,null),_react2.default.createElement('div',{className:_Planning2.default.Ctas},_react2.default.createElement(_FindFuneralHomeCTA2.default,null),_react2.default.createElement(_ObitWriterCTA2.default,null),_react2.default.createElement(_SearchCTA2.default,null)))));}}]);return Planning;}(_react2.default.Component);/* istanbul ignore next */Planning.propTypes={ads:_react2.default.PropTypes.object.isRequired,location:_react2.default.PropTypes.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{ads:state.adStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Planning);

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Planning":"Planning","Content":"Content","Container":"Container","Ctas":"Ctas"};

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Planner=__webpack_require__(1245);var _Planner2=_interopRequireDefault(_Planner);var _Questionnaire=__webpack_require__(1246);var _Questionnaire2=_interopRequireDefault(_Questionnaire);var _library=__webpack_require__(40);var _GAHelpers=__webpack_require__(22);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _planningHero=__webpack_require__(1273);var _planningHero2=_interopRequireDefault(_planningHero);var _planning=__webpack_require__(1274);var _planning2=_interopRequireDefault(_planning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Button=_library.FormControls.Button,EnhancedTextInput=_library.FormControls.EnhancedTextInput;/* eslint-disable global-require */var Planner=function(_React$Component){(0,_inherits3.default)(Planner,_React$Component);function Planner(props){(0,_classCallCheck3.default)(this,Planner);var _this=(0,_possibleConstructorReturn3.default)(this,(Planner.__proto__||(0,_getPrototypeOf2.default)(Planner)).call(this,props));_this.state={zipCode:'',questionnaire:'pending'};_this.handleZipCodeChange=_this.handleZipCodeChange.bind(_this);_this.handleZipCodeSubmit=_this.handleZipCodeSubmit.bind(_this);_this.handleQuestionnaireClose=_this.handleQuestionnaireClose.bind(_this);_this.handleQuestionnaireSubmit=_this.handleQuestionnaireSubmit.bind(_this);return _this;}(0,_createClass3.default)(Planner,[{key:'handleZipCodeChange',value:function handleZipCodeChange(event){if(!isNaN(event.target.value)&&event.target.value.length<=5){this.setState({zipCode:''+event.target.value});}}},{key:'handleZipCodeSubmit',value:function handleZipCodeSubmit(event){event.preventDefault();if(this.state.zipCode.length>=5){// fire off event tracking
(0,_GAHelpers.getGATags)({eventCategory:'planning_question',eventAction:'q_zip',eventLabel:this.state.zipCode});this.setState({questionnaire:'launched'});}}},{key:'handleQuestionnaireClose',value:function handleQuestionnaireClose(){this.setState({questionnaire:'pending'});}},{key:'handleQuestionnaireSubmit',value:function handleQuestionnaireSubmit(){var _this2=this;if(typeof document!=='undefined'&&document.location){var leaveQuestionnarie=function leaveQuestionnarie(){_this2.setState({questionnaire:'pending'});document.location.href=(0,_AppConfig2.default)().vanityDomain+'/funeral-homes/directory/search?City=&StateName=&ZipCode='+_this2.state.zipCode;};setTimeout(leaveQuestionnarie.bind(this),1500);}this.setState({questionnaire:'submitted'});}},{key:'cta',value:function cta(){var disabled=this.state.zipCode.length<5;return _react2.default.createElement('div',{className:_Planner2.default.CtaBlock},_react2.default.createElement('h1',{className:_Planner2.default.Title},'Plan a Funeral'),_react2.default.createElement('div',{className:_Planner2.default.Form},_react2.default.createElement('form',{onSubmit:this.handleZipCodeSubmit},_react2.default.createElement('div',{className:_Planner2.default.Heading},'Protect your loved ones from worry. Begin now to set up a reliable advance funeral plan.'),_react2.default.createElement(EnhancedTextInput,{name:'postalCode',type:'text',title:'Zip Code',onChange:this.handleZipCodeChange,placeholder:'Enter Zip Code',value:this.state.zipCode}),_react2.default.createElement(Button,{className:(0,_classnames2.default)(_Planner2.default.PrimaryButton,disabled?_Planner2.default.disabled:null),type:'submit'},'Get Started'))));}},{key:'prompt',value:function prompt(){return _react2.default.createElement('div',{className:_Planner2.default.Prompt},_react2.default.createElement('div',{className:_Planner2.default.PlanningHeroNarrow},_react2.default.createElement('img',{src:_planning2.default}),this.cta()),_react2.default.createElement('div',{className:_Planner2.default.PlanningHeroWide},_react2.default.createElement('img',{src:_planningHero2.default}),this.cta()));}},{key:'questionnaire',value:function questionnaire(){if(this.state.questionnaire!=='pending'){return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:_Planner2.default.PModalBkgd},_react2.default.createElement('div',{className:_Planner2.default.PModalContent},_react2.default.createElement(_Questionnaire2.default,{handleClose:this.handleQuestionnaireClose,handleSubmit:this.handleQuestionnaireSubmit}))));}return null;}},{key:'render',value:function render(){var prompt=this.prompt();var questionnaire=this.questionnaire();return _react2.default.createElement('div',{className:_Planner2.default.Planner},prompt,questionnaire);}}]);return Planner;}(_react2.default.Component);exports.default=Planner;

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Planner":"Planner","Prompt":"Prompt","PlanningHeroWide":"PlanningHeroWide","CtaBlock":"CtaBlock","PlanningHeroNarrow":"PlanningHeroNarrow","Title":"Title","Form":"Form","Heading":"Heading","ZipInput":"ZipInput","PrimaryButton":"PrimaryButton","disabled":"disabled","PModalBkgd":"PModalBkgd","PModalContent":"PModalContent"};

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(171);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _cookies=__webpack_require__(172);var _GAHelpers=__webpack_require__(22);var _library=__webpack_require__(40);var _Question=__webpack_require__(1248);var _Question2=_interopRequireDefault(_Question);var _questions=__webpack_require__(552);var _questions2=_interopRequireDefault(_questions);var _Question3=__webpack_require__(553);var _Question4=_interopRequireDefault(_Question3);var _findIndex2=__webpack_require__(1251);var _findIndex3=_interopRequireDefault(_findIndex2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable id-length */var Questionnaire=function(_React$Component){(0,_inherits3.default)(Questionnaire,_React$Component);function Questionnaire(props){(0,_classCallCheck3.default)(this,Questionnaire);var _this=(0,_possibleConstructorReturn3.default)(this,(Questionnaire.__proto__||(0,_getPrototypeOf2.default)(Questionnaire)).call(this,props));_this.totalQuestions=_questions2.default.length;_this.questionsAnswered=[];_this.answerIndexes=[];_this.state={progress:0};_this.handleAnswer=_this.handleAnswer.bind(_this);_this.handleBack=_this.handleBack.bind(_this);_this.handleClose=_this.handleClose.bind(_this);_this.handleSkip=_this.handleSkip.bind(_this);return _this;}(0,_createClass3.default)(Questionnaire,[{key:'handleAnswer',value:function handleAnswer(answer){var _this2=this;var answerIndex=parseInt(answer,10);this.answerIndexes[this.state.progress]=answer;if(answer==='Skip'&&this.questionsAnswered.length>0){// // track that the question has been unanswered
var removeIndex=(0,_findIndex3.default)(this.questionsAnswered,function(item){return item.name===_questions2.default[_this2.state.progress].fieldName;});if(removeIndex>-1){this.questionsAnswered.splice(removeIndex,1);}}if(!isNaN(answerIndex)){// track the questions answered
this.questionsAnswered.push({name:_questions2.default[this.state.progress].fieldName,a:_questions2.default[this.state.progress].answers[answerIndex]});// fire off event tracking
(0,_GAHelpers.getGATags)({eventCategory:'planning_question',eventAction:_questions2.default[this.state.progress].fieldName,eventLabel:_questions2.default[this.state.progress].answers[answerIndex]});}if(this.state.progress+1>=this.totalQuestions){(0,_cookies.setCookie)('_leg_LG',encodeURIComponent((0,_stringify2.default)(this.questionsAnswered)),4/24);if(typeof this.props.handleSubmit==='function'){this.props.handleSubmit();}}this.setState({progress:this.state.progress+1});}},{key:'handleBack',value:function handleBack(){// fire off event tracking
(0,_GAHelpers.getGATags)({eventCategory:'planning_question',eventAction:_questions2.default[this.state.progress].fieldName,eventLabel:'Back'});this.setState({progress:this.state.progress-1});}},{key:'handleClose',value:function handleClose(){// fire off event tracking
(0,_GAHelpers.getGATags)({eventCategory:'planning_question',eventAction:_questions2.default[this.state.progress].fieldName,eventLabel:'Close'});this.props.handleClose();}},{key:'handleSkip',value:function handleSkip(){// fire off event tracking
(0,_GAHelpers.getGATags)({eventCategory:'planning_question',eventAction:_questions2.default[this.state.progress].fieldName,eventLabel:'Skip'});this.handleAnswer('Skip');}},{key:'render',value:function render(){var questionNumber=this.state.progress+1;var currentQuestion=_questions2.default[this.state.progress];if(this.state.progress>=this.totalQuestions){return _react2.default.createElement('div',{className:_Question4.default.Question},_react2.default.createElement('p',{className:_Question4.default.QuestionText},'Generating your personalized recommendations...'),_react2.default.createElement('div',{style:{padding:'32px 0 40px 0'}},_react2.default.createElement(_library.Spinner,null)));}return _react2.default.createElement(_Question2.default,{answerIndex:this.answerIndexes[this.state.progress],answers:currentQuestion.answers,handleAnswer:this.handleAnswer,handleBack:this.handleBack,handleClose:this.handleClose,handleSkip:this.handleSkip,help:currentQuestion.help,question:currentQuestion.question,step:questionNumber,total:this.totalQuestions});}}]);return Questionnaire;}(_react2.default.Component);Questionnaire.propTypes={handleClose:_react2.default.PropTypes.func.isRequired,handleSubmit:_react2.default.PropTypes.func.isRequired};exports.default=Questionnaire;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(35);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _questions=__webpack_require__(552);var _questions2=_interopRequireDefault(_questions);var _Question=__webpack_require__(553);var _Question2=_interopRequireDefault(_Question);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _backArrow=__webpack_require__(1249);var _backArrow2=_interopRequireDefault(_backArrow);var _closeX=__webpack_require__(1250);var _closeX2=_interopRequireDefault(_closeX);var _constants=__webpack_require__(41);var _GAHelpers=__webpack_require__(22);var _partial2=__webpack_require__(325);var _partial3=_interopRequireDefault(_partial2);var _isNil2=__webpack_require__(346);var _isNil3=_interopRequireDefault(_isNil2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Question=function(_React$Component){(0,_inherits3.default)(Question,_React$Component);function Question(props){(0,_classCallCheck3.default)(this,Question);var _this=(0,_possibleConstructorReturn3.default)(this,(Question.__proto__||(0,_getPrototypeOf2.default)(Question)).call(this,props));_this.state={selectedOption:null,hoveredOption:null};_this.handleAnswer=_this.handleAnswer.bind(_this);_this.handleClose=_this.handleClose.bind(_this);_this.handleHover=_this.handleHover.bind(_this);_this.handleUnhover=_this.handleUnhover.bind(_this);return _this;}(0,_createClass3.default)(Question,[{key:'componentDidMount',value:function componentDidMount(){(0,_GAHelpers.setVirtualPageView)('/funeral-homes/planning?'+_constants.QUESTION_PARAM+'='+_questions2.default[0].page);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var currentStep=this.props.step;var nextStep=nextProps.step;if(currentStep!==nextStep){this.setState({selectedOption:nextProps.answerIndex});this.handleUnhover();(0,_GAHelpers.setVirtualPageView)('/funeral-homes/planning?'+_constants.QUESTION_PARAM+'='+_questions2.default[nextStep-1].page);}}},{key:'handleAnswer',value:function handleAnswer(changeEvent){this.setState({selectedOption:changeEvent.target.value});this.props.handleAnswer(changeEvent.target.value);}},{key:'handleClose',value:function handleClose(){(0,_GAHelpers.setVirtualPageView)('/funeral-homes/planning');this.props.handleClose();}},{key:'handleHover',value:function handleHover(hoveredIndex){this.setState({hoveredOption:hoveredIndex});}},{key:'handleUnhover',value:function handleUnhover(){this.setState({hoveredOption:null});}},{key:'render',value:function render(){var _this2=this;var question=this.props.question;var answers=this.props.answers.map(function(answer,idx){var answerClass=(0,_classnames2.default)(_Question2.default.Answer,_this2.state.selectedOption===''+idx?_Question2.default.Selected:null,_this2.state.hoveredOption===idx?_Question2.default.Hover:null);return _react2.default.createElement('div',{className:answerClass,key:'answer-'+idx,onMouseEnter:(0,_partial3.default)(_this2.handleHover,idx),onMouseLeave:_this2.handleUnhover},_react2.default.createElement('label',{className:_Question2.default.AnswerText},_react2.default.createElement('input',{className:_Question2.default.AnswerSelect,checked:_this2.state.selectedOption===''+idx,onChange:_this2.handleAnswer,type:'radio',value:''+idx}),answer));});return _react2.default.createElement('div',{className:_Question2.default.Question},_react2.default.createElement('div',{className:_Question2.default.Nav},_react2.default.createElement('div',{className:(0,_classnames2.default)(_Question2.default.Back,this.props.step===1?_Question2.default.Hidden:null),onClick:this.props.handleBack},_react2.default.createElement('img',{src:_backArrow2.default}),' ',_react2.default.createElement('span',null,'Back')),_react2.default.createElement('div',{className:_Question2.default.Close,onClick:this.handleClose},_react2.default.createElement('img',{src:_closeX2.default}))),_react2.default.createElement('p',{className:_Question2.default.QuestionText},question),_react2.default.createElement('div',{className:_Question2.default.Answers},answers),(0,_isNil3.default)(this.props.help)?null:_react2.default.createElement('div',{className:_Question2.default.QuestionHelp},this.props.help),_react2.default.createElement('div',{className:_Question2.default.Indicator},_react2.default.createElement('div',{className:_Question2.default.Progress,style:{width:100*this.props.step/this.props.total+'%'}})),_react2.default.createElement('div',{className:_Question2.default.Skip,onClick:this.props.handleSkip},'Skip'));}}]);return Question;}(_react2.default.Component);Question.propTypes={answerIndex:_react2.default.PropTypes.number,answers:_react2.default.PropTypes.array,handleAnswer:_react2.default.PropTypes.func.isRequired,handleBack:_react2.default.PropTypes.func.isRequired,handleClose:_react2.default.PropTypes.func.isRequired,handleSkip:_react2.default.PropTypes.func.isRequired,help:_react2.default.PropTypes.string,question:_react2.default.PropTypes.string.isRequired,step:_react2.default.PropTypes.number.isRequired,total:_react2.default.PropTypes.number.isRequired};exports.default=Question;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/backArrow.6dc0e0d8.png";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/closeX.2306e07e.png";

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(495),
    baseIteratee = __webpack_require__(1252),
    toInteger = __webpack_require__(333);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to search.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array ? array.length : 0;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1253),
    baseMatchesProperty = __webpack_require__(1266),
    identity = __webpack_require__(328),
    isArray = __webpack_require__(46),
    property = __webpack_require__(1270);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1254),
    getMatchData = __webpack_require__(1265),
    matchesStrictComparable = __webpack_require__(557);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(233),
    baseIsEqual = __webpack_require__(554);

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(233),
    equalArrays = __webpack_require__(555),
    equalByTag = __webpack_require__(1260),
    equalObjects = __webpack_require__(1261),
    getTag = __webpack_require__(321),
    isArray = __webpack_require__(46),
    isHostObject = __webpack_require__(212),
    isTypedArray = __webpack_require__(349);

/** Used to compose bitmasks for comparison styles. */
var PARTIAL_COMPARE_FLAG = 2;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(319),
    setCacheAdd = __webpack_require__(1257),
    setCacheHas = __webpack_require__(1258);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1257 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1259 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216),
    Uint8Array = __webpack_require__(547),
    eq = __webpack_require__(161),
    equalArrays = __webpack_require__(555),
    mapToArray = __webpack_require__(549),
    setToArray = __webpack_require__(550);

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var keys = __webpack_require__(142);

/** Used to compose bitmasks for comparison styles. */
var PARTIAL_COMPARE_FLAG = 2;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var isLength = __webpack_require__(322),
    isObjectLike = __webpack_require__(95);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1263 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(476);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(125)(module)))

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(556),
    keys = __webpack_require__(142);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(554),
    get = __webpack_require__(135),
    hasIn = __webpack_require__(1267),
    isKey = __webpack_require__(218),
    isStrictComparable = __webpack_require__(556),
    matchesStrictComparable = __webpack_require__(557),
    toKey = __webpack_require__(162);

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1268),
    hasPath = __webpack_require__(1269);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(475),
    isArguments = __webpack_require__(163),
    isArray = __webpack_require__(46),
    isIndex = __webpack_require__(224),
    isKey = __webpack_require__(218),
    isLength = __webpack_require__(322),
    isString = __webpack_require__(164),
    toKey = __webpack_require__(162);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isString(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1271),
    basePropertyDeep = __webpack_require__(1272),
    isKey = __webpack_require__(218),
    toKey = __webpack_require__(162);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(474);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/planning-hero.be4251ad.jpg";

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/planning.82028bde.png";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ReasonsBlock=__webpack_require__(1276);var _ReasonsBlock2=_interopRequireDefault(_ReasonsBlock);var _Reason=__webpack_require__(1277);var _Reason2=_interopRequireDefault(_Reason);var _Svgs=__webpack_require__(1279);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ReasonsBlock=function ReasonsBlock(){var blurb3="Get funeral services covered now so it doesn't cost more later.";return _react2.default.createElement('div',{className:_ReasonsBlock2.default.ReasonsBlock},_react2.default.createElement('h2',{className:_ReasonsBlock2.default.Title},'3 Reasons to Plan a Funeral in Advance'),_react2.default.createElement('div',{className:_ReasonsBlock2.default.Reasons},_react2.default.createElement(_Reason2.default,{icon:_react2.default.createElement(_Svgs.PlanReasonIcon,null),title:'Make your last wishes clear',blurb:'Have the comfort of knowing your plans will be followed.'}),_react2.default.createElement(_Reason2.default,{icon:_react2.default.createElement(_Svgs.EaseReasonIcon,null),title:'Make it easier on loved ones',blurb:'Save your family from added stress during a difficult time.'}),_react2.default.createElement(_Reason2.default,{icon:_react2.default.createElement(_Svgs.CostReasonIcon,null),title:'Make smart spending decisions',blurb:blurb3})));};exports.default=ReasonsBlock;

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","ReasonsBlock":"ReasonsBlock","Title":"Title","Reasons":"Reasons"};

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Reason=__webpack_require__(1278);var _Reason2=_interopRequireDefault(_Reason);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Reason=function Reason(props){return(/**
   * Returns JSX representation of a Reason block
   * @param {Object} icon icon
   * @param {String} title reason title
   * @param {String} blurb reason text
   * @returns {JSX} Reason block
   */_react2.default.createElement('div',{className:_Reason2.default.Reason},_react2.default.createElement('div',{className:_Reason2.default.IconContainer},props.icon),_react2.default.createElement('div',{className:_Reason2.default.TextContainer},_react2.default.createElement('div',{className:_Reason2.default.ReasonTitle},props.title),_react2.default.createElement('div',{className:_Reason2.default.ReasonBlurb},props.blurb))));};Reason.propTypes={blurb:_react2.default.PropTypes.string,icon:_react2.default.PropTypes.object,title:_react2.default.PropTypes.string};exports.default=Reason;

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Reason":"Reason","TextContainer":"TextContainer","IconContainer":"IconContainer","ReasonTitle":"ReasonTitle","ReasonBlurb":"ReasonBlurb"};

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.EaseReasonIcon=exports.PlanReasonIcon=exports.CostReasonIcon=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CostReasonIcon=exports.CostReasonIcon=function CostReasonIcon(){return _react2.default.createElement("svg",{xmlns:"https://www.w3.org/2000/svg",width:"48",height:"48",viewBox:"0 0 48 48"},_react2.default.createElement("g",{fill:"none",fillRule:"evenodd"},_react2.default.createElement("rect",{width:"48",height:"48",fill:"#F28C8D",rx:"4"}),_react2.default.createElement("path",{fill:"#FFF",fillRule:"nonzero",d:"M7.74 14c-.437 0-.74.386-.74.74v17a.77.77 0 0 0 .74.75.77.77 0 0 0 .738-.75V15.477h30.305a.77.77 0 0 0 .75-.739.77.77 0 0 0-.75-.739H7.739zm2.956 2.957c-.426 0-.73.406-.74.739v16.26c0 .388.353.74.74.74H40.26c.387 0 .739-.352.739-.74v-16.26a.768.768 0 0 0-.74-.74H10.697zm.739 1.478h8.373c-1.962 1.77-3.2 4.434-3.2 7.391 0 2.963 1.243 5.624 3.211 7.391h-8.384V18.435zm10.948 0h6.19c2.513 1.278 4.297 4.096 4.297 7.391 0 3.306-1.795 6.12-4.32 7.391h-6.144c-2.525-1.272-4.319-4.085-4.319-7.39 0-3.296 1.783-6.114 4.296-7.392zm8.766 0h8.373v14.782h-8.385c1.969-1.767 3.21-4.428 3.21-7.39 0-2.958-1.237-5.621-3.198-7.392zm-5.67 1.109a.74.74 0 0 0-.74.739v.462a2.928 2.928 0 0 0-2.217 2.864c0 .926.45 1.65 1.005 2.055.406.297.82.47 1.212.636v3.014a2.12 2.12 0 0 1-.82-.866c-.148-.383-.65-.576-1.016-.393-.367.183-.517.703-.3 1.051.383.767 1.124 1.54 2.136 1.802v.462a.74.74 0 1 0 1.478 0v-.462a2.928 2.928 0 0 0 2.218-2.864c0-.927-.45-1.663-1.005-2.068-.406-.296-.82-.47-1.213-.635v-3.003c.362.203.655.525.82.855.149.382.65.576 1.017.393.366-.184.517-.703.3-1.051-.383-.767-1.125-1.531-2.137-1.79v-.462a.74.74 0 0 0-.739-.74zm-.74 2.737v2.39c-.532-.236-.736-.587-.739-1.062 0-.68.276-1.117.74-1.328zm1.478 4.688c.534.236.748.619.74 1.074 0 .68-.276 1.117-.74 1.328v-2.402z"})));};/* eslint-disable react/no-multi-comp */var PlanReasonIcon=exports.PlanReasonIcon=function PlanReasonIcon(){return _react2.default.createElement("svg",{xmlns:"https://www.w3.org/2000/svg",width:"48",height:"48",viewBox:"0 0 48 48"},_react2.default.createElement("g",{fill:"none",fillRule:"evenodd"},_react2.default.createElement("rect",{width:"48",height:"48",fill:"#308C8F",rx:"4"}),_react2.default.createElement("g",{fill:"#FFF",fillRule:"nonzero"},_react2.default.createElement("path",{d:"M38.245 11.925l-.147-.1a3.55 3.55 0 0 0-4.115.066l-.934.676-.933-.674a3.585 3.585 0 0 0-1.74-.664v-1.096A2.135 2.135 0 0 0 28.24 8H13.275c-1.18 0-2.137.955-2.137 2.133v1.6H9.534a.534.534 0 0 0-.534.534v12.266c0 .884.718 1.6 1.603 1.6h3.741v8.8c0 1.031.838 1.867 1.87 1.867.09-.003.18-.012.268-.027v.027h2.672v2.667c0 .294.24.533.534.533h14.964a.534.534 0 0 0 .534-.533v-6.4c0-.884-.717-1.6-1.603-1.6h-3.206V20.872l2.33 1.938a.535.535 0 0 0 .684 0l4.948-4.117a4.04 4.04 0 0 0 1.516-2.251 4.214 4.214 0 0 0-1.61-4.517zM10.07 24.533V12.8h1.069v11.733a.534.534 0 0 1-1.07 0zm2.04.534c.062-.171.096-.352.097-.534v-14.4a1.068 1.068 0 0 1 2.138 0v14.934h-2.236zm5.788 10.666c.122-.249.186-.522.188-.8v-1.866a.534.534 0 0 1 1.069 0v2.666h-1.257zm16.22-2.666v5.866H20.223v-5.866a1.579 1.579 0 0 0-.099-.534h13.46c.294 0 .533.24.533.534zm-4.81-1.6H18.62c-.885 0-1.603.716-1.603 1.6v1.866a.8.8 0 0 1-1.603 0v-24.8a2.108 2.108 0 0 0-.297-1.066h13.123c.59 0 1.069.477 1.069 1.066v1.149a3.595 3.595 0 0 0-1.31.544l-.145.1a4.215 4.215 0 0 0-1.61 4.516c.226.891.751 1.678 1.488 2.23l1.577 1.311v11.484zM38.82 16.17a3.002 3.002 0 0 1-1.138 1.681l-4.633 3.855-4.662-3.875a2.98 2.98 0 0 1-1.11-1.661 3.134 3.134 0 0 1 1.176-3.364l.146-.1a2.49 2.49 0 0 1 2.885.048l1.247.903a.535.535 0 0 0 .628 0l1.247-.903a2.488 2.488 0 0 1 2.886-.048l.147.1a3.134 3.134 0 0 1 1.181 3.364z"}),_react2.default.createElement("path",{d:"M17 10h6v1h-6zM24 10h2v1h-2zM17 13h6v1h-6zM25 13h2v1h-2zM17 15h4v1h-4zM17 18h5v1h-5zM17 21h7v1h-7zM17 23h10v1H17zM17 26h8v1h-8zM17 29h9v1h-9zM27 26h2v1h-2zM22 34h8v1h-8zM22 36h9v1h-9zM32 34h2v1h-2zM37.5 40c.194 0 .37-.119.452-.304l1-2.26a.551.551 0 0 0 .048-.224V22.529c0-.292-.224-.529-.5-.529h-2c-.276 0-.5.237-.5.53v14.682c0 .077.016.154.048.225l1 2.259A.499.499 0 0 0 37.5 40zm.5-14.294h-1v-.53h1v.53zm0-2.647v1.059h-1v-1.06h1zm-1 3.706h1v10.33l-.5 1.128-.5-1.129v-10.33z"}))));};var EaseReasonIcon=exports.EaseReasonIcon=function EaseReasonIcon(){return _react2.default.createElement("svg",{xmlns:"https://www.w3.org/2000/svg",width:"48",height:"48",viewBox:"0 0 48 48"},_react2.default.createElement("g",{fill:"none",fillRule:"evenodd"},_react2.default.createElement("rect",{width:"48",height:"48",fill:"#069",rx:"4"}),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeWidth:"1.5",d:"M39.434 19.766c0 3.562-2.845 6.292-6.355 6.292-3.51 0-6.355-2.73-6.355-6.292"}),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",d:"M20.021 25.802c.834.345 1.594.933 2.235 1.679M7.198 35.66v-2.648a8.528 8.528 0 0 1 3.917-7.199"}),_react2.default.createElement("g",{fill:"#FFF",fillRule:"nonzero",transform:"translate(11.69 19.55)"},_react2.default.createElement("ellipse",{cx:"6.556",cy:"1.124",rx:"1",ry:"1"}),_react2.default.createElement("path",{d:"M1.99 1.124a.842.842 0 0 1-.836.849.841.841 0 0 1-.837-.849c0-.468.374-.848.837-.848.46 0 .836.38.836.848z"})),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeWidth:"1.5",d:"M16.665 24.406c-.146.346-.488.693-1.09.693-.602 0-.976-.347-1.09-.693"}),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",d:"M15.562 20.575s-.418.838-.418 2.17h1.089"}),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeWidth:"1.5",d:"M23.285 26.379v-7.655c0-4.3-3.435-7.787-7.672-7.787-4.238 0-7.672 3.486-7.672 7.787v7.655s.266 2.149-1.889 2.149"}),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",d:"M37.6 24.377a8.525 8.525 0 0 1 3.92 7.218l-.005 4.064M25.372 27.574c.676-1.48 1.73-2.71 3.321-3.211"}),_react2.default.createElement("g",{fill:"#FFF",fillRule:"nonzero",transform:"translate(29.574 17.488)"},_react2.default.createElement("ellipse",{cx:"6.249",cy:"1.145",rx:"1",ry:"1"}),_react2.default.createElement("ellipse",{cx:".847",cy:"1.145",rx:"1",ry:"1"})),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeWidth:"1.5",d:"M34.446 22.625c-.178.421-.592.842-1.324.842-.732 0-1.187-.42-1.325-.842"}),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",d:"M33.317 18.665s-.604.973-.604 2.552h1.088M39.435 19.866s-.047-2.69 1.338-2.69"}),_react2.default.createElement("g",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5"},_react2.default.createElement("path",{d:"M24.893 18.057v1.757c0 .655.523 1.186 1.168 1.186M26.585 21h-.524"})),_react2.default.createElement("g",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5"},_react2.default.createElement("path",{d:"M41.126 18.057v1.757c0 .655-.523 1.186-1.168 1.186M39.958 21h-.524"})),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",d:"M21.866 18.403h-5.388c-3.861 0-4.47-3.117-4.47-3.117s-2.751 1.005-2.751 4.397v1.596c0 3.533 2.823 6.398 6.305 6.398 3.481 0 6.304-2.864 6.304-6.398v-2.876M40.773 17.175c.455 0 .422-.576.422-.576 0-4.558-3.64-8.253-8.13-8.253-4.491 0-8.132 3.695-8.132 8.253 0 0-.04.683.474.675 1.317-.018 1.317 2.492 1.317 2.492"}),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",d:"M38.541 18.776v-2.15c-1.276.135-2.978-1.757-2.978-1.757-2.306 2.374-7.9 1.702-7.9 1.702v2.205M19.507 33.1v.644c0 2.701 2.158 3.935 4.82 3.935 2.661 0 4.819-1.234 4.819-3.935V33.1M27.413 37.103a4.942 4.942 0 0 1 1.763 3.797M19.478 40.9c0-1.529.686-2.895 1.763-3.798"}),_react2.default.createElement("g",{fill:"#FFF",fillRule:"nonzero",transform:"translate(22.258 32.337)"},_react2.default.createElement("ellipse",{cx:"3.457",cy:".706",rx:"1",ry:"1"}),_react2.default.createElement("ellipse",{cx:".68",cy:".706",rx:"1",ry:"1"})),_react2.default.createElement("path",{fill:"#FFF",fillRule:"nonzero",stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",d:"M24.991 34.734a.262.262 0 0 0-.26-.264h-.808a.262.262 0 0 0-.26.264l.664.476.664-.476z"}),_react2.default.createElement("path",{stroke:"#FFF",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",d:"M21.31 29.635v2.11c0 .793-.633 1.435-1.414 1.435-.78 0-1.414-.643-1.414-1.435v-1.23c0-.793.578-1.741 1.414-2.092 0 0 1.767-.882 4.563-.882 2.798 0 4.257.882 4.257.882.892.433 1.414 1.299 1.414 2.092v1.23c0 .793-.633 1.435-1.414 1.435a1.425 1.425 0 0 1-1.414-1.435v-2.11"})));};

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Pricing=__webpack_require__(1281);var _Pricing2=_interopRequireDefault(_Pricing);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Pricing=function Pricing(){return _react2.default.createElement('div',{className:_Pricing2.default.Pricing},_react2.default.createElement('div',{className:_Pricing2.default.Description},_react2.default.createElement('div',{className:_Pricing2.default.Title},'The average funeral',' ',_react2.default.createElement('span',{className:_Pricing2.default.NoWrap},'costs',' ',_react2.default.createElement('span',{style:{fontWeight:'bold',color:'#006699'}},'$8,755'),_react2.default.createElement('span',{style:{fontSize:'24px',verticalAlign:'top'}},' *'))),_react2.default.createElement('div',{className:_Pricing2.default.Blurb},'Start planning today to settle your family\'s',' ',_react2.default.createElement('span',{className:_Pricing2.default.NoWrap},'expenses ahead of time.'))),_react2.default.createElement('div',{className:_Pricing2.default.Prices},_react2.default.createElement('ul',{className:_Pricing2.default.Averages},_react2.default.createElement('li',null,_react2.default.createElement('span',null,'Basic Service Fees'),_react2.default.createElement('span',null,'$2,100')),_react2.default.createElement('li',null,_react2.default.createElement('span',null,'Transfer of Remains'),_react2.default.createElement('span',null,'$325')),_react2.default.createElement('li',null,_react2.default.createElement('span',null,'Embalming'),_react2.default.createElement('span',null,'$725')),_react2.default.createElement('li',null,_react2.default.createElement('span',null,'Viewing'),_react2.default.createElement('span',null,'$425')),_react2.default.createElement('li',null,_react2.default.createElement('span',null,'Funeral Ceremony'),_react2.default.createElement('span',null,'$500')),_react2.default.createElement('li',null,_react2.default.createElement('span',null,'Burial Casket'),_react2.default.createElement('span',null,'$2,400')),_react2.default.createElement('li',null,_react2.default.createElement('span',null,'Other Preparations'),_react2.default.createElement('span',null,'$250')),_react2.default.createElement('li',{className:_Pricing2.default.Totals},_react2.default.createElement('span',null,'Total'),_react2.default.createElement('span',null,'$8,755'))),_react2.default.createElement('div',{className:_Pricing2.default.Source},'* Source:\xA0',_react2.default.createElement('a',{href:'https://www.nfda.org/news/statistics'},'www.nfda.org/news/statistics'))));};exports.default=Pricing;

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Pricing":"Pricing","Description":"Description","Title":"Title","Blurb":"Blurb","Prices":"Prices","Averages":"Averages","Totals":"Totals","data":"data","Source":"Source","NoWrap":"NoWrap"};

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ArticlesCTA=__webpack_require__(1283);var _ArticlesCTA2=_interopRequireDefault(_ArticlesCTA);var _CTABlock=__webpack_require__(234);var _CTABlock2=_interopRequireDefault(_CTABlock);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var niceBreakingBlurb=_react2.default.createElement('span',null,'We have resources to help you through every stage of funeral planning,',' ',_react2.default.createElement('span',{style:{whiteSpace:'nowrap'}},'grieving and remembrance.'));var data={title:'Feeling Overwhelmed?',blurb:niceBreakingBlurb,button:{text:'View Helpful Articles',href:(0,_AppConfig2.default)().vanityDomain+'/news/advice-and-support'}};var ArticlesCTA=function ArticlesCTA(){return _react2.default.createElement('div',{className:_ArticlesCTA2.default.ArticlesCTA},_react2.default.createElement(_CTABlock2.default,{blurb:data.blurb,button:data.button,className:'LongBlurb',title:data.title,newWindow:true}));};exports.default=ArticlesCTA;

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","ArticlesCTA":"ArticlesCTA"};

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","CTABlock":"CTABlock","Title":"Title","Blurb":"Blurb","LongBlurb":"LongBlurb","Button":"Button","disabled":"disabled","FhButton":"FhButton","ObitsButton":"ObitsButton","WriterButton":"WriterButton"};

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ArticlesBlock=__webpack_require__(1286);var _ArticlesBlock2=_interopRequireDefault(_ArticlesBlock);var _ArticleButton=__webpack_require__(1287);var _ArticleButton2=_interopRequireDefault(_ArticleButton);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _library=__webpack_require__(40);var _casket=__webpack_require__(1289);var _casket2=_interopRequireDefault(_casket);var _burial=__webpack_require__(1290);var _burial2=_interopRequireDefault(_burial);var _support=__webpack_require__(1291);var _support2=_interopRequireDefault(_support);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable global-require */var Button=_library.FormControls.Button;var domain=(0,_AppConfig2.default)().vanityDomain;var ArticlesBlock=function ArticlesBlock(){var handleClick=function handleClick(){if(window){window.open(domain+'/news/advice-and-support','_blank');}};return _react2.default.createElement('div',{className:_ArticlesBlock2.default.ArticlesBlock},_react2.default.createElement('h2',{className:_ArticlesBlock2.default.Title},'End-of-Life Help'),_react2.default.createElement('div',{className:_ArticlesBlock2.default.Articles},_react2.default.createElement(_ArticleButton2.default,{href:domain+'/news/advice-and-support/article/how-to-shop-for-a-funeral-home',image:_casket2.default,title:'How to Shop for a Funeral Home'}),_react2.default.createElement(_ArticleButton2.default,{href:domain+'/news/advice-and-support/article/burial-vs-cremation-and-alternatives-pros-and-cons',image:_burial2.default,title:'Burial vs. Cremation vs. Alternative Options'}),_react2.default.createElement(_ArticleButton2.default,{href:domain+'/news/advice-and-support/article/what-to-do-when-a-loved-one-is-terminal',image:_support2.default,title:'What to Do When a Loved One Is Terminal'})),_react2.default.createElement(Button,{className:_ArticlesBlock2.default.ArticlesButton,handleClick:handleClick},'View All Articles'));};exports.default=ArticlesBlock;

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","ArticlesBlock":"ArticlesBlock","Title":"Title","Articles":"Articles","ArticlesButton":"ArticlesButton","disabled":"disabled"};

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ArticleButton=__webpack_require__(1288);var _ArticleButton2=_interopRequireDefault(_ArticleButton);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ArticleButton=function ArticleButton(props){var handleClick=function handleClick(){if(window){window.open(props.href);}};/**
   * Returns JSX representation of a ArticleButton block
   * @param {String} href article href
   * @param {Object} image image
   * @param {String} title article title
   * @returns {JSX} ArticleButton block
   */return _react2.default.createElement('div',{className:_ArticleButton2.default.ArticleButton,onClick:handleClick},_react2.default.createElement('div',{className:_ArticleButton2.default.IconContainer},_react2.default.createElement('img',{src:props.image})),_react2.default.createElement('div',{className:_ArticleButton2.default.TextContainer},_react2.default.createElement('div',{className:_ArticleButton2.default.ArticleTitle},props.title),_react2.default.createElement('div',{className:_ArticleButton2.default.ReadMore},'Read More')));};ArticleButton.propTypes={href:_react2.default.PropTypes.string,image:_react2.default.PropTypes.object,title:_react2.default.PropTypes.string};exports.default=ArticleButton;

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","ArticleButton":"ArticleButton","TextContainer":"TextContainer","ArticleTitle":"ArticleTitle","ReadMore":"ReadMore","IconContainer":"IconContainer"};

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/casket.e1a68e81.jpg";

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/burial.9c4ee263.jpg";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/support.1a895cb2.jpg";

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _FindFuneralHomeCTA=__webpack_require__(1293);var _FindFuneralHomeCTA2=_interopRequireDefault(_FindFuneralHomeCTA);var _CTABlock=__webpack_require__(234);var _CTABlock2=_interopRequireDefault(_CTABlock);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var data={title:'Find a Funeral Home',blurb:'The most comprehensive and accurate online funeral home directory.',button:{text:'Search',href:(0,_AppConfig2.default)().vanityDomain+'/funeral-homes',class:'FhButton'},seo:'h2'};var FindFuneralHomeCTA=function FindFuneralHomeCTA(){return _react2.default.createElement('div',{className:_FindFuneralHomeCTA2.default.FindFuneralHomeCTA},_react2.default.createElement(_CTABlock2.default,{blurb:data.blurb,button:data.button,seo:data.seo,title:data.title}));};exports.default=FindFuneralHomeCTA;

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","FindFuneralHomeCTA":"FindFuneralHomeCTA"};

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ObitWriterCTA=__webpack_require__(1295);var _ObitWriterCTA2=_interopRequireDefault(_ObitWriterCTA);var _CTABlock=__webpack_require__(234);var _CTABlock2=_interopRequireDefault(_CTABlock);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var data={title:'Write an Obituary',blurb:"Legacy's simple online assistant helps you prepare a meaningful life story to share.",button:{text:'Learn More',href:(0,_AppConfig2.default)().vanityDomain+'/obitwriter',class:'WriterButton'}};var ObitWriterCTA=function ObitWriterCTA(){return _react2.default.createElement('div',{className:_ObitWriterCTA2.default.ObitWriterCTA},_react2.default.createElement(_CTABlock2.default,{blurb:data.blurb,button:data.button,title:data.title}));};exports.default=ObitWriterCTA;

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","ObitWriterCTA":"ObitWriterCTA"};

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _SearchCTA=__webpack_require__(1297);var _SearchCTA2=_interopRequireDefault(_SearchCTA);var _CTABlock=__webpack_require__(234);var _CTABlock2=_interopRequireDefault(_CTABlock);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var data={title:'Search Obituaries',blurb:'Search more than 1,500 newspapers and 3,500 funeral homes.',button:{text:'Search',href:(0,_AppConfig2.default)().vanityDomain+'/search',class:'ObitsButton'}};var SearchCTA=function SearchCTA(){return _react2.default.createElement('div',{className:_SearchCTA2.default.SearchCTA},_react2.default.createElement(_CTABlock2.default,{blurb:data.blurb,button:data.button,title:data.title}));};exports.default=SearchCTA;

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","SearchCTA":"SearchCTA"};

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Planning=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _Planning=__webpack_require__(1299);var _Planning2=_interopRequireDefault(_Planning);var _WhatsIncluded=__webpack_require__(1300);var _WhatsIncluded2=_interopRequireDefault(_WhatsIncluded);var _PlanningSearchCTA=__webpack_require__(1305);var _PlanningSearchCTA2=_interopRequireDefault(_PlanningSearchCTA);var _PlanAhead=__webpack_require__(1309);var _PlanAhead2=_interopRequireDefault(_PlanAhead);var _Hero=__webpack_require__(1312);var _Hero2=_interopRequireDefault(_Hero);var _alternate=__webpack_require__(1422);var _alternate2=_interopRequireDefault(_alternate);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Planning module
 * @class   Planning
 * @return  {JSX}     Returns the rendered module
 */var Planning=exports.Planning=function(_React$Component){(0,_inherits3.default)(Planning,_React$Component);function Planning(){(0,_classCallCheck3.default)(this,Planning);return(0,_possibleConstructorReturn3.default)(this,(Planning.__proto__||(0,_getPrototypeOf2.default)(Planning)).apply(this,arguments));}(0,_createClass3.default)(Planning,[{key:'render',/**
   * React Component render.
   * @return {JSX} Planning page rendered.
   */value:function render(){var guideVersion=this.props.planning.guideVersion;return _react2.default.createElement('div',{className:_Planning2.default.Planning},_react2.default.createElement('div',{className:_Planning2.default.Content},_react2.default.createElement('div',{className:_Planning2.default.Container},guideVersion===2?_react2.default.createElement(_Hero2.default,null):_react2.default.createElement(_alternate2.default,null),_react2.default.createElement(_PlanAhead2.default,null),_react2.default.createElement(_WhatsIncluded2.default,null),_react2.default.createElement(_PlanningSearchCTA2.default,null))));}}]);return Planning;}(_react2.default.Component);/* istanbul ignore next */Planning.propTypes={ads:_react2.default.PropTypes.object.isRequired,location:_react2.default.PropTypes.object.isRequired,planning:_react2.default.PropTypes.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{ads:state.adStore,planning:state.planningStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Planning);

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap","Planning":"Planning","Content":"Content","Container":"Container","Ctas":"Ctas"};

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _WhatsIncluded=__webpack_require__(1301);var _WhatsIncluded2=_interopRequireDefault(_WhatsIncluded);var _Shared=__webpack_require__(173);var _Shared2=_interopRequireDefault(_Shared);var _Item=__webpack_require__(1302);var _Item2=_interopRequireDefault(_Item);var _Svgs=__webpack_require__(1304);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WhatsIncluded=function WhatsIncluded(){return _react2.default.createElement('div',{className:_Shared2.default.Wrap},_react2.default.createElement('div',{className:_WhatsIncluded2.default.WhatsIncludedBlock},_react2.default.createElement('h2',{className:_WhatsIncluded2.default.Title},'The guide will help you:'),_react2.default.createElement('div',{className:_WhatsIncluded2.default.Items},_react2.default.createElement(_Item2.default,{icon:_react2.default.createElement(_Svgs.CandleIcon,null),title:'Choose a type of ceremony',blurb:'Do you want a traditional service or a unique memorial\xA0event?'}),_react2.default.createElement(_Item2.default,{icon:_react2.default.createElement(_Svgs.GravestoneIcon,null),title:'Decide how to be laid to\xA0rest',blurb:'Burial and cremation are the most common, but there are other\xA0options.'}),_react2.default.createElement(_Item2.default,{icon:_react2.default.createElement(_Svgs.TreeIcon,null),title:'Ensure your legacy',blurb:'How do you want the world to remember you? Who will deliver your\xA0eulogy?'}),_react2.default.createElement(_Item2.default,{icon:_react2.default.createElement(_Svgs.CalculatorIcon,null),title:'Know your\xA0financial options',blurb:'Pros and cons of options like life insurance, burial insurance, and funeral\xA0pre-payment.'}),_react2.default.createElement(_Item2.default,{icon:_react2.default.createElement(_Svgs.DocumentIcon,null),title:'Secure essential\xA0documents',blurb:'Learn which documents and information to share with family ahead of\xA0time.'}),_react2.default.createElement(_Item2.default,{icon:_react2.default.createElement(_Svgs.ChecklistIcon,null),title:'Outline your\xA0preferences',blurb:'Use the checklists to stay organized as you begin to\xA0plan.'}))));};exports.default=WhatsIncluded;

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap","WhatsIncludedBlock":"WhatsIncludedBlock","Title":"Title","Items":"Items"};

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Item=__webpack_require__(1303);var _Item2=_interopRequireDefault(_Item);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Item=function Item(props){return(/**
   * Returns JSX representation of a Reason block
   * @param {Object} icon icon
   * @param {String} title reason title
   * @param {String} blurb reason text
   * @returns {JSX} Reason block
   */_react2.default.createElement('div',{className:_Item2.default.Item},_react2.default.createElement('div',{className:_Item2.default.IconContainer},props.icon),_react2.default.createElement('div',{className:_Item2.default.TextContainer},_react2.default.createElement('div',{className:_Item2.default.ItemTitle},props.title),_react2.default.createElement('div',{className:_Item2.default.ItemBlurb},props.blurb))));};Item.propTypes={blurb:_react2.default.PropTypes.string,icon:_react2.default.PropTypes.object,title:_react2.default.PropTypes.string};exports.default=Item;

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap","WhatsIncludedBlock":"WhatsIncludedBlock","Item":"Item","IconContainer":"IconContainer","TextContainer":"TextContainer","ItemTitle":"ItemTitle","ItemBlurb":"ItemBlurb"};

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TreeIcon=exports.GravestoneIcon=exports.DocumentIcon=exports.ChecklistIcon=exports.CandleIcon=exports.CalculatorIcon=exports.CostReasonIcon=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CostReasonIcon=exports.CostReasonIcon=function CostReasonIcon(){return _react2.default.createElement("svg",{xmlns:"https://www.w3.org/2000/svg",width:"48",height:"48",viewBox:"0 0 48 48"},_react2.default.createElement("g",{fill:"none",fillRule:"evenodd"},_react2.default.createElement("rect",{width:"48",height:"48",fill:"#F28C8D",rx:"4"}),_react2.default.createElement("path",{fill:"#FFF",fillRule:"nonzero",d:"M7.74 14c-.437 0-.74.386-.74.74v17a.77.77 0 0 0 .74.75.77.77 0 0 0 .738-.75V15.477h30.305a.77.77 0 0 0 .75-.739.77.77 0 0 0-.75-.739H7.739zm2.956 2.957c-.426 0-.73.406-.74.739v16.26c0 .388.353.74.74.74H40.26c.387 0 .739-.352.739-.74v-16.26a.768.768 0 0 0-.74-.74H10.697zm.739 1.478h8.373c-1.962 1.77-3.2 4.434-3.2 7.391 0 2.963 1.243 5.624 3.211 7.391h-8.384V18.435zm10.948 0h6.19c2.513 1.278 4.297 4.096 4.297 7.391 0 3.306-1.795 6.12-4.32 7.391h-6.144c-2.525-1.272-4.319-4.085-4.319-7.39 0-3.296 1.783-6.114 4.296-7.392zm8.766 0h8.373v14.782h-8.385c1.969-1.767 3.21-4.428 3.21-7.39 0-2.958-1.237-5.621-3.198-7.392zm-5.67 1.109a.74.74 0 0 0-.74.739v.462a2.928 2.928 0 0 0-2.217 2.864c0 .926.45 1.65 1.005 2.055.406.297.82.47 1.212.636v3.014a2.12 2.12 0 0 1-.82-.866c-.148-.383-.65-.576-1.016-.393-.367.183-.517.703-.3 1.051.383.767 1.124 1.54 2.136 1.802v.462a.74.74 0 1 0 1.478 0v-.462a2.928 2.928 0 0 0 2.218-2.864c0-.927-.45-1.663-1.005-2.068-.406-.296-.82-.47-1.213-.635v-3.003c.362.203.655.525.82.855.149.382.65.576 1.017.393.366-.184.517-.703.3-1.051-.383-.767-1.125-1.531-2.137-1.79v-.462a.74.74 0 0 0-.739-.74zm-.74 2.737v2.39c-.532-.236-.736-.587-.739-1.062 0-.68.276-1.117.74-1.328zm1.478 4.688c.534.236.748.619.74 1.074 0 .68-.276 1.117-.74 1.328v-2.402z"})));};/* eslint-disable react/no-multi-comp */var CalculatorIcon=exports.CalculatorIcon=function CalculatorIcon(){return _react2.default.createElement("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",width:"44.5px",height:"50px",viewBox:"0 0 44.5 50"},_react2.default.createElement("g",null,_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M5.3,25.5h5.3v-5.3H5.3V25.5z M6.4,21.3h3.2v3.2H6.4V21.3z"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M5.3,35.1h5.3v-5.3H5.3V35.1z M6.4,34v-3.2h3.2V34L6.4,34L6.4,34z"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M5.3,44.7h5.3v-5.3H5.3V44.7z M6.4,40.4h3.2v3.2H6.4V40.4z"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M24.5,44.7h5.3v-5.3h-5.3V44.7z M25.5,40.4h3.2v3.2h-3.2V40.4z"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M24.5,35.1h5.3v-5.3h-5.3V35.1z M25.5,34v-3.2h3.2V34L25.5,34L25.5,34z"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M14.9,44.7L14.9,44.7h5.3v-5.3h-5.3V44.7z M16,40.4h3.2v3.2H16C16,43.6,16,40.4,16,40.4z"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M14.9,35.1L14.9,35.1l5.3,0v-5.3h-5.3V35.1z M16,34v-3.2h3.2V34L16,34L16,34z"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M14.9,25.5L14.9,25.5h5.3v-5.3h-5.3V25.5z M16,21.3h3.2v3.2H16C16,24.5,16,21.3,16,21.3z"}),_react2.default.createElement("polygon",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",points:"5.3,16 5.3,16 5.3,16 \t"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M44.5,17c0-5.2-4.2-9.4-9.4-9.5V2.7c0-1.5-1.2-2.7-2.7-2.7H2.7C1.2,0,0,1.2,0,2.7v44.7C0,48.8,1.2,50,2.7,50 h29.8c1.5,0,2.7-1.2,2.7-2.7V26.5C40.3,26.4,44.5,22.2,44.5,17z M32.4,48.9H2.7c-0.9,0-1.6-0.7-1.6-1.6V2.7c0-0.9,0.7-1.6,1.6-1.6 h29.8c0.9,0,1.6,0.7,1.6,1.6v4.9c-1.6,0.2-3,0.7-4.3,1.5V5.3H5.3V16h20.2c0,0.3-0.1,0.7-0.1,1c0,1.1,0.2,2.2,0.6,3.2h-1.6v5.3h5.3 v-0.6c1.2,0.8,2.7,1.4,4.3,1.5v20.9C34,48.2,33.3,48.9,32.4,48.9z M28.7,24.1v0.4h-3.2v-3.2h1C27.1,22.4,27.8,23.3,28.7,24.1z M25.7,14.9H6.4v0V6.4h22.3v3.5C27.3,11.2,26.2,12.9,25.7,14.9z M35,25.5c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5 S39.7,25.5,35,25.5z"}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#85736B",d:"M37.7,18.3c-0.2-0.3-0.4-0.5-0.8-0.7c-0.3-0.2-0.9-0.4-1.6-0.6v-2.9c0.7,0.1,1.4,0.2,2,0.5l0.3-0.9 c-0.7-0.3-1.5-0.5-2.4-0.5V12h-0.9v1.2c-0.7,0.1-1.3,0.3-1.8,0.7c-0.4,0.4-0.7,0.8-0.7,1.4c0,0.6,0.2,1.1,0.5,1.5 c0.4,0.4,1,0.7,1.9,1v2.9c-0.4,0-0.8-0.1-1.3-0.2c-0.5-0.1-0.9-0.2-1.3-0.4v1c0.3,0.1,0.7,0.2,1.1,0.3c0.5,0.1,0.9,0.1,1.4,0.1v1.5 h0.9v-1.5c0.8-0.1,1.4-0.3,1.9-0.7c0.4-0.4,0.7-0.9,0.7-1.5h0C38,18.9,37.9,18.6,37.7,18.3z M34.6,16.7c-0.5-0.2-0.8-0.4-1-0.6 c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.6-0.3,1-0.4V16.7z M35.4,20.6V18c0.6,0.2,0.9,0.4,1.1,0.6 c0.2,0.2,0.3,0.5,0.3,0.8C36.9,20.1,36.4,20.5,35.4,20.6z"})));};var CandleIcon=exports.CandleIcon=function CandleIcon(){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"34",height:"49",viewBox:"0 0 34 49"},_react2.default.createElement("g",{fill:"none",fillRule:"evenodd"},_react2.default.createElement("path",{fill:"#85736B",d:"M27.571 42.29H6.31l-3.577-3.575h28.415l-3.576 3.576zm-.446 4.211c0 .42-.34.761-.76.761H7.515a.762.762 0 0 1-.761-.76v-2.69h20.371v2.69zM10.054 13.74c0-.419.342-.76.762-.76h12.249c.42 0 .76.341.76.76v23.456H10.054V13.739zm4.324-8.186c0-1.338 1.581-2.904 2.562-3.702.981.796 2.561 2.36 2.561 3.702 0 1.763-1.03 2.948-2.56 2.948-1.533 0-2.563-1.185-2.563-2.948zm19.308 32.11a.76.76 0 0 0-.702-.468h-7.637V13.739a2.284 2.284 0 0 0-2.282-2.28H17.7V9.945c1.962-.358 3.321-2.092 3.321-4.393 0-2.627-3.27-5.015-3.642-5.279a.764.764 0 0 0-.878 0c-.373.264-3.643 2.652-3.643 5.279 0 2.301 1.36 4.035 3.321 4.393v1.512h-5.363a2.283 2.283 0 0 0-2.282 2.281v23.456H.896a.76.76 0 0 0-.538 1.296l4.876 4.875v3.135a2.284 2.284 0 0 0 2.28 2.283h18.85a2.285 2.285 0 0 0 2.283-2.283v-3.135l4.874-4.875a.76.76 0 0 0 .165-.829z"}),_react2.default.createElement("path",{stroke:"#FFF",strokeWidth:".2",d:"M27.571 42.29H6.31l-3.577-3.575h28.415l-3.576 3.576zm-.446 4.211c0 .42-.34.761-.76.761H7.515a.762.762 0 0 1-.761-.76v-2.69h20.371v2.69zM10.054 13.74c0-.419.342-.76.762-.76h12.249c.42 0 .76.341.76.76v23.456H10.054V13.739zm4.324-8.186c0-1.338 1.581-2.904 2.562-3.702.981.796 2.561 2.36 2.561 3.702 0 1.763-1.03 2.948-2.56 2.948-1.533 0-2.563-1.185-2.563-2.948zm19.308 32.11a.76.76 0 0 0-.702-.468h-7.637V13.739a2.284 2.284 0 0 0-2.282-2.28H17.7V9.945c1.962-.358 3.321-2.092 3.321-4.393 0-2.627-3.27-5.015-3.642-5.279a.764.764 0 0 0-.878 0c-.373.264-3.643 2.652-3.643 5.279 0 2.301 1.36 4.035 3.321 4.393v1.512h-5.363a2.283 2.283 0 0 0-2.282 2.281v23.456H.896a.76.76 0 0 0-.538 1.296l4.876 4.875v3.135a2.284 2.284 0 0 0 2.28 2.283h18.85a2.285 2.285 0 0 0 2.283-2.283v-3.135l4.874-4.875a.76.76 0 0 0 .165-.829z"})));};var ChecklistIcon=exports.ChecklistIcon=function ChecklistIcon(){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"37",height:"50",viewBox:"0 0 37 50"},_react2.default.createElement("path",{fill:"#85736B",fillRule:"nonzero",stroke:"#85736B",strokeWidth:".2",d:"M3.717.543A2.723 2.723 0 0 0 1 3.261v43.478a2.723 2.723 0 0 0 2.717 2.718h30.435a2.723 2.723 0 0 0 2.718-2.718V3.261A2.723 2.723 0 0 0 34.152.543H3.717zm0 1.087h30.435c.913 0 1.63.718 1.63 1.63v43.48c0 .912-.717 1.63-1.63 1.63H3.717c-.912 0-1.63-.718-1.63-1.63V3.26c0-.912.718-1.63 1.63-1.63zm2.174 4.892c-.345.005-.545.32-.543.543v7.609c0 .284.259.543.543.543h9.783a.565.565 0 0 0 .543-.543V7.065a.565.565 0 0 0-.543-.543H5.89zm.544 1.087h8.695v6.521H6.435V7.61zm13.587 2.717a.543.543 0 1 0 0 1.087h11.956a.543.543 0 1 0 0-1.087H20.022zm-2.225 8.135a.552.552 0 0 0-.39.238l-4.586 6.624L10 23.455a.565.565 0 0 0-.758.142.565.565 0 0 0 .147.758l3.26 2.174a.564.564 0 0 0 .748-.136l4.891-7.066c.252-.336-.074-.91-.492-.866zM5.89 19.565a.552.552 0 0 0-.543.544v9.782c0 .285.259.544.543.544h9.783a.565.565 0 0 0 .543-.544v-1.087a.557.557 0 0 0-.543-.543.558.558 0 0 0-.544.543v.544H6.435v-8.696h5.978a.557.557 0 0 0 .544-.543.558.558 0 0 0-.544-.544H5.891zm14.13 4.892a.544.544 0 0 0 0 1.086h11.957a.543.543 0 1 0 0-1.086H20.022zM5.892 34.783c-.345.005-.545.32-.543.543v7.609c0 .284.259.543.543.543h9.783a.565.565 0 0 0 .543-.543v-7.609a.565.565 0 0 0-.543-.543H5.89zm.544 1.087h8.695v6.521H6.435V35.87zm13.587 2.717a.543.543 0 1 0 0 1.087h11.956a.543.543 0 1 0 0-1.087H20.022z"}));};var DocumentIcon=exports.DocumentIcon=function DocumentIcon(){return _react2.default.createElement("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",width:"53.7px",height:"50px",viewBox:"0 0 53.7 50"},_react2.default.createElement("g",null,_react2.default.createElement("path",{fill:"#85736B",d:"M47.5,0L47.5,0l-0.4,0c0,0-0.1,0-0.1,0H13.8c-3.4,0-6.2,2.7-6.2,6.2v31.4H5.8c0,0-0.1,0-0.1,0 c-3.4,0.3-6,3.3-5.7,6.7c0.3,3,2.6,5.4,5.7,5.7c0,0,0.1,0,0.1,0h30.6c3.4,0,6.2-2.8,6.2-6.2V12.5h4.9c3.4,0,6.2-2.8,6.2-6.2 C53.7,2.8,50.9,0,47.5,0z M6.2,48.7L6.2,48.7c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9h26.3c-2.7,2.1-3.2,6-1,8.7 c0.3,0.4,0.6,0.7,1,1H6.2z M41.3,6.2v37.7h0c0,2.7-2.2,4.9-4.9,4.9c0,0,0,0,0,0c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9 c0,0,0,0,0,0c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7H8.9V6.2c0-2.7,2.2-4.9,4.9-4.9h29.8C42.2,2.5,41.3,4.3,41.3,6.2z M47.5,11.1 L47.5,11.1l-4.9,0V6.2c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9S50.2,11.1,47.5,11.1z"}),_react2.default.createElement("rect",{x:"14.4",y:"24",fill:"#85736B",width:"21.1",height:"1.4"}),_react2.default.createElement("rect",{x:"14.4",y:"29.2",fill:"#85736B",width:"21.1",height:"1.4"}),_react2.default.createElement("rect",{x:"14.4",y:"11.6",fill:"#85736B",width:"4.4",height:"1.4"}),_react2.default.createElement("rect",{x:"14.4",y:"18.8",fill:"#85736B",width:"21.1",height:"1.4"}),_react2.default.createElement("rect",{x:"21",y:"11.6",fill:"#85736B",width:"14.5",height:"1.4"})));};var GravestoneIcon=exports.GravestoneIcon=function GravestoneIcon(){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"36",height:"50",viewBox:"0 0 36 50"},_react2.default.createElement("g",{fill:"none",fillRule:"evenodd"},_react2.default.createElement("path",{fill:"#85736B",d:"M32.98 46.948H2.376v-1.321c0-.465.727-.987 1.701-.987H31.28c.975 0 1.7.52 1.7.987v1.321zM5.7 38.475a1.04 1.04 0 0 1 1.036-1.036H28.62a1.04 1.04 0 0 1 1.038 1.036V42.6H5.7v-4.125zm5.242-29.534l6.736-6.197 6.735 6.197V35.4H10.942V8.94zm20.755 33.695v-4.16A3.08 3.08 0 0 0 28.62 35.4h-2.166V8.493c0-.284-.12-.557-.329-.752L18.37.606a1.02 1.02 0 0 0-1.381 0L9.232 7.741a1.03 1.03 0 0 0-.328.752V35.4H6.736a3.08 3.08 0 0 0-3.075 3.075v4.161c-1.891.165-3.323 1.412-3.323 2.99v2.341a1.02 1.02 0 0 0 1.02 1.02h32.64a1.02 1.02 0 0 0 1.02-1.02v-2.34c0-1.579-1.432-2.826-3.321-2.99z"}),_react2.default.createElement("path",{stroke:"#FFF",strokeWidth:".5",d:"M32.98 46.948H2.376v-1.321c0-.465.727-.987 1.701-.987H31.28c.975 0 1.7.52 1.7.987v1.321zM5.7 38.475a1.04 1.04 0 0 1 1.036-1.036H28.62a1.04 1.04 0 0 1 1.038 1.036V42.6H5.7v-4.125zm5.242-29.534l6.736-6.197 6.735 6.197V35.4H10.942V8.94zm20.755 33.695v-4.16A3.08 3.08 0 0 0 28.62 35.4h-2.166V8.493c0-.284-.12-.557-.329-.752L18.37.606a1.02 1.02 0 0 0-1.381 0L9.232 7.741a1.03 1.03 0 0 0-.328.752V35.4H6.736a3.08 3.08 0 0 0-3.075 3.075v4.161c-1.891.165-3.323 1.412-3.323 2.99v2.341a1.02 1.02 0 0 0 1.02 1.02h32.64a1.02 1.02 0 0 0 1.02-1.02v-2.34c0-1.579-1.432-2.826-3.321-2.99z"})));};var TreeIcon=exports.TreeIcon=function TreeIcon(){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"36",height:"49",viewBox:"0 0 36 49"},_react2.default.createElement("g",{fill:"none",fillRule:"evenodd"},_react2.default.createElement("path",{fill:"#85736B",d:"M8.465 12.65c2.089 1.674 2.757 4.681 2.925 6.103-1.422.166-4.513.25-6.604-1.422-2.087-1.671-2.757-4.68-2.923-6.1 1.42-.084 4.512-.252 6.602 1.42m6.016-4.347c0-2.673 2.007-5.012 3.009-6.016 1.003 1.004 3.009 3.343 2.925 6.016 0 2.675-2.006 5.017-3.01 6.02-.917-1.003-2.924-3.345-2.924-6.02m12.285 4.347c2.09-1.672 5.18-1.504 6.602-1.42-.168 1.42-.836 4.429-2.925 6.1-2.09 1.672-5.182 1.504-6.602 1.422.25-1.422.836-4.429 2.925-6.102M24.76 25.353c2.09-1.67 5.182-1.504 6.604-1.42-.168 1.42-.838 4.43-2.925 6.1-2.09 1.671-5.182 1.505-6.602 1.421.166-1.421.752-4.428 2.923-6.101m-18.218 4.68c-2.089-1.67-2.757-4.68-2.923-6.1 1.42-.166 4.513-.25 6.6 1.42 2.09 1.673 2.76 4.68 2.927 6.101-1.338.084-4.43.25-6.604-1.421m-2.84-11.364c1.923 1.503 4.346 1.837 6.183 1.837.92 0 1.672-.082 2.09-.166l4.68 4.26v8.776L14.9 31.704c-.084-1.251-.67-5.43-3.594-7.687-3.427-2.675-8.525-1.671-8.691-1.588-.418.083-.668.418-.668.834 0 .252.25 5.433 3.593 8.108 1.921 1.503 4.344 1.839 6.184 1.839.92 0 1.671-.084 2.089-.168l2.84 2.675v12.004c0 .501.335.926.837.926.501 0 .835-.453.835-.953V35.8l2.841-2.759c.418.084 1.172.168 2.09.168 1.839 0 4.262-.336 6.184-1.84 3.426-2.674 3.594-7.855 3.594-8.107 0-.416-.252-.751-.67-.834-.25-.083-5.348-1.087-8.69 1.588-2.925 2.34-3.51 6.52-3.593 7.687l-1.756 1.672V24.6l4.93-4.26c.419.083 1.17.165 2.09.165 1.84 0 4.263-.334 6.186-1.837 3.425-2.675 3.593-7.856 3.593-8.107 0-.416-.252-.752-.67-.836-.25-.084-5.348-1.086-8.691 1.587-2.925 2.258-3.51 6.434-3.593 7.69l-3.845 3.343v-6.604c1.002-.918 3.845-3.843 3.845-7.52 0-4.346-3.929-7.687-4.095-7.855a.877.877 0 0 0-1.087 0c-.166.168-4.095 3.509-4.095 7.855 0 3.677 2.925 6.77 3.845 7.604v6.52l-3.593-3.26c-.084-1.255-.67-5.432-3.595-7.689C6.124 8.724 1.025 9.726.86 9.81c-.419.084-.669.418-.669.836-.084.167.166 5.348 3.51 8.023"}),_react2.default.createElement("path",{stroke:"#FFF",strokeWidth:".2",d:"M8.465 12.65c2.089 1.674 2.757 4.681 2.925 6.103-1.422.166-4.513.25-6.604-1.422-2.087-1.671-2.757-4.68-2.923-6.1 1.42-.084 4.512-.252 6.602 1.42zm6.016-4.346c0-2.673 2.007-5.012 3.009-6.016 1.003 1.004 3.009 3.343 2.925 6.016 0 2.675-2.006 5.017-3.01 6.02-.917-1.003-2.924-3.345-2.924-6.02zm12.285 4.347c2.09-1.672 5.18-1.504 6.602-1.42-.168 1.42-.836 4.429-2.925 6.1-2.09 1.672-5.182 1.504-6.602 1.422.25-1.422.836-4.429 2.925-6.102zM24.76 25.353c2.09-1.67 5.182-1.504 6.604-1.42-.168 1.42-.838 4.43-2.925 6.1-2.09 1.671-5.182 1.505-6.602 1.421.166-1.421.752-4.428 2.923-6.101zm-18.218 4.68c-2.089-1.67-2.757-4.68-2.923-6.1 1.42-.166 4.513-.25 6.6 1.42 2.09 1.673 2.76 4.68 2.927 6.101-1.338.084-4.43.25-6.604-1.421zm-2.84-11.364c1.923 1.503 4.346 1.837 6.183 1.837.92 0 1.672-.082 2.09-.166l4.68 4.26v8.776L14.9 31.704c-.084-1.251-.67-5.43-3.594-7.687-3.427-2.675-8.525-1.671-8.691-1.588-.418.083-.668.418-.668.834 0 .252.25 5.433 3.593 8.108 1.921 1.503 4.344 1.839 6.184 1.839.92 0 1.671-.084 2.089-.168l2.84 2.675v12.004c0 .501.335.926.837.926.501 0 .835-.453.835-.953V35.8l2.841-2.759c.418.084 1.172.168 2.09.168 1.839 0 4.262-.336 6.184-1.84 3.426-2.674 3.594-7.855 3.594-8.107 0-.416-.252-.751-.67-.834-.25-.083-5.348-1.087-8.69 1.588-2.925 2.34-3.51 6.52-3.593 7.687l-1.756 1.672V24.6l4.93-4.26c.419.083 1.17.165 2.09.165 1.84 0 4.263-.334 6.186-1.837 3.425-2.675 3.593-7.856 3.593-8.107 0-.416-.252-.752-.67-.836-.25-.084-5.348-1.086-8.691 1.587-2.925 2.258-3.51 6.434-3.593 7.69l-3.845 3.343v-6.604c1.002-.918 3.845-3.843 3.845-7.52 0-4.346-3.929-7.687-4.095-7.855a.877.877 0 0 0-1.087 0c-.166.168-4.095 3.509-4.095 7.855 0 3.677 2.925 6.77 3.845 7.604v6.52l-3.593-3.26c-.084-1.255-.67-5.432-3.595-7.689C6.124 8.724 1.025 9.726.86 9.81c-.419.084-.669.418-.669.836-.084.167.166 5.348 3.51 8.023z"})));};

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PlanningSearchCTA=__webpack_require__(1306);var _PlanningSearchCTA2=_interopRequireDefault(_PlanningSearchCTA);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _Shared=__webpack_require__(173);var _Shared2=_interopRequireDefault(_Shared);var _Button=__webpack_require__(143);var _Button2=_interopRequireDefault(_Button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var planningImg=__webpack_require__(1308);var PlanningSearchCTA=function PlanningSearchCTA(){return _react2.default.createElement('div',{className:_PlanningSearchCTA2.default.PlanningSearchCTA},_react2.default.createElement('div',{className:_Shared2.default.Wrap},_react2.default.createElement('div',{className:_PlanningSearchCTA2.default.PlanningCTABlock},_react2.default.createElement('div',{className:_PlanningSearchCTA2.default.ContentContainer},_react2.default.createElement('h2',{className:_PlanningSearchCTA2.default.Title},'Ready to contact a funeral\xA0home?'),_react2.default.createElement('div',{className:_PlanningSearchCTA2.default.Blurb},'Once you\'ve gathered your preferences, discuss them with a local funeral\xA0director.'),_react2.default.createElement(_Button2.default,{href:(0,_AppConfig2.default)().vanityDomain+'/funeral-homes',target:'_blank',className:_PlanningSearchCTA2.default.Button+' button btn large-button primary'},'Search Now')),_react2.default.createElement('div',{className:_PlanningSearchCTA2.default.ImgContainer},_react2.default.createElement('img',{src:planningImg})))));};exports.default=PlanningSearchCTA;

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap","PlanningSearchCTA":"PlanningSearchCTA","PlanningCTABlock":"PlanningCTABlock","ContentContainer":"ContentContainer","Title":"Title","Blurb":"Blurb","ImgContainer":"ImgContainer","Button":"Button","disabled":"disabled"};

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","btn":"btn","large-button":"large-button","small-button":"small-button"};

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/planning-laptop-phone.f191b6d5.png";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PlanAhead=__webpack_require__(1310);var _PlanAhead2=_interopRequireDefault(_PlanAhead);var _Svgs=__webpack_require__(1311);var _Shared=__webpack_require__(173);var _Shared2=_interopRequireDefault(_Shared);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PlanAhead=function PlanAhead(){return _react2.default.createElement('div',{className:_Shared2.default.Wrap},_react2.default.createElement('div',{className:_PlanAhead2.default.PlanAheadBlock},_react2.default.createElement('h2',{className:_PlanAhead2.default.Title},'Why plan ahead?'),_react2.default.createElement('div',{className:_PlanAhead2.default.PlanReasons},_react2.default.createElement('div',{className:_PlanAhead2.default.PlanReason},_react2.default.createElement('div',{className:_PlanAhead2.default.IconContainer},_react2.default.createElement(_Svgs.CheckIcon,null)),_react2.default.createElement('div',{className:_PlanAhead2.default.PlanReasonDescription},'Ease the burden on your loved\xA0ones.')),_react2.default.createElement('div',{className:_PlanAhead2.default.PlanReason},_react2.default.createElement('div',{className:_PlanAhead2.default.IconContainer},_react2.default.createElement(_Svgs.CheckIcon,null)),_react2.default.createElement('div',{className:_PlanAhead2.default.PlanReasonDescription},'Make your final wishes\xA0known.')),_react2.default.createElement('div',{className:_PlanAhead2.default.PlanReason},_react2.default.createElement('div',{className:_PlanAhead2.default.IconContainer},_react2.default.createElement(_Svgs.CheckIcon,null)),_react2.default.createElement('div',{className:_PlanAhead2.default.PlanReasonDescription},'Save money.')))));};exports.default=PlanAhead;

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap","PlanAheadBlock":"PlanAheadBlock","Title":"Title","PlanReasons":"PlanReasons","PlanReason":"PlanReason","IconContainer":"IconContainer","PlanReasonDescription":"PlanReasonDescription"};

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CheckIcon=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckIcon=exports.CheckIcon=function CheckIcon(){return _react2.default.createElement("svg",{xmlns:"https://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},_react2.default.createElement("defs",null,_react2.default.createElement("circle",{id:"a",cx:"12",cy:"12",r:"12"}),_react2.default.createElement("path",{id:"b",d:"M4.396 9.443L13.592.247a.843.843 0 0 1 1.191 1.191l-9.645 9.645a.853.853 0 0 1-.056.052.843.843 0 0 1-1.277.1L.247 7.677a.843.843 0 1 1 1.191-1.192l2.958 2.958z"})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd"},_react2.default.createElement("path",{d:"M0 0h24v24H0z"}),_react2.default.createElement("use",{fill:"#00816B",xlinkHref:"#a"}),_react2.default.createElement("use",{fill:"#FFF",transform:"translate(4.5 6)",xlinkHref:"#b"})));};/* eslint-disable react/no-multi-comp */

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Hero=__webpack_require__(558);var _Hero2=_interopRequireDefault(_Hero);var _Shared=__webpack_require__(173);var _Shared2=_interopRequireDefault(_Shared);var _LeadFormEmailOnly=__webpack_require__(1313);var _LeadFormEmailOnly2=_interopRequireDefault(_LeadFormEmailOnly);var _assets=__webpack_require__(584);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Hero=function Hero(){return _react2.default.createElement('div',{className:_Hero2.default.HeroBlock,style:_assets.bgStyles},_react2.default.createElement('div',{className:_Shared2.default.Wrap},_react2.default.createElement('div',{className:_Hero2.default.HeroContent},_react2.default.createElement('div',{className:_Hero2.default.HeroInner},_react2.default.createElement('h1',{className:_Hero2.default.Title},'Get Answers About Planning\xA0Ahead'),_react2.default.createElement('h2',{className:_Hero2.default.SubTitle},'Download your free funeral planning guide\xA0&\xA0checklist'),_react2.default.createElement('div',{className:_Hero2.default.Form},_react2.default.createElement(_LeadFormEmailOnly2.default,null))),_react2.default.createElement('div',{className:_Hero2.default.Image},_react2.default.createElement('img',{src:_assets.GuideImage['1x'],alt:'Your Guide to Planning Ahead thumbnail',srcSet:_assets.GuideImage['2x']+' 2x, '+_assets.GuideImage['3x']+' 3x',sizes:'527px'})))));};exports.default=Hero;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Button=__webpack_require__(143);var _Button2=_interopRequireDefault(_Button);var _LeadForm=__webpack_require__(350);var _LeadForm2=_interopRequireDefault(_LeadForm);var _EmailLeadForm=__webpack_require__(1400);var _EmailLeadForm2=_interopRequireDefault(_EmailLeadForm);var _salesforceApi=__webpack_require__(360);var _PlanningGuideLeadForm=__webpack_require__(361);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TempLeadForm=function(_Component){(0,_inherits3.default)(TempLeadForm,_Component);function TempLeadForm(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,TempLeadForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=TempLeadForm.__proto__||(0,_getPrototypeOf2.default)(TempLeadForm)).call.apply(_ref,[this].concat(args))),_this),_this.fields=[{name:'email',title:'Email Address',placeholder:'Enter your Email Address',type:'email'}],_this.styles={width:'100%',maxWidth:'485px',margin:'0 auto'},_this.handleSubmit=function(formValues,formik){var body=(0,_salesforceApi.buildSalesforcePayload)({form:'helpPlanning',formValues:formValues});(0,_salesforceApi.sendToWebcollect)({body:body,externalKey:'ECC651A8-1542-47A9-83A5-98E1CFDC788E'}).then(function(json){var success=json.success,_json$error=json.error,error=_json$error===undefined?undefined:_json$error;// eslint-disable-line no-undefined
formik.setSubmitting(false);formik.setStatus({loading:false,success:success,error:error});}).catch(function(){formik.setSubmitting(false);formik.setStatus({loading:false,error:true,success:false});});},_this.renderSuccess=function(){return _react2.default.createElement('div',{className:_EmailLeadForm2.default.SuccessContainer},_react2.default.createElement('p',{className:_EmailLeadForm2.default.SuccessMessage},'Success! Thank you.'),_react2.default.createElement(_Button2.default,{href:_PlanningGuideLeadForm.GUIDE_LINK,type:'large-button',className:_EmailLeadForm2.default.SuccessButton,target:'_blank',download:'Your Guide to Planning Ahead'},'Download Your Guide'));},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(TempLeadForm,[{key:'render',value:function render(){return _react2.default.createElement('div',{style:this.styles,className:_EmailLeadForm2.default.EmailLead},_react2.default.createElement(_LeadForm2.default,{initialValues:{email:''},onSubmit:this.handleSubmit,submitText:'Get the Guide',renderSuccess:this.renderSuccess,fields:this.fields,styleMods:{emailOnly:true}}));}}]);return TempLeadForm;}(_react.Component);exports.default=TempLeadForm;

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1317);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(1318);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(16);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(1320);


/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDeep);


/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayEach_js__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assignValue_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseAssign_js__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__copyArray_js__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__copySymbols_js__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getTag_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isBuffer_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isMap_js__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isObject_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isSet_js__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__keys_js__ = __webpack_require__(352);






















/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!Object(__WEBPACK_IMPORTED_MODULE_18__isObject_js__["a" /* default */])(value)) {
    return value;
  }
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_15__isArray_js__["a" /* default */])(value);
  if (isArr) {
    result = Object(__WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__["a" /* default */])(value);
    if (!isDeep) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__copyArray_js__["a" /* default */])(value, result);
    }
  } else {
    var tag = Object(__WEBPACK_IMPORTED_MODULE_11__getTag_js__["a" /* default */])(value),
        isFunc = tag == funcTag || tag == genTag;

    if (Object(__WEBPACK_IMPORTED_MODULE_16__isBuffer_js__["a" /* default */])(value)) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__["a" /* default */])(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : Object(__WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__["a" /* default */])(value);
      if (!isDeep) {
        return isFlat
          ? Object(__WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__["a" /* default */])(result, value))
          : Object(__WEBPACK_IMPORTED_MODULE_7__copySymbols_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_3__baseAssign_js__["a" /* default */])(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = Object(__WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__["a" /* default */])(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (Object(__WEBPACK_IMPORTED_MODULE_19__isSet_js__["a" /* default */])(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_17__isMap_js__["a" /* default */])(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__["a" /* default */])
    : (isFlat ? keysIn : __WEBPACK_IMPORTED_MODULE_20__keys_js__["a" /* default */]);

  var props = isArr ? undefined : keysFunc(value);
  Object(__WEBPACK_IMPORTED_MODULE_1__arrayEach_js__["a" /* default */])(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    Object(__WEBPACK_IMPORTED_MODULE_2__assignValue_js__["a" /* default */])(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClone);


/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(1331);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(236);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(236);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(236);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(236);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(235);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(564);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(563);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(237);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1336);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(79);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(351);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(1344);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(238);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(238);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(238);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(238);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(239);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(239);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(239);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(239);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(117);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(352);



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssign);


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(144);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(144);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(354);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(144);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1361);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(570);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(572);



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignIn);


/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(1364);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(79);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(204)(module)))

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(356);



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbols);


/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(575);



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbolsIn);


/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(352);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(572);




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeysIn);


/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(79);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(79);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(79);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(79);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneArray);


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__ = __webpack_require__(1381);






/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return Object(__WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__["a" /* default */])(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return Object(__WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__["a" /* default */])(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return Object(__WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__["a" /* default */])(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return Object(__WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__["a" /* default */])(object);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneByTag);


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(79);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(358);


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDataView);


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneRegExp);


/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(237);


/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ __webpack_exports__["a"] = (cloneSymbol);


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(358);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(355);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(175);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(354);




/* Node.js helper references. */
var nodeIsMap = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsMap) : __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isMap);


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(144);



/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == mapTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMap);


/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(354);




/* Node.js helper references. */
var nodeIsSet = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsSet) : __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isSet);


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(144);



/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == setTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsSet);


/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(1393);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(1390);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(1391);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(564);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(359);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(1394);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(359);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["a"] = (deepmerge_1);


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 1398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","LeadForm":"LeadForm","FormError":"FormError","EmailOnly":"EmailOnly","FieldWrap":"FieldWrap","SuccessButton":"SuccessButton"};

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(324);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _formik=__webpack_require__(559);var _EnhancedTextInput=__webpack_require__(535);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FormikTextInput=function FormikTextInput(_ref){var field=_ref.field,form=_ref.form,rest=(0,_objectWithoutProperties3.default)(_ref,['field','form']);var name=field.name;var _form$errors=form.errors,errors=_form$errors===undefined?{}:_form$errors,_form$touched=form.touched,touched=_form$touched===undefined?{}:_form$touched,initialValues=form.initialValues,setFieldValue=form.setFieldValue;var initialValue=(0,_formik.getIn)(initialValues,name);var clearField=function clearField(){setFieldValue(name,initialValue);};return _react2.default.createElement(_EnhancedTextInput.EnhancedTextInput,(0,_extends3.default)({name:name,error:(0,_formik.getIn)(errors,name),touched:(0,_formik.getIn)(touched,name),onClear:clearField,value:initialValue},field,rest));};exports.default=(0,_formik.connect)(FormikTextInput);

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","EmailLead":"EmailLead","SuccessMessage":"SuccessMessage","SuccessContainer":"SuccessContainer","SuccessButton":"SuccessButton"};

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(464);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1403), __esModule: true };

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1404);
module.exports = __webpack_require__(35).Object.keys;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(156);
var $keys = __webpack_require__(159);

__webpack_require__(462)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(1406);
module.exports = self.fetch.bind(self);


/***/ }),
/* 1406 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(1408),
    createAssigner = __webpack_require__(1414);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(233),
    arrayEach = __webpack_require__(331),
    assignMergeValue = __webpack_require__(581),
    baseKeysIn = __webpack_require__(582),
    baseMergeDeep = __webpack_require__(1410),
    isArray = __webpack_require__(46),
    isObject = __webpack_require__(54),
    isTypedArray = __webpack_require__(349);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

module.exports = baseMerge;


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(581),
    baseClone = __webpack_require__(544),
    copyArray = __webpack_require__(223),
    isArguments = __webpack_require__(163),
    isArray = __webpack_require__(46),
    isArrayLikeObject = __webpack_require__(479),
    isFunction = __webpack_require__(136),
    isObject = __webpack_require__(54),
    isPlainObject = __webpack_require__(1411),
    isTypedArray = __webpack_require__(349),
    toPlainObject = __webpack_require__(1412);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototype = __webpack_require__(551),
    isHostObject = __webpack_require__(212),
    isObjectLike = __webpack_require__(95);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

module.exports = isPlainObject;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(347),
    keysIn = __webpack_require__(1413);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(543),
    baseKeysIn = __webpack_require__(582),
    isArrayLike = __webpack_require__(137);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(326),
    isIterateeCall = __webpack_require__(1415);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(161),
    isArrayLike = __webpack_require__(137),
    isIndex = __webpack_require__(224),
    isObject = __webpack_require__(54);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","PlanningGuideLeadForm":"PlanningGuideLeadForm","LeadForm":"LeadForm","FieldControl":"FieldControl","SuccessButton":"SuccessButton","Light":"Light"};

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/guide-open-img.e9625cbb.png";

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/guide-open-img@2x.150186a9.png";

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/guide-open-img@3x.a780195a.png";

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/mobile-main-img.e9ee3590.jpg";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Desktop-BG.d72e3c92.jpg";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Hero=__webpack_require__(558);var _Hero2=_interopRequireDefault(_Hero);var _Shared=__webpack_require__(173);var _Shared2=_interopRequireDefault(_Shared);var _assets=__webpack_require__(584);var _PlanningGuideLeadForm=__webpack_require__(361);var _PlanningGuideLeadForm2=_interopRequireDefault(_PlanningGuideLeadForm);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var cx=_classnames2.default.bind(_Hero2.default);var HeroAlternate=function HeroAlternate(){var classes={HeroBlock:true,Alternate:true};return _react2.default.createElement('div',{className:cx(classes),style:_assets.bgStyles},_react2.default.createElement('div',{className:_Shared2.default.Wrap},_react2.default.createElement('div',{className:_Hero2.default.HeroHeading},_react2.default.createElement('h1',{className:_Hero2.default.Title},'Get Answers About Planning\xA0Ahead'),_react2.default.createElement('h2',{className:_Hero2.default.SubTitle},'Download your free funeral planning guide\xA0&\xA0checklist')),_react2.default.createElement('div',{className:_Hero2.default.HeroContent},_react2.default.createElement('div',{className:_Hero2.default.HeroInner},_react2.default.createElement('div',{className:_Hero2.default.Form},_react2.default.createElement(_PlanningGuideLeadForm2.default,{webcollectKey:'ECC651A8-1542-47A9-83A5-98E1CFDC788E',theme:'dark',visibleFields:['firstName','lastName','email','zipCode','phoneNumber']}))),_react2.default.createElement('div',{className:_Hero2.default.Image},_react2.default.createElement('img',{src:_assets.GuideImage['1x'],alt:'Your Guide to Planning Ahead thumbnail',srcSet:_assets.GuideImage['2x']+' 2x, '+_assets.GuideImage['3x']+' 3x',sizes:'527px'})))));};exports.default=HeroAlternate;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Search=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _Search=__webpack_require__(1424);var _Search2=_interopRequireDefault(_Search);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Funeral Home Faceted Search module
 * @class   Search
 * @return  {JSX}     Returns the rendered module
 */var Search=exports.Search=function(_React$Component){(0,_inherits3.default)(Search,_React$Component);/**
   * Funeral Home Faceted Search React Component constructor
   * @param       {Object}    props   Passed in props
   * @constructs  {Search}
   * @return      {Undefined} Returns nothing
   */function Search(props){(0,_classCallCheck3.default)(this,Search);return(0,_possibleConstructorReturn3.default)(this,(Search.__proto__||(0,_getPrototypeOf2.default)(Search)).call(this,props));}/**
   * React Component render.
   * @return {JSX} Faceted Search page rendered.
   */(0,_createClass3.default)(Search,[{key:'render',value:function render(){var funeralHomes=this.props.funeralHomes;return _react2.default.createElement('div',{className:_Search2.default.Search},'Arrived At Faceted Search',_react2.default.createElement('div',null,'Search Retrieved ',funeralHomes.length,' Homes',_react2.default.createElement('ul',null,funeralHomes.map(function(fh,key){return _react2.default.createElement('li',{key:key,style:{padding:'10px'}},_react2.default.createElement('div',null,fh.name,' -',' ',fh.premiumSubscriber?'A Partner Home':'A Standard Home'),_react2.default.createElement('div',null,fh.address1,', ',fh.city,', ',fh.state));}))));}}]);return Search;}(_react2.default.Component);/* istanbul ignore next */Search.propTypes={ads:_react2.default.PropTypes.object.isRequired,funeralHomes:_react2.default.PropTypes.array.isRequired};var mapStateToProps=function mapStateToProps(state){return{ads:state.adStore,funeralHomes:state.searchFuneralHomesStore.funeralHomes};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Search);

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Search":"Search"};

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Profile=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);__webpack_require__(1426);var _Carousel=__webpack_require__(1427);var _Carousel2=_interopRequireDefault(_Carousel);var _Tabs=__webpack_require__(1470);var _Tabs2=_interopRequireDefault(_Tabs);var _Aside=__webpack_require__(1551);var _Aside2=_interopRequireDefault(_Aside);var _FuneralInfo=__webpack_require__(1568);var _FuneralInfo2=_interopRequireDefault(_FuneralInfo);var _TopLeaderboardAdOptions=__webpack_require__(1572);var _TopLeaderboardAdOptions2=_interopRequireDefault(_TopLeaderboardAdOptions);var _cookies=__webpack_require__(172);var _urlHelpers=__webpack_require__(28);var _constants=__webpack_require__(41);var _Breadcrumbs=__webpack_require__(1578);var _Breadcrumbs2=_interopRequireDefault(_Breadcrumbs);var _MobileOverlayAd=__webpack_require__(1580);var _MobileOverlayAd2=_interopRequireDefault(_MobileOverlayAd);var _WithMediaQuery=__webpack_require__(1584);var _WithMediaQuery2=_interopRequireDefault(_WithMediaQuery);var _CtaModule=__webpack_require__(613);var _CtaModule2=_interopRequireDefault(_CtaModule);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Profile=exports.Profile=function(_Component){(0,_inherits3.default)(Profile,_Component);function Profile(){(0,_classCallCheck3.default)(this,Profile);return(0,_possibleConstructorReturn3.default)(this,(Profile.__proto__||(0,_getPrototypeOf2.default)(Profile)).apply(this,arguments));}(0,_createClass3.default)(Profile,[{key:'componentDidMount',value:function componentDidMount(){// If the affiliate that is associated to this profile page request
// is not cookied, set the Legacy Global Affiliate Cookie for the user
if(this.props.affiliate){this.setAffiliateCookie();}}},{key:'setAffiliateCookie',value:function setAffiliateCookie(){var _props$affiliate=this.props.affiliate,affiliateId=_props$affiliate.sourceId,siteName=_props$affiliate.siteName;if(affiliateId){var affiliateCookie=(0,_cookies.getCookie)(_constants.AFFILIATE_COOKIE.name);var currentCookiedAffiliateId=(0,_cookies.getAspCookieSubValue)(affiliateCookie,_constants.AFFILIATE_COOKIE.idKey);if(currentCookiedAffiliateId!==''+affiliateId){var cookieSubValues=[_constants.AFFILIATE_COOKIE.idKey+'='+affiliateId,_constants.AFFILIATE_COOKIE.siteNameKey+'='+siteName,_constants.AFFILIATE_COOKIE.urlKey+'='+(0,_urlHelpers.buildAffiliateUrl)(siteName)];(0,_cookies.setCookie)(_constants.AFFILIATE_COOKIE.name,cookieSubValues.join('&'),4/24);}}}},{key:'render',value:function render(){var mqMatches=this.props.matches;var funeralHome=this.props.funeralHome;var isPremium=funeralHome.isPremium,_funeralHome$adData=funeralHome.adData;_funeralHome$adData=_funeralHome$adData===undefined?{}:_funeralHome$adData;var displayOverlayOnMobile=_funeralHome$adData.displayOverlayOnMobile;var entityBreadcrumbs={name:funeralHome.name,location:funeralHome.location};return _react2.default.createElement('div',{className:'funeral-home-profile'},_react2.default.createElement('div',{className:'funeral-home-profile-content'},_react2.default.createElement('div',{className:'head-container'},_react2.default.createElement(_Breadcrumbs2.default,{entity:entityBreadcrumbs}),!isPremium&&_react2.default.createElement(_TopLeaderboardAdOptions2.default,{adService:this.props.ads.adService})),isPremium&&_react2.default.createElement(_Carousel2.default,null),_react2.default.createElement('main',{className:'main-container'},_react2.default.createElement('div',{className:'left-side'},_react2.default.createElement(_FuneralInfo2.default,{funeralHome:this.props.funeralHome}),mqMatches&&_react2.default.createElement(_CtaModule2.default,null),_react2.default.createElement(_Tabs2.default,{funeralHome:this.props.funeralHome})),_react2.default.createElement(_Aside2.default,null)),!isPremium&&displayOverlayOnMobile&&_react2.default.createElement(_MobileOverlayAd2.default,{positionId:'display-overlay-1'})));}}]);return Profile;}(_react.Component);Profile.propTypes={ads:_react2.default.PropTypes.object.isRequired,affiliate:_react2.default.PropTypes.object,funeralHome:_react2.default.PropTypes.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{ads:state.adStore,affiliate:state.affiliateStore,funeralHome:state.funeralHomeStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)((0,_WithMediaQuery2.default)(Profile,{mediaQuery:'(max-width: 900px)'}));

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","funeral-home-profile-content":"funeral-home-profile-content","main-container":"main-container","left-side":"left-side","react-tabs":"react-tabs","tab-header":"tab-header"};

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Carousel=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _reactSlick=__webpack_require__(1428);var _reactSlick2=_interopRequireDefault(_reactSlick);__webpack_require__(1444);var _icons=__webpack_require__(177);var _icons2=_interopRequireDefault(_icons);var _imageHelper=__webpack_require__(1454);var _imageHelper2=_interopRequireDefault(_imageHelper);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Carousel=exports.Carousel=function(_Component){(0,_inherits3.default)(Carousel,_Component);function Carousel(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Carousel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Carousel.__proto__||(0,_getPrototypeOf2.default)(Carousel)).call.apply(_ref,[this].concat(args))),_this),_this.addImagesIfLessThanThree=function(images){var _this$props$funeralHo=_this.props.funeralHome.funeralHomeId,funeralHomeId=_this$props$funeralHo===undefined?0:_this$props$funeralHo;var seriesStart=Math.floor(funeralHomeId%10/2);var fillerImages=(0,_imageHelper2.default)();if(images.length===0){return[fillerImages[seriesStart],fillerImages[seriesStart+1],fillerImages[seriesStart+2]];}if(images.length===1){return[images[0],fillerImages[seriesStart+1],fillerImages[seriesStart+2]];}if(images.length===2){return[images[0],fillerImages[seriesStart],images[1]];}return images;},_this.cleanVideoUrl=function(link){return link.replace(/\/watch\?v=/,'/embed/');},_this.PrevArrow=function(props){var onClick=props.onClick;return _react2.default.createElement('div',{className:'slick-arrow slick-prev',onClick:onClick},_react2.default.createElement(_icons2.default,{className:'funeral-home-amenities__svg',name:'leftArrow',fill:'#ffffff',size:'64px'}));},_this.NextArrow=function(props){var onClick=props.onClick;return _react2.default.createElement('div',{className:'slick-arrow slick-next',onClick:onClick},_react2.default.createElement(_icons2.default,{className:'funeral-home-amenities__svg',name:'rightArrow',fill:'#ffffff',size:'64px'}));},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Carousel,[{key:'getImages',value:function getImages(){var images=this.props.images.filter(function(image){return image.includeInCarousel;}).map(function(image){return image.url;});return this.addImagesIfLessThanThree(images);}},{key:'render',value:function render(){var _this2=this;var NextArrow=this.NextArrow;var PrevArrow=this.PrevArrow;var sliderUrls=this.getImages().map(function(url,index){if(url.toLowerCase().match(/png$|jpg$|gif$|svg$/)){return _react2.default.createElement('img',{src:url,key:index});}var videoUrl=_this2.cleanVideoUrl(url);return _react2.default.createElement('iframe',{key:index,frameBorder:'0',height:'284px',allowFullScreen:'allowfullscreen',src:videoUrl});});var settingsForMobile={dots:true,infinite:true,slidesToShow:1,slidesToScroll:1,arrows:false,variableWidth:false,speed:500,appendDots:function appendDots(dots){return _react2.default.createElement('div',null,_react2.default.createElement('ul',{style:{margin:'0px'}},dots));},customPaging:function customPaging(){return _react2.default.createElement('div',{className:'dots'},_react2.default.createElement(_icons2.default,{className:'slick-list-dots',name:'circle',fill:'#ffffff',size:'14px'}));}};var settingsForDesktop={className:'slider variable-width multiple-images',dots:false,infinite:true,centerMode:true,slidesToShow:1,slidesToScroll:1,variableWidth:true,arrows:true,speed:500,nextArrow:_react2.default.createElement(NextArrow,null),prevArrow:_react2.default.createElement(PrevArrow,null)};var settings=typeof window!=='undefined'&&window.matchMedia('(min-width: 768px)').matches?settingsForDesktop:settingsForMobile;return _react2.default.createElement('div',{className:'carousel'},sliderUrls.length>0?_react2.default.createElement(_reactSlick2.default,settings,sliderUrls):null);}}]);return Carousel;}(_react.Component);Carousel.propTypes={images:_react2.default.PropTypes.array.isRequired,funeralHome:_react2.default.PropTypes.object};var mapStateToProps=function mapStateToProps(state){return{funeralHome:state.funeralHomeStore,images:state.funeralHomeStore.images};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Carousel);

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(1429);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(1430);

var _json2mq = __webpack_require__(1437);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(1439);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(1440);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(59);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(1431);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(1432);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(241);

var _track = __webpack_require__(1433);

var _dots = __webpack_require__(1434);

var _arrows = __webpack_require__(1435);

var _resizeObserverPolyfill = __webpack_require__(1436);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          currentSlide = _this$props.currentSlide,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */


/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */


/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [], len = arguments.length - 1;
    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */


/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */


/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */


/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */


/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(1438);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(1441);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(1442);
var Util = __webpack_require__(585);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(1443);
var each = __webpack_require__(585).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 1443 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 1444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"funeral-home-profile":"funeral-home-profile","slick-slider":"slick-slider","slick-list":"slick-list","slick-track":"slick-track","slick-slide":"slick-slide","slick-prev":"slick-prev","slick-next":"slick-next","slick-current":"slick-current","multiple-images":"multiple-images","leftArrow":"leftArrow","rightArrow":"rightArrow","slick-dots":"slick-dots","dots":"dots","slick-active":"slick-active"};

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckMark=function CheckMark(){var fill=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'#000000';return _react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm7.28,7.44L9.64,17.08l-.06.06a.85.85,0,0,1-1.18.18l-.1-.08L4.75,13.68a.84.84,0,0,1,0-1.19.85.85,0,0,1,1.19-.05l0,.05,3,2.95,9.19-9.19a.84.84,0,0,1,1.19,1.19Z',fill:fill}),_react2.default.createElement('path',{d:'M19.28,7.44,9.64,17.08l-.06.06a.85.85,0,0,1-1.18.18l-.1-.08L4.75,13.68a.84.84,0,0,1,0-1.19.85.85,0,0,1,1.19-.05l0,.05,3,2.95,9.19-9.19a.84.84,0,0,1,1.19,1.19Z',fill:'white'}));};exports.default=CheckMark;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Globe=function Globe(){var fill=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'#000000';return _react2.default.createElement('g',{fill:'none',fillRule:'evenodd'},_react2.default.createElement('path',{fill:fill,fillRule:'nonzero',d:'M15.905 7.126C15.43 2.809 11.507-.311 7.14.156 2.775.627-.38 4.505.094 8.823c.219 1.999 1.203 3.715 2.58 4.99 3.302 3.063 8.4 2.658 11.394-.757 1.376-1.571 2.082-3.7 1.837-5.93zM2.589 3.096h.01l.002.017-.023.005c-.02-.006.011-.022.011-.022zm-.084.182l.007.011c.007.01-.001.014-.001.014s-.013.02-.018.011c-.003-.008-.013-.021-.013-.021l.025-.015zm-.012.141l-.012.004s-.015-.013-.016-.022l.016-.018.005-.003.01.017-.003.022zm.049.06l-.016.02-.01-.008a.09.09 0 0 1-.018-.026l.014-.016s.005-.004.014-.007c.008-.004.01.002.016.01s0 .027 0 .027zm.01-.274l-.008.018-.014-.016.002-.01.007-.02.013.007c.012.007 0 .02 0 .02zm.058.403c-.008.007-.024.003-.024.003l-.023-.045c-.004-.015.023-.012.032-.016.009-.003.012-.001.012-.001l.026.016s-.015.036-.023.043zm-.005-.584l.012-.017.01-.013c.01-.013.006 0 .006 0l.002.02-.03.01zm10.806-.034c.019.004.011.009.01.009l.007.034c.006.023-.01.02-.014.01-.003-.008-.009-.005-.017-.024-.009-.02-.018-.025-.018-.025-.004-.009.014-.008.032-.004zm-.143-.456l.05.01c.048.009.026-.006.044-.005.018 0 .007.013.01.031.001.017.008.055.008.055l-.013.04s-.014-.013-.025-.039a.225.225 0 0 1-.018-.048s-.025-.006-.042-.005c-.018.003-.014-.04-.014-.04zm-.114.057l.082.038c.054.023.034.029.047.04a.5.5 0 0 1 .101.099c.015.03-.083-.021-.083-.021s-.01-.014-.018-.022c-.007-.008-.053-.018-.077-.045-.024-.028-.026-.013-.045-.028-.02-.016-.032-.048-.032-.048-.02-.015.025-.014.025-.013zm-1.277-.226c.005.012-.004.039.022.058.024.02.03.04.084.076.055.036.054.023.091.05.038.027.067.149.022.2-.044.05-.027-.07-.032-.08-.005-.011-.079-.015-.116-.041a.783.783 0 0 1-.09-.074c-.02-.02-.045-.033-.06-.058-.014-.025-.021-.029-.032-.046-.01-.018-.028-.04-.057-.105-.03-.065-.027.076-.085.036-.059-.04-.054-.04-.07-.084-.017-.044-.024-.004-.091-.047-.066-.043-.013-.048-.104-.073-.092-.024-.039-.086-.022-.096.065-.042.112.007.112.007.066.008.044.018.086.044.041.026.034.023.13.058s.129.017.241.027c.114.011.044.011.126.025.083.014.078.034.145.057.068.023.02.013.07.038s.02.033.03.058c.01.026 0 .072.008.113.009.041.02.037.062.112.043.075-.036-.012-.06-.031-.027-.02-.037-.02-.047-.034-.01-.013-.062-.035-.09-.078-.028-.043-.067-.023-.073-.037-.005-.016-.083-.053-.104-.066a1.031 1.031 0 0 0-.15-.037s.049.018.054.028zm-.479-.113c.004.038-.022.01-.04.009-.02-.001-.034-.054-.034-.054.014-.017.07.008.07.009l.004.036zm-.476 6.717c.007-.014.016-.006.061-.015.044-.01.06-.01.108.009.048.02.004.035.004.035s-.018.027-.023.045c-.007.017-.047.033-.047.033s-.081.005-.097-.018c-.015-.023-.007-.032-.007-.032s-.006-.044.001-.057zm-.016-6.923c-.01-.013-.054-.016-.064-.05-.006-.022.05-.005.065-.003a.179.179 0 0 1 .024.005l.009.015.006.049c.003.03-.03-.001-.04-.016zm-.857 1.305c-.025.048-.001.012-.09.019-.09.006-.029-.015-.08-.057-.049-.043-.029 0-.07-.02-.042-.019-.124-.025-.124-.025s-.116-.052-.15-.088c-.034-.035-.019-.006-.058-.038-.04-.031-.063-.044-.083-.071-.021-.027-.048-.019-.07-.034-.023-.015-.077-.018-.143-.071-.067-.052-.058-.027-.068-.04-.01-.013-.052-.066-.035-.104.017-.037.017-.01.04-.03.026-.022.043-.035.046-.058.004-.025-.025-.018-.032-.03-.009-.011-.058.003-.072.011-.014.007-.053.038-.076.046-.023.009-.043.026-.08-.011-.037-.039-.045-.03-.056-.057-.013-.026.008-.028.033-.051.025-.023.023-.012.027-.024.005-.013-.002-.02-.002-.02l-.07-.055c-.013-.01-.042.013-.042.013s-.046.029-.06.04c-.014.01-.032.003-.06-.027-.027-.03-.012-.028-.029-.071-.016-.044-.054-.03-.136-.084-.08-.054-.057-.008-.076-.011a5.043 5.043 0 0 1-.199-.057c-.009-.006-.066.013-.09.021-.023.009-.097.046-.12.046-.025 0-.065-.014-.065-.014s-.073-.007-.093-.02a.285.285 0 0 1-.066-.061c-.015-.019-.033-.017-.053-.042-.022-.024-.012-.029.02-.067.03-.04.026-.028.056-.058.03-.029.032-.035.052-.052.019-.017-.023-.022-.036-.032-.014-.01-.022.002-.042.008-.021.005-.064 0-.06-.03.002-.03.024-.044.024-.044l-.017-.027s.02-.012.052-.042c.033-.03.011-.04.012-.06l.004-.125c.004-.105.015-.034.045-.08.031-.045.02-.014.065-.048.043-.035.01-.008.08-.021.072-.014.09-.012.09-.012s.121.01.14.018c.019.006.023-.007.023-.007l.026-.038c.026-.038.015-.007.05-.014.035-.006 0 0 .025.01.025.008.088.032.134.042.046.009.058.008.092.02.034.01.06.02.09.031.032.012.08.042.124.055.043.013.06.03.076.03.014.002.092.032.127.043.034.012.112.033.201.053.09.02.077.042.077.042s.039.026.15.109c.111.083.052.048.105.049.05 0 .053.023.094.04.04.016.087.035.1.042.014.008.04.103.069.153.03.05-.008.06-.008.06s-.024.03-.02.038c.003.009.008.02.012.059.004.038.026.053.038.067.01.014.035.05.02.075a.127.127 0 0 0-.015.08.252.252 0 0 1 0 .064c-.003.027.003.05.008.068.005.017.124.09.151.126.028.036-.003-.008.052.104.053.114 0 0 .025.048.027.048-.005-.011.072.072.075.085 0 0 .059.072.059.07.021.038.028.07.007.033-.012.053-.012.053s-.028.047-.042.007c-.013-.04 0 0-.089-.024-.09-.022 0 0-.025.048zm-1.046.326c.012.002.01.013.02.025.011.01-.005.027-.005.027h-.024c-.018-.001-.016-.028-.016-.028s.013-.026.025-.024zm-.04-.061l.013-.022.017-.013s.004.014.016.039c.011.026-.012.004-.02.005-.01.002-.026-.009-.026-.009zM7.98.761C7.96.76 7.95.753 7.95.753S7.934.74 7.928.721C7.924.703 7.915.696 7.915.695c0 0 .105-.026.112-.008.005.019.04.019.004.042C7.994.752 8 .763 7.98.76zm.013.223c-.033-.019.005-.065.005-.065.033.027.029.084-.005.065zm.68.114l-.057.006c-.02.003-.015-.021-.015-.021l.01-.02s.037-.012.057-.006c.02.005.025.02.03.034.006.015-.025.007-.025.007zm.028.05l.128.009c.128.01.025.02.025.02s-.032.023-.043.028c-.01.004-.034-.004-.055-.009-.02-.005-.025.01-.05.028-.026.017-.019.01-.048.028-.028.019-.091.002-.116-.01-.025-.013-.028-.01-.045-.019-.016-.01-.035-.011-.067-.023s-.044-.015-.054-.028c-.01-.015-.01-.057-.01-.057s.125-.018.147-.027c0 0-.001.02.03.027.032.008.029.013.061.025.032.01.012-.002.056.02.045.022.041-.012.041-.012zM8.547.666a.746.746 0 0 1-.075.02c-.011 0-.068.01-.13.017-.06.006-.061-.005-.124-.013-.063-.01.069-.043.069-.043s.026-.002.054 0a.355.355 0 0 0 .134-.034c.06-.026.071-.023.107-.008.036.015.044.049.044.049s-.064.007-.08.012zm1.649 1.65c-.046-.024-.028-.042-.02-.062.01-.02.04.003.08-.012.041-.016.019-.014.02-.029.003-.015-.007-.072-.01-.098-.003-.026.052-.054.052-.054s.03-.008.08.002c.051.01.085-.001.144.073.058.073.028.042.038.064.01.021.003.03.008.102.003.072-.057.048-.068.056a.42.42 0 0 1-.085.037c-.022.006-.076-.03-.076-.03s-.04-.015-.072-.023c-.032-.009-.046 0-.091-.026zm-2.522.012c.021.03-.006.057-.003.108.003.05.006.049.006.049s.008.047.008.107-.023-.01-.03-.019c-.006-.008-.092.022-.122.026-.03.003-.21-.002-.21-.002s-.048.038-.055.025c-.008-.015-.03-.027-.03-.027l-.05-.013s0-.023-.007-.038c-.007-.013-.009.004-.009.004l-.037-.01s-.017.001-.039-.03c-.02-.03-.006-.028-.006-.028s.005-.007.016-.01c.012-.005.016-.003.042-.009.026-.005.013.006.03.006.02.001.019-.004.038-.019.02-.013.023-.01.033-.025a.04.04 0 0 0 .008-.036c0-.008.006-.033.005-.042-.001-.008-.013-.01-.025-.014-.013-.005-.03-.006-.041-.013a.534.534 0 0 1-.091-.143c-.017-.048 0-.024.02-.04.019-.018.024-.018.063-.053.038-.033.025-.04.08-.09.054-.051.03-.03.092-.07.061-.039.037-.016.096-.046.061-.03.027-.005.074-.016.046-.012.077.018.105.033a.144.144 0 0 1 .04.025s.024.084.03.116c.007.031 0 .026.008.044.008.016-.001.044-.008.06-.008.016-.015.031-.017.04-.002.01-.016.046-.027.08-.012.035-.008.04.013.07zm-.424.682c.01.013.033.005.037.04.005.035.019.051.009.076-.009.025-.013.047-.036.064-.021.016-.013.018-.039.028-.025.008-.024.017-.046.011-.022-.008-.04-.017-.04-.017l-.047-.03s-.04-.029-.033-.057c.006-.027.03-.058.03-.058 0-.001.03-.004-.018-.026s-.042-.031-.072-.031c-.03 0 0 .065-.058 0a.631.631 0 0 1-.065-.08c0 .003.01.022-.01 0-.02-.025-.016-.038-.016-.038l.04-.031s.027.01.02-.02c-.005-.029-.01-.043-.01-.043s.007-.013.015-.02l.028-.02s.013.004.03 0c.018-.005.025-.018.033-.01.006.008.038.02.045.028.006.008.016.016.03.003l.035-.034s-.002.007.065-.013c.067-.019.117-.007.117-.007s.002-.002 0 .01c0 .012.01.025-.005.056-.015.032-.047.071-.056.093-.01.022-.017.013-.016.05 0 .035.023.062.033.076zm-1.088.078c-.003-.007-.011-.023-.015-.035.002.008 0 .012-.035-.03-.052-.067-.073-.062-.08-.062-.01.002-.059-.002-.059-.002s-.015-.033-.017-.048l-.008-.047s-.02-.022.017-.037a.136.136 0 0 0 .066-.058c.013-.019.052-.095.052-.095s.008-.04.048-.029c.04.01.06-.003.077.018.018.022.046.029.059.045.014.016.026.01.051.03.027.02.031.006.054.03.025.024.043.03.052.054.009.022.037.038.037.038 0-.001.022-.023.04 0 .017.027.08.004.09 0 .008-.003.022.021.023.021l.027-.047.027-.006s.015-.005.022-.014l.025-.027h.03s.05-.031.006.033c-.044.064-.05.055-.06.086-.008.03-.013.04-.001.06l.018.04c.016.033.016.027.034.055.018.027.034.038.044.046.01.008.05.022.05.022l.033-.004s.013-.013.014.016c0 .03.001.042.004.068.003.026.029.018.003.047-.028.03-.004.021-.045.035-.04.012-.028-.003-.09-.002-.064 0-.062.006-.088-.003-.025-.01-.027-.027-.072-.03-.045-.005-.03-.019-.075.004-.046.024-.03.049-.079.045-.048-.004-.055-.006-.07-.005-.014.001.001.009-.039-.001-.04-.01-.044-.023-.054-.03-.01-.009.002-.013-.032-.018-.034-.005-.05-.022-.075-.025-.024-.003-.042-.048-.042-.048s.016-.027.023-.03c.01-.004.035-.024.028-.033a.117.117 0 0 1-.018-.027zm.455-.75s.007-.022.032-.046c.024-.023.006 0 .054.004.048.003.013.007.017.019.004.011.002.018 0 .035 0 .017-.023.029-.023.029l-.027.027s-.014.01-.023.008a.185.185 0 0 1-.036-.02l.008-.04-.002-.017zm.003.163c-.011.03-.011.03-.009.054.003.023-.011.037.01.037.022 0 .09-.011.09-.011s.004-.046.024-.022c.021.024.054.052.052.066-.001.015.01.038-.03.054s-.034.018-.089.036c-.055.018-.05.006-.09.028-.04.022-.005.065-.076.02-.071-.046-.083-.044-.09-.065-.01-.02.016-.013-.026-.063-.041-.048-.035-.043-.045-.057-.01-.014-.018-.022-.022-.03-.004-.009-.009-.053-.003-.057 0 0 .025-.017.054-.029l.06-.024s.06-.006.068-.015c.008-.005.015-.03.037-.018a.722.722 0 0 0 .048.025l.027-.007s.022.047.01.078zm.378-.195c.014.007.01.058.01.058l-.01.013-.017.017c-.016.017-.06-.012-.072-.031-.014-.02-.016-.008-.032-.044-.016-.038-.01-.05-.01-.05a16.198 16.198 0 0 0 .096.016c.037.005.023.013.035.02zm0-.086s-.004-.011.041-.008c.046.005.008.014.008.014l-.016.023-.02-.02-.013-.01zm-.112.29c.025.043.022.01.05-.002.03-.011.015-.005.062-.01.048-.005 0 0 .033.021.033.02.01.01.011.022.001.012-.02.056-.015.082.006.026-.003.027-.003.027l-.046.02-.037-.01s-.008-.017-.01-.03c0-.011-.036-.007-.036-.007s-.032-.009-.038-.02a.094.094 0 0 1-.013-.031c-.001-.01-.01-.041-.008-.07.003-.03-.033-.057-.033-.057-.004-.02.033.002.033.002l.02.013s.004.01.03.05zm.212.12c0-.023.007-.015.007-.015s.008-.01.021-.02c.014-.01.012-.001.03 0s.02.007.02.007.01.022.013.04c.002.018-.032.01-.032.01s-.017 0-.036.005c-.017.006-.023-.003-.023-.027zM5.52 1.238l.017-.02.05-.033c.023-.014.035-.008.057-.017.021-.01.025-.014.037-.013.011.003.025.021.025.021s-.035.026-.051.029c-.015.002-.017.023-.019.035-.003.013-.049.014-.049.014s-.028.022-.059.053c-.031.029-.053.005-.053.005l-.01-.018.055-.056zm-.09-.02c-.015.004-.061.002-.061.002-.008-.026.075-.046.075-.046s.016.006.025.016c.009.011-.025.022-.04.027zm-.651.838l-.014.02s-.027.007-.045.014c-.018.004-.008-.05-.008-.05.008-.02.067.016.067.016zm-.726.406c.01-.009.085-.135.085-.135s.029-.022.07-.034c.04-.012.048-.052.066-.06.018-.01.09-.053.113-.059.023-.005.014.022.015.037.001.015-.036.053-.076.088-.038.034-.03.037-.039.096-.008.057-.042.065-.051.089-.01.024-.042.034-.053.048a.77.77 0 0 1-.09.082c-.015.005-.064.025-.105.037-.04.012-.05-.002-.062-.012-.013-.01.004-.028.015-.07.01-.044.01-.024.08-.07.073-.046.021-.029.032-.037zm-.166.39c.004.035-.028.03-.028.03s-.03-.004-.041-.03c-.01-.025-.002-.018 0-.041a.39.39 0 0 1 .018-.078l.003-.009s.014.025.03.035c.017.01.01.01.02.033.01.022-.005.027-.002.06zm-.714-.711c.155-.086.3-.051.3-.051.016.064-.13.107-.198.161-.07.053-.48.205-.506.184-.026-.02.25-.208.404-.294zm-.264.476c-.008.006-.025.011-.027-.006-.001-.018.001-.045.001-.045.076-.02.035.043.026.05zM4.356 4.87c-.01-.01-.01-.02-.014-.102-.002-.083 0 0 .023-.035a.102.102 0 0 0 .015-.024l.062-.053s.018.013.023.028c.004.015 0 .027 0 .027s-.023.031-.032.038c-.008.007-.003.019-.007.037s0 .026-.005.042c-.005.015-.005.015-.008.042-.003.027-.026.01-.038.01-.011.001-.008.001-.019-.01zm10.154 5.804c-.045.084-.072.232-.117.306-.046.073-.088.226-.127.283-.04.058-.041.074-.057.144-.015.07-.02.17-.02.204 0 .034-.118.47-.304.676-.184.208-.264.28-.35.35-.085.07-.18.145-.227.207-.048.062-.021.056-.087.128a.575.575 0 0 0-.125.189c-.005.03-.15.324-.335.485-.188.16-.302.276-.377.334-.074.057-.079.088-.187.156-.108.07-.082.06-.198.155-.117.096-.16.12-.248.168-.087.047-.072.042-.162.1-.09.06-.12.06-.176.11-.056.053-.04.062-.14.104-.1.04-.118.043-.159.092-.04.05.03.059.03.059s.023.005-.02.032c-.044.027-.097.063-.204.11-.106.045-.047.023-.134.078-.086.055-.1.072-.15.097-.052.024-.046.008-.09.036-.042.027-.04.084-.04.084s-.157.075-.176.08c-.02.006.04.019-.083.016-.123-.002-.113-.014-.186-.01-.073.003-.088.006-.088.006s-.001-.008.034-.042.066-.033.097-.056c.033-.023.105 0 .119-.055.012-.055.048-.089.048-.089s.081-.062.091-.074c.01-.013.11-.088.119-.113.008-.023-.038.002-.103.046-.065.045-.067.053-.08.073-.014.022-.04.07-.028.027a.878.878 0 0 1 .122-.19c.027-.032.057-.035.058-.065 0-.031.042-.074.072-.119.029-.045.033-.041.082-.097.047-.054.05-.035.092-.104a1.1 1.1 0 0 1 .075-.111v-.041c-.002-.046.022-.091.028-.107.005-.016.023-.025.028-.049.005-.023.002.012.017-.062.015-.074.065-.106.068-.145.004-.038.024-.066.035-.11.011-.043.043-.066.04-.12-.001-.052.023-.115.025-.13.002-.016-.002-.009.01-.059a.307.307 0 0 0 .005-.115.328.328 0 0 1-.017-.081c.002-.024.007-.047.004-.073l-.006-.057s.022-.01-.037-.023a.9.9 0 0 1-.16-.048c-.044-.018-.16-.032-.16-.032l-.105-.034c-.024-.009-.03-.024-.06-.028-.033-.005-.048-.014-.1-.031-.052-.017-.059-.013-.073-.03-.013-.018-.028-.046-.042-.068-.014-.022-.367-.463-.416-.492-.05-.03-.015-.034-.08-.06-.064-.028-.034-.027-.073-.035a.205.205 0 0 1-.085-.036c-.021-.017-.014-.021 0-.03.015-.01.06-.022.027-.042-.033-.02-.053-.028-.053-.028s-.041.016-.035-.035c.006-.05.015-.07.015-.07s-.014.01.014-.028a.241.241 0 0 1 .061-.06l.016.002.035-.034s.034.023-.006-.025c-.04-.05-.026-.059-.043-.072-.016-.014-.02-.001-.027-.035-.007-.034.02-.094.02-.094s.011-.082.006-.095c-.006-.015.021-.083.021-.083s.11-.096.15-.172c.043-.077.022-.086.058-.133.039-.045.096-.082.098-.093.004-.012.031 0 .037-.05.007-.05-.015-.11-.03-.179-.016-.07.003-.07-.03-.13-.034-.062-.029-.047-.04-.08-.01-.034-.004-.038-.03-.062-.026-.023.01.026-.047-.048-.058-.073-.055-.078-.075-.087a.536.536 0 0 1-.055-.03l-.037-.002c-.07-.004-.027-.027-.07-.004-.044.024-.052-.01-.06.048-.01.058-.033.061-.015.079.018.016.007.033.028.042.02.009.023.04.015.06-.01.02 0 .015-.025.02-.028.007-.001.024-.054-.001-.054-.024-.02-.005-.074-.034l-.098-.054c-.029-.016-.017-.048-.058-.035-.04.011-.03.01-.055.02-.026.01-.045.017-.065.007-.02-.009-.01-.022-.035-.038s.023.002-.043-.041c-.066-.042-.068-.023-.096-.036-.028-.011.014-.013-.047-.01-.062.004-.04.024-.089.002-.048-.021-.055-.047-.055-.047s.012-.027-.01-.056c-.023-.028-.025-.046-.027-.066-.002-.019.027-.003-.002-.019-.029-.015.019-.002-.04-.014-.059-.013-.056-.013-.073-.03-.018-.018-.016-.003-.042-.038-.028-.035-.041-.056-.041-.056s-.012-.003-.034-.027l-.025-.03a.779.779 0 0 1-.017-.004c-.067-.011-.042.005-.078-.01-.037-.016-.072-.026-.097-.036-.024-.008-.255-.015-.255-.015-.159-.085-.24-.135-.4-.205-.028-.011.007-.004-.04-.01a.308.308 0 0 0-.123.006c-.06.01-.073.03-.115.036-.042.004-.019.012-.09-.007-.07-.019-.084-.025-.119-.036-.036-.011.002.015-.095-.024a19.322 19.322 0 0 1-.74-.32c-.04-.02-.011-.03-.096-.067-.276-.118-.051-.334-.298-.574-.039-.037-.018-.028-.059-.076-.04-.05-.032-.081-.07-.123-.04-.042-.041-.057-.063-.077-.022-.02.017-.02-.077-.098-.093-.078-.09-.074-.114-.099a.222.222 0 0 1-.058-.073 5.536 5.536 0 0 1-.062-.184l-.047-.002s-.007-.023-.03-.062c-.023-.04-.026-.062-.036-.083-.01-.023-.028-.073-.028-.073s-.02-.075-.035-.081c-.017-.005-.014-.018-.035-.034-.021-.017-.04-.05-.064-.058-.024-.009-.015-.036-.036-.007-.019.028-.025.013-.021.051s.012.034.003.064c-.008.031-.033.02-.028.06.004.041.017.052.032.073.013.021-.008-.026.034.038.042.065.07.062.076.09.007.03.017.087.019.102 0 .015.048.021.061.07.013.048.026.031.04.083.013.052.036.05.05.079.016.028.05.025.042.067-.006.043-.01.07-.003.1s.014.056.047.082c.034.027.053.025.059.047.006.022.043.038.053.059.01.022.035.004.036.05 0 .045.008.071-.003.076-.01.005.047.075-.026.01-.073-.064-.09-.085-.123-.108-.033-.023-.043-.034-.06-.047-.016-.013.01.014-.03-.023-.039-.038-.038-.031-.047-.052-.01-.023-.017-.014-.017-.048s.02-.063.02-.063.038-.008.022-.049c-.016-.04-.029-.054-.029-.054s0-.003-.038-.026c-.037-.023-.025-.02-.054-.04-.029-.02-.032-.012-.072-.058-.039-.044-.032-.049-.053-.062-.02-.014-.013-.01-.053-.032-.042-.022-.056-.048-.056-.048s-.022-.035-.011-.029c.013.006.06.02.077.041.019.021.072.023.072.023s-.016-.048-.029-.061c-.013-.015.008-.07-.002-.084-.009-.015-.016-.04-.036-.057-.022-.018-.05-.06-.05-.06s-.011-.037-.037-.056c-.025-.021-.035-.008-.038-.042a12.953 12.953 0 0 0-.01-.071l-.016-.082c-.008-.041-.03-.096-.03-.096L4.86 7.71l-.012-.045-.017-.055s.007-.035-.086-.116c-.094-.082-.175-.115-.175-.115s-.03-.023-.04-.041c-.008-.018.024-.042-.013-.09-.036-.05-.038-.073-.042-.103-.002-.03.028-.06-.002-.125s-.018-.067-.034-.103c-.016-.036-.011-.029-.016-.078-.006-.05.007-.042-.006-.09-.014-.049-.007-.06-.02-.105-.012-.045-.004-.072-.006-.087-.001-.015-.012-.014-.003-.068.009-.055.035-.1.035-.1s.023.025.031-.033c.01-.059.015-.074.015-.074s-.036.023.001-.064a.374.374 0 0 1 .053-.105l.03-.134s.056-.074.06-.097A1.01 1.01 0 0 1 4.64 5.8s0-.088.005-.115c.006-.027.023-.079.023-.079s-.014-.017-.014-.055l.001-.099s-.018-.017-.03-.034c-.014-.019-.035-.069-.04-.08-.005-.01-.046-.129-.035-.145.009-.017-.002-.023.014-.044.017-.02.06-.01.048-.058A.347.347 0 0 1 4.594 5c-.004-.034.019-.033.01-.07-.007-.037.018-.054-.006-.098-.024-.043-.017-.047-.03-.054-.012-.006-.022-.032-.024-.043 0-.01-.02-.02.019-.043.04-.024.08-.04.067-.057-.013-.018-.025-.04-.048-.048-.024-.01 0 .003-.048-.018-.049-.022-.062-.005-.078-.041-.015-.037.007-.042-.005-.08a.424.424 0 0 1-.023-.115c0-.035.015-.063.015-.063s.029-.06.025-.094a.797.797 0 0 0-.025-.115c-.006-.027-.03-.077-.03-.077s.003-.035-.015-.059c-.019-.025.01-.029-.028-.046-.037-.02-.047-.042-.072-.062-.026-.02-.106-.08-.11-.121-.004-.041.042-.03-.004-.041-.048-.01.01-.01-.063-.01s-.034.005-.084.01-.086-.014-.086-.014-.016-.01-.022-.02c-.003-.01-.019-.037-.023-.045a.859.859 0 0 1-.019.008c-.066.026-.065.014-.081.035-.017.02-.028.03-.036.057-.008.027.02.013-.024.056a.625.625 0 0 0-.063.063s0 .008-.02.018c-.023.01.002-.008-.046-.021-.048-.014-.033-.02-.064-.027-.032-.01-.013-.01-.06-.005-.044.004.002.01-.056.008-.058-.001-.063-.026-.125-.023-.062.002-.036-.008-.105-.005-.069.004-.066 0-.143 0-.077 0-.064.008-.128-.008-.063-.017-.067-.02-.108-.038-.04-.02-.03-.028-.054-.036-.024-.01-.07-.046-.07-.046s.13.039.142.038c.012-.002.011-.01.023.005.014.013-.056.002.026.023.084.022.087.006.132.006.047-.002.093.005.117.002.022-.002.097-.025.113-.016a.43.43 0 0 0 .146.03c.034-.004.123-.001.125-.013.003-.012-.003-.003.016-.032.02-.03.037-.046.037-.046s.044-.028.042-.046a.333.333 0 0 0-.035-.073s-.007-.026-.022-.028c-.016-.002-.011.006-.027-.001-.017-.005.002-.05.002-.05s.01-.012.022-.048c.01-.035.01-.043.01-.043l-.018-.055-.015-.07-.005-.042.062-.075s.029-.01.06-.017c.03-.008.155-.06.166-.065.01-.004.06-.048.082-.058.022-.01.056-.048.056-.048l.036.012s0-.008.007.026c.007.033-.004.027.013.044.017.017.036.046.056.028.022-.017.054-.036.054-.036s.005-.03-.007-.033c-.012-.003-.031-.005-.041-.027-.01-.022-.013-.047-.013-.047l.025-.046.039-.034s.01-.043.033-.057c.021-.014-.018-.021.038-.023a.198.198 0 0 1 .095.016s.025.012.023.029c-.002.015-.015.046.001.053.017.005.09.005.09.005l.01-.055.01-.046a.466.466 0 0 1 .022-.075c.012-.031.013-.021.04-.053.028-.033.036-.028.047-.032l.03-.01s.006-.013.022-.011c.015.002.075.015.09.006.013-.01.01-.016.025-.019l.053-.001.058-.002.046.002.074.007s.027-.036.044.019c.019.054.03.072.049.116.016.044-.047.001.025.058.072.058.104.039.106.054.001.015.029.122.036.152.006.03.065.035.066.047.002.01.057.035.057.035s.11.018.122.018c.012-.002.06-.022.091-.018s.135.004.147.007c.012.002.065 0 .08.026.013.025.039.034.043.045.006.01.062 0 .068.015.005.014.036.015.039.042.003.026.08.022.098.047.018.024.035.006.054.051.021.043.044.041.062.065.018.025.005.046.053.037.05-.01-.022.044.021.047.043.003.042-.009.097-.003.054.005.12.006.13.009.013.002.036.034.06.009.024-.026.055-.064.076-.058.019.005.08 0 .09.013.008.015.056.025.088.036.031.012.123.036.134.028.01-.009.063-.045.063-.045l.005-.065a.491.491 0 0 1 .033-.09s-.011-.072.031-.028c.044.046.074.073.083.087.01.014.045.022.045.022s-.061.037-.042.07c.019.03.117.013.123-.03.008-.042.022-.051.031-.067a.295.295 0 0 1 .098-.053l.104-.01.062.049.09.002.007-.073s-.004-.034-.025-.047c-.02-.013-.022-.031-.096-.031-.072 0-.086.013-.094-.021-.008-.034.006-.054-.009-.079a.163.163 0 0 1-.026-.069c-.004-.026.013-.052.015-.074 0-.023.032-.05.054-.07.02-.022.05-.06.05-.06s-.063-.054.053-.013c.116.041.189.003.189.003s.045-.04.067-.026c.02.012.076.026.089.047.014.021.024.006.076.053.051.048.07.042.121.06a1 1 0 0 0 .195.016s.077.034.111.07c.035.033.045.127.068.132.024.005.142.02.154.022.01.002.066.015.086.013.018-.002.135-.033.15 0 .015.033.082.044.055.081-.027.037-.032.061-.029.091.004.03.1.065 0 .057-.102-.008-.098-.035-.15-.049-.05-.014-.063-.023-.098-.015-.033.007-.049 0-.05.024-.002.022 0 .03.016.044.017.013.072.026.09.047.017.021.075.014.105.042.03.027.067.02.09.048.023.027.066.073.071.083.005.012.006.023 0 .043-.005.018-.02-.007-.062-.006-.043.001.014.007-.054 0-.066-.009-.036-.023-.09-.014-.052.009-.078.023-.078.023s.023.029.075.05.11.018.119.029c.008.01.053-.003.017.017-.037.019-.053.017-.101.022-.05.005-.05.005-.09-.005-.041-.012-.052-.023-.082-.045-.03-.024-.003-.023-.046-.037-.045-.015-.004 0-.076-.022-.072-.023-.113-.041-.132-.04-.019.002-.01-.018-.044.02-.034.038-.02.025-.049.043-.028.019.023.068-.052.02-.074-.044-.056-.02-.074-.044-.018-.025-.03-.028-.037-.054-.006-.025.025-.021-.022-.061-.047-.042-.04-.046-.072-.061-.033-.016.001-.024-.046-.041-.05-.017-.037-.046-.079-.01-.043.033-.028.029-.052.055a.208.208 0 0 0-.05.065c-.006.02.027.032-.033.02-.059-.014-.056-.021-.078-.011-.022.01-.04.027-.08.076-.04.051-.03.072-.032.1 0 .026.053-.014-.038.076-.09.09-.09.093-.11.119-.02.024.021-.018-.036.052-.058.072-.062.107-.088.148-.027.04-.03.048-.041.08-.013.032-.02.026-.027.071-.007.047.02.082.025.097.005.014-.007 0 .032.045.04.046.119.057.133.089.016.033-.011.032.08.083.089.052.16.063.176.072.017.01.12.04.153.056.032.016.108.046.121.052.012.006.12.013.14.012.019-.002.032-.019.057-.002.025.016.07.007.09.047.02.039.051.043.054.105.003.06-.01.039.02.111.031.073.043.083.069.1.025.016.028-.053.065.027.035.08.084.14.086.09.003-.05.012-.104.01-.124-.002-.018.006-.02-.007-.063-.012-.044-.012-.079-.015-.102-.003-.021.01-.073-.014-.093-.026-.02-.032-.012-.044-.04-.01-.03-.022-.036-.009-.057.013-.021.012-.028.025-.04.015-.014.036-.03.048-.063.012-.032.03-.042.024-.067-.007-.026.007-.039-.016-.072-.023-.03-.016-.04-.034-.06a.266.266 0 0 1-.038-.065c-.006-.014.008-.035-.026-.062-.034-.027-.05-.044-.05-.044s-.038-.027-.027-.073c.009-.046.008-.092.008-.092 0-.001-.019-.033-.04-.057-.022-.024-.038-.053-.038-.053l-.018-.06s-.001-.09.01-.092c.011-.001.006-.01.025-.01.02-.002.083-.047.116-.035.032.011.11.018.133.016.023-.003.03-.034.076-.009.046.026.06-.014.11.057.05.07.12.075.13.094.01.016-.001-.046.019.035.021.082.084.094.084.094s.001.011.016.006c.015-.005.11-.02.11-.02s.014-.001.027-.06c.012-.058.043-.103.042-.114-.001-.012-.083-.052 0-.03.083.02.2-.003.206.053.007.056-.031.034.03.092.06.059.102.054.132.081.03.028.057.028.09.047.033.02.097.005.128.044.032.04.125.056.125.056 0-.001.078-.024.118.013.039.038.097.048.109.08a.461.461 0 0 0 .137.127c.015.001.08-.028.092.035.011.064.025.089.034.141a.167.167 0 0 0 .151.143c.03 0 .137-.01.154.003.018.014.025.005.063.043.038.037.09.04.096.066.006.026.013.048.014.06 0 .01.014.02.004.037-.01.016.04.015-.038.035-.079.02-.039 0-.127.005-.088.006-.087.014-.124.032a.29.29 0 0 1-.084.033c-.03.006-.046.012-.088.012-.042 0-.07.016-.076-.033-.006-.049-.01-.075-.012-.109-.004-.034.005-.091-.012-.14-.017-.047.013-.054-.023-.103-.036-.05-.028-.085-.068-.097-.04-.01-.056-.02-.074.032-.018.05-.018.047-.032.098-.012.051.002.08-.028.091-.03.01-.091.006-.131.029-.04.023-.094.025-.13.044-.037.02-.056.026-.15.085-.092.059-.11.05-.124.09-.015.039-.003.042-.028.093-.025.053-.042.074-.042.109 0 .033.014.058.027.038.013-.02-.007-.03.05-.081a.458.458 0 0 1 .11-.077l.062-.03.086-.024s.046-.036.057-.006c.01.03.039.035.026.066-.011.032-.013.05-.011.066.001.015.014.021.032.042.017.021.04.014.075.053.034.038.159.01.159.01s.01.02.048-.013c.04-.035.05-.04.05-.04l.074-.027s-.04-.087.011-.039c.05.048.099.058.076.095-.023.037-.035.041-.049.088-.013.048.033.05-.005.085-.039.035-.086.025-.086.025s.053-.082-.021.017c-.074.1-.045.081-.085.116-.038.033-.066.052-.076.07-.01.015.01.028-.03.037-.042.008-.08-.022-.08-.022s.011-.04.013-.055a.526.526 0 0 1 .023-.068s.043-.03.002-.057c-.042-.026-.061-.027-.091.01-.031.037-.046.04-.048.062-.001.023.026.028-.028.068-.052.04-.08.043-.099.075-.019.033-.02.03-.044.062-.022.033-.043.02-.046.058-.004.039-.005.032-.016.067-.012.035-.052.02-.02.063.03.042.037.057.048.056.012 0 .026-.007.044.01.017.018.029.028.05.029.019.003.044-.008.044-.008s.004.038-.017.059c-.02.02-.037.011-.048.013-.012.001-.005-.004-.02-.006-.016-.002-.057.01-.057.01s-.001-.012-.034.038c-.033.047-.043.057-.044.058 0-.001.012-.015-.039.031-.053.047-.092.074-.097.098-.005.023-.02.06-.026.082-.005.024.015.033-.013.048-.03.014-.04.034-.038.046.001.01.013.014.018.029.005.014.02.032.015.067a.629.629 0 0 1-.04.122c-.006.015-.003.003-.016.028-.013.024-.019.044.002.061.022.016.042.025.058.058.015.032.03-.006.05.067.018.074.035.084 0 .106-.037.023-.065.05-.065.05l-.017.02c-.014.017-.013.024-.055.06-.042.034-.032.023-.067.057s-.038.042-.062.071c-.022.029-.114.115-.124.131-.01.016-.032.09-.06.12-.027.03-.061.037-.072.085-.01.046-.01.05 0 .087.007.037.015.045.042.077.027.03.032.015.044.055.013.04.017.006.027.066.01.06.013.055.038.106.025.05.034.061.044.083.01.021.014.017.033.061.021.043.034.054.037.083.003.031.005.049-.002.085-.008.034-.001.06-.01.093-.008.03-.006.045-.017.051l-.048.016s-.02-.032-.04-.049c-.022-.017-.034-.054-.062-.066-.028-.012-.019-.001-.058-.036-.038-.033-.034-.041-.073-.075-.039-.035-.055-.044-.067-.088-.013-.045-.007-.064-.017-.09-.011-.025-.004-.033-.02-.074-.016-.04-.03-.08-.042-.095a.305.305 0 0 0-.05-.044.155.155 0 0 0-.053-.024c-.02-.006-.029-.016-.039 0-.01.016-.015.035-.015.035l-.072-.018c-.024-.005.009-.024-.105-.012l-.138.015-.02.02-.025.019c-.021.018-.032.022-.057.037-.026.014-.016.001-.028.033a.114.114 0 0 1-.05.062c-.022.014-.018.018-.048.025-.03.007.013.002-.104-.004-.116-.007-.157.012-.157.012s.013.01-.014.01c-.028-.002-.082-.037-.101-.046-.021-.01-.06.006-.06.006l-.045-.014s-.018.025-.036.026a.985.985 0 0 0-.187.093c-.024.021.017.002-.052.05-.068.05-.066.03-.091.08-.026.048-.043.035-.058.102a.422.422 0 0 0-.017.134c.001.041-.013.05-.009.093.005.04.031.042.022.088-.01.048-.003.073-.02.129-.018.054-.02.093-.025.128a.287.287 0 0 0 .006.094c.008.026.019.025.025.081a.26.26 0 0 0 .07.145c.029.027.153.205.153.205s.001.014.042.038c.04.021.094.012.122.047.026.035.101.057.121.056.019-.003.115-.035.115-.035s.064-.05.079-.059l.093-.063.079-.05s.014-.048.016-.063.025-.022.026-.056c0-.034-.018-.048.033-.08.05-.032.12-.062.142-.072.022-.01.072-.004.128-.033.054-.03.122-.036.148-.046.026-.01.01.162-.006.183-.018.02-.011.009-.023.044-.011.036-.036.084-.043.127-.007.042.07.015.018.097-.053.082-.071.088-.082.13-.01.044.039.077.03.1-.008.024-.035.065-.037.084 0 .02.06.051.07.046a1.82 1.82 0 0 1 .145-.02s.19-.092.205-.094c.015-.002.094.005.11.007.015.002.094-.017.109.012.013.028.039.045.041.071.003.026.032.047.026.09-.007.041.003.063-.004.103-.008.038-.003.041-.01.095-.004.054.015.094.024.14.009.044.038.07.057.096a.687.687 0 0 0 .065.065s.01.029.04.057c.03.027.098.039.113.045.016.006.031-.008.064.016a.096.096 0 0 0 .093.005c.018-.01.113-.096.113-.096.038-.078.154-.056.224-.032.032.012.082-.012.088.033.004.045.019.066.024.081.006.015.032-.03.068-.049.036-.02.085-.028.082-.059-.004-.03.012-.063.012-.063s.027-.176.095-.226c.068-.049.157-.044.168-.052.01-.009.078-.02.096-.071a.373.373 0 0 1 .055-.098s.004.003.02-.029c.015-.032.026-.04.026-.04s.037-.043.044-.02c.006.022.014.025.033.057.019.032.053.029.07.041.018.014.053.018.058.002.006-.016.017-.024.021-.051.006-.028-.023-.081.03-.045.054.035.025.043.077.068.053.024.044-.024.127-.003a.58.58 0 0 0 .137.024c.012-.002 0 .037.062.005a1.43 1.43 0 0 1 .106-.054.402.402 0 0 1 .113-.027c.016.006.087.09.118.018.03-.072.055-.09.07-.095a.793.793 0 0 1 .085-.028c.015-.002.067-.027.1-.01.032.015.131.008.142.037.011.03-.03.03.041.056a.753.753 0 0 0 .165.037s.04.007.061.02c.02.012.144.086.158.101.012.013.005-.027.025.027.022.055.048.075.066.066.018-.01.047-.062.065-.076.017-.013.014-.005.042-.034a.237.237 0 0 1 .07-.062c.02-.006.034-.038.09-.02a.45.45 0 0 0 .111.022c.011-.002.022-.04.077 0 .054.039.098.05.098.05s-.086-.052.024-.022c.112.03.139.03.14.042a.223.223 0 0 0 .035.073c.018.024.083.055.112.076.029.019.098.015.107.03.009.014.014-.01.04.045.026.055.147.076.147.076s.07-.031.081-.032a.927.927 0 0 1 .046-.004s.088.032.134.023c.045-.009.053-.002.086-.017.033-.015.037-.015.102-.057.065-.041.065-.075.113-.088.05-.012.03-.045.104 0 .075.046.105.043.105.043s.05-.003.061-.007c.012-.006.025-.022.077-.04.052-.016.1-.037.094.021-.005.058.02.136.012.209a.74.74 0 0 1-.09.244zM8.148 3.911l-.027.024s-.019-.004-.028-.003c-.008 0-.027-.009-.035-.022-.007-.015.009-.058.009-.058l.034-.016s.01.014.037.04c.028.028.01.035.01.035zm-.21-.17s-.054-.018-.066-.02c-.013-.001-.042.025-.047.035a.694.694 0 0 1-.051.053l-.062.015s-.037-.013-.047-.019c-.01-.004-.02-.024-.025-.041-.006-.017-.006-.047-.009-.074-.003-.026-.023-.047-.023-.047-.014-.022.034-.016.049-.023.014-.007.008-.01.03-.022.023-.011 0 0 .024-.008.022-.008.014-.005.044-.008s.015-.001.06.006c.046.007.017.015.036.046.018.031.049.037.082.039.033.002.04.005.097.032.056.026-.012.03-.02.038-.009.006-.072-.002-.072-.002zm.028.124c.002.019-.007.017-.016.045-.009.026-.044.012-.062.012a.165.165 0 0 1-.044-.013l-.002-.027.026-.03s.005-.015.018-.026c.015-.01.009-.007.037-.021.029-.015.02-.003.025.006.004.008.016.037.018.054zm.365.592c.04.01.004.008.036.064.035.056.01.02.027.036.016.016-.075.067-.075.067s-.028-.015-.035-.027a.335.335 0 0 1-.015-.024l.041-.064s-.019-.064.02-.052zm2.173 4.728s-.023.027-.047.07c-.024.044-.04-.02-.04-.02s-.039-.016-.06-.018c-.02-.001-.033.024-.033.024l-.062.007-.052.014-.052.022-.044.009s-.03 0-.04-.02c-.01-.02.006-.026.006-.026l.036-.045a.304.304 0 0 1 .046-.037s.04-.017.047-.03c.007-.013.012-.038.015-.05.002-.013-.021.001-.075-.038-.054-.04.01-.017.01-.017s.03-.028.059-.032c.029-.002.013.003.095.036.082.032.04-.017.082-.038.043-.021.025-.01.06-.034.033-.025.038-.026.084-.022.045.004.067.013.127.031.06.019.014.007.06.027.049.02.042.028.055.035.012.006.003.032.014.064.012.03-.024-.002-.024-.002l-.064.023-.068.023s-.073.013-.108.016c-.039.004-.027.028-.027.028zm-.362-.353c.01.01.01.015.012.039s-.022.019-.022.019l-.046.005c-.02.002-.03-.01-.03-.01l.022-.03s.01-.018.04-.037c.032-.02.014.002.024.014zm-.171-3.78c-.061-.008-.085-.01-.104-.018-.018-.007-.011-.023-.037-.01-.025.01-.063 0-.063 0l-.01-.029.044-.02c.011-.003.024-.017.04-.015.015.002.077-.01.087-.01a.207.207 0 0 1 .069.026c.006.007.01.011.017.025.008.014.023.02 0 .032-.022.012.018.028-.043.02zm-.152 4.346c.01.016-.017.034-.017.034l-.04.02s-.133-.018-.175-.058c-.042-.04.003-.017.005-.03.003-.012.01-.029.01-.029s.023-.007.04-.008c.016-.003.025.005.055.01s.058.006.058.006l.044.025c.044.024.01.014.02.03zm-.035-.238c-.038.029-.014.083-.089.054-.073-.029-.055-.018-.087-.039a.88.88 0 0 1-.09-.068c-.023-.022-.03-.058-.07-.066-.037-.01-.042-.012-.075-.013-.033 0-.03-.005-.066.004-.036.007-.02.005-.077.007-.059.003-.068-.008-.127.014-.06.023-.063.036-.095.048-.031.01-.031.011-.086.009-.053-.003-.057-.003-.079-.009-.021-.005.015-.013-.046-.006-.062.006-.116-.005-.093-.02 0 0 .046-.102.08-.123.036-.02.174-.076.174-.076s.053-.013.076-.027c.023-.016.074-.046.074-.046s.052-.013.084.008c.03.021.089.055.089.055l.12.012s.004-.041.075-.004c.07.038.116.041.134.055a.29.29 0 0 0 .103.042c.034.004.092.003.113.009.022.005.088.007.102.02.014.016.049-.012.045.033-.003.046-.134.1-.134.1s-.016-.002-.055.027z'}),_react2.default.createElement('circle',{cx:'8',cy:'8',r:'7.5',stroke:fill}));};exports.default=Globe;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Phone=function Phone(){var fill=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'#000000';return _react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M7.665 3.35L5.933.436C5.493-.304 4.73.123 4.73.123L3.661.722l2.613 4.396 1.069-.6c.763-.428.322-1.168.322-1.168m4.441 12.419l-2.614-4.396c-.645.361-1.237-.306-1.781-1.023a16.378 16.378 0 0 1-1.79-3.012c-.368-.817-.645-1.662-.023-2.01L3.285.932c-.922.517-2.754 3.266.889 9.393 3.653 6.145 7.01 5.96 7.931 5.443m1.768-1.979l-1.732-2.913c-.441-.741-1.204-.313-1.204-.313l-1.069.598 2.614 4.396 1.069-.598c.763-.428.322-1.17.322-1.17',fill:fill}));};exports.default=Phone;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RightArrow=function RightArrow(){var fill=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'#000000';return _react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M3.38,1.7l6.86,6.77L3.38,15.3l1.09,1.08,7.91-7.91L4.44.62Z',fill:fill}));};exports.default=RightArrow;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LeftArrow=function LeftArrow(){var fill=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'#000000';return _react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M12.38,15.3,5.53,8.53,12.38,1.7,11.3.62,3.38,8.53l8,7.85Z',fill:fill}));};exports.default=LeftArrow;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DownArrow=function DownArrow(){var fill=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'#000000';return _react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M14.68,4,7.91,10.86,1.09,4,0,5.09,7.91,13l7.86-7.94Z',fill:fill}));};exports.default=DownArrow;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UpArrow=function UpArrow(){var fill=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'#000000';return _react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M1.09,13,7.85,6.14,14.68,13l1.08-1.09L7.85,4,0,11.94Z',fill:fill}));};exports.default=UpArrow;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Circle=function Circle(){var fill=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'#000000';return _react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M15.59,8A7.58,7.58,0,1,1,8,.44,7.58,7.58,0,0,1,15.59,8Z',fill:fill}));};exports.default=Circle;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Facebook=function Facebook(){return _react2.default.createElement("g",null,_react2.default.createElement("path",{d:"M9.1,0.1V2H8C7.6,2,7.3,2.1,7.1,2.3C7,2.4,6.9,2.7,6.9,3v1.4H9L8.8,6.5H6.9V12H4.7V6.5H2.9V4.4h1.8V2.8 c0-0.9,0.3-1.6,0.7-2.1C6,0.2,6.6,0,7.5,0C8.2,0,8.7,0,9.1,0.1z"}));};exports.default=Facebook;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _=__webpack_require__(1455);var _2=_interopRequireDefault(_);var _3=__webpack_require__(1456);var _4=_interopRequireDefault(_3);var _5=__webpack_require__(1457);var _6=_interopRequireDefault(_5);var _7=__webpack_require__(1458);var _8=_interopRequireDefault(_7);var _9=__webpack_require__(1459);var _10=_interopRequireDefault(_9);var _11=__webpack_require__(1460);var _12=_interopRequireDefault(_11);var _13=__webpack_require__(1461);var _14=_interopRequireDefault(_13);var _15=__webpack_require__(1462);var _16=_interopRequireDefault(_15);var _17=__webpack_require__(1463);var _18=_interopRequireDefault(_17);var _19=__webpack_require__(1464);var _20=_interopRequireDefault(_19);var _21=__webpack_require__(1465);var _22=_interopRequireDefault(_21);var _23=__webpack_require__(1466);var _24=_interopRequireDefault(_23);var _25=__webpack_require__(1467);var _26=_interopRequireDefault(_25);var _27=__webpack_require__(1468);var _28=_interopRequireDefault(_27);var _29=__webpack_require__(1469);var _30=_interopRequireDefault(_29);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var helperImages=function helperImages(){return[_2.default,_4.default,_6.default,_8.default,_10.default,_12.default,_14.default,_16.default,_18.default,_20.default,_22.default,_24.default,_26.default,_28.default,_30.default];};exports.default=helperImages;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/0.6cc04d28.jpg";

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1.2f523c66.jpg";

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/2.aca66c45.jpg";

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/3.8a48d7f4.jpg";

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/4.1aa56dd5.jpg";

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/5.ae92a6b3.jpg";

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/6.4680fc2e.jpg";

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/7.41aa5db8.jpg";

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/8.35c60102.jpg";

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/9.32567a1e.jpg";

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10.0d574bdd.jpg";

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/11.b888c14d.jpg";

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/12.bbfaf675.jpg";

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/13.d0a21a46.jpg";

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/14.b74aca82.jpg";

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TabsComp=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _AboutUs=__webpack_require__(1471);var _AboutUs2=_interopRequireDefault(_AboutUs);var _FuneralPlanning=__webpack_require__(1483);var _FuneralPlanning2=_interopRequireDefault(_FuneralPlanning);var _Obituaries=__webpack_require__(1487);var _Obituaries2=_interopRequireDefault(_Obituaries);var _UpcomingServices=__webpack_require__(1540);var _UpcomingServices2=_interopRequireDefault(_UpcomingServices);var _get2=__webpack_require__(135);var _get3=_interopRequireDefault(_get2);var _actions=__webpack_require__(37);var _metaDataUtilities=__webpack_require__(364);var _urlHelpers=__webpack_require__(28);var _GAHelpers=__webpack_require__(22);var _refreshAds=__webpack_require__(600);var _reactTabs=__webpack_require__(609);var _breakPointChecker=__webpack_require__(368);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);__webpack_require__(1550);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import RatingsReviews from './RatingsReviews';
var conf=(0,_AppConfig2.default)();/*
 * RATINGS & REVIEWS TABS
 * We plan to re-implement ratings tab from a different vender, until then this is currently unused
 * We are leaving ratings and reviews code commented out
 */var TabsComp=exports.TabsComp=function(_Component){(0,_inherits3.default)(TabsComp,_Component);function TabsComp(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,TabsComp);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=TabsComp.__proto__||(0,_getPrototypeOf2.default)(TabsComp)).call.apply(_ref,[this].concat(args))),_this),_this.state={// ratingsBreakPointHit: false,
aboutBreakPointHit:false,servicesBreakPointHit:false,flowersBreakPointHit:false,planningTabBreakPointHit:false},_this.checkBreakPoint=function(){_this.setState({// ratingsBreakPointHit: breakPointChecker(1110),
aboutBreakPointHit:(0,_breakPointChecker.breakPointChecker)(1024),servicesBreakPointHit:(0,_breakPointChecker.breakPointChecker)(950),flowersBreakPointHit:(0,_breakPointChecker.breakPointChecker)(900),planningTabBreakPointHit:(0,_breakPointChecker.breakPointChecker)(600)});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(TabsComp,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.checkBreakPoint);this.checkBreakPoint();}},{key:'componentDidUpdate',value:function componentDidUpdate(nextProps){if(nextProps.tabIndex!==this.props.tabIndex){(0,_refreshAds.refreshAds)(['display-right-inview-1','display-right-inview-2']);}}},{key:'render',/* 
   * See comment at top of file
   * 
  getRatings(ratingsHeader) {
    let ratingsTab = null;
    let ratingsTabHeader = null;

    if (!this.props.funeralHome.profileData.suppressRatingsAndReviews) {
      ratingsTabHeader = <Tab className="tab-header">{ratingsHeader}</Tab>;
      ratingsTab = (
        <TabPanel forceRender>
          <RatingsReviews funeralHome={this.props.funeralHome} />
        </TabPanel>
      );
    }
    return {
      header: ratingsTabHeader,
      tab: ratingsTab,
    };
  }
  */value:function render(){var _this2=this;var isPremium=this.props.funeralHome.isPremium;var _state=this.state,aboutBreakPointHit=_state.aboutBreakPointHit,servicesBreakPointHit=_state.servicesBreakPointHit,planningTabBreakPointHit=_state.planningTabBreakPointHit;var aboutHeader=aboutBreakPointHit?'About':'About Us';/* const ratingsHeader = ratingsBreakPointHit
      ? 'Reviews'
      : 'Ratings & Reviews'; */var servicesHeader=servicesBreakPointHit?'Services':'Upcoming Services';var planningHeader=planningTabBreakPointHit?'Planning':'Funeral Planning';var TAB_NAMES=['tab_about_us','tab_obituaries','tab_services'];if(isPremium){TAB_NAMES.splice(1,0,'tab_funeral_planning');}var tabIndexUpdated=function tabIndexUpdated(tabIndex,lastTabIndex){var page=_this2.props.page;if(tabIndex!==lastTabIndex){(0,_GAHelpers.getGATags)({eventCategory:'fhd_tabs',eventAction:TAB_NAMES[tabIndex]+'_click',eventLabel:'fhd_'+TAB_NAMES[tabIndex]});var nextTabSlug=TAB_NAMES[tabIndex];var nextTabParameters=[{key:'tab',value:nextTabSlug}];if(nextTabSlug==='tab_obituaries'){nextTabParameters.push({key:'page',value:page});}var nextTabUrl=(0,_urlHelpers.buildUrl)(conf.vanityDomain,(0,_metaDataUtilities.buildDirectoryPath)(_this2.props.funeralHome),nextTabParameters);(0,_GAHelpers.setVirtualPageView)(nextTabUrl);history.pushState(null,null,nextTabUrl);}_this2.props.dispatch((0,_actions.setTabIndex)({tabIndex:tabIndex}));};// const ratings = this.getRatings(ratingsHeader);
return _react2.default.createElement(_reactTabs.Tabs,{selectedIndex:this.props.tabIndex,onSelect:function onSelect(tabIndex,lastTabIndex){tabIndexUpdated(tabIndex,lastTabIndex);}},_react2.default.createElement(_reactTabs.TabList,null,_react2.default.createElement(_reactTabs.Tab,{className:'tab-header'},aboutHeader),isPremium&&_react2.default.createElement(_reactTabs.Tab,{className:'tab-header'},planningHeader),_react2.default.createElement(_reactTabs.Tab,{className:'tab-header'},'Obituaries'),_react2.default.createElement(_reactTabs.Tab,{className:'tab-header'},servicesHeader)),_react2.default.createElement(_reactTabs.TabPanel,null,_react2.default.createElement(_AboutUs2.default,null)),isPremium&&_react2.default.createElement(_reactTabs.TabPanel,null,_react2.default.createElement(_FuneralPlanning2.default,null)),_react2.default.createElement(_reactTabs.TabPanel,null,_react2.default.createElement(_Obituaries2.default,null)),_react2.default.createElement(_reactTabs.TabPanel,null,_react2.default.createElement(_UpcomingServices2.default,null)));}}]);return TabsComp;}(_react.Component);TabsComp.propTypes={funeralHome:_react2.default.PropTypes.object.isRequired,planning:_react2.default.PropTypes.bool.isRequired,tabIndex:_react2.default.PropTypes.number.isRequired,dispatch:_react2.default.PropTypes.func};TabsComp.propTypes={funeralHome:_propTypes2.default.object.isRequired,planning:_propTypes2.default.bool.isRequired,tabIndex:_propTypes2.default.number.isRequired,dispatch:_propTypes2.default.func};var mapStateToProps=function mapStateToProps(state){return{page:(0,_get3.default)(state,'obituaryStore.page'),planning:(0,_get3.default)(state,'planningStore.isPlanning'),tabIndex:(0,_get3.default)(state,'tabIndexStore.tabIndex')};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(TabsComp);

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AboutUs=undefined;var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);__webpack_require__(1472);var _Amenities=__webpack_require__(1473);var _Amenities2=_interopRequireDefault(_Amenities);var _Map=__webpack_require__(1476);var _Map2=_interopRequireDefault(_Map);var _Details=__webpack_require__(1478);var _Details2=_interopRequireDefault(_Details);var _Header=__webpack_require__(98);var _Header2=_interopRequireDefault(_Header);var _VisitWebsiteLink=__webpack_require__(1481);var _VisitWebsiteLink2=_interopRequireDefault(_VisitWebsiteLink);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _urlHelpers=__webpack_require__(28);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var AboutUs=exports.AboutUs=function(_Component){(0,_inherits3.default)(AboutUs,_Component);function AboutUs(){(0,_classCallCheck3.default)(this,AboutUs);return(0,_possibleConstructorReturn3.default)(this,(AboutUs.__proto__||(0,_getPrototypeOf2.default)(AboutUs)).apply(this,arguments));}(0,_createClass3.default)(AboutUs,[{key:'renderAttributes',value:function renderAttributes(attributes){if(attributes){var capitalizeIf=function capitalizeIf(value,fallBack){if(value.toLowerCase()===fallBack.toLowerCase()){return value.toUpperCase();}return value;};var cleanedData=attributes.map(function(attr){switch(attr.category){case'Detail':return(0,_extends3.default)({},attr,{value:capitalizeIf(attr.value,'N/A')||'N/A',name:attr.name||'Error Loading'});case'Amenity':return(0,_extends3.default)({},attr,{name:attr.name||'Error Loading'});default:return(0,_extends3.default)({},attr);}});var filterAttributes=function filterAttributes(query){return cleanedData.filter(function(attribute){return attribute.category===query;});};return _react2.default.createElement('div',null,_react2.default.createElement(_Details2.default,{details:filterAttributes('Detail')}),_react2.default.createElement(_Amenities2.default,{amenities:filterAttributes('Amenity')}));}return null;}},{key:'render',value:function render(){var _props$funeralHome=this.props.funeralHome,isPremium=_props$funeralHome.isPremium,attributes=_props$funeralHome.attributesData;var address1=this.props.funeralHome.profileData.address1;var city=this.props.funeralHome.location.city.fullName;var state=this.props.funeralHome.location.state.fullName;var postalCode=this.props.funeralHome.location.postalCode;var _props$funeralHome2=this.props.funeralHome,profileData=_props$funeralHome2.profileData,logoImageUrl=_props$funeralHome2.logoImageUrl,primaryImageUrl=_props$funeralHome2.primaryImageUrl;var websiteUrl=profileData.websiteUrl;var description=profileData&&profileData.description;var googleMapsAddressLink=(0,_urlHelpers.getMapUrl)(address1+'+'+city+'+'+state+'+'+postalCode);var logo=logoImageUrl?_react2.default.createElement('img',{className:'logo',src:logoImageUrl}):null;var fhpic=primaryImageUrl?_react2.default.createElement('img',{className:'fhpic',src:primaryImageUrl}):null;var imageContainer=logo||fhpic?_react2.default.createElement('div',{className:'about-us-tab__image'},fhpic,logo):null;return _react2.default.createElement('div',{className:'about-us-tab__container'},_react2.default.createElement(_Header2.default,{title:'About Us'}),isPremium&&_react2.default.createElement(_Map2.default,{href:googleMapsAddressLink}),_react2.default.createElement('div',{className:'about-us-tab__description-image-container'},_react2.default.createElement('div',{className:'about-us-tab__description'},description.split('\n').map(function(paragraph,index){return paragraph&&_react2.default.createElement('p',{key:index},paragraph);}),_react2.default.createElement(_VisitWebsiteLink2.default,{websiteUrl:websiteUrl}),!isPremium&&_react2.default.createElement('p',null,'Is this your business?',' ',_react2.default.createElement('a',{href:'https://cloud.alerts.legacy.com/fhd-update'},'Update this page'),'.')),imageContainer),this.renderAttributes(attributes));}}]);return AboutUs;}(_react.Component);AboutUs.propTypes={funeralHome:_propTypes2.default.object.isRequired,planning:_propTypes2.default.bool.isRequired};var mapStateToProps=function mapStateToProps(state){return{planning:state.planningStore.isPlanning,funeralHome:state.funeralHomeStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(AboutUs);

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","about-us-tab__container":"about-us-tab__container","google-static-map":"google-static-map","about-us-tab__header":"about-us-tab__header","about-us-tab__description-image-container":"about-us-tab__description-image-container","about-us-tab__image":"about-us-tab__image","fhpic":"fhpic","logo":"logo","about-us-tab__description":"about-us-tab__description","details":"details"};

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _amenity=__webpack_require__(1474);var _amenity2=_interopRequireDefault(_amenity);var _Header=__webpack_require__(98);var _Header2=_interopRequireDefault(_Header);__webpack_require__(586);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Amenities=function(_Component){(0,_inherits3.default)(Amenities,_Component);function Amenities(){(0,_classCallCheck3.default)(this,Amenities);return(0,_possibleConstructorReturn3.default)(this,(Amenities.__proto__||(0,_getPrototypeOf2.default)(Amenities)).apply(this,arguments));}(0,_createClass3.default)(Amenities,[{key:'render',value:function render(){if(!this.props.amenities||this.props.amenities.length===0){return null;}var renderAmenities=this.props.amenities.map(function(amenity,i){return _react2.default.createElement(_amenity2.default,{key:i,amenity:amenity.name});});return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'funeral-home-amenities'},_react2.default.createElement(_Header2.default,{title:'Amenities'}),_react2.default.createElement('ul',{className:'funeral-home-amenities__list'},renderAmenities)));}}]);return Amenities;}(_react.Component);exports.default=Amenities;Amenities.propTypes={amenities:_propTypes2.default.array};

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _icons=__webpack_require__(177);var _icons2=_interopRequireDefault(_icons);__webpack_require__(586);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Amenity=function(_Component){(0,_inherits3.default)(Amenity,_Component);function Amenity(){(0,_classCallCheck3.default)(this,Amenity);return(0,_possibleConstructorReturn3.default)(this,(Amenity.__proto__||(0,_getPrototypeOf2.default)(Amenity)).apply(this,arguments));}(0,_createClass3.default)(Amenity,[{key:'render',value:function render(){return _react2.default.createElement('li',{className:'funeral-home-amenities__item'},_react2.default.createElement(_icons2.default,{className:'funeral-home-amenities__svg',name:'checkmark',fill:'#079B56',size:'1.5em'}),_react2.default.createElement('div',{className:'funeral-home-amenities__name'},this.props.amenity));}}]);return Amenity;}(_react.Component);exports.default=Amenity;Amenity.propTypes={amenity:_propTypes2.default.string.isRequired};

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","header__header":"header__header","no-border":"no-border","header__title":"header__title","header__children":"header__children","aside-header":"aside-header"};

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Map=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _googleMapsUrlHelper=__webpack_require__(1477);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Map=exports.Map=function(_Component){(0,_inherits3.default)(Map,_Component);function Map(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Map);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Map.__proto__||(0,_getPrototypeOf2.default)(Map)).call.apply(_ref,[this].concat(args))),_this),_this.state={imageUrl:(0,_googleMapsUrlHelper.urlBuilder)(_this.props.apiKey,_this.props.funeralHome)},_this.handleOnError=function(){_this.setState({imageUrl:null});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Map,[{key:'render',value:function render(){if(this.state.imageUrl){return _react2.default.createElement('a',{href:this.props.href,target:'_blank',className:'google-static-map',style:{backgroundImage:'url(\''+this.state.imageUrl+'\')'},onError:this.handleOnError});}return null;}}]);return Map;}(_react.Component);Map.propTypes={funeralHome:_react2.default.PropTypes.object.isRequired,apiKey:_react2.default.PropTypes.string.isRequired};var mapStateToProps=function mapStateToProps(state){return{funeralHome:state.funeralHomeStore,apiKey:''+(0,_AppConfig2.default)().googleApi.apiKey};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Map);

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.urlBuilder=urlBuilder;var _qs=__webpack_require__(541);var _qs2=_interopRequireDefault(_qs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Build Url For Google Maps API
 * @param {String} apiKey the google map api key
 * @param {Object} funeralHome all of the funeral home info
 * @param {Number} zoomLevel the map zoom level
 * @returns {String} Returns a formated URL for Google Static Maps API
 */function urlBuilder(apiKey){var funeralHome=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var zoomLevel=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var address1=funeralHome.profileData.address1,_funeralHome$location=funeralHome.location,city=_funeralHome$location.city.fullName,state=_funeralHome$location.state.code,latitude=_funeralHome$location.latitude,longitude=_funeralHome$location.longitude;var location=latitude&&longitude?latitude+','+longitude:address1+','+city+','+state;var mapRoot='https://maps.googleapis.com/maps/api/staticmap';var query=_qs2.default.stringify({zoom:zoomLevel,size:'924x180',scale:'2',markers:'color:red|'+location,center:location,key:apiKey});return mapRoot+'?'+query;}/* eslint quotes: ["error", "single", {"allowTemplateLiterals": true}] */

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Details=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _Detail=__webpack_require__(1479);var _Detail2=_interopRequireDefault(_Detail);var _Header=__webpack_require__(98);var _Header2=_interopRequireDefault(_Header);__webpack_require__(1480);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Details=exports.Details=function(_Component){(0,_inherits3.default)(Details,_Component);function Details(){(0,_classCallCheck3.default)(this,Details);return(0,_possibleConstructorReturn3.default)(this,(Details.__proto__||(0,_getPrototypeOf2.default)(Details)).apply(this,arguments));}(0,_createClass3.default)(Details,[{key:'render',value:function render(){var details=this.props.details;var hasAnyValidDetails=details?details.filter(function(detail){return!detail.value.toLowerCase().includes('n/a');}).length>0:false;var detailItems=details?details.map(function(detail,i){return _react2.default.createElement(_Detail2.default,{key:i,detail:detail});}):null;return this.props.planning||hasAnyValidDetails?_react2.default.createElement('div',{className:'details'},_react2.default.createElement(_Header2.default,{title:'Details'}),_react2.default.createElement('ul',{className:'details__unordered-list'},detailItems)):null;}}]);return Details;}(_react.Component);Details.propTypes={details:_propTypes2.default.array.isRequired,planning:_propTypes2.default.bool.isRequired};var mapStateToProps=function mapStateToProps(state){return{planning:state.planningStore.isPlanning};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Details);

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Detail=function(_React$Component){(0,_inherits3.default)(Detail,_React$Component);function Detail(){(0,_classCallCheck3.default)(this,Detail);return(0,_possibleConstructorReturn3.default)(this,(Detail.__proto__||(0,_getPrototypeOf2.default)(Detail)).apply(this,arguments));}(0,_createClass3.default)(Detail,[{key:'render',value:function render(){var _props$detail=this.props.detail,name=_props$detail.name,value=_props$detail.value;return _react2.default.createElement('li',{className:'details__list-item'},_react2.default.createElement('div',{className:'details__name'},name),_react2.default.createElement('div',{className:'details__value'},value));}}]);return Detail;}(_react2.default.Component);exports.default=Detail;Detail.propTypes={detail:_propTypes2.default.object};

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"funeral-home-profile":"funeral-home-profile","details__unordered-list":"details__unordered-list","details__list-item":"details__list-item","details__name":"details__name","details__value":"details__value"};

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _VisitWebsiteLink=__webpack_require__(1482);var _VisitWebsiteLink2=_interopRequireDefault(_VisitWebsiteLink);var _formatHelpers=__webpack_require__(55);var _icons=__webpack_require__(177);var _icons2=_interopRequireDefault(_icons);var _GAHelpers=__webpack_require__(22);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var VisitWebsiteLink=function VisitWebsiteLink(props){var formattedUrl=(0,_formatHelpers.formatExternalLink)(props.websiteUrl);if(!formattedUrl){return null;}var handleClick=function handleClick(){(0,_GAHelpers.getGATags)({eventCategory:'fhd_fhweb',eventAction:'fhd_fhweb_click',eventLabel:'fhd_website'});};return _react2.default.createElement('div',{className:_VisitWebsiteLink2.default.VisitWebsiteLink},_react2.default.createElement(_icons2.default,{name:'globe',fill:'#069',size:'16'}),_react2.default.createElement('a',{className:_VisitWebsiteLink2.default.Link,'data-ga-no-auto-tag':true,href:formattedUrl,onClick:handleClick,target:'_blank'},'Visit Our Website'));};VisitWebsiteLink.propTypes={websiteUrl:_react2.default.PropTypes.string};exports.default=VisitWebsiteLink;

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"funeral-home-profile":"funeral-home-profile","VisitWebsiteLink":"VisitWebsiteLink","Link":"Link"};

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FuneralPlanning=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _GetHelpNow=__webpack_require__(1484);var _GetHelpNow2=_interopRequireDefault(_GetHelpNow);__webpack_require__(1486);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FuneralPlanning=exports.FuneralPlanning=function(_Component){(0,_inherits3.default)(FuneralPlanning,_Component);function FuneralPlanning(){(0,_classCallCheck3.default)(this,FuneralPlanning);return(0,_possibleConstructorReturn3.default)(this,(FuneralPlanning.__proto__||(0,_getPrototypeOf2.default)(FuneralPlanning)).apply(this,arguments));}(0,_createClass3.default)(FuneralPlanning,[{key:'render',value:function render(){var name=this.props.funeralHome.name;return _react2.default.createElement('section',{className:'fh-planning'},_react2.default.createElement(_GetHelpNow2.default,null),_react2.default.createElement('div',{className:'funeral-home-planning'},_react2.default.createElement('header',{className:'benefits-of-pre-planning__header'},'Whether it\u2019s time \u2014 or ahead of time'),_react2.default.createElement('p',{className:'benefits-of-pre-planning__text'},'Pre-planning your funeral can be one of the biggest gifts you give to your loved ones. Grief can be confusing and overwhelming. Taking care of your own arrangements can lift a burden off your family during such an emotional time.'),_react2.default.createElement('p',{className:'benefits-of-pre-planning__text'},'As one of Legacy\u2019s funeral home partners, ',name,' is intimately familiar with the major decisions a family has to make.'),_react2.default.createElement('p',{className:'benefits-of-pre-planning__text'},'Those range from the practical (what kind of burial and where?) and the personal (who will provide comfort and support?) to the financial (is pre-payment a good idea?) and the legal (what documents are required?).'),_react2.default.createElement('p',{className:'benefits-of-pre-planning__text'},name,' is here to help you and your family with your pre-planning needs.\xA0Contact ',name,' when you\u2019re ready to discuss a free, customized funeral plan.')));}}]);return FuneralPlanning;}(_react.Component);FuneralPlanning.propTypes={funeralHome:_react2.default.PropTypes.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{funeralHome:state.funeralHomeStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(FuneralPlanning);

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.GetHelpNow=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _formatHelpers=__webpack_require__(55);var _PhoneButton=__webpack_require__(587);var _PhoneButton2=_interopRequireDefault(_PhoneButton);__webpack_require__(1485);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var GetHelpNow=exports.GetHelpNow=function(_Component){(0,_inherits3.default)(GetHelpNow,_Component);function GetHelpNow(){(0,_classCallCheck3.default)(this,GetHelpNow);return(0,_possibleConstructorReturn3.default)(this,(GetHelpNow.__proto__||(0,_getPrototypeOf2.default)(GetHelpNow)).apply(this,arguments));}(0,_createClass3.default)(GetHelpNow,[{key:'render',value:function render(){var isPremium=this.props.funeralHome.isPremium;var phone=this.props.funeralHome.profileData.phone;var formattedPhone=(0,_formatHelpers.formatPhoneNumber)(phone);return _react2.default.createElement('div',{className:'get-help-now'},_react2.default.createElement('h1',{className:'get-help-now__title'},'Need Help Right Away?'),_react2.default.createElement('p',{className:'get-help-now__information'},'We\'ll help you get through the next steps.'),_react2.default.createElement(_PhoneButton2.default,{className:'get-help-now__phone-number',phoneNumber:formattedPhone,isPremium:isPremium,showIcon:false}));}}]);return GetHelpNow;}(_react.Component);GetHelpNow.propTypes={funeralHome:_react2.default.PropTypes.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{funeralHome:state.funeralHomeStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(GetHelpNow);

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","get-help-now":"get-help-now","get-help-now__title":"get-help-now__title","get-help-now__information":"get-help-now__information","get-help-now__phone-number":"get-help-now__phone-number"};

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","funeral-home-planning":"funeral-home-planning","funeral-home-planning__text":"funeral-home-planning__text","benefits-of-pre-planning__header":"benefits-of-pre-planning__header","benefits-of-pre-planning__text":"benefits-of-pre-planning__text","benefits-of-pre-planning__list":"benefits-of-pre-planning__list","benefits-of-pre-planning__list-item":"benefits-of-pre-planning__list-item","help-with-the-details__header":"help-with-the-details__header","help-with-the-details__text":"help-with-the-details__text","help-with-the-details__list":"help-with-the-details__list","help-with-the-details__list-item":"help-with-the-details__list-item","help-with-the-details__detail":"help-with-the-details__detail","help-with-the-details__list-span":"help-with-the-details__list-span","benefits-of-pre-planning__span":"benefits-of-pre-planning__span"};

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Obituaries=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRedux=__webpack_require__(12);__webpack_require__(1488);var _obituary=__webpack_require__(1489);var _obituary2=_interopRequireDefault(_obituary);var _MobileAdUnit=__webpack_require__(1495);var _MobileAdUnit2=_interopRequireDefault(_MobileAdUnit);var _urlHelpers=__webpack_require__(28);var _GAHelpers=__webpack_require__(22);var _obituariesHelper=__webpack_require__(1531);var _Header=__webpack_require__(98);var _Header2=_interopRequireDefault(_Header);var _FlowersAd=__webpack_require__(604);var _FlowersAd2=_interopRequireDefault(_FlowersAd);var _flower=__webpack_require__(605);var _flower2=_interopRequireDefault(_flower);var _flower3=__webpack_require__(606);var _flower4=_interopRequireDefault(_flower3);var _flower5=__webpack_require__(607);var _flower6=_interopRequireDefault(_flower5);var _SearchObituaries=__webpack_require__(608);var _SearchObituaries2=_interopRequireDefault(_SearchObituaries);var _get2=__webpack_require__(135);var _get3=_interopRequireDefault(_get2);var _Spinner=__webpack_require__(538);var _Spinner2=_interopRequireDefault(_Spinner);var _legacyAdvertising=__webpack_require__(99);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Obituaries=exports.Obituaries=function(_Component){(0,_inherits3.default)(Obituaries,_Component);function Obituaries(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Obituaries);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Obituaries.__proto__||(0,_getPrototypeOf2.default)(Obituaries)).call.apply(_ref,[this].concat(args))),_this),_this.state={isMobile:_this.props.isMobile},_this.ticking=false,_this.lastScrollPos=0,_this.getScrollPos=function(){var supportPageOffset=window.pageXOffset!==undefined;// eslint-disable-line no-undefined
var isCSS1Compat=(document.compatMode||'')==='CSS1Compat';if(supportPageOffset){return window.pageYOffset;}return isCSS1Compat?document.documentElement.scrollTop:document.body.scrollTop;},_this.handleScroll=function(){var obituaries=_this.props.obituaries;var loading=obituaries.loading,showLoadMoreButton=obituaries.showLoadMoreButton;var direction='';if(_this.getScrollPos()>_this.lastScrollPos){direction='down';}else{direction='up';}_this.lastScrollPos=_this.getScrollPos();if(!_this.ticking&&!loading&&showLoadMoreButton){var tabHeight=_this.tabRef.clientHeight;var threshold=Math.ceil(tabHeight*0.85);window.requestAnimationFrame(function(){if(direction==='down'&&_this.lastScrollPos>=threshold){_this.handleInfiniteScroll();}_this.ticking=false;});_this.ticking=true;}},_this.handleSendFlowersClick=function(){(0,_GAHelpers.getGATags)({eventCategory:'fhd_flowers',eventAction:'fhd_flowers_click',eventLabel:'fhd_flowers_store'});},_this.handleInfiniteScroll=function(){var _this$props=_this.props,funeralHome=_this$props.funeralHome,affiliateId=_this$props.affiliateId,dispatch=_this$props.dispatch;var funeralHomeId=funeralHome.funeralHomeId;(0,_GAHelpers.getGATags)({eventCategory:'fhd_obitload',eventAction:'fhd_obitload_click',eventLabel:'fhd_obitload_loadmore'});dispatch((0,_obituariesHelper.getMoreObituaries)(funeralHomeId,affiliateId));},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Obituaries,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.handleScroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);}},{key:'shouldRenderObituaries',value:function shouldRenderObituaries(){return this.props.obituaries&&this.props.obituaries.people&&this.props.obituaries.people.length;}},{key:'renderAds',value:function renderAds(index){var adService=this.props.adService;var isMobile=this.state.isMobile;var positionId=null;if(!isMobile||index<=10){return null;}if(index%10===4){positionId='custom-inline-1';}if(index%10===9){positionId='custom-inline-2';}if(positionId){this.adCount++;var slotName='inlineAd'+this.adCount;var slotKeyValues=[{key:'spot',value:this.adCount.toString()}];return _react2.default.createElement('div',{style:{margin:'1.5rem 0',textAlign:'center'}},_react2.default.createElement(_MobileAdUnit2.default,{adService:adService,positionId:positionId,slotName:slotName,slotKeyValues:slotKeyValues}));}return null;}},{key:'renderRecentObituariesWithFlowersAd',value:function renderRecentObituariesWithFlowersAd(flowersUrlOptions){var _this2=this;var flowersAdsItems=[{image:_flower2.default,text:'The FTD® Comfort™ Planter',link:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions)},{image:_flower4.default,text:'The FTD® Faithful Blessings™ Bouquet - VASE INCLUDED',link:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions)},{image:_flower6.default,text:'The FTD® Eternal Affection™ Arrangement',link:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions)}];var obituaries=this.props.obituaries;var flowersAd=this.props.planning?null:_react2.default.createElement(_FlowersAd2.default,{key:'flowersAd',flowersAdItems:flowersAdsItems,flowersUrlOptions:flowersUrlOptions});var flowerAdIndex=obituaries.people.length<=5?-1:5;this.adCount=0;return _react2.default.createElement('div',null,obituaries.people.map(function(person,index){return _react2.default.createElement('div',{key:person.personId,style:{marginBottom:'1.5rem'}},index===flowerAdIndex&&flowersAd,_this2.renderAds(index),_react2.default.createElement(_obituary2.default,{person:person}));}),this.props.obituaries.isLoading&&_react2.default.createElement('div',{style:{marginTop:40}},_react2.default.createElement(_Spinner2.default,{size:60})),flowerAdIndex===-1&&flowersAd);}},{key:'renderRecentObituaries',value:function renderRecentObituaries(flowersUrlOptions){return _react2.default.createElement('div',{className:'obituaries-collection'},_react2.default.createElement(_Header2.default,{type:'no-border',title:'Recent Obituaries'}),this.renderRecentObituariesWithFlowersAd(flowersUrlOptions));}},{key:'renderNoRecentObituaries',value:function renderNoRecentObituaries(){return _react2.default.createElement('div',{className:'obituaries-collection'},_react2.default.createElement(_Header2.default,{type:'no-border',title:'Recent Obituaries'}),_react2.default.createElement('p',null,'There are no recent obituaries at this time. Search for older obituaries.'));}},{key:'render',value:function render(){var _this3=this;var _props=this.props,affiliateId=_props.affiliateId,funeralHome=_props.funeralHome,isMobile=_props.isMobile;var funeralHomeId=funeralHome.funeralHomeId,name=funeralHome.name,location=funeralHome.location,flowerSettings=funeralHome.flowerSettings;var flowersUrlOptions={funeralHomeId:funeralHomeId,funeralHomeName:name,affiliateId:affiliateId,cultureCode:location.country.cultureCode,flowerSettings:flowerSettings,isMobile:isMobile};return _react2.default.createElement('div',{className:'obituaries-tab',ref:function ref(element){_this3.tabRef=element;}},_react2.default.createElement(_Header2.default,{title:'Attending The Funeral'}),_react2.default.createElement('div',{className:'tab-overview'},_react2.default.createElement('p',null,'We encourage you to contact the funeral home to verify time and location before attending services or visitation.'),_react2.default.createElement('p',null,'To send flowers to ',this.props.funeralHome.name,' please visit our',' ',_react2.default.createElement('a',{href:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions),className:'link-send-flowers','data-ga-no-auto-tag':true,onClick:this.handleSendFlowersClick},'sympathy store'),'.')),this.shouldRenderObituaries()?this.renderRecentObituaries(flowersUrlOptions):this.renderNoRecentObituaries(),_react2.default.createElement('div',{className:'obituaries__search-obituaries'},_react2.default.createElement(_Header2.default,{type:'no-border',title:'Search Obituaries'}),_react2.default.createElement(_SearchObituaries2.default,null)));}}]);return Obituaries;}(_react.Component);Obituaries.propTypes={adService:_propTypes2.default.shape({type:_propTypes2.default.instanceOf(_legacyAdvertising.AdService)}).isRequired};var mapStateToProps=function mapStateToProps(state){return{funeralHome:state.funeralHomeStore,obituaries:state.obituaryStore,affiliateId:state.affiliateStore.sourceId,planning:(0,_get3.default)(state,'planningStore.isPlanning'),isMobile:state.mobileDetailsStore.any,adService:state.adStore.adService};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Obituaries);

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","obituaries-tab":"obituaries-tab","obituaries-collection":"obituaries-collection","show-more-obituaries":"show-more-obituaries"};

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _personObituary=__webpack_require__(1490);var _personObituary2=_interopRequireDefault(_personObituary);__webpack_require__(1494);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Obituary=function(_Component){(0,_inherits3.default)(Obituary,_Component);function Obituary(){(0,_classCallCheck3.default)(this,Obituary);return(0,_possibleConstructorReturn3.default)(this,(Obituary.__proto__||(0,_getPrototypeOf2.default)(Obituary)).apply(this,arguments));}(0,_createClass3.default)(Obituary,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'obit-group'},this.props.person.obituaries.map(function(personObit,i){return _react2.default.createElement(_personObituary2.default,{key:i,personObit:personObit});}));}}]);return Obituary;}(_react.Component);exports.default=Obituary;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.PersonObituary=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1491);var _reactRedux=__webpack_require__(12);var _moment=__webpack_require__(97);var _moment2=_interopRequireDefault(_moment);var _urlHelpers=__webpack_require__(28);var _GAHelpers=__webpack_require__(22);var _ForestLawnFuneralHomeIds=__webpack_require__(1492);var _ForestLawnFuneralHomeIds2=_interopRequireDefault(_ForestLawnFuneralHomeIds);var _SocialButtons=__webpack_require__(588);var _SocialButtons2=_interopRequireDefault(_SocialButtons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PersonObituary=exports.PersonObituary=function(_Component){(0,_inherits3.default)(PersonObituary,_Component);function PersonObituary(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,PersonObituary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=PersonObituary.__proto__||(0,_getPrototypeOf2.default)(PersonObituary)).call.apply(_ref,[this].concat(args))),_this),_this.truncateStringByWordCount=function(str,no_words){return str.split(' ').splice(0,no_words).join(' ');},_this.handleNameClick=function(){(0,_GAHelpers.getGATags)({eventCategory:'fhd_obit',eventAction:'obit_name_click',eventLabel:'fhd_obit_name'});},_this.handleImageClick=function(){(0,_GAHelpers.getGATags)({eventCategory:'fhd_obit',eventAction:'obit_image_click',eventLabel:'fhd_obit_image'});},_this.handleReadMoreClick=function(){(0,_GAHelpers.getGATags)({eventCategory:'fhd_obit',eventAction:'obit_readmore_click',eventLabel:'fhd_obit_read_more'});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(PersonObituary,[{key:'getPublishDate',value:function getPublishDate(){var start=_moment2.default.utc(this.props.personObit.publishedStartDate).format('MMM DD, YYYY');var end=_moment2.default.utc(this.props.personObit.publishedCompleteDate).format('MMM DD, YYYY');if(start===end){return end;}return _moment2.default.utc(this.props.personObit.publishedStartDate).format('MMM DD')+' to '+end;}},{key:'formatDescription',value:function formatDescription(descriptionHtml,maxWordLength){var fullDescription=descriptionHtml.replace(/<(?:.|\n)*?>/gm,'');var truncatedDescription=this.truncateStringByWordCount(fullDescription,maxWordLength);return fullDescription.split(/\W+/).length>maxWordLength?truncatedDescription+'... ':fullDescription;}},{key:'render',value:function render(){var _props$personObit=this.props.personObit,obituaryId=_props$personObit.obituaryId,imageUrl=_props$personObit.imageUrl,fullName=_props$personObit.fullName,lifespan=_props$personObit.lifespan,descriptionHtml=_props$personObit.descriptionHtml,obituaryUrl=_props$personObit.obituaryUrl,publishedType=_props$personObit.publishedType,publisherDisplayName=_props$personObit.publisherDisplayName,_props$personObit$max=_props$personObit.maxWordLength,maxWordLength=_props$personObit$max===undefined?40:_props$personObit$max,ampUrl=_props$personObit.ampUrl;var _props=this.props,affiliateId=_props.affiliateId,funeralHome=_props.funeralHome,isMobile=_props.isMobile;var name=funeralHome.name,location=funeralHome.location,flowerSettings=funeralHome.flowerSettings,funeralHomeId=funeralHome.funeralHomeId;var flowersUrlOptions={personId:obituaryId,personName:fullName,affiliateId:affiliateId,cultureCode:location.country.cultureCode,flowerSettings:flowerSettings,isMobile:isMobile};var socialUrls={flowersUrl:(0,_urlHelpers.buildObitFlowersUrl)(flowersUrlOptions),obituaryUrl:obituaryUrl};var socialDetails={fullName:fullName,isPlanning:this.props.isPlanning};var formattedDescription=this.formatDescription(descriptionHtml,maxWordLength);var formattedLifespan=lifespan?'('+lifespan+')':'';var ForestLawnFuneralHomeIds=(0,_ForestLawnFuneralHomeIds2.default)();var IsForestLawnFuneralHome=ForestLawnFuneralHomeIds.includes(funeralHomeId);var IsNotTribues=publisherDisplayName!=='Tributes.com';return _react2.default.createElement('div',{className:'person-obituary','data-id':obituaryId},_react2.default.createElement('div',{className:'person-content'},_react2.default.createElement('div',{className:'person-content__header'},_react2.default.createElement('div',{className:'person-content__name-lifespan'},_react2.default.createElement('a',{onClick:this.handleNameClick,href:isMobile&&!IsForestLawnFuneralHome&&IsNotTribues?ampUrl:obituaryUrl},fullName,' ',formattedLifespan)),_react2.default.createElement('div',{onClick:this.handleImageClick,className:'person-content__picture',style:{backgroundImage:'url('+imageUrl+')'}})),_react2.default.createElement('div',{className:'description'},formattedDescription,_react2.default.createElement('a',{href:isMobile&&!IsForestLawnFuneralHome&&IsNotTribues?ampUrl:obituaryUrl,onClick:this.handleReadMoreClick,style:{marginLeft:'0.5rem'}},'Read More')),['Tributes.com','Batesville','Dignity Memorial'].includes(publisherDisplayName)?_react2.default.createElement('div',{className:'publisher'},'Published ',publishedType,' on ',this.getPublishDate(),' courtesy of',' ',name,'.'):_react2.default.createElement('div',{className:'publisher'},'Published ',publishedType,' in ',publisherDisplayName,' ',this.getPublishDate()),_react2.default.createElement(_SocialButtons2.default,{type:'obituary',urls:socialUrls,details:socialDetails})));}}]);return PersonObituary;}(_react.Component);var mapStateToProps=function mapStateToProps(state){return{isPlanning:state.planningStore.isPlanning,affiliateId:state.affiliateStore.sourceId,funeralHome:state.funeralHomeStore,isMobile:state.mobileDetailsStore.any};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(PersonObituary);

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","person-obituary":"person-obituary","person-content":"person-content","person-content__header":"person-content__header","person-content__picture":"person-content__picture","person-content__name-lifespan":"person-content__name-lifespan","description":"description","publisher":"publisher","person-obituary__read-more":"person-obituary__read-more"};

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=getForestLawnFuneralHomeIds;/**
 * This function returns the Funeral Home Ids which is associated with Forest Lawn CA.
 * These FH does not want to use AMPUrl on the page.
 * @return {Array} List of Ids
 */function getForestLawnFuneralHomeIds(){return[2676,4501,4502,4503,4504,4505,24101,20227];}

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","social-buttons":"social-buttons","social-buttons__facebook":"social-buttons__facebook","social-buttons__email":"social-buttons__email","social-buttons__flowers":"social-buttons__flowers","facebook":"facebook","social-buttons__fb-span":"social-buttons__fb-span"};

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"funeral-home-profile":"funeral-home-profile","obit-group":"obit-group"};

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _legacyAdvertising=__webpack_require__(99);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MobileAdUnit=function(_Component){(0,_inherits3.default)(MobileAdUnit,_Component);function MobileAdUnit(props){(0,_classCallCheck3.default)(this,MobileAdUnit);var _this=(0,_possibleConstructorReturn3.default)(this,(MobileAdUnit.__proto__||(0,_getPrototypeOf2.default)(MobileAdUnit)).call(this,props));_this.renderCount=0;return _this;}(0,_createClass3.default)(MobileAdUnit,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){return false;}},{key:'render',value:function render(){var _props=this.props,adService=_props.adService,positionId=_props.positionId,slotName=_props.slotName,slotKeyValues=_props.slotKeyValues;this.renderCount++;return _react2.default.createElement('div',null,_react2.default.createElement(_legacyAdvertising.AdController,{adService:adService,adSize:[[300,250],[320,100],[320,50],[1,1]],clientLoadOnly:true,pageName:'fh-profile',positionId:positionId,slotName:slotName,slotKeyValues:slotKeyValues}));}}]);return MobileAdUnit;}(_react.Component);MobileAdUnit.propTypes={adService:_propTypes2.default.shape({type:_propTypes2.default.instanceOf(_legacyAdvertising.AdService)}),positionId:_propTypes2.default.string,slotName:_propTypes2.default.string,slotKeyValues:_propTypes2.default.array};exports.default=MobileAdUnit;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = __webpack_require__(1497)['default'];


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = __webpack_require__(590);

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = __webpack_require__(1508);

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = __webpack_require__(118);

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = __webpack_require__(80);

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = __webpack_require__(1509);

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = __webpack_require__(1511);

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(80);

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(80);

var _exception = __webpack_require__(118);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else if (typeof Symbol === 'function' && context[Symbol.iterator]) {
        var newContext = [];
        var iterator = context[Symbol.iterator]();
        for (var it = iterator.next(); !it.done; it = iterator.next()) {
          newContext.push(it.value);
        }
        context = newContext;
        for (var j = context.length; i < j; i++) {
          execIteration(i, i, i === context.length - 1);
        }
      } else {
        (function () {
          var priorKey = undefined;

          Object.keys(context).forEach(function (key) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          });
          if (priorKey !== undefined) {
            execIteration(priorKey, i - 1, true);
          }
        })();
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = __webpack_require__(118);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFDSixtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUNqRSxDQUFDO0tBQ0g7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oXG4gICAgICAgICdNaXNzaW5nIGhlbHBlcjogXCInICsgYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXS5uYW1lICsgJ1wiJ1xuICAgICAgKTtcbiAgICB9XG4gIH0pO1xufVxuIl19


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(80);

var _exception = __webpack_require__(118);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#if requires exactly one argument');
    }
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#unless requires exactly one argument');
    }
    return instance.helpers['if'].call(this, conditional, {
      fn: options.inverse,
      inverse: options.fn,
      hash: options.hash
    });
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ3BCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM1QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVEsSUFBSSxDQUFDLENBQUM7R0FDdkIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgb3B0aW9ucyA9IGFyZ3VtZW50c1thcmd1bWVudHMubGVuZ3RoIC0gMV07XG4gICAgZm9yIChsZXQgaSA9IDA7IGkgPCBhcmd1bWVudHMubGVuZ3RoIC0gMTsgaSsrKSB7XG4gICAgICBhcmdzLnB1c2goYXJndW1lbnRzW2ldKTtcbiAgICB9XG5cbiAgICBsZXQgbGV2ZWwgPSAxO1xuICAgIGlmIChvcHRpb25zLmhhc2gubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmhhc2gubGV2ZWw7XG4gICAgfSBlbHNlIGlmIChvcHRpb25zLmRhdGEgJiYgb3B0aW9ucy5kYXRhLmxldmVsICE9IG51bGwpIHtcbiAgICAgIGxldmVsID0gb3B0aW9ucy5kYXRhLmxldmVsO1xuICAgIH1cbiAgICBhcmdzWzBdID0gbGV2ZWw7XG5cbiAgICBpbnN0YW5jZS5sb2coLi4uYXJncyk7XG4gIH0pO1xufVxuIl19


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field, options) {
    if (!obj) {
      // Note for 5.0: Change to "obj == null" in 5.0
      return obj;
    }
    return options.lookupProperty(obj, field);
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRTtBQUM5RCxRQUFJLENBQUMsR0FBRyxFQUFFOztBQUVSLGFBQU8sR0FBRyxDQUFDO0tBQ1o7QUFDRCxXQUFPLE9BQU8sQ0FBQyxjQUFjLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0dBQzNDLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6Imxvb2t1cC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVySGVscGVyKCdsb29rdXAnLCBmdW5jdGlvbihvYmosIGZpZWxkLCBvcHRpb25zKSB7XG4gICAgaWYgKCFvYmopIHtcbiAgICAgIC8vIE5vdGUgZm9yIDUuMDogQ2hhbmdlIHRvIFwib2JqID09IG51bGxcIiBpbiA1LjBcbiAgICAgIHJldHVybiBvYmo7XG4gICAgfVxuICAgIHJldHVybiBvcHRpb25zLmxvb2t1cFByb3BlcnR5KG9iaiwgZmllbGQpO1xuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(80);

var _exception = __webpack_require__(118);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#with requires exactly one argument');
    }
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = __webpack_require__(1506);

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG4iXX0=


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(80);

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXVCLFVBQVU7O3FCQUVsQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGV4dGVuZCB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJEZWNvcmF0b3IoJ2lubGluZScsIGZ1bmN0aW9uKGZuLCBwcm9wcywgY29udGFpbmVyLCBvcHRpb25zKSB7XG4gICAgbGV0IHJldCA9IGZuO1xuICAgIGlmICghcHJvcHMucGFydGlhbHMpIHtcbiAgICAgIHByb3BzLnBhcnRpYWxzID0ge307XG4gICAgICByZXQgPSBmdW5jdGlvbihjb250ZXh0LCBvcHRpb25zKSB7XG4gICAgICAgIC8vIENyZWF0ZSBhIG5ldyBwYXJ0aWFscyBzdGFjayBmcmFtZSBwcmlvciB0byBleGVjLlxuICAgICAgICBsZXQgb3JpZ2luYWwgPSBjb250YWluZXIucGFydGlhbHM7XG4gICAgICAgIGNvbnRhaW5lci5wYXJ0aWFscyA9IGV4dGVuZCh7fSwgb3JpZ2luYWwsIHByb3BzLnBhcnRpYWxzKTtcbiAgICAgICAgbGV0IHJldCA9IGZuKGNvbnRleHQsIG9wdGlvbnMpO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBvcmlnaW5hbDtcbiAgICAgICAgcmV0dXJuIHJldDtcbiAgICAgIH07XG4gICAgfVxuXG4gICAgcHJvcHMucGFydGlhbHNbb3B0aW9ucy5hcmdzWzBdXSA9IG9wdGlvbnMuZm47XG5cbiAgICByZXR1cm4gcmV0O1xuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createNewLookupObject = createNewLookupObject;

var _utils = __webpack_require__(80);

/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */

function createNewLookupObject() {
  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  return _utils.extend.apply(undefined, [Object.create(null)].concat(sources));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2ludGVybmFsL2NyZWF0ZS1uZXctbG9va3VwLW9iamVjdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztxQkFBdUIsVUFBVTs7Ozs7Ozs7O0FBUTFCLFNBQVMscUJBQXFCLEdBQWE7b0NBQVQsT0FBTztBQUFQLFdBQU87OztBQUM5QyxTQUFPLGdDQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQUssT0FBTyxFQUFDLENBQUM7Q0FDaEQiLCJmaWxlIjoiY3JlYXRlLW5ldy1sb29rdXAtb2JqZWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZXh0ZW5kIH0gZnJvbSAnLi4vdXRpbHMnO1xuXG4vKipcbiAqIENyZWF0ZSBhIG5ldyBvYmplY3Qgd2l0aCBcIm51bGxcIi1wcm90b3R5cGUgdG8gYXZvaWQgdHJ1dGh5IHJlc3VsdHMgb24gcHJvdG90eXBlIHByb3BlcnRpZXMuXG4gKiBUaGUgcmVzdWx0aW5nIG9iamVjdCBjYW4gYmUgdXNlZCB3aXRoIFwib2JqZWN0W3Byb3BlcnR5XVwiIHRvIGNoZWNrIGlmIGEgcHJvcGVydHkgZXhpc3RzXG4gKiBAcGFyYW0gey4uLm9iamVjdH0gc291cmNlcyBhIHZhcmFyZ3MgcGFyYW1ldGVyIG9mIHNvdXJjZSBvYmplY3RzIHRoYXQgd2lsbCBiZSBtZXJnZWRcbiAqIEByZXR1cm5zIHtvYmplY3R9XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBjcmVhdGVOZXdMb29rdXBPYmplY3QoLi4uc291cmNlcykge1xuICByZXR1cm4gZXh0ZW5kKE9iamVjdC5jcmVhdGUobnVsbCksIC4uLnNvdXJjZXMpO1xufVxuIl19


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Build out our basic SafeString type


exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = __webpack_require__(80);

var Utils = _interopRequireWildcard(_utils);

var _exception = __webpack_require__(118);

var _exception2 = _interopRequireDefault(_exception);

var _base = __webpack_require__(590);

var _helpers = __webpack_require__(591);

var _internalWrapHelper = __webpack_require__(1510);

var _internalProtoAccess = __webpack_require__(593);

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
    return;
  }

  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
  } else {
    // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as pseudo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }
    partial = env.VM.resolvePartial.call(this, partial, context, options);

    var extendedOptions = Utils.extend({}, options, {
      hooks: this.hooks,
      protoAccessControl: this.protoAccessControl
    });

    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, extendedOptions);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name, loc) {
      if (!obj || !(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
          loc: loc
        });
      }
      return container.lookupProperty(obj, name);
    },
    lookupProperty: function lookupProperty(parent, propertyName) {
      var result = parent[propertyName];
      if (result == null) {
        return result;
      }
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return result;
      }

      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
        return result;
      }
      return undefined;
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        var result = depths[i] && container.lookupProperty(depths[i], name);
        if (result != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    mergeIfNeeded: function mergeIfNeeded(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }

    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }

  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
      wrapHelpersToPassLookupProperty(mergedHelpers, container);
      container.helpers = mergedHelpers;

      if (templateSpec.usePartial) {
        // Use mergeIfNeeded here to prevent compiling global partials multiple times
        container.partials = container.mergeIfNeeded(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = Utils.extend({}, env.decorators, options.decorators);
      }

      container.hooks = {};
      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);

      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
    } else {
      container.protoAccessControl = options.protoAccessControl; // internal option
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
      container.hooks = options.hooks;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  // Use the current closure context to save the partial-block if this partial
  var currentPartialBlock = options.data && options.data['partial-block'];
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    (function () {
      options.data = _base.createFrame(options.data);
      // Wrapper function to get access to currentPartialBlock from the closure
      var fn = options.fn;
      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        // Restore the partial-block from the closure for the execution of the block
        // i.e. the part inside the block of the partial call.
        options.data = _base.createFrame(options.data);
        options.data['partial-block'] = currentPartialBlock;
        return fn(context, options);
      };
      if (fn.partials) {
        options.partials = Utils.extend({}, options.partials, fn.partials);
      }
    })();
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}

function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
  Object.keys(mergedHelpers).forEach(function (helperName) {
    var helper = mergedHelpers[helperName];
    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
  });
}

function passLookupPropertyOption(helper, container) {
  var lookupProperty = container.lookupProperty;
  return _internalWrapHelper.wrapHelper(helper, function (options) {
    return Utils.extend({ lookupProperty: lookupProperty }, options);
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrapHelper = wrapHelper;

function wrapHelper(helper, transformOptionsFn) {
  if (typeof helper !== 'function') {
    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
  }
  var wrapper = function wrapper() /* dynamic arguments */{
    var options = arguments[arguments.length - 1];
    arguments[arguments.length - 1] = transformOptionsFn(options);
    return helper.apply(this, arguments);
  };
  return wrapper;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2ludGVybmFsL3dyYXBIZWxwZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBTyxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUUsa0JBQWtCLEVBQUU7QUFDckQsTUFBSSxPQUFPLE1BQU0sS0FBSyxVQUFVLEVBQUU7OztBQUdoQyxXQUFPLE1BQU0sQ0FBQztHQUNmO0FBQ0QsTUFBSSxPQUFPLEdBQUcsU0FBVixPQUFPLDBCQUFxQztBQUM5QyxRQUFNLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUNoRCxhQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsR0FBRyxrQkFBa0IsQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUM5RCxXQUFPLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxDQUFDO0dBQ3RDLENBQUM7QUFDRixTQUFPLE9BQU8sQ0FBQztDQUNoQiIsImZpbGUiOiJ3cmFwSGVscGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGZ1bmN0aW9uIHdyYXBIZWxwZXIoaGVscGVyLCB0cmFuc2Zvcm1PcHRpb25zRm4pIHtcbiAgaWYgKHR5cGVvZiBoZWxwZXIgIT09ICdmdW5jdGlvbicpIHtcbiAgICAvLyBUaGlzIHNob3VsZCBub3QgaGFwcGVuLCBidXQgYXBwYXJlbnRseSBpdCBkb2VzIGluIGh0dHBzOi8vZ2l0aHViLmNvbS93eWNhdHMvaGFuZGxlYmFycy5qcy9pc3N1ZXMvMTYzOVxuICAgIC8vIFdlIHRyeSB0byBtYWtlIHRoZSB3cmFwcGVyIGxlYXN0LWludmFzaXZlIGJ5IG5vdCB3cmFwcGluZyBpdCwgaWYgdGhlIGhlbHBlciBpcyBub3QgYSBmdW5jdGlvbi5cbiAgICByZXR1cm4gaGVscGVyO1xuICB9XG4gIGxldCB3cmFwcGVyID0gZnVuY3Rpb24oLyogZHluYW1pYyBhcmd1bWVudHMgKi8pIHtcbiAgICBjb25zdCBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdID0gdHJhbnNmb3JtT3B0aW9uc0ZuKG9wdGlvbnMpO1xuICAgIHJldHVybiBoZWxwZXIuYXBwbHkodGhpcywgYXJndW1lbnRzKTtcbiAgfTtcbiAgcmV0dXJuIHdyYXBwZXI7XG59XG4iXX0=


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global globalThis */


exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  // https://mathiasbynens.be/notes/globalthis
  (function () {
    if (typeof globalThis === 'object') return;
    Object.prototype.__defineGetter__('__magic__', function () {
      return this;
    });
    __magic__.globalThis = __magic__; // eslint-disable-line no-undef
    delete Object.prototype.__magic__;
  })();

  var $Handlebars = globalThis.Handlebars;

  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (globalThis.Handlebars === Handlebars) {
      globalThis.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUNlLFVBQVMsVUFBVSxFQUFFOzs7QUFHbEMsR0FBQyxZQUFXO0FBQ1YsUUFBSSxPQUFPLFVBQVUsS0FBSyxRQUFRLEVBQUUsT0FBTztBQUMzQyxVQUFNLENBQUMsU0FBUyxDQUFDLGdCQUFnQixDQUFDLFdBQVcsRUFBRSxZQUFXO0FBQ3hELGFBQU8sSUFBSSxDQUFDO0tBQ2IsQ0FBQyxDQUFDO0FBQ0gsYUFBUyxDQUFDLFVBQVUsR0FBRyxTQUFTLENBQUM7QUFDakMsV0FBTyxNQUFNLENBQUMsU0FBUyxDQUFDLFNBQVMsQ0FBQztHQUNuQyxDQUFBLEVBQUcsQ0FBQzs7QUFFTCxNQUFNLFdBQVcsR0FBRyxVQUFVLENBQUMsVUFBVSxDQUFDOzs7QUFHMUMsWUFBVSxDQUFDLFVBQVUsR0FBRyxZQUFXO0FBQ2pDLFFBQUksVUFBVSxDQUFDLFVBQVUsS0FBSyxVQUFVLEVBQUU7QUFDeEMsZ0JBQVUsQ0FBQyxVQUFVLEdBQUcsV0FBVyxDQUFDO0tBQ3JDO0FBQ0QsV0FBTyxVQUFVLENBQUM7R0FDbkIsQ0FBQztDQUNIIiwiZmlsZSI6Im5vLWNvbmZsaWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIGdsb2JhbFRoaXMgKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKEhhbmRsZWJhcnMpIHtcbiAgLyogaXN0YW5idWwgaWdub3JlIG5leHQgKi9cbiAgLy8gaHR0cHM6Ly9tYXRoaWFzYnluZW5zLmJlL25vdGVzL2dsb2JhbHRoaXNcbiAgKGZ1bmN0aW9uKCkge1xuICAgIGlmICh0eXBlb2YgZ2xvYmFsVGhpcyA9PT0gJ29iamVjdCcpIHJldHVybjtcbiAgICBPYmplY3QucHJvdG90eXBlLl9fZGVmaW5lR2V0dGVyX18oJ19fbWFnaWNfXycsIGZ1bmN0aW9uKCkge1xuICAgICAgcmV0dXJuIHRoaXM7XG4gICAgfSk7XG4gICAgX19tYWdpY19fLmdsb2JhbFRoaXMgPSBfX21hZ2ljX187IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8tdW5kZWZcbiAgICBkZWxldGUgT2JqZWN0LnByb3RvdHlwZS5fX21hZ2ljX187XG4gIH0pKCk7XG5cbiAgY29uc3QgJEhhbmRsZWJhcnMgPSBnbG9iYWxUaGlzLkhhbmRsZWJhcnM7XG5cbiAgLyogaXN0YW5idWwgaWdub3JlIG5leHQgKi9cbiAgSGFuZGxlYmFycy5ub0NvbmZsaWN0ID0gZnVuY3Rpb24oKSB7XG4gICAgaWYgKGdsb2JhbFRoaXMuSGFuZGxlYmFycyA9PT0gSGFuZGxlYmFycykge1xuICAgICAgZ2xvYmFsVGhpcy5IYW5kbGViYXJzID0gJEhhbmRsZWJhcnM7XG4gICAgfVxuICAgIHJldHVybiBIYW5kbGViYXJzO1xuICB9O1xufVxuIl19


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-new */
// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

if (typeof window !== 'undefined') {
  try {
    new window.CustomEvent('test');
  } catch (e) {
    var CustomEvent = function CustomEvent(event, params) {
      var evt = null;

      var evtparams = params || {
        bubbles: false,
        cancelable: false,
        detail: null
      };

      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, evtparams.bubbles, evtparams.cancelable, evtparams.detail);
      return evt;
    };

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  name: 'Criteo',
  refresh: function refresh() {
    return null;
  },

  preAdSlotScript: function preAdSlotScript() {
    return '//lago criteo extensions\n    lago.criteoContent = \'\';\n    lago.setCriteoTargets = function () {\n      if (lago.criteoContent !== \'\') {\n        var crtg_split = lago.criteoContent.split(\';\');\n        for (var i=0;i<crtg_split.length;i++) { if (crtg_split[i] && crtg_split[i].split(\'=\').length > 1) { googletag.pubads().setTargeting (crtg_split[i].split(\'=\')[0], crtg_split[i].split(\'=\')[1]); } }\n      }\n    };\n';
  },

  pageTargetsScript: function pageTargetsScript() {
    return 'lago.setCriteoTargets();';
  },

  postRegistrationScript: function postRegistrationScript() {
    return '<!-- Begin Criteo Code -->\n<script type=\'text/javascript\'>\n    var crtg_nid = \'2396\';\n    var crtg_cookiename = \'cto_legacy\';\n    var crtg_varname = \'crtg_content\';\n    function crtg_getCookie(c_name) { var i, x, y, ARRCookies = document.cookie.split(\';\'); for (i = 0; i < ARRCookies.length; i++) { x = ARRCookies[i].substr(0, ARRCookies[i].indexOf(\'=\')); y = ARRCookies[i].substr(ARRCookies[i].indexOf(\'=\') + 1); x = x.replace(/^\\s+|\\s+$/g, \'\'); if (x == c_name) { return unescape(y); } } return \'\'; }\n    lago.criteoContent = crtg_getCookie(crtg_cookiename); var crtg_rnd = Math.floor(Math.random() * 99999999999);\n    var crtg_url = \'https://rtax.criteo.com/delivery/rta/rta.js?netId=\' + escape(crtg_nid); crtg_url += \'&cookieName=\' + escape(crtg_cookiename); crtg_url += \'&rnd=\' + crtg_rnd; crtg_url += \'&varName=\' + escape(crtg_varname);\n    var crtg_script = document.createElement(\'script\'); crtg_script.type = \'text/javascript\'; crtg_script.src = crtg_url; crtg_script.async = true;\n    if (document.getElementsByTagName(\'head\').length > 0) document.getElementsByTagName(\'head\')[0].appendChild(crtg_script); else if (document.getElementsByTagName(\'body\').length > 0) document.getElementsByTagName(\'body\')[0].appendChild(crtg_script);\n</script>\n<!-- End Criteo Code -->';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaultExtension = __webpack_require__(594);
var A9Extension = __webpack_require__(595);

module.exports = {
  name: 'Index-Exchange',
  refresh: function refresh() {
    return window.index_headertag_lightspeed ? function (adId) {
      var slot = adId ? [window.lago.getAdSlot(adId)] : null;

      var a9Refresh = A9Extension.refresh();

      a9Refresh(adId);

      window.index_headertag_lightspeed.add_session_end_hook(function () {
        window.googletag.cmd.push(function () {
          window.index_headertag_lightspeed.set_slot_targeting(slot);

          var googleRefresh = defaultExtension.refresh();

          googleRefresh(adId);
        });
      }, true);
      window.index_headertag_lightspeed.refresh();
    } : null;
  },

  displayAdUnit: function displayAdUnit(adId) {
    A9Extension.displayAdUnit(adId);

    window.googletag.cmd.push(function () {
      if (window.index_headertag_lightspeed) {
        window.index_headertag_lightspeed.display(adId);
      } else {
        window.googletag.display('' + adId);
      }
    });
  },

  postRegistrationScript: function postRegistrationScript() {
    var scriptUrl = 'https://js-sec.indexww.com/ht/ls-legacy.js';

    return '<!--Index Request-->\r\n<script src=\'' + scriptUrl + '\'></script>\r\n<!-- Index Request -->';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var rubiconAccountId = '10698';

module.exports = {
  name: 'Rubicon',

  refresh: function refresh() {
    return null;
  },

  preDfpScript: function preDfpScript() {
    return '<script type=\'text/javascript\' src=\'//ads.rubiconproject.com/header/' + rubiconAccountId + '.js\'></script>';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvUnViaWNvbkV4dGVuc2lvbi5qcyJdLCJuYW1lcyI6WyJydWJpY29uQWNjb3VudElkIiwibW9kdWxlIiwiZXhwb3J0cyIsIm5hbWUiLCJyZWZyZXNoIiwicHJlRGZwU2NyaXB0Il0sIm1hcHBpbmdzIjoiOztBQUFBLElBQU1BLG1CQUFtQixPQUF6Qjs7QUFFQUMsT0FBT0MsT0FBUCxHQUFpQjtBQUNmQyxRQUFNLFNBRFM7O0FBR2ZDLFdBQVMsbUJBQU07QUFDYixXQUFPLElBQVA7QUFDRCxHQUxjOztBQU9mQyxnQkFBYyx3QkFBTTtBQUNsQix1RkFBOEVMLGdCQUE5RTtBQUNEO0FBVGMsQ0FBakIiLCJmaWxlIjoiUnViaWNvbkV4dGVuc2lvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHJ1Ymljb25BY2NvdW50SWQgPSAnMTA2OTgnO1xuXG5tb2R1bGUuZXhwb3J0cyA9IHtcbiAgbmFtZTogJ1J1Ymljb24nLFxuXG4gIHJlZnJlc2g6ICgpID0+IHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfSxcblxuICBwcmVEZnBTY3JpcHQ6ICgpID0+IHtcbiAgICByZXR1cm4gYDxzY3JpcHQgdHlwZT0ndGV4dC9qYXZhc2NyaXB0JyBzcmM9Jy8vYWRzLnJ1Ymljb25wcm9qZWN0LmNvbS9oZWFkZXIvJHtydWJpY29uQWNjb3VudElkfS5qcyc+PC9zY3JpcHQ+YDtcbiAgfVxufTtcbiJdfQ==

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  name: 'Quantcast',
  refresh: function refresh() {
    return null;
  },

  preAdSlotScript: function preAdSlotScript() {
    return '//lago quantcast Extensions\n    lago.audienceSegments = [];\n    lago.quantcastResults = function(result){ for (var i = 0; i < result.segments.length; i++) { this.audienceSegments.push(result.segments[i].id); } };';
  },

  pageTargetsScript: function pageTargetsScript() {
    return '//Quantcast page Targets\n    if (lago.audienceSegments.length > 0) { googletag.pubads().setTargeting(\'quantcast\', lago.audienceSegments); }';
  },

  postRegistrationScript: function postRegistrationScript() {
    var apiKey = 'p-57OGVHgSOoedo';

    return '<!-- Start Quantcast tag (audience) -->\n    <script type=\'text/javascript\' src=\'https://pixel.quantserve.com/api/segments.json?a=' + apiKey + '&callback=lago.quantcastResults\'></script>\n<!-- End Quantcast tag (audience) -->';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvUXVhbnRjYXN0RXh0ZW5zaW9uLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJuYW1lIiwicmVmcmVzaCIsInByZUFkU2xvdFNjcmlwdCIsInBhZ2VUYXJnZXRzU2NyaXB0IiwicG9zdFJlZ2lzdHJhdGlvblNjcmlwdCIsImFwaUtleSJdLCJtYXBwaW5ncyI6Ijs7QUFBQUEsT0FBT0MsT0FBUCxHQUFpQjtBQUNmQyxRQUFNLFdBRFM7QUFFZkMsV0FBUyxtQkFBTTtBQUNiLFdBQU8sSUFBUDtBQUNELEdBSmM7O0FBTWZDLG1CQUFpQiwyQkFBTTtBQUNyQjtBQUdELEdBVmM7O0FBWWZDLHFCQUFtQiw2QkFBTTtBQUN2QjtBQUVELEdBZmM7O0FBaUJmQywwQkFBd0Isa0NBQU07QUFDNUIsUUFBTUMsU0FBUyxpQkFBZjs7QUFFQSxxSkFDdUZBLE1BRHZGO0FBR0Q7QUF2QmMsQ0FBakIiLCJmaWxlIjoiUXVhbnRjYXN0RXh0ZW5zaW9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsibW9kdWxlLmV4cG9ydHMgPSB7XG4gIG5hbWU6ICdRdWFudGNhc3QnLFxuICByZWZyZXNoOiAoKSA9PiB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH0sXG5cbiAgcHJlQWRTbG90U2NyaXB0OiAoKSA9PiB7XG4gICAgcmV0dXJuIGAvL2xhZ28gcXVhbnRjYXN0IEV4dGVuc2lvbnNcbiAgICBsYWdvLmF1ZGllbmNlU2VnbWVudHMgPSBbXTtcbiAgICBsYWdvLnF1YW50Y2FzdFJlc3VsdHMgPSBmdW5jdGlvbihyZXN1bHQpeyBmb3IgKHZhciBpID0gMDsgaSA8IHJlc3VsdC5zZWdtZW50cy5sZW5ndGg7IGkrKykgeyB0aGlzLmF1ZGllbmNlU2VnbWVudHMucHVzaChyZXN1bHQuc2VnbWVudHNbaV0uaWQpOyB9IH07YDtcbiAgfSxcblxuICBwYWdlVGFyZ2V0c1NjcmlwdDogKCkgPT4ge1xuICAgIHJldHVybiBgLy9RdWFudGNhc3QgcGFnZSBUYXJnZXRzXG4gICAgaWYgKGxhZ28uYXVkaWVuY2VTZWdtZW50cy5sZW5ndGggPiAwKSB7IGdvb2dsZXRhZy5wdWJhZHMoKS5zZXRUYXJnZXRpbmcoJ3F1YW50Y2FzdCcsIGxhZ28uYXVkaWVuY2VTZWdtZW50cyk7IH1gO1xuICB9LFxuXG4gIHBvc3RSZWdpc3RyYXRpb25TY3JpcHQ6ICgpID0+IHtcbiAgICBjb25zdCBhcGlLZXkgPSAncC01N09HVkhnU09vZWRvJztcblxuICAgIHJldHVybiBgPCEtLSBTdGFydCBRdWFudGNhc3QgdGFnIChhdWRpZW5jZSkgLS0+XG4gICAgPHNjcmlwdCB0eXBlPSd0ZXh0L2phdmFzY3JpcHQnIHNyYz0naHR0cHM6Ly9waXhlbC5xdWFudHNlcnZlLmNvbS9hcGkvc2VnbWVudHMuanNvbj9hPSR7YXBpS2V5fSZjYWxsYmFjaz1sYWdvLnF1YW50Y2FzdFJlc3VsdHMnPjwvc2NyaXB0PlxuPCEtLSBFbmQgUXVhbnRjYXN0IHRhZyAoYXVkaWVuY2UpIC0tPmA7XG4gIH1cbn07XG4iXX0=

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  name: 'InstartLogic',
  refresh: function refresh() {
    return null;
  },

  pageTargetsScript: function pageTargetsScript() {
    return '//InstartLogic Page Targets\n    if (window.I11C != undefined && I11C.Morph == 1) { googletag.pubads().setTargeting(\'shield\', \'1\'); }';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvSW5zdGFydExvZ2ljRXh0ZW5zaW9uLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJuYW1lIiwicmVmcmVzaCIsInBhZ2VUYXJnZXRzU2NyaXB0Il0sIm1hcHBpbmdzIjoiOztBQUFBQSxPQUFPQyxPQUFQLEdBQWlCO0FBQ2ZDLFFBQU0sY0FEUztBQUVmQyxXQUFTLG1CQUFNO0FBQ2IsV0FBTyxJQUFQO0FBQ0QsR0FKYzs7QUFNZkMscUJBQW1CLDZCQUFNO0FBQ3ZCO0FBRUQ7QUFUYyxDQUFqQiIsImZpbGUiOiJJbnN0YXJ0TG9naWNFeHRlbnNpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJtb2R1bGUuZXhwb3J0cyA9IHtcbiAgbmFtZTogJ0luc3RhcnRMb2dpYycsXG4gIHJlZnJlc2g6ICgpID0+IHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfSxcblxuICBwYWdlVGFyZ2V0c1NjcmlwdDogKCkgPT4ge1xuICAgIHJldHVybiBgLy9JbnN0YXJ0TG9naWMgUGFnZSBUYXJnZXRzXG4gICAgaWYgKHdpbmRvdy5JMTFDICE9IHVuZGVmaW5lZCAmJiBJMTFDLk1vcnBoID09IDEpIHsgZ29vZ2xldGFnLnB1YmFkcygpLnNldFRhcmdldGluZygnc2hpZWxkJywgJzEnKTsgfWA7XG4gIH1cbn07XG4iXX0=

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  name: 'AdLightning',
  refresh: function refresh() {
    return null;
  },

  adBlockingScript: function adBlockingScript() {
    var script = 'https://tagan.adlightning.com/legacy/op.js';

    return '<!--AdLightning Request--><script type="text/javascript">var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);if(isMobile && window.googletag){!function(e,t,r){function n(){for(;d[0]&&"loaded"==d[0][f];)c=d.shift(),c[o]=!i.parentNode.insertBefore(c,i)}for(var s,a,c,d=[],i=e.scripts[0],o="onreadystatechange",f="readyState";s=r.shift();)a=e.createElement(t),"async"in i?(a.async=!1,e.head.appendChild(a)):i[f]?(d.push(a),a[o]=n):e.write("<"+t+\' src="\'+s+\'" defer></\'+t+">"),a.src=s}(document,"script",[\'' + script + '\'])}</script>\r\n<!--AdLightning Request-->';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvQWRMaWdodG5pbmdFeHRlbnNpb24uanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsIm5hbWUiLCJyZWZyZXNoIiwiYWRCbG9ja2luZ1NjcmlwdCIsInNjcmlwdCJdLCJtYXBwaW5ncyI6Ijs7QUFBQUEsT0FBT0MsT0FBUCxHQUFpQjtBQUNmQyxRQUFNLGFBRFM7QUFFZkMsV0FBUyxtQkFBTTtBQUNiLFdBQU8sSUFBUDtBQUNELEdBSmM7O0FBTWZDLG9CQUFrQiw0QkFBTTtBQUN0QixRQUFNQyxTQUFTLDRDQUFmOztBQUVBLDRoQkFBaWhCQSxNQUFqaEI7QUFDRDtBQVZjLENBQWpCIiwiZmlsZSI6IkFkTGlnaHRuaW5nRXh0ZW5zaW9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsibW9kdWxlLmV4cG9ydHMgPSB7XG4gIG5hbWU6ICdBZExpZ2h0bmluZycsXG4gIHJlZnJlc2g6ICgpID0+IHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfSxcblxuICBhZEJsb2NraW5nU2NyaXB0OiAoKSA9PiB7XG4gICAgY29uc3Qgc2NyaXB0ID0gJ2h0dHBzOi8vdGFnYW4uYWRsaWdodG5pbmcuY29tL2xlZ2FjeS9vcC5qcyc7XG5cbiAgICByZXR1cm4gYDwhLS1BZExpZ2h0bmluZyBSZXF1ZXN0LS0+PHNjcmlwdCB0eXBlPVwidGV4dC9qYXZhc2NyaXB0XCI+dmFyIGlzTW9iaWxlID0gL2lQaG9uZXxpUGFkfGlQb2R8QW5kcm9pZC9pLnRlc3QobmF2aWdhdG9yLnVzZXJBZ2VudCk7aWYoaXNNb2JpbGUgJiYgd2luZG93Lmdvb2dsZXRhZyl7IWZ1bmN0aW9uKGUsdCxyKXtmdW5jdGlvbiBuKCl7Zm9yKDtkWzBdJiZcImxvYWRlZFwiPT1kWzBdW2ZdOyljPWQuc2hpZnQoKSxjW29dPSFpLnBhcmVudE5vZGUuaW5zZXJ0QmVmb3JlKGMsaSl9Zm9yKHZhciBzLGEsYyxkPVtdLGk9ZS5zY3JpcHRzWzBdLG89XCJvbnJlYWR5c3RhdGVjaGFuZ2VcIixmPVwicmVhZHlTdGF0ZVwiO3M9ci5zaGlmdCgpOylhPWUuY3JlYXRlRWxlbWVudCh0KSxcImFzeW5jXCJpbiBpPyhhLmFzeW5jPSExLGUuaGVhZC5hcHBlbmRDaGlsZChhKSk6aVtmXT8oZC5wdXNoKGEpLGFbb109bik6ZS53cml0ZShcIjxcIit0Kycgc3JjPVwiJytzKydcIiBkZWZlcj48LycrdCtcIj5cIiksYS5zcmM9c30oZG9jdW1lbnQsXCJzY3JpcHRcIixbJyR7c2NyaXB0fSddKX08L3NjcmlwdD5cXHJcXG48IS0tQWRMaWdodG5pbmcgUmVxdWVzdC0tPmA7XG4gIH1cbn07XG4iXX0=

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaultExtension = __webpack_require__(242);
var A9Extension = __webpack_require__(596);
var FAILSAFE_TIMEOUT = 2000;
var a9RefreshSlot;
var prebidSlot;
var bidarray = [];
var bidCountPrebid = 0;

module.exports = {
  name: 'Prebid',

  bidHandler: function bidhandler() {
    var requestManager = {
      adserverRequestSent: false,
      aps: false,
      prebid: false
    };

    // when both APS and Prebid have returned, initiate ad request
    function biddersBack() {
      if (requestManager.aps && requestManager.prebid) {
        sendAdserverRequest();
      }
      return;
    }

    // sends adserver request
    function sendAdserverRequest() {
      if (requestManager.adserverRequestSent === true) {
        return;
      }
      requestManager.adserverRequestSent = true;

      var adId = bidarray.shift();
      var slot = adId ? [window.lago.getAdSlot(adId)] : null;

      // both a call to displayAdUnit and .refresh are needed
      // when using disableInitialLoad()
      defaultExtension.displayAdUnit(adId);

      googletag.cmd.push(function () {
        googletag.pubads().refresh(slot);
      });
    }

    // sends bid request to APS and Prebid
    function requestHeaderBids() {
      // APS request
      if (a9RefreshSlot !== undefined) {
        apstag.fetchBids({
          slots: a9RefreshSlot
        }, function (bids) {
          googletag.cmd.push(function () {
            apstag.setDisplayBids();
            requestManager.aps = true; // signals that APS request has completed
            biddersBack(); // checks whether both APS and Prebid have returned
          });
        });
      } else {
        requestManager.aps = true;
      }

      if (prebidSlot !== undefined) {
        // put prebid request here for individual slot
        pbjs.que.push(function () {
          pbjs.rp.requestBids({
            gptSlotObjects: prebidSlot,
            callback: function callback() {
              googletag.cmd.push(function () {
                requestManager.prebid = true; // signals that Prebid request has completed
                biddersBack(); // checks whether both APS and Prebid have returned
              });
            }
          });
        });
      } else if (prebidSlot === undefined && bidCountPrebid === 1) {
        // put prebid request here for batch request and call only once
        bidCountPrebid++;
        pbjs.que.push(function () {
          pbjs.rp.requestBids({
            callback: function callback() {
              googletag.cmd.push(function () {
                requestManager.prebid = true; // signals that Prebid request has completed
                biddersBack(); // checks whether both APS and Prebid have returned
              });
            }
          });
        });
      } else {
        requestManager.prebid = true;
      }
    }

    // initiate bid request
    requestHeaderBids();

    // set failsafe timeout
    window.setTimeout(function () {
      sendAdserverRequest();
    }, FAILSAFE_TIMEOUT);
  },

  refresh: function refresh(bidCallback) {
    return window.pbjs && window.apstag ? function (adId) {
      prebidSlot = adId ? [window.lago.getAdSlot(adId)] : null;
      window.lago.a9Slots = A9Extension.buildA9SlotsFromGPT(window.lago.slots);
      a9RefreshSlot = window.lago.a9Slots.filter(function (adSlot) {
        return adSlot.slotID === adId;
      });
      bidarray.push(adId);
      defaultExtension.bidHandlerCallback(module.exports.bidHandler);
    } : null;
  },

  preAdSlotScript: function preAdSlotScript() {
    return '//lago Prebid Extensions\n    var pbjs = pbjs || {};\n    pbjs.que = pbjs.que || [];';
  },

  enableServicesScript: function enableServicesScript() {
    return '<script>var googletag = googletag || {};\n    googletag.cmd = googletag.cmd || [];\n    googletag.cmd.push(function () {\n      // initialize\n      googletag.pubads().enableAsyncRendering();\n      googletag.pubads().disableInitialLoad();\n      googletag.enableServices();\n    });</script>';
  },

  postRegistrationScript: function postRegistrationScript() {
    return module.exports.buildPrebidScript();
  },

  buildPrebidScript: function buildPrebidScript() {
    var scriptUrl = 'https://ads.rubiconproject.com/prebid/10698.js';
    return '<!--Prebid Request-->\r\n\r\n<script src=\'' + scriptUrl + '\'></script>\r\n\r\n<!--Prebid Request-->';
  },

  displayAdUnit: function displayAdUnit(adId, postPageLoad) {
    var id = setInterval(function () {
      if (window.lago.slots.length == 0) {
        // do nothing until slots is populated
      } else {
        clearInterval(id);
        if (window.pbjs && window.apstag) {
          if (postPageLoad) {
            prebidSlot = adId ? [window.lago.getAdSlot(adId)] : null;
            window.lago.a9Slots = A9Extension.buildA9SlotsFromGPT(window.lago.slots);
            a9RefreshSlot = window.lago.a9Slots.filter(function (adSlot) {
              return adSlot.slotID === adId;
            });
          }
          bidCountPrebid++;
          bidarray.push(adId);
          defaultExtension.bidHandlerCallback(module.exports.bidHandler);
        }
      }
    }, 100);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '{{#each EndPageScripts}}{{{this}}}{{/each}}';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL1RlbXBsYXRlcy9lbmRQYWdlUmVnaXN0cmF0aW9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUFlLDZDIiwiZmlsZSI6ImVuZFBhZ2VSZWdpc3RyYXRpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCAne3sjZWFjaCBFbmRQYWdlU2NyaXB0c319e3t7dGhpc319fXt7L2VhY2h9fSc7XG4iXX0=

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  name: 'Index-Exchange',
  refresh: function refresh() {
    return null;
  },

  postRegistrationScript: function postRegistrationScript() {
    var scriptUrl = 'https://js-sec.indexww.com/ht/ls-legacy.js';

    return '<!--Index_beta Request-->\r\n<script async src=\'' + scriptUrl + '\'></script>\r\n<!-- Index Request -->';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvSW5kZXhFeGNoYW5nZUV4dGVuc2lvbl9iZXRhLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJuYW1lIiwicmVmcmVzaCIsInBvc3RSZWdpc3RyYXRpb25TY3JpcHQiLCJzY3JpcHRVcmwiXSwibWFwcGluZ3MiOiI7O0FBQUFBLE9BQU9DLE9BQVAsR0FBaUI7QUFDZkMsUUFBTSxnQkFEUztBQUVmQyxXQUFTLG1CQUFNO0FBQ2IsV0FBTyxJQUFQO0FBQ0QsR0FKYzs7QUFNZkMsMEJBQXdCLGtDQUFNO0FBQzVCLFFBQU1DLFlBQVksNENBQWxCOztBQUVBLGlFQUEwREEsU0FBMUQ7QUFDRDtBQVZjLENBQWpCIiwiZmlsZSI6IkluZGV4RXhjaGFuZ2VFeHRlbnNpb25fYmV0YS5qcyIsInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0ge1xuICBuYW1lOiAnSW5kZXgtRXhjaGFuZ2UnLFxuICByZWZyZXNoOiAoKSA9PiB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH0sXG5cbiAgcG9zdFJlZ2lzdHJhdGlvblNjcmlwdDogKCkgPT4ge1xuICAgIGNvbnN0IHNjcmlwdFVybCA9ICdodHRwczovL2pzLXNlYy5pbmRleHd3LmNvbS9odC9scy1sZWdhY3kuanMnO1xuXG4gICAgcmV0dXJuIGA8IS0tSW5kZXhfYmV0YSBSZXF1ZXN0LS0+XFxyXFxuPHNjcmlwdCBhc3luYyBzcmM9JyR7c2NyaXB0VXJsfSc+PC9zY3JpcHQ+XFxyXFxuPCEtLSBJbmRleCBSZXF1ZXN0IC0tPmA7XG4gIH1cbn07XG4iXX0=

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Lee Account Id
var accountId = '3266';
var defaultExtension = __webpack_require__(242);

module.exports = {
  name: 'A9',

  bidHandler: function bidHandler() {
    window.apstag.setDisplayBids();
  },

  refresh: function refresh(bidCallback) {
    return window.apstag ? function (adId) {
      window.lago.a9Slots = module.exports.buildA9SlotsFromGPT(window.lago.slots);
      var slot = adId ? [window.lago.getAdSlot(adId)] : null;
      var a9RefreshSlot = window.lago.a9Slots.filter(function (adSlot) {
        return adSlot.slotID === adId;
      });

      window.apstag.fetchBids({
        slots: a9RefreshSlot
      }, function (bids) {
        if (bidCallback && typeof bidCallback === 'function') {
          bidCallback(module.exports.bidHandler, slot);
        } else {
          defaultExtension.bidHandlerRefreshCallback(module.exports.bidHandler, slot);
        }
      });
    } : null;
  },

  postRegistrationScript: function postRegistrationScript(adSlots) {
    return module.exports.buildA9Script(adSlots);
  },

  buildA9Slots: function buildA9Slots() {
    var adSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return adSlots.map(function (slot) {
      return { slotID: slot.containerId, sizes: JSON.parse(slot.adSizes), slotName: slot.adAlias };
    });
  },

  buildA9SlotsFromGPT: function buildA9SlotsFromGPT() {
    var gptSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return gptSlots.map(function (slot) {
      return { slotID: slot.key, sizes: module.exports.gptSlotSizeToArray(slot), slotName: slot.slot.getAdUnitPath() };
    });
  },

  gptSlotSizeToArray: function gptSlotSizeToArray(gptSlot) {
    return gptSlot.slot.getSizes().map(function (slot) {
      var keys = Object.keys(slot);

      return [slot[keys[0]], slot[keys[1]]];
    });
  },

  buildA9Script: function buildA9Script(adSlots) {
    var a9Slots = module.exports.buildA9Slots(adSlots);

    return '<!--PartnerA9 Request-->\r\n<script>!function(a9,a,p,s,t,A,g){if(a[a9])return;function q(c,r){a[a9]._Q.push([c,r])}a[a9]={init:function(){q("i",arguments)},fetchBids:function()\n{q("f",arguments)},setDisplayBids:function(){},_Q:[]};A=p.createElement(s);A.async=!0;A.src=t;g=p.getElementsByTagName(s)[0];g.parentNode.insertBefore(\nA,g)}("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");\n  apstag.init({\n    pubID: \'' + accountId + '\',\n    adServer: \'googletag\',\n    timeout: 2e3\n  });\n  apstag.fetchBids({\n    slots: ' + JSON.stringify(a9Slots) + '\n  }, function(bids) {\n    window.googletag.cmd.push(function(){\n      apstag.setDisplayBids();\n    });\n  });\n</script>\r\n<!--PartnerA9 Request-->';
  },

  displayAdUnit: function displayAdUnit(adId, postPageLoad) {
    if (postPageLoad && window.apstag) {
      window.lago.a9Slots = module.exports.buildA9SlotsFromGPT(window.lago.slots);
      var a9RefreshSlot = window.lago.a9Slots.filter(function (adSlot) {
        return adSlot.slotID === adId;
      });

      window.apstag.fetchBids({
        slots: a9RefreshSlot
      }, function (bids) {
        defaultExtension.bidHandlerCallback(module.exports.bidHandler);
      });
    }
    defaultExtension.displayAdUnit(adId);
  }

};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvUGFydG5lckE5RXh0ZW5zaW9uLmpzIl0sIm5hbWVzIjpbImFjY291bnRJZCIsImRlZmF1bHRFeHRlbnNpb24iLCJyZXF1aXJlIiwibW9kdWxlIiwiZXhwb3J0cyIsIm5hbWUiLCJiaWRIYW5kbGVyIiwid2luZG93IiwiYXBzdGFnIiwic2V0RGlzcGxheUJpZHMiLCJyZWZyZXNoIiwibGFnbyIsImE5U2xvdHMiLCJidWlsZEE5U2xvdHNGcm9tR1BUIiwic2xvdHMiLCJzbG90IiwiYWRJZCIsImdldEFkU2xvdCIsImE5UmVmcmVzaFNsb3QiLCJmaWx0ZXIiLCJhZFNsb3QiLCJzbG90SUQiLCJmZXRjaEJpZHMiLCJiaWRzIiwiYmlkQ2FsbGJhY2siLCJiaWRIYW5kbGVyUmVmcmVzaENhbGxiYWNrIiwicG9zdFJlZ2lzdHJhdGlvblNjcmlwdCIsImJ1aWxkQTlTY3JpcHQiLCJhZFNsb3RzIiwiYnVpbGRBOVNsb3RzIiwibWFwIiwiY29udGFpbmVySWQiLCJzaXplcyIsIkpTT04iLCJwYXJzZSIsImFkU2l6ZXMiLCJzbG90TmFtZSIsImFkQWxpYXMiLCJncHRTbG90cyIsImtleSIsImdwdFNsb3RTaXplVG9BcnJheSIsImdldEFkVW5pdFBhdGgiLCJncHRTbG90IiwiZ2V0U2l6ZXMiLCJrZXlzIiwiT2JqZWN0Iiwic3RyaW5naWZ5IiwiZGlzcGxheUFkVW5pdCIsInBvc3RQYWdlTG9hZCIsImJpZEhhbmRsZXJDYWxsYmFjayJdLCJtYXBwaW5ncyI6Ijs7QUFBQTtBQUNBLElBQU1BLFlBQVksTUFBbEI7QUFDQSxJQUFNQyxtQkFBbUJDLFFBQVEseUJBQVIsQ0FBekI7O0FBRUFDLE9BQU9DLE9BQVAsR0FBaUI7QUFDZkMsUUFBTSxJQURTOztBQUdmQyxjQUFZLHNCQUFNO0FBQ2hCQyxXQUFPQyxNQUFQLENBQWNDLGNBQWQ7QUFDRCxHQUxjOztBQU9mQyxXQUFTLDhCQUFlO0FBQ3RCLFdBQVNILE9BQU9DLE1BQVIsR0FDTixnQkFBUTtBQUNORCxhQUFPSSxJQUFQLENBQVlDLE9BQVosR0FBc0JULE9BQU9DLE9BQVAsQ0FBZVMsbUJBQWYsQ0FBbUNOLE9BQU9JLElBQVAsQ0FBWUcsS0FBL0MsQ0FBdEI7QUFDQSxVQUFNQyxPQUFRQyxJQUFELEdBQVMsQ0FBQ1QsT0FBT0ksSUFBUCxDQUFZTSxTQUFaLENBQXNCRCxJQUF0QixDQUFELENBQVQsR0FBeUMsSUFBdEQ7QUFDQSxVQUFNRSxnQkFBZ0JYLE9BQU9JLElBQVAsQ0FBWUMsT0FBWixDQUFvQk8sTUFBcEIsQ0FBMkIsa0JBQVU7QUFBRSxlQUFPQyxPQUFPQyxNQUFQLEtBQWtCTCxJQUF6QjtBQUFnQyxPQUF2RSxDQUF0Qjs7QUFFQVQsYUFBT0MsTUFBUCxDQUFjYyxTQUFkLENBQXdCO0FBQ3RCUixlQUFPSTtBQURlLE9BQXhCLEVBRUcsVUFBQ0ssSUFBRCxFQUFVO0FBQ1gsWUFBSUMsZUFBZSxPQUFPQSxXQUFQLEtBQXVCLFVBQTFDLEVBQXNEO0FBQ3BEQSxzQkFBWXJCLE9BQU9DLE9BQVAsQ0FBZUUsVUFBM0IsRUFBdUNTLElBQXZDO0FBQ0QsU0FGRCxNQUVPO0FBQ0xkLDJCQUFpQndCLHlCQUFqQixDQUEyQ3RCLE9BQU9DLE9BQVAsQ0FBZUUsVUFBMUQsRUFBc0VTLElBQXRFO0FBQ0Q7QUFDRixPQVJEO0FBU0QsS0FmSyxHQWVGLElBZk47QUFnQkQsR0F4QmM7O0FBMEJmVywwQkFBd0IseUNBQVc7QUFDakMsV0FBT3ZCLE9BQU9DLE9BQVAsQ0FBZXVCLGFBQWYsQ0FBNkJDLE9BQTdCLENBQVA7QUFDRCxHQTVCYzs7QUE4QmZDLGdCQUFjLHdCQUFrQjtBQUFBLFFBQWpCRCxPQUFpQix1RUFBUCxFQUFPOztBQUM5QixXQUFPQSxRQUFRRSxHQUFSLENBQVksZ0JBQVE7QUFDekIsYUFBTyxFQUFDVCxRQUFRTixLQUFLZ0IsV0FBZCxFQUEyQkMsT0FBT0MsS0FBS0MsS0FBTCxDQUFXbkIsS0FBS29CLE9BQWhCLENBQWxDLEVBQTREQyxVQUFVckIsS0FBS3NCLE9BQTNFLEVBQVA7QUFDRCxLQUZNLENBQVA7QUFHRCxHQWxDYzs7QUFvQ2Z4Qix1QkFBcUIsK0JBQW1CO0FBQUEsUUFBbEJ5QixRQUFrQix1RUFBUCxFQUFPOztBQUN0QyxXQUFPQSxTQUFTUixHQUFULENBQWEsZ0JBQVE7QUFDMUIsYUFBTyxFQUFDVCxRQUFRTixLQUFLd0IsR0FBZCxFQUFtQlAsT0FBTzdCLE9BQU9DLE9BQVAsQ0FBZW9DLGtCQUFmLENBQWtDekIsSUFBbEMsQ0FBMUIsRUFBbUVxQixVQUFVckIsS0FBS0EsSUFBTCxDQUFVMEIsYUFBVixFQUE3RSxFQUFQO0FBQ0QsS0FGTSxDQUFQO0FBR0QsR0F4Q2M7O0FBMENmRCxzQkFBb0IscUNBQVc7QUFDN0IsV0FBT0UsUUFBUTNCLElBQVIsQ0FBYTRCLFFBQWIsR0FBd0JiLEdBQXhCLENBQTRCLGdCQUFRO0FBQ3pDLFVBQU1jLE9BQU9DLE9BQU9ELElBQVAsQ0FBWTdCLElBQVosQ0FBYjs7QUFFQSxhQUFPLENBQUNBLEtBQUs2QixLQUFLLENBQUwsQ0FBTCxDQUFELEVBQWdCN0IsS0FBSzZCLEtBQUssQ0FBTCxDQUFMLENBQWhCLENBQVA7QUFDRCxLQUpNLENBQVA7QUFLRCxHQWhEYzs7QUFrRGZqQixpQkFBZSxnQ0FBVztBQUN4QixRQUFNZixVQUFVVCxPQUFPQyxPQUFQLENBQWV5QixZQUFmLENBQTRCRCxPQUE1QixDQUFoQjs7QUFFQSw2Y0FJVTVCLFNBSlYscUdBU1NpQyxLQUFLYSxTQUFMLENBQWVsQyxPQUFmLENBVFQ7QUFnQkQsR0FyRWM7O0FBdUVmbUMsaUJBQWUsdUJBQUMvQixJQUFELEVBQU9nQyxZQUFQLEVBQXdCO0FBQ3JDLFFBQUlBLGdCQUFnQnpDLE9BQU9DLE1BQTNCLEVBQW1DO0FBQ2pDRCxhQUFPSSxJQUFQLENBQVlDLE9BQVosR0FBc0JULE9BQU9DLE9BQVAsQ0FBZVMsbUJBQWYsQ0FBbUNOLE9BQU9JLElBQVAsQ0FBWUcsS0FBL0MsQ0FBdEI7QUFDQSxVQUFNSSxnQkFBZ0JYLE9BQU9JLElBQVAsQ0FBWUMsT0FBWixDQUFvQk8sTUFBcEIsQ0FBMkIsa0JBQVU7QUFBRSxlQUFPQyxPQUFPQyxNQUFQLEtBQWtCTCxJQUF6QjtBQUFnQyxPQUF2RSxDQUF0Qjs7QUFFQVQsYUFBT0MsTUFBUCxDQUFjYyxTQUFkLENBQXdCO0FBQ3RCUixlQUFPSTtBQURlLE9BQXhCLEVBRUcsVUFBQ0ssSUFBRCxFQUFVO0FBQ1h0Qix5QkFBaUJnRCxrQkFBakIsQ0FBb0M5QyxPQUFPQyxPQUFQLENBQWVFLFVBQW5EO0FBQ0QsT0FKRDtBQUtEO0FBQ0RMLHFCQUFpQjhDLGFBQWpCLENBQStCL0IsSUFBL0I7QUFDRDs7QUFuRmMsQ0FBakIiLCJmaWxlIjoiUGFydG5lckE5RXh0ZW5zaW9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy9MZWUgQWNjb3VudCBJZFxuY29uc3QgYWNjb3VudElkID0gJzMyNjYnO1xuY29uc3QgZGVmYXVsdEV4dGVuc2lvbiA9IHJlcXVpcmUoJy4vRGVmYXVsdEV4dGVuc2lvbl9iZXRhJyk7XG5cbm1vZHVsZS5leHBvcnRzID0ge1xuICBuYW1lOiAnQTknLFxuXG4gIGJpZEhhbmRsZXI6ICgpID0+IHtcbiAgICB3aW5kb3cuYXBzdGFnLnNldERpc3BsYXlCaWRzKCk7XG4gIH0sXG5cbiAgcmVmcmVzaDogYmlkQ2FsbGJhY2sgPT4ge1xuICAgIHJldHVybiAoKHdpbmRvdy5hcHN0YWcpID9cbiAgICAgIGFkSWQgPT4ge1xuICAgICAgICB3aW5kb3cubGFnby5hOVNsb3RzID0gbW9kdWxlLmV4cG9ydHMuYnVpbGRBOVNsb3RzRnJvbUdQVCh3aW5kb3cubGFnby5zbG90cyk7XG4gICAgICAgIGNvbnN0IHNsb3QgPSAoYWRJZCkgPyBbd2luZG93LmxhZ28uZ2V0QWRTbG90KGFkSWQpXSA6IG51bGw7XG4gICAgICAgIGNvbnN0IGE5UmVmcmVzaFNsb3QgPSB3aW5kb3cubGFnby5hOVNsb3RzLmZpbHRlcihhZFNsb3QgPT4geyByZXR1cm4gYWRTbG90LnNsb3RJRCA9PT0gYWRJZDsgfSk7XG5cbiAgICAgICAgd2luZG93LmFwc3RhZy5mZXRjaEJpZHMoe1xuICAgICAgICAgIHNsb3RzOiBhOVJlZnJlc2hTbG90XG4gICAgICAgIH0sIChiaWRzKSA9PiB7XG4gICAgICAgICAgaWYgKGJpZENhbGxiYWNrICYmIHR5cGVvZiBiaWRDYWxsYmFjayA9PT0gJ2Z1bmN0aW9uJykge1xuICAgICAgICAgICAgYmlkQ2FsbGJhY2sobW9kdWxlLmV4cG9ydHMuYmlkSGFuZGxlciwgc2xvdCk7XG4gICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgIGRlZmF1bHRFeHRlbnNpb24uYmlkSGFuZGxlclJlZnJlc2hDYWxsYmFjayhtb2R1bGUuZXhwb3J0cy5iaWRIYW5kbGVyLCBzbG90KTtcbiAgICAgICAgICB9XG4gICAgICAgIH0pO1xuICAgICAgfSA6IG51bGwpO1xuICB9LFxuXG4gIHBvc3RSZWdpc3RyYXRpb25TY3JpcHQ6IGFkU2xvdHMgPT4ge1xuICAgIHJldHVybiBtb2R1bGUuZXhwb3J0cy5idWlsZEE5U2NyaXB0KGFkU2xvdHMpO1xuICB9LFxuXG4gIGJ1aWxkQTlTbG90czogKGFkU2xvdHMgPSBbXSkgPT4ge1xuICAgIHJldHVybiBhZFNsb3RzLm1hcChzbG90ID0+IHtcbiAgICAgIHJldHVybiB7c2xvdElEOiBzbG90LmNvbnRhaW5lcklkLCBzaXplczogSlNPTi5wYXJzZShzbG90LmFkU2l6ZXMpLCBzbG90TmFtZTogc2xvdC5hZEFsaWFzfTtcbiAgICB9KTtcbiAgfSxcblxuICBidWlsZEE5U2xvdHNGcm9tR1BUOiAoZ3B0U2xvdHMgPSBbXSkgPT4ge1xuICAgIHJldHVybiBncHRTbG90cy5tYXAoc2xvdCA9PiB7XG4gICAgICByZXR1cm4ge3Nsb3RJRDogc2xvdC5rZXksIHNpemVzOiBtb2R1bGUuZXhwb3J0cy5ncHRTbG90U2l6ZVRvQXJyYXkoc2xvdCksIHNsb3ROYW1lOiBzbG90LnNsb3QuZ2V0QWRVbml0UGF0aCgpfTtcbiAgICB9KTtcbiAgfSxcblxuICBncHRTbG90U2l6ZVRvQXJyYXk6IGdwdFNsb3QgPT4ge1xuICAgIHJldHVybiBncHRTbG90LnNsb3QuZ2V0U2l6ZXMoKS5tYXAoc2xvdCA9PiB7XG4gICAgICBjb25zdCBrZXlzID0gT2JqZWN0LmtleXMoc2xvdCk7XG5cbiAgICAgIHJldHVybiBbc2xvdFtrZXlzWzBdXSwgc2xvdFtrZXlzWzFdXV07XG4gICAgfSk7XG4gIH0sXG5cbiAgYnVpbGRBOVNjcmlwdDogYWRTbG90cyA9PiB7XG4gICAgY29uc3QgYTlTbG90cyA9IG1vZHVsZS5leHBvcnRzLmJ1aWxkQTlTbG90cyhhZFNsb3RzKTtcblxuICAgIHJldHVybiBgPCEtLVBhcnRuZXJBOSBSZXF1ZXN0LS0+XFxyXFxuPHNjcmlwdD4hZnVuY3Rpb24oYTksYSxwLHMsdCxBLGcpe2lmKGFbYTldKXJldHVybjtmdW5jdGlvbiBxKGMscil7YVthOV0uX1EucHVzaChbYyxyXSl9YVthOV09e2luaXQ6ZnVuY3Rpb24oKXtxKFwiaVwiLGFyZ3VtZW50cyl9LGZldGNoQmlkczpmdW5jdGlvbigpXG57cShcImZcIixhcmd1bWVudHMpfSxzZXREaXNwbGF5QmlkczpmdW5jdGlvbigpe30sX1E6W119O0E9cC5jcmVhdGVFbGVtZW50KHMpO0EuYXN5bmM9ITA7QS5zcmM9dDtnPXAuZ2V0RWxlbWVudHNCeVRhZ05hbWUocylbMF07Zy5wYXJlbnROb2RlLmluc2VydEJlZm9yZShcbkEsZyl9KFwiYXBzdGFnXCIsd2luZG93LGRvY3VtZW50LFwic2NyaXB0XCIsXCIvL2MuYW1hem9uLWFkc3lzdGVtLmNvbS9hYXgyL2Fwc3RhZy5qc1wiKTtcbiAgYXBzdGFnLmluaXQoe1xuICAgIHB1YklEOiAnJHthY2NvdW50SWR9JyxcbiAgICBhZFNlcnZlcjogJ2dvb2dsZXRhZycsXG4gICAgdGltZW91dDogMmUzXG4gIH0pO1xuICBhcHN0YWcuZmV0Y2hCaWRzKHtcbiAgICBzbG90czogJHtKU09OLnN0cmluZ2lmeShhOVNsb3RzKX1cbiAgfSwgZnVuY3Rpb24oYmlkcykge1xuICAgIHdpbmRvdy5nb29nbGV0YWcuY21kLnB1c2goZnVuY3Rpb24oKXtcbiAgICAgIGFwc3RhZy5zZXREaXNwbGF5QmlkcygpO1xuICAgIH0pO1xuICB9KTtcbjwvc2NyaXB0PlxcclxcbjwhLS1QYXJ0bmVyQTkgUmVxdWVzdC0tPmA7XG4gIH0sXG5cbiAgZGlzcGxheUFkVW5pdDogKGFkSWQsIHBvc3RQYWdlTG9hZCkgPT4ge1xuICAgIGlmIChwb3N0UGFnZUxvYWQgJiYgd2luZG93LmFwc3RhZykge1xuICAgICAgd2luZG93LmxhZ28uYTlTbG90cyA9IG1vZHVsZS5leHBvcnRzLmJ1aWxkQTlTbG90c0Zyb21HUFQod2luZG93LmxhZ28uc2xvdHMpO1xuICAgICAgY29uc3QgYTlSZWZyZXNoU2xvdCA9IHdpbmRvdy5sYWdvLmE5U2xvdHMuZmlsdGVyKGFkU2xvdCA9PiB7IHJldHVybiBhZFNsb3Quc2xvdElEID09PSBhZElkOyB9KTtcblxuICAgICAgd2luZG93LmFwc3RhZy5mZXRjaEJpZHMoe1xuICAgICAgICBzbG90czogYTlSZWZyZXNoU2xvdFxuICAgICAgfSwgKGJpZHMpID0+IHtcbiAgICAgICAgZGVmYXVsdEV4dGVuc2lvbi5iaWRIYW5kbGVyQ2FsbGJhY2sobW9kdWxlLmV4cG9ydHMuYmlkSGFuZGxlcik7XG4gICAgICB9KTtcbiAgICB9XG4gICAgZGVmYXVsdEV4dGVuc2lvbi5kaXNwbGF5QWRVbml0KGFkSWQpO1xuICB9XG5cbn07XG4iXX0=

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  name: 'Admiral',
  refresh: function refresh() {
    return null;
  },

  postRegistrationScript: function postRegistrationScript() {
    return '<!--Admiral Request-->\r\n<script type="text/javascript">!(function(o,n,t){t=o.createElement(n),o=o.getElementsByTagName(n)[0],t.async=1,t.src="https://carpentercomparison.com/v2nlfZdn3WoydGB1vjUETH1FnPIs9s3tfOmWUoMQxerMX82X2Uytr4JrrHDfUxs_v",o.parentNode.insertBefore(t,o)})(document,"script"),(function(o,n){o[n]=o[n]||function(){(o[n].q=o[n].q||[]).push(arguments)}})(window,"admiral");!(function(c,e,o,t,n){function r(o,t){(function n(){try{return 0<(localStorage.getItem("v4ac1eiZr0")||"").split(",")[4]}catch(o){}return!1})()&&(t=c[e].pubads())&&t.setTargeting("admiral-engaged","true")}(n=c[e]=c[e]||{}).cmd=n.cmd||[],typeof n.pubads===o?r():typeof n.cmd.unshift===o?n.cmd.unshift(r):n.cmd.push(r)})(window,"googletag","function");</script>\r\n<!--Admiral Request-->';
  },

  endPageScript: function endPageScript() {
    return '\n<!--Admiral Request-->\n<script>\nwindow.aax = window.aax || {};\nwindow.aax.cmd = window.aax.cmd || [];\nwindow.aax.cmd.push(function () {\n\tif (window.aax.getAbpStatus()) {\n    \twindow.googletag = window.googletag || {};\n    \twindow.googletag.cmd = window.googletag.cmd || [];\n    \twindow.googletag.cmd.push(function () {\n        \tgoogletag.pubads().refresh();\n    \t});\n\t}\n});\n</script>\n<!--Admiral Request-->';
  },

  pageUpdateScript: function pageUpdateScript() {
    if (window) {
      window.aax = window.aax || {};
      window.aax.cmd = window.aax.cmd || [];
      window.aax.cmd.push(function () {
        window.aax.incrementPage();
      });
    }
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdController = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(59);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _AdControl = __webpack_require__(589);

var _AdControl2 = _interopRequireDefault(_AdControl);

var _LocalAdControl = __webpack_require__(599);

var _LocalAdControl2 = _interopRequireDefault(_LocalAdControl);

var _domHelpers = __webpack_require__(1525);

var _lodash = __webpack_require__(8);

var _lodash2 = _interopRequireDefault(_lodash);

var _bindMethods = __webpack_require__(598);

var _AdService = __webpack_require__(363);

var _AdService2 = _interopRequireDefault(_AdService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React component that will register an ad placement in a page and maintain the logic
 * needed to display, refresh and remove an advertisement.
 */
var AdController = exports.AdController = function (_React$Component) {
  _inherits(AdController, _React$Component);

  /**
   * constructor
   *
   * @param  {array} props injected into control instance
   * @return {Undefined} Returns nothing
   */
  function AdController(props) {
    _classCallCheck(this, AdController);

    var _this = _possibleConstructorReturn(this, (AdController.__proto__ || Object.getPrototypeOf(AdController)).call(this, props));

    _this.isVisible = false;
    _this.heartBeatIntervalId = null;
    _this.secondsInView = 0;
    _this.idleAdRefreshes = 0;
    _this.isAdDisplayed = !_this.props.clientLoadOnly;
    _this.disableAutoRefresh = _this.props.disableAutoRefresh;

    _this.state = { isAdInitialized: _this.isAdDisplayed };

    (0, _bindMethods.bindMethods)(_this, ['heartbeat', 'setAdControlRef', 'handleOnScroll', 'adDisplayCheck', 'handleOnAdEvent']);

    _this.handleOnScroll = _lodash2.default.throttle(_this.handleOnScroll, _this.props.scrollThrottle, { 'leading': true, 'trailing': false });
    _this.adDisplayCheck = _lodash2.default.throttle(_this.adDisplayCheck, _this.props.scrollThrottle, { 'leading': true, 'trailing': false });
    return _this;
  }

  /**
   * componentDidMount - Runs on the client after render is called.  This method
   * will add a scroll listener and checks if the ad should be rendered.
   *
   * @return {Undefined} Returns nothing
   */


  _createClass(AdController, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.element = _reactDom2.default.findDOMNode(this);
      window.addEventListener('scroll', this.handleOnScroll);
      this.handleOnScroll();
    }

    /**
     * componentWillUnmount - Runs on the client after the component unmounts to clean up.
     * Removes listenrs.
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleOnScroll);
      this.disableHeartbeat();
    }

    /**
     * disableHeartbeat - Removes heartbeat interval for idle ad refresh
     *
     * @return {Undefined}  Returns Nothing.
     */

  }, {
    key: 'disableHeartbeat',
    value: function disableHeartbeat() {
      window.clearInterval(this.heartBeatIntervalId);
      this.heartBeatIntervalId = null;
    }

    /**
     * heartbeat - Runs every second when an advertisement is in-view to check if
     * an ad should be refrehed or not
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'heartbeat',
    value: function heartbeat() {
      if (this.isVisible && this.idleAdRefreshes < this.props.maxIdleAdRefreshes) {
        if (this.secondsInView >= this.props.adRefreshInterval) {
          this.secondsInView = 0;
          this.idleAdRefreshes++;
          this.refreshAd();
        } else {
          this.secondsInView++;
        }
      } else {
        window.clearInterval(this.heartBeatIntervalId);
        this.heartBeatIntervalId = null;
      }
    }

    /**
     * adDisplayCheck - Checks to see if ad should be displayed / refreshed or
     * unloaded because its out of view.
     *
     * @param  {object} win Window Object
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'adDisplayCheck',
    value: function adDisplayCheck(win) {
      var distanceFromVisible = (0, _domHelpers.distanceFromInView)(this.element, win || window);

      if (this.isAdDisplayed && distanceFromVisible > this.props.inviewThreshold) {
        // Hide Ad
        this.isAdDisplayed = false;
        this.unloadAd();
      }
      if (!this.isAdDisplayed && distanceFromVisible < this.props.inviewThreshold) {
        // Show Ad
        this.isAdDisplayed = true;
        if (this.state.isAdInitialized) {
          this.refreshAd();
        } else {
          this.setState({ isAdInitialized: true });
        }
      }
    }

    /**
     * handleOnScroll - Function called by the scroll event to determine if an ad
     * is in-view if it should have a heartbeat or to clear the heartbeat
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'handleOnScroll',
    value: function handleOnScroll() {
      this.isVisible = (0, _domHelpers.percentVisible)(this.element, window) >= this.props.inviewPercentage;

      // Reset Counter if scrolling occurs and ad is out of view
      if (this.idleAdRefreshes >= this.props.maxIdleAdRefreshes && !this.isAdDisplayed) {
        this.idleAdRefreshes = 0;
      }
      this.adDisplayCheck();
      this.secondsInView = 0;

      if (!this.disableAutoRefresh && this.isVisible && !this.heartBeatIntervalId) {
        var ONE_SECOND = 1000;

        this.heartBeatIntervalId = window.setInterval(this.heartbeat, ONE_SECOND);
      }

      if (!this.isVisible && this.heartBeatIntervalId) {
        window.clearInterval(this.heartBeatIntervalId);
        this.heartBeatIntervalId = null;
      }
    }

    /**
     * setAdControlRef - pattern for setting the ref as a function for adControl
     *
     * @param  {object} adControl to add to reference
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'setAdControlRef',
    value: function setAdControlRef(adControl) {
      if (adControl) {
        this.adControlRef = adControl;
      }
    }

    /**
     * refreshAd - pass thru function to AdControl for refreshing ad
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'refreshAd',
    value: function refreshAd() {
      if (this.adControlRef) {
        this.adControlRef.refreshAd();
        this.handleOnAdRefresh();
      }
    }

    /**
     * retargetAd - pass thru function to AdControl for retargeting ad
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'retargetAd',
    value: function retargetAd() {
      if (this.adControlRef) {
        this.adControlRef.retargetAd();
      }
    }

    /**
     * loadAd - pass thru function to AdControl for loading ad
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'loadAd',
    value: function loadAd() {
      if (this.adControlRef) {
        this.adControlRef.loadAd();
      }
    }

    /**
     * unloadAd - pass thru function to AdControl for unloading ad
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'unloadAd',
    value: function unloadAd() {
      if (this.adControlRef) {
        this.adControlRef.unloadAd();
      }
    }

    /**
     * handleOnAdEvent - Listen to all AdControl events, checks for disable refreshAd
     * call and removes auto refresh. Continues to bubble the events up.
     *
     * @param  {String} eventName - Name of event being fired
     * @param  {Object} eventData - event data object
     * @param  {Object} controlInstance - ad control instance of origin event
     * @return {Undefined} Returns Nothing
     */

  }, {
    key: 'handleOnAdEvent',
    value: function handleOnAdEvent(eventName, eventData, controlInstance) {
      if (eventName.toLowerCase() === 'norefresh') {
        this.disableAutoRefresh = true;
        this.disableHeartbeat();
      }

      if (this.props.onAdEvent) {
        this.props.onAdEvent(eventName, eventData, controlInstance);
      }
    }

    /**
     * handleOnAdRefresh - fire callback when ad is refreshed
     *
     * @return {Undefined}  Returns nothing
     */

  }, {
    key: 'handleOnAdRefresh',
    value: function handleOnAdRefresh() {
      if (this.props.onAdRefresh && this.props.onAdRefresh instanceof Function) {
        this.props.onAdRefresh();
      }
    }

    /**
     * render - Renders the contents of the AdController.
     *
     * @return {function} function to render control.
     */

  }, {
    key: 'render',
    value: function render() {
      var adControl = null;

      if (this.state.isAdInitialized) {
        adControl = this.props.useLocalAd ? _react2.default.createElement(_LocalAdControl2.default, { ref: this.setAdControlRef, affiliateSiteName: this.props.affiliateSiteName }) : _react2.default.createElement(_AdControl2.default, _extends({ ref: this.setAdControlRef }, this.props, { onAdEvent: this.handleOnAdEvent, adService: this.props.adService }));
      }

      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', 'minWidth': '1px', 'minHeight': '1px' } },
        adControl
      );
    }
  }]);

  return AdController;
}(_react2.default.Component);

AdController.propTypes = {
  affiliateSiteName: _propTypes2.default.string,
  adRefreshInterval: _propTypes2.default.number,
  adSize: _propTypes2.default.array.isRequired,
  cleanupIds: _propTypes2.default.array,
  clientLoadOnly: _propTypes2.default.bool,
  disableAutoRefresh: _propTypes2.default.bool,
  inviewPercentage: _propTypes2.default.number,
  inviewThreshold: _propTypes2.default.number,
  manualLoad: _propTypes2.default.bool,
  maxIdleAdRefreshes: _propTypes2.default.number,
  onAdEvent: _propTypes2.default.func,
  onAdRefresh: _propTypes2.default.func,
  pageName: _propTypes2.default.string.isRequired,
  positionId: _propTypes2.default.string.isRequired,
  responsiveSizeMap: _propTypes2.default.string,
  scrollThrottle: _propTypes2.default.number,
  slotKeyValues: _propTypes2.default.array,
  slotName: _propTypes2.default.string,
  slotType: _propTypes2.default.string,
  uniqueCounter: _propTypes2.default.number,
  useLocalAd: _propTypes2.default.bool,
  adService: _propTypes2.default.instanceOf(_AdService2.default).isRequired,
  usePartnerAdNetwork: _propTypes2.default.bool
};
AdController.defaultProps = {
  adRefreshInterval: 30,
  disableAutoRefresh: false,
  inviewPercentage: 51,
  inviewThreshold: 2000,
  maxIdleAdRefreshes: 4,
  scrollThrottle: 500,
  useLocalAd: false,
  usePartnerAdNetwork: false
};
exports.default = AdController;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.percentVisible = percentVisible;
exports.distanceFromInView = distanceFromInView;


/**
 * percentVisible - Gives the percentage of a dom element in view
 *
 * @param  {object} element dom element to check percentage in-view
 * @param  {object} win Window object to check visiblity of element
 * @return {number}  percentage 0-100 an element is in-view
 */
function percentVisible(element, win) {
  var elementRect = element.getBoundingClientRect();
  var winHeight = win.innerHeight;
  var winWidth = win.innerWidth;

  //  Get Height in viewport
  var inViewHeight = elementRect.height;

  if (elementRect.bottom < 0 || elementRect.top > winHeight) {
    inViewHeight = 0;
  }

  if (elementRect.top < 0 && elementRect.bottom > 0) {
    inViewHeight = elementRect.bottom;
  }

  if (elementRect.bottom > winHeight && elementRect.top < winHeight) {
    inViewHeight = winHeight - elementRect.top;
  }

  //  Get width in viewport
  var inViewWidth = elementRect.width;

  if (elementRect.right < 0 || elementRect.left > winWidth) {
    inViewWidth = 0;
  }

  if (elementRect.left < 0 && elementRect.right > 0) {
    inViewWidth = elementRect.right;
  }

  if (elementRect.right > winWidth && elementRect.left < winWidth) {
    inViewWidth = winWidth - elementRect.left;
  }

  var area = elementRect.height * elementRect.width;
  var hundredPercent = 100;
  var inviewArea = inViewHeight * inViewWidth;
  var percentageVisible = area > 0 ? inviewArea / area * hundredPercent : 0;

  return percentageVisible;
}

/**
 * distanceFromInView - Determines the distance an element is from being inview
 * in the viewport.  0 means in-view; all results 0 or positive number.
 *
 * @param  {object} element Dom Element to get distance from viewport
 * @param  {object} win Window object to check how far the element is from visible
 * @return {number} 0 -> In-view; >=1 distance from being visible
 */
function distanceFromInView(element, win) {
  var elementRect = element.getBoundingClientRect();
  var elementTop = elementRect.top;
  var elementBottom = elementRect.bottom;
  var winHeight = win.innerHeight;

  //  Check if element is inview
  if (elementBottom >= winHeight && elementTop <= winHeight || elementBottom <= winHeight && elementBottom >= 0) {
    return 0;
  }

  return elementTop > winHeight ? elementTop - winHeight : Math.abs(elementBottom);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _expressInterceptor = __webpack_require__(1527);

var _expressInterceptor2 = _interopRequireDefault(_expressInterceptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * DfpMiddleware
 *
 * @param  {object} function(req - express request object
 * @param  {object} res -           express response object
 * @return {object} function used by express-interceptor
 */
var DfpMiddleware = function () {
  function DfpMiddleware() {
    _classCallCheck(this, DfpMiddleware);

    this.adScriptInjector = (0, _expressInterceptor2.default)(this.injector.bind(this));
  }

  _createClass(DfpMiddleware, [{
    key: 'injector',
    // eslint-disable-line no-invalid-this

    /**
     * injector - Express Interceptor used to inject Ad Script into the final page output
     *
     * @param  {type} req Express Request Object
     * @param  {type} res Express Response Object
     * @return {object} function used by express-interceptor
     */
    value: function injector(req, res) {
      var _this = this;

      return {

        /**
         * isInterceptable - function used to determine if a particular request
         * should be intercepted.  Only a Content-Type of text/html should be
         * modified by this intercept function.
         * @return {type}  description
         */
        isInterceptable: function isInterceptable() {
          return _this.isHtmlContentType(res.get('Content-Type'));
        },

        /**
         * intercept - description
         *
         * @param  {string} body - full response body
         * @param  {function} send function to return new html body after modification.
         * @return {void}
         */
        intercept: function intercept(body, send) {
          if (_this.isAdsDisabled(req.query)) {
            send(body);
          } else {
            var responseHtml = _this.injectScripts(body, res.locals.adService);

            send(responseHtml);
          }
        }
      };
    }

    /**
     * isHtmlContentType - Determines if a given mime-type is HTML
     *
     * @param  {String} contentType - mime-type of current request
     * @return {Boolean} - true/false if mime-type is html content.
     */

  }, {
    key: 'isHtmlContentType',
    value: function isHtmlContentType(contentType) {
      return (/text\/html/.test(contentType)
      );
    }
  }, {
    key: 'injectScripts',
    value: function injectScripts(body, adService) {
      var htmlWithHeaderScripts = this.injectScriptIntoHead(body, adService.renderAdScript());
      var responseHtml = this.injectScriptIntoBody(htmlWithHeaderScripts, adService.renderEndPageScript());

      return responseHtml;
    }
  }, {
    key: 'injectScriptBeforeClosingTag',
    value: function injectScriptBeforeClosingTag(body, closingTag, script) {
      var finalBody = body.replace(closingTag, '' + script + closingTag);

      return finalBody;
    }

    /**
     * injectScriptIntoHead - Injects a given script into the head of an html document
     *
     * @param  {String} body   Body HTML
     * @param  {String} script HTML to be injected just before the </head> tag.
     * @return {String} Final HTML containing the script injected into the HTML.
     */

  }, {
    key: 'injectScriptIntoHead',
    value: function injectScriptIntoHead(body, script) {
      return this.injectScriptBeforeClosingTag(body, '</head>', script);
    }

    /**
     * injectScriptIntoBody - Injects a given script into the end of the body of an html document
     *
     * @param  {String} body   Body HTML
     * @param  {String} script HTML to be injected just before the </body> tag.
     * @return {String} Final HTML containing the script injected into the HTML.
     */

  }, {
    key: 'injectScriptIntoBody',
    value: function injectScriptIntoBody(body, script) {
      return this.injectScriptBeforeClosingTag(body, '</body>', script);
    }

    /**
     * isAdsDisabled - Checks if ads should be disabled based on URL.  If Url contains debug=1 then true else false.
     *
     * @param  {String} params - parameters in url of request
     * @return {Boolean} Based on the Url returns true or false to show or hide ads.
     */

  }, {
    key: 'isAdsDisabled',
    value: function isAdsDisabled(params) {
      var result = false;

      if (typeof params !== 'undefined' && typeof params.debug !== 'undefined') {
        result = params.debug === '1' || params.debug === '4';
      }
      return result;
    }
  }]);

  return DfpMiddleware;
}();

/**
 * Exports class as a singleton
 */


exports.default = new DfpMiddleware();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {
module.exports = function(fn) {
  var debug = __webpack_require__(1528)('express-interceptor');

  return function(req, res, next) {
    var methods = fn(req, res);
    _validateParams(methods);

    var originalEnd = res.end;
    var originalWrite = res.write;
    var chunks = [];
    var isIntercepting;
    var isFirstWrite = true;

    function intercept(rawChunk, encoding) {
      if (isFirstWrite) {
        isFirstWrite = false;
        isIntercepting = methods.isInterceptable();
      }

      debug('isIntercepting? %s', isIntercepting);
      if (isIntercepting) {
        // collect all the parts of a response
        if (rawChunk) {
          var chunk = rawChunk
          if (rawChunk !== null && !Buffer.isBuffer(chunk) && encoding !== 'buffer') {
            if (!encoding) {
              chunk = new Buffer(rawChunk)
            } else {
              chunk = new Buffer(rawChunk, encoding)
            }
          }
          chunks.push(chunk);
        }
        if (typeof cb === 'function') {
          cb();
        }
      }

      return isIntercepting;
    }

    res.write = function(chunk, encoding, cb) {
      debug('write called');
      if(!intercept(chunk,encoding)) {
        originalWrite.apply(res, arguments);
      }
    };

    function afterSend(oldBody, newBody) {
      if (typeof methods.afterSend === 'function') {
        process.nextTick(function() {
          debug('methods.afterSend running now, body size: %s %s', oldBody.length, newBody.length);
          methods.afterSend(oldBody, newBody);
        });
      }
    }

    res.end = function(chunk, encoding, cb) {
      debug('end called');
      var args = Array.prototype.slice.call(arguments);

      if (intercept(chunk,encoding)) {
        isIntercepting = false;
        var oldBody = Buffer.concat(chunks).toString('utf-8');

        if (methods.intercept) {
          if (typeof methods.intercept !== 'function') {
            throw new Error('`send` must be a function with the body to be sent as the only param');
          }

          res.removeHeader('Content-Length');
          // allow the user to re-write response
          methods.intercept(oldBody, function(newBody) {
            args[0] = newBody;
            originalEnd.apply(res,args);
            afterSend(oldBody,newBody);
          });
        } else {
          debug(' methods.send isnt defined');
          afterSend(oldBody, oldBody);
          originalEnd.apply(res, args);
        }

      } else {
        originalEnd.apply(res, args);
      }

    };

    next();
  };
};

var VALID_PARAMS = ['isInterceptable', 'intercept', 'afterSend'];
function _validateParams(methods) {
  for (var k in methods) {
    if (VALID_PARAMS.indexOf(k) < 0) {
      throw(new Error(k+' isn\'t a valid param (' + VALID_PARAMS.join(', ') + ')'));
    }
  }

  if (!('isInterceptable' in methods)) {
    throw('isInterceptable is a required param (function)');
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21).Buffer, __webpack_require__(43)))

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1529);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","APP_ENV":"prod","ENABLE_STATSD":false,"HEADER_BIDDING":true}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1530);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1530 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getMoreObituaries=getMoreObituaries;var _queryTemplates=__webpack_require__(243);var _gatewayFetch=__webpack_require__(178);var _gatewayFetch2=_interopRequireDefault(_gatewayFetch);var _refreshAds=__webpack_require__(600);var _GAHelpers=__webpack_require__(22);var _metaDataUtilities=__webpack_require__(364);var _urlHelpers=__webpack_require__(28);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conf=(0,_AppConfig2.default)();var obituariesRequest=function obituariesRequest(){return{type:_actions.OBITUARIES_REQUEST};};var obituariesSuccess=function obituariesSuccess(response,count){return{type:_actions.OBITUARIES_SUCCESS,response:response,count:count};};var obituariesError=function obituariesError(error){return{type:_actions.OBITUARIES_ERROR,error:error};};/**
 * @param  {number}   funeralHomeId funeralHomeId
 * @param  {number}   affiliateId Affiliate ID
 * @param  {number}   count Number of obituaries to return
 * @return {function} returns the function to make the fetch
 */function getMoreObituaries(funeralHomeId){var affiliateId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var count=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10;return function(dispatch,getState){var _getState=getState(),_getState$obituarySto=_getState.obituaryStore.page,page=_getState$obituarySto===undefined?1:_getState$obituarySto;var parameters={count:count,affiliateId:affiliateId,offset:count*page};var query=(0,_queryTemplates.getMoreObituariesQuery)(funeralHomeId,parameters);dispatch(obituariesRequest());if(funeralHomeId){return(0,_gatewayFetch2.default)(query,'query').then(function(data){var _getState2=getState(),obituaryStore=_getState2.obituaryStore,funeralHomeStore=_getState2.funeralHomeStore;var nextPageNumber=obituaryStore.page+1;var nextPageParameters=nextPageNumber>1?[{key:'page',value:nextPageNumber}]:null;var nextPageUrl=(0,_urlHelpers.buildUrl)(conf.vanityDomain,(0,_metaDataUtilities.buildDirectoryPath)(funeralHomeStore),nextPageParameters);(0,_GAHelpers.setVirtualPageView)(nextPageUrl);history.replaceState(null,null,nextPageUrl);(0,_refreshAds.refreshAds)(['display-right-inview-1','display-right-inview-2']);dispatch(obituariesSuccess(data,count));}).catch(function(error){dispatch(obituariesError(error));});}dispatch(obituariesError(new Error('No get parameters present')));};}

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1533), __esModule: true };

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158);
__webpack_require__(1534);
module.exports = __webpack_require__(35).Array.from;


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(131);
var $export = __webpack_require__(66);
var toObject = __webpack_require__(156);
var call = __webpack_require__(601);
var isArrayIter = __webpack_require__(602);
var toLength = __webpack_require__(314);
var createProperty = __webpack_require__(1535);
var getIterFn = __webpack_require__(366);

$export($export.S + $export.F * !__webpack_require__(603)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(86);
var createDesc = __webpack_require__(157);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.addFuneralHomeAndEventSchema=addFuneralHomeAndEventSchema;exports.addNewsArticleSchema=addNewsArticleSchema;exports.addPersonEventsSchema=addPersonEventsSchema;exports.addPersonSchema=addPersonSchema;exports.addItemListSchema=addItemListSchema;var _metaDataUtilities=__webpack_require__(364);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _urlHelpers=__webpack_require__(28);var _moment=__webpack_require__(97);var _moment2=_interopRequireDefault(_moment);var _formatHelpers=__webpack_require__(55);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conf=(0,_AppConfig2.default)();var DEFAULT_DATA={'@context':'http://schema.org','@type':'LocalBusiness',name:'',telephone:'',address:'',url:'',description:'',areaServed:'',foundingdate:''};var DEFAULT_ADDRESS={'@type':'PostalAddress',addressLocality:'',addressRegion:'',streetAddress:'',postalCode:''};var DEFAULT_EVENT={'@context':'http://www.schema.org','@type':'Event',name:'',description:'',startDate:'',endDate:'',location:{'@type':'Place',name:'',address:DEFAULT_ADDRESS}};/**
 * Builds JSON LD Data string from a funeral home
 * @param {object} funeralHome Funeral Home object
 * @param {object} upcomingServices Upcoming Services at funeral home
 * @return {object} JSON LD String
 */function addFuneralHomeAndEventSchema(funeralHome,upcomingServices){var _funeralHome$location=funeralHome.location,location=_funeralHome$location===undefined?{}:_funeralHome$location,profileData=funeralHome.profileData,attributesData=funeralHome.attributesData,logoImageUrl=funeralHome.logoImageUrl,primaryImageUrl=funeralHome.primaryImageUrl;var _profileData$websiteU=profileData.websiteUrl,websiteUrl=_profileData$websiteU===undefined?'':_profileData$websiteU;var city=location.city,fhState=location.state,postalCode=location.postalCode;var description=_lodash2.default.get(funeralHome,'meta.description')||(0,_metaDataUtilities.getProfileDescription)(funeralHome);var _upcomingServices$peo=upcomingServices.people,people=_upcomingServices$peo===undefined?[]:_upcomingServices$peo;var eventSchema=[];var address=_lodash2.default.defaults({'@type':'PostalAddress',addressLocality:city.fullName,addressRegion:fhState.fullName,streetAddress:profileData.address1,postalCode:postalCode},DEFAULT_ADDRESS);if(people.length>0){people.forEach(function(person){var _person$services=person.services,services=_person$services===undefined?[]:_person$services;if(services.length>0){services.forEach(function(service){var serviceDate=_moment2.default.utc(service.serviceDate);var serviceLocation=service.isAtFuneralHome?{name:funeralHome.name,address:address}:{name:service.name,address:{addressLocality:_lodash2.default.get(service,'location.city',''),addressRegion:_lodash2.default.get(service,'location.state',''),streetAddress:_lodash2.default.get(service,'location.address',''),postalCode:_lodash2.default.get(service,'location.postalCode','')}};eventSchema.push(_lodash2.default.defaultsDeep({'@context':'http://www.schema.org','@type':'Event',name:person.fullName+' - '+service.serviceType,description:'Join us for the '+service.serviceType+' to celebrate the life of '+person.fullName+' on the day of '+serviceDate.format('MMMM Do, YYYY')+' at the '+funeralHome.name,startDate:''+serviceDate.format('MM/DD/YYYY '),endDate:''+serviceDate.format('MM/DD/YYYY'),location:(0,_extends3.default)({'@type':'Place'},serviceLocation)},DEFAULT_EVENT));});}});}var funeralHomeSchema=_lodash2.default.defaults({name:funeralHome.name,telephone:funeralHome.phone,address:address,url:(0,_urlHelpers.ensureProtocol)(websiteUrl),description:description},DEFAULT_DATA);if(primaryImageUrl){funeralHomeSchema.image=primaryImageUrl;if(eventSchema.length>0){eventSchema.map(function(event){return(0,_extends3.default)({},event,{image:[primaryImageUrl]});});}}if(logoImageUrl){funeralHomeSchema.logo=logoImageUrl;}// Remove any details with 'N/A' values
// eslint-disable-next-line
// TODO: This logic is duplicated down in the Details component
var validDetails=attributesData.filter(function(item){return item.value&&!item.value.toLowerCase().includes('n/a');});var areaServed=validDetails.find(function(item){return item.name==='Communities Served';});var founded=validDetails.find(function(item){return item.name==='Founded Year';});if(areaServed){funeralHomeSchema.areaServed=areaServed.value.split(', ');}if(founded){funeralHomeSchema.foundingdate=founded.value;}return{funeralHome:funeralHomeSchema,events:eventSchema};}/**
 * get name
 * @param  {object} name name obj
 * @return {String} full name
 */function getFullName(name){var full=name.full,short=name.short,first=name.first,last=name.last;var personName=full?full:short;if(!personName){personName=[first,last].filter(function(nameItem){return nameItem;}).join(' ');}return personName;}/**
 * http://schema.org/newsarticle
 * @param {Object} person Person page data.
 * @return {Object} Returns formated object.
 */function addNewsArticleSchema(person){var _person$portraitImage=person.portraitImage;_person$portraitImage=_person$portraitImage===undefined?{}:_person$portraitImage;var imgHref=_person$portraitImage.href,width=_person$portraitImage.width,height=_person$portraitImage.height,_person$meta=person.meta,meta=_person$meta===undefined?{}:_person$meta,_person$name=person.name,name=_person$name===undefined?{}:_person$name,_person$displayText=person.displayText,displayText=_person$displayText===undefined?{}:_person$displayText,_person$location=person.location;_person$location=_person$location===undefined?{}:_person$location;var city=_person$location.city,state=_person$location.state;var personUrl=meta.seoCanonicalUrl;var imgUrl=imgHref?''+conf.environmentalUrl.cacheUrl+imgHref:conf.environmentalUrl.staticCacheUrl+'/obituaries/images/premiumobit/premiumobit_candle.jpg';var imgWidth=imgHref&&width?width:130;var imgHeight=imgHref&&height?height:130;var personName=getFullName(name);var obitText=displayText.fullSanitized||displayText.text||'';var articleBody=(0,_formatHelpers.sanitizeText)(obitText);var logoUrl='https://static-cms.legacy.com/sites/default/files/legacy-com-logo-a.png';var obitId=_lodash2.default.head(_lodash2.default.get(person,'obitSources.person'));var obit=_lodash2.default.find(_lodash2.default.get(person,'obituaries',[]),['sourceId',obitId]);var datePublished=_lodash2.default.get(obit,'dateCreated')||_lodash2.default.get(meta,'latestDate','');var dateModified=_lodash2.default.get(meta,'latestDate',datePublished);var headline=(0,_formatHelpers.formatTitle)(name.first,name.last,city,state);return{'@context':'http://schema.org','@type':'NewsArticle',mainEntityOfPage:{'@type':'WebPage','@id':personUrl},headline:headline,description:meta.description,url:personUrl,image:{'@type':'ImageObject',url:imgUrl,height:imgHeight,width:imgWidth},articleSection:'Obituaries',genre:'Obituary(Obit),Biography',dateCreated:datePublished,datePublished:datePublished,dateModified:dateModified,articleBody:articleBody,creator:['Legacy.com'],author:{'@type':'Person',name:'Legacy'},keywords:[personName+' Obituary','Obituaries'],publisher:{'@type':'Organization',name:'Legacy',logo:{'@type':'ImageObject',url:logoUrl,width:640,height:200}}};}/**
 * Formats service data to the correct schema.
 * For schema testing: https://search.google.com/structured-data/testing-tool
 * @param {Array} personData Person page data.
 * @return {Array} Returns array of formated events.
 */function addPersonEventsSchema(personData){var serviceData=_lodash2.default.get(personData,'services',false);if(serviceData){return serviceData.map(function(event){var serviceType=event.serviceType,city=event.city,state=event.state,postalCode=event.postalCode,streetAddress=event.address,startTime=event.startTime,endTime=event.endTime,location=event.location;var address=_lodash2.default.defaults({'@type':'PostalAddress',addressLocality:city,addressRegion:state,streetAddress:streetAddress,postalCode:postalCode},DEFAULT_ADDRESS);return{'@context':'https://schema.org','@type':'Event',name:serviceType||'',startDate:startTime||'',endDate:endTime||'',location:{'@type':'Place',name:location||'',address:address}};});}return[];}/**
 * Format person data to the correct schema. (https://schema.org/Person)
 * For schema testing: https://search.google.com/structured-data/testing-tool
 * @param {Object} personData Person page data.
 * @return {Object} Returns formated object.
 */function addPersonSchema(personData){if(!personData){return{};}var dateOfBirth=personData.dateOfBirth,dateOfDeath=personData.dateOfDeath,_personData$name=personData.name,name=_personData$name===undefined?{}:_personData$name,_personData$location=personData.location,location=_personData$location===undefined?{}:_personData$location,_personData$portraitI=personData.portraitImage,portraitImage=_personData$portraitI===undefined?{}:_personData$portraitI;var full=name.full,short=name.short,first=name.first,last=name.last;var city=location.city,state=location.state;var personName=full?full:short;if(!personName){personName=[first,last].filter(function(nameItem){return nameItem;}).join(' ');}var personLocation=[city,state].filter(function(locationItem){return locationItem;}).join(' ');return{'@context':'https://schema.org','@type':'Person',additionalName:personName,address:{'@type':'PostalAddress',addressLocality:personLocation},birthDate:dateOfBirth||'',deathDate:dateOfDeath||'',familyName:last||'',givenName:first||'',name:personName,url:personData['og:url'],image:portraitImage.href?''+(0,_urlHelpers.buildUrl)(conf.environmentalUrl.cacheUrl,portraitImage.href):''};}/**
 * Formats service data to the correct schema.
 * For schema testing: https://search.google.com/structured-data/testing-tool
 * @param {object} personData Person page data.
 * @return {object} Returns array of formated events.
 */function addItemListSchema(personData){var obituaryData=_lodash2.default.get(personData,'obituaries',false);if(obituaryData.length>1){var itemList=[];obituaryData.map(function(obit,index){var href=obit.href;itemList.push({'@type':'ListItem',position:index+1,url:href});});return{'@context':'https://schema.org','@type':'ItemList',itemListElement:itemList};}return{};}

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _GAHelpers=__webpack_require__(22);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FlowersCTA=function(_Component){(0,_inherits3.default)(FlowersCTA,_Component);function FlowersCTA(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,FlowersCTA);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=FlowersCTA.__proto__||(0,_getPrototypeOf2.default)(FlowersCTA)).call.apply(_ref,[this].concat(args))),_this),_this.handleSendFlowersClick=function(){(0,_GAHelpers.getGATags)({eventCategory:'fhd_flowers',eventAction:'fhd_flowersad_click',eventLabel:'fhd_flowerad'});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(FlowersCTA,[{key:'render',value:function render(){var _props$data=this.props.data,image=_props$data.image,text=_props$data.text,link=_props$data.link;return _react2.default.createElement('a',{href:link,className:'flowers-cta-item','data-ga-no-auto-tag':true,onClick:this.handleSendFlowersClick},_react2.default.createElement('div',{className:'image',style:{backgroundImage:'url('+image+')'}}),_react2.default.createElement('div',{className:'description'},text));}}]);return FlowersCTA;}(_react.Component);FlowersCTA.propTypes={data:_react2.default.PropTypes.object,image:_react2.default.PropTypes.string,text:_react2.default.PropTypes.string,link:_react2.default.PropTypes.string};exports.default=FlowersCTA;

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","flowers-ad":"flowers-ad","flowers-cta-header":"flowers-cta-header","flowers-cta-link":"flowers-cta-link","flowers-cta-items":"flowers-cta-items","flowers-cta-item":"flowers-cta-item","description":"description","image":"image"};

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","search-obituaries__form":"search-obituaries__form","search-obituaries__container":"search-obituaries__container","error":"error","search-obituaries__title":"search-obituaries__title","search-obituaries__form-inner":"search-obituaries__form-inner","search-obituaries__first-name":"search-obituaries__first-name","search-obituaries__last-name":"search-obituaries__last-name","search-obituaries__button":"search-obituaries__button","obituaries__search-obituaries":"obituaries__search-obituaries","upcoming-services-tab__search-obituaries":"upcoming-services-tab__search-obituaries"};

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.UpcomingServices=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _urlHelpers=__webpack_require__(28);var _GAHelpers=__webpack_require__(22);var _Header=__webpack_require__(98);var _Header2=_interopRequireDefault(_Header);var _CalendarEvent=__webpack_require__(1541);var _CalendarEvent2=_interopRequireDefault(_CalendarEvent);var _FlowersAd=__webpack_require__(604);var _FlowersAd2=_interopRequireDefault(_FlowersAd);var _SearchObituaries=__webpack_require__(608);var _SearchObituaries2=_interopRequireDefault(_SearchObituaries);var _flower=__webpack_require__(605);var _flower2=_interopRequireDefault(_flower);var _flower3=__webpack_require__(606);var _flower4=_interopRequireDefault(_flower3);var _flower5=__webpack_require__(607);var _flower6=_interopRequireDefault(_flower5);__webpack_require__(1544);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UpcomingServices=exports.UpcomingServices=function(_Component){(0,_inherits3.default)(UpcomingServices,_Component);function UpcomingServices(){(0,_classCallCheck3.default)(this,UpcomingServices);return(0,_possibleConstructorReturn3.default)(this,(UpcomingServices.__proto__||(0,_getPrototypeOf2.default)(UpcomingServices)).apply(this,arguments));}(0,_createClass3.default)(UpcomingServices,[{key:'hasUpcomingServices',value:function hasUpcomingServices(upcomingServices){return upcomingServices&&upcomingServices.people&&upcomingServices.people.length>0;}},{key:'renderUpcomingServices',value:function renderUpcomingServices(upcomingServices){if(this.hasUpcomingServices(upcomingServices)){return _react2.default.createElement('div',{className:'upcoming-services-tab__events-container'},_react2.default.createElement(_Header2.default,{type:'no-border',title:'Upcoming Services'}),upcomingServices.people.map(function(value,index){return _react2.default.createElement(_CalendarEvent2.default,{key:index,data:value});}));}return null;}},{key:'render',value:function render(){var _props=this.props,affiliateId=_props.affiliateId,funeralHome=_props.funeralHome,_props$upcomingServic=_props.upcomingServices,upcomingServices=_props$upcomingServic===undefined?{people:[]}:_props$upcomingServic,planning=_props.planning,isMobile=_props.isMobile;var funeralHomeId=funeralHome.funeralHomeId,name=funeralHome.name,location=funeralHome.location,flowerSettings=funeralHome.flowerSettings;var flowersUrlOptions={funeralHomeId:funeralHomeId,funeralHomeName:name,affiliateId:affiliateId,cultureCode:location.country.cultureCode,flowerSettings:flowerSettings,isMobile:isMobile};var flowersAdsItems=[{image:_flower2.default,text:'The FTD® Comfort™ Planter',link:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions)},{image:_flower4.default,text:'The FTD® Faithful Blessings™ Bouquet - VASE INCLUDED',link:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions)},{image:_flower6.default,text:'The FTD® Eternal Affection™ Arrangement',link:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions)}];return _react2.default.createElement('div',{className:'upcoming-services-tab'},_react2.default.createElement(_Header2.default,{title:'Attending The Funeral'}),_react2.default.createElement('div',{className:'tab-overview'},!this.hasUpcomingServices(upcomingServices)&&_react2.default.createElement('p',null,'No upcoming services are currently listed. Updates will appear on this page as obituaries are published.'),_react2.default.createElement('p',null,'We encourage you to contact the funeral home to verify time and location before attending services or visitation.'),_react2.default.createElement('p',null,'To send flowers to ',this.props.funeralHome.name,' please visit our',' ',_react2.default.createElement('a',{href:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions),className:'link-flowers-store','data-ga-no-auto-tag':true,onClick:(0,_GAHelpers.gaClickHandler)('fhd_flowers','fhd_flowers_click','fhd_flowers_store')},'sympathy store'),'.')),this.renderUpcomingServices(upcomingServices),!planning&&_react2.default.createElement(_FlowersAd2.default,{flowersAdItems:flowersAdsItems,flowersUrlOptions:flowersUrlOptions}),_react2.default.createElement('div',{className:'upcoming-services-tab__search-obituaries'},_react2.default.createElement(_Header2.default,{type:'no-border',title:'Search Obituaries'}),_react2.default.createElement(_SearchObituaries2.default,null)));}}]);return UpcomingServices;}(_react.Component);UpcomingServices.propTypes={upcomingServices:_react2.default.PropTypes.object,funeralHome:_react2.default.PropTypes.object,planning:_react2.default.PropTypes.bool.isRequired,isMobile:_react2.default.PropTypes.bool};var mapStateToProps=function mapStateToProps(state){return{upcomingServices:state.upcomingServicesStore,funeralHome:state.funeralHomeStore,planning:state.planningStore.isPlanning,affiliateId:state.affiliateStore.sourceId,isMobile:state.mobileDetailsStore.any};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(UpcomingServices);

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CalendarEvent=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _FormatDate=__webpack_require__(1542);var _FormatDate2=_interopRequireDefault(_FormatDate);var _SocialButtons=__webpack_require__(588);var _SocialButtons2=_interopRequireDefault(_SocialButtons);var _urlHelpers=__webpack_require__(28);var _moment=__webpack_require__(97);var _moment2=_interopRequireDefault(_moment);var _reactRedux=__webpack_require__(12);__webpack_require__(1543);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CalendarEvent=exports.CalendarEvent=function(_Component){(0,_inherits3.default)(CalendarEvent,_Component);function CalendarEvent(){(0,_classCallCheck3.default)(this,CalendarEvent);return(0,_possibleConstructorReturn3.default)(this,(CalendarEvent.__proto__||(0,_getPrototypeOf2.default)(CalendarEvent)).apply(this,arguments));}(0,_createClass3.default)(CalendarEvent,[{key:'renderServices',value:function renderServices(){var _props$data=this.props.data,fullName=_props$data.fullName,obituaryUrl=_props$data.obituaryUrl,services=_props$data.services;var _props=this.props,affiliateId=_props.affiliateId,funeralHome=_props.funeralHome,isMobile=_props.isMobile;var location=funeralHome.location,flowerSettings=funeralHome.flowerSettings;var flowersUrlOptions={personName:fullName,personId:this.props.data.obituaryId,affiliateId:affiliateId,cultureCode:location.country.cultureCode,flowerSettings:flowerSettings,isMobile:isMobile};var flowersUrl=(0,_urlHelpers.buildObitFlowersUrl)(flowersUrlOptions);return services.map(function(service,index){var formattedServiceDate=_moment2.default.utc(service.serviceDate).format('dddd, MMMM Do YYYY');var socialUrls={obituaryUrl:obituaryUrl,flowersUrl:flowersUrl};var socialService={fullName:fullName,serviceDate:service.serviceDate,serviceType:service.serviceType};return _react2.default.createElement('div',{key:index,className:'calendar-event__container'},_react2.default.createElement('div',{className:'calendar-event__title'},_react2.default.createElement('a',{href:''+obituaryUrl},fullName)),_react2.default.createElement('div',{className:'calendar-event__event'},_react2.default.createElement('span',null,service.serviceType),_react2.default.createElement('span',{className:'calendar-event__service-date'},formattedServiceDate)),_react2.default.createElement(_SocialButtons2.default,{type:'service',urls:socialUrls,details:socialService}),_react2.default.createElement('div',{className:'calendar-event__calendar-icon'},_react2.default.createElement(_FormatDate2.default,{dateString:service.serviceDate})));});}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:'upcoming-services-collection'},this.renderServices());}}]);return CalendarEvent;}(_react.Component);CalendarEvent.propTypes={data:_react2.default.PropTypes.object};CalendarEvent.defaultProps={funeralHome:{}};var mapStateToProps=function mapStateToProps(state){return{affiliateId:state.affiliateStore.sourceId,funeralHome:state.funeralHomeStore,isMobile:state.mobileDetailsStore.any};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(CalendarEvent);

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _class=function(_Component){(0,_inherits3.default)(_class,_Component);function _class(){(0,_classCallCheck3.default)(this,_class);return(0,_possibleConstructorReturn3.default)(this,(_class.__proto__||(0,_getPrototypeOf2.default)(_class)).apply(this,arguments));}(0,_createClass3.default)(_class,[{key:'render',value:function render(){var dateString=this.props.dateString;var date=new Date(dateString);var day=date.getUTCDate();var month=date.toLocaleString('en-us',{month:'short'});var year=date.getFullYear();return _react2.default.createElement('div',null,_react2.default.createElement('span',{className:'year'},year),_react2.default.createElement('span',{className:'month'},month),_react2.default.createElement('span',{className:'day'},day));}}]);return _class;}(_react.Component);_class.propTypes={dateString:_react2.default.PropTypes.string};exports.default=_class;

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","calendar-event__container":"calendar-event__container","calendar-event__title":"calendar-event__title","calendar-event__service-date":"calendar-event__service-date","calendar-event__event":"calendar-event__event","calendar-event__calendar-icon":"calendar-event__calendar-icon","year":"year","month":"month","day":"day"};

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","upcoming-services-tab":"upcoming-services-tab","upcoming-services-tab__events-container":"upcoming-services-tab__events-container","upcoming-services-tab__image":"upcoming-services-tab__image"};

/***/ }),
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","react-tabs":"react-tabs","react-tabs__tab-list":"react-tabs__tab-list","tab-header":"tab-header","react-tabs__tab--selected":"react-tabs__tab--selected","react-tabs__tab":"react-tabs__tab","react-tabs__tab--disabled":"react-tabs__tab--disabled","react-tabs__tabfocus":"react-tabs__tabfocus","react-tabs__tabfocusafter":"react-tabs__tabfocusafter","react-tabs__tab-panel":"react-tabs__tab-panel","react-tabs__tab-panel--selected":"react-tabs__tab-panel--selected"};

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _AsideContents=__webpack_require__(1552);var _AsideContents2=_interopRequireDefault(_AsideContents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Aside=function Aside(){return _react2.default.createElement('aside',{className:'aside'},_react2.default.createElement(_AsideContents2.default,null));};exports.default=Aside;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AsideContents=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _get2=__webpack_require__(135);var _get3=_interopRequireDefault(_get2);var _reactRedux=__webpack_require__(12);var _HelpfulInformation=__webpack_require__(1553);var _HelpfulInformation2=_interopRequireDefault(_HelpfulInformation);var _Advertisement=__webpack_require__(1559);var _Advertisement2=_interopRequireDefault(_Advertisement);var _CtaModule=__webpack_require__(613);var _CtaModule2=_interopRequireDefault(_CtaModule);__webpack_require__(1567);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* NOTE:
 * The <HelpfulInformation/> and <NearbyFuneralHomes/> components have been commented out in order to make more
 * room for ads while a user is scrolling. These components are commented out rather than removed because it is likely
 * that we will want them turned back on in the future.
 */var AsideContents=exports.AsideContents=function(_Component){(0,_inherits3.default)(AsideContents,_Component);function AsideContents(){(0,_classCallCheck3.default)(this,AsideContents);return(0,_possibleConstructorReturn3.default)(this,(AsideContents.__proto__||(0,_getPrototypeOf2.default)(AsideContents)).apply(this,arguments));}(0,_createClass3.default)(AsideContents,[{key:'render',value:function render(){var _props=this.props,isPlanning=_props.isPlanning,_props$funeralHome=_props.funeralHome,funeralHome=_props$funeralHome===undefined?{}:_props$funeralHome;var isPremium=funeralHome.isPremium;var CtaModuleExists=typeof window!=='undefined'&&document.querySelector('.help-planning-question, .FuneralGuideForm')!==null;var displayAds=typeof window!=='undefined'&&window.matchMedia('(min-width: 900px)').matches;var displayAdsRightRail=typeof window!=='undefined'&&window.matchMedia('(min-width: 900px) and (min-height: 880px)').matches;if(isPremium){return _react2.default.createElement('div',{className:'aside-contents'},_react2.default.createElement(_CtaModule2.default,null),_react2.default.createElement(_HelpfulInformation2.default,null));}if(isPlanning){return _react2.default.createElement('div',{className:'aside-contents'},_react2.default.createElement(_CtaModule2.default,null),displayAds&&_react2.default.createElement(_Advertisement2.default,{positionId:'display-right-inview-2'}));}return _react2.default.createElement('div',{className:'aside-contents'},_react2.default.createElement(_CtaModule2.default,null),displayAds&&_react2.default.createElement(_Advertisement2.default,{positionId:'display-right-inview-1'}),!CtaModuleExists&&displayAds&&_react2.default.createElement(_Advertisement2.default,{positionId:'display-right-inview-2'}),CtaModuleExists&&displayAdsRightRail&&_react2.default.createElement(_Advertisement2.default,{positionId:'display-right-inview-2'}));}}]);return AsideContents;}(_react.Component);// import NearbyFuneralHomes from '../Shared/NearbyFuneralHomes';
/* eslint-disable no-inline-comments */AsideContents.propTypes={funeralHome:_react2.default.PropTypes.object.isRequired,nearbyFuneralHomes:_react2.default.PropTypes.array,isPlanning:_react2.default.PropTypes.bool.isRequired};var mapStateToProps=function mapStateToProps(state){return{page:(0,_get3.default)(state,'obituaryStore.page'),funeralHome:state.funeralHomeStore,// nearbyFuneralHomes: state.nearbyFuneralHomesStore,
isPlanning:state.planningStore.isPlanning};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(AsideContents);

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1554);var _copingBtnImg=__webpack_require__(1555);var _copingBtnImg2=_interopRequireDefault(_copingBtnImg);var _etiquetteBtnImg=__webpack_require__(1556);var _etiquetteBtnImg2=_interopRequireDefault(_etiquetteBtnImg);var _prePlanningBtnImg=__webpack_require__(1557);var _prePlanningBtnImg2=_interopRequireDefault(_prePlanningBtnImg);var _HelpfulInformationListItem=__webpack_require__(1558);var _HelpfulInformationListItem2=_interopRequireDefault(_HelpfulInformationListItem);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _Header=__webpack_require__(98);var _Header2=_interopRequireDefault(_Header);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var domain=(0,_AppConfig2.default)().vanityDomain;var HelpfulInformation=function HelpfulInformation(){var newsDomain=domain.replace(/https:/,'http:');var helpfulInformation=[{header:'How to Pay for a Funeral',title:'coping',image:_copingBtnImg2.default,path:newsDomain+'/news/advice-and-support/article/how-to-pay-for-a-funeral'},{header:'Five Ways to Cover Funeral Costs in Advance',title:'etiquette',image:_etiquetteBtnImg2.default,path:newsDomain+'/news/advice-and-support/article/five-ways-to-cover-funeral-costs-in-advance'},{header:'What Funeral Benefits Am I Eligible For?',title:'pre-planning',image:_prePlanningBtnImg2.default,path:newsDomain+'/news/advice-and-support/article/what-funeral-benefits-am-i-eligible-for'}];return _react2.default.createElement('div',{className:'helpful-information-container'},_react2.default.createElement(_Header2.default,{type:'aside-header',className:'helpful-information-container__title',title:'Helpful Information'}),_react2.default.createElement('ul',null,helpfulInformation.map(function(infoItem,i){return _react2.default.createElement(_HelpfulInformationListItem2.default,{helpfulInformation:infoItem,key:i});})));};exports.default=HelpfulInformation;

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","helpful-information-container":"helpful-information-container","helpful-information-container__title":"helpful-information-container__title","helpful-information-list":"helpful-information-list","helpful-information-list__link":"helpful-information-list__link","helpful-information-list__title":"helpful-information-list__title","helpful-information-list__author":"helpful-information-list__author","helpful-information-list__image":"helpful-information-list__image"};

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coping-btn-img.eb9bcbb2.png";

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/etiquette-btn-img.b0083d1c.png";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/pre-planning-btn-img.047a620b.png";

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HelpfulInformationListItem=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var HelpfulInformationListItem=exports.HelpfulInformationListItem=function(_Component){(0,_inherits3.default)(HelpfulInformationListItem,_Component);function HelpfulInformationListItem(){(0,_classCallCheck3.default)(this,HelpfulInformationListItem);return(0,_possibleConstructorReturn3.default)(this,(HelpfulInformationListItem.__proto__||(0,_getPrototypeOf2.default)(HelpfulInformationListItem)).apply(this,arguments));}(0,_createClass3.default)(HelpfulInformationListItem,[{key:"render",value:function render(){var _props$helpfulInforma=this.props.helpfulInformation,header=_props$helpfulInforma.header,title=_props$helpfulInforma.title,path=_props$helpfulInforma.path,image=_props$helpfulInforma.image;return _react2.default.createElement("li",{className:"helpful-information-list"},_react2.default.createElement("a",{className:"helpful-information-list__link",href:path,target:"_blank"},_react2.default.createElement("img",{className:"helpful-information-list__image",src:image,alt:title+"-image"}),_react2.default.createElement("header",{className:"helpful-information-list__title"},header)));}}]);return HelpfulInformationListItem;}(_react.Component);HelpfulInformationListItem.propTypes={helpfulInformation:_react2.default.PropTypes.object.isRequired};exports.default=HelpfulInformationListItem;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Advertisement=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRedux=__webpack_require__(12);var _legacyAdvertising=__webpack_require__(99);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* global adRefs */var Advertisement=exports.Advertisement=function(_Component){(0,_inherits3.default)(Advertisement,_Component);function Advertisement(props){(0,_classCallCheck3.default)(this,Advertisement);var _this=(0,_possibleConstructorReturn3.default)(this,(Advertisement.__proto__||(0,_getPrototypeOf2.default)(Advertisement)).call(this,props));_this.setAdRef=function(element){var positionId=_this.props.positionId;_this.adElement=element;adRefs.push({positionId:positionId,ref:element});};_this.adElement=null;return _this;}(0,_createClass3.default)(Advertisement,[{key:'render',value:function render(){var _props=this.props,adService=_props.adService,positionId=_props.positionId;return _react2.default.createElement('div',{style:{width:'300px',marginLeft:'auto',marginRight:'auto'}},_react2.default.createElement(_legacyAdvertising.AdController,{adService:adService,adSize:[[300,250],'fluid'],pageName:'fh-profile',positionId:positionId,responsiveSizeMap:'mapping300x250RightRail',ref:this.setAdRef}));}}]);return Advertisement;}(_react.Component);Advertisement.propTypes={adService:_propTypes2.default.shape({type:_propTypes2.default.instanceOf(_legacyAdvertising.AdService)}).isRequired,positionId:_propTypes2.default.string.isRequired};var mapStateToProps=function mapStateToProps(state){return{adService:state.adStore.adService};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Advertisement);

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HelpPlanningForm=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);__webpack_require__(1561);var _HelpPlanningQuestion=__webpack_require__(1562);var _HelpPlanningQuestion2=_interopRequireDefault(_HelpPlanningQuestion);var _LeadForm=__webpack_require__(350);var _LeadForm2=_interopRequireDefault(_LeadForm);var _salesforceApi=__webpack_require__(360);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable no-warning-comments *//* eslint arrow-body-style: ["error", "as-needed"] */var initialValues={firstName:'',lastName:'',email:'',phoneNumber:''};var phoneRegExp=/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;var HelpPlanningForm=exports.HelpPlanningForm=function(_Component){(0,_inherits3.default)(HelpPlanningForm,_Component);function HelpPlanningForm(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,HelpPlanningForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=HelpPlanningForm.__proto__||(0,_getPrototypeOf2.default)(HelpPlanningForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={planning:_this.props.planning},_this.onAnswer=function(){_this.setState({planning:true});},_this.handleFormSubmit=function(formValues,formik){var _this$props=_this.props,funeralHome=_this$props.funeralHome,affiliate=_this$props.affiliate;formik.setStatus({loading:true,error:false});var body=(0,_salesforceApi.buildSalesforcePayload)({form:'helpPlanning',formValues:formValues,funeralHome:funeralHome,affiliate:affiliate});(0,_salesforceApi.sendToWebcollect)({body:body}).then(function(json){var success=json.success,_json$error=json.error,error=_json$error===undefined?undefined:_json$error;// eslint-disable-line no-undefined
formik.setSubmitting(false);formik.setStatus({loading:false,success:success,error:error});}).catch(function(){formik.setSubmitting(false);formik.setStatus({loading:false,error:true,success:false});});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(HelpPlanningForm,[{key:'render',value:function render(){var planning=this.state.planning;var fields=[{name:'firstName',title:'First Name',required:true},{name:'lastName',title:'Last Name',required:true},{name:'email',type:'email',title:'Email',required:true},{name:'phoneNumber',type:'tel',title:'Phone Number',required:true}];if(planning){return _react2.default.createElement('div',{className:'help-planning-form'},_react2.default.createElement('header',{className:'help-planning-form__header'},'Get a Free, Custom Funeral Plan'),_react2.default.createElement('p',{className:'help-planning-form__info'},'A specialist from the funeral home will contact you to discuss your needs.'),_react2.default.createElement(_LeadForm2.default,{initialValues:initialValues,onSubmit:this.handleFormSubmit,submitText:'Contact Me',fields:fields,renderSuccess:function renderSuccess(){return _react2.default.createElement('p',{className:'Success'},'Someone will be in contact with you shortly.');}}));}return _react2.default.createElement(_HelpPlanningQuestion2.default,{onAnswer:this.onAnswer});}}]);return HelpPlanningForm;}(_react.Component);HelpPlanningForm.propTypes={affiliate:_react2.default.PropTypes.object,funeralHome:_react2.default.PropTypes.object,planning:_react2.default.PropTypes.bool};var mapStateToProps=function mapStateToProps(state){return{affiliate:state.affiliateStore,funeralHome:state.funeralHomeStore,planning:state.planningStore.isPlanning};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(HelpPlanningForm);

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","help-planning-form":"help-planning-form","Success":"Success","help-planning-form__header":"help-planning-form__header","help-planning-form__info":"help-planning-form__info"};

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(171);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1563);var _cookies=__webpack_require__(172);var _GAHelpers=__webpack_require__(22);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _class=function(_Component){(0,_inherits3.default)(_class,_Component);function _class(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,_class);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=_class.__proto__||(0,_getPrototypeOf2.default)(_class)).call.apply(_ref,[this].concat(args))),_this),_this.setImmediate=function(){(0,_cookies.setCookie)('_leg_LG',encodeURIComponent((0,_stringify2.default)([{name:'q_preneed',a:'Immediate help'}])),4/24);(0,_GAHelpers.getGATags)({eventCategory:'fhd_planning',eventAction:'fhd_need_click',eventLabel:'fhd_need'});_this.props.onAnswer('immediate');},_this.setFuture=function(){(0,_cookies.setCookie)('_leg_LG',encodeURIComponent((0,_stringify2.default)([{name:'q_preneed',a:'Future pre-planning'}])),4/24);(0,_GAHelpers.getGATags)({eventCategory:'fhd_planning',eventAction:'fhd_planning_click',eventLabel:'fhd_planning'});_this.props.onAnswer('future');},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(_class,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'help-planning-question'},_react2.default.createElement('header',null,'How Can We Help?'),_react2.default.createElement('label',null,_react2.default.createElement('input',{type:'radio','data-id':'immediate',name:'planTiming',value:'immediate',onClick:this.setImmediate}),_react2.default.createElement('span',null,'I have an immediate need')),_react2.default.createElement('label',null,_react2.default.createElement('input',{type:'radio','data-id':'future',name:'planTiming',value:'future',onClick:this.setFuture}),_react2.default.createElement('span',null,'I am planning for the future')),_react2.default.createElement('p',null,'Pre-planning means making arrangements for a funeral someday in the future.'));}}]);return _class;}(_react.Component);_class.propTypes={onAnswer:_react2.default.PropTypes.func};exports.default=_class;

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","help-planning-question":"help-planning-question"};

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.PlanningGuideForm=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _PlanningGuideCta=__webpack_require__(1565);var _PlanningGuideCta2=_interopRequireDefault(_PlanningGuideCta);var _Button=__webpack_require__(232);var _Button2=_interopRequireDefault(_Button);var _PlanningMockup=__webpack_require__(1566);var _PlanningMockup2=_interopRequireDefault(_PlanningMockup);var _PlanningGuideLeadForm=__webpack_require__(361);var _PlanningGuideLeadForm2=_interopRequireDefault(_PlanningGuideLeadForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PlanningGuideForm=exports.PlanningGuideForm=function(_Component){(0,_inherits3.default)(PlanningGuideForm,_Component);function PlanningGuideForm(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,PlanningGuideForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=PlanningGuideForm.__proto__||(0,_getPrototypeOf2.default)(PlanningGuideForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={showFields:false},_this.toggleFields=function(){_this.setState({showFields:true});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(PlanningGuideForm,[{key:'renderCtaBody',value:function renderCtaBody(){var showFields=this.state.showFields;if(showFields){return _react2.default.createElement(_PlanningGuideLeadForm2.default,null);}return _react2.default.createElement(_Button2.default,{handleClick:this.toggleFields,className:'FormSubmit'},'Get the Free Guide');}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:_PlanningGuideCta2.default.FuneralGuideForm},_react2.default.createElement('div',{className:_PlanningGuideCta2.default.FormHeader},_react2.default.createElement('div',{className:_PlanningGuideCta2.default.HeaderContent},_react2.default.createElement('h4',{className:_PlanningGuideCta2.default.FormTitle},'Funeral Planning Guide'),_react2.default.createElement('p',{className:_PlanningGuideCta2.default.FormBody},'Prepare for a meaningful funeral.')),_react2.default.createElement('div',{className:_PlanningGuideCta2.default.HeaderMedia},_react2.default.createElement('img',{src:_PlanningMockup2.default,alt:'Funeral Planning Guide',className:_PlanningGuideCta2.default.HeaderImage}))),this.renderCtaBody());}}]);return PlanningGuideForm;}(_react.Component);PlanningGuideForm.propTypes={affiliate:_react2.default.PropTypes.object.isRequired,funeralHome:_react2.default.PropTypes.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{affiliate:state.affiliateStore,funeralHome:state.funeralHomeStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(PlanningGuideForm);

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","FuneralGuideForm":"FuneralGuideForm","FormTitle":"FormTitle","FormBody":"FormBody","FormHeader":"FormHeader","HeaderContent":"HeaderContent","HeaderMedia":"HeaderMedia","HeaderImage":"HeaderImage","button":"button","FormSubmit":"FormSubmit","SuccessButton":"SuccessButton"};

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Planning-Mockup-02.e866209d.png";

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","aside":"aside","aside-contents":"aside-contents","adControl":"adControl"};

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FuneralInfo=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1569);var _InfoButtons=__webpack_require__(1570);var _InfoButtons2=_interopRequireDefault(_InfoButtons);var _formatHelpers=__webpack_require__(55);var _urlHelpers=__webpack_require__(28);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FuneralInfo=exports.FuneralInfo=function(_Component){(0,_inherits3.default)(FuneralInfo,_Component);function FuneralInfo(){(0,_classCallCheck3.default)(this,FuneralInfo);return(0,_possibleConstructorReturn3.default)(this,(FuneralInfo.__proto__||(0,_getPrototypeOf2.default)(FuneralInfo)).apply(this,arguments));}(0,_createClass3.default)(FuneralInfo,[{key:'render',value:function render(){var _props$funeralHome=this.props.funeralHome,funeralHomeId=_props$funeralHome.funeralHomeId,name=_props$funeralHome.name,_props$funeralHome$pr=_props$funeralHome.profileData,address1=_props$funeralHome$pr.address1,address2=_props$funeralHome$pr.address2,phone=_props$funeralHome$pr.phone,isPremium=_props$funeralHome.isPremium,_props$funeralHome$lo=_props$funeralHome.location,city=_props$funeralHome$lo.city.fullName,state=_props$funeralHome$lo.state.code,postalCode=_props$funeralHome$lo.postalCode;var formattedPhone=(0,_formatHelpers.formatPhoneNumber)(phone);var googleMapsAddressLink=(0,_urlHelpers.getMapUrl)(address1+'+'+city+'+'+state+'+'+postalCode);return _react2.default.createElement('div',{className:'funeral-info'},_react2.default.createElement('h1',{className:'funeral-home-title',itemProp:'name'},name),_react2.default.createElement('div',{'data-testid':'fh-address',itemProp:'address',itemScope:true,itemType:'http://schema.org/PostalAddress'},_react2.default.createElement('a',{className:(0,_classnames2.default)('address',address2?'addressMargin':''),target:'_blank',href:googleMapsAddressLink,itemProp:'url'},_react2.default.createElement('span',{itemProp:'streetAddress'},address1),',\xA0',_react2.default.createElement('span',{itemProp:'addressLocality'},city),',\xA0',_react2.default.createElement('span',{itemProp:'addressRegion'},state),'\xA0',_react2.default.createElement('span',{itemProp:'postalCode'},postalCode)),address2&&_react2.default.createElement('div',{className:'address2'},address2)),_react2.default.createElement(_InfoButtons2.default,{phone:formattedPhone,isPremium:isPremium,funeralHomeId:funeralHomeId}));}}]);return FuneralInfo;}(_react.Component);FuneralInfo.propTypes={funeralHome:_propTypes2.default.object.isRequired};exports.default=FuneralInfo;

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","funeral-info":"funeral-info","funeral-home-title":"funeral-home-title","address2":"address2","address":"address","addressMargin":"addressMargin"};

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.InfoButtons=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _Button=__webpack_require__(143);var _Button2=_interopRequireDefault(_Button);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _PhoneButton=__webpack_require__(587);var _PhoneButton2=_interopRequireDefault(_PhoneButton);var _urlHelpers=__webpack_require__(28);var _GAHelpers=__webpack_require__(22);__webpack_require__(1571);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InfoButtons=exports.InfoButtons=function(_Component){(0,_inherits3.default)(InfoButtons,_Component);function InfoButtons(){(0,_classCallCheck3.default)(this,InfoButtons);return(0,_possibleConstructorReturn3.default)(this,(InfoButtons.__proto__||(0,_getPrototypeOf2.default)(InfoButtons)).apply(this,arguments));}(0,_createClass3.default)(InfoButtons,[{key:'renderPhoneButton',value:function renderPhoneButton(){return _react2.default.createElement(_PhoneButton2.default,{isPremium:this.props.isPremium,phoneNumber:this.props.phone});}},{key:'renderFlowerButton',value:function renderFlowerButton(){var prominentClassName=this.props.isPremium?null:'prominent-button';var _props=this.props,affiliateId=_props.affiliateId,funeralHome=_props.funeralHome,isMobile=_props.isMobile;var funeralHomeId=funeralHome.funeralHomeId,name=funeralHome.name,location=funeralHome.location,flowerSettings=funeralHome.flowerSettings;var flowersUrlOptions={funeralHomeId:funeralHomeId,affiliateId:affiliateId,cultureCode:location.country.cultureCode,funeralHomeName:name,flowerSettings:flowerSettings,isMobile:isMobile};return _react2.default.createElement(_Button2.default,{className:(0,_classnames2.default)('spaced-button',prominentClassName),label:'Send Flowers',type:'large-button',href:(0,_urlHelpers.buildFuneralHomeFlowersUrl)(flowersUrlOptions),action:(0,_GAHelpers.gaClickHandler)('fhd_flowers','fhd_fh_flowers_click','fhd_flowers_button')},'Send Flowers');}},{key:'renderFlowerAndPhoneButtons',value:function renderFlowerAndPhoneButtons(){if(this.props.isPremium){return _react2.default.createElement('div',{className:'flower-phone-buttons'},this.renderPhoneButton(),this.renderFlowerButton());}return _react2.default.createElement('div',{className:'flower-phone-buttons'},this.renderFlowerButton(),this.renderPhoneButton());}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:'funeral-info-buttons'},this.props.planning?this.renderPhoneButton():this.renderFlowerAndPhoneButtons());}}]);return InfoButtons;}(_react.Component);InfoButtons.propTypes={isPremium:_propTypes2.default.bool.isRequired,phone:_propTypes2.default.string.isRequired,funeralHomeId:_propTypes2.default.number,planning:_propTypes2.default.bool.isRequired,isMobile:_propTypes2.default.bool};var mapStateToProps=function mapStateToProps(state){return{planning:state.planningStore.isPlanning,affiliateId:state.affiliateStore.sourceId,funeralHome:state.funeralHomeStore,isMobile:state.mobileDetailsStore.any};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(InfoButtons);

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","funeral-info-buttons":"funeral-info-buttons","phone-container":"phone-container","spaced-button":"spaced-button","prominent-button":"prominent-button","phone-button":"phone-button","large-button":"large-button"};

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TopLeaderboardAdOptions=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _TopLeaderboardAdOptions=__webpack_require__(1573);var _TopLeaderboardAdOptions2=_interopRequireDefault(_TopLeaderboardAdOptions);var _legacyAdvertising=__webpack_require__(99);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _NearbyFuneralHomes=__webpack_require__(1574);var _NearbyFuneralHomes2=_interopRequireDefault(_NearbyFuneralHomes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TopLeaderboardAdOptions=exports.TopLeaderboardAdOptions=function(_Component){(0,_inherits3.default)(TopLeaderboardAdOptions,_Component);function TopLeaderboardAdOptions(){(0,_classCallCheck3.default)(this,TopLeaderboardAdOptions);return(0,_possibleConstructorReturn3.default)(this,(TopLeaderboardAdOptions.__proto__||(0,_getPrototypeOf2.default)(TopLeaderboardAdOptions)).apply(this,arguments));}(0,_createClass3.default)(TopLeaderboardAdOptions,[{key:'renderNearbyFuneralHomesAd',value:function renderNearbyFuneralHomesAd(){return _react2.default.createElement('div',{className:'TopLeaderboardNearbyHomes'},_react2.default.createElement(_NearbyFuneralHomes2.default,{funeralHomes:this.props.nearbyFuneralHomes}));}},{key:'renderTopLeaderboardAd',value:function renderTopLeaderboardAd(){return _react2.default.createElement('div',{className:_TopLeaderboardAdOptions2.default.TopLeaderboardAd},_react2.default.createElement('div',{className:_TopLeaderboardAdOptions2.default.AdvertisementCopy},'Advertisement'),_react2.default.createElement(_legacyAdvertising.AdController,{adService:this.props.adService,adSize:[[728,90],[320,50],'fluid'],pageName:'fh-profile',positionId:'display-top-1',responsiveSizeMap:'mapping728x90Header'}));}},{key:'render',value:function render(){var _props=this.props,shortVersion=_props.shortVersion,planning=_props.planning;return _react2.default.createElement('div',{className:(0,_classnames2.default)(_TopLeaderboardAdOptions2.default.TopLeaderboardAdOptions,shortVersion?_TopLeaderboardAdOptions2.default.ShortVersion:null)},planning?this.renderNearbyFuneralHomesAd():this.renderTopLeaderboardAd());}}]);return TopLeaderboardAdOptions;}(_react.Component);TopLeaderboardAdOptions.propTypes={adService:_propTypes2.default.shape({type:_propTypes2.default.instanceOf(_legacyAdvertising.AdService)}).isRequired,shortVersion:_react2.default.PropTypes.bool,nearbyFuneralHomes:_react2.default.PropTypes.array,planning:_react2.default.PropTypes.bool};TopLeaderboardAdOptions.defaultProps={shortVersion:false};var mapStateToProps=function mapStateToProps(state){return{nearbyFuneralHomes:state.nearbyFuneralHomesStore,planning:state.planningStore.isPlanning};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(TopLeaderboardAdOptions);

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","TopLeaderboardAdOptions":"TopLeaderboardAdOptions","TopLeaderboardAd":"TopLeaderboardAd","AdvertisementCopy":"AdvertisementCopy"};

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.NearbyFuneralHomes=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);__webpack_require__(1575);var _NearbyFuneralHome=__webpack_require__(1576);var _NearbyFuneralHome2=_interopRequireDefault(_NearbyFuneralHome);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _Header=__webpack_require__(98);var _Header2=_interopRequireDefault(_Header);var _breakPointChecker=__webpack_require__(368);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var config=(0,_AppConfig2.default)();var NearbyFuneralHomes=exports.NearbyFuneralHomes=function(_Component){(0,_inherits3.default)(NearbyFuneralHomes,_Component);function NearbyFuneralHomes(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,NearbyFuneralHomes);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=NearbyFuneralHomes.__proto__||(0,_getPrototypeOf2.default)(NearbyFuneralHomes)).call.apply(_ref,[this].concat(args))),_this),_this.state={largeMobile:false,smallMobile:false},_this.checkBreakPoint=function(){_this.setState({largeMobile:(0,_breakPointChecker.breakPointChecker)(500),smallMobile:(0,_breakPointChecker.breakPointChecker)(300)});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(NearbyFuneralHomes,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.checkBreakPoint);this.checkBreakPoint();}},{key:'renderNearbyFuneralHomes',value:function renderNearbyFuneralHomes(funeralHomes){if(funeralHomes){return funeralHomes.map(function(funeralHome,i){return _react2.default.createElement(_NearbyFuneralHome2.default,{funeralHome:funeralHome,key:i});});}return null;}},{key:'render',value:function render(){var _this2=this;var viewAllLink=config.vanityDomain+'/funeral-homes/directory/'+this.props.funeralHome.location.state.urlName+'/'+this.props.funeralHome.location.city.urlName;var title=function title(){if(_this2.state.smallMobile){return'Nearby';}else if(_this2.state.largeMobile){return'Nearby Homes';}return'Nearby Funeral Homes';};return _react2.default.createElement('div',{className:'nearby-funeral-homes-container'},_react2.default.createElement(_Header2.default,{type:'aside-header',className:'nearby-funeral-homes-container__title',title:title()},_react2.default.createElement('a',{href:viewAllLink,className:'nearby-funeral-homes-container__link'},'View all')),_react2.default.createElement('div',{className:'funeral-homes'},this.renderNearbyFuneralHomes(this.props.funeralHomes)));}}]);return NearbyFuneralHomes;}(_react.Component);NearbyFuneralHomes.propTypes={funeralHome:_react2.default.PropTypes.object,funeralHomes:_react2.default.PropTypes.array};var mapStateToProps=function mapStateToProps(state){return{funeralHome:state.funeralHomeStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(NearbyFuneralHomes);

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","nearby-funeral-homes-container__title":"nearby-funeral-homes-container__title","nearby-funeral-homes-container__link":"nearby-funeral-homes-container__link","TopLeaderboardNearbyHomes":"TopLeaderboardNearbyHomes","nearby-funeral-homes-container":"nearby-funeral-homes-container","funeral-homes":"funeral-homes","aside-contents":"aside-contents","funeral-homes-nearby":"funeral-homes-nearby","rating-scale":"rating-scale","rating":"rating","rating-positive":"rating-positive","partner":"partner","funeral-homes-nearby__text-container":"funeral-homes-nearby__text-container","funeral-homes-nearby__name":"funeral-homes-nearby__name","funeral-homes-nearby__location":"funeral-homes-nearby__location","funeral-homes-nearby__image":"funeral-homes-nearby__image"};

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.NearbyFuneralHome=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _placeholder=__webpack_require__(1577);var _placeholder2=_interopRequireDefault(_placeholder);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var config=(0,_AppConfig2.default)();var NearbyFuneralHome=exports.NearbyFuneralHome=function(_Component){(0,_inherits3.default)(NearbyFuneralHome,_Component);function NearbyFuneralHome(){(0,_classCallCheck3.default)(this,NearbyFuneralHome);return(0,_possibleConstructorReturn3.default)(this,(NearbyFuneralHome.__proto__||(0,_getPrototypeOf2.default)(NearbyFuneralHome)).apply(this,arguments));}(0,_createClass3.default)(NearbyFuneralHome,[{key:'positiveRating',value:function positiveRating(rating,starRating){return rating<=starRating?'rating-positive':null;}},{key:'buildFullRelativePath',value:function buildFullRelativePath(){var betaPath=config.baseUrl.beta;return betaPath+this.props.funeralHome.url;}},{key:'renderRating',value:function renderRating(starRating){var _this2=this;if(starRating){var ratingScale=[1,2,3,4,5];return _react2.default.createElement('div',{className:'rating-scale'},ratingScale.map(function(rating,i){return _react2.default.createElement('div',{key:i,className:(0,_classnames2.default)('rating',_this2.positiveRating(rating,starRating))});}));}return null;}},{key:'render',value:function render(){var _props$funeralHome=this.props.funeralHome,isPremium=_props$funeralHome.isPremium,name=_props$funeralHome.name,city=_props$funeralHome.city,state=_props$funeralHome.state,imageUrl=_props$funeralHome.imageUrl,starRating=_props$funeralHome.starRating;var partner=isPremium?_react2.default.createElement('div',{className:'partner'},'Partner'):null;var image=imageUrl?imageUrl:_placeholder2.default;return _react2.default.createElement('a',{className:'funeral-homes-nearby',href:this.buildFullRelativePath()},_react2.default.createElement('div',{className:'funeral-homes-nearby__image',style:{backgroundImage:'url('+image+')'}}),partner,_react2.default.createElement('div',{className:'funeral-homes-nearby__text-container'},this.renderRating(starRating),_react2.default.createElement('header',{className:'funeral-homes-nearby__name'},name),_react2.default.createElement('div',{className:'funeral-homes-nearby__location'},city,', ',state)));}}]);return NearbyFuneralHome;}(_react.Component);NearbyFuneralHome.propTypes={funeralHome:_react2.default.PropTypes.object};exports.default=NearbyFuneralHome;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/placeholder.c4c996f8.svg";

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Breadcrumbs=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);__webpack_require__(1579);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Breadcrumbs=exports.Breadcrumbs=function Breadcrumbs(props){var _ref=props.entity||{},name=_ref.name,location=_ref.location;var state=location&&location.state;var city=location&&location.city;var _ref2=props.affiliate||{},description=_ref2.description,siteName=_ref2.siteName;var homeDirectory=siteName?{url:'/obituaries/'+siteName,title:'Home'}:{url:'/',title:'Home'};var funeralHomesDirectory=description?{url:'/funeral-homes/directory',title:description+' Funeral Homes'}:{url:'/funeral-homes',title:'Funeral Homes'};var breadcrumbItems=[homeDirectory,funeralHomesDirectory];if(state&&city){breadcrumbItems.push({url:'/funeral-homes/directory/'+state.urlName,title:state.fullName},{url:'/funeral-homes/directory/'+state.urlName+'/'+city.urlName,title:city.fullName});}if(name){breadcrumbItems.push({title:name});}return _react2.default.createElement('div',{className:'breadcrumbs'},breadcrumbItems.map(function(item,index){return _react2.default.createElement('span',{key:index,className:'breadcrumb-item',itemScope:true,itemType:'http://data-vocabulary.org/Breadcrumb'},_react2.default.createElement('a',{href:item.url,itemProp:'url',className:'breadcrumb-link'},_react2.default.createElement('span',{itemProp:'title'},item.title)));}));};var mapStateToProps=function mapStateToProps(state){return{affiliate:state.affiliateStore};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Breadcrumbs);

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"funeral-home-profile":"funeral-home-profile","head-container":"head-container","breadcrumbs":"breadcrumbs","breadcrumb-item":"breadcrumb-item","breadcrumb-link":"breadcrumb-link"};

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.MobileOverlayAd=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(13);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRedux=__webpack_require__(12);var _legacyAdvertising=__webpack_require__(99);var _Svgs=__webpack_require__(36);var _MobileOverlayAd=__webpack_require__(1581);var _MobileOverlayAd2=_interopRequireDefault(_MobileOverlayAd);var _bind=__webpack_require__(1582);var _bind2=_interopRequireDefault(_bind);var _WithScrollPos=__webpack_require__(1583);var _WithScrollPos2=_interopRequireDefault(_WithScrollPos);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var cx=_bind2.default.bind(_MobileOverlayAd2.default);var THRESHOLD=400;var MobileOverlayAd=exports.MobileOverlayAd=function(_Component){(0,_inherits3.default)(MobileOverlayAd,_Component);function MobileOverlayAd(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,MobileOverlayAd);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=MobileOverlayAd.__proto__||(0,_getPrototypeOf2.default)(MobileOverlayAd)).call.apply(_ref,[this].concat(args))),_this),_this.state={slotLoaded:false,isClosed:false},_this.handleClick=function(){_this.setState({isClosed:true});},_this.handleAdEvent=function(eventName){// don't show the ad until it has loaded
if(eventName==='slotOnLoad'){_this.setState({slotLoaded:true});}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(MobileOverlayAd,[{key:'render',value:function render(){var _state=this.state,isClosed=_state.isClosed,slotLoaded=_state.slotLoaded;var thresholdTriggered=this.props.thresholdTriggered;/*
     * Display ad if:
     * - we're client side (window !== undefined)
     * - The window is less than or equal to 900px wide (max-width: 900px)
     */var displayAd=typeof window!=='undefined'&&window.matchMedia('(max-width: 900px)').matches;if(!displayAd){return null;}var _props=this.props,adService=_props.adService,positionId=_props.positionId;var classes=cx({MobileOverlay:true,isVisible:slotLoaded&&thresholdTriggered&&!isClosed});return _react2.default.createElement('div',{className:classes},_react2.default.createElement('button',{className:_MobileOverlayAd2.default.MobileOverlayCloseButton,onClick:this.handleClick},_react2.default.createElement(_Svgs.CloseXIcon,{size:14})),_react2.default.createElement(_legacyAdvertising.AdController,{onAdEvent:this.handleAdEvent,adService:adService,adSize:[[1,1],[728,90],[970,90],[320,50],'fluid'],pageName:'fh-profile',positionId:positionId,responsiveSizeMap:'mapping320x250DisplayOverlay1'}));}}]);return MobileOverlayAd;}(_react.Component);MobileOverlayAd.propTypes={adService:_propTypes2.default.shape({type:_propTypes2.default.instanceOf(_legacyAdvertising.AdService)}).isRequired,positionId:_propTypes2.default.string.isRequired};var mapStateToProps=function mapStateToProps(state){return{adService:state.adStore.adService};};exports.default=(0,_reactRedux.connect)(mapStateToProps)((0,_WithScrollPos2.default)(MobileOverlayAd,{threshold:THRESHOLD}));

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MobileOverlay":"MobileOverlay","isVisible":"isVisible","MobileOverlayCloseButton":"MobileOverlayCloseButton"};

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * HOC for getting the current scroll position
 * @param {Function} WrappedComponent Component to wrap with scroll position
 * @param {Object} options Additional options
 * @return {Function} Component with scroll position in props
 */function withScrollPos(WrappedComponent){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(_Component){(0,_inherits3.default)(_class2,_Component);function _class2(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,_class2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=_class2.__proto__||(0,_getPrototypeOf2.default)(_class2)).call.apply(_ref,[this].concat(args))),_this),_this.state={scrollPos:0,thresholdTriggered:false},_this.handleScroll=function(){var lastScrollPos=0;var ticking=false;lastScrollPos=window.scrollY||0;if(!ticking){window.requestAnimationFrame(function(){_this.setState({scrollPos:lastScrollPos,thresholdTriggered:_this.state.thresholdTriggered?_this.state.thresholdTriggered:lastScrollPos>=options.threshold});ticking=false;});ticking=true;}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(_class2,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.handleScroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);}},{key:'render',value:function render(){return _react2.default.createElement(WrappedComponent,(0,_extends3.default)({scrollPos:this.state.scrollPos,thresholdTriggered:this.state.thresholdTriggered},this.props));}}]);return _class2;}(_react.Component);}exports.default=withScrollPos;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var checkMq=function checkMq(){var mediaQuery=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return typeof window!=='undefined'&&window.matchMedia(mediaQuery).matches;};/**
 * HOC for providing matchMedia to child
 * @param {Function} WrappedComponent Component to wrap with scroll position
 * @param {Object} options Options
 * @return {Function} Component with scroll position in props
 */function withMediaQuery(WrappedComponent){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(_Component){(0,_inherits3.default)(_class2,_Component);function _class2(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,_class2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=_class2.__proto__||(0,_getPrototypeOf2.default)(_class2)).call.apply(_ref,[this].concat(args))),_this),_this.state={matches:checkMq(options.mediaQuery)},_this.handleResize=function(){var ticking=false;if(!ticking){window.requestAnimationFrame(function(){_this.setState({matches:checkMq(options.mediaQuery)});ticking=false;});ticking=true;}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(_class2,[{key:'componentDidMount',value:function componentDidMount(){if(typeof window!=='undefined'){window.addEventListener('resize',this.handleResize);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);}},{key:'render',value:function render(){return _react2.default.createElement(WrappedComponent,(0,_extends3.default)({matches:this.state.matches},this.props));}}]);return _class2;}(_react.Component);}exports.default=withMediaQuery;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Person=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(59);var _reactDom2=_interopRequireDefault(_reactDom);var _reactRedux=__webpack_require__(12);var _orientationchangeend=__webpack_require__(1586);var _orientationchangeend2=_interopRequireDefault(_orientationchangeend);var _Person=__webpack_require__(1588);var _Person2=_interopRequireDefault(_Person);var _PersonHero=__webpack_require__(1589);var _PersonHero2=_interopRequireDefault(_PersonHero);var _GuestBook=__webpack_require__(1608);var _GuestBook2=_interopRequireDefault(_GuestBook);var _StickyGbCta=__webpack_require__(1661);var _StickyGbCta2=_interopRequireDefault(_StickyGbCta);var _Obituary=__webpack_require__(1663);var _Obituary2=_interopRequireDefault(_Obituary);var _MainService=__webpack_require__(1667);var _MainService2=_interopRequireDefault(_MainService);var _ServiceInfo=__webpack_require__(1669);var _ServiceInfo2=_interopRequireDefault(_ServiceInfo);var _ResourcesBlock=__webpack_require__(1671);var _ResourcesBlock2=_interopRequireDefault(_ResourcesBlock);var _GalleryTeaser=__webpack_require__(1681);var _GalleryTeaser2=_interopRequireDefault(_GalleryTeaser);var _FlowersCta=__webpack_require__(1686);var _FlowersCta2=_interopRequireDefault(_FlowersCta);var _Questionnaire=__webpack_require__(1691);var _Questionnaire2=_interopRequireDefault(_Questionnaire);var _componentHelpers=__webpack_require__(26);var _personPageType=__webpack_require__(67);var _formatHelpers=__webpack_require__(55);var _orderHelpers=__webpack_require__(1698);var _scrollHelpers=__webpack_require__(372);var _urlHelpers=__webpack_require__(28);var _constants=__webpack_require__(41);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _legacyAdvertising=__webpack_require__(99);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conf=(0,_AppConfig2.default)();var FLOWERS_DATA_LAYER_MAP={HeadlineButton:{action:'HeadlineButton',category:'DeceasedHeadlineMod'},ServicesTopLink:{action:'TopLink',category:'FHMod'},ThankYouButton:{action:'gbthankyou',category:'gbthankyou'},FlowersCta:{action:'flowers_module',category:'flowers_module'},ObitModule:{action:'flowers_obit_header',category:'flowers_obit_header'}};/**
 * Person page module
 * @class   Person
 * @return  {JSX}     Returns the rendered module
 */var Person=exports.Person=function(_React$Component){(0,_inherits3.default)(Person,_React$Component);/**
   * Person React Component constructor
   * @param       {Object}    props   Passed in props
   * @param       {Object}    context Used for flux store
   * @constructs  {Person}
   * @return      {Undefined} Returns nothing
   */function Person(props){(0,_classCallCheck3.default)(this,Person);var _this=(0,_possibleConstructorReturn3.default)(this,(Person.__proto__||(0,_getPrototypeOf2.default)(Person)).call(this,props));_this.state={isSingleColumn:false,gallery:{show:false,initialId:null}};var person=props.person,location=props.location;var _ref=person||{},affiliates=_ref.affiliates,church=_ref.church,displayText=_ref.displayText,funeralHomes=_ref.funeralHomes,obitSources=_ref.obitSources,obituaries=_ref.obituaries,services=_ref.services,flowers=_ref.flowers,guestBook=_ref.guestBook,personLayout=_ref.personLayout;var _ref2=guestBook||{},allowGuestBook=_ref2.allowGuestBook,allowGuestBookPhoto=_ref2.allowGuestBookPhoto,allowGuestBookVideo=_ref2.allowGuestBookVideo,allowPersonPagePosting=_ref2.allowPersonPagePosting;var personPageType=personLayout.personPageType;_this.fpData={};var first=_lodash2.default.get(person,'name.first');var last=_lodash2.default.get(person,'name.last');var obitSourcesId=_lodash2.default.get(obitSources,'displayText')?_lodash2.default.head(obitSources.displayText):null;_this.allowGallery=allowGuestBook&&allowGuestBookPhoto&&allowGuestBookVideo&&allowPersonPagePosting;var layoutMapKey=allowGuestBook?_lodash2.default.get(_this.props,'person.personLayout.layout.left[0]','Obit'):'Obit';var pageTypeLayoutMapKey=(0,_personPageType.getPageTypeLayoutKey)(personPageType,layoutMapKey);_this.layoutMap=(0,_personPageType.getPageTypeLayoutMap)(personPageType,pageTypeLayoutMapKey);_this.getObjectByKey=(0,_orderHelpers.createGetObjectByKey)('sourceId');/* Links */_this.canonicalUrl=(0,_urlHelpers.buildUrl)(conf.vanityDomain,_lodash2.default.get(location,'pathname'),[{key:'pid',value:_lodash2.default.get(location,'query.pid')},{key:'sid',value:_lodash2.default.get(location,'query.sid')},{key:'v',value:_lodash2.default.get(location,'query.v')}]);/* Obituaries */_this.obituaries=(0,_orderHelpers.orderObjectList)(obituaries,_lodash2.default.get(person,'obitSources.person'),_this.getObjectByKey);var obitsWithPartners=_this.addInfoToObituaries(_this.obituaries,affiliates,funeralHomes,_this.getObjectByKey);_this.primaryDisplayTextObit=_this.getObjectByKey(obitSourcesId,obitsWithPartners);_this.displayObituaries=_lodash2.default.size(_this.obituaries)>0?_this.processObituaries(obitsWithPartners,(0,_personPageType.isFuneralHomePageType)(personPageType),_this.primaryDisplayTextObit):[];_this.hasPrimaryObit=_lodash2.default.isObject(_this.primaryDisplayTextObit);_this.primaryFuneralHome=_this.getObjectByKey(_this.primaryDisplayTextObit.funeralHomeId,funeralHomes);_this.funeralHomeAttribution=_this.getFuneralHomeAttribution(_this.primaryDisplayTextObit,_this.primaryFuneralHome);/* Flowers */var fhShowFlowers=personLayout.fhShowFlowers,showFlowersAndGifts=personLayout.showFlowersAndGifts;var _ref3=flowers||{},link=_ref3.link,source=_ref3.source,eventTagDateRecieved=_ref3.eventTagDateRecieved,eventTagDateDod=_ref3.eventTagDateDod;var showLegacyFlowerOnPartner=_this.shouldDisplayLegacyFlowerOnPartner(personPageType,source,link);var revShareAffiliateId=showLegacyFlowerOnPartner?_lodash2.default.get(_this.primaryDisplayTextObit,'affiliate.sourceId'):null;_this.showFlowers=showFlowersAndGifts&&fhShowFlowers&&link;_this.flowersLinks=_this.getFlowersUrls(link,source,showLegacyFlowerOnPartner,revShareAffiliateId);_this.flowersDataLayerObjs=_this.getDataLayerObjs(FLOWERS_DATA_LAYER_MAP,eventTagDateRecieved,eventTagDateDod,_this.getDataLayerObj);/* Text */_this.showReadMore=_lodash2.default.get(displayText,'showReadMore',false);_this.textToDisplay=_this.getTextToDisplay(personPageType,_lodash2.default.get(displayText,'text'),showLegacyFlowerOnPartner);/* Services */_this.flowersLocation=_this.getFlowersLocation(flowers);_this.serviceGroup=_this.addFlowersLink(_lodash2.default.cloneDeep({services:services,funeralHomes:funeralHomes,church:church}),flowers,_this.flowersLinks.page);_this.hasServices=_this.checkServices(_this.serviceGroup);/* Resources */_this.resources=_this.getFuneralHomeResources(personPageType);/* General */_this.isInferiorBrowser=(0,_componentHelpers.isInferiorBrowser)(typeof navigator==='undefined'?null:navigator);_this.title=(0,_formatHelpers.formatTitle)(first,last,_lodash2.default.get(location,'city'),_lodash2.default.get(location,'state'));(0,_componentHelpers.bindMethods)(_this,['flowerClickEvents','getGuestBookPosition','handleResize','handleModalClose','handleModalOpen','openCondolenceEntry','scrollToGuestbook','showGallery']);_this.initializeOrientationChange();return _this;}/**
   * Lifecycle method
   * @return {Undefined} Returns nothing
   */(0,_createClass3.default)(Person,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.handleResize);window.addEventListener('focus',this.handleResize);this.handleResize();}/**
   * Remove event listeners.
   * @return {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);window.removeEventListener('focus',this.handleResize);}/**
   * Initialize the orientationchangeend custom event
   * @return {Undefined} Returns nothing
   */},{key:'initializeOrientationChange',value:function initializeOrientationChange(){if(typeof window!=='undefined'){var OCE=(0,_orientationchangeend2.default)();var orientationchangeend=null;if(!('onorientationchangeend'in window)){window.onorientationchangeend=true;orientationchangeend=new CustomEvent('orientationchangeend');OCE.on('orientationchangeend',function(){window.dispatchEvent(orientationchangeend);});}}}/**
   * Opens the guestbook condolence entry
   * @return {Undefined} Returns nothing
   */},{key:'openCondolenceEntry',value:function openCondolenceEntry(){var guestbook=this.refs.guestbook.getWrappedInstance();guestbook.openCondolenceEntry();}/**
   * gets position of guestbook
   * @return {number} top position of guestbook
   */},{key:'getGuestBookPosition',value:function getGuestBookPosition(){var guestBookRect=_reactDom2.default.findDOMNode(this.refs.guestbook).getBoundingClientRect();var offsetTop=guestBookRect.top;return offsetTop;}/**
   * Scrolls to the guestbook entry
   * @return {undefined} returns nothing
   */},{key:'scrollToGuestbook',value:function scrollToGuestbook(){var scrollSpeed=300;var element=this.isInferiorBrowser?document.documentElement:document.body;(0,_scrollHelpers.scrollToTop)(element,Math.round(this.getGuestBookPosition()+window.scrollY),scrollSpeed,this.openCondolenceEntry);}/**
   * Constructs a data layer object based on properties for flowers
   * @param  {Object} eventTag Event Tag object
   * @param  {String} category The event category
   * @param  {String} action The event action
   * @param  {String} type The type of data layer obj
   * @return {Object} Data Layer Obj
   */},{key:'getDataLayerObj',value:function getDataLayerObj(eventTag,category,action,type){var dataLayerObj={};if(eventTag){var label=eventTag.label,value=eventTag.value;dataLayerObj.event='GAEvent';dataLayerObj.eventCategory='ByPage_Person_'+category+'_'+type;dataLayerObj.eventAction='SendFlowers_'+action+'_Click_'+type;dataLayerObj.eventLabel=label?label:'Person_DataType_null_'+type;if(value){dataLayerObj.eventValue=value;}}return dataLayerObj;}/**
   * Constructs the data layer objects needed for flower click events
   * @param  {Object}   flowersClickMap Map of the Flower buttons and their basic properties
   * @param  {Object}   eventTagDateRecieved Event Tag object
   * @param  {Object}   eventTagDateDod Event Tag object
   * @param  {Function} getDataLayerObj Data Layer construction function
   * @return {Object}   Object map of data layer object arrays
   */},{key:'getDataLayerObjs',value:function getDataLayerObjs(flowersClickMap,eventTagDateRecieved,eventTagDateDod,getDataLayerObj){var dataLayerObjs={};_lodash2.default.each(flowersClickMap,function(item,key){dataLayerObjs[key]=[];var dataLayerDateReceived=getDataLayerObj(eventTagDateRecieved,item.category,item.action,'DateReceived');var dataLayerDOD=getDataLayerObj(eventTagDateDod,item.category,item.action,'DOD');if(!_lodash2.default.isEmpty(dataLayerDateReceived)){dataLayerObjs[key].push(dataLayerDateReceived);}if(!_lodash2.default.isEmpty(dataLayerDOD)){dataLayerObjs[key].push(dataLayerDOD);}});return dataLayerObjs;}/**
   * Determines if the legacy flower should display on a Partner obit
   * @param  {String}     personPageType  the person page type
   * @param  {String}     source  the type of flower url potentially available to the page
   * @param  {String}     link  the flowers link url or empty string
   * @return {Undefined}  Returns whether the legacy flower link should be displayed
   */},{key:'shouldDisplayLegacyFlowerOnPartner',value:function shouldDisplayLegacyFlowerOnPartner(personPageType,source,link){var isPageTypeBatesville=(0,_personPageType.isBatesvillePageType)(personPageType);var isSourceFlowerTypeLegacy=source===_constants.FLOWER_TYPE_LEGACY;return isPageTypeBatesville&&isSourceFlowerTypeLegacy&&link;}/**
   * Pushes flower button click events to GA data layer.
   * @param  {String}     buttonPosition Label for button position.
   * @return {Undefined}  Returns nothing, pushes GA events to the dataLayer.
   */},{key:'flowerClickEvents',value:function flowerClickEvents(buttonPosition){if(this.flowersDataLayerObjs[buttonPosition]){_lodash2.default.each(this.flowersDataLayerObjs[buttonPosition],function(obj){if(window&&window.dataLayer){window.dataLayer.push(obj);}});}}/**
   * Gets the location for a the flowers link
   * @method getFlowersLocationInformation
   * @param  {Object} flowers Flowers information
   * @return {Object} Returns the flowers location object
   */},{key:'getFlowersLocation',value:function getFlowersLocation(flowers){var _ref4=flowers||{},funeralHome=_ref4.funeralHome,church=_ref4.church;return funeralHome||church||null;}/**
   * Adds flowers links to the appropriate partners
   * @method addFlowersLink
   * @param  {Object} serviceGroup Services, Funeral Homes, and Churches
   * @param  {Object} flowers      Flowers information
   * @param  {String} flowersLink  The page level flowers link
   * @return {Object} Returns an services group that has flowers links
   */},{key:'addFlowersLink',value:function addFlowersLink(serviceGroup,flowers,flowersLink){var _ref5=flowers||{},funeralHome=_ref5.funeralHome,church=_ref5.church;if(funeralHome){serviceGroup.funeralHomes.map(function(fh){if(fh.sourceId===funeralHome.sourceId){fh.flowersLink=flowersLink;return fh;}return fh;});serviceGroup.funeralHomes.sort(function(fh){return fh.flowersLink?-1:1;});}if(church){serviceGroup.church.flowersLink=flowersLink;}return serviceGroup;}/**
   * Get the Information to render a Resources Block
   * @method getFuneralHomeResources
   * @param  {String} personPageType the type of person page being rendered
   * @return {Object} Returns an object containing title plus array of resource objects
   */},{key:'getFuneralHomeResources',value:function getFuneralHomeResources(personPageType){var resources=[];var title='Advice & Support Resources';if((0,_personPageType.isForestLawnPageType)(personPageType)){title='Resources';resources=[{type:'flplanning',target:'_blank',asset:'flplanning.jpg',text:'Advanced Planning',url:'https://forestlawn.com/plan-ahead/'},{type:'flgrief',target:'_blank',asset:'flgrief.jpg',text:'Grief Support Services',url:'https://forestlawn.com/grief-resources/'},{type:'fllocations',target:'_blank',asset:'fllocations.jpg',text:'Cemetery Property',url:'https://forestlawn.com/locations/'}];}else{resources=[{type:'planning',target:'_self',asset:'planning.png',text:'Funeral Pre-Planning',url:conf.vanityDomain+'/funeral-homes/planning'},{type:'etiquette',target:'_self',asset:'etiquette.png',text:'Funeral & Sympathy Etiquette',url:conf.vanityDomain+'/news/advice-and-support/article/funeral-etiquette'},{type:'grief',target:'_self',asset:'grief.png',text:'Coping With Grief',url:conf.vanityDomain+'/news/advice-and-support/article/grief-support'},{type:'obitwriter',target:'_self',asset:'obitwriter.png',text:'Preserving Memories Forever',url:conf.vanityDomain+'/news/advice-and-support/article/how-to-preserve-our-precious-memories-forever'}];}return{title:title,resources:resources};}/**
   * Adds affilate and funeralHome information to obituaries
   * @param {Array}     obituaries The obituaries to loop through
   * @param {Array}     affiliates The affiliates list
   * @param {Array}     funeralHomes The funeralHome list
   * @param {Function}  getObjectByKey The function to fetch items from an object list
   * @return {Array} The mapped list of obituaries with the new info properties
   */},{key:'addInfoToObituaries',value:function addInfoToObituaries(obituaries,affiliates,funeralHomes,getObjectByKey){var obitsWithPartner=[];if(obituaries){obitsWithPartner=obituaries.map(function(obituary){var obit=_lodash2.default.cloneDeep(obituary);var affiliateId=obit.affiliateId,funeralHomeId=obit.funeralHomeId;obit.affiliate=getObjectByKey(affiliateId,affiliates);var noAffiliatePresent=funeralHomeId>1&&!_lodash2.default.get(obit,'affiliate.sourceId');var isFuneralHomePublisher=_lodash2.default.get(obit,'affiliate.affiliateType')==='Funeral Home Publisher';if(noAffiliatePresent||isFuneralHomePublisher){obit.funeralHome=getObjectByKey(funeralHomeId,funeralHomes);}return obit;});}return obitsWithPartner;}/**
   * Check to see if the service group should be displayed
   * @method checkServices
   * @param  {Object}   serviceGroup Services, Funeral Home, and Church
   * @return {Boolean}  Returns true if any service item is present
   */},{key:'checkServices',value:function checkServices(serviceGroup){var numberOfServices=_lodash2.default.keys(serviceGroup).length;var emptyServices=0;_lodash2.default.mapValues(serviceGroup,function(item){if(_lodash2.default.isEmpty(item)||!_lodash2.default.isArray(item)&&(!item.sourceId||item.sourceId===1)){emptyServices++;}});return numberOfServices>0&&emptyServices<numberOfServices;}/**
   * Constructs the flowers urls for Person and ThankYou components
   * @param   {String} flowersLink The basic flowers link
   * @param   {String} source The source of the flowers link
   * @param   {Boolean} allowLegacyFlower allow the partner obit to display a Legacy flower link
   * @param   {Number} revShareAffiliateId AffiliateId to add to flowers url for rev share
   * @return  {String} Returns the flowers url
   */},{key:'getFlowersUrls',value:function getFlowersUrls(flowersLink,source,allowLegacyFlower,revShareAffiliateId){var urls={page:'',thankYou:''};if(flowersLink){if(source===_constants.FLOWER_TYPE_LEGACY){if(allowLegacyFlower){urls.thankYou=flowersLink+'&rs=07';urls.page=flowersLink+'&rs=03';}}else{urls.thankYou=flowersLink;urls.page=flowersLink;}if(revShareAffiliateId){urls.thankYou=(0,_urlHelpers.addQueryParams)(urls.thankYou,{affiliateid:revShareAffiliateId});urls.page=(0,_urlHelpers.addQueryParams)(urls.page,{affiliateid:revShareAffiliateId});}}return urls;}/**
   * Gets the funeral home attribution if it's there and conditions are met
   * @param  {Object} primaryObit The primary obit
   * @param  {Object} primaryFuneralHome The primary obit's funeral home
   * @return {String} The funeral home attribution
   */},{key:'getFuneralHomeAttribution',value:function getFuneralHomeAttribution(primaryObit,primaryFuneralHome){var attribution='';var hasValidFuneralHome=_lodash2.default.get(primaryObit,'funeralHomeId',0)>1;if(primaryObit&&hasValidFuneralHome){var isFuneralHomePublisher=_lodash2.default.get(primaryObit,'affiliate.affiliateType')==='Funeral Home Publisher';if(!primaryObit.affiliateId||isFuneralHomePublisher){attribution=_lodash2.default.get(primaryFuneralHome,'name','');}}return attribution;}/**
   * Determines how much text to display based on the obit type
   * @method getTextToDisplay
   * @param   {String}  personPageType the type of person page being rendered
   * @param   {String}  text The display text
   * @param   {Boolean}  showFullTeaser Whether to show full text as teaser
   * @return  {String}  Returns the text to display
   */},{key:'getTextToDisplay',value:function getTextToDisplay(personPageType,text,showFullTeaser){var formattedText=text;var textToDisplay={teaser:'',full:''};var MAX_DESC_CHARS=300;var tags=['blockquote','p','a','ul','ol','nl','li','b','i','strong','em','strike','code','hr','table','thead','caption','tbody','tr','th','td','pre'];if((0,_personPageType.isForestLawnPageType)(personPageType)){formattedText=(0,_formatHelpers.simpleFormat)(text);tags.push('br');}var options={length:MAX_DESC_CHARS,separator:' '};if(formattedText){textToDisplay.full=(0,_formatHelpers.sanitizeText)(formattedText,tags);if(showFullTeaser){textToDisplay.teaser=textToDisplay.full;}else if(textToDisplay.full.length<=MAX_DESC_CHARS){textToDisplay.teaser=textToDisplay.full;}else{textToDisplay.teaser=_lodash2.default.flow(_lodash2.default.partial(_formatHelpers.sanitizeText,textToDisplay.full,[]),_lodash2.default.partial(_lodash2.default.truncate,_lodash2.default,options))();}}return textToDisplay;}/**
   * Filter out the obituaries before sending to the source group
   * - return obits that have a partner affiliation
   * - for a partner page, exclude the actual partner obit
   * @param  {Array} obituaries The obituaries to be filtered
   * @param  {Boolean} isPartnerPageType Is the person page is a partner obit page
   * @param  {Object} primaryDisplayTextObit The obit providing the display text
   * @return {Array} The filtered obituaries
   */},{key:'processObituaries',value:function processObituaries(obituaries,isPartnerPageType,primaryDisplayTextObit){return obituaries.filter(function(obituary){if(isPartnerPageType&&obituary.sourceId===primaryDisplayTextObit.sourceId){return false;}var isFuneralHome=!_lodash2.default.isNull(_lodash2.default.get(obituary,'funeralHome.sourceId',null));var isAffiliate=!_lodash2.default.isNull(_lodash2.default.get(obituary,'affiliate.sourceId',null));return isFuneralHome||isAffiliate;});}/**
   * shows gallery with given id
   * @param  {number} id the initial gallery id
   * @return {undefined} returns nothing
   */},{key:'showGallery',value:function showGallery(id){this.setState({gallery:{show:_lodash2.default.isNumber(id),initialId:id}});}/**
   * Modal close handler
   * @param {string} id Contains the instruction on what to do with the
   * gallery.
   * @return {Undefined} Returns nothing.
   */},{key:'handleModalClose',value:function handleModalClose(id){if(id==='showGallery'){this.showGallery();}}/**
   * Modal open handler
   * @return {Undefined} Returns nothing.
   */},{key:'handleModalOpen',value:function handleModalOpen(){this.setState({displayStickySignGuestBook:false});}/**
   * resize handler
   * @return {Undefined} Returns nothing
   */},{key:'handleResize',value:function handleResize(){var width=window.outerWidth;var singleColumn=940;if(width<singleColumn){if(!this.state.isSingleColumn){this.setState({isSingleColumn:true});}}else if(this.state.isSingleColumn){this.setState({isSingleColumn:false});}}/**
   * React Component render.
   * @return {JSX} Person page rendered.
   */},{key:'render',value:function render(){var layout={map:this.layoutMap,columns:this.state.isSingleColumn?'single':'dual'};var personPageType=this.props.person.personLayout.personPageType;var firstToFile=_lodash2.default.get(this.props,'person.customDimensions.firstToFile');var obituary=_react2.default.createElement(_Obituary2.default,{firstName:_lodash2.default.get(this.props,'person.name.first',''),flowerClickEvents:_lodash2.default.partial(this.flowerClickEvents,'ObitModule'),flowersLink:this.flowersLinks.page,funeralHomeAttribution:this.funeralHomeAttribution,hasPrimaryObit:this.hasPrimaryObit,parentLayout:layout,personPageType:personPageType,primaryDisplayTextObit:this.primaryDisplayTextObit,primaryFuneralHome:this.primaryFuneralHome,showFlowers:this.showFlowers,showReadMore:this.showReadMore,sourceGroup:_lodash2.default.size(this.displayObituaries)>0?this.displayObituaries:null,textToDisplay:this.textToDisplay});var guestbook=_react2.default.createElement(_GuestBook2.default,{allowGallery:this.allowGallery,canonicalUrl:this.canonicalUrl,count:_lodash2.default.get(this.props,'relay.variables.count'),flowersLink:this.flowersLinks.thankYou,flowersLocation:this.flowersLocation,fpData:this.fpData,galleryConfig:this.state.gallery,handleModalClose:this.handleModalClose,handleModalOpen:this.handleModalOpen,isInferiorBrowser:this.isInferiorBrowser,location:this.props.location,primaryFuneralHome:this.primaryFuneralHome,ref:'guestbook',thankYouFlowerClickEvents:_lodash2.default.partial(this.flowerClickEvents,'ThankYouButton'),title:this.title});var mainService=_react2.default.createElement(_MainService2.default,{flowerClickEvents:_lodash2.default.partial(this.flowerClickEvents,'ServicesTopLink'),flowersLink:this.flowersLinks.page,personPageType:personPageType,serviceGroup:this.serviceGroup,showFlowers:this.showFlowers});var serviceInfo=_react2.default.createElement(_ServiceInfo2.default,{serviceGroup:this.serviceGroup});var resourcesBlock=this.resources.resources.length>0?_react2.default.createElement(_ResourcesBlock2.default,{resources:this.resources.resources,title:this.resources.title}):null;var gallery=_react2.default.createElement(_GalleryTeaser2.default,{allowGallery:this.allowGallery,count:_lodash2.default.get(this.props,'person.guestBook.totalMediaCount'),isSingleColumn:this.state.isSingleColumn,items:_lodash2.default.chunk(_lodash2.default.get(this.props,'person.guestBookGallery.condolences.edges',[]),8)[0],openCondolenceEntry:this.scrollToGuestbook,showGalleryHandler:this.showGallery});var flowers=_react2.default.createElement(_FlowersCta2.default,{flowerClickEvents:_lodash2.default.partial(this.flowerClickEvents,'FlowersCta'),flowersLink:this.flowersLinks.page,personPageType:personPageType,showFlowers:this.showFlowers});var components={obituary:obituary,guestbook:guestbook,mainService:mainService,serviceInfo:serviceInfo,resourcesBlock:resourcesBlock,gallery:gallery,flowers:flowers};return _react2.default.createElement('div',{className:_Person2.default.Person},_react2.default.createElement(_StickyGbCta2.default,{display:this.state.displayStickySignGuestBook,getGuestBookPosition:this.getGuestBookPosition,guestBookHandler:this.scrollToGuestbook,hasSubmitted:_lodash2.default.has(this.props.mutationStatus,'condolence'),isSingleColumn:this.state.isSingleColumn}),_react2.default.createElement(_PersonHero2.default,{canonicalUrl:this.canonicalUrl,flowerClickEvents:_lodash2.default.partial(this.flowerClickEvents,'HeadlineButton'),flowersLink:this.flowersLinks.page,funeralHomeAttribution:this.funeralHomeAttribution,galleryCount:_lodash2.default.get(this.props,'person.guestBook.totalMediaCount'),isSingleColumn:this.state.isSingleColumn,person:this.props.person,personPageType:personPageType,scrollToGuestbook:this.scrollToGuestbook,showGalleryHandler:this.showGallery,title:this.title}),_react2.default.createElement('div',{className:_Person2.default.personContent},this.state.isSingleColumn?_react2.default.createElement('main',null,this.layoutMap.single.map(function(component,key){return _react2.default.createElement('div',{key:key},components[component]);})):_react2.default.createElement('main',null,_react2.default.createElement('div',{className:_Person2.default.left},this.layoutMap.dual.left.map(function(component,key){return _react2.default.createElement('div',{key:key},components[component]);})),_react2.default.createElement('div',{className:_Person2.default.right},this.layoutMap.dual.right.map(function(component,key){return _react2.default.createElement('div',{key:key},components[component]);})))),firstToFile===_constants.GA_SITENAMES.dignityMemorial?_react2.default.createElement(_legacyAdvertising.AdControl,{adService:this.props.ads.adService,adSize:_constants.AD_DIGNITY_MEMORIAL.adSize,clientLoadOnly:_constants.AD_DIGNITY_MEMORIAL.clientLoadOnly,maxIdleAdRefreshes:_constants.AD_DIGNITY_MEMORIAL.maxIdleAdRefreshes,pageName:_constants.AD_DIGNITY_MEMORIAL.pageName,positionId:_constants.AD_DIGNITY_MEMORIAL.positionId,slotName:_constants.AD_DIGNITY_MEMORIAL.slotName}):null,_lodash2.default.get(this.props,'person.showUGC')?_react2.default.createElement(_Questionnaire2.default,null):null);}}]);return Person;}(_react2.default.Component);/* istanbul ignore next */Person.propTypes={ads:_react2.default.PropTypes.object.isRequired,location:_react2.default.PropTypes.object,mutationStatus:_react2.default.PropTypes.object,person:_react2.default.PropTypes.object};var mapStateToProps=function mapStateToProps(state){return{ads:state.adStore,mutationStatus:_lodash2.default.get(state,'personStore.mutationStatus'),person:_lodash2.default.get(state,'personStore.person')};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(Person);

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var Event,
    Sister = __webpack_require__(1587);

Event = function Event (config) {
    var event,
        lastEnd,
        eventEmitter;

    if (!(this instanceof Event)) {
        return new Event(config);
    }

    eventEmitter = Sister();

    event = this;
    event.on = eventEmitter.on;

    config = config || {};

    /**
     * @var {Number} Number of iterations the subject of interval inspection must not mutate to fire "orientationchangeend".
     */
    config.noChangeCountToEnd = config.noChangeCountToEnd || 100;
    /**
     * @var {Number} Number of milliseconds after which fire the "orientationchangeend" if interval inspection did not do it before.
     */
    config.noEndTimeout = 1000 || config.noEndTimeout;
    /**
     * @var {Boolean} Enables logging of the events.
     */
    config.debug = config.debug || false;

    global
        .addEventListener('orientationchange', function () {
            var interval,
                timeout,
                end,
                lastInnerWidth,
                lastInnerHeight,
                noChangeCount;

            end = function (dispatchEvent) {
                clearInterval(interval);
                clearTimeout(timeout);

                interval = null;
                timeout = null;

                if (dispatchEvent) {
                    eventEmitter.trigger('orientationchangeend');
                }
            };

            // If there is a series of orientationchange events fired one after another,
            // where n event orientationchangeend event has not been fired before the n+2 orientationchange,
            // then orientationchangeend will fire only for the last orientationchange event in the series.
            if (lastEnd) {
                lastEnd(false);
            }

            lastEnd = end;

            interval = setInterval(function () {
                if (global.innerWidth === lastInnerWidth && global.innerHeight === lastInnerHeight) {
                    noChangeCount++;

                    if (noChangeCount === config.noChangeCountToEnd) {
                        if (config.debug) {
                            console.debug('setInterval');
                        }

                        end(true);
                    }
                } else {
                    lastInnerWidth = global.innerWidth;
                    lastInnerHeight = global.innerHeight;
                    noChangeCount = 0;
                }
            });
            timeout = setTimeout(function () {
                if (config.debug) {
                    console.debug('setTimeout');
                }

                end(true);
            }, config.noEndTimeout);
        });
}

global.gajus = global.gajus || {};
global.gajus.orientationchangeend = Event;

module.exports = Event;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
function Sister () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index != -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
}

global.gajus = global.gajus || {};
global.gajus.Sister = Sister;

module.exports = Sister;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","Person":"Person","solidBar":"solidBar","bottom":"bottom","dottedBar":"dottedBar","personContent":"personContent","adBottom":"adBottom","left":"left","right":"right","emptyData":"emptyData"};

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.PersonHero=undefined;var _slicedToArray2=__webpack_require__(614);var _slicedToArray3=_interopRequireDefault(_slicedToArray2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PersonHero=__webpack_require__(1596);var _PersonHero2=_interopRequireDefault(_PersonHero);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _imageChecker=__webpack_require__(615);var _imageChecker2=_interopRequireDefault(_imageChecker);var _PortraitImage=__webpack_require__(1597);var _PortraitImage2=_interopRequireDefault(_PortraitImage);var _HeroButtons=__webpack_require__(1599);var _HeroButtons2=_interopRequireDefault(_HeroButtons);var _BreadCrumbs=__webpack_require__(1601);var _BreadCrumbs2=_interopRequireDefault(_BreadCrumbs);var _library=__webpack_require__(40);var _componentHelpers=__webpack_require__(26);var _urlHelpers=__webpack_require__(28);var _shareHelpers=__webpack_require__(362);var _personPageType=__webpack_require__(67);var _moment=__webpack_require__(97);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable global-require */var Button=_library.FormControls.Button;/**
 * PersonHero Module
 * @class  PersonHero
 */var PersonHero=exports.PersonHero=function(_React$Component){(0,_inherits3.default)(PersonHero,_React$Component);/**
   * Constructor
   * @param  {Object}     props props object
   * @return {Undefined}  Returns nothing
   */function PersonHero(props){(0,_classCallCheck3.default)(this,PersonHero);var _this=(0,_possibleConstructorReturn3.default)(this,(PersonHero.__proto__||(0,_getPrototypeOf2.default)(PersonHero)).call(this,props));var _ref=props.person||{},dateOfBirth=_ref.dateOfBirth,dateOfDeath=_ref.dateOfDeath,fromToYears=_ref.fromToYears,age=_ref.age,location=_ref.location,locationDisplay=_ref.locationDisplay,_ref$obitSources=_ref.obitSources,obitSources=_ref$obitSources===undefined?{}:_ref$obitSources,_ref$obituaries=_ref.obituaries,obituaries=_ref$obituaries===undefined?[]:_ref$obituaries;var _obitSources$displayT=obitSources.displayText;_obitSources$displayT=_obitSources$displayT===undefined?[]:_obitSources$displayT;var _obitSources$displayT2=(0,_slicedToArray3.default)(_obitSources$displayT,1),obitId=_obitSources$displayT2[0];var obituarySource=_lodash2.default.find(obituaries,['sourceId',obitId])||{};_this.obituarySourceLink=obituarySource.href;_this.state={portraitImage:true};_this.config=(0,_AppConfig2.default)();_this.backgroundImg=__webpack_require__(1603)("./"+(0,_personPageType.getPageTypeBackgroundImage)(props.personPageType));_this.windowSizeBoundary=600;_this.maxBackgroundPhotos=1;_this.lifeSpan=_this.getLifeSpan(dateOfBirth,dateOfDeath,fromToYears,age);_this.location=_this.getLocation(location);_this.locationDisplay=(0,_personPageType.isBatesvillePageType)(props.personPageType)?null:_this.getLocationDisplay(locationDisplay);_this.shareItems=(0,_shareHelpers.ShareIcons)(props.canonicalUrl,props.title);(0,_componentHelpers.bindMethods)(_this,['handleSendFlowersClick','handleShareClick','handleWindowLoad']);return _this;}/**
   * Lifecycle
   * @returns {Undefined} Returns nothing
   */(0,_createClass3.default)(PersonHero,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('load',this.handleWindowLoad);}/**
   * Lifecycle
   * @returns {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('load',this.handleWindowLoad);}/**
   * Checks if a portrait image exists and sets the state
   * @param  {String} imageUrl The image's URL
   * @return {Undefined} Returns nothing
   */},{key:'checkPortraitImage',value:function checkPortraitImage(imageUrl){var image=(0,_imageChecker2.default)(imageUrl);if(!image){this.setState({portraitImage:false});}}/**
   * Handles when window is loaded and fires a check on the portrait image
   * @return {Undefined} Returns nothing
   */},{key:'handleWindowLoad',value:function handleWindowLoad(){if(_lodash2.default.get(this.props.person,'portraitImage.href')){this.checkPortraitImage(''+(0,_urlHelpers.buildUrl)(this.config.environmentalUrl.cacheUrl,this.props.person.portraitImage.href));}}/**
   * Creates a string of the person's birth date, death date, and age
   * @param  {String} dateOfBirth Person's birthdate
   * @param  {String} dateOfDeath Person's death date
   * @param  {String} fromToYears Person's birth year and death year (1981 - 2081)
   * @param  {Number} age Person's age
   * @returns {String} Returns a string representing the date that the person lived
   */},{key:'getLifeSpan',value:function getLifeSpan(dateOfBirth,dateOfDeath,fromToYears,age){var dateString='';// Birth Range
if(dateOfBirth&&dateOfDeath){var dob=_moment2.default.utc(dateOfBirth,'MMMM D, YYYY');var formattedDob=dob.format('MMM D, YYYY');var dod=_moment2.default.utc(dateOfDeath,'MMMM D, YYYY');var formattedDod=dod.format('MMM D, YYYY');dateString+=formattedDob+' - '+formattedDod;}else if(fromToYears){dateString+=fromToYears;}// Age
if(age){// There is no birth range so no paren's
if(dateString===''){dateString+='Age '+age;}else{dateString+=' (Age '+age+')';}}return dateString;}/**
   * Get either the city or the state or both
   * @method getLocation
   * @param  {Object}  location Person's location
   * @return {String}  Returns a person's location
   */},{key:'getLocation',value:function getLocation(location){var _ref2=location||{},city=_ref2.city,state=_ref2.state;var text=[city,state].filter(function(place){return place;}).join(', ');return text;}/**
   * Get either the city or the state or both
   * @method getLocationDisplay
   * @param  {Object}  locationDisplay Person's locationDisplay
   * @return {String}  Returns a person's location
   */},{key:'getLocationDisplay',value:function getLocationDisplay(locationDisplay){var _ref3=locationDisplay||{},city=_ref3.city,state=_ref3.state,country=_ref3.country;return _lodash2.default.compact([city,state,country]).join(', ');}/**
   * Constructs the URL for the See More link
   * @param  {String} firstName First name to search with
   * @param  {String} lastName  Last name to search with
   * @param  {String} domain The domain to search at
   * @return {String} The constructed See More link
   */},{key:'getSearchUrl',value:function getSearchUrl(firstName,lastName,domain){var queryParams=firstName&&lastName?'?daterange=all&firstname='+firstName+'&lastname='+lastName:'';return domain+'/ns/obitfinder/obituary-search.aspx'+queryParams;}/**
   * Renders Component
   * @return {JSX} Rendered PersonHero Component
   */},{key:'render',value:function render(){var _props=this.props,flowersLink=_props.flowersLink,flowerClickEvents=_props.flowerClickEvents,funeralHomeAttribution=_props.funeralHomeAttribution,galleryCount=_props.galleryCount,isSingleColumn=_props.isSingleColumn,person=_props.person,personPageType=_props.personPageType,scrollToGuestbook=_props.scrollToGuestbook,showGalleryHandler=_props.showGalleryHandler;var _ref4=person||{},name=_ref4.name,portraitImage=_ref4.portraitImage,guestBook=_ref4.guestBook,byPageLink=_ref4.byPageLink,sourceId=_ref4.sourceId,personLayout=_ref4.personLayout;var _ref5=name||{},first=_ref5.first,last=_ref5.last,full=_ref5.full;var _ref6=guestBook||{},allowGuestBook=_ref6.allowGuestBook,allowGuestBookEntry=_ref6.allowGuestBookEntry,guestBookLink=_ref6.guestBookLink,guestBookGALabel=_ref6.guestBookGALabel,totalCondolencesCount=_ref6.totalCondolencesCount;var _ref7=personLayout||{},pageTypeClass=_ref7.pageTypeClass;return _react2.default.createElement('div',{className:_PersonHero2.default[pageTypeClass]||_PersonHero2.default.PersonHero},_react2.default.createElement('div',{className:_PersonHero2.default.background},_react2.default.createElement('img',{src:this.backgroundImg}),_react2.default.createElement('div',{className:_PersonHero2.default.gradient})),_react2.default.createElement('div',{className:_PersonHero2.default.content},_react2.default.createElement(_BreadCrumbs2.default,{byPageUrl:this.config.vanityDomain+'/obituaries/local',name:name,pageTypeClass:pageTypeClass}),_react2.default.createElement('div',{className:_PersonHero2.default.infoGroup},_react2.default.createElement('div',{className:_PersonHero2.default.personHeroLeft},_react2.default.createElement(_PortraitImage2.default,{attribution:funeralHomeAttribution,cacheUrl:this.config.environmentalUrl.cacheUrl,firstname:first,galleryCount:galleryCount,isValidImage:this.state.portraitImage,lastname:last,portraitImage:_lodash2.default.get(portraitImage,'href'),showGalleryHandler:showGalleryHandler,showPortrait:this.state.portraitImage})),_react2.default.createElement('div',{className:_PersonHero2.default.personHeroRight},_react2.default.createElement('h1',{className:_PersonHero2.default.name},full?full:''),_react2.default.createElement('p',{className:_PersonHero2.default.date},this.lifeSpan),_react2.default.createElement('p',{className:_PersonHero2.default.location},this.locationDisplay),_react2.default.createElement(_HeroButtons2.default,{allowGuestBook:allowGuestBook,allowGuestBookEntry:allowGuestBookEntry,allowPersonPagePosting:true,fhShowFlowers:_lodash2.default.get(personLayout,'fhShowFlowers'),flowerClickEvents:flowerClickEvents,flowersLink:flowersLink,guestBookGALabel:guestBookGALabel,guestBookLink:_lodash2.default.get(guestBookLink,'href'),isSingleColumn:isSingleColumn,layout:_lodash2.default.get(personLayout,'layout.left[0]','Obit'),obituarySourceLink:this.obituarySourceLink,personPageType:personPageType,pageTypeClass:pageTypeClass,scrollToGuestbook:scrollToGuestbook,showFlowersAndGifts:_lodash2.default.get(personLayout,'showFlowersAndGifts'),sourceId:sourceId,totalCondolencesCount:totalCondolencesCount}))),_react2.default.createElement('aside',{className:_PersonHero2.default.extras},_react2.default.createElement('div',{className:_PersonHero2.default.shares},this.shareItems.map(function(obj,i){return _react2.default.createElement(Button,{btnType:'none',className:_PersonHero2.default.icons,handleClick:_lodash2.default.partial(_shareHelpers.HandleShareClick,_lodash2.default,obj.shareUrl,obj.label),id:obj.label,key:i},_react2.default.createElement('span',{className:_PersonHero2.default[obj.label]},obj.svg));})),_react2.default.createElement('a',{className:_PersonHero2.default.search,href:byPageLink||this.getSearchUrl(first,last,this.config.vanityDomain),target:'_blank'},'Not the right person? See All \u203A'))));}}]);return PersonHero;}(_react2.default.Component);PersonHero.propTypes={canonicalUrl:_react2.default.PropTypes.string,flowerClickEvents:_react2.default.PropTypes.func,flowersLink:_react2.default.PropTypes.string,funeralHomeAttribution:_react2.default.PropTypes.string,galleryCount:_react2.default.PropTypes.number,isSingleColumn:_react2.default.PropTypes.bool,scrollToGuestbook:_react2.default.PropTypes.func,person:_react2.default.PropTypes.object,personPageType:_react2.default.PropTypes.string,showGalleryHandler:_react2.default.PropTypes.func,title:_react2.default.PropTypes.string};exports.default=PersonHero;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1591), __esModule: true };

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(209);
__webpack_require__(158);
module.exports = __webpack_require__(1592);


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(367);
var ITERATOR = __webpack_require__(45)('iterator');
var Iterators = __webpack_require__(133);
module.exports = __webpack_require__(35).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1594), __esModule: true };

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(209);
__webpack_require__(158);
module.exports = __webpack_require__(1595);


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(77);
var get = __webpack_require__(366);
module.exports = __webpack_require__(35).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","PersonHero":"PersonHero","background":"background","gradient":"gradient","content":"content","infoGroup":"infoGroup","personHeroLeft":"personHeroLeft","personHeroRight":"personHeroRight","name":"name","date":"date","location":"location","extras":"extras","shares":"shares","icons":"icons","facebook":"facebook","twitter":"twitter","email":"email","search":"search","forestlawnView":"forestlawnView PersonHero"};

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PortraitImage=__webpack_require__(1598);var _PortraitImage2=_interopRequireDefault(_PortraitImage);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _Svgs=__webpack_require__(36);var _urlHelpers=__webpack_require__(28);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CANDLE_JPG=__webpack_require__(616);/**
 * The portait image item in the hero section of the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns a portait image
 */var PortraitImage=function PortraitImage(props){var firstname=props.firstname,galleryCount=props.galleryCount,lastname=props.lastname,isValidImage=props.isValidImage,portraitImage=props.portraitImage,showPortrait=props.showPortrait,showGalleryHandler=props.showGalleryHandler;var altText=[firstname,lastname,'Obituary'].filter(function(text){return text;}).join('-');var image=_react2.default.createElement('div',{className:_PortraitImage2.default.PortraitImage},_react2.default.createElement('div',{className:_PortraitImage2.default.imageHolder},_react2.default.createElement('div',{className:_PortraitImage2.default.image},_react2.default.createElement('img',{alt:altText,src:CANDLE_JPG}))));var hasLink=showPortrait||galleryCount;if(isValidImage&&portraitImage){var attribution=props.attribution,cacheUrl=props.cacheUrl;image=_react2.default.createElement('div',{className:_PortraitImage2.default.PortraitImage},_react2.default.createElement('div',{className:_PortraitImage2.default.imageHolder},_react2.default.createElement('div',{className:_PortraitImage2.default.image},_react2.default.createElement('img',{alt:altText,className:hasLink?_PortraitImage2.default.active:'',onClick:hasLink?_lodash2.default.partial(showGalleryHandler,0):null,src:''+(0,_urlHelpers.buildUrl)(cacheUrl,portraitImage)}),hasLink?_react2.default.createElement(_Svgs.GalleryIcon,null):null),attribution?_react2.default.createElement('p',{className:_PortraitImage2.default.imageAttribution},'Photo courtesy of ',attribution):null));}return image;};PortraitImage.propTypes={attribution:_react2.default.PropTypes.string,cacheUrl:_react2.default.PropTypes.string,firstname:_react2.default.PropTypes.string,galleryCount:_react2.default.PropTypes.number,isValidImage:_react2.default.PropTypes.bool,lastname:_react2.default.PropTypes.string,portraitImage:_react2.default.PropTypes.string,showGalleryHandler:_react2.default.PropTypes.func,showPortrait:_react2.default.PropTypes.bool};exports.default=PortraitImage;

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","PortraitImage":"PortraitImage","imageHolder":"imageHolder","image":"image","active":"active","imageAttribution":"imageAttribution"};

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _HeroButtons=__webpack_require__(1600);var _HeroButtons2=_interopRequireDefault(_HeroButtons);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _library=__webpack_require__(40);var _componentHelpers=__webpack_require__(26);var _GAHelpers=__webpack_require__(22);var _personPageType=__webpack_require__(67);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Dropdown=_library.FormControls.Dropdown,Button=_library.FormControls.Button;var conf=(0,_AppConfig2.default)();/**
 * Person Hero buttons
 * @param   {Object}  props Passed in properties
 * @return  {JSX}     Returns the Buttons and Dropdown of the Person Hero
 */var HeroButtons=function(_React$Component){(0,_inherits3.default)(HeroButtons,_React$Component);function HeroButtons(props){(0,_classCallCheck3.default)(this,HeroButtons);var _this=(0,_possibleConstructorReturn3.default)(this,(HeroButtons.__proto__||(0,_getPrototypeOf2.default)(HeroButtons)).call(this,props));_this.state={isDropdownToggled:false};(0,_componentHelpers.bindMethods)(_this,['flowersClickHandler','getButtonItems','getDropdownItems','getMainButtonItem','getPriorities','getPrioritizedCtaItems','readObituaryHandler','setupButtons','signGbClickHandler','toggleDropdown']);return _this;}/**
   * Sets up the buttons for rendering
   * Has to be done during render and not in constructor only
   * because buttons can change from single to multi column views
   * @return {undefined}  returns nothing
   */(0,_createClass3.default)(HeroButtons,[{key:'setupButtons',value:function setupButtons(){var ctaItems=[];var _props=this.props,allowGuestBookEntry=_props.allowGuestBookEntry,allowGuestBook=_props.allowGuestBook,fhShowFlowers=_props.fhShowFlowers,flowersLink=_props.flowersLink,flowerClickEvents=_props.flowerClickEvents,isSingleColumn=_props.isSingleColumn,obituarySourceLink=_props.obituarySourceLink,personPageType=_props.personPageType,showFlowersAndGifts=_props.showFlowersAndGifts,sourceId=_props.sourceId,totalCondolencesCount=_props.totalCondolencesCount;if(flowersLink&&showFlowersAndGifts&&fhShowFlowers){ctaItems.push({ctaType:'sendFlowers',displayText:'Send Flowers',screenReader:'Opens send flowers url in a new window',props:{className:_HeroButtons2.default.mainButton,handleClick:_lodash2.default.partial(this.flowersClickHandler,flowersLink,flowerClickEvents),id:'FlowersHeader'}});}if(!isSingleColumn&&(0,_personPageType.useButtonsWithoutDropdown)(personPageType)){ctaItems.push({ctaType:'readObituary',displayText:'Read Obituary',screenReader:'Opens source obituary in a new window',props:{className:_HeroButtons2.default.mainButton,handleClick:_lodash2.default.partial(this.readObituaryHandler,obituarySourceLink),id:'ReadObituaryHeader'}});}else if(allowGuestBookEntry){ctaItems.push({ctaType:'signGuestBook',displayText:'Sign Guest Book',screenReader:'Scrolls to Condolence Entry',props:{className:_HeroButtons2.default.mainButton+' '+_HeroButtons2.default.signGBMainButton,handleClick:this.signGbClickHandler(),id:'SignGuestBookEntryHeader'}});}var prioritizedCtaItems=this.getPrioritizedCtaItems(ctaItems,this.getPriorities());if((0,_personPageType.useButtonsWithoutDropdown)(personPageType)){this.buttons=this.getButtonItems(prioritizedCtaItems);this.hasButtons=!_lodash2.default.isEmpty(this.buttons);}else{this.dropdownItems=this.getDropdownItems(prioritizedCtaItems);this.hasDropDown=!_lodash2.default.isEmpty(this.dropdownItems);this.mainButton=this.getMainButtonItem(prioritizedCtaItems);this.hasMainButton=!_lodash2.default.isEmpty(this.mainButton);}}/**
   * Determines the priorities of the CTA items
   * @method getPriorities
   * @return {array}  returns the ordered list of prioritized items
   */},{key:'getPriorities',value:function getPriorities(){return['sendFlowers','readObituary','signGuestBook'];}/**
   * Takes a list of cta items and injects the appropriate priority
   * NOTE: ctaTypes in the priorities need to match the ctaTypes in ctaItems
   * @method getPrioritizedCtaItems
   * @param  {array}  ctaItems    List of ctaItems without the priority property
   * @param  {array}  priorities  List of priorities
   * @return {array}  returns the list of ctaItems with the priority property
   */},{key:'getPrioritizedCtaItems',value:function getPrioritizedCtaItems(ctaItems,priorities){var priority=1;return _lodash2.default.reduce(priorities,function(result,ctaType){_lodash2.default.map(ctaItems,function(item){if(ctaType===item.ctaType){item.priority=priority;priority++;result.push(item);}});return result;},[]);}/**
   * Gets the first priority ctaItem for the button display
   * @method getMainButtonItem
   * @param  {array}  prioritizedCtaItems The ctaItems with priority
   * @return {object} returns the button data object
   */},{key:'getMainButtonItem',value:function getMainButtonItem(prioritizedCtaItems){var button=_lodash2.default.find(prioritizedCtaItems,function(item){return item.priority===1;});if(button){button.props.btnType='none';button.props.type='button';button.displayText=_react2.default.createElement('span',{'data-ga-no-auto-tag':'true'},button.displayText,_react2.default.createElement('span',{className:_HeroButtons2.default.srOnly},button.screenReader));}return button;}/**
   * Gets the ctaItems for the buttons
   * @method getButtonItems
   * @param  {array}  prioritizedCtaItems The ctaItems with priority
   * @return {array} returns an array of the button data objects
   */},{key:'getButtonItems',value:function getButtonItems(prioritizedCtaItems){var buttons=prioritizedCtaItems.map(function(ctaItem){ctaItem.props.btnType='none';ctaItem.props.type='button';ctaItem.props.className=_HeroButtons2.default.mainButton+' '+(ctaItem.ctaType==='sendFlowers'?_HeroButtons2.default.primaryButton:_HeroButtons2.default.secondaryButton);ctaItem.displayText=_react2.default.createElement('span',{'data-ga-no-auto-tag':'true'},ctaItem.displayText,_react2.default.createElement('span',{className:_HeroButtons2.default.srOnly},ctaItem.screenReader));return ctaItem;});return _lodash2.default.orderBy(buttons,['priority']);}/**
   * Gets the ctaItems for the dropdown and orders them based on priority
   * @method getDropdownItems
   * @param  {array}  prioritizedCtaItems List of ctaItems with priority
   * @return {array}  returns the ordered array of dropdown diplay objects
   */},{key:'getDropdownItems',value:function getDropdownItems(prioritizedCtaItems){var filteredCtaItems=_lodash2.default.reduce(prioritizedCtaItems,function(result,item){if(item.priority>1){item.displayText=_react2.default.createElement('span',{'data-ga-no-auto-tag':'true'},item.displayText,_react2.default.createElement('span',{className:_HeroButtons2.default.srOnly},item.screenReader));item.props.onClick=item.props.handleClick;// eslint-disable-next-line
delete item.props.handleClick;result.push(item);}return result;},[]);return _lodash2.default.orderBy(filteredCtaItems,['priority']);}/**
   * Fires the flowers GA event function, then opens the flowers link in a new window
   * @method flowersClickHandler
   * @param  {string}     flowersLink       Link for sympathy flowers
   * @param  {function}   flowerClickEvents GA events for flowers
   * @return {undefined}  returns nothing
   */},{key:'flowersClickHandler',value:function flowersClickHandler(flowersLink,flowerClickEvents){if(_lodash2.default.isFunction(flowerClickEvents)){flowerClickEvents();}window.open(flowersLink,'_blank');}/**
   * Opens the obituary link in a new window
   * @method readObituaryHandler
   * @param  {string}     obituarySourceLink  Link for external obit
   * @return {undefined}  returns nothing
   */},{key:'readObituaryHandler',value:function readObituaryHandler(obituarySourceLink){window.open(obituarySourceLink,'_blank');}/**
   * Scrolls to the guest book and fires the GA events
   * @method signGbClickHandler
   * @return {undefined} returns nothing
   */},{key:'signGbClickHandler',value:function signGbClickHandler(){var _this2=this;return function(e){e.preventDefault();_this2.props.scrollToGuestbook();(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'sign_guest_book_header',eventLabel:'onpage'});};}/**
   * Toggles whether the dropdown is open or closed
   * @return {undefined} returns nothing
   */},{key:'toggleDropdown',value:function toggleDropdown(){this.setState({isDropdownToggled:!this.state.isDropdownToggled});}},{key:'render',value:function render(){var pageTypeClass=this.props.pageTypeClass;this.setupButtons();return _react2.default.createElement('span',{className:_HeroButtons2.default[pageTypeClass]||_HeroButtons2.default.HeroButtons},this.hasButtons?this.buttons.map(function(button){return _react2.default.createElement(Button,(0,_extends3.default)({key:button.props.id},button.props),button.displayText);}):null,this.hasMainButton?_react2.default.createElement(Button,this.mainButton.props,this.mainButton.displayText):null,this.hasDropDown?_react2.default.createElement(Dropdown,{btnClassName:_HeroButtons2.default.heroDropdownBtn,className:_HeroButtons2.default.heroDropdown,dropdownItems:this.dropdownItems,id:'heroDropDown',isDropdownToggled:this.state.isDropdownToggled,tetherAttachment:'top right',tetherOffset:'-5px 0',tetherTargetAttachment:'bottom right',toggleDropdown:this.toggleDropdown}):null);}}]);return HeroButtons;}(_react2.default.Component);HeroButtons.propTypes={allowGuestBook:_react2.default.PropTypes.bool,allowGuestBookEntry:_react2.default.PropTypes.bool,allowPersonPagePosting:_react2.default.PropTypes.bool,fhShowFlowers:_react2.default.PropTypes.bool,flowerClickEvents:_react2.default.PropTypes.func,flowersLink:_react2.default.PropTypes.string,guestBookGALabel:_react2.default.PropTypes.string,guestBookLink:_react2.default.PropTypes.string,isSingleColumn:_react2.default.PropTypes.bool,layout:_react2.default.PropTypes.string,obituarySourceLink:_react2.default.PropTypes.string,pageTypeClass:_react2.default.PropTypes.string,personPageType:_react2.default.PropTypes.string,scrollToGuestbook:_react2.default.PropTypes.func,showFlowersAndGifts:_react2.default.PropTypes.bool,sourceId:_react2.default.PropTypes.number,totalCondolencesCount:_react2.default.PropTypes.number};exports.default=HeroButtons;

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","HeroButtons":"HeroButtons","mainButton":"mainButton","primaryButton":"primaryButton","secondaryButton":"secondaryButton","signGBMainButton":"signGBMainButton","heroDropdown":"heroDropdown","heroDropdownBtn":"heroDropdownBtn","forestlawnView":"forestlawnView HeroButtons"};

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _BreadCrumbs=__webpack_require__(1602);var _BreadCrumbs2=_interopRequireDefault(_BreadCrumbs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BreadCrumbs=function BreadCrumbs(props){var byPageUrl=props.byPageUrl,name=props.name,pageTypeClass=props.pageTypeClass;return _react2.default.createElement('div',{className:_BreadCrumbs2.default[pageTypeClass]||_BreadCrumbs2.default.BreadCrumbs},_react2.default.createElement('a',{href:'/',target:'_self'},'Home'),_react2.default.createElement('a',{href:byPageUrl,target:'_self'},'Obituaries'),name&&name.short?_react2.default.createElement('a',{className:_BreadCrumbs2.default.active,href:'#'},name.short,' Obituary'):null);};BreadCrumbs.propTypes={byPageUrl:_react2.default.PropTypes.string,name:_react2.default.PropTypes.object,pageTypeClass:_react2.default.PropTypes.string};exports.default=BreadCrumbs;

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","BreadCrumbs":"BreadCrumbs","active":"active","forestlawnView":"forestlawnView BreadCrumbs"};

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./batesville-hero-2x.jpg": 1604,
	"./candle.jpg": 616,
	"./forestlawn-hero-2x.jpg": 1605,
	"./hero-img-2x.jpg": 1606,
	"./share_candle.png": 1607
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1603;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/batesville-hero-2x.f56ec3e8.jpg";

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/forestlawn-hero-2x.9641dc0f.jpg";

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hero-img-2x.1ac75a39.jpg";

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/share_candle.7ecfc8bd.png";

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.GuestBook=undefined;var _promise=__webpack_require__(370);var _promise2=_interopRequireDefault(_promise);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(59);var _reactDom2=_interopRequireDefault(_reactDom);var _reactRedux=__webpack_require__(12);var _GuestBook=__webpack_require__(1619);var _GuestBook2=_interopRequireDefault(_GuestBook);var _CondolenceItem=__webpack_require__(621);var _CondolenceItem2=_interopRequireDefault(_CondolenceItem);var _CondolenceCollection=__webpack_require__(1628);var _CondolenceCollection2=_interopRequireDefault(_CondolenceCollection);var _ThankYou=__webpack_require__(1632);var _ThankYou2=_interopRequireDefault(_ThankYou);var _CondolenceEntry=__webpack_require__(1635);var _CondolenceEntry2=_interopRequireDefault(_CondolenceEntry);var _EntryNav=__webpack_require__(1645);var _EntryNav2=_interopRequireDefault(_EntryNav);var _CaptionContainer=__webpack_require__(1653);var _CaptionContainer2=_interopRequireDefault(_CaptionContainer);var _library=__webpack_require__(40);var _ErrorDisplay=__webpack_require__(1657);var _ErrorDisplay2=_interopRequireDefault(_ErrorDisplay);var _componentHelpers=__webpack_require__(26);var _constants=__webpack_require__(41);var CONSTANTS=_interopRequireWildcard(_constants);var _GAHelpers=__webpack_require__(22);var _scrollHelpers=__webpack_require__(372);var _urlHelpers=__webpack_require__(28);var _personAlertHelper=__webpack_require__(1659);var _condolenceHelper=__webpack_require__(1660);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Button=_library.FormControls.Button;var ENTRY_KEY=CONSTANTS.ENTRY_KEY;var VIDEO_MODAL_PADDING=12;/**
 * GuestBook page module.
 * @class   GuestBook
 * @prop    {Object}  person - An obituary with a list of condolences
 * @return  {JSX}     Returns the rendered module
 */var GuestBook=exports.GuestBook=function(_React$Component){(0,_inherits3.default)(GuestBook,_React$Component);function GuestBook(props){(0,_classCallCheck3.default)(this,GuestBook);var _this=(0,_possibleConstructorReturn3.default)(this,(GuestBook.__proto__||(0,_getPrototypeOf2.default)(GuestBook)).call(this,props));_this.state={captionsOverlayCount:0,condolenceEntry:{},condolenceCount:9,currentOverlayID:null,fetchingData:false,galleryItemModalIndex:0,hubItemModalIndex:0,isCandleLit:false,isExpanded:false,isInitialUpload:false,isPhone:false,mediaCollection:null,scrollPosition:null,pendingUpload:false,showAudioOverlay:false,showCaptionsOverlay:false,showGallery:false,showOverlay:false,showThankYou:false,showVideoOverlay:false,submittingCondolence:false,condolenceError:false};_this.currentPage=1;_this.resizeHeight=false;_this.resizeWidth=false;_this.element=null;_this.pid=_lodash2.default.get(props,'personStore.person.personId');_this.pageLayout=_lodash2.default.get(props,'personStore.person.personLayout.layout.left[0]','Obit');_this.allowGuestBook=_lodash2.default.get(props,'personStore.person.guestBook.allowGuestBook');_this.showFlowers=_lodash2.default.get(props,'personStore.person.personLayout.showFlowersAndGifts',true)&&_lodash2.default.get(props,'personStore.person.personLayout.fhShowFlowers',true);_this.submissionData={firstName:'',lastName:''};/* refs */_this[ENTRY_KEY]=null;_this.setRefEntry=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,ENTRY_KEY,_this);(0,_componentHelpers.bindMethods)(_this,['getAdditionalPayload','getAdditionalGalleryPayload','handleCondolenceSubmission','handleDisplayError','handleCondolenceSubmitSuccess','handleEntryToggle','handleMediaCollection','handleGuestBookClick','handleModalClose','handleModalOpen','handleModalResize','handleModalVideoResize','handlePendingUpload','openEditOverlay','handleSetGalleryModalIndex','handleSetItemModalIndex','openCondolenceEntry','toggleCandleLighting','updateModalHeight']);return _this;}(0,_createClass3.default)(GuestBook,[{key:'componentDidMount',value:function componentDidMount(){if(typeof window!=='undefined'){var galleryCondolences=_lodash2.default.get(this.props,'personStore.person.guestBookGallery');var mediaCount=_lodash2.default.get(this.props,'personStore.person.guestBook.totalMediaCount',0);this.element=this.props.isInferiorBrowser?document.documentElement:document.body;window.addEventListener('orientationchangeend',this.handleModalVideoResize);(0,_urlHelpers.updateHistory)(window,this.props.location,this.pageLayout,this.allowGuestBook,this.pid);if(this.props.allowGallery&&mediaCount!==0){if(galleryCondolences){var currentMediaCount=_lodash2.default.get(galleryCondolences,'condolences.edges',[]).length;var outsideMediaCount=_lodash2.default.reduce(_lodash2.default.get(galleryCondolences,'condolences.edges',[]).slice(0,3),function(total,item){return total+(_lodash2.default.get(item,'node.isNonCondolenceMedia',false)?1:0);},0);currentMediaCount-=outsideMediaCount;if(currentMediaCount<mediaCount&&currentMediaCount<8){this.getAdditionalGalleryPayload();}}else{this.getAdditionalGalleryPayload();}}this.detectIsPhone();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var stateObj={};if(_lodash2.default.get(nextProps,'galleryConfig.show',false)){stateObj.showGallery=nextProps.galleryConfig.show;stateObj.galleryItemModalIndex=this.props.galleryConfig.initialId||this.props.galleryConfig.initialId===0?this.state.galleryItemModalIndex:nextProps.galleryConfig.initialId;}/* fetching additional condolences */if(!nextProps.personStore.loading&&this.state.fetchingData){stateObj.fetchingData=false;}if(!_lodash2.default.isEmpty(stateObj)){this.setState(stateObj);}var currentCondolences=_lodash2.default.get(nextProps,'personStore.person.guestBook.condolences.edges');var nextCondolences=_lodash2.default.get(this.props,'personStore.person.guestBook.condolences.edges');if(_lodash2.default.size(currentCondolences)>_lodash2.default.size(nextCondolences)){this.currentPage++;}var condolenceMutationStatus=_lodash2.default.get(nextProps,'personStore.mutationStatus.condolence');/* condolence submission handlers */if(_lodash2.default.isNumber(condolenceMutationStatus)){this.handlePendingUpload(false,null);if(condolenceMutationStatus>0){this.handleCondolenceSubmitSuccess(_lodash2.default.get(this.submissionData,'firstName',''),_lodash2.default.get(this.submissionData,'lastName',''));}else{this.handleDisplayError('submission');}this.props.resetMutationStatus(condolenceMutationStatus);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('orientationchangeend',this.handleModalVideoResize);}/**
   * Phone detection that gets run after component mounts
   * NOTE: This should be removed after the desktop design catches up to the phone design - this is a temporary fixe
   *   to bypass a warning where server rendering did not match client rendering
   * @return {Undefined} Returns nothing
   */},{key:'detectIsPhone',value:function detectIsPhone(){var isPhone=this.props.mobileDetails.phone;if(isPhone===true){this.setState({isPhone:isPhone});}}/**
   * Handles infinite scrolling by setting count
   * @method getAdditionalPayload
   * @param  {Number} currentPage     The current page
   * @return {Undefined} Returns nothing
   */},{key:'getAdditionalPayload',value:function getAdditionalPayload(currentPage){if(!this.state.fetchingData){var queryParams={sourceId:_lodash2.default.get(this.props,'personStore.person.sourceId'),count:9,cursor:_lodash2.default.get(this.props,'personStore.person.guestBook.condolences.pageInfo.endCursor')};if(queryParams.sourceId&&queryParams.cursor){this.props.queryCondolences(queryParams);}var dataLayer=window.dataLayer;var nextPage=currentPage+1;(0,_urlHelpers.updateHistory)(window,this.props.location,this.pageLayout,this.allowGuestBook,this.pid,nextPage);// Virtual Page View Tracking
if(dataLayer){var pathName=_lodash2.default.get(window,'location.pathname','');var pathQuery=_lodash2.default.get(window,'location.search','');window.dataLayer.push({event:'analyticsVPV',vpvName:''+pathName+pathQuery});}}this.setState({fetchingData:true});}/**
   * Handles infinite gallery scrolling by setting count
   * @param   {Number} count count value
   * @return  {Undefined} Returns nothing
   */},{key:'getAdditionalGalleryPayload',value:function getAdditionalGalleryPayload(){var count=arguments.length>0&&arguments[0]!==undefined?arguments[0]:9;var queryParams={sourceId:_lodash2.default.get(this.props,'personStore.person.sourceId'),count:count,cursor:_lodash2.default.get(this.props,'personStore.person.guestBookGallery.condolences.pageInfo.endCursor')};if(queryParams.sourceId){this.props.queryGalleryCondolences(queryParams);}}/**
   * Handler for closing the modal
   * @param {String} key The key of the modal to close
   * @return {Undefined} Returns nothing
   */},{key:'handleModalClose',value:function handleModalClose(key){var _this2=this;var stateObj={};stateObj[key]=false;if(key==='showOverlay'){stateObj.currentOverlayID=null;}this.setState(stateObj,function(){var element=key==='showThankYou'?_this2.refs.container:_reactDom2.default.findDOMNode(_this2).querySelector('#HubItem_'+_this2.state.hubItemModalIndex);if(element&&key!=='showGallery'){element.focus();}if(_lodash2.default.isFunction(_this2.props.handleModalClose)){_this2.props.handleModalClose(key);}});}/**
   * Opens the modal from a hub item
   * @param  {String} id Hub Item id to be shown in the modal
   * @return {Undefined} Returns nothing
   */},{key:'handleModalOpen',value:function handleModalOpen(id){var _this3=this;var condolences=this.props.personStore.person.guestBook.condolences.edges;var hubItemModalIndex=_lodash2.default.findIndex(condolences,{node:{id:id}});var stateObj={hubItemModalIndex:hubItemModalIndex};this.resizeHeight=false;this.resizeWidth=false;if(this.state.isPhone){var hubItemData=condolences[hubItemModalIndex].node;if(_lodash2.default.get(hubItemData,'video.id')){stateObj.showVideoOverlay=true;}else if(hubItemData.audioUrl){stateObj.showAudioOverlay=true;}else{stateObj.showOverlay=true;}}else{stateObj.showOverlay=true;stateObj.currentOverlayID=id;(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'browse_condolences',eventLabel:'opened_browse_condolences'});}this.setState(stateObj,function(){if(_lodash2.default.isFunction(_this3.props.handleModalOpen)){_this3.props.handleModalOpen(id);}});}/**
   * Handler for modal navigation
   * @param  {Number} idx Index of the next array item navigated to
   * @param {String} dir The direction that the index was incremented
   * @return {Undefined} Returns nothing
   */},{key:'handleSetItemModalIndex',value:function handleSetItemModalIndex(idx,dir){var indexOffSet=5;var arrayLocation=idx+indexOffSet;var condolences=_lodash2.default.get(this.props,'personStore.person.guestBook.condolences',{});var hasNextPage=_lodash2.default.get(condolences,'pageInfo.hasNextPage',false);if(hasNextPage&&arrayLocation===condolences.edges.length&&dir==='next'){this.getAdditionalPayload(this.currentPage);}(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'browse_condolences',eventLabel:dir});this.setState({currentOverlayID:this.props.personStore.person.guestBook.condolences.edges[idx].node.id,hubItemModalIndex:idx});}/**
   * Handler for modal navigation
   * @param  {Number} idx Index of the next array item navigated to
   * @param {String} dir The direction that the index was incremented
   * @return {Undefined} Returns nothing
   */},{key:'handleSetGalleryModalIndex',value:function handleSetGalleryModalIndex(idx,dir){var indexOffSet=0;var arrayLocation=idx+indexOffSet;var condolences=_lodash2.default.get(this.props,'personStore.person.guestBookGallery.condolences',{});var hasNextPage=_lodash2.default.get(condolences,'pageInfo.hasNextPage',false);if(hasNextPage&&arrayLocation+5>=condolences.edges.length&&dir==='next'){this.getAdditionalGalleryPayload();}(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'browse_gallery',eventLabel:dir});this.setState({currentOverlayID:this.props.personStore.person.guestBookGallery.condolences.edges[idx].node.id,galleryItemModalIndex:idx});}/**
   * Guestbook click handler
   * @return {Undefined} Returns nothing
   */},{key:'handleGuestBookClick',value:function handleGuestBookClick(){var offsetTop=this.refs.container.offsetTop;var scrollSpeed=500;(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'sign_guest_book_footer',eventLabel:'onpage'});(0,_scrollHelpers.scrollToTop)(this.element,offsetTop,scrollSpeed,this.openCondolenceEntry);}/**
   * Opens Entry
   * @return {Undefined} Returns nothing
   */},{key:'openCondolenceEntry',value:function openCondolenceEntry(){this[ENTRY_KEY].handleEntryFocus();}/**
   * Updates the modal height - used for after videos are uploaded to keep the modal height in sync
   * @return {Undefined} Returns nothing
   */},{key:'updateModalHeight',value:function updateModalHeight(){this.refs.modal.updateHeight();}/**
   * Get the Max height of a video
   * @return {Number} The max height
   */},{key:'getVideoMaxHeight',value:function getVideoMaxHeight(){return window?window.innerHeight-VIDEO_MODAL_PADDING:0;}/**
   * Handle Modal media resize to keep media elements within full view on phones
   * @return {Undefined} Returns nothing
   */},{key:'handleModalVideoResize',value:function handleModalVideoResize(){var videoModalContainer=this.refs.videoModalContainer;if(this.state.isPhone&&videoModalContainer){var ele=videoModalContainer.querySelector('.viddler-app-wrap');var eleHeight=ele.clientHeight;var modalHeight=this.getVideoMaxHeight();if(eleHeight>modalHeight){var width=modalHeight/eleHeight*(videoModalContainer.clientWidth-VIDEO_MODAL_PADDING);videoModalContainer.style.width=width+'px';}else{videoModalContainer.style.width='100%';}/* triggers the Viddler video to resize */window.dispatchEvent(new Event('resize'));}}/**
   * Handler for condolence submission
   * @method handleCondolenceSubmission
   * @param  {object}     submissionData - all non-object type submission data
   * @param  {array}      pictures       - the array of picture objects
   * @param  {object}     personAlert    - the data for the person alert
   * @return {undefined}  returns nothing, calls mutateCondolence or handleDisplayError
   */},{key:'handleCondolenceSubmission',value:function handleCondolenceSubmission(submissionData,pictures,personAlert){var submission=_lodash2.default.cloneDeep(submissionData);submission.sourceId=_lodash2.default.get(this.props,'personStore.person.sourceId');if(submission.sourceId){this.handlePendingUpload('Submitting',null);submission.iconId=this.state.isCandleLit?1:0;submission.applicationId=this.props.mobileDetails.any?65536:32768;var filteredSubmission=_lodash2.default.reduce(submission,function(result,value,key){if(value){result[key]=value;}return result;},{});this.submissionData.firstName=submission.firstName||'';this.submissionData.lastName=submission.lastName||'';this.props.mutateCondolence({filteredSubmission:filteredSubmission,pictures:pictures});if(personAlert){this.props.mutatePersonAlert(personAlert);(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'pp_alert',eventLabel:'within_gb_signup'});}}else{this.handleDisplayError('submission');}}/**
   * Sets the error state
   * @method handleDisplayError
   * @param  {string} error The display error string
   * @return {undefined} returns nothing, sets state values
   */},{key:'handleDisplayError',value:function handleDisplayError(error){var errorTypes={submission:'Oops! There was an error, please submit again.',picturesUpload:'Oops! There was an error with one or more of your pictures, please try again.',picturesUnavailable:'Oops! Picture uploads are not available, please submit a text entry.',video:'Oops! There was an error attempting to upload a video, please try again.',invalidEmail:'Error: Please enter a valid email address.',default:'Oops! There was an error, please try again.'};if(_lodash2.default.isString(error)){this.setState({condolenceError:errorTypes[error]||errorTypes.default,submittingCondolence:false});}else{this.setState({condolenceError:false});}}/**
   * Handle Submission success
   * @param {String} firstName The first name from the entry
   * @param {String} lastName The last name from the entry
   * @return {Undefined} Returns nothing
   */},{key:'handleCondolenceSubmitSuccess',value:function handleCondolenceSubmitSuccess(firstName,lastName){var _this4=this;this.setState({condolenceEntry:{firstname:firstName,lastname:lastName},showThankYou:true,submittingCondolence:false,condolenceError:false,mediaCollection:null},function(){_this4[ENTRY_KEY].clearForm();});}/**
   * Handle the modal resizing of media to fit into the viewport
   * @return {Undefined} Returns nothing
   */},{key:'handleModalResize',value:function handleModalResize(){var modalHubItemContainer=this.refs.modalHubItemContainer;var figure=modalHubItemContainer&&modalHubItemContainer.refs.figure;if(modalHubItemContainer&&figure){var condolences=_lodash2.default.get(this.props,'personStore.person.guestBook.condolences.edges',[]);var hubItemData=_lodash2.default.get(condolences,'[this.state.hubItemModalIndex].node',{});var windowHeight=window.innerHeight;var eleHeight=figure.clientHeight;var eleWidth=figure.clientWidth;var IMG_PADDING=40;var height=windowHeight-IMG_PADDING;var width=windowHeight/eleHeight*eleWidth;if(_lodash2.default.get(hubItemData,'video.id')){this.resizeHeight=false;if(eleHeight>windowHeight){this.resizeWidth=true;}else if(width>figure.parentElement.clientWidth){this.resizeWidth=false;}}else if(_lodash2.default.get(hubItemData,'audioUrl')){this.resizeWidth=false;this.resizeHeight=false;}else{this.resizeWidth=false;if(eleHeight>windowHeight){if(figure.querySelector('img')){figure.querySelector('img').style.maxHeight='100%';this.resizeHeight=true;}}else if(eleHeight-2>figure.firstChild.clientHeight){var image=figure.querySelector('img');if(image){image.style.maxHeight='none';this.resizeHeight=false;}}}figure.style.width=this.resizeWidth?width+'px':'100%';figure.style.height=this.resizeHeight?height+'px':'auto';figure.style.opacity=1;}}/**
   * Updates the state value when viddler upload starts and stops
   * @method handlePendingUpload
   * @param  {boolean}   shouldDisplay              should the modal show or not
   * @param  {function}  completeFunction  finialize upload
   * @return {undefined} retruns nothing, sets pendingUpload and runs fn
   */},{key:'handlePendingUpload',value:function handlePendingUpload(shouldDisplay,completeFunction){this.setState({pendingUpload:shouldDisplay},function(){if(shouldDisplay&&_lodash2.default.isFunction(completeFunction)){completeFunction();}});}/**
   * Sets the media collection state value
   * @method handleMediaCollection
   * @param  {Array}      mediaCollection       List of pending media
   * @param  {Boolean}    showCaptionsOverlay   Whether or not to show captions panel
   * @param  {Number}     scrollPosition        Saved scroll position before action
   * @return {Undefined}  Returns nothing
   */},{key:'handleMediaCollection',value:function handleMediaCollection(mediaCollection){var _this5=this;var showCaptionsOverlay=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var scrollPosition=arguments[2];var captionsOverlayCount=_lodash2.default.size(mediaCollection)===0?0:this.state.captionsOverlayCount+1;var isInitialUpload=captionsOverlayCount<2;var showOverlay=showCaptionsOverlay;if(_lodash2.default.get(mediaCollection,'[0].mediaType')===_constants.MEDIA_TYPES.video){this.setState({captionsOverlayCount:captionsOverlayCount,isInitialUpload:isInitialUpload,mediaCollection:mediaCollection||[],scrollPosition:scrollPosition,showCaptionsOverlay:showCaptionsOverlay},function(){if(!showOverlay&&scrollPosition){(0,_scrollHelpers.scrollToTop)(_this5.element,scrollPosition,500);_this5.element.style.position='static';_this5.element.style.width='auto';}});}else{var promisedMediaCollection=_lodash2.default.size(mediaCollection)?mediaCollection.map(function(item){return _promise2.default.resolve(item);}):[];_promise2.default.all(promisedMediaCollection).then(function(mediaItems){var filteredMediaItems=mediaItems.filter(function(item){return!_lodash2.default.isEmpty(item);});showOverlay=showCaptionsOverlay?!_lodash2.default.isEmpty(filteredMediaItems):false;_this5.setState({captionsOverlayCount:captionsOverlayCount,isInitialUpload:isInitialUpload,mediaCollection:filteredMediaItems,showCaptionsOverlay:showOverlay,scrollPosition:scrollPosition},function(){if(!showOverlay&&scrollPosition){(0,_scrollHelpers.scrollToTop)(_this5.element,scrollPosition,500);_this5.element.style.position='static';_this5.element.style.width='auto';}});}).catch(function(){_this5.handleDisplayError('picturesUpload');});}}/**
   * Shows edit overlay and saves current scroll position
   * @return {Undefined}  Returns nothing
   */},{key:'openEditOverlay',value:function openEditOverlay(){var scrollPosition=window.pageYOffset;this.element.style.position='fixed';this.element.style.width='100%';this.setState({scrollPosition:scrollPosition,showCaptionsOverlay:true});}/**
   * Toggles the candle's state value in order to show or hide the candle.
   * @method  toggleCandleLighting
   * @param   {Boolean}   reset If present sets isCandleLit to false
   * @return  {Undefined} Returns nothing.
   */},{key:'toggleCandleLighting',value:function toggleCandleLighting(reset){this.setState({isCandleLit:reset===true?false:!this.state.isCandleLit,condolenceError:false});}},{key:'handleEntryToggle',value:function handleEntryToggle(isExpanded,setSignupStyle){if(this.state.isExpanded!==isExpanded){this.setState({isExpanded:isExpanded});}setSignupStyle();}},{key:'render',value:function render(){var _$get=_lodash2.default.get(this.props,'personStore.person.guestBook',{}),allowGuestBook=_$get.allowGuestBook,allowGuestBookEntry=_$get.allowGuestBookEntry,allowPersonPagePosting=_$get.allowPersonPagePosting,allowGuestBookPhoto=_$get.allowGuestBookPhoto,allowGuestBookVideo=_$get.allowGuestBookVideo,condolences=_$get.condolences,isFallback=_$get.isFallback,totalCondolencesCount=_$get.totalCondolencesCount;var _ref=condolences||{},edges=_ref.edges,pageInfo=_ref.pageInfo;var gallery=_lodash2.default.get(this.props,'personStore.person.guestBookGallery')||{};var hasNextPage=_lodash2.default.get(pageInfo,'hasNextPage',false);var firstName=_lodash2.default.get(this.props,'personStore.person.name.first');var lastName=_lodash2.default.get(this.props,'personStore.person.name.last');var _props$personStore=this.props.personStore;_props$personStore=_props$personStore===undefined?{}:_props$personStore;var _props$personStore$pe=_props$personStore.person;_props$personStore$pe=_props$personStore$pe===undefined?{}:_props$personStore$pe;var _props$personStore$pe2=_props$personStore$pe.personLayout;_props$personStore$pe2=_props$personStore$pe2===undefined?{}:_props$personStore$pe2;var personPageType=_props$personStore$pe2.personPageType;var preloaderContainer=null;var guestBookFooterBtn=null;var modal=null;if(allowGuestBook){/** Modal Items **/var node=_lodash2.default.get(edges,'['+this.state.hubItemModalIndex+'].node',{});var audioUrl=node.audioUrl,city=node.city,date=node.date,name=node.name,iconUrl=node.iconUrl,message=node.message,photo=node.photo,relationship=node.relationship,state=node.state,video=node.video;/** Gallery Items **/var galleryNode=_lodash2.default.get(gallery,'condolences.edges['+this.state.galleryItemModalIndex+'].node',{});if(this.state.showOverlay){modal=_react2.default.createElement(_library.Modal,{contentLength:_lodash2.default.size(edges),currentIndex:this.state.hubItemModalIndex,getAdditionalPayload:this.getAdditionalPayload,handleClose:_lodash2.default.partial(this.handleModalClose,'showOverlay'),handleSetContentIndex:this.handleSetItemModalIndex,ref:'modal',resizeCallback:this.handleModalResize},_react2.default.createElement(_CondolenceItem2.default,{adService:this.props.ads.adService,audioUrl:audioUrl,city:city,date:date,firstName:name&&name.firstName,iconUrl:iconUrl,id:'Modal_'+this.state.hubItemModalIndex,isModal:true,lastName:name&&name.lastName,message:message,photo:photo,primaryFuneralHome:this.props.primaryFuneralHome,ref:'modalHubItemContainer',relationship:relationship,state:state,video:video,videoReadyCallback:this.updateModalHeight}));}if(this.state.showGallery){modal=_react2.default.createElement(_library.Modal,{contentLength:_lodash2.default.size(_lodash2.default.get(gallery,'condolences.edges')),currentIndex:this.state.galleryItemModalIndex,getAdditionalPayload:this.getAdditionalGalleryPayload,handleClose:_lodash2.default.partial(this.handleModalClose,'showGallery'),handleSetContentIndex:this.handleSetGalleryModalIndex,ref:'modal',resizeCallback:this.handleModalResize},_react2.default.createElement(_CondolenceItem2.default,{adService:this.props.ads.adService,audioUrl:_lodash2.default.get(galleryNode,'audioUrl'),city:_lodash2.default.get(galleryNode,'city'),date:_lodash2.default.get(galleryNode,'date'),firstName:_lodash2.default.get(galleryNode,'name.firstName'),iconUrl:_lodash2.default.get(galleryNode,'iconUrl'),id:'Modal_'+this.state.galleryItemModalIndex,isModal:true,lastName:_lodash2.default.get(galleryNode,'name.lastName'),message:_lodash2.default.get(galleryNode,'message'),photo:_lodash2.default.get(galleryNode,'photo'),primaryFuneralHome:this.props.primaryFuneralHome,ref:'modalHubItemContainer',relationship:_lodash2.default.get(galleryNode,'relationship'),state:_lodash2.default.get(galleryNode,'state'),video:_lodash2.default.get(galleryNode,'video'),videoReadyCallback:this.updateModalHeight}));}if(this.state.showVideoOverlay){modal=_react2.default.createElement(_library.Modal,{classNameCloseBtn:_GuestBook2.default.mediaModalCloseBtn,classNameContent:_GuestBook2.default.mediaModalContent,classNameItem:_GuestBook2.default.videoModalItem,handleClose:_lodash2.default.partial(this.handleModalClose,'showVideoOverlay'),isPhone:true},_react2.default.createElement('div',{ref:'videoModalContainer',style:{margin:'0 auto',width:'100%'}},_react2.default.createElement(_library.Video,{id:'HubItemModalVideo',isPhone:true,videoId:video&&video.id,videoReadyCallback:this.handleModalVideoResize})));}if(this.state.showAudioOverlay){modal=_react2.default.createElement(_library.Modal,{classNameCloseBtn:_GuestBook2.default.mediaModalCloseBtn,classNameContent:_GuestBook2.default.mediaModalContent,handleClose:_lodash2.default.partial(this.handleModalClose,'showAudioOverlay'),isPhone:true},_react2.default.createElement('div',{className:_GuestBook2.default.audioContainer},_react2.default.createElement(_library.Audio,{tabIndex:'1000',url:audioUrl})));}if(this.state.showCaptionsOverlay){modal=_react2.default.createElement(_library.Modal,{classNameContent:this.props.mobileDetails.any?_GuestBook2.default.captionsModalMobileContent:null,isPhone:true,showCloseButton:false},_react2.default.createElement(_CaptionContainer2.default,{handleMediaCollection:this.handleMediaCollection,isInitialUpload:this.state.isInitialUpload,mediaCollection:this.state.mediaCollection,mobileDetails:this.props.mobileDetails,scrollPosition:this.state.scrollPosition}));}if(this.state.pendingUpload){modal=_react2.default.createElement(_library.Modal,{classNameContent:_GuestBook2.default.loadingModal,handleClose:_lodash2.default.partial(this.handleModalClose,'pendingUpload'),isPhone:true,showCloseButton:false},_react2.default.createElement('div',{className:_GuestBook2.default.loadingWrapper},_react2.default.createElement(_library.Spinner,null),_react2.default.createElement('p',{className:_GuestBook2.default.loading},this.state.pendingUpload,'...')));}if(this.state.showThankYou){modal=_react2.default.createElement(_library.Modal,{classNameItem:_GuestBook2.default.thankYouModal,isPhone:true,ref:'modal',showCloseButton:false},_react2.default.createElement(_ThankYou2.default,{canonicalUrl:this.props.canonicalUrl,entry:this.state.condolenceEntry,flowerClickEvents:this.props.thankYouFlowerClickEvents,flowersLink:this.props.flowersLink,flowersLocation:this.props.flowersLocation,handleClose:_lodash2.default.partial(this.handleModalClose,'showThankYou'),handleFlowersImgLoad:this.updateModalHeight,name:_lodash2.default.get(this.props,'personStore.person.name'),showFlowers:this.showFlowers,title:this.props.title}));}/** Footer Items **/if(hasNextPage){if(this.props.personStore.loading){preloaderContainer=_react2.default.createElement('div',{className:_GuestBook2.default.preloader},_react2.default.createElement(_library.Spinner,null));}}else{guestBookFooterBtn=totalCondolencesCount>0?_react2.default.createElement('div',{className:_GuestBook2.default.footer},allowGuestBookEntry&&allowPersonPagePosting&&_lodash2.default.size(this.state.mediaCollection)===0&&totalCondolencesCount>4?_react2.default.createElement(Button,{btnType:'primary',className:this.state.isExpanded?_GuestBook2.default.guestBookFooterBtnDisabled:null,disabled:this.state.isExpanded,handleClick:this.handleGuestBookClick,id:'SignGuestBookEntryFooter'},_react2.default.createElement('span',{'data-ga-no-auto-tag':'true'},'Sign Guest Book '),_react2.default.createElement('span',{className:_GuestBook2.default.srOnly},'Scrolls to Condolence Entry')):null):null;}/** Return the Guestbook **/return _react2.default.createElement('div',{className:''+_GuestBook2.default.GuestBook+(this.state.isPhone?' '+_GuestBook2.default.phone:''),ref:'container',tabIndex:'0'},_react2.default.createElement('div',{className:_GuestBook2.default.content},_react2.default.createElement('div',{className:_GuestBook2.default.main},_react2.default.createElement('div',{className:_GuestBook2.default.header},_react2.default.createElement('h2',null,'Guest Book'),allowGuestBook&&allowGuestBookEntry?_react2.default.createElement(_EntryNav2.default,{allowGuestBookPhoto:allowGuestBookPhoto,allowGuestBookVideo:allowGuestBookVideo,fpData:this.props.fpData,handleCandleToggle:this.toggleCandleLighting,handleDisplayError:this.handleDisplayError,handleEditOverlay:this.openEditOverlay,handleMediaCollection:this.handleMediaCollection,handlePendingUpload:this.handlePendingUpload,isCandleLit:this.state.isCandleLit,isInferiorBrowser:this.props.isInferiorBrowser,location:this.props.location,mediaCollection:this.state.mediaCollection,mobileDetails:this.props.mobileDetails}):null),allowGuestBook&&allowGuestBookEntry?_react2.default.createElement(_CondolenceEntry2.default,{condolenceError:this.state.condolenceError,firstName:firstName,handleCandleToggle:this.toggleCandleLighting,handleDisplayError:this.handleDisplayError,handleEditOverlay:this.openEditOverlay,handleEntryToggle:this.handleEntryToggle,handleMediaCollection:this.handleMediaCollection,handleSubmit:this.handleCondolenceSubmission,isCandleLit:this.state.isCandleLit,isNFGB:_lodash2.default.get(this.props,'personStore.person.personLayout.isNFGB',false),isSubmitting:this.state.submittingCondolence,lastName:lastName,location:this.props.location,mediaCollection:this.state.mediaCollection,mutationStatus:_lodash2.default.get(this.props,'personStore.mutationStatus'),ref:this.setRefEntry,showCollection:!this.state.isInitialUpload,sourceId:_lodash2.default.get(this.props,'personStore.person.guestBook.sourceId')}):null,_lodash2.default.size(edges)>0?_react2.default.createElement(_CondolenceCollection2.default,{adService:this.props.ads.adService,data:edges,getAdditionalPayload:_lodash2.default.partial(this.getAdditionalPayload,this.currentPage),handleHubItemClick:this.handleModalOpen,hasNextPage:hasNextPage,isFetchingData:this.state.fetchingData,isPhone:this.state.isPhone,personPageType:personPageType,primaryFuneralHome:this.props.primaryFuneralHome,showFlowersAndGifts:_lodash2.default.get(this.props,'personStore.person.personLayout.showFlowersAndGifts'),sourceId:_lodash2.default.get(this.props,'personStore.person.guestBook.sourceId')}):null,preloaderContainer,guestBookFooterBtn)),modal);}return _react2.default.createElement('div',null,_react2.default.createElement(_ErrorDisplay2.default,{isFallback:isFallback}));}}]);return GuestBook;}(_react2.default.Component);/* istanbul ignore next */GuestBook.propTypes={ads:_react2.default.PropTypes.object.isRequired,allowGallery:_react2.default.PropTypes.bool,canonicalUrl:_react2.default.PropTypes.string,queryCondolences:_react2.default.PropTypes.func,queryGalleryCondolences:_react2.default.PropTypes.func,flowersLink:_react2.default.PropTypes.string,flowersLocation:_react2.default.PropTypes.object,fpData:_react2.default.PropTypes.object,galleryConfig:_react2.default.PropTypes.object,handleModalClose:_react2.default.PropTypes.func,handleModalOpen:_react2.default.PropTypes.func,isInferiorBrowser:_react2.default.PropTypes.bool,location:_react2.default.PropTypes.object,mobileDetails:_react2.default.PropTypes.object.isRequired,mutateCondolence:_react2.default.PropTypes.func,mutatePersonAlert:_react2.default.PropTypes.func,personStore:_react2.default.PropTypes.object,primaryFuneralHome:_react2.default.PropTypes.object,resetMutationStatus:_react2.default.PropTypes.func,thankYouFlowerClickEvents:_react2.default.PropTypes.func,title:_react2.default.PropTypes.string};var mapStateToProps=function mapStateToProps(state){return{ads:state.adStore,personStore:_lodash2.default.get(state,'personStore'),mobileDetails:state.mobileDetailsStore};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{queryCondolences:function queryCondolences(queryParams){dispatch((0,_condolenceHelper.queryCondolences)(queryParams));},queryGalleryCondolences:function queryGalleryCondolences(queryParams){dispatch((0,_condolenceHelper.queryGalleryCondolences)(queryParams));},mutateCondolence:function mutateCondolence(mutationParams){dispatch((0,_condolenceHelper.mutateCondolence)(mutationParams));},mutatePersonAlert:function mutatePersonAlert(mutationParams){dispatch((0,_personAlertHelper.mutatePersonAlert)(mutationParams));},resetMutationStatus:function resetMutationStatus(mutationStatus){dispatch((0,_condolenceHelper.resetCondlenceMutationStatus)(mutationStatus));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps,null,{withRef:true})(GuestBook);

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(473);
__webpack_require__(158);
__webpack_require__(209);
__webpack_require__(1610);
__webpack_require__(1617);
__webpack_require__(1618);
module.exports = __webpack_require__(35).Promise;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(207);
var global = __webpack_require__(53);
var ctx = __webpack_require__(131);
var classof = __webpack_require__(367);
var $export = __webpack_require__(66);
var isObject = __webpack_require__(93);
var aFunction = __webpack_require__(206);
var anInstance = __webpack_require__(1611);
var forOf = __webpack_require__(1612);
var speciesConstructor = __webpack_require__(617);
var task = __webpack_require__(618).set;
var microtask = __webpack_require__(1614)();
var newPromiseCapabilityModule = __webpack_require__(371);
var perform = __webpack_require__(619);
var promiseResolve = __webpack_require__(620);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(45)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1615)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(208)($Promise, PROMISE);
__webpack_require__(1616)(PROMISE);
Wrapper = __webpack_require__(35)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(603)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(131);
var call = __webpack_require__(601);
var isArrayIter = __webpack_require__(602);
var anObject = __webpack_require__(77);
var toLength = __webpack_require__(314);
var getIterFn = __webpack_require__(366);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 1613 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var macrotask = __webpack_require__(618).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(160)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(114);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(53);
var core = __webpack_require__(35);
var dP = __webpack_require__(86);
var DESCRIPTORS = __webpack_require__(94);
var SPECIES = __webpack_require__(45)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(66);
var core = __webpack_require__(35);
var global = __webpack_require__(53);
var speciesConstructor = __webpack_require__(617);
var promiseResolve = __webpack_require__(620);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(66);
var newPromiseCapability = __webpack_require__(371);
var perform = __webpack_require__(619);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","GuestBook":"GuestBook","content":"content","main":"main","header":"header","headerGuestbookBtn":"headerGuestbookBtn","preloader":"preloader","footer":"footer","printButton":"printButton","guestBookFooterBtnDisabled":"guestBookFooterBtnDisabled","guestBookLinkBtn":"guestBookLinkBtn","audioContainer":"audioContainer","mediaModalContent":"mediaModalContent","mediaModalCloseBtn":"mediaModalCloseBtn","loading":"loading","loadingWrapper":"loadingWrapper","loadingModal":"loadingModal","thankYouModal":"thankYouModal","videoModalItem":"videoModalItem","captionsModalMobileContent":"captionsModalMobileContent","item":"item","phone":"phone","heroImage":"heroImage"};

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","CondolenceItem":"CondolenceItem","rollover":"rollover","postInfo":"postInfo","rememberedBy":"rememberedBy","divider":"divider","name":"name","details":"details","body":"body","icon":"icon","overlay":"overlay","candleFigure":"candleFigure","noMessage":"noMessage","audio":"audio","video":"video","modal":"modal","closeButton":"closeButton","hover":"hover","imageBackground":"imageBackground","candle":"candle","isAd":"isAd","content":"content"};

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Likes=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _Likes=__webpack_require__(1622);var _Likes2=_interopRequireDefault(_Likes);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _componentHelpers=__webpack_require__(26);var _GAHelpers=__webpack_require__(22);var _localStorageHelper=__webpack_require__(1623);var _Svgs=__webpack_require__(36);var _likesHelper=__webpack_require__(1626);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable  no-process-env */var Likes=exports.Likes=function(_React$Component){(0,_inherits3.default)(Likes,_React$Component);function Likes(props){(0,_classCallCheck3.default)(this,Likes);var _this=(0,_possibleConstructorReturn3.default)(this,(Likes.__proto__||(0,_getPrototypeOf2.default)(Likes)).call(this,props));_this.state={animate:false};_this.isDisabled=Object({"NODE_ENV":"production","APP_ENV":"prod","ENABLE_STATSD":false,"HEADER_BIDDING":true}).DISABLE_LIKES==='true';_this.initialCount=null;_this.nextCount=null;_this.setCount();_this.timer=null;(0,_componentHelpers.bindMethods)(_this,['checkLikeHistory','handleClick']);return _this;}(0,_createClass3.default)(Likes,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('keydown',_localStorageHelper.clearLocalStorage);this.timer=setTimeout(this.checkLikeHistory,Math.random()*1000+1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timer);window.removeEventListener('keydown',_localStorageHelper.clearLocalStorage);}/**
   * sets initial and next count. evens up length
   * @param {number} increment  amount to increment initial count
   * @return {Undefined}        returns nothing
   */},{key:'setCount',value:function setCount(){var increment=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var count=_lodash2.default.get(this.props,'likesCount')||0;var initialCount=count.toString().split('');this.nextCount=(count+increment).toString().split('');if(_lodash2.default.size(initialCount)<_lodash2.default.size(this.nextCount)){initialCount.unshift('0');}this.initialCount=initialCount;}/**
   * applies necessary styles for number counts
   * @param {Object} mainStyle style Object
   * @param {number} index     current index
   * @return {Object}          style object
   */},{key:'setStyles',value:function setStyles(mainStyle,index){var conditionalClasses={};var isMatch=this.initialCount[index]===this.nextCount[index];var shouldAnimate=this.state.animate&&!isMatch;conditionalClasses[_Likes2.default.animate]=shouldAnimate;conditionalClasses[_Likes2.default['order'+index]]=shouldAnimate;if(mainStyle===_Likes2.default.top&&index===0){conditionalClasses[_Likes2.default.danglingDigit]=this.initialCount[0]==='0';}return(0,_classnames2.default)(mainStyle,conditionalClasses);}/**
   * click handler
   * @return {Undefined} returns nothing
   */},{key:'handleClick',value:function handleClick(){if(!this.state.animate&&!(0,_localStorageHelper.getLocalStorage)(this.props.condolenceId)){this.props.mutateCondolenceLikes({condolenceId:this.props.condolenceId});(0,_GAHelpers.getGATags)({eventCategory:'bypage_person_'+this.props.sourceId,eventAction:'gb_like_'+this.props.condolenceId,eventLabel:this.props.likesCount+1});(0,_localStorageHelper.setLocalStorage)(this.props.condolenceId);this.setState({animate:true});}}/**
   * checks like status of condolence
   * @return {undefined} returns nothing
   */},{key:'checkLikeHistory',value:function checkLikeHistory(){if((0,_localStorageHelper.getLocalStorage)(this.props.condolenceId)){this.setCount(0);this.setState({animate:true});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,condolenceId=_props.condolenceId,likesCount=_props.likesCount;return!this.isDisabled&&condolenceId&&likesCount>=0?_react2.default.createElement('div',{className:_Likes2.default.Likes},_react2.default.createElement('div',{className:_Likes2.default.counter},this.nextCount.map(function(item,index){return _react2.default.createElement('span',{className:_Likes2.default.group,key:index},_react2.default.createElement('div',{className:_this2.setStyles(_Likes2.default.top,index)},_this2.initialCount[index]),_react2.default.createElement('div',{className:_this2.setStyles(_Likes2.default.bottom,index)},item));})),_react2.default.createElement('div',{className:''+_Likes2.default.icon+(this.state.animate?' '+_Likes2.default.animate:''),id:'likes',onClick:this.handleClick},_react2.default.createElement(_Svgs.LikesHeart,null))):null;}}]);return Likes;}(_react2.default.Component);/* istanbul ignore next */Likes.propTypes={condolenceId:_react2.default.PropTypes.number,likesCount:_react2.default.PropTypes.number,mutateCondolenceLikes:_react2.default.PropTypes.func,sourceId:_react2.default.PropTypes.number};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{mutateCondolenceLikes:function mutateCondolenceLikes(mutationParams){dispatch((0,_likesHelper.mutateCondolenceLikes)(mutationParams));}};};exports.default=(0,_reactRedux.connect)(null,mapDispatchToProps)(Likes);

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","Likes":"Likes","counter":"counter","group":"group","top":"top","animate":"animate","danglingDigit":"danglingDigit","order0":"order0","order1":"order1","order2":"order2","order3":"order3","order4":"order4","order5":"order5","bottom":"bottom","icon":"icon","scale":"scale"};

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setLocalStorage=setLocalStorage;exports.getLocalStorage=getLocalStorage;exports.clearLocalStorage=clearLocalStorage;var _localStorage=__webpack_require__(622);var _localStorage2=_interopRequireDefault(_localStorage);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * sets local storage
 * @param   {*} key     local storage key
 * @return  {undefined} returns nothing
 */function setLocalStorage(key){_localStorage2.default.set(key,true);}/**
 * gets local storage value
 * @param  {*} key    local storage key
 * @return {Boolean}  value
 */function getLocalStorage(key){return _localStorage2.default.get(key)||false;}/**
 * keyDown handler for local storage reset
 * @param  {event} e    onKeyDown event
 * @return {undefined}  returns nothing
 */function clearLocalStorage(e){var altKey=e.altKey,code=e.code,shiftKey=e.shiftKey;if(altKey&&code==='KeyC'&&shiftKey){_localStorage2.default.clear();window.location.reload(true);}}

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ms = {};

function getItem (key) {
  return key in ms ? ms[key] : null;
}

function setItem (key, value) {
  ms[key] = value;
  return true;
}

function removeItem (key) {
  var found = key in ms;
  if (found) {
    return delete ms[key];
  }
  return false;
}

function clear () {
  ms = {};
  return true;
}

module.exports = {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
  clear: clear
};


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var listeners = {};
var listening = false;

function listen () {
  if (global.addEventListener) {
    global.addEventListener('storage', change, false);
  } else if (global.attachEvent) {
    global.attachEvent('onstorage', change);
  } else {
    global.onstorage = change;
  }
}

function change (e) {
  if (!e) {
    e = global.event;
  }
  var all = listeners[e.key];
  if (all) {
    all.forEach(fire);
  }

  function fire (listener) {
    listener(JSON.parse(e.newValue), JSON.parse(e.oldValue), e.url || e.uri);
  }
}

function on (key, fn) {
  if (listeners[key]) {
    listeners[key].push(fn);
  } else {
    listeners[key] = [fn];
  }
  if (listening === false) {
    listen();
  }
}

function off (key, fn) {
  var ns = listeners[key];
  if (ns.length > 1) {
    ns.splice(ns.indexOf(fn), 1);
  } else {
    listeners[key] = [];
  }
}

module.exports = {
  on: on,
  off: off
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mutateCondolenceLikes=undefined;var _seedHelperFn=__webpack_require__(623);var _seedHelperFn2=_interopRequireDefault(_seedHelperFn);var _mutationTemplates=__webpack_require__(245);var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Posts condolence likes data to graphQL
 * @return {function} returns the function to make the fetch
 */var mutateCondolenceLikes=exports.mutateCondolenceLikes=(0,_seedHelperFn2.default)(_mutationTemplates.LIKES_MUTATION_TEMPLATE,'mutation',_actions.mutationRequest,_actions.mutateCondolenceLikesSuccess,_actions.mutateCondolenceLikesFailure);

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/audio@2x.d8b5f4fd.png";

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _CondolenceItem=__webpack_require__(621);var _CondolenceItem2=_interopRequireDefault(_CondolenceItem);var _CondolenceCollection=__webpack_require__(1629);var _CondolenceCollection2=_interopRequireDefault(_CondolenceCollection);var _componentHelpers=__webpack_require__(26);var _personPageType=__webpack_require__(67);var _constants=__webpack_require__(41);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Magic numbers!
 * @type {Number}
 */var WINDOW_WIDTH=1024;/* eslint-disable global-require */var RESIZE_TIMEOUT=100;/**
 * The group of condolences displayed as a guestbook on person page.
 * @class  CondolenceCollection
 */var CondolenceCollection=function(_React$Component){(0,_inherits3.default)(CondolenceCollection,_React$Component);/**
   * CondolenceCollection Component constructor
   * @param  {Object} props   Passed in properties.
   * @return {Undefined}           Returns nothing.
   */function CondolenceCollection(props){(0,_classCallCheck3.default)(this,CondolenceCollection);var _this=(0,_possibleConstructorReturn3.default)(this,(CondolenceCollection.__proto__||(0,_getPrototypeOf2.default)(CondolenceCollection)).call(this,props));var gridSize=_this.getCurrentGridSize(WINDOW_WIDTH);_this.state={data:_this.mutateCondolences(props.data)};_this.fetchingData=false;_this.gridColumns=gridSize;_this.heights=[];_this.imagesLoaded=null;_this.renderedHubItems=[];_this.containerRef=null;_this.setContainerRef=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'containerRef',_this);(0,_componentHelpers.bindMethods)(_this,['addRenderedHubItem','handleDidReceiveMessage','handleResize','handleScroll']);_this.handleResize=_lodash2.default.debounce(_this.handleResize,RESIZE_TIMEOUT);return _this;}/**
   * If the window object exists, add the event listeners and call handleResize().
   * @return {Undefined} Returns nothing
   */(0,_createClass3.default)(CondolenceCollection,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.addEventListener('resize',this.handleResize);window.addEventListener('scroll',this.handleScroll);window.addEventListener('message',this.handleDidReceiveMessage);setTimeout(this.handleResize,RESIZE_TIMEOUT);this.imagesLoaded=__webpack_require__(1630);this.imagesLoaded(this.containerRef,function(){_this2.organizeHubItems(_this2.renderedHubItems,_this2.gridColumns);});}/**
   * Lifecycle Method
   * @param  {Object} newProps New props object
   * @return {Void} Undefined
   */},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){if(this.props.data!==newProps.data){this.fetchingData=false;this.setState({data:this.mutateCondolences(newProps.data)});}}/**
   * Lifecycle Method
   * @param  {Object} newProps The new properties
   * @return {Boolean} Whether or not to render the component
   */},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(newProps){return this.props.data!==newProps.data;}/**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this3=this;/* calling this to avoid jankiness */this.organizeHubItems(this.renderedHubItems,this.gridColumns);this.imagesLoaded(this.containerRef,function(){_this3.organizeHubItems(_this3.renderedHubItems,_this3.gridColumns);});}/**
   * Remove event listeners.
   * @return {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);window.removeEventListener('scroll',this.handleScroll);window.removeEventListener('message',this.handleDidReceiveMessage);}/**
   * Handles either setting the columns or updating the layout
   * @return {Undefined} Retuns nothing
   */},{key:'handleResize',value:function handleResize(){this.gridColumns=this.getCurrentGridSize(window.innerWidth);this.organizeHubItems(this.renderedHubItems,this.gridColumns);}/**
   * Handler for the scroll event
   * @return {Undefined} Returns nothing
   */},{key:'handleScroll',value:function handleScroll(){if(this.props.hasNextPage&&!this.props.isFetchingData){var smallestColHeight=this.heights[this.getHeightKey(this.heights)];var windowHeight=window.innerHeight;var containerRectTop=this.containerRef.getBoundingClientRect().top;var diff=containerRectTop+smallestColHeight;if(windowHeight>diff){this.fetchingData=true;this.props.getAdditionalPayload();}}}/**
   * Handler for message event (from ads)
   * @param  {event} e message event
   * @return {Undefined}   returns nothing
   */},{key:'handleDidReceiveMessage',value:function handleDidReceiveMessage(e){try{var message=JSON.parse(e.data);var action=_lodash2.default.get(message,'action');var frameId=_lodash2.default.get(message,'frameId');if(action==='resize'&&frameId===_constants.AD_PGB.positionId){this.organizeHubItems(this.renderedHubItems,this.gridColumns);}}catch(ex){// do nothing
}}/**
   * Ref callback to add the hub items into a stored array for easy dom manipulation
   * @param {Element} hubItem The dom container for the hub item
   * @returns {Undefined} Returns nothing
   */},{key:'addRenderedHubItem',value:function addRenderedHubItem(hubItem){if(_lodash2.default.get(this,'renderedHubItems')){var foundItem=_lodash2.default.find(this.renderedHubItems,function(item){return item===hubItem;});if(!foundItem){this.renderedHubItems.push(hubItem);}}}/**
   * Determines the grid size (1, 2 or 3) based on the window width
   * @param  {Number} width Inner window width.
   * @return {Number}       Returns the number columns the grid should have.
   */},{key:'getCurrentGridSize',value:function getCurrentGridSize(width){var LOWER_WINDOW_WIDTH=600;if(width<LOWER_WINDOW_WIDTH){return 1;}return 2;}/**
   * Gets the height key for the smallest column
   * @param  {Array} heights The heights array
   * @return {Number} The smallest height key
   */},{key:'getHeightKey',value:function getHeightKey(heights){var heightKey=0;var smallestHeight=heights[0];_lodash2.default.each(heights,function(height,key){if(height<smallestHeight){smallestHeight=height;heightKey=key;}});return heightKey;}/**
   * Gets the largest column height
   * @param  {Array} heights The heights array
   * @return {Undefined} Returns nothing
   */},{key:'getLargestHeight',value:function getLargestHeight(heights){var largestHeight=heights[0];_lodash2.default.each(heights,function(height){if(height>largestHeight){largestHeight=height;}});return largestHeight;}/**
   * Organizes the hub items by setting their positions within the container based on their heights
   * @param  {Array} hubItems The currently rendered hub items
   * @param  {Number} gridSize The current size of the grid
   * @return {Undefined} Returns nothing
   */},{key:'organizeHubItems',value:function organizeHubItems(hubItems,gridSize){var _this4=this;var PERCENT_MULTIPLIER=100;var hubItemPercent=1/gridSize*PERCENT_MULTIPLIER;var filteredHubItems=_lodash2.default.compact(hubItems);this.heights=[];for(var i=0;i<gridSize;i++){this.heights.push(0);}_lodash2.default.each(filteredHubItems,function(hubItem){var heightKey=_this4.getHeightKey(_this4.heights);hubItem.style.position='absolute';hubItem.style.width=hubItemPercent+'%';hubItem.style.top=_this4.heights[heightKey]+'px';hubItem.style.left=heightKey*hubItemPercent+'%';_this4.heights[heightKey]+=hubItem.clientHeight;});if(_lodash2.default.get(this,'containerRef')){this.containerRef.style.height=this.getLargestHeight(this.heights)+'px';}}/**
   * Process data to add original index
   * @param {Array} data The data that will be processed
   * @return {Array} Returns and array with the data for the hub teasers.
   */},{key:'mutateCondolences',value:function mutateCondolences(data){var dataClone=_lodash2.default.map(data,_lodash2.default.clone);var adSlot=3;var dataItem=null;var processedData=[];if(data.length>adSlot+1&&(0,_personPageType.allowPrintedGuestBookAd)(this.props.personPageType)&&this.props.showFlowersAndGifts){var adObj={isAd:true,node:{audioUrl:null,city:null,date:null,iconUrl:null,id:null,message:null,name:{firstName:null,lastName:null},photo:{url:null,width:0,height:0,caption:null},relationship:null,state:{code:null,name:null},video:{id:null}}};dataClone.splice(adSlot,0,adObj);}_lodash2.default.each(dataClone,function(item,key){dataItem=_lodash2.default.cloneDeep(item);dataItem.originalIndex=key;processedData.push(dataItem);});return processedData;}/**
   * React Component render.
   * @return {JSX} CondolenceCollection rendered.
   */},{key:'render',value:function render(){var _this5=this;return _react2.default.createElement('div',{className:''+_CondolenceCollection2.default.CondolenceCollection+(this.props.isPhone?' '+_CondolenceCollection2.default.phone:''),ref:this.setContainerRef},_react2.default.createElement('div',{className:_CondolenceCollection2.default.gridGroup},this.state.data.map(function(item,key){return _react2.default.createElement('div',{className:_CondolenceCollection2.default.groupItem,key:key,ref:_this5.addRenderedHubItem},_react2.default.createElement(_CondolenceItem2.default,{adService:_this5.props.adService,audioUrl:item.node.audioUrl,city:item.node.city,condolenceId:item.node.condolenceId,date:item.node.date,firstName:item.node.name.firstName,handleClick:_lodash2.default.partial(_this5.props.handleHubItemClick,item.node.id),iconUrl:item.node.iconUrl,id:_lodash2.default.get(item,'originalIndex','').toString(),isAd:item.isAd,isModal:false,isPhone:_this5.props.isPhone,lastName:item.node.name.lastName,likesCount:item.node.likes,message:item.node.message,photo:item.node.photo,primaryFuneralHome:_this5.props.primaryFuneralHome,relationship:item.node.relationship,sourceId:_this5.props.sourceId,state:item.node.state,video:item.node.video}));})));}}]);return CondolenceCollection;}(_react2.default.Component);CondolenceCollection.propTypes={adService:_react2.default.PropTypes.object.isRequired,data:_react2.default.PropTypes.array,getAdditionalPayload:_react2.default.PropTypes.func,handleHubItemClick:_react2.default.PropTypes.func,hasNextPage:_react2.default.PropTypes.bool,isFetchingData:_react2.default.PropTypes.bool,isPhone:_react2.default.PropTypes.bool,personPageType:_react2.default.PropTypes.string,primaryFuneralHome:_react2.default.PropTypes.object,showFlowersAndGifts:_react2.default.PropTypes.bool,sourceId:_react2.default.PropTypes.number};exports.default=CondolenceCollection;

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","CondolenceCollection":"CondolenceCollection","groupItem":"groupItem","gridGroup":"gridGroup","phone":"phone"};

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * imagesLoaded v4.1.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(1631)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
      return factory( window, EvEmitter );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EvEmitter
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  if ( typeof elem == 'string' ) {
    elem = document.querySelectorAll( elem );
  }

  this.elements = makeArray( elem );
  this.options = extend( {}, this.options );

  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( function() {
    this.check();
  }.bind( this ));
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  return this.img.complete && this.img.naturalWidth !== undefined;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.0.3
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var i = 0;
  var listener = listeners[i];
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  while ( listener ) {
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
    // get next listener
    i += isOnce ? 0 : 1;
    listener = listeners[i];
  }

  return this;
};

return EvEmitter;

}));


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ThankYou=__webpack_require__(1633);var _ThankYou2=_interopRequireDefault(_ThankYou);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _Svgs=__webpack_require__(36);var _shareHelpers=__webpack_require__(362);var _formatHelpers=__webpack_require__(55);var _library=__webpack_require__(40);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Button=_library.FormControls.Button;var flowers=__webpack_require__(1634);var ThankYou=function ThankYou(props){var canonicalUrl=props.canonicalUrl,entry=props.entry,flowerClickEvents=props.flowerClickEvents,flowersLink=props.flowersLink,flowersLocation=props.flowersLocation,handleClose=props.handleClose,handleFlowersImgLoad=props.handleFlowersImgLoad,name=props.name,showFlowers=props.showFlowers,title=props.title;var _ref=entry||{},_ref$firstname=_ref.firstname,firstname=_ref$firstname===undefined?'':_ref$firstname,_ref$lastname=_ref.lastname,lastname=_ref$lastname===undefined?'':_ref$lastname;var first=firstname?' '+firstname:'';var last=lastname?' '+lastname:'';var hasFlowersLocation=_lodash2.default.get(flowersLocation,'sourceId',false);var funeralHomeBlock=null;var shareIcons=(0,_shareHelpers.ShareIcons)(canonicalUrl,title);if(hasFlowersLocation){var flowersName=flowersLocation.name,address1=flowersLocation.address1,address2=flowersLocation.address2,city=flowersLocation.city,state=flowersLocation.state,postalCode=flowersLocation.postalCode;funeralHomeBlock=_react2.default.createElement('div',null,_react2.default.createElement('p',{className:_ThankYou2.default.funeralHome},flowersName),_react2.default.createElement('p',{id:'address1'},address1),address2&&_react2.default.createElement('p',{id:'address2'},address2),_react2.default.createElement('p',{id:'address3'},city,' ',state,', ',postalCode));}return _react2.default.createElement('div',{className:_ThankYou2.default.ThankYou},_react2.default.createElement('div',{className:(0,_classnames2.default)(_ThankYou2.default.module,_ThankYou2.default.message)},_react2.default.createElement('div',{className:_ThankYou2.default.close,onClick:handleClose},_react2.default.createElement(_Svgs.CloseXIcon,null)),_react2.default.createElement(_Svgs.ThankYouEmailIcon,null),_react2.default.createElement('p',{className:_ThankYou2.default.header},'Thank You',''+first+last),_react2.default.createElement('p',{className:_ThankYou2.default.body},'Please allow ',_react2.default.createElement('span',null,'24 hours'),' for your entry to be reviewed for appropriate content.')),showFlowers?_react2.default.createElement('div',{className:(0,_classnames2.default)(_ThankYou2.default.module,_ThankYou2.default.flowers)},_react2.default.createElement('p',{className:_ThankYou2.default.header},'Would you like to send flowers?'),_react2.default.createElement('img',{onLoad:handleFlowersImgLoad,src:flowers}),funeralHomeBlock,flowersLink?_react2.default.createElement('a',{className:_ThankYou2.default.link,'data-ga-no-auto-tag':'true',href:flowersLink,onClick:flowerClickEvents,tabIndex:'1000',target:'_blank'},_react2.default.createElement('span',null,_react2.default.createElement(_Svgs.FlowerIcon,null)),'Send Flowers \u203A'):null):null,_react2.default.createElement('div',{className:(0,_classnames2.default)(_ThankYou2.default.module,_ThankYou2.default.shares)},_react2.default.createElement('p',null,'Invite family & friends to share the life of',' ',_react2.default.createElement('span',null,(0,_formatHelpers.getName)(name))),_react2.default.createElement('div',{className:_ThankYou2.default.group},shareIcons.map(function(obj,i){return _react2.default.createElement(Button,{btnType:'none',className:_ThankYou2.default.icon,handleClick:_lodash2.default.partial(_shareHelpers.HandleShareClick,_lodash2.default,obj.shareUrl,obj.label),id:obj.label,key:i},_react2.default.createElement('span',{className:_ThankYou2.default[obj.label]},obj.svg));}))),_react2.default.createElement('div',{className:(0,_classnames2.default)(_ThankYou2.default.module,_ThankYou2.default.buttonContainer)},_react2.default.createElement(Button,{className:_ThankYou2.default.button,handleClick:handleClose},'No Thanks')));};ThankYou.propTypes={canonicalUrl:_react2.default.PropTypes.string,entry:_react2.default.PropTypes.object,flowerClickEvents:_react2.default.PropTypes.func,flowersLink:_react2.default.PropTypes.string,flowersLocation:_react2.default.PropTypes.object,handleClose:_react2.default.PropTypes.func,handleFlowersImgLoad:_react2.default.PropTypes.func,name:_react2.default.PropTypes.object,showFlowers:_react2.default.PropTypes.bool,title:_react2.default.PropTypes.string};exports.default=ThankYou;

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","ThankYou":"ThankYou","module":"module","message":"message","FadeIn":"FadeIn","close":"close","header":"header","body":"body","flowers":"flowers","funeralHome":"funeralHome","link":"link","shares":"shares","group":"group","icon":"icon","facebook":"facebook","twitter":"twitter","email":"email","buttonContainer":"buttonContainer"};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/flowers@2x.f11f25da.jpg";

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _library=__webpack_require__(40);var _Svgs=__webpack_require__(36);var _SuggestedEntries=__webpack_require__(1636);var _SuggestedEntries2=_interopRequireDefault(_SuggestedEntries);var _componentHelpers=__webpack_require__(26);var _validationHelpers=__webpack_require__(1639);var _GAHelpers=__webpack_require__(22);var _urlHelpers=__webpack_require__(28);var _formatHelpers=__webpack_require__(55);var _constants=__webpack_require__(41);var CONSTANTS=_interopRequireWildcard(_constants);var _CondolenceEntry=__webpack_require__(1640);var _CondolenceEntry2=_interopRequireDefault(_CondolenceEntry);var _MediaBar=__webpack_require__(1641);var _MediaBar2=_interopRequireDefault(_MediaBar);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conf=(0,_AppConfig2.default)();var Button=_library.FormControls.Button,SelectList=_library.FormControls.SelectList,TextArea=_library.FormControls.TextArea,TextInput=_library.FormControls.TextInput;var ENTRY_PANEL_KEY=CONSTANTS.ENTRY_PANEL_KEY,ENTRY_TEXT_AREA_KEY=CONSTANTS.ENTRY_TEXT_AREA_KEY,FAQ_BASE_URL=CONSTANTS.FAQ_BASE_URL,GUIDELINES_BASE_URL=CONSTANTS.GUIDELINES_BASE_URL,MEDIA_TYPES=CONSTANTS.MEDIA_TYPES,PERSON_SIGNUP_KEY=CONSTANTS.PERSON_SIGNUP_KEY,SUGGESTED_ENTRY_KEY=CONSTANTS.SUGGESTED_ENTRY_KEY;/**
 * Condolence Entry module for Guestbook
 * @class CondolenceEntry
 */var CondolenceEntry=function(_React$Component){(0,_inherits3.default)(CondolenceEntry,_React$Component);/**
   * CondolenceEntry Component constructor
   * @param  {Object} props Passed in properties
   * @return {Undefined} Returns nothing
   */function CondolenceEntry(props){(0,_classCallCheck3.default)(this,CondolenceEntry);var _this=(0,_possibleConstructorReturn3.default)(this,(CondolenceEntry.__proto__||(0,_getPrototypeOf2.default)(CondolenceEntry)).call(this,props));_this.mobileBreakPoint=415;_this.textOptions={mobile:'What would you like to say...',firstName:'What would you like to say about '+props.firstName+'?',default:'Share a memory or condolence to the guest book.'};_this.state={city:'',email:'',entry:'',errors:{},firstName:'',hasCandle:'',isExpanded:_lodash2.default.size(props.mediaCollection)!==0,lastName:'',photos:[],relationship:'none',state:0,hasPersonAlertRequest:!props.isNFGB,hasPersonAlertCompleted:false,promptText:_this.textOptions.mobile,showSignupToggle:true,signupStyle:{visibility:'hidden',display:'block'},tooltipStyles:{}};_this.candleUrl=''+(0,_urlHelpers.buildUrl)(conf.environmentalUrl.cacheUrl,'globalcontent/gbmementos/candle.jpg');_this.isClient=typeof window!=='undefined';_this.names=_lodash2.default.compact([props.firstName,props.lastName]);/* refs */_this[ENTRY_PANEL_KEY]=null;_this[ENTRY_TEXT_AREA_KEY]=null;_this[PERSON_SIGNUP_KEY]=null;_this[SUGGESTED_ENTRY_KEY]=null;_this.setRefEntryPanel=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,ENTRY_PANEL_KEY,_this);_this.setRefTextArea=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,ENTRY_TEXT_AREA_KEY,_this);_this.setRefPersonSignUp=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,PERSON_SIGNUP_KEY,_this);_this.setRefSuggestedEntries=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,SUGGESTED_ENTRY_KEY,_this);_this.guidelinesLink=_this.getLink(GUIDELINES_BASE_URL,props.sourceId,_this.names);_this.faqLink=_this.getLink(FAQ_BASE_URL,props.sourceId,_this.names);_this.hasEntryFocusEventFired=false;_this.isClient=typeof window!=='undefined';/* selectlist options */_this.relationshipOptions=[{name:'Choose A Relationship',value:'none'},{name:'Friend',value:'friend'},{name:'Family',value:'family'},{name:'Coworker',value:'coworker'},{name:'Classmate',value:'classmate'},{name:'Neighbor',value:'neighbor'},{name:'Acquaintance',value:'acquaintance'},{name:'Student',value:'student'},{name:'Teacher',value:'teacher'},{name:'Served in the Military together',value:'military'},{name:'Significant Other',value:'significant_other'},{name:'Spouse',value:'spouse'},{name:'Brother',value:'brother'},{name:'Sister',value:'sister'},{name:'Daughter',value:'daughter'},{name:'Son',value:'son'},{name:'Grandchild',value:'grandchild'},{name:'Mother',value:'mother'},{name:'Father',value:'father'},{name:'Grandparent',value:'grandparent'}];_this.states=[{value:0,name:'State/Province'},{value:1,name:'Alberta'},{value:2,name:'Alaska'},{value:3,name:'Alabama'},{value:4,name:'Arkansas'},{value:5,name:'Arizona'},{value:6,name:'British Columbia'},{value:7,name:'California'},{value:8,name:'Colorado'},{value:9,name:'Connecticut'},{value:10,name:'District of Columbia'},{value:11,name:'Delaware'},{value:12,name:'Florida'},{value:13,name:'Georgia'},{value:14,name:'Hawaii'},{value:15,name:'Iowa'},{value:16,name:'Idaho'},{value:17,name:'Illinois'},{value:18,name:'Indiana'},{value:19,name:'Kansas'},{value:20,name:'Kentucky'},{value:21,name:'Louisiana'},{value:22,name:'Massachusetts'},{value:23,name:'Manitoba'},{value:24,name:'Maryland'},{value:25,name:'Maine'},{value:26,name:'Michigan'},{value:27,name:'Minnesota'},{value:28,name:'Missouri'},{value:29,name:'Mississippi'},{value:30,name:'Montana'},{value:32,name:'New Brunswick'},{value:33,name:'North Carolina'},{value:34,name:'North Dakota'},{value:35,name:'Nebraska'},{value:37,name:'New Hampshire'},{value:38,name:'New Jersey'},{value:36,name:'Newfoundland'},{value:39,name:'New Mexico'},{value:40,name:'Nova Scotia'},{value:41,name:'Northwest Territories'},{value:42,name:'Nunavut'},{value:43,name:'Nevada'},{value:44,name:'New York'},{value:45,name:'Ohio'},{value:46,name:'Oklahoma'},{value:47,name:'Ontario'},{value:48,name:'Oregon'},{value:49,name:'Pennsylvania'},{value:50,name:'Prince Edward Island'},{value:51,name:'Quebec'},{value:52,name:'Rhode Island'},{value:53,name:'South Carolina'},{value:54,name:'South Dakota'},{value:55,name:'Saskatchewan'},{value:56,name:'Tennessee'},{value:57,name:'Texas'},{value:58,name:'Utah'},{value:59,name:'Virginia'},{value:60,name:'Vermont'},{value:61,name:'Washington'},{value:62,name:'Wisconsin'},{value:63,name:'West Virginia'},{value:64,name:'Wyoming'},{value:65,name:'Yukon Territory'},{value:183,name:'American Samoa'},{value:179,name:'Guam'},{value:185,name:'Marshall Islands'},{value:184,name:'Micronesia'},{value:182,name:'Northern Marianas'},{value:186,name:'Palau'},{value:180,name:'Puerto Rico'},{value:181,name:'U.S. Virgin Islands'},{value:205,name:'U.S. Minor Outlying Islands'}];(0,_componentHelpers.bindMethods)(_this,['clearForm','handleEntryFocus','handleInputChange','handleResize','handleSubmit','setRef','setSignupStyle','setTooltipStyles','toggleEmailSignUp','setSuggestedEntry']);return _this;}/**
   * Lifecycle method
   * @return {undefined} Returns nothing
   */(0,_createClass3.default)(CondolenceEntry,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.handleResize);window.addEventListener('orientationchange',this.handleResize);this.setPromptText(this.props.firstName,this.textOptions);this.setSignupStyle(this.isClient,this.state.isExpanded,this.props.isNFGB,this.state.signupStyle);}/**
   * Lifecycle method - checks if done fetching data from Relay
   * @param  {Object} nextProps The new props
   * @return {Undefined} Returns nothing
   */},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if(_lodash2.default.size(nextProps.mediaCollection)!==0){this.setState({isExpanded:true},function(){_this2.setSignupStyle(_this2.isClient,_this2.state.isExpanded,_this2.props.isNFGB,_this2.state.signupStyle);});}var alertMutationStatus=_lodash2.default.get(nextProps,'mutationStatus.alert');if(_lodash2.default.isNumber(alertMutationStatus)){if(alertMutationStatus>0){this.setState({hasPersonAlertRequest:false,hasPersonAlertCompleted:true,showSignupToggle:false});}}}/**
   * Lifecycle method
   * @return {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);window.removeEventListener('orientationchange',this.handleResize);}/**
   * External method for cleaning the form
   * @return {Undefined} Returns nothing
   */},{key:'clearForm',value:function clearForm(){var _this3=this;this.setState({city:'',email:'',entry:'',firstName:'',lastName:'',isExpanded:false,relationship:'none',state:0},function(){_this3.props.handleEntryToggle(_this3.state.isExpanded,_lodash2.default.partial(_this3.setSignupStyle,_this3.isClient,_this3.state.isExpanded,_this3.props.isNFGB,_this3.state.signupStyle));});this.props.handleMediaCollection(null);var resetCandle=true;this.props.handleCandleToggle(resetCandle);this[SUGGESTED_ENTRY_KEY].resetEntries();}/**
   * Sets the entry state with the suggested entry
   * @param  {string}    entry the suggested entry
   * @return {Undefined} Returns nothing
   */},{key:'setSuggestedEntry',value:function setSuggestedEntry(entry){var _this4=this;this.setState({entry:entry},function(){_this4.handleEntryFocus();_this4.handleEntryUpdate();});}/**
   * Closes the entry form
   * @return {Undefined} Returns nothing
   */},{key:'closeForm',value:function closeForm(){var _this5=this;if(this.state.entry===''){this.setState({isExpanded:false},function(){_this5.props.handleEntryToggle(_this5.state.isExpanded,_lodash2.default.partial(_this5.setSignupStyle,_this5.isClient,_this5.state.isExpanded,_this5.props.isNFGB,_this5.state.signupStyle));});}}/**
   * Returns link for faq
   * @param  {String} baseUrl  The base url for the link
   * @param  {String} sourceId  Person's guest book id
   * @param  {Array}  names Person's first and/or last name
   * @return {String} Returns the formatted url
   */},{key:'getLink',value:function getLink(baseUrl,sourceId,names){var formattedNameParam='';if(!_lodash2.default.isEmpty(names)){var formattedName=names.join('-').toLowerCase();formattedNameParam='n='+formattedName+'&';}return baseUrl+'?'+formattedNameParam+'pid='+sourceId;}/**
   * Gets the text for the entry prompt
   * @param  {string} firstName   The first name
   * @param  {object} textOptions variations of the entry placeholder text
   * @return {undefined} returns nothing, sets state
   */},{key:'setPromptText',value:function setPromptText(firstName,textOptions){var promptText=textOptions.mobile;if(this.isClient){var isMobileSize=window.innerWidth<this.mobileBreakPoint;if(!isMobileSize){promptText=textOptions[firstName?'firstName':'default'];}}if(this.state.promptText!==promptText){this.setState({promptText:promptText});}}/**
   * Handles when focus happens on the entry
   * @return {undefined} Returns nothing
   */},{key:'handleEntryFocus',value:function handleEntryFocus(){var _this6=this;var isExpanded=this.state.isExpanded;if(!isExpanded){this.setState({isExpanded:true},function(){_this6.props.handleEntryToggle(_this6.state.isExpanded,_lodash2.default.partial(_this6.setSignupStyle,_this6.isClient,_this6.state.isExpanded,_this6.props.isNFGB,_this6.state.signupStyle));});}var _textArea=_lodash2.default.get(this[ENTRY_TEXT_AREA_KEY],'_textArea',{});if(_lodash2.default.isFunction(_textArea.focus)){_textArea.focus();}this.handleEntryFocusEvent();}/**
   * Upon foucs, fire the ga event
   * @return {undefined} Returns nothing
   */},{key:'handleEntryFocusEvent',value:function handleEntryFocusEvent(){if(!this.hasEntryFocusEventFired){this.hasEntryFocusEventFired=true;(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'sign_guest_book_gbheader',eventLabel:'onpage'});}}/**
   * Handles when the entry text area updates to adjust the height
   * @return {Undefined} Returns nothing
   */},{key:'handleEntryUpdate',value:function handleEntryUpdate(){var textArea=_lodash2.default.get(this,'_entryTextArea._textArea');if(textArea){textArea.style.height='auto';textArea.style.height=textArea.scrollHeight+'px';}}/**
   * Handle an input change
   * @param  {Object} e The Event object
   * @param  {String} key The state key
   * @return {Undefined} Returns nothing
   */},{key:'handleInputChange',value:function handleInputChange(e,key){var _this7=this;var value=e.target.value;var stateObj={};stateObj[key]=value;this.setState(stateObj,function(){if(key==='entry'){_this7.handleEntryUpdate();}});this[SUGGESTED_ENTRY_KEY].resetEntries();}/**
   * Resize handler
   * @return {Undefined} Returns nothing
   */},{key:'handleResize',value:function handleResize(){if(!this.state.mediaUpload){this.handleEntryUpdate();}this.setPromptText(this.props.firstName,this.textOptions);this.setSignupStyle(this.isClient,this.state.isExpanded,this.props.isNFGB,this.state.signupStyle);}/**
   * sets the style of the email signup input element
   * @param   {boolean}   isClient      is window available
   * @param   {boolean}   isExpanded    is the entry expanded
   * @param   {boolean}   isNFGB        is the page a national featured guestbook
   * @param   {object}    currentStyle  the current state of the signup style
   * @return  {undefined} returns nothing
   */},{key:'setSignupStyle',value:function setSignupStyle(isClient,isExpanded,isNFGB,currentStyle){if(isClient){var display=currentStyle.display;var visibility=currentStyle.visibility;var style={};if(isExpanded&&!isNFGB&&this.state.showSignupToggle){style={visibility:'visible',display:'block'};if(display!==style.display||visibility!==style.visibility){this.setState({signupStyle:style});}}else{var stackPoint=1017;style={visibility:'hidden',display:window.innerWidth<stackPoint?'none':'block'};if(display!==style.display||visibility!==style.visibility){this.setState({signupStyle:style});}}}}/**
   * Strips html and replace carriage returns with <br /> tags
   * @method sanitizeMessage
   * @param  {string} message - user submitted condolence entry
   * @return {string} returns the cleaned message
   */},{key:'sanitizeMessage',value:function sanitizeMessage(message){return _lodash2.default.isString(message)?(0,_formatHelpers.sanitizeText)(message.replace(/\r\n|\r|\n/g,'<br />'),['br']):'';}/**
   * Handles condolence submission
   * @param   {object} e  the Event object
   * @return  {undefined} returns nothing
   */},{key:'handleSubmit',value:function handleSubmit(e){var _this8=this;e.preventDefault();/* add full validation in (future) */var isValidEntry=this.isValidEntry(this.state.entry,this.state.firstName,this.state.lastName,this.props.mediaCollection);var videoId=!_lodash2.default.isEmpty(this.props.mediaCollection)&&_lodash2.default.get(this.props,'mediaCollection[0].mediaType')===MEDIA_TYPES.video&&_lodash2.default.get(this.props,'mediaCollection[0].id');var videoCaption=videoId?_lodash2.default.get(this.props,'mediaCollection[0].caption',false):false;var pictures=!_lodash2.default.isEmpty(this.props.mediaCollection)&&!videoId?this.props.mediaCollection.map(function(item){return{url:item.url,caption:_this8.sanitizeMessage(item.caption),width:item.width,height:item.height};}):[];var submissionData={message:this.sanitizeMessage(this.state.entry),firstName:this.state.firstName,lastName:this.state.lastName,email:this.state.email,relationship:this.state.relationship==='none'?'':this.state.relationship,city:this.state.city,stateId:parseInt(this.state.state,10),videoId:videoId,videoCaption:videoCaption?this.sanitizeMessage(videoCaption):false};var hasPersonAlertRequest=_lodash2.default.get(this.props,'location.query.pid')&&this.state.email&&this.props.sourceId&&this.state.hasPersonAlertRequest;var personAlert=null;if(hasPersonAlertRequest){personAlert={personId:this.props.location.query.pid,email:this.state.email,guestBookId:this.props.sourceId};}var isInvalidPersonAlert=!this.state.email&&this.state.hasPersonAlertRequest;var isInvalidEmail=this.state.email&&!(0,_validationHelpers.validateEmail)(this.state.email);var isValideSubmission=isValidEntry&&!isInvalidPersonAlert&&!isInvalidEmail&&_lodash2.default.isFunction(this.props.handleSubmit);if(isInvalidEmail||isInvalidPersonAlert){this.props.handleDisplayError('invalidEmail');}if(isValideSubmission){this.props.handleSubmit(submissionData,pictures,personAlert);}}/**
   * Checks if entry is valid for submission - can be fleshed more out later
   * @param  {String}  entry The entry
   * @param  {String}  firstName The first name field
   * @param  {String}  lastName  The last name field
   * @param  {Array}  mediaCollection  The mediaCollection array
   * @return {Boolean} If the form can be submitted
   */},{key:'isValidEntry',value:function isValidEntry(entry,firstName,lastName,mediaCollection){return!_lodash2.default.isEmpty(_lodash2.default.trim(entry))||!_lodash2.default.isEmpty(_lodash2.default.trim(firstName))||!_lodash2.default.isEmpty(_lodash2.default.trim(lastName))||!_lodash2.default.isEmpty(mediaCollection);}/**
   * Toggles the person alert request
   * @return {undefined} returns nothing
   */},{key:'toggleEmailSignUp',value:function toggleEmailSignUp(){this.setState(function(prevState){return{hasPersonAlertRequest:!prevState.hasPersonAlertRequest};});}/**
   * Sets styles for tooltip
   * @return {undefined} Returns nothing
   */},{key:'setTooltipStyles',value:function setTooltipStyles(){var element=this[PERSON_SIGNUP_KEY];if(element){var selfRect=element.getBoundingClientRect();this.setState({tooltipStyles:{display:'block',bottom:selfRect.height+10+'px'}});}}/**
   * React Component render.
   * @return {JSX} Condolence Entry rendered.
   */},{key:'render',value:function render(){var baseId='CondolenceEntry';var _props=this.props,condolenceError=_props.condolenceError,isSubmitting=_props.isSubmitting,mediaCollection=_props.mediaCollection;var isValidEntry=this.isValidEntry(this.state.entry,this.state.firstName,this.state.lastName,mediaCollection);return _react2.default.createElement('div',{className:_CondolenceEntry2.default.Entry},this.props.mediaCollection?_react2.default.createElement(_MediaBar2.default,{handleEditOverlay:this.props.handleEditOverlay,mediaCollection:this.props.mediaCollection,showCollection:this.props.showCollection}):null,_react2.default.createElement('div',{className:_CondolenceEntry2.default.panel,ref:this.setRefEntryPanel},_react2.default.createElement('img',{className:this.props.isCandleLit?'':_CondolenceEntry2.default.hideCandle,src:this.candleUrl}),_react2.default.createElement('div',{className:this.props.isCandleLit?_CondolenceEntry2.default.isCandleLit:''},_react2.default.createElement(TextArea,{className:_CondolenceEntry2.default.textArea,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'entry'),handleFocus:this.handleEntryFocus,id:baseId,placeholder:this.state.promptText,ref:this.setRefTextArea,value:this.state.entry})),_react2.default.createElement(_SuggestedEntries2.default,{ref:this.setRefSuggestedEntries,setSuggestedEntry:this.setSuggestedEntry}),_react2.default.createElement(_library.Collapse,{'in':this.state.isExpanded},_react2.default.createElement('div',{'aria-hidden':!this.state.isExpanded,className:_CondolenceEntry2.default.panelContent},_react2.default.createElement(TextInput,{className:_CondolenceEntry2.default.action,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'firstName'),id:baseId+'_firstName',isInvalid:this.state.errors.firstName,name:'firstName',placeholder:'First Name',value:this.state.firstName}),_react2.default.createElement(TextInput,{className:_CondolenceEntry2.default.action,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'lastName'),id:baseId+'_lastName',isInvalid:this.state.errors.lastName,name:'lastName',placeholder:'Last Name',value:this.state.lastName}),_react2.default.createElement(SelectList,{className:_CondolenceEntry2.default.action,defaultValue:this.relationshipOptions[0].value,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'relationship'),id:baseId+'_relationship',isInvalid:this.state.errors.relationship,name:'relationship',options:this.relationshipOptions,value:this.state.relationship}),_react2.default.createElement(TextInput,{className:_CondolenceEntry2.default.action,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'city'),id:baseId+'_city',isInvalid:this.state.errors.city,name:'city',placeholder:'City',value:this.state.city}),_react2.default.createElement(SelectList,{className:_CondolenceEntry2.default.action,defaultValue:this.states[0].value,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'state'),id:baseId+'_state',isInvalid:this.state.errors.state,name:'state',options:this.states,value:this.state.state}),_react2.default.createElement(TextInput,{className:_CondolenceEntry2.default.action,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'email'),id:baseId+'_email',isInvalid:this.state.errors.email,name:'email',placeholder:this.state.hasPersonAlertRequest?'Email Address':'Email Address (optional)',type:'email',value:this.state.email}))),_react2.default.createElement('div',{className:_CondolenceEntry2.default.lowerPanel},_react2.default.createElement('div',{className:_CondolenceEntry2.default.emailSignUp,style:this.state.signupStyle},_react2.default.createElement('input',{className:_CondolenceEntry2.default.emailCheckBox,defaultChecked:true,id:'emailSignUp',onChange:this.toggleEmailSignUp,type:'checkbox'}),_react2.default.createElement('label',{htmlFor:'emailSignUp'},'Get email updates for this page',_react2.default.createElement('span',{onMouseOver:this.setTooltipStyles,ref:this.setRefPersonSignUp},' ',_react2.default.createElement(_Svgs.InfoIcon,null),_react2.default.createElement('aside',{style:this.state.tooltipStyles},_react2.default.createElement('div',{className:_CondolenceEntry2.default.arrow}),_react2.default.createElement('p',null,'Get email updates about',' ',_react2.default.createElement('span',null,this.names.join(' ')),' delivered directly to your inbox.'))))),_react2.default.createElement('div',{className:_CondolenceEntry2.default.buttonGroup},this.state.isExpanded?_react2.default.createElement(Button,{btnType:'primary',className:_CondolenceEntry2.default.cancel,disabled:isSubmitting,handleClick:this.clearForm},'Cancel'):null,_react2.default.createElement(Button,{btnType:'primary',className:_CondolenceEntry2.default.submit,disabled:!isValidEntry||isSubmitting,handleClick:this.handleSubmit,id:baseId+'_submit'},'Submit')),_react2.default.createElement('div',{className:_CondolenceEntry2.default.guidelines},_react2.default.createElement('a',{href:this.guidelinesLink,target:'_blank'},'Posting Guidelines'),_react2.default.createElement('span',{className:_CondolenceEntry2.default.divider},'|'),_react2.default.createElement('a',{href:this.faqLink,target:'_blank'},'FAQ'))),_react2.default.createElement('div',{className:_CondolenceEntry2.default.clearFix})),condolenceError?_react2.default.createElement('div',null,_react2.default.createElement('p',{className:_CondolenceEntry2.default.errorMessage},_react2.default.createElement('span',{className:_CondolenceEntry2.default.errorIcon},'i'),'\xA0',' ',condolenceError)):null);}}]);return CondolenceEntry;}(_react2.default.Component);CondolenceEntry.propTypes={allowPhotos:_react2.default.PropTypes.bool,allowVideos:_react2.default.PropTypes.bool,condolenceError:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string,_react2.default.PropTypes.bool]),firstName:_react2.default.PropTypes.string,handleEditOverlay:_react2.default.PropTypes.func,handleEntryToggle:_react2.default.PropTypes.func,handleCandleToggle:_react2.default.PropTypes.func,handleDisplayError:_react2.default.PropTypes.func,handleMediaCollection:_react2.default.PropTypes.func,handleSubmit:_react2.default.PropTypes.func,isCandleLit:_react2.default.PropTypes.bool,isNFGB:_react2.default.PropTypes.bool,isSubmitting:_react2.default.PropTypes.bool,lastName:_react2.default.PropTypes.string,location:_react2.default.PropTypes.object,mediaCollection:_react2.default.PropTypes.array,mutationStatus:_react2.default.PropTypes.object,obitFirstName:_react2.default.PropTypes.string,showCollection:_react2.default.PropTypes.bool,sourceId:_react2.default.PropTypes.number};exports.default=CondolenceEntry;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _SuggestedEntries=__webpack_require__(1637);var _SuggestedEntries2=_interopRequireDefault(_SuggestedEntries);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _componentHelpers=__webpack_require__(26);var _library=__webpack_require__(40);var _suggestedEntries=__webpack_require__(1638);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * suggested condolence entries
 * @class SuggestedEntries
 */var SuggestedEntries=function(_React$Component){(0,_inherits3.default)(SuggestedEntries,_React$Component);function SuggestedEntries(){(0,_classCallCheck3.default)(this,SuggestedEntries);var _this=(0,_possibleConstructorReturn3.default)(this,(SuggestedEntries.__proto__||(0,_getPrototypeOf2.default)(SuggestedEntries)).call(this));_this.state={isExpanded:false};_this.entries=_lodash2.default.map(_suggestedEntries.suggestedEntries,_this.createEntry);(0,_componentHelpers.bindMethods)(_this,['handleToggleClick']);return _this;}/**
   * Builds out an object with the active flag, display and full text
   * @param  {string} entry the full suggested entry
   * @return {object} the entry object
   */(0,_createClass3.default)(SuggestedEntries,[{key:'createEntry',value:function createEntry(entry){var displayOptions={separator:' ',length:35};return{isActive:false,displayText:_lodash2.default.truncate(entry,displayOptions),fullText:entry};}/**
   * Sets the style flag for the active suggested entry
   * @param  {array}     entries     the array of suggested entries
   * @param  {number}    activeIndex the location of the current active entry
   * @return {undefined} returns nothing
   */},{key:'setActiveStyle',value:function setActiveStyle(entries,activeIndex){_lodash2.default.forEach(entries,function(entry,index){if(index===activeIndex){entry.isActive=true;}else{entry.isActive=false;}});}/**
   * Sets the static and dynamic styles for each of the suggested entries
   * @param  {boolean}   isActive is a particular entry currently active?
   * @return {string}    the current classes for each entry
   */},{key:'setEntryStyles',value:function setEntryStyles(isActive){var conditionalClasses={};conditionalClasses[_SuggestedEntries2.default.active]=isActive;return(0,_classnames2.default)(_SuggestedEntries2.default.entry,conditionalClasses);}/**
   * Seeds the click handler with the full entry text and the current index
   * @param  {array}     entries the suggested entry array
   * @param  {number}    index   the location of the current selected entry
   * @return {function}  Seeded click handler
   */},{key:'handleEntryClick',value:function handleEntryClick(entries,index){var _this2=this;return function(){_this2.setActiveStyle(entries,index);_this2.props.setSuggestedEntry(entries[index].fullText);};}/**
   * Expand or collapse the suggested entries section
   * @return {undefined} returns nothing
   */},{key:'handleToggleClick',value:function handleToggleClick(){this.setState(function(prevState){return{isExpanded:!prevState.isExpanded};});}/**
   * Sets active flags to false and closes the suggested entries module
   * @return {undefined}  returns nothing
   */},{key:'resetEntries',value:function resetEntries(){if(this.state.isExpanded){this.setState({isExpanded:false});}_lodash2.default.forEach(this.entries,function(entry){entry.isActive=false;});}},{key:'render',value:function render(){var _this3=this;var isExpanded=this.state.isExpanded;var toggleText=isExpanded?'Hide Suggestions ^':'Not sure what to say?';return _lodash2.default.isFunction(this.props.setSuggestedEntry)?_react2.default.createElement('div',{className:_SuggestedEntries2.default.SuggestedEntries},_react2.default.createElement('p',{className:_SuggestedEntries2.default.toggleEntries,onClick:this.handleToggleClick},toggleText),_react2.default.createElement(_library.Collapse,{'in':isExpanded},_react2.default.createElement('div',{'aria-hidden':!isExpanded},this.entries.map(function(entry,index){return _react2.default.createElement('div',{alt:entry.fullText,className:_this3.setEntryStyles(entry.isActive),key:index,onClick:_this3.handleEntryClick(_this3.entries,index),title:entry.fullText},_react2.default.createElement('p',null,entry.displayText));}),_react2.default.createElement('div',{className:_SuggestedEntries2.default.clearFix})))):null;}}]);return SuggestedEntries;}(_react2.default.Component);SuggestedEntries.propTypes={setSuggestedEntry:_react2.default.PropTypes.func};exports.default=SuggestedEntries;

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","SuggestedEntries":"SuggestedEntries","toggleEntries":"toggleEntries","entry":"entry","active":"active","clearFix":"clearFix"};

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

module.exports = {
	"suggestedEntries": [
		"May God bless you and your family in this time of sorrow.",
		"May your hearts soon be filled with wonderful memories of joyful times together as you celebrate a life well lived.",
		"May the love of friends and family carry you through your grief.",
		"As the days and weeks pass, and as you return to life's routine, may you continue to feel comforted by the love and support of family and friends.",
		"In loving memory of a wonderful person. We will love you and miss you always.",
		"Grief can be so hard, but our special memories help us cope. Remembering you and your loved one today and always."
	]
};

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.validateEmail=validateEmail;/**
 * Validates email form element
 * @param  {string}   value Value of email input element
 * @return {boolean}  Boolean of valid value
 */function validateEmail(value){return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);}

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","Entry":"Entry","panel":"panel","clearFix":"clearFix","textArea":"textArea","isCandleLit":"isCandleLit","hideCandle":"hideCandle","panelContent":"panelContent","action":"action","lowerPanel":"lowerPanel","guidelines":"guidelines","divider":"divider","emailSignUp":"emailSignUp","emailCheckBox":"emailCheckBox","arrow":"arrow","buttonGroup":"buttonGroup","submit":"submit","cancel":"cancel","errorMessage":"errorMessage","errorIcon":"errorIcon"};

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _MediaBarItem=__webpack_require__(1642);var _MediaBarItem2=_interopRequireDefault(_MediaBarItem);var _MediaBar=__webpack_require__(1644);var _MediaBar2=_interopRequireDefault(_MediaBar);var _componentHelpers=__webpack_require__(26);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MediaBar=function(_React$Component){(0,_inherits3.default)(MediaBar,_React$Component);/**
   * MediaBar Component constructor
   * @return {Undefined} Returns nothing
   */function MediaBar(){(0,_classCallCheck3.default)(this,MediaBar);var _this=(0,_possibleConstructorReturn3.default)(this,(MediaBar.__proto__||(0,_getPrototypeOf2.default)(MediaBar)).call(this));_this.mediaBarRef=null;_this.setMediaBarRef=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'mediaBarRef',_this);(0,_componentHelpers.bindMethods)(_this,['getRef']);return _this;}/**
   * Getter for mediaBarRef
   * @return {Object} DOM Element
   */(0,_createClass3.default)(MediaBar,[{key:'getRef',value:function getRef(){return this.mediaBarRef;}/**
   * React Component render.
   * @return {JSX} MediaBar rendered.
   */},{key:'render',value:function render(){var _this2=this;var _props=this.props,handleEditOverlay=_props.handleEditOverlay,mediaCollection=_props.mediaCollection,showCollection=_props.showCollection;return _lodash2.default.size(mediaCollection)!==0&&showCollection?_react2.default.createElement('div',{className:_MediaBar2.default.MediaBar,ref:this.setMediaBarRef},mediaCollection.map(function(item,index){return _react2.default.createElement(_MediaBarItem2.default,{caption:item.caption,filename:item.filename,handleEditOverlay:handleEditOverlay,key:index,mediaType:item.mediaType,parentRefGetter:_this2.getRef,url:item.url});})):null;}}]);return MediaBar;}(_react2.default.Component);MediaBar.propTypes={handleEditOverlay:_react2.default.PropTypes.func,mediaCollection:_react2.default.PropTypes.array,showCollection:_react2.default.PropTypes.bool};exports.default=MediaBar;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _MediaBarItem=__webpack_require__(1643);var _MediaBarItem2=_interopRequireDefault(_MediaBarItem);var _componentHelpers=__webpack_require__(26);var _constants=__webpack_require__(41);var _Svgs=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MediaBarItem=function(_React$Component){(0,_inherits3.default)(MediaBarItem,_React$Component);/**
   * MediaBarItem Component constructor
   * @param  {object}    props passed in properties
   * @return {Undefined} Returns nothing
   */function MediaBarItem(props){(0,_classCallCheck3.default)(this,MediaBarItem);var _this=(0,_possibleConstructorReturn3.default)(this,(MediaBarItem.__proto__||(0,_getPrototypeOf2.default)(MediaBarItem)).call(this,props));_this.state={captionStyles:{},arrowStyles:{}};_this.mediaBarItemRef=null;_this.setMediaBarItemRef=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'mediaBarItemRef',_this);_this.fileName=_this.formatFileName(props.filename);(0,_componentHelpers.bindMethods)(_this,['setStyles']);return _this;}(0,_createClass3.default)(MediaBarItem,[{key:'formatFileName',value:function formatFileName(filename){var name=_lodash2.default.isString(filename)?filename:'';if(name.length>36){var beginning=name.substr(0,name.lastIndexOf('.')-3);var end=name.substr(beginning.length-1,name.length);var options={length:30-end.length};name=''+_lodash2.default.truncate(beginning,options)+end;}return name;}/**
   * Sets styles for captions
   * @return {Undefined} Returns nothing
   */},{key:'setStyles',value:function setStyles(){var parentElement=this.props.parentRefGetter();var element=this.mediaBarItemRef;if(parentElement&&element){var parentRect=parentElement.getBoundingClientRect();var selfRect=element.getBoundingClientRect();var captionWidth=300;var arrowWidthOffset=15;var captionOffset=10;var captionLeft=-((captionWidth-selfRect.width)/2);var arrowLeft=captionWidth/2;var xMin=selfRect.left-parentRect.left+captionLeft;var xMax=selfRect.left+selfRect.width-parentRect.width-captionLeft;if(xMin<0){captionLeft-=captionLeft-captionOffset;arrowLeft=selfRect.width/2-captionOffset;}else if(xMax>0){var diff=parentRect.width+parentRect.left-(selfRect.left+selfRect.width);captionLeft+=captionLeft+diff-captionOffset;arrowLeft=captionWidth-selfRect.width/2-diff+captionOffset;}this.setState({captionStyles:{display:'block',left:captionLeft+'px',top:selfRect.height-10+'px'},arrowStyles:{left:arrowLeft-arrowWidthOffset+'px'}});}}/**
   * React Component render.
   * @return {JSX} MediaBarItem rendered.
   */},{key:'render',value:function render(){var _props=this.props,caption=_props.caption,handleEditOverlay=_props.handleEditOverlay,mediaType=_props.mediaType,url=_props.url;return url?_react2.default.createElement('div',{className:_MediaBarItem2.default.MediaBarItem,onClick:handleEditOverlay,onMouseOver:caption?this.setStyles:null,ref:this.setMediaBarItemRef},caption?_react2.default.createElement('aside',{style:this.state.captionStyles},_react2.default.createElement('div',{className:_MediaBarItem2.default.arrow,style:this.state.arrowStyles}),_react2.default.createElement('p',null,caption)):null,mediaType===_constants.MEDIA_TYPES.video?_react2.default.createElement('div',{className:_MediaBarItem2.default.mediaDisplay},_react2.default.createElement(_Svgs.VideoUploadIcon,null),_react2.default.createElement('p',null,this.fileName)):_react2.default.createElement('img',{src:url})):null;}}]);return MediaBarItem;}(_react2.default.Component);MediaBarItem.propTypes={caption:_react2.default.PropTypes.string,handleEditOverlay:_react2.default.PropTypes.func,mediaType:_react2.default.PropTypes.string,filename:_react2.default.PropTypes.string,parentRefGetter:_react2.default.PropTypes.func.isRequired,url:_react2.default.PropTypes.string};exports.default=MediaBarItem;

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","MediaBarItem":"MediaBarItem","arrow":"arrow","mediaDisplay":"mediaDisplay"};

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","MediaBar":"MediaBar"};

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(171);var _stringify2=_interopRequireDefault(_stringify);var _promise=__webpack_require__(370);var _promise2=_interopRequireDefault(_promise);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _gatewayFetch=__webpack_require__(178);var _gatewayFetch2=_interopRequireDefault(_gatewayFetch);var _superagent=__webpack_require__(1646);var _superagent2=_interopRequireDefault(_superagent);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);var _EntryNav=__webpack_require__(1650);var _EntryNav2=_interopRequireDefault(_EntryNav);var _componentHelpers=__webpack_require__(26);var _constants=__webpack_require__(41);var _queryTemplates=__webpack_require__(243);var _Svgs=__webpack_require__(36);var _scrollHelpers=__webpack_require__(372);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conf=(0,_AppConfig2.default)();/**
 * The navigation buttons for the condolence entry
 * @param   {object}  props - passed down props
 * @return  {JSX}     returns the entry navigation
 *//* eslint-disable global-require *//* eslint-disable no-console */var EntryNav=function(_React$Component){(0,_inherits3.default)(EntryNav,_React$Component);function EntryNav(props){(0,_classCallCheck3.default)(this,EntryNav);var _this=(0,_possibleConstructorReturn3.default)(this,(EntryNav.__proto__||(0,_getPrototypeOf2.default)(EntryNav)).call(this,props));var debug=_lodash2.default.get(props,'location.query.debug');_this.filepicker=_this.getFilePicker(debug);_this.scrollPosition=0;_this.pictures=[];_this.setVideoInputRef=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,_constants.VIDEO_INPUT,_this);_this.viddlerUploadData=null;_this.fpPolicy=_lodash2.default.get(props,'fpData.fpPolicy',null);_this.fpSignature=_lodash2.default.get(props,'fpData.fpSignature',null);_this.videoFormats='.mp4,.m4v,h.264,.avi,.mov1,.mov,.wmv,.wmv9,.mpg,.mpeg,.m2v,.mpeg-1,.mpeg-2,.mkv';(0,_componentHelpers.bindMethods)(_this,['createUploadDialog','onVideoAdd','togglePhotoUpload']);return _this;}/* picture upload methods *//**
   * Creates filepicker instance or returns existing one
   * @param  {number} debug the query param to disable ads and 3rd party scripts
   * @return {class}  filepicker instance
   */(0,_createClass3.default)(EntryNav,[{key:'getFilePicker',value:function getFilePicker(debug){if(typeof window!=='undefined'&&debug!=='3'&&debug!=='4'){__webpack_require__(1651);window.filepicker.setKey(conf.filepicker.key);return window.filepicker;}}/**
   * Complete hack for filestack overlay on phones
   * @param  {number} [y=0] y Position of scroll
   * @return {undefined}       Returns nothing
   */},{key:'scrollTo',value:function scrollTo(){var y=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;if(this.props.mobileDetails.apple.device){var element=this.props.isInferiorBrowser?document.documentElement:document.body;element.style.position='fixed';element.style.width='100%';var scrollSpeed=500;(0,_scrollHelpers.scrollToTop)(element,y,scrollSpeed);}}/**
   * Parses filepicker data and adds creds and id
   * @param  {array}      filePickerResponse filepicker data
   * @return {undefined}  Returns nothing
   */},{key:'handlePickComplete',value:function handlePickComplete(filePickerResponse){var _this2=this;var urls=JSON.parse(filePickerResponse);var credentials=this.fpPolicy&&this.fpSignature?'?policy='+this.fpPolicy+'&signature='+this.fpSignature:'';var pictures=urls.map(function(picture){return new _promise2.default(function(resolve,reject){var pictureOutput=picture;pictureOutput.fileExtension=(0,_componentHelpers.getMediaExtension)(picture.mimetype);pictureOutput.id=_lodash2.default.last(picture.url.split('/'));pictureOutput.mediaType=(0,_componentHelpers.getMediaType)(picture.mimetype);pictureOutput.url=''+picture.url+credentials;_this2.filepicker.convert(picture,{format:'jpg',rotate:'exif'},function(convertedPicture){pictureOutput.fileExtension=(0,_componentHelpers.getMediaExtension)(convertedPicture.mimetype);pictureOutput.filename=convertedPicture.filename;pictureOutput.id=_lodash2.default.last(convertedPicture.url.split('/'));pictureOutput.isWriteable=convertedPicture.isWriteable;pictureOutput.mediaType=(0,_componentHelpers.getMediaType)(convertedPicture.mimetype);pictureOutput.mimetype=convertedPicture.mimetype;pictureOutput.size=convertedPicture.size;pictureOutput.url=''+convertedPicture.url+credentials;_this2.filepicker.stat(convertedPicture,{width:true,height:true},function(dimensions){pictureOutput.height=dimensions.height;pictureOutput.width=dimensions.width;resolve(pictureOutput);},function(err){reject(err);});},function(err){reject(err);});}).catch(function(reason){console.log('error with filepicker `stat` or `convert`',reason);return{};});});this.props.handleMediaCollection(pictures,true,this.scrollPosition);}/**
   * Uploads files to filepickers's api, sets CondolenceEntry's pictures state
   * @param  {array}      mimetype   the allowed file type(s) i.e. 'image/*'
   * @param  {array}      services   outside services to pick files from i.e. ['COMPUTER', 'FACEBOOK', 'CLOUDAPP']
   * @param  {string}     container  the filepicker popup type: 'modal' or 'window'
   * @return {undefined}  Retruns nothing
   */},{key:'handlePick',value:function handlePick(mimetype,services){var _this3=this;var container=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'modal';var options={mimetype:mimetype,services:services,container:container};var _ref=this.props.fpData||{},fpPolicy=_ref.fpPolicy,fpSignature=_ref.fpSignature;if(fpPolicy&&fpSignature){options.policy=fpPolicy;options.signature=fpSignature;}if(_lodash2.default.isFunction(_lodash2.default.get(this,'filepicker.pickMultiple'))){this.filepicker.pickMultiple(options,function(blob){_this3.pictures.push((0,_stringify2.default)(blob));_this3.handlePickComplete(_this3.pictures[0]);},function(fpError){if(fpError.code!==101){_this3.props.handleDisplayError('picturesUpload');}_this3.props.handleMediaCollection([],false,_this3.scrollPosition);});}else{this.props.handleDisplayError('picturesUnavailable');}this.scrollPosition=window.pageYOffset;this.scrollTo(0);}/**
   * Toggle the photo upload menu - sets the media upload state
   * @method  togglePhotoUpload
   * @return  {undefined} Returns nothing
   */},{key:'togglePhotoUpload',value:function togglePhotoUpload(){this.pictures=[];this.props.handleDisplayError();this.handlePick(['image/*'],['COMPUTER','FACEBOOK','FLICKR','INSTAGRAM','PICASA']);}/* video upload methods *//**
   * Makes an ajax request to the gateway
   * to get the viddler upload endpoint and token
   * @method requestViddlerAuth
   * @return {undefind} returns the viddler auth information
   */},{key:'requestViddlerAuth',value:function requestViddlerAuth(){var _this4=this;return(0,_gatewayFetch2.default)(_queryTemplates.VIDDLER_AUTH_QUERY,'query').then(function(res){_this4.viddlerUploadData=_lodash2.default.get(res,'data.video');return _this4.viddlerUploadData;}).catch(function(err){console.log('error getting viddler auth',err);return err;});}/**
   * Creates the system dialog via a simulated click on the hidden input element
   * At this point we know a user wants to do a video upload so we request the auth
   * @method createUploadDialog
   * @return {undefined} returns nothing
   */},{key:'createUploadDialog',value:function createUploadDialog(){this.props.handleDisplayError();this.requestViddlerAuth();this[_constants.VIDEO_INPUT].click();}/**
   * Uploads a video to viddler
   * @method uploadVideo
   * @param  {string}    viddlerUrl endpoint to make the POST
   * @param  {string}    token      viddler auth token
   * @return {undefined} returns nothing, fires handleVideoUploadComplete on success
   */},{key:'uploadVideo',value:function uploadVideo(viddlerUrl,token){var _this5=this;var file=this[_constants.VIDEO_INPUT].files[0];this.props.handlePendingUpload('Loading',null);return _superagent2.default.post(viddlerUrl).field('name',file.name).field('uploadtoken',token).attach('file',file).then(function(res){if(res.error){_this5.props.handlePendingUpload(false,null);console.log('error response from viddler',res.error);}else{_this5.props.handlePendingUpload(false,_this5.handleVideoUploadComplete(res,file));}}).catch(function(){// the error will be displayed in handlePendingUpload
_this5.props.handlePendingUpload(false,null);});}/**
   * Listener on the video input, upon
   * @method onVideoAdd
   * @return {undefined} returns nothing, fires the viddler upload
   */},{key:'onVideoAdd',value:function onVideoAdd(){if(_lodash2.default.isObject(this.viddlerUploadData)){var _viddlerUploadData=this.viddlerUploadData,endpoint=_viddlerUploadData.endpoint,token=_viddlerUploadData.token;this.uploadVideo(endpoint,token);}else{this.props.handleDisplayError('video');}}/**
   * Processes the payload from viddler and fires handleMediaCollection
   * @method handleVideoUploadComplete
   * @param  {object}     viddlerResponse parsed response from viddler upload
   * @param  {object}     file            information about the video file
   * @return {undefined}  returns nothing, fires handleMediaCollection (GuestBook)
   */},{key:'handleVideoUploadComplete',value:function handleVideoUploadComplete(viddlerResponse,file){var payload=JSON.parse(viddlerResponse.text);var videoData=_lodash2.default.get(payload,'video',null);if(_lodash2.default.isObject(videoData)){var mimetype=_lodash2.default.get(file,'type','video/');var media={id:videoData.id,url:videoData.thumbnail_url,mimetype:mimetype,filename:_lodash2.default.get(file,'name','video'),mediaType:(0,_componentHelpers.getMediaType)(mimetype),fileExtension:(0,_componentHelpers.getMediaExtension)(mimetype)};this.props.handleMediaCollection([media],true);}else{this.props.handleDisplayError('video');}}},{key:'render',value:function render(){var _props=this.props,allowGuestBookPhoto=_props.allowGuestBookPhoto,allowGuestBookVideo=_props.allowGuestBookVideo,allowGuestBookCandle=_props.allowGuestBookCandle,handleEditOverlay=_props.handleEditOverlay,mediaCollection=_props.mediaCollection,isCandleLit=_props.isCandleLit,handleCandleToggle=_props.handleCandleToggle;var collectionSize=_lodash2.default.size(mediaCollection);var display=null;var mediaType=_lodash2.default.get(_lodash2.default.head(mediaCollection),'mediaType','Item');if(collectionSize!==0){var mediaString=collectionSize>1?mediaType+'s':''+mediaType;display=_react2.default.createElement('div',{className:_EntryNav2.default.EntryNav},_react2.default.createElement('span',{className:_EntryNav2.default.removeAll,onClick:handleEditOverlay},'Edit '+mediaString));}else if(isCandleLit){display=_react2.default.createElement('div',{className:_EntryNav2.default.EntryNav},_react2.default.createElement('span',{className:_EntryNav2.default.removeAll,onClick:handleCandleToggle},'Remove Candle'));}else if(this.props.handleMediaCollection){display=_react2.default.createElement('div',{className:_EntryNav2.default.EntryNav},_react2.default.createElement('div',{className:_EntryNav2.default.uploadButtons},allowGuestBookPhoto?_react2.default.createElement('button',{className:_EntryNav2.default.photo,onClick:this.togglePhotoUpload},_react2.default.createElement(_Svgs.AddPhotoIcon,null)):null,allowGuestBookCandle?_react2.default.createElement('button',{className:_EntryNav2.default.candle,onClick:handleCandleToggle},_react2.default.createElement(_Svgs.LightCandleIcon,null)):null),_react2.default.createElement('input',{accept:this.videoFormats,id:'videoupload',onChange:this.onVideoAdd,ref:this.setVideoInputRef,style:{display:'none'},type:'file'}));}return display;}}]);return EntryNav;}(_react2.default.Component);EntryNav.propTypes={allowGuestBookPhoto:_react2.default.PropTypes.bool,allowGuestBookVideo:_react2.default.PropTypes.bool,allowGuestBookCandle:_react2.default.PropTypes.bool,fpData:_react2.default.PropTypes.object,handleCandleToggle:_react2.default.PropTypes.func,handleDisplayError:_react2.default.PropTypes.func,handleEditOverlay:_react2.default.PropTypes.func,handleMediaCollection:_react2.default.PropTypes.func,handlePendingUpload:_react2.default.PropTypes.func,isCandleLit:_react2.default.PropTypes.bool,isInferiorBrowser:_react2.default.PropTypes.bool,location:_react2.default.PropTypes.object,mediaCollection:_react2.default.PropTypes.array,mobileDetails:_react2.default.PropTypes.object.isRequired};EntryNav.defaultProps={allowGuestBookPhoto:false,allowGuestBookVideo:false,allowGuestBookCandle:true};exports.default=EntryNav;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(1647);
var requestBase = __webpack_require__(1648);
var isObject = __webpack_require__(624);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = module.exports = __webpack_require__(1649).bind(null, Request);

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function type(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function params(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */),
        key = parts.shift(),
        val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req, options) {
  options = options || {};
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  this._setStatusProperties(this.xhr.status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);
  this.body = this.req.method != 'HEAD'
    ? this._parseBody(this.text ? this.text : this.xhr.response)
    : null;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

Response.prototype.get = function(field){
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

Response.prototype._setHeaderProperties = function(header){
  // content-type
  var ct = this.header['content-type'] || '';
  this.type = type(ct);

  // params
  var obj = params(ct);
  for (var key in obj) this[key] = obj[key];
};

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

Response.prototype._setStatusProperties = function(status){
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }

  var type = status / 100 | 0;

  // status / class
  this.status = this.statusCode = status;
  this.statusType = type;

  // basics
  this.info = 1 == type;
  this.ok = 2 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = (4 == type || 5 == type)
    ? this.toError()
    : false;

  // sugar
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.notFound = 404 == status;
  this.forbidden = 403 == status;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
      // issue #876: return the http status code if the response parsing fails
      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (res.status < 200 || res.status >= 300) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `requestBase`.
 */

Emitter(Request.prototype);
for (var key in requestBase) {
  Request.prototype[key] = requestBase[key];
}

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
 * 'arraybuffer'.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (!options) {
    options = {
      type: 'basic'
    }
  }

  switch (options.type) {
    case 'basic':
      var str = btoa(user + ':' + pass);
      this.set('Authorization', 'Basic ' + str);
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
  }
  return this;
};

/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, filename){
  this._getFormData().append(field, file, filename || file.name);
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  var fn = this._callback;
  this.clearTimeout();
  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

Request.prototype._timeoutError = function(){
  var timeout = this._timeout;
  var err = new Error('timeout of ' + timeout + 'ms exceeded');
  err.timeout = timeout;
  this.callback(err);
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += ~this.url.indexOf('?')
      ? '&' + query
      : '?' + query;
  }
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var timeout = this._timeout;
  var data = this._formData || this._data;

  // store callback
  this._callback = fn || noop;

  // state change
  xhr.onreadystatechange = function(){
    if (4 != xhr.readyState) return;

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (0 == status) {
      if (self.timedout) return self._timeoutError();
      if (self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  }
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // timeout
  if (timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self.timedout = true;
      self.abort();
    }, timeout);
  }

  // querystring
  this._appendQueryString();

  // initiate request
  if (this.username && this.password) {
    xhr.open(this.method, this.url, true, this.username, this.password);
  } else {
    xhr.open(this.method, this.url, true);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;
    xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};


/**
 * Expose `Request`.
 */

request.Request = Request;

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, fn){
  var req = request('DELETE', url);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(624);

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

exports.clearTimeout = function _clearTimeout(){
  this._timeout = 0;
  clearTimeout(this._timer);
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

exports.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

exports.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */

exports.timeout = function timeout(ms){
  this._timeout = ms;
  return this;
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} reject
 * @return {Request}
 */

exports.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

exports.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

exports.use = function use(fn) {
  fn(this);
  return this;
}


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

exports.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

exports.getHeader = exports.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

exports.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
exports.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
exports.field = function(name, val) {

  // name should be either a string or an object.
  if (null === name ||  undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
exports.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

exports.withCredentials = function(){
  // This is browser-only functionality. Node side is no-op.
  this._withCredentials = true;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

exports.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

exports.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

exports._isHost = function _isHost(obj) {
  var str = {}.toString.call(obj);

  switch (str) {
    case '[object File]':
    case '[object Blob]':
    case '[object FormData]':
      return true;
    default:
      return false;
  }
}

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

exports.send = function(data){
  var obj = isObject(data);
  var type = this._header['content-type'];

  // merge
  if (obj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!obj || this._isHost(data)) return this;

  // default to json
  if (!type) this.type('json');
  return this;
};


/***/ }),
/* 1649 */
/***/ (function(module, exports) {

// The node and browser modules expose versions of this with the
// appropriate constructor function bound as first argument
/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */

function request(RequestConstructor, method, url) {
  // callback
  if ('function' == typeof url) {
    return new RequestConstructor('GET', method).end(url);
  }

  // url first
  if (2 == arguments.length) {
    return new RequestConstructor('GET', method);
  }

  return new RequestConstructor(method, url);
}

module.exports = request;


/***/ }),
/* 1650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","EntryNav":"EntryNav","uploadButtons":"uploadButtons","photo":"photo","video":"video","candle":"candle"};

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

/*
    Module definition for browserify
*/
__webpack_require__(1652);
module.exports = filepicker;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function() {
    var fp = function() {
        var context = {};
        var addObjectTo = function(name, obj, base) {
            var path = name.split(".");
            for (var i = 0; i < path.length - 1; i++) {
                if (!base[path[i]]) {
                    base[path[i]] = {};
                }
                base = base[path[i]];
            }
            if (typeof obj === "function") {
                if (obj.isClass) {
                    base[path[i]] = obj;
                } else {
                    base[path[i]] = function() {
                        return obj.apply(context, arguments);
                    };
                }
            } else {
                base[path[i]] = obj;
            }
        };
        var extendObject = function(name, obj, is_public) {
            addObjectTo(name, obj, context);
            if (is_public) {
                addObjectTo(name, obj, window.filepicker);
            }
        };
        var extend = function(pkg, init_fn, is_public) {
            if (typeof pkg === "function") {
                is_public = init_fn;
                init_fn = pkg;
                pkg = "";
            }
            if (pkg) {
                pkg += ".";
            }
            var objs = init_fn.call(context);
            for (var obj_name in objs) {
                extendObject(pkg + obj_name, objs[obj_name], is_public);
            }
        };
        var internal = function(fn) {
            fn.apply(context, arguments);
        };
        return {
            extend: extend,
            internal: internal
        };
    }();
    if (!window.filepicker) {
        window.filepicker = fp;
    } else {
        for (var attr in fp) {
            window.filepicker[attr] = fp[attr];
        }
    }
})();

"use strict";

filepicker.extend("comm", function() {
    var fp = this;
    var COMM_IFRAME_NAME = "filepicker_comm_iframe";
    var API_IFRAME_NAME = "fpapi_comm_iframe";
    var openCommIframe = function() {
        if (window.frames[COMM_IFRAME_NAME] === undefined) {
            openCommunicationsChannel();
            var commIFrame;
            commIFrame = document.createElement("iframe");
            commIFrame.id = commIFrame.name = COMM_IFRAME_NAME;
            commIFrame.src = fp.urls.COMM;
            commIFrame.style.display = "none";
            document.body.appendChild(commIFrame);
        }
        if (window.frames[API_IFRAME_NAME] === undefined) {
            openCommunicationsChannel();
            var apiIFrame;
            apiIFrame = document.createElement("iframe");
            apiIFrame.id = apiIFrame.name = API_IFRAME_NAME;
            apiIFrame.src = fp.urls.API_COMM;
            apiIFrame.style.display = "none";
            document.body.appendChild(apiIFrame);
        }
    };
    var communicationsHandler = function(event) {
        if (event.origin !== fp.urls.BASE && event.origin !== fp.urls.DIALOG_BASE) {
            return;
        }
        try {
            var data = fp.json.parse(event.data);
        } catch (err) {
            console.log("[Filepicker] Failed processing message:", event.data);
        }
        if (data) {
            fp.handlers.run(data);
        }
    };
    var isOpen = false;
    var openCommunicationsChannel = function() {
        if (isOpen) {
            return;
        } else {
            isOpen = true;
        }
        if (window.addEventListener) {
            window.addEventListener("message", communicationsHandler, false);
        } else if (window.attachEvent) {
            window.attachEvent("onmessage", communicationsHandler);
        } else {
            throw new fp.FilepickerException("Unsupported browser");
        }
    };
    var destroyCommIframe = function() {
        if (window.removeEventListener) {
            window.removeEventListener("message", communicationsHandler, false);
        } else if (window.attachEvent) {
            window.detachEvent("onmessage", communicationsHandler);
        } else {
            throw new fp.FilepickerException("Unsupported browser");
        }
        if (!isOpen) {
            return;
        } else {
            isOpen = false;
        }
        var iframes = document.getElementsByName(COMM_IFRAME_NAME);
        for (var i = 0; i < iframes.length; i++) {
            iframes[i].parentNode.removeChild(iframes[i]);
        }
        try {
            delete window.frames[COMM_IFRAME_NAME];
        } catch (e) {}
        var api_iframes = document.getElementsByName(API_IFRAME_NAME);
        for (var j = 0; j < api_iframes.length; j++) {
            api_iframes[j].parentNode.removeChild(api_iframes[j]);
        }
        try {
            delete window.frames[API_IFRAME_NAME];
        } catch (e) {}
    };
    return {
        openChannel: openCommIframe,
        closeChannel: destroyCommIframe
    };
});

"use strict";

filepicker.extend("comm_fallback", function() {
    var fp = this;
    var FP_COMM_IFRAME_NAME = "filepicker_comm_iframe";
    var HOST_COMM_IFRAME_NAME = "host_comm_iframe";
    var base_host_location = "";
    var hash_check_interval = 200;
    var openCommIframe = function() {
        openHostCommIframe();
    };
    var openHostCommIframe = function() {
        if (window.frames[HOST_COMM_IFRAME_NAME] === undefined) {
            var hostCommIFrame;
            hostCommIFrame = document.createElement("iframe");
            hostCommIFrame.id = hostCommIFrame.name = HOST_COMM_IFRAME_NAME;
            base_host_location = hostCommIFrame.src = fp.urls.constructHostCommFallback();
            hostCommIFrame.style.display = "none";
            var onload = function() {
                base_host_location = hostCommIFrame.contentWindow.location.href;
                openFPCommIframe();
            };
            if (hostCommIFrame.attachEvent) {
                hostCommIFrame.attachEvent("onload", onload);
            } else {
                hostCommIFrame.onload = onload;
            }
            document.body.appendChild(hostCommIFrame);
        }
    };
    var openFPCommIframe = function() {
        if (window.frames[FP_COMM_IFRAME_NAME] === undefined) {
            var fpCommIFrame;
            fpCommIFrame = document.createElement("iframe");
            fpCommIFrame.id = fpCommIFrame.name = FP_COMM_IFRAME_NAME;
            fpCommIFrame.src = fp.urls.FP_COMM_FALLBACK + "?host_url=" + encodeURIComponent(base_host_location);
            fpCommIFrame.style.display = "none";
            document.body.appendChild(fpCommIFrame);
        }
        openCommunicationsChannel();
    };
    var isOpen = false;
    var timer;
    var lastHash = "";
    var checkHash = function() {
        var comm_iframe = window.frames[FP_COMM_IFRAME_NAME];
        if (!comm_iframe) {
            return;
        }
        var host_iframe = comm_iframe.frames[HOST_COMM_IFRAME_NAME];
        if (!host_iframe) {
            return;
        }
        var hash = host_iframe.location.hash;
        if (hash && hash.charAt(0) === "#") {
            hash = hash.substr(1);
        }
        if (hash === lastHash) {
            return;
        }
        lastHash = hash;
        if (!lastHash) {
            return;
        }
        var data;
        try {
            data = fp.json.parse(hash);
        } catch (e) {}
        if (data) {
            fp.handlers.run(data);
        }
    };
    var openCommunicationsChannel = function() {
        if (isOpen) {
            return;
        } else {
            isOpen = true;
        }
        timer = window.setInterval(checkHash, hash_check_interval);
    };
    var destroyCommIframe = function() {
        window.clearInterval(timer);
        if (!isOpen) {
            return;
        } else {
            isOpen = false;
        }
        var iframes = document.getElementsByName(FP_COMM_IFRAME_NAME);
        for (var i = 0; i < iframes.length; i++) {
            iframes[i].parentNode.removeChild(iframes[i]);
        }
        try {
            delete window.frames[FP_COMM_IFRAME_NAME];
        } catch (e) {}
        iframes = document.getElementsByName(HOST_COMM_IFRAME_NAME);
        for (i = 0; i < iframes.length; i++) {
            iframes[i].parentNode.removeChild(iframes[i]);
        }
        try {
            delete window.frames[HOST_COMM_IFRAME_NAME];
        } catch (e) {}
    };
    var isEnabled = !("postMessage" in window);
    var setEnabled = function(enabled) {
        if (enabled !== isEnabled) {
            isEnabled = !!enabled;
            if (isEnabled) {
                activate();
            } else {
                deactivate();
            }
        }
    };
    var old_comm;
    var activate = function() {
        old_comm = fp.comm;
        fp.comm = {
            openChannel: openCommIframe,
            closeChannel: destroyCommIframe
        };
    };
    var deactivate = function() {
        fp.comm = old_comm;
        old_comm = undefined;
    };
    if (isEnabled) {
        activate();
    }
    return {
        openChannel: openCommIframe,
        closeChannel: destroyCommIframe,
        isEnabled: isEnabled
    };
});

"use strict";

filepicker.extend("cookies", function() {
    var fp = this;
    var getReceiveCookiesMessage = function(callback) {
        var handler = function(data) {
            if (data.type !== "ThirdPartyCookies") {
                return;
            }
            fp.cookies.THIRD_PARTY_COOKIES = !!data.payload;
            if (callback && typeof callback === "function") {
                callback(!!data.payload);
            }
        };
        return handler;
    };
    var checkThirdParty = function(callback) {
        var handler = getReceiveCookiesMessage(callback);
        fp.handlers.attach("cookies", handler);
        fp.comm.openChannel();
    };
    return {
        checkThirdParty: checkThirdParty
    };
});

"use strict";

filepicker.extend("handlers", function() {
    var fp = this;
    var storage = {};
    var attachHandler = function(id, handler) {
        if (storage.hasOwnProperty(id)) {
            storage[id].push(handler);
        } else {
            storage[id] = [ handler ];
        }
        return handler;
    };
    var detachHandler = function(id, fn) {
        var handlers = storage[id];
        if (!handlers) {
            return;
        }
        if (fn) {
            for (var i = 0; i < handlers.length; i++) {
                if (handlers[i] === fn) {
                    handlers.splice(i, 1);
                    break;
                }
            }
            if (handlers.length === 0) {
                delete storage[id];
            }
        } else {
            delete storage[id];
        }
    };
    var run = function(data) {
        if (data == null || data.id == null) {
            return false;
        }
        var callerId = data.id;
        if (storage.hasOwnProperty(callerId)) {
            var handlers = storage[callerId];
            for (var i = 0; i < handlers.length; i++) {
                handlers[i](data);
            }
            return true;
        }
        return false;
    };
    return {
        attach: attachHandler,
        detach: detachHandler,
        run: run
    };
});

"use strict";

filepicker.extend("exporter", function() {
    var fp = this;
    var normalizeOptions = function(options) {
        var normalize = function(singular, plural, def) {
            if (options[plural] && !fp.util.isArray(options[plural])) {
                options[plural] = [ options[plural] ];
            } else if (options[singular]) {
                options[plural] = [ options[singular] ];
            } else if (def) {
                options[plural] = def;
            }
        };
        if (options.mimetype && options.extension) {
            throw fp.FilepickerException("Error: Cannot pass in both mimetype and extension parameters to the export function");
        }
        normalize("service", "services");
        if (options.services) {
            for (var i = 0; i < options.services.length; i++) {
                var service = ("" + options.services[i]).replace(" ", "");
                var sid = fp.services[service];
                options.services[i] = sid === undefined ? service : sid;
            }
        }
        if (options.openTo) {
            options.openTo = fp.services[options.openTo] || options.openTo;
        }
        fp.util.setDefault(options, "container", fp.browser.openInModal() ? "modal" : "window");
    };
    var getExportHandler = function(onSuccess, onError) {
        var handler = function(data) {
            if (data.type !== "filepickerUrl") {
                return;
            }
            if (data.error) {
                fp.util.console.error(data.error);
                onError(fp.errors.FPError(132));
            } else {
                var fpfile = {};
                fpfile.url = data.payload.url;
                fpfile.filename = data.payload.data.filename;
                fpfile.mimetype = data.payload.data.type;
                fpfile.size = data.payload.data.size;
                fpfile.client = data.payload.data.client;
                fpfile.isWriteable = true;
                onSuccess(fpfile);
            }
            fp.modal.close();
        };
        return handler;
    };
    var createExporter = function(input, options, onSuccess, onError) {
        normalizeOptions(options);
        var api = {
            close: function() {
                fp.modal.close();
            }
        };
        if (options.debug) {
            setTimeout(function() {
                onSuccess({
                    id: 1,
                    url: "https://www.filepicker.io/api/file/-nBq2onTSemLBxlcBWn1",
                    filename: "test.png",
                    mimetype: "image/png",
                    size: 58979,
                    client: "computer"
                });
            }, 1);
            return api;
        }
        if (fp.cookies.THIRD_PARTY_COOKIES === undefined) {
            var alreadyHandled = false;
            fp.cookies.checkThirdParty(function() {
                if (!alreadyHandled) {
                    createExporter(input, options, onSuccess, onError);
                    alreadyHandled = true;
                }
            });
            return api;
        }
        var id = fp.util.getId();
        var finished = false;
        var onSuccessMark = function(fpfile) {
            finished = true;
            onSuccess(fpfile);
        };
        var onErrorMark = function(fperror) {
            finished = true;
            onError(fperror);
        };
        var onClose = function() {
            if (!finished) {
                finished = true;
                onError(fp.errors.FPError(131));
            }
        };
        fp.window.open(options.container, fp.urls.constructExportUrl(input, options, id), onClose);
        fp.handlers.attach(id, getExportHandler(onSuccessMark, onErrorMark));
        return api;
    };
    return {
        createExporter: createExporter
    };
});

"use strict";

filepicker.extend("modal", function() {
    var fp = this, SHADE_NAME = "filepicker_shade", WINDOW_CONTAINER_NAME = "filepicker_dialog_container";
    var originalBody = getHtmlTag();
    if (originalBody) {
        var originalOverflow = originalBody.style.overflow;
    }
    var generateModal = function(modalUrl, onClose) {
        appendStyle();
        var shade = createModalShade(onClose), container = createModalContainer(), close = createModalClose(onClose), modal = document.createElement("iframe");
        modal.name = fp.window.WINDOW_NAME;
        modal.id = fp.window.WINDOW_NAME;
        modal.style.width = "100%";
        modal.style.height = "100%";
        modal.style.border = "none";
        modal.style.position = "relative";
        modal.setAttribute("border", 0);
        modal.setAttribute("frameborder", 0);
        modal.setAttribute("frameBorder", 0);
        modal.setAttribute("marginwidth", 0);
        modal.setAttribute("marginheight", 0);
        modal.src = modalUrl;
        container.appendChild(modal);
        shade.appendChild(close);
        shade.appendChild(container);
        document.body.appendChild(shade);
        var body = getHtmlTag();
        if (body) {
            body.style.overflow = "hidden";
        }
        return modal;
    };
    var createModalShade = function(onClose) {
        var shade = document.createElement("div");
        shade.id = SHADE_NAME;
        shade.className = "fp__overlay";
        shade.onclick = getCloseModal(onClose);
        return shade;
    };
    var createModalContainer = function() {
        var modalcontainer = document.createElement("div");
        modalcontainer.id = WINDOW_CONTAINER_NAME;
        modalcontainer.className = "fp__container";
        return modalcontainer;
    };
    var createModalClose = function(onClose) {
        var close = document.createElement("div");
        close.className = "fp__close";
        var closeAnchor = document.createElement("a");
        closeAnchor.appendChild(document.createTextNode("X"));
        close.appendChild(closeAnchor);
        closeAnchor.onclick = getCloseModal(onClose);
        document.onkeydown = function(evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                getCloseModal(onClose)();
            }
        };
        return close;
    };
    var getCloseModal = function(onClose, force) {
        force = !!force;
        return function() {
            if (fp.uploading && !force) {
                if (!window.confirm('You are currently uploading. If you choose "OK", the window will close and your upload will not finish. Do you want to stop uploading and close the window?')) {
                    return;
                }
            }
            fp.uploading = false;
            document.onkeydown = null;
            setOriginalOverflow();
            var shade = document.getElementById(SHADE_NAME);
            if (shade) {
                document.body.removeChild(shade);
            }
            var container = document.getElementById(WINDOW_CONTAINER_NAME);
            if (container) {
                document.body.removeChild(container);
            }
            try {
                delete window.frames[fp.window.WINDOW_NAME];
            } catch (e) {}
            if (onClose) {
                onClose();
            }
        };
    };
    function hide() {
        var shade = document.getElementById(SHADE_NAME);
        if (shade) {
            shade.hidden = true;
        }
        var container = document.getElementById(WINDOW_CONTAINER_NAME);
        if (container) {
            container.hidden = true;
        }
        setOriginalOverflow();
    }
    function setOriginalOverflow() {
        var body = getHtmlTag();
        if (body) {
            body.style.overflow = originalOverflow;
        }
    }
    function appendStyle() {
        var css = ".fp__overlay {top: 0;right: 0;bottom: 0;left: 0;z-index: 1000;background: rgba(0, 0, 0, 0.8);}" + ".fp__close {top: 104px; right: 108px; width: 35px; height: 35px; z-index: 20; cursor: pointer}" + "@media screen and (max-width: 768px), screen and (max-height: 500px) {.fp__close {top: 15px; right: 12px;}}" + ".fp__close a {text-indent: -9999px; overflow: hidden; display: block; width: 100%; height: 100%; background: url(https://d1zyh3sbxittvg.cloudfront.net/close.png) 50% 50% no-repeat;}" + ".fp__close a:hover {background-color: rgba(0,0,0, .02); opacity: .8;}" + "@media screen and (max-width: 768px), screen and (max-height: 500px) {top: 14px; right: 14px;}" + ".fp__copy {display: none;}" + ".fp__container {-webkit-overflow-scrolling: touch; overflow: hidden; min-height: 300px; top: 100px;right: 100px;bottom: 100px;left: 100px;background: #eee; box-sizing:content-box; -webkit-box-sizing:content-box; -moz-box-sizing:content-box;}" + "@media screen and (max-width: 768px), screen and (max-height: 500px) {.fp__copy {bottom: 0; left: 0; right: 0; height: 20px; background: #333;}}" + "@media screen and (max-width: 768px), screen and (max-height: 500px) {.fp__copy a {margin-left: 5px;}}" + "@media screen and (max-width: 768px), screen and (max-height: 500px) {.fp__container {top: 0;right: 0;bottom: 0;left: 0;}}" + ".fp__overlay, .fp__close, .fp__copy, .fp__container {position: fixed;}";
        var head = document.head || document.getElementsByTagName("head")[0], style = document.createElement("style");
        style.type = "text/css";
        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
    }
    function getHtmlTag() {
        try {
            return document.getElementsByTagName("html")[0];
        } catch (err) {
            return null;
        }
    }
    var closeModal = getCloseModal(function() {});
    return {
        generate: generateModal,
        close: closeModal,
        hide: hide
    };
});

"use strict";

filepicker.extend("picker", function() {
    var fp = this;
    var normalizeOptions = function(options) {
        var normalize = function(singular, plural, def) {
            if (options[plural]) {
                if (!fp.util.isArray(options[plural])) {
                    options[plural] = [ options[plural] ];
                }
            } else if (options[singular]) {
                options[plural] = [ options[singular] ];
            } else if (def) {
                options[plural] = def;
            }
        };
        normalize("service", "services");
        normalize("mimetype", "mimetypes");
        normalize("extension", "extensions");
        if (options.services) {
            for (var i = 0; i < options.services.length; i++) {
                var service = ("" + options.services[i]).replace(" ", "");
                if (fp.services[service] !== undefined) {
                    service = fp.services[service];
                }
                options.services[i] = service;
            }
        }
        if (options.mimetypes && options.extensions) {
            throw fp.FilepickerException("Error: Cannot pass in both mimetype and extension parameters to the pick function");
        }
        if (!options.mimetypes && !options.extensions) {
            options.mimetypes = [ "*/*" ];
        }
        if (options.openTo) {
            options.openTo = fp.services[options.openTo] || options.openTo;
        }
        fp.util.setDefault(options, "container", fp.browser.openInModal() ? "modal" : "window");
    };
    var getPickHandler = function(onSuccess, onError, onProgress) {
        var handler = function(data) {
            if (filterDataType(data, onProgress)) {
                return;
            }
            fp.uploading = false;
            if (data.error) {
                fp.util.console.error(data.error);
                if (data.error.code) {
                    onError(fp.errors.FPError(data.error.code));
                } else {
                    onError(fp.errors.FPError(102));
                    fp.modal.close();
                }
            } else {
                var fpfile = fpfileFromPayload(data.payload);
                onSuccess(fpfile);
                fp.modal.close();
            }
        };
        return handler;
    };
    var getPickFolderHandler = function(onSuccess, onError, onProgress) {
        var handler = function(data) {
            if (filterDataType(data, onProgress)) {
                return;
            }
            fp.uploading = false;
            if (data.error) {
                fp.util.console.error(data.error);
                onError(fp.errors.FPError(102));
            } else {
                data.payload.data.url = data.payload.url;
                onSuccess(data.payload.data);
            }
            fp.modal.close();
        };
        return handler;
    };
    var getUploadingHandler = function(onUploading) {
        onUploading = onUploading || function() {};
        var handler = function(data) {
            if (data.type !== "uploading") {
                return;
            }
            fp.uploading = !!data.payload;
            onUploading(fp.uploading);
        };
        return handler;
    };
    var addIfExist = function(data, fpfile, key) {
        if (data[key]) {
            fpfile[key] = data[key];
        }
    };
    var fpfileFromPayload = function(payload) {
        var fpfile = {};
        var url = payload.url;
        if (url && url.url) {
            url = url.url;
        }
        fpfile.url = url;
        var data = payload.url.data || payload.data;
        fpfile.filename = data.filename;
        fpfile.mimetype = data.type;
        fpfile.size = data.size;
        if (data.cropped !== undefined) {
            fpfile.cropped = data.cropped;
        }
        if (data.rotated !== undefined) {
            fpfile.rotated = data.rotated;
        }
        if (data.converted !== undefined) {
            fpfile.converted = data.converted;
        }
        addIfExist(data, fpfile, "id");
        addIfExist(data, fpfile, "key");
        addIfExist(data, fpfile, "container");
        addIfExist(data, fpfile, "path");
        addIfExist(data, fpfile, "client");
        fpfile.isWriteable = true;
        return fpfile;
    };
    var getPickMultipleHandler = function(onSuccess, onError, onProgress) {
        var handler = function(data) {
            if (filterDataType(data, onProgress)) {
                return;
            }
            fp.uploading = false;
            if (data.error) {
                fp.util.console.error(data.error);
                onError(fp.errors.FPError(102));
            } else {
                var fpfiles = [];
                if (!fp.util.isArray(data.payload)) {
                    data.payload = [ data.payload ];
                }
                for (var i = 0; i < data.payload.length; i++) {
                    var fpfile = fpfileFromPayload(data.payload[i]);
                    fpfiles.push(fpfile);
                }
                onSuccess(fpfiles);
            }
            fp.modal.close();
        };
        return handler;
    };
    var createPicker = function(options, onSuccess, onError, multiple, folder, onProgress, convertFile) {
        normalizeOptions(options);
        var api = {
            close: function() {
                fp.modal.close();
            }
        };
        if (options.debug) {
            var dumy_data = {
                id: 1,
                url: "https://www.filepicker.io/api/file/-nBq2onTSemLBxlcBWn1",
                filename: "test.png",
                mimetype: "image/png",
                size: 58979,
                client: "computer"
            };
            var dumy_callback;
            if (multiple || options.storeLocation) {
                dumy_callback = [ dumy_data, dumy_data, dumy_data ];
            } else {
                dumy_callback = dumy_data;
            }
            setTimeout(function() {
                onSuccess(dumy_callback);
            }, 1);
            return api;
        }
        if (fp.cookies.THIRD_PARTY_COOKIES === undefined) {
            var alreadyHandled = false;
            fp.cookies.checkThirdParty(function() {
                if (!alreadyHandled) {
                    createPicker(options, onSuccess, onError, !!multiple, folder, onProgress);
                    alreadyHandled = true;
                }
            });
            return api;
        }
        var id = fp.util.getId();
        var finished = false;
        var onSuccessMark = function(fpfile) {
            if (options.container === "window") {
                window.onbeforeunload = null;
            }
            finished = true;
            onSuccess(fpfile);
        };
        var onErrorMark = function(fperror) {
            finished = true;
            onError(fperror);
        };
        var onClose = function() {
            if (!finished) {
                finished = true;
                onError(fp.errors.FPError(101));
            }
        };
        var url;
        var handler;
        if (convertFile) {
            url = fp.urls.constructConvertUrl(options, id);
            handler = getPickHandler(onSuccessMark, onErrorMark, onProgress);
        } else if (multiple) {
            url = fp.urls.constructPickUrl(options, id, true);
            handler = getPickMultipleHandler(onSuccessMark, onErrorMark, onProgress);
        } else if (folder) {
            url = fp.urls.constructPickFolderUrl(options, id);
            handler = getPickFolderHandler(onSuccessMark, onErrorMark, onProgress);
        } else {
            url = fp.urls.constructPickUrl(options, id, false);
            handler = getPickHandler(onSuccessMark, onErrorMark, onProgress);
        }
        fp.window.open(options.container, url, onClose);
        fp.handlers.attach(id, handler);
        var key = id + "-upload";
        fp.handlers.attach(key, getUploadingHandler(function() {
            fp.handlers.detach(key);
        }));
        return api;
    };
    function filterDataType(data, onProgress) {
        if (data.type === "filepickerProgress") {
            fp.uploading = true;
            if (onProgress) {
                onProgress(data.payload.data);
            }
        } else if (data.type === "notUploading") {
            fp.uploading = false;
        } else if (data.type === "closeModal") {
            fp.modal.close();
        } else if (data.type === "hideModal") {
            fp.modal.hide();
        } else if (data.type === "filepickerUrl" || data.type === "serverHttpError") {
            return false;
        }
        return true;
    }
    return {
        createPicker: createPicker
    };
});

"use strict";

filepicker.extend("window", function() {
    var fp = this;
    var DIALOG_TYPES = {
        OPEN: "/dialog/open/",
        SAVEAS: "/dialog/save/"
    };
    var WINDOW_NAME = "filepicker_dialog";
    var WINDOW_PROPERTIES = "left=100,top=100,height=600,width=800,menubar=no,toolbar=no,location=no,personalbar=no,status=no,resizable=yes,scrollbars=yes,dependent=yes,dialog=yes";
    var CLOSE_CHECK_INTERVAL = 100;
    var openWindow = function(container, src, onClose) {
        onClose = onClose || function() {};
        if (!container && fp.browser.openInModal()) {
            container = "modal";
        } else if (!container) {
            container = "window";
        }
        if (container === "window") {
            var name = WINDOW_NAME + fp.util.getId();
            window.onbeforeunload = function confirmExit() {
                return "Filepicker upload does not complete.";
            };
            var win = window.open(src, name, WINDOW_PROPERTIES);
            if (!win) {
                window.onbeforeunload = null;
                window.alert("Please disable your popup blocker to upload files.");
            }
            var closeCheck = window.setInterval(function() {
                if (!win || win.closed) {
                    window.onbeforeunload = null;
                    window.clearInterval(closeCheck);
                    onClose();
                }
            }, CLOSE_CHECK_INTERVAL);
        } else if (container === "modal") {
            fp.modal.generate(src, onClose);
        } else {
            var container_iframe = document.getElementById(container);
            if (!container_iframe) {
                throw new fp.FilepickerException('Container "' + container + '" not found. This should either be set to "window","modal", or the ID of an iframe that is currently in the document.');
            }
            container_iframe.src = src;
        }
    };
    return {
        open: openWindow,
        WINDOW_NAME: WINDOW_NAME
    };
});

"use strict";

filepicker.extend("conversions", function() {
    var fp = this;
    var valid_parameters = {
        align: "string",
        blurAmount: "number",
        crop: "string or array",
        crop_first: "boolean",
        compress: "boolean",
        exif: "string or boolean",
        filter: "string",
        fit: "string",
        format: "string",
        height: "number",
        policy: "string",
        quality: "number",
        page: "number",
        rotate: "string or number",
        secure: "boolean",
        sharpenAmount: "number",
        signature: "string",
        storeAccess: "string",
        storeContainer: "string",
        storeRegion: "string",
        storeLocation: "string",
        storePath: "string",
        text: "string",
        text_align: "string",
        text_color: "string",
        text_font: "string",
        text_padding: "number",
        text_size: "number",
        watermark: "string",
        watermark_position: "string",
        watermark_size: "number",
        width: "number"
    };
    var rest_map = {
        w: "width",
        h: "height"
    };
    var mapRestParams = function(options) {
        var obj = {};
        for (var key in options) {
            obj[rest_map[key] || key] = options[key];
            if (valid_parameters[rest_map[key] || key] === "number") {
                obj[rest_map[key] || key] = Number(options[key]);
            }
        }
        return obj;
    };
    var checkParameters = function(options) {
        var found;
        for (var key in options) {
            found = false;
            for (var test in valid_parameters) {
                if (key === test) {
                    found = true;
                    if (valid_parameters[test].indexOf(fp.util.typeOf(options[key])) === -1) {
                        throw new fp.FilepickerException("Conversion parameter " + key + " is not the right type: " + options[key] + ". Should be a " + valid_parameters[test]);
                    }
                }
            }
            if (!found) {
                throw new fp.FilepickerException("Conversion parameter " + key + " is not a valid parameter.");
            }
        }
    };
    var convert = function(fp_url, options, onSuccess, onError, onProgress) {
        checkParameters(options);
        if (options.crop && fp.util.isArray(options.crop)) {
            options.crop = options.crop.join(",");
        }
        fp.ajax.post(fp_url + "/convert", {
            data: options,
            json: true,
            success: function(fpfile) {
                onSuccess(fp.util.standardizeFPFile(fpfile));
            },
            error: function(msg, status, xhr) {
                if (msg === "not_found") {
                    onError(new fp.errors.FPError(141));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(142));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(143));
                }
            },
            progress: onProgress
        });
    };
    return {
        convert: convert,
        mapRestParams: mapRestParams
    };
});

"use strict";

filepicker.extend("errors", function() {
    var fp = this;
    var FPError = function(code) {
        if (this === window) {
            return new FPError(code);
        }
        this.code = code;
        if (filepicker.debug) {
            var info = filepicker.error_map[this.code];
            this.message = info.message;
            this.moreInfo = info.moreInfo;
            this.toString = function() {
                return "FPError " + this.code + ": " + this.message + ". For help, see " + this.moreInfo;
            };
        } else {
            this.toString = function() {
                return "FPError " + this.code + ". Include filepicker_debug.js for more info";
            };
        }
        return this;
    };
    FPError.isClass = true;
    var handleError = function(fperror) {
        if (filepicker.debug) {
            fp.util.console.error(fperror.toString());
        }
    };
    return {
        FPError: FPError,
        handleError: handleError
    };
}, true);

"use strict";

filepicker.extend(function() {
    var fp = this, VERSION = "2.4.18";
    fp.API_VERSION = "v2";
    var setKey = function(key) {
        fp.apikey = key;
    };
    var FilepickerException = function(text) {
        this.text = text;
        this.toString = function() {
            return "FilepickerException: " + this.text;
        };
        return this;
    };
    FilepickerException.isClass = true;
    var pick = function(options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        return fp.picker.createPicker(options, onSuccess, onError, false, false, onProgress);
    };
    var pickMultiple = function(options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onProgress = onError;
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        return fp.picker.createPicker(options, onSuccess, onError, true, false, onProgress);
    };
    var pickAndStore = function(picker_options, store_options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (!picker_options || !store_options || typeof picker_options === "function" || typeof picker_options === "function") {
            throw new fp.FilepickerException("Not all required parameters given, missing picker or store options");
        }
        onError = onError || fp.errors.handleError;
        var multiple = !!picker_options.multiple;
        var options = !!picker_options ? fp.util.clone(picker_options) : {};
        options.storeLocation = store_options.location || "S3";
        options.storePath = store_options.path;
        options.storeContainer = store_options.storeContainer || store_options.container;
        options.storeRegion = store_options.storeRegion;
        options.storeAccess = store_options.access || "private";
        if (multiple && options.storePath) {
            if (options.storePath.charAt(options.storePath.length - 1) !== "/") {
                throw new fp.FilepickerException("pickAndStore with multiple files requires a path that ends in " / "");
            }
        }
        var success = onSuccess;
        if (!multiple) {
            success = function(resp) {
                onSuccess([ resp ]);
            };
        }
        return fp.picker.createPicker(options, success, onError, multiple, false, onProgress);
    };
    var pickFolder = function(options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        return fp.picker.createPicker(options, onSuccess, onError, false, true, onProgress);
    };
    var read = function(input, options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (!input) {
            throw new fp.FilepickerException("No input given - nothing to read!");
        }
        if (typeof options === "function") {
            onProgress = onError;
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        onProgress = onProgress || function() {};
        if (typeof input === "string") {
            if (fp.util.isFPUrl(input)) {
                fp.files.readFromFPUrl(input, options, onSuccess, onError, onProgress);
            } else {
                fp.files.readFromUrl(input, options, onSuccess, onError, onProgress);
            }
        } else if (fp.util.isFileInputElement(input)) {
            if (!input.files) {
                storeThenRead(input, options, onSuccess, onError, onProgress);
            } else if (input.files.length === 0) {
                onError(new fp.errors.FPError(115));
            } else {
                fp.files.readFromFile(input.files[0], options, onSuccess, onError, onProgress);
            }
        } else if (fp.util.isFile(input)) {
            fp.files.readFromFile(input, options, onSuccess, onError, onProgress);
        } else if (input.url) {
            fp.files.readFromFPUrl(input.url, options, onSuccess, onError, onProgress);
        } else {
            throw new fp.FilepickerException("Cannot read given input: " + input + ". Not a url, file input, DOM File, or FPFile object.");
        }
    };
    var storeThenRead = function(input, readOptions, onSuccess, onError, onProgress) {
        onProgress(10);
        fp.store(input, function(fpfile) {
            onProgress(50);
            fp.read(fpfile, readOptions, onSuccess, onError, function(progress) {
                onProgress(50 + progress / 2);
            });
        }, onError);
    };
    var write = function(fpfile, input, options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (!fpfile) {
            throw new fp.FilepickerException("No fpfile given - nothing to write to!");
        }
        if (input === undefined || input === null) {
            throw new fp.FilepickerException("No input given - nothing to write!");
        }
        if (typeof options === "function") {
            onProgress = onError;
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        onProgress = onProgress || function() {};
        var fp_url;
        if (fp.util.isFPUrl(fp.util.getFPUrl(fpfile))) {
            fp_url = fpfile;
        } else if (fpfile.url) {
            fp_url = fpfile.url;
        } else {
            throw new fp.FilepickerException("Invalid file to write to: " + fpfile + ". Not a filepicker url or FPFile object.");
        }
        fp_url = fp.util.trimConvert(fp.util.getFPUrl(fp_url));
        if (typeof input === "string") {
            fp.files.writeDataToFPUrl(fp_url, input, options, onSuccess, onError, onProgress);
        } else {
            if (fp.util.isFileInputElement(input)) {
                if (!input.files) {
                    fp.files.writeFileInputToFPUrl(fp_url, input, options, onSuccess, onError, onProgress);
                } else if (input.files.length === 0) {
                    onError(new fp.errors.FPError(115));
                } else {
                    fp.files.writeFileToFPUrl(fp_url, input.files[0], options, onSuccess, onError, onProgress);
                }
            } else if (fp.util.isFile(input)) {
                fp.files.writeFileToFPUrl(fp_url, input, options, onSuccess, onError, onProgress);
            } else if (input.url) {
                fp.files.writeUrlToFPUrl(fp_url, input.url, options, onSuccess, onError, onProgress);
            } else {
                throw new fp.FilepickerException("Cannot read from given input: " + input + ". Not a string, file input, DOM File, or FPFile object.");
            }
        }
    };
    var writeUrl = function(fpfile, input, options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (!fpfile) {
            throw new fp.FilepickerException("No fpfile given - nothing to write to!");
        }
        if (input === undefined || input === null) {
            throw new fp.FilepickerException("No input given - nothing to write!");
        }
        if (typeof options === "function") {
            onProgress = onError;
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        onProgress = onProgress || function() {};
        var fp_url;
        if (fp.util.isFPUrl(fp.util.getFPUrl(fpfile))) {
            fp_url = fpfile;
        } else if (fpfile.url) {
            fp_url = fpfile.url;
        } else {
            throw new fp.FilepickerException("Invalid file to write to: " + fpfile + ". Not a filepicker url or FPFile object.");
        }
        fp_url = fp.util.getFPUrl(fp_url);
        fp.files.writeUrlToFPUrl(fp.util.trimConvert(fp_url), input, options, onSuccess, onError, onProgress);
    };
    var exportFn = function(input, options, onSuccess, onError) {
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = !!options ? fp.util.clone(options) : {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        var fp_url;
        if (typeof input === "string" && fp.util.isUrl(input)) {
            fp_url = input;
        } else if (input.url) {
            fp_url = input.url;
            if (!options.mimetype && !options.extension) {
                options.mimetype = input.mimetype;
            }
            if (!options.suggestedFilename) {
                options.suggestedFilename = input.filename;
            }
        } else {
            throw new fp.FilepickerException("Invalid file to export: " + input + ". Not a valid url or FPFile object. You may want to use filepicker.store() to get an FPFile to export");
        }
        if (options.suggestedFilename) {
            options.suggestedFilename = encodeURI(options.suggestedFilename);
        }
        return fp.exporter.createExporter(fp_url, options, onSuccess, onError);
    };
    var processImage = function(input, options, onSuccess, onError, onProgress) {
        var convertUrl;
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        if (typeof input === "string") {
            convertUrl = input;
        } else if (input.url) {
            convertUrl = input.url;
            if (!options.filename) {
                options.filename = input.filename;
            }
        } else {
            throw new fp.FilepickerException("Invalid file to convert: " + input + ". Not a valid url or FPFile object or not filepicker url. You can convert only filepicker url images.");
        }
        options.convertUrl = convertUrl;
        options.multiple = false;
        options.services = [ "CONVERT", "COMPUTER" ];
        options.backgroundUpload = true;
        options.hide = false;
        return fp.picker.createPicker(options, onSuccess, onError, false, false, onProgress, true);
    };
    var store = function(input, options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onProgress = onError;
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = !!options ? fp.util.clone(options) : {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        onProgress = onProgress || function() {};
        if (typeof input === "string") {
            fp.files.storeData(input, options, onSuccess, onError, onProgress);
        } else {
            if (fp.util.isFileInputElement(input)) {
                if (!input.files) {
                    fp.files.storeFileInput(input, options, onSuccess, onError, onProgress);
                } else if (input.files.length === 0) {
                    onError(new fp.errors.FPError(115));
                } else {
                    fp.files.storeFile(input.files[0], options, onSuccess, onError, onProgress);
                }
            } else if (fp.util.isFile(input)) {
                fp.files.storeFile(input, options, onSuccess, onError, onProgress);
            } else if (input.url) {
                if (!options.filename) {
                    options.filename = input.filename;
                }
                fp.files.storeUrl(input.url, options, onSuccess, onError, onProgress);
            } else {
                throw new fp.FilepickerException("Cannot store given input: " + input + ". Not a string, file input, DOM File, or FPFile object.");
            }
        }
    };
    var storeUrl = function(input, options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onProgress = onError;
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        onProgress = onProgress || function() {};
        fp.files.storeUrl(input, options, onSuccess, onError, onProgress);
    };
    var stat = function(fpfile, options, onSuccess, onError) {
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        var fp_url;
        if (fp.util.isFPUrl(fp.util.getFPUrl(fpfile))) {
            fp_url = fpfile;
        } else if (fpfile.url) {
            fp_url = fpfile.url;
        } else {
            throw new fp.FilepickerException("Invalid file to get metadata for: " + fpfile + ". Not a filepicker url or FPFile object.");
        }
        fp_url = fp.util.getFPUrl(fp_url);
        fp.files.stat(fp.util.trimConvert(fp_url), options, onSuccess, onError);
    };
    var remove = function(fpfile, options, onSuccess, onError) {
        fp.util.checkApiKey();
        if (typeof options === "function") {
            onError = onSuccess;
            onSuccess = options;
            options = {};
        }
        options = options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        var fp_url;
        if (fp.util.isFPUrl(fp.util.getFPUrl(fpfile))) {
            fp_url = fpfile;
        } else if (fpfile.url) {
            fp_url = fpfile.url;
        } else {
            throw new fp.FilepickerException("Invalid file to remove: " + fpfile + ". Not a filepicker url or FPFile object.");
        }
        fp_url = fp.util.getFPUrl(fp_url);
        fp.files.remove(fp.util.trimConvert(fp_url), options, onSuccess, onError);
    };
    var convert = function(fpfile, convert_options, store_options, onSuccess, onError, onProgress) {
        fp.util.checkApiKey();
        if (!fpfile) {
            throw new fp.FilepickerException("No fpfile given - nothing to convert!");
        }
        if (typeof store_options === "function") {
            onProgress = onError;
            onError = onSuccess;
            onSuccess = store_options;
            store_options = {};
        }
        var options = !!convert_options ? fp.util.clone(convert_options) : {};
        store_options = store_options || {};
        onSuccess = onSuccess || function() {};
        onError = onError || fp.errors.handleError;
        onProgress = onProgress || function() {};
        if (store_options.location) {
            options.storeLocation = store_options.location;
        }
        if (store_options.path) {
            options.storePath = store_options.path;
        }
        if (store_options.container) {
            options.storeContainer = store_options.container;
        }
        options.storeAccess = store_options.access || "private";
        var fp_url;
        if (fp.util.isFPUrl(fp.util.getFPUrl(fpfile))) {
            fp_url = fpfile;
        } else if (fpfile.url) {
            fp_url = fpfile.url;
            if (!fp.mimetypes.matchesMimetype(fpfile.mimetype, "image/*") && !fp.mimetypes.matchesMimetype(fpfile.mimetype, "application/pdf")) {
                onError(new fp.errors.FPError(142));
                return;
            }
        } else {
            throw new fp.FilepickerException("Invalid file to convert: " + fpfile + ". Not a filepicker url or FPFile object.");
        }
        fp_url = fp.util.getFPUrl(fp_url);
        if (fp_url.indexOf("/convert") > -1) {
            var restConvertOptions = fp.util.parseUrl(fp_url).params;
            restConvertOptions = fp.conversions.mapRestParams(restConvertOptions);
            if (restConvertOptions.crop) {
                fp.util.setDefault(restConvertOptions, "crop_first", true);
            }
            for (var attr in restConvertOptions) {
                fp.util.setDefault(options, attr, restConvertOptions[attr]);
            }
        }
        fp.conversions.convert(fp.util.trimConvert(fp_url), options, onSuccess, onError, onProgress);
    };
    var constructWidget = function(base) {
        return fp.widgets.constructWidget(base);
    };
    var makeDropPane = function(div, options) {
        return fp.dragdrop.makeDropPane(div, options);
    };
    var setResponsiveOptions = function(options) {
        return fp.responsiveImages.setResponsiveOptions(options);
    };
    var responsive = function() {
        fp.responsiveImages.update.apply(null, arguments);
    };
    var logout = function(options) {
        options = options || {};
        fp.ajax.get(fp.urls.LOGOUT, {
            success: options.onSuccess,
            error: options.onError,
            withCredentials: true
        });
    };
    return {
        setKey: setKey,
        setResponsiveOptions: setResponsiveOptions,
        pick: pick,
        pickFolder: pickFolder,
        pickMultiple: pickMultiple,
        pickAndStore: pickAndStore,
        read: read,
        write: write,
        writeUrl: writeUrl,
        "export": exportFn,
        exportFile: exportFn,
        processImage: processImage,
        store: store,
        storeUrl: storeUrl,
        stat: stat,
        metadata: stat,
        remove: remove,
        convert: convert,
        constructWidget: constructWidget,
        makeDropPane: makeDropPane,
        FilepickerException: FilepickerException,
        responsive: responsive,
        logout: logout,
        version: VERSION
    };
}, true);

"use strict";

filepicker.extend("mimetypes", function() {
    var fp = this;
    var mimetype_extension_map = {
        ".stl": "application/sla",
        ".hbs": "text/html",
        ".pdf": "application/pdf",
        ".jpg": "image/jpeg",
        ".jpeg": "image/jpeg",
        ".jpe": "image/jpeg",
        ".imp": "application/x-impressionist",
        ".vob": "video/dvd"
    };
    var mimetype_bad_array = [ "application/octet-stream", "application/download", "application/force-download", "octet/stream", "application/unknown", "application/x-download", "application/x-msdownload", "application/x-secure-download" ];
    var getMimetype = function(file) {
        if (file.type) {
            var type = file.type;
            type = type.toLowerCase();
            var bad_type = false;
            for (var n = 0; n < mimetype_bad_array.length; n++) {
                bad_type = bad_type || type === mimetype_bad_array[n];
            }
            if (!bad_type) {
                return file.type;
            }
        }
        var filename = file.name || file.fileName;
        var extension = filename.match(/\.\w*$/);
        if (extension) {
            return mimetype_extension_map[extension[0].toLowerCase()] || "";
        } else {
            if (file.type) {
                return file.type;
            } else {
                return "";
            }
        }
    };
    var matchesMimetype = function(test, against) {
        if (!test) {
            return against === "*/*";
        }
        test = fp.util.trim(test).toLowerCase();
        against = fp.util.trim(against).toLowerCase();
        for (var n = 0; n < mimetype_bad_array.length; n++) {
            if (test === mimetype_bad_array[n]) {
                return true;
            }
        }
        var test_parts = test.split("/"), against_parts = against.split("/");
        if (against_parts[0] === "*") {
            return true;
        }
        if (against_parts[0] !== test_parts[0]) {
            return false;
        }
        if (against_parts[1] === "*") {
            return true;
        }
        return against_parts[1] === test_parts[1];
    };
    return {
        getMimetype: getMimetype,
        matchesMimetype: matchesMimetype
    };
});

"use strict";

filepicker.extend("services", function() {
    return {
        COMPUTER: 1,
        DROPBOX: 2,
        FACEBOOK: 3,
        GITHUB: 4,
        GMAIL: 5,
        IMAGE_SEARCH: 6,
        URL: 7,
        WEBCAM: 8,
        GOOGLE_DRIVE: 9,
        SEND_EMAIL: 10,
        INSTAGRAM: 11,
        FLICKR: 12,
        VIDEO: 13,
        EVERNOTE: 14,
        PICASA: 15,
        WEBDAV: 16,
        FTP: 17,
        ALFRESCO: 18,
        BOX: 19,
        SKYDRIVE: 20,
        GDRIVE: 21,
        CUSTOMSOURCE: 22,
        CLOUDDRIVE: 23,
        GENERIC: 24,
        CONVERT: 25,
        AUDIO: 26
    };
}, true);

"use strict";

filepicker.extend("urls", function() {
    var fp = this;
    var base = "https://www.filepicker.io";
    if (window.filepicker.hostname) {
        base = window.filepicker.hostname;
    }
    var dialog_base = base.replace("www", "dialog"), pick_url = dialog_base + "/dialog/open/", export_url = dialog_base + "/dialog/save/", convert_url = dialog_base + "/dialog/process/", pick_folder_url = dialog_base + "/dialog/folder/", store_url = base + "/api/store/";
    var allowedConversions = [ "crop", "rotate", "filter" ];
    var constructPickUrl = function(options, id, multiple) {
        return pick_url + constructModalQuery(options, id) + (multiple ? "&multi=" + !!multiple : "") + (options.mimetypes !== undefined ? "&m=" + options.mimetypes.join(",") : "") + (options.extensions !== undefined ? "&ext=" + options.extensions.join(",") : "") + (options.maxSize ? "&maxSize=" + options.maxSize : "") + (options.customSourceContainer ? "&customSourceContainer=" + options.customSourceContainer : "") + (options.customSourcePath ? "&customSourcePath=" + options.customSourcePath : "") + (options.maxFiles ? "&maxFiles=" + options.maxFiles : "") + (options.folders !== undefined ? "&folders=" + options.folders : "") + (options.storeLocation ? "&storeLocation=" + options.storeLocation : "") + (options.storePath ? "&storePath=" + options.storePath : "") + (options.storeContainer ? "&storeContainer=" + options.storeContainer : "") + (options.storeRegion ? "&storeRegion=" + options.storeRegion : "") + (options.storeAccess ? "&storeAccess=" + options.storeAccess : "") + (options.webcam && options.webcam.webcamDim ? "&wdim=" + options.webcam.webcamDim.join(",") : "") + (options.webcamDim ? "&wdim=" + options.webcamDim.join(",") : "") + (options.webcam && options.webcam.videoRes ? "&videoRes=" + options.webcam.videoRes : "") + (options.webcam && options.webcam.videoLen ? "&videoLen=" + options.webcam.videoLen : "") + (options.webcam && options.webcam.audioLen ? "&audioLen=" + options.webcam.audioLen : "") + constructConversionsQuery(options.conversions);
    };
    var constructConvertUrl = function(options, id) {
        var url = options.convertUrl;
        if (url.indexOf("&") >= 0 || url.indexOf("?") >= 0) {
            url = encodeURIComponent(url);
        }
        return convert_url + constructModalQuery(options, id) + "&curl=" + url + constructConversionsQuery(options.conversions);
    };
    var constructPickFolderUrl = function(options, id) {
        return pick_folder_url + constructModalQuery(options, id);
    };
    var constructExportUrl = function(url, options, id) {
        if (url.indexOf("&") >= 0 || url.indexOf("?") >= 0) {
            url = encodeURIComponent(url);
        }
        return export_url + constructModalQuery(options, id) + "&url=" + url + (options.mimetype !== undefined ? "&m=" + options.mimetype : "") + (options.extension !== undefined ? "&ext=" + options.extension : "") + (options.suggestedFilename ? "&defaultSaveasName=" + options.suggestedFilename : "");
    };
    var constructStoreUrl = function(options) {
        return store_url + options.location + "?key=" + fp.apikey + (options.base64decode ? "&base64decode=true" : "") + (options.mimetype ? "&mimetype=" + options.mimetype : "") + (options.filename ? "&filename=" + encodeURIComponent(options.filename) : "") + (options.path ? "&path=" + options.path : "") + (options.container ? "&container=" + options.container : "") + (options.access ? "&access=" + options.access : "") + constructSecurityQuery(options) + "&plugin=" + getPlugin();
    };
    var constructWriteUrl = function(fp_url, options) {
        return fp_url + "?nonce=fp" + (!!options.base64decode ? "&base64decode=true" : "") + (options.mimetype ? "&mimetype=" + options.mimetype : "") + constructSecurityQuery(options) + "&plugin=" + getPlugin();
    };
    var constructHostCommFallback = function() {
        var parts = fp.util.parseUrl(window.location.href);
        return parts.origin + "/404";
    };
    function constructModalQuery(options, id) {
        return "?key=" + fp.apikey + "&id=" + id + "&referrer=" + window.location.hostname + "&iframe=" + (options.container !== "window") + "&version=" + fp.API_VERSION + (options.services ? "&s=" + options.services.join(",") : "") + (options.container !== undefined ? "&container=" + options.container : "modal") + (options.openTo ? "&loc=" + options.openTo : "") + "&language=" + (options.language || fp.browser.getLanguage()) + (options.mobile !== undefined ? "&mobile=" + options.mobile : "") + (options.backgroundUpload !== undefined ? "&bu=" + options.backgroundUpload : "") + (options.cropRatio ? "&cratio=" + options.cropRatio : "") + (options.cropDim ? "&cdim=" + options.cropDim.join(",") : "") + (options.cropMax ? "&cmax=" + options.cropMax.join(",") : "") + (options.cropMin ? "&cmin=" + options.cropMin.join(",") : "") + (options.cropForce !== undefined ? "&cforce=" + options.cropForce : "") + (options.hide !== undefined ? "&hide=" + options.hide : "") + (options.customCss ? "&css=" + encodeURIComponent(options.customCss) : "") + (options.customText ? "&text=" + encodeURIComponent(options.customText) : "") + (options.imageMin ? "&imin=" + options.imageMin.join(",") : "") + (options.imageMax ? "&imax=" + options.imageMax.join(",") : "") + (options.imageDim ? "&idim=" + options.imageDim.join(",") : "") + (options.imageQuality ? "&iq=" + options.imageQuality : "") + (options.noFileReader ? "&nfl=" + options.noFileReader : "") + (fp.util.isCanvasSupported() ? "" : "&canvas=false") + (options.redirectUrl ? "&redirect_url=" + options.redirectUrl : "") + (options.showClose && options.container !== "modal" ? "&showClose=" + options.showClose : "") + constructSecurityQuery(options) + "&plugin=" + getPlugin();
    }
    function constructSecurityQuery(options) {
        return (options.signature ? "&signature=" + options.signature : "") + (options.policy ? "&policy=" + options.policy : "");
    }
    function getPlugin() {
        return filepicker.plugin || "js_lib";
    }
    function constructConversionsQuery(conversions) {
        conversions = conversions || [];
        var allowed = [], i, j;
        for (i in conversions) {
            for (j in allowedConversions) {
                if (conversions[i] === allowedConversions[j] && conversions.hasOwnProperty(i)) {
                    allowed.push(conversions[i]);
                }
            }
        }
        if (!allowed.length) {
            allowed.push("crop");
        }
        return "&co=" + allowed.join(",");
    }
    return {
        BASE: base,
        DIALOG_BASE: dialog_base,
        API_COMM: base + "/dialog/comm_iframe/",
        COMM: dialog_base + "/dialog/comm_iframe/",
        FP_COMM_FALLBACK: dialog_base + "/dialog/comm_hash_iframe/",
        STORE: store_url,
        PICK: pick_url,
        EXPORT: export_url,
        LOGOUT: base + "/api/clients/unauth",
        constructPickUrl: constructPickUrl,
        constructConvertUrl: constructConvertUrl,
        constructPickFolderUrl: constructPickFolderUrl,
        constructExportUrl: constructExportUrl,
        constructWriteUrl: constructWriteUrl,
        constructStoreUrl: constructStoreUrl,
        constructHostCommFallback: constructHostCommFallback,
        getPlugin: getPlugin
    };
});

"use strict";

filepicker.extend("ajax", function() {
    var fp = this;
    var get_request = function(url, options) {
        options.method = "GET";
        make_request(url, options);
    };
    var post_request = function(url, options) {
        options.method = "POST";
        url += (url.indexOf("?") >= 0 ? "&" : "?") + "_cacheBust=" + fp.util.getId();
        make_request(url, options);
    };
    var toQueryString = function(object, base) {
        var queryString = [];
        for (var key in object) {
            var value = object[key];
            if (base) {
                key = base + ". + key + ";
            }
            var result;
            switch (fp.util.typeOf(value)) {
              case "object":
                result = toQueryString(value, key);
                break;

              case "array":
                var qs = {};
                for (var i = 0; i < value.length; i++) {
                    qs[i] = value[i];
                }
                result = toQueryString(qs, key);
                break;

              default:
                result = key + "=" + encodeURIComponent(value);
                break;
            }
            if (value !== null) {
                queryString.push(result);
            }
        }
        return queryString.join("&");
    };
    var getXhr = function() {
        try {
            return new window.XMLHttpRequest();
        } catch (e) {
            try {
                return new window.ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                try {
                    return new window.ActiveXObject("Microsoft.XMLHTTP");
                } catch (e) {
                    return null;
                }
            }
        }
    };
    var make_request = function(url, options) {
        url = url || "";
        var method = options.method ? options.method.toUpperCase() : "POST";
        var success = options.success || function() {};
        var error = options.error || function() {};
        var async = options.async === undefined ? true : options.async;
        var data = options.data || null;
        var processData = options.processData === undefined ? true : options.processData;
        var headers = options.headers || {};
        var urlParts = fp.util.parseUrl(url);
        var origin = window.location.protocol + "//" + window.location.host;
        var crossdomain = origin !== urlParts.origin;
        var finished = false;
        url += (url.indexOf("?") >= 0 ? "&" : "?") + "plugin=" + fp.urls.getPlugin();
        if (data && processData) {
            data = toQueryString(options.data);
        }
        var xhr;
        if (options.xhr) {
            xhr = options.xhr;
        } else {
            xhr = getXhr();
            if (!xhr) {
                options.error("Ajax not allowed");
                return xhr;
            }
        }
        if (crossdomain && window.XDomainRequest && !("withCredentials" in xhr)) {
            return new XDomainAjax(url, options);
        }
        if (options.progress && xhr.upload) {
            xhr.upload.addEventListener("progress", function(e) {
                if (e.lengthComputable) {
                    options.progress(Math.round(e.loaded * 95 / e.total));
                }
            }, false);
        }
        var onStateChange = function() {
            if (xhr.readyState == 4 && !finished) {
                if (options.progress) {
                    options.progress(100);
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    var resp = xhr.responseText;
                    if (options.json) {
                        try {
                            resp = fp.json.decode(resp);
                        } catch (e) {
                            onerror.call(xhr, "Invalid json: " + resp);
                            return;
                        }
                    }
                    success(resp, xhr.status, xhr);
                    finished = true;
                } else {
                    onerror.call(xhr, xhr.responseText);
                    finished = true;
                }
            }
        };
        xhr.onreadystatechange = onStateChange;
        var onerror = function(err) {
            if (finished) {
                return;
            }
            if (options.progress) {
                options.progress(100);
            }
            finished = true;
            if (this.status == 400) {
                error("bad_params", this.status, this);
                return;
            } else if (this.status == 403) {
                error("not_authorized", this.status, this);
                return;
            } else if (this.status == 404) {
                error("not_found", this.status, this);
                return;
            }
            if (crossdomain) {
                if (this.readyState == 4 && this.status === 0) {
                    error("CORS_not_allowed", this.status, this);
                    return;
                } else {
                    error("CORS_error", this.status, this);
                    return;
                }
            }
            error(err, this.status, this);
        };
        xhr.onerror = onerror;
        if (data && method == "GET") {
            url += (url.indexOf("?") !== -1 ? "&" : "?") + data;
            data = null;
        }
        if (options.withCredentials) {
            xhr.withCredentials = true;
        }
        xhr.open(method, url, async);
        if (options.json) {
            xhr.setRequestHeader("Accept", "application/json, text/javascript");
        } else {
            xhr.setRequestHeader("Accept", "text/javascript, text/html, application/xml, text/xml, */*");
        }
        var contentType = headers["Content-Type"] || headers["content-type"];
        if (data && processData && (method == "POST" || method == "PUT") && contentType === undefined) {
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=utf-8");
        }
        if (headers) {
            for (var key in headers) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
        xhr.send(data);
        return xhr;
    };
    var XDomainAjax = function(url, options) {
        if (!window.XDomainRequest) {
            return null;
        }
        var method = options.method ? options.method.toUpperCase() : "POST";
        var success = options.success || function() {};
        var error = options.error || function() {};
        var data = options.data || {};
        if (window.location.protocol == "http:") {
            url = url.replace("https:", "http:");
        } else if (window.location.protocol == "https:") {
            url = url.replace("http:", "https:");
        }
        if (options.async) {
            throw new fp.FilepickerException("Asyncronous Cross-domain requests are not supported");
        }
        if (method !== "GET" && method !== "POST") {
            data._method = method;
            method = "POST";
        }
        if (options.processData !== false) {
            data = data ? toQueryString(data) : null;
        }
        if (data && method == "GET") {
            url += (url.indexOf("?") >= 0 ? "&" : "?") + data;
            data = null;
        }
        url += (url.indexOf("?") >= 0 ? "&" : "?") + "_xdr=true&_cacheBust=" + fp.util.getId();
        var xdr = new window.XDomainRequest();
        xdr.onload = function() {
            var resp = xdr.responseText;
            if (options.progress) {
                options.progress(100);
            }
            if (options.json) {
                try {
                    resp = fp.json.decode(resp);
                } catch (e) {
                    error("Invalid json: " + resp, 200, xdr);
                    return;
                }
            }
            success(resp, 200, xdr);
        };
        xdr.onerror = function() {
            if (options.progress) {
                options.progress(100);
            }
            error(xdr.responseText || "CORS_error", this.status || 500, this);
        };
        xdr.onprogress = function() {};
        xdr.ontimeout = function() {};
        xdr.timeout = 3e4;
        xdr.open(method, url, true);
        xdr.send(data);
        return xdr;
    };
    return {
        get: get_request,
        post: post_request,
        request: make_request
    };
});

"use strict";

filepicker.extend("files", function() {
    var fp = this;
    var readFromFPUrl = function(url, options, onSuccess, onError, onProgress) {
        var temp64 = options.base64encode === undefined;
        if (temp64) {
            options.base64encode = true;
        }
        options.base64encode = options.base64encode !== false;
        var success = function(responseText) {
            if (temp64) {
                responseText = fp.base64.decode(responseText, !!options.asText);
            }
            onSuccess(responseText);
        };
        readFromUrl.call(this, url, options, success, onError, onProgress);
    };
    var readFromUrl = function(url, options, onSuccess, onError, onProgress) {
        if (options.cache !== true) {
            options._cacheBust = fp.util.getId();
        }
        fp.ajax.get(url, {
            data: options,
            headers: {
                "X-NO-STREAM": true
            },
            success: onSuccess,
            error: function(msg, status, xhr) {
                if (msg === "CORS_not_allowed") {
                    onError(new fp.errors.FPError(113));
                } else if (msg === "CORS_error") {
                    onError(new fp.errors.FPError(114));
                } else if (msg === "not_found") {
                    onError(new fp.errors.FPError(115));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(400));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(118));
                }
            },
            progress: onProgress
        });
    };
    var readFromFile = function(file, options, onSuccess, onError, onProgress) {
        if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
            onProgress(10);
            fp.files.storeFile(file, {}, function(fpfile) {
                onProgress(50);
                fp.files.readFromFPUrl(fpfile.url, options, onSuccess, onError, function(progress) {
                    onProgress(50 + progress / 2);
                });
            }, onError, function(progress) {
                onProgress(progress / 2);
            });
            return;
        }
        var base64encode = !!options.base64encode;
        var asText = !!options.asText;
        var reader = new FileReader();
        reader.onprogress = function(evt) {
            if (evt.lengthComputable) {
                onProgress(Math.round(evt.loaded / evt.total * 100));
            }
        };
        reader.onload = function(evt) {
            onProgress(100);
            if (base64encode) {
                onSuccess(fp.base64.encode(evt.target.result, asText));
            } else {
                onSuccess(evt.target.result);
            }
        };
        reader.onerror = function(evt) {
            switch (evt.target.error.code) {
              case evt.target.error.NOT_FOUND_ERR:
                onError(new fp.errors.FPError(115));
                break;

              case evt.target.error.NOT_READABLE_ERR:
                onError(new fp.errors.FPError(116));
                break;

              case evt.target.error.ABORT_ERR:
                onError(new fp.errors.FPError(117));
                break;

              default:
                onError(new fp.errors.FPError(118));
                break;
            }
        };
        if (asText || !reader.readAsBinaryString) {
            reader.readAsText(file);
        } else {
            reader.readAsBinaryString(file);
        }
    };
    var writeDataToFPUrl = function(fp_url, input, options, onSuccess, onError, onProgress) {
        var mimetype = options.mimetype || "text/plain";
        fp.ajax.post(fp.urls.constructWriteUrl(fp_url, options), {
            headers: {
                "Content-Type": mimetype
            },
            data: input,
            processData: false,
            json: true,
            success: function(json) {
                onSuccess(fp.util.standardizeFPFile(json));
            },
            error: function(msg, status, xhr) {
                if (msg === "not_found") {
                    onError(new fp.errors.FPError(121));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(122));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(123));
                }
            },
            progress: onProgress
        });
    };
    var writeFileInputToFPUrl = function(fp_url, input, options, onSuccess, onError, onProgress) {
        var error = function(msg, status, xhr) {
            if (msg === "not_found") {
                onError(new fp.errors.FPError(121));
            } else if (msg === "bad_params") {
                onError(new fp.errors.FPError(122));
            } else if (msg === "not_authorized") {
                onError(new fp.errors.FPError(403));
            } else {
                onError(new fp.errors.FPError(123));
            }
        };
        var success = function(json) {
            onSuccess(fp.util.standardizeFPFile(json));
        };
        uploadFile(input, fp.urls.constructWriteUrl(fp_url, options), success, error, onProgress);
    };
    var writeFileToFPUrl = function(fp_url, input, options, onSuccess, onError, onProgress) {
        var error = function(msg, status, xhr) {
            if (msg === "not_found") {
                onError(new fp.errors.FPError(121));
            } else if (msg === "bad_params") {
                onError(new fp.errors.FPError(122));
            } else if (msg === "not_authorized") {
                onError(new fp.errors.FPError(403));
            } else {
                onError(new fp.errors.FPError(123));
            }
        };
        var success = function(json) {
            onSuccess(fp.util.standardizeFPFile(json));
        };
        options.mimetype = input.type;
        uploadFile(input, fp.urls.constructWriteUrl(fp_url, options), success, error, onProgress);
    };
    var writeUrlToFPUrl = function(fp_url, input, options, onSuccess, onError, onProgress) {
        fp.ajax.post(fp.urls.constructWriteUrl(fp_url, options), {
            data: {
                url: input
            },
            json: true,
            success: function(json) {
                onSuccess(fp.util.standardizeFPFile(json));
            },
            error: function(msg, status, xhr) {
                if (msg === "not_found") {
                    onError(new fp.errors.FPError(121));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(122));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(123));
                }
            },
            progress: onProgress
        });
    };
    var storeFileInput = function(input, options, onSuccess, onError, onProgress) {
        if (input.files) {
            if (input.files.length === 0) {
                onError(new fp.errors.FPError(115));
            } else {
                storeFile(input.files[0], options, onSuccess, onError, onProgress);
            }
            return;
        }
        fp.util.setDefault(options, "location", "S3");
        if (!options.filename) {
            options.filename = input.value.replace("C:\\fakepath\\", "") || input.name;
        }
        var old_name = input.name;
        input.name = "fileUpload";
        fp.iframeAjax.post(fp.urls.constructStoreUrl(options), {
            data: input,
            processData: false,
            json: true,
            success: function(json) {
                input.name = old_name;
                onSuccess(fp.util.standardizeFPFile(json));
            },
            error: function(msg, status, xhr) {
                if (msg === "not_found") {
                    onError(new fp.errors.FPError(121));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(122));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(123));
                }
            }
        });
    };
    var storeFile = function(input, options, onSuccess, onError, onProgress) {
        fp.util.setDefault(options, "location", "S3");
        var error = function(msg, status, xhr) {
            if (msg === "not_found") {
                onError(new fp.errors.FPError(121));
            } else if (msg === "bad_params") {
                onError(new fp.errors.FPError(122));
            } else if (msg === "not_authorized") {
                onError(new fp.errors.FPError(403));
            } else {
                fp.util.console.error(msg);
                onError(new fp.errors.FPError(123));
            }
        };
        var success = function(json) {
            onSuccess(fp.util.standardizeFPFile(json));
        };
        if (!options.filename) {
            options.filename = input.name || input.fileName;
        }
        uploadFile(input, fp.urls.constructStoreUrl(options), success, error, onProgress);
    };
    var uploadFile = function(file, url, success, error, progress) {
        if (file.files) {
            file = file.files[0];
        }
        var html5Upload = !!window.FormData && !!window.XMLHttpRequest;
        if (html5Upload) {
            var data = new window.FormData();
            data.append("fileUpload", file);
            fp.ajax.post(url, {
                json: true,
                processData: false,
                data: data,
                success: success,
                error: error,
                progress: progress
            });
        } else {
            fp.iframeAjax.post(url, {
                data: file,
                json: true,
                success: success,
                error: error
            });
        }
    };
    var storeData = function(input, options, onSuccess, onError, onProgress) {
        fp.util.setDefault(options, "location", "S3");
        fp.util.setDefault(options, "mimetype", "text/plain");
        fp.ajax.post(fp.urls.constructStoreUrl(options), {
            headers: {
                "Content-Type": options.mimetype
            },
            data: input,
            processData: false,
            json: true,
            success: function(json) {
                onSuccess(fp.util.standardizeFPFile(json));
            },
            error: function(msg, status, xhr) {
                if (msg === "not_found") {
                    onError(new fp.errors.FPError(121));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(122));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(123));
                }
            },
            progress: onProgress
        });
    };
    var storeUrl = function(input, options, onSuccess, onError, onProgress) {
        fp.util.setDefault(options, "location", "S3");
        fp.ajax.post(fp.urls.constructStoreUrl(options), {
            data: {
                url: fp.util.getFPUrl(input)
            },
            json: true,
            success: function(json) {
                onSuccess(fp.util.standardizeFPFile(json));
            },
            error: function(msg, status, xhr) {
                if (msg === "not_found") {
                    onError(new fp.errors.FPError(151));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(152));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(153));
                }
            },
            progress: onProgress
        });
    };
    var stat = function(fp_url, options, onSuccess, onError) {
        var dateparams = [ "uploaded", "modified", "created" ];
        if (options.cache !== true) {
            options._cacheBust = fp.util.getId();
        }
        fp.ajax.get(fp_url + "/metadata", {
            json: true,
            data: options,
            success: function(metadata) {
                for (var i = 0; i < dateparams.length; i++) {
                    if (metadata[dateparams[i]]) {
                        metadata[dateparams[i]] = new Date(metadata[dateparams[i]]);
                    }
                }
                onSuccess(metadata);
            },
            error: function(msg, status, xhr) {
                if (msg === "not_found") {
                    onError(new fp.errors.FPError(161));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(400));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(162));
                }
            }
        });
    };
    var remove = function(fp_url, options, onSuccess, onError) {
        options.key = fp.apikey;
        fp.ajax.post(fp_url + "/remove", {
            data: options,
            success: function(resp) {
                onSuccess();
            },
            error: function(msg, status, xhr) {
                if (msg === "not_found") {
                    onError(new fp.errors.FPError(171));
                } else if (msg === "bad_params") {
                    onError(new fp.errors.FPError(400));
                } else if (msg === "not_authorized") {
                    onError(new fp.errors.FPError(403));
                } else {
                    onError(new fp.errors.FPError(172));
                }
            }
        });
    };
    return {
        readFromUrl: readFromUrl,
        readFromFile: readFromFile,
        readFromFPUrl: readFromFPUrl,
        writeDataToFPUrl: writeDataToFPUrl,
        writeFileToFPUrl: writeFileToFPUrl,
        writeFileInputToFPUrl: writeFileInputToFPUrl,
        writeUrlToFPUrl: writeUrlToFPUrl,
        storeFileInput: storeFileInput,
        storeFile: storeFile,
        storeUrl: storeUrl,
        storeData: storeData,
        stat: stat,
        remove: remove
    };
});

"use strict";

filepicker.extend("iframeAjax", function() {
    var fp = this;
    var IFRAME_ID = "ajax_iframe";
    var queue = [];
    var running = false;
    var get_request = function(url, options) {
        options.method = "GET";
        make_request(url, options);
    };
    var post_request = function(url, options) {
        options.method = "POST";
        url += (url.indexOf("?") >= 0 ? "&" : "?") + "_cacheBust=" + fp.util.getId();
        make_request(url, options);
    };
    var runQueue = function() {
        if (queue.length > 0) {
            var next = queue.shift();
            make_request(next.url, next.options);
        }
    };
    var make_request = function(url, options) {
        if (running) {
            queue.push({
                url: url,
                options: options
            });
            return;
        }
        url += (url.indexOf("?") >= 0 ? "&" : "?") + "plugin=" + fp.urls.getPlugin() + "&_cacheBust=" + fp.util.getId();
        url += "&Content-Type=text%2Fhtml";
        fp.comm.openChannel();
        var uploadIFrame;
        try {
            uploadIFrame = document.createElement('<iframe name="' + IFRAME_ID + '">');
        } catch (ex) {
            uploadIFrame = document.createElement("iframe");
        }
        uploadIFrame.id = uploadIFrame.name = IFRAME_ID;
        uploadIFrame.style.display = "none";
        var release = function() {
            running = false;
        };
        if (uploadIFrame.attachEvent) {
            uploadIFrame.attachEvent("onload", release);
            uploadIFrame.attachEvent("onerror", release);
        } else {
            uploadIFrame.onerror = uploadIFrame.onload = release;
        }
        uploadIFrame.id = IFRAME_ID;
        uploadIFrame.name = IFRAME_ID;
        uploadIFrame.style.display = "none";
        uploadIFrame.onerror = uploadIFrame.onload = function() {
            running = false;
        };
        document.body.appendChild(uploadIFrame);
        fp.handlers.attach("upload", getReceiveUploadMessage(options));
        var form = document.createElement("form");
        form.method = options.method || "GET";
        form.action = url;
        form.target = IFRAME_ID;
        var data = options.data;
        if (fp.util.isFileInputElement(data) || fp.util.isFile(data)) {
            form.encoding = form.enctype = "multipart/form-data";
        }
        document.body.appendChild(form);
        var input;
        if (fp.util.isFile(data)) {
            var file_input = getInputForFile(data);
            if (!file_input) {
                throw fp.FilepickerException("Couldn't find corresponding file input.");
            }
            data = {
                fileUpload: file_input
            };
        } else if (fp.util.isFileInputElement(data)) {
            input = data;
            data = {};
            data.fileUpload = input;
        } else if (data && fp.util.isElement(data) && data.tagName === "INPUT") {
            input = data;
            data = {};
            data[input.name] = input;
        } else if (options.processData !== false) {
            data = {
                data: data
            };
        }
        data.format = "iframe";
        var input_cache = {};
        for (var key in data) {
            var val = data[key];
            if (fp.util.isElement(val) && val.tagName === "INPUT") {
                input_cache[key] = {
                    par: val.parentNode,
                    sib: val.nextSibling,
                    name: val.name,
                    input: val,
                    focused: val === document.activeElement
                };
                val.name = key;
                form.appendChild(val);
            } else {
                var input_val = document.createElement("input");
                input_val.name = key;
                input_val.value = val;
                form.appendChild(input_val);
            }
        }
        running = true;
        window.setTimeout(function() {
            form.submit();
            for (var cache_key in input_cache) {
                var cache_val = input_cache[cache_key];
                cache_val.par.insertBefore(cache_val.input, cache_val.sib);
                cache_val.input.name = cache_val.name;
                if (cache_val.focused) {
                    cache_val.input.focus();
                }
            }
            form.parentNode.removeChild(form);
        }, 1);
    };
    var getReceiveUploadMessage = function(options) {
        var success = options.success || function() {};
        var error = options.error || function() {};
        var handler = function(data) {
            if (data.type !== "Upload") {
                return;
            }
            running = false;
            var response = data.payload;
            if (response.error) {
                error(response.error);
            } else {
                success(response);
            }
            fp.handlers.detach("upload");
            runQueue();
        };
        return handler;
    };
    var getInputForFile = function(file) {
        var inputs = document.getElementsByTagName("input");
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[0];
            if (input.type !== "file" || !input.files || !input.files.length) {
                continue;
            }
            for (var j = 0; j < input.files.length; j++) {
                if (input.files[j] === file) {
                    return input;
                }
            }
        }
        return null;
    };
    return {
        get: get_request,
        post: post_request,
        request: make_request
    };
});

"use strict";

filepicker.extend("base64", function() {
    var fp = this;
    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var encode = function(input, utf8encode) {
        utf8encode = utf8encode || utf8encode === undefined;
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        if (utf8encode) {
            input = _utf8_encode(input);
        }
        while (i < input.length) {
            chr1 = input.charCodeAt(i);
            chr2 = input.charCodeAt(i + 1);
            chr3 = input.charCodeAt(i + 2);
            i += 3;
            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
    };
    var decode = function(input, utf8decode) {
        utf8decode = utf8decode || utf8decode === undefined;
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
            enc1 = _keyStr.indexOf(input.charAt(i));
            enc2 = _keyStr.indexOf(input.charAt(i + 1));
            enc3 = _keyStr.indexOf(input.charAt(i + 2));
            enc4 = _keyStr.indexOf(input.charAt(i + 3));
            i += 4;
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }
        if (utf8decode) {
            output = _utf8_decode(output);
        }
        return output;
    };
    var _utf8_encode = function(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode(c >> 6 | 192);
                utftext += String.fromCharCode(c & 63 | 128);
            } else {
                utftext += String.fromCharCode(c >> 12 | 224);
                utftext += String.fromCharCode(c >> 6 & 63 | 128);
                utftext += String.fromCharCode(c & 63 | 128);
            }
        }
        return utftext;
    };
    var _utf8_decode = function(utftext) {
        var string = "", i = 0, c = 0, c2 = 0;
        while (i < utftext.length) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if (c > 191 && c < 224) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode((c & 31) << 6 | c2 & 63);
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                i += 3;
            }
        }
        return string;
    };
    return {
        encode: encode,
        decode: decode
    };
}, true);

"use strict";

filepicker.extend("browser", function() {
    var fp = this;
    var isIOS = function() {
        return !!(navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/iPad/i));
    };
    var isAndroid = function() {
        return !!navigator.userAgent.match(/Android/i);
    };
    var getLanguage = function() {
        var language = window.navigator.userLanguage || window.navigator.language;
        if (language === undefined) {
            language = "en";
        }
        language = language.replace("-", "_").toLowerCase();
        return language;
    };
    return {
        getLanguage: getLanguage,
        openInModal: function() {
            return !(isIOS() || isAndroid()) || !!window.navigator.standalone;
        },
        isMobile: function() {
            return isIOS() || isAndroid();
        }
    };
});

"use strict";

filepicker.extend("conversionsUtil", function() {
    var fp = this, CONVERSION_DOMAIN = fp.urls.BASE.replace("www", "process") + "/";
    var parseConversionUrl = function(processUrl) {
        if (!processUrl) {
            return {
                url: null,
                optionsDict: {}
            };
        }
        processUrl = processUrl.replace(CONVERSION_DOMAIN, "");
        var originalUrl = processUrl.substring(processUrl.indexOf("/http") + 1);
        processUrl = processUrl.replace("/" + originalUrl, "");
        var apikey = processUrl.substring(0, processUrl.indexOf("/"));
        processUrl = processUrl.replace(apikey + "/", "");
        var segments = processUrl.split("/"), optionsDict = {}, majorOption, minorOptions, minorOption, i, j;
        for (i in segments) {
            majorOption = segments[i].split("=");
            if (majorOption.length > 1) {
                optionsDict[majorOption[0]] = {};
                minorOptions = majorOption[1].split(",");
                for (j in minorOptions) {
                    minorOption = minorOptions[j].split(":");
                    if (minorOption.length > 1) {
                        optionsDict[majorOption[0]][minorOption[0]] = minorOption[1];
                    }
                }
            } else if (segments[i]) {
                optionsDict[segments[i]] = null;
            }
        }
        return {
            url: originalUrl,
            apikey: apikey,
            optionsDict: optionsDict
        };
    };
    var buildConversionUrl = function(originalUrl, optionsDict, apikey) {
        var conversionUrl = CONVERSION_DOMAIN + apikey, majorOption, minorOption, length;
        optionsDict = optionsDict || {};
        for (majorOption in optionsDict) {
            conversionUrl += "/" + majorOption;
            length = fp.util.objectKeys(optionsDict[majorOption] || {}).length;
            if (length) {
                conversionUrl += "=";
            }
            for (minorOption in optionsDict[majorOption]) {
                conversionUrl += minorOption + ":" + optionsDict[majorOption][minorOption];
                if (--length !== 0) {
                    conversionUrl += ",";
                }
            }
        }
        conversionUrl += "/" + originalUrl;
        return conversionUrl;
    };
    return {
        CONVERSION_DOMAIN: CONVERSION_DOMAIN,
        parseUrl: parseConversionUrl,
        buildUrl: buildConversionUrl
    };
});

"use strict";

filepicker.extend("json", function() {
    var fp = this;
    var special = {
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    };
    var escape = function(chr) {
        return special[chr] || "\\u" + ("0000" + chr.charCodeAt(0).toString(16)).slice(-4);
    };
    var validate = function(string) {
        string = string.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, "");
        return /^[\],:{}\s]*$/.test(string);
    };
    var encode = function(obj) {
        if (window.JSON && window.JSON.stringify) {
            return window.JSON.stringify(obj);
        }
        if (obj && obj.toJSON) {
            obj = obj.toJSON();
        }
        var string = [];
        switch (fp.util.typeOf(obj)) {
          case "string":
            return '"' + obj.replace(/[\x00-\x1f\\"]/g, escape) + '"';

          case "array":
            for (var i = 0; i < obj.length; i++) {
                string.push(encode(obj[i]));
            }
            return "[" + string + "]";

          case "object":
          case "hash":
            var json;
            var key;
            for (key in obj) {
                json = encode(obj[key]);
                if (json) {
                    string.push(encode(key) + ":" + json);
                }
                json = null;
            }
            return "{" + string + "}";

          case "number":
          case "boolean":
            return "" + obj;

          case "null":
            return "null";

          default:
            return "null";
        }
        return null;
    };
    var decode = function(string, secure) {
        if (!string || fp.util.typeOf(string) !== "string") {
            return null;
        }
        if (window.JSON && window.JSON.parse) {
            return window.JSON.parse(string);
        } else {
            if (secure) {
                if (!validate(string)) {
                    throw new Error("JSON could not decode the input; security is enabled and the value is not secure.");
                }
            }
            return eval("(" + string + ")");
        }
    };
    return {
        validate: validate,
        encode: encode,
        stringify: encode,
        decode: decode,
        parse: decode
    };
});

"use strict";

filepicker.extend("util", function() {
    var fp = this;
    var trim = function(string) {
        return string.replace(/^\s+|\s+$/g, "");
    };
    var trimConvert = function(url) {
        return url.replace(/\/convert\b.*/, "");
    };
    var URL_REGEX = /^(http|https)\:.*\/\//i;
    var isUrl = function(string) {
        return !!string.match(URL_REGEX);
    };
    var parseUrl = function(url) {
        if (!url || url.charAt(0) === "/") {
            url = window.location.protocol + "//" + window.location.host + url;
        }
        var a = document.createElement("a");
        a.href = url;
        var host = a.hostname.indexOf(":") === -1 ? a.hostname : a.host;
        var ret = {
            source: url,
            protocol: a.protocol.replace(":", ""),
            host: host,
            port: a.port,
            query: a.search,
            params: function() {
                var ret = {}, seg = a.search.replace(/^\?/, "").split("&"), len = seg.length, i = 0, s;
                for (;i < len; i++) {
                    if (!seg[i]) {
                        continue;
                    }
                    s = seg[i].split("=");
                    ret[s[0]] = s[1];
                }
                return ret;
            }(),
            file: (a.pathname.match(/\/([^\/?#]+)$/i) || [ undefined, "" ])[1],
            hash: a.hash.replace("#", ""),
            path: a.pathname.replace(/^([^\/])/, "/$1"),
            relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [ undefined, "" ])[1],
            segments: a.pathname.replace(/^\//, "").split("/")
        };
        ret.origin = ret.protocol + "://" + ret.host + (ret.port ? ":" + ret.port : "");
        ret.rawUrl = (ret.origin + ret.path).replace("/convert", "");
        return ret;
    };
    var endsWith = function(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    };
    var appendQueryToUrl = function(url, key, value) {
        return url + (url.indexOf("?") >= 0 ? "&" : "?") + key + "=" + value;
    };
    return {
        trim: trim,
        trimConvert: trimConvert,
        parseUrl: parseUrl,
        isUrl: isUrl,
        endsWith: endsWith,
        appendQueryToUrl: appendQueryToUrl
    };
});

"use strict";

filepicker.extend("util", function() {
    var fp = this;
    var isArray = function(o) {
        return o && Object.prototype.toString.call(o) === "[object Array]";
    };
    var isFile = function(o) {
        return o && (Object.prototype.toString.call(o) === "[object File]" || Object.prototype.toString.call(o) === "[object Blob]");
    };
    var isElement = function(o) {
        if (typeof window.HTMLElement === "object") {
            return o instanceof window.HTMLElement;
        } else {
            return o && typeof o === "object" && o.nodeType === 1 && typeof o.nodeName === "string";
        }
    };
    var isFileInputElement = function(o) {
        return isElement(o) && o.tagName === "INPUT" && o.type === "file";
    };
    var typeOf = function(value) {
        if (value === null) {
            return "null";
        } else if (isArray(value)) {
            return "array";
        } else if (isFile(value)) {
            return "file";
        }
        return typeof value;
    };
    var getId = function() {
        var d = new Date();
        return d.getTime().toString();
    };
    var setDefault = function(obj, key, def) {
        if (obj[key] === undefined) {
            obj[key] = def;
        }
    };
    var addOnLoad = function(func) {
        if (window.jQuery) {
            window.jQuery(function() {
                func();
            });
        } else {
            var evnt = "load";
            if (window.addEventListener) {
                window.addEventListener(evnt, func, false);
            } else if (window.attachEvent) {
                window.attachEvent("on" + evnt, func);
            } else {
                if (window.onload) {
                    var curr = window.onload;
                    window.onload = function() {
                        curr();
                        func();
                    };
                } else {
                    window.onload = func;
                }
            }
        }
    };
    var isFPUrl = function(url) {
        return typeof url === "string" && url.match(fp.urls.BASE + "/api/file/");
    };
    var isFPUrlCdn = function(url) {
        return typeof url === "string" && url.match("/api/file/");
    };
    var getFPUrl = function(url) {
        if (typeof url === "string") {
            var matched = url.match(/(?:^https?:\/\/cdn.filestackcontent.com|^https?:\/\/cdn.filepicker.io)[\S]*\/([\S]{20,})/);
            if (matched && matched.length > 1) {
                return fp.urls.BASE + "/api/file/" + matched[1];
            }
        }
        return url;
    };
    var consoleWrap = function(fn) {
        return function() {
            if (window.console && typeof window.console[fn] === "function") {
                try {
                    window.console[fn].apply(window.console, arguments);
                } catch (e) {
                    window.alert(Array.prototype.join.call(arguments, ","));
                }
            }
        };
    };
    var console = {};
    console.log = consoleWrap("log");
    console.error = consoleWrap("error");
    var clone = function(o) {
        var ret = {};
        for (var key in o) {
            ret[key] = o[key];
        }
        return ret;
    };
    var standardizeFPFile = function(json) {
        var fpfile = {};
        fpfile.url = json.url;
        fpfile.filename = json.filename || json.name;
        fpfile.mimetype = json.mimetype || json.type;
        fpfile.size = json.size;
        fpfile.key = json.key || json.s3_key;
        fpfile.isWriteable = !!(json.isWriteable || json.writeable);
        return fpfile;
    };
    var isCanvasSupported = function() {
        try {
            var elem = document.createElement("canvas");
            return !!(elem.getContext && elem.getContext("2d"));
        } catch (err) {
            return false;
        }
    };
    var extend = function(obj1, obj2) {
        for (var i in obj1) {
            if (obj1.hasOwnProperty(i)) {
                obj2[i] = obj1[i];
            }
        }
        return obj2;
    };
    var checkApiKey = function() {
        if (!fp.apikey) {
            throw new fp.FilepickerException("API Key not found");
        }
    };
    var objectKeys = function(obj) {
        if (typeof Object.keys !== "function") {
            return function(obj) {
                var keys = [];
                for (var i in obj) {
                    if (obj.hasOwnProperty(i)) {
                        keys.push(i);
                    }
                }
                return keys;
            };
        } else {
            return Object.keys(obj);
        }
    };
    return {
        isArray: isArray,
        isFile: isFile,
        isElement: isElement,
        isFileInputElement: isFileInputElement,
        getId: getId,
        setDefault: setDefault,
        typeOf: typeOf,
        addOnLoad: addOnLoad,
        isFPUrl: isFPUrl,
        getFPUrl: getFPUrl,
        isFPUrlCdn: isFPUrlCdn,
        console: console,
        clone: clone,
        standardizeFPFile: standardizeFPFile,
        isCanvasSupported: isCanvasSupported,
        extend: extend,
        checkApiKey: checkApiKey,
        objectKeys: objectKeys
    };
});

"use strict";

filepicker.extend("windowUtils", function() {
    return {
        getWidth: getWidth,
        getHeight: getHeight
    };
    function getWidth() {
        return document.documentElement.clientWidth || document.body && document.body.clientWidth || 1024;
    }
    function getHeight() {
        return document.documentElement.clientHeight || document.body && document.body.clientHeight || 768;
    }
});

"use strict";

filepicker.extend("dragdrop", function() {
    var fp = this;
    var canDragDrop = function() {
        return (!!window.FileReader || navigator.userAgent.indexOf("Safari") >= 0) && "draggable" in document.createElement("span");
    };
    var makeDropPane = function(div, options) {
        var err = "No DOM element found to create drop pane";
        if (!div) {
            throw new fp.FilepickerException(err);
        }
        if (div.jquery) {
            if (div.length === 0) {
                throw new fp.FilepickerException(err);
            }
            div = div[0];
        }
        if (!canDragDrop()) {
            fp.util.console.error("Your browser doesn't support drag-drop functionality");
            return false;
        }
        options = options || {};
        var dragEnter = options.dragEnter || function() {};
        var dragLeave = options.dragLeave || function() {};
        var onStart = options.onStart || function() {};
        var onSuccess = options.onSuccess || function() {};
        var onError = options.onError || function() {};
        var onProgress = options.onProgress || function() {};
        var mimetypes = options.mimetypes;
        if (!mimetypes) {
            if (options.mimetype) {
                mimetypes = [ options.mimetype ];
            } else {
                mimetypes = [ "*/*" ];
            }
        }
        if (fp.util.typeOf(mimetypes) === "string") {
            mimetypes = mimetypes.split(",");
        }
        var extensions = options.extensions;
        if (!extensions) {
            if (options.extension) {
                extensions = [ options.extension ];
            }
        }
        if (fp.util.typeOf(extensions) === "string") {
            extensions = extensions.replace(/ /g, "").split(",");
        }
        if (extensions) {
            for (var i = 0; i < extensions.length; i++) {
                extensions[i] = extensions[i].toLowerCase();
            }
        }
        var store_options = {
            location: options.location,
            path: options.path,
            container: options.container,
            access: options.access,
            policy: options.policy,
            signature: options.signature
        };
        var enabled = function() {
            return div && (div.getAttribute("disabled") || "enabled") !== "disabled";
        };
        div.addEventListener("dragenter", function(e) {
            if (enabled()) {
                dragEnter();
            }
            e.stopPropagation();
            e.preventDefault();
            return false;
        }, false);
        div.addEventListener("dragleave", function(e) {
            if (enabled()) {
                dragLeave();
            }
            e.stopPropagation();
            e.preventDefault();
            return false;
        }, false);
        div.addEventListener("dragover", function(e) {
            e.dataTransfer.dropEffect = "copy";
            e.preventDefault();
            return false;
        }, false);
        div.addEventListener("drop", function(e) {
            e.stopPropagation();
            e.preventDefault();
            if (!enabled()) {
                return false;
            }
            if (isFolderDropped(e)) {
                return false;
            }
            var files = e.dataTransfer.files, imageSrc = getImageSrcDrop(e.dataTransfer);
            if (files.length) {
                uploadDroppedFiles(files);
            } else if (imageSrc) {
                uploadImageSrc(imageSrc);
            } else {
                onError("NoFilesFound", "No files uploaded");
            }
            return false;
        });
        var reenablePane = function() {
            div.setAttribute("disabled", "enabled");
            if (window.$) {
                window.$(div).prop("disabled", false);
            }
        };
        var progresses = {};
        var response = [];
        var getSuccessHandler = function(i, total) {
            return function(fpfile) {
                if (!options.multiple) {
                    onSuccess([ fpfile ]);
                } else {
                    response.push(fpfile);
                    if (response.length === total) {
                        onSuccess(response);
                        response = [];
                        progresses = {};
                    } else {
                        progresses[i] = 100;
                        updateProgress(total);
                    }
                }
                reenablePane();
            };
        };
        var errorHandler = function(err) {
            onError("UploadError", err.toString());
            reenablePane();
        };
        var getProgressHandler = function(i, total) {
            return function(percent) {
                progresses[i] = percent;
                updateProgress(total);
            };
        };
        var updateProgress = function(totalCount) {
            var totalProgress = 0;
            for (var i in progresses) {
                totalProgress += progresses[i];
            }
            var percentage = totalProgress / totalCount;
            onProgress(percentage);
        };
        var verifyUpload = function(files) {
            if (files.length > 0) {
                if (files.length > 1 && !options.multiple) {
                    onError("TooManyFiles", "Only one file at a time");
                    return false;
                }
                if (options.maxFiles > 0 && files.length > options.maxFiles) {
                    onError("TooManyFiles", "Only " + options.maxFiles + " files at a time");
                    return false;
                }
                var found;
                var file;
                var filename;
                for (var i = 0; i < files.length; i++) {
                    found = false;
                    file = files[i];
                    filename = file.name || file.fileName || "Unknown file";
                    for (var j = 0; j < mimetypes.length; j++) {
                        var mimetype = fp.mimetypes.getMimetype(file);
                        found = found || fp.mimetypes.matchesMimetype(mimetype, mimetypes[j]);
                    }
                    if (!found) {
                        onError("WrongType", filename + " isn't the right type of file");
                        return false;
                    }
                    if (extensions) {
                        found = false;
                        for (j = 0; j < extensions.length; j++) {
                            found = found || fp.util.endsWith(filename, extensions[j]);
                        }
                        if (!found) {
                            onError("WrongType", filename + " isn't the right type of file");
                            return false;
                        }
                    }
                    if (file.size && !!options.maxSize && file.size > options.maxSize) {
                        onError("WrongSize", filename + " is too large (" + file.size + " Bytes)");
                        return false;
                    }
                }
                return true;
            } else {
                onError("NoFilesFound", "No files uploaded");
            }
            return false;
        };
        var getImageSrcDrop = function(dataTransfer) {
            var url, matched;
            if (dataTransfer && typeof dataTransfer.getData === "function") {
                url = dataTransfer.getData("text");
                try {
                    url = url || dataTransfer.getData("text/html");
                } catch (e) {
                    fp.util.console.error(e);
                }
                if (url && !fp.util.isUrl(url)) {
                    matched = url.match(/<img.*?src="(.*?)"/i);
                    url = matched && matched.length > 1 ? matched[1] : null;
                }
            }
            return url;
        };
        return true;
        function onSuccessSrcUpload(blob) {
            var successHandlerForOneFile = getSuccessHandler(0, 1);
            var blobToCheck = fp.util.clone(blob);
            blobToCheck.name = blobToCheck.filename;
            if (verifyUpload([ blobToCheck ])) {
                successHandlerForOneFile(blob);
            } else {
                fp.files.remove(blob.url, store_options, function() {}, function() {});
            }
        }
        function uploadDroppedFiles(files) {
            var total = files.length, i;
            if (verifyUpload(files)) {
                onStart(files);
                div.setAttribute("disabled", "disabled");
                for (i = 0; i < files.length; i++) {
                    fp.store(files[i], store_options, getSuccessHandler(i, total), errorHandler, getProgressHandler(i, total));
                }
            }
        }
        function uploadImageSrc(imageSrc) {
            var progressHandlerForOneFile = getProgressHandler(0, 1);
            fp.storeUrl(imageSrc, onSuccessSrcUpload, errorHandler, progressHandlerForOneFile);
        }
        function isFolderDropped(event) {
            var entry, items, i;
            if (event.dataTransfer.items) {
                items = event.dataTransfer.items;
                for (i = 0; i < items.length; i++) {
                    entry = items[i] && items[i].webkitGetAsEntry ? items[i].webkitGetAsEntry() : undefined;
                    if (entry && !!entry.isDirectory) {
                        onError("WrongType", "Uploading a folder is not allowed");
                        return true;
                    }
                }
            }
            return false;
        }
    };
    return {
        enabled: canDragDrop,
        makeDropPane: makeDropPane
    };
});

"use strict";

filepicker.extend("responsiveImages", function() {
    var fp = this;
    var WINDOW_RESIZE_TIMEOUT = 200;
    var reloadWithDebounce = debounce(function() {
        constructAll();
    }, WINDOW_RESIZE_TIMEOUT);
    return {
        activate: activate,
        deactivate: deactivate,
        update: update,
        setResponsiveOptions: setResponsiveOptions,
        getResponsiveOptions: getResponsiveOptions,
        getElementDims: getElementDims,
        replaceSrc: replaceSrc,
        getCurrentResizeParams: getCurrentResizeParams,
        construct: construct,
        constructParams: constructParams,
        shouldConstruct: shouldConstruct,
        roundWithStep: roundWithStep,
        addWindowResizeEvent: addWindowResizeEvent,
        removeWindowResizeEvent: removeWindowResizeEvent
    };
    function activate() {
        constructAll();
        addWindowResizeEvent(reloadWithDebounce);
    }
    function deactivate() {
        removeWindowResizeEvent(reloadWithDebounce);
    }
    function update(element) {
        if (element !== undefined) {
            if (element.nodeName === "IMG") {
                construct(element);
            } else {
                throw new fp.FilepickerException("Passed object is not an image");
            }
        } else {
            constructAll(true);
        }
    }
    function constructAll(forceConstruct) {
        var responsiveImages = document.querySelectorAll("img[data-fp-src]"), element, i;
        for (i = 0; i < responsiveImages.length; i++) {
            element = responsiveImages[i];
            if (shouldConstruct(element) || forceConstruct === true) {
                construct(element);
            }
        }
    }
    function shouldConstruct(image) {
        var imageSrc = getSrcAttr(image), changeOnResize = getFpOnResizeAttr(image) || getResponsiveOptions().onResize || "all";
        if (!imageSrc || changeOnResize === "all") {
            return true;
        }
        if (changeOnResize === "none") {
            return false;
        }
        var shouldBeEnlarged = getCurrentResizeParams(imageSrc).width < getElementDims(image).width;
        if (shouldBeEnlarged && changeOnResize === "up" || !shouldBeEnlarged && changeOnResize === "down") {
            return true;
        }
        return false;
    }
    function getElementDims(elem) {
        var dims = {};
        if (elem.parentNode === null) {
            dims.width = fp.windowUtils.getWidth();
            dims.height = fp.windowUtils.getWidth();
            return dims;
        }
        if (elem.alt && !elem.fpAltCheck) {
            elem.parentNode.fpAltCheck = true;
            return getElementDims(elem.parentNode);
        }
        dims.width = elem.offsetWidth;
        dims.height = elem.offsetHeight;
        if (!dims.width) {
            return getElementDims(elem.parentNode);
        }
        return dims;
    }
    function replaceSrc(elem, newSrc) {
        var previousSrc = getSrcAttr(elem) || getFpSrcAttr(elem);
        if (previousSrc !== newSrc) {
            elem.src = newSrc;
            if (previousSrc) {
                elem.onerror = function() {
                    elem.src = previousSrc;
                    elem.onerror = null;
                };
            }
        }
    }
    function getFpOnResizeAttr(elem) {
        return elem.getAttribute("data-fp-on-resize");
    }
    function getFpPixelRoundAttr(elem) {
        return elem.getAttribute("data-fp-pixel-round");
    }
    function getSrcAttr(elem) {
        return elem.getAttribute("src");
    }
    function getFpSrcAttr(elem) {
        return elem.getAttribute("data-fp-src");
    }
    function getFpKeyAttr(elem) {
        return elem.getAttribute("data-fp-apikey");
    }
    function getFpSignatureAttr(elem) {
        return elem.getAttribute("data-fp-signature");
    }
    function getFpPolicyAttr(elem) {
        return elem.getAttribute("data-fp-policy");
    }
    function getCurrentResizeParams(url) {
        return fp.conversionsUtil.parseUrl(url).optionsDict.resize || {};
    }
    function construct(elem) {
        var url = getFpSrcAttr(elem) || getSrcAttr(elem), apikey = getFpKeyAttr(elem) || fp.apikey, responsiveOptions = getResponsiveOptions();
        if (!fp.apikey) {
            fp.setKey(apikey);
            fp.util.checkApiKey();
        }
        replaceSrc(elem, fp.conversionsUtil.buildUrl(url, constructParams(elem, responsiveOptions), apikey));
    }
    function constructParams(elem, responsiveOptions) {
        responsiveOptions = responsiveOptions || {};
        var dims = getElementDims(elem), pixelRound = getFpPixelRoundAttr(elem) || responsiveOptions.pixelRound || 10, params = {
            resize: {
                width: roundWithStep(dims.width, pixelRound)
            }
        }, signature = responsiveOptions.signature || getFpSignatureAttr(elem);
        if (signature) {
            params.security = {
                signature: signature,
                policy: responsiveOptions.policy || getFpPolicyAttr(elem)
            };
        }
        return params;
    }
    function debounce(func, wait) {
        var timeout;
        return function() {
            var context = this;
            var args = arguments;
            var later = function() {
                timeout = null;
                func.apply(context, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    function addWindowResizeEvent(onWindowResized) {
        if (window.addEventListener) {
            window.addEventListener("resize", onWindowResized, false);
        } else if (window.attachEvent) {
            window.attachEvent("onresize", onWindowResized);
        }
    }
    function removeWindowResizeEvent(onWindowResized) {
        if (window.removeEventListener) {
            window.removeEventListener("resize", onWindowResized, false);
        } else if (window.detachEvent) {
            window.detachEvent("onresize", onWindowResized);
        }
    }
    function getResponsiveOptions() {
        return fp.responsiveOptions || {};
    }
    function setResponsiveOptions(options) {
        options = options || {};
        if (typeof options !== "object") {
            throw new fp.FilepickerException("Responsive options must be an object.");
        }
        fp.responsiveOptions = options;
    }
    function roundWithStep(value, round) {
        var pixelRounding = round === 0 ? 1 : round;
        return Math.ceil(value / pixelRounding) * pixelRounding;
    }
});

"use strict";

filepicker.extend("widgets", function() {
    var fp = this;
    var setAttrIfExists = function(key, options, attrname, dom) {
        var val = dom.getAttribute(attrname);
        if (val) {
            options[key] = val;
        }
    };
    var fireOnChangeEvent = function(input, fpfiles) {
        var e;
        if (document.createEvent) {
            e = document.createEvent("Event");
            e.initEvent("change", true, false);
            e.fpfile = fpfiles ? fpfiles[0] : undefined;
            e.fpfiles = fpfiles;
            input.dispatchEvent(e);
        } else if (document.createEventObject) {
            e = document.createEventObject("Event");
            e.eventPhase = 2;
            e.currentTarget = e.srcElement = e.target = input;
            e.fpfile = fpfiles ? fpfiles[0] : undefined;
            e.fpfiles = fpfiles;
            input.fireEvent("onchange", e);
        } else if (input.onchange) {
            input.onchange(fpfiles);
        }
    };
    var splitIfExist = function(key, options) {
        if (options[key]) {
            options[key] = options[key].split(",");
        }
    };
    var setAttrIfExistsArray = function(fpoptions, domElement, optionsObj) {
        for (var option in optionsObj) {
            setAttrIfExists(optionsObj[option], fpoptions, option, domElement);
        }
    };
    var constructOptions = function(domElement, mode) {
        mode = mode || "pick";
        var fpoptions = {}, generalOptionsMap = {
            "data-fp-container": "container",
            "data-fp-mimetype": "mimetype",
            "data-fp-extension": "extension",
            "data-fp-openTo": "openTo",
            "data-fp-debug": "debug",
            "data-fp-signature": "signature",
            "data-fp-policy": "policy",
            "data-fp-language": "language",
            "data-fp-background-upload": "backgroundUpload",
            "data-fp-hide": "hide",
            "data-fp-custom-css": "customCss",
            "data-fp-crop-force": "cropForce",
            "data-fp-crop-ratio": "cropRatio",
            "data-fp-crop-dim": "cropDim",
            "data-fp-crop-max": "cropMax",
            "data-fp-crop-min": "cropMin",
            "data-fp-show-close": "showClose",
            "data-fp-conversions": "conversions",
            "data-fp-custom-text": "customText",
            "data-fp-custom-source-container": "customSourceContainer",
            "data-fp-custom-source-path": "customSourcePath"
        }, pickOnlyOptionsMap = {
            "data-fp-mimetypes": "mimetypes",
            "data-fp-extensions": "extensions",
            "data-fp-maxSize": "maxSize",
            "data-fp-maxFiles": "maxFiles",
            "data-fp-store-location": "storeLocation",
            "data-fp-store-path": "storePath",
            "data-fp-store-container": "storeContainer",
            "data-fp-store-region": "storeRegion",
            "data-fp-store-access": "storeAccess",
            "data-fp-image-quality": "imageQuality",
            "data-fp-image-dim": "imageDim",
            "data-fp-image-max": "imageMax",
            "data-fp-image-min": "imageMin"
        }, webcamOptionsMap = {
            "data-fp-video-recording-resolution": "videoRes",
            "data-fp-webcam-dim": "webcamDim",
            "data-fp-video-length": "videoLen",
            "data-fp-audio-length": "audioLen"
        };
        setAttrIfExistsArray(fpoptions, domElement, generalOptionsMap);
        if (mode === "export") {
            setAttrIfExists("suggestedFilename", fpoptions, "data-fp-suggestedFilename", domElement);
        } else if (mode === "pick") {
            setAttrIfExistsArray(fpoptions, domElement, pickOnlyOptionsMap);
            fpoptions.webcam = {};
            setAttrIfExistsArray(fpoptions.webcam, domElement, webcamOptionsMap);
        }
        var services = domElement.getAttribute("data-fp-services");
        if (services) {
            services = services.split(",");
            for (var j = 0; j < services.length; j++) {
                services[j] = fp.services[services[j].replace(" ", "")] || services[j];
            }
            fpoptions.services = services;
        }
        var service = domElement.getAttribute("data-fp-service");
        if (service) {
            fpoptions.service = fp.services[service.replace(" ", "")] || service;
        }
        var arrayToSplit = [ "extensions", "mimetypes", "imageDim", "imageMin", "imageMax", "cropDim", "cropMax", "cropMin", "webcamDim", "conversions" ];
        for (var key in arrayToSplit) {
            splitIfExist(arrayToSplit[key], fpoptions);
        }
        var apikey = domElement.getAttribute("data-fp-apikey");
        if (apikey) {
            fp.setKey(apikey);
        }
        fpoptions.folders = domElement.getAttribute("data-fp-folders") === "true";
        return fpoptions;
    };
    var isMultiple = function(domElement) {
        return domElement.getAttribute("data-fp-multiple") === "true";
    };
    var constructPickWidget = function(domElement) {
        var widget = document.createElement("button");
        widget.setAttribute("type", "button");
        widget.innerHTML = domElement.getAttribute("data-fp-button-text") || "Pick File";
        widget.className = domElement.getAttribute("data-fp-button-class") || domElement.className || "fp__btn";
        domElement.style.display = "none";
        var fpoptions = constructOptions(domElement);
        if (isMultiple(domElement)) {
            widget.onclick = function() {
                widget.blur();
                fp.pickMultiple(fpoptions, function(fpfiles) {
                    var urls = [];
                    for (var j = 0; j < fpfiles.length; j++) {
                        urls.push(fpfiles[j].url);
                    }
                    domElement.value = urls.join();
                    fireOnChangeEvent(domElement, fpfiles);
                });
                return false;
            };
        } else {
            widget.onclick = function() {
                widget.blur();
                fp.pick(fpoptions, function(fpfile) {
                    domElement.value = fpfile.url;
                    fireOnChangeEvent(domElement, [ fpfile ]);
                });
                return false;
            };
        }
        domElement.parentNode.insertBefore(widget, domElement.nextSibling);
    };
    var constructConvertWidget = function(domElement) {
        var url = domElement.getAttribute("data-fp-url");
        if (!url) {
            return true;
        }
        var widget = document.createElement("button");
        widget.setAttribute("type", "button");
        widget.innerHTML = domElement.getAttribute("data-fp-button-text") || "Convert File";
        widget.className = domElement.getAttribute("data-fp-button-class") || domElement.className || "fp__btn";
        domElement.style.display = "none";
        var fpoptions = constructOptions(domElement, "convert");
        widget.onclick = function() {
            widget.blur();
            fp.processImage(url, fpoptions, function(fpfile) {
                domElement.value = fpfile.url;
                fireOnChangeEvent(domElement, [ fpfile ]);
            });
            return false;
        };
        domElement.parentNode.insertBefore(widget, domElement.nextSibling);
    };
    var constructDragWidget = function(domElement) {
        var pane = document.createElement("div");
        pane.className = domElement.getAttribute("data-fp-class") || domElement.className;
        pane.style.padding = "1px";
        domElement.style.display = "none";
        domElement.parentNode.insertBefore(pane, domElement.nextSibling);
        var pickButton = document.createElement("button");
        pickButton.setAttribute("type", "button");
        pickButton.innerHTML = domElement.getAttribute("data-fp-button-text") || "Pick File";
        pickButton.className = domElement.getAttribute("data-fp-button-class") || "fp__btn";
        pane.appendChild(pickButton);
        var dragPane = document.createElement("div");
        setupDragContainer(dragPane);
        dragPane.innerHTML = domElement.getAttribute("data-fp-drag-text") || "Or drop files here";
        dragPane.className = domElement.getAttribute("data-fp-drag-class") || "";
        pane.appendChild(dragPane);
        var fpoptions = constructOptions(domElement), multiple = isMultiple(domElement);
        if (fp.dragdrop.enabled()) {
            setupDropPane(dragPane, multiple, fpoptions, domElement);
        } else {
            dragPane.innerHTML = "&nbsp;";
        }
        if (multiple) {
            dragPane.onclick = pickButton.onclick = function() {
                pickButton.blur();
                fp.pickMultiple(fpoptions, function(fpfiles) {
                    var urls = [];
                    var filenames = [];
                    for (var j = 0; j < fpfiles.length; j++) {
                        urls.push(fpfiles[j].url);
                        filenames.push(fpfiles[j].filename);
                    }
                    domElement.value = urls.join();
                    onFilesUploaded(domElement, dragPane, filenames.join(", "));
                    fireOnChangeEvent(domElement, fpfiles);
                });
                return false;
            };
        } else {
            dragPane.onclick = pickButton.onclick = function() {
                pickButton.blur();
                fp.pick(fpoptions, function(fpfile) {
                    domElement.value = fpfile.url;
                    onFilesUploaded(domElement, dragPane, fpfile.filename);
                    fireOnChangeEvent(domElement, [ fpfile ]);
                });
                return false;
            };
        }
    };
    var onFilesUploaded = function(input, odrag, text) {
        odrag.innerHTML = text;
        odrag.style.padding = "2px 4px";
        odrag.style.cursor = "default";
        odrag.style.width = "";
        var cancel = document.createElement("span");
        cancel.innerHTML = "X";
        cancel.style.borderRadius = "8px";
        cancel.style.fontSize = "14px";
        cancel.style.cssFloat = "right";
        cancel.style.padding = "0 3px";
        cancel.style.color = "#600";
        cancel.style.cursor = "pointer";
        var clickFn = function(e) {
            if (!e) {
                e = window.event;
            }
            e.cancelBubble = true;
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            setupDragContainer(odrag);
            if (!fp.dragdrop.enabled) {
                odrag.innerHTML = "&nbsp;";
            } else {
                odrag.innerHTML = input.getAttribute("data-fp-drag-text") || "Or drop files here";
            }
            input.value = "";
            fireOnChangeEvent(input);
            return false;
        };
        if (cancel.addEventListener) {
            cancel.addEventListener("click", clickFn, false);
        } else if (cancel.attachEvent) {
            cancel.attachEvent("onclick", clickFn);
        }
        odrag.appendChild(cancel);
    };
    var setupDragContainer = function(dragPane) {
        dragPane.style.border = "1px dashed #AAA";
        dragPane.style.display = "inline-block";
        dragPane.style.margin = "0 0 0 4px";
        dragPane.style.borderRadius = "3px";
        dragPane.style.backgroundColor = "#F3F3F3";
        dragPane.style.color = "#333";
        dragPane.style.fontSize = "14px";
        dragPane.style.lineHeight = "22px";
        dragPane.style.padding = "2px 4px";
        dragPane.style.verticalAlign = "middle";
        dragPane.style.cursor = "pointer";
        dragPane.style.overflow = "hidden";
    };
    var setupDropPane = function(odrag, multiple, fpoptions, input) {
        var text = odrag.innerHTML;
        var pbar;
        fp.dragdrop.makeDropPane(odrag, {
            multiple: multiple,
            maxSize: fpoptions.maxSize,
            mimetypes: fpoptions.mimetypes,
            mimetype: fpoptions.mimetype,
            extensions: fpoptions.extensions,
            extension: fpoptions.extension,
            location: fpoptions.storeLocation,
            path: fpoptions.storePath,
            container: fpoptions.storeContainer,
            region: fpoptions.storeRegion,
            access: fpoptions.storeAccess,
            policy: fpoptions.policy,
            signature: fpoptions.signature,
            dragEnter: function() {
                odrag.innerHTML = "Drop to upload";
                odrag.style.backgroundColor = "#E0E0E0";
                odrag.style.border = "1px solid #000";
            },
            dragLeave: function() {
                odrag.innerHTML = text;
                odrag.style.backgroundColor = "#F3F3F3";
                odrag.style.border = "1px dashed #AAA";
            },
            onError: function(type, msg) {
                if (type === "TooManyFiles") {
                    odrag.innerHTML = msg;
                } else if (type === "WrongType") {
                    odrag.innerHTML = msg;
                } else if (type === "NoFilesFound") {
                    odrag.innerHTML = msg;
                } else if (type === "UploadError") {
                    odrag.innerHTML = "Oops! Had trouble uploading.";
                }
            },
            onStart: function(files) {
                pbar = setupProgress(odrag);
            },
            onProgress: function(percentage) {
                if (pbar) {
                    pbar.style.width = percentage + "%";
                }
            },
            onSuccess: function(fpfiles) {
                var vals = [];
                var filenames = [];
                for (var i = 0; i < fpfiles.length; i++) {
                    vals.push(fpfiles[i].url);
                    filenames.push(fpfiles[i].filename);
                }
                input.value = vals.join();
                onFilesUploaded(input, odrag, filenames.join(", "));
                fireOnChangeEvent(input, fpfiles);
            }
        });
    };
    var setupProgress = function(odrag) {
        var pbar = document.createElement("div");
        var height = odrag.offsetHeight - 2;
        pbar.style.height = height + "px";
        pbar.style.backgroundColor = "#0E90D2";
        pbar.style.width = "2%";
        pbar.style.borderRadius = "3px";
        odrag.style.width = odrag.offsetWidth + "px";
        odrag.style.padding = "0";
        odrag.style.border = "1px solid #AAA";
        odrag.style.backgroundColor = "#F3F3F3";
        odrag.style.boxShadow = "inset 0 1px 2px rgba(0, 0, 0, 0.1)";
        odrag.innerHTML = "";
        odrag.appendChild(pbar);
        return pbar;
    };
    var constructExportWidget = function(domElement) {
        domElement.onclick = function() {
            var url = domElement.getAttribute("data-fp-url");
            if (!url) {
                return true;
            }
            var fpoptions = constructOptions(domElement, "export");
            fp.exportFile(url, fpoptions);
            return false;
        };
    };
    var buildWidgets = function() {
        if (document.querySelectorAll) {
            var i;
            var pick_base = document.querySelectorAll('input[type="filepicker"]');
            for (i = 0; i < pick_base.length; i++) {
                constructPickWidget(pick_base[i]);
            }
            var drag_widgets = document.querySelectorAll('input[type="filepicker-dragdrop"]');
            for (i = 0; i < drag_widgets.length; i++) {
                constructDragWidget(drag_widgets[i]);
            }
            var convert_widgets = document.querySelectorAll('input[type="filepicker-convert"]');
            for (i = 0; i < convert_widgets.length; i++) {
                constructConvertWidget(convert_widgets[i]);
            }
            var export_base = [];
            var tmp = document.querySelectorAll("button[data-fp-url]");
            for (i = 0; i < tmp.length; i++) {
                export_base.push(tmp[i]);
            }
            tmp = document.querySelectorAll("a[data-fp-url]");
            for (i = 0; i < tmp.length; i++) {
                export_base.push(tmp[i]);
            }
            tmp = document.querySelectorAll('input[type="button"][data-fp-url]');
            for (i = 0; i < tmp.length; i++) {
                export_base.push(tmp[i]);
            }
            for (i = 0; i < export_base.length; i++) {
                constructExportWidget(export_base[i]);
            }
            var previews = document.querySelectorAll('[type="filepicker-preview"][data-fp-url]');
            for (i = 0; i < previews.length; i++) {
                constructPreview(previews[i]);
            }
            appendStyle();
        }
    };
    var constructWidget = function(base) {
        if (base.jquery) {
            base = base[0];
        }
        var base_type = base.getAttribute("type");
        if (base_type === "filepicker") {
            constructPickWidget(base);
        } else if (base_type === "filepicker-dragdrop") {
            constructDragWidget(base);
        } else if (base_type === "filepicker-preview") {
            constructPreview(base);
        } else if (base.getAttribute("data-fp-src")) {
            fp.responsiveImages.construct(base);
        } else {
            constructExportWidget(base);
        }
    };
    var constructPreview = function(domElement) {
        var url = domElement.getAttribute("data-fp-url"), css = domElement.getAttribute("data-fp-custom-css");
        var url = fp.util.getFPUrl(url);
        if (!url || !fp.util.isFPUrl(url)) {
            return true;
        } else {
            url = url.replace("api/file/", "api/preview/");
        }
        var iframe = document.createElement("iframe");
        if (css) {
            url = fp.util.appendQueryToUrl(url, "css", css);
        }
        iframe.src = url;
        iframe.width = "100%";
        iframe.height = "100%";
        domElement.appendChild(iframe);
    };
    function appendStyle() {
        try {
            var css = '.fp__btn{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:inline-block;height:34px;padding:4px 30px 5px 40px;position:relative;margin-bottom:0;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:"Open Sans", sans-serif;font-size:12px;font-weight:600;line-height:1.42857143;color:#fff;text-align:center;white-space:nowrap;background:#ef4925;background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAVCAYAAABLy77vAAAABGdBTUEAALGPC/xhBQAAAJRJREFUOBHNUcEWgCAIy14fbl9egK5MRarHQS7ocANmOCgWh1gdNERig1CgwPlLxkZuE80ndHlU+4Lda1zz0m01dSKtcz0h7qpQb7WR+HyrqRPxahzwwMqqkEVs6qnv+86NQAbcJlK/X+vMeMe7XcBOYaRzcbItUR7/8QgcykmElQrQPErnmxNxl2yyiwcgEvQUocIJaE6yERwqXDIAAAAASUVORK5CYII=");background-repeat:no-repeat;background-position:15px 6px;border:1px solid transparent;border-radius:17px}.fp__btn:hover{background-color:#d64533}.fp__btn::after{position:absolute;content:"";top:15px;right:14px;width:7px;height:4px;background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAABGdBTUEAALGPC/xhBQAAAGlJREFUCB1j/P//vw4DA4MiEKOD+0xAkatA/AJNBsS/ysTIyPgfyDgHxO+hCkD0Oag4RAhoPDsQm4NoqCIGBiBnAhBjAxNAkkxAvBZNFsQHuQesmxPIOQZVAKI54UZDFYgABbcBsQhMAgDIVGYSqZsn6wAAAABJRU5ErkJggg==");}.fp__btn:hover::after{background-position:0 -4px;}.fp__btn:active,.fp__btn:focus{outline:none}@media only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2 / 1), only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2){.fp__btn{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAqCAYAAADbCvnoAAAABGdBTUEAALGPC/xhBQAAAQFJREFUWAntWEESwjAIbBwfHl+upNoRNjKUJhk5kIvZQGG7bHOwPGltgdYtEJedShKyJnLHhEILz1Zi9HCOzFI7FUqFLAWseDgPdfeQ9QZ4b1j53nstnEJJyBqx20NeT1gEMB5uZG6Fzn5lV5UMp1ASQhMjdnvoqjewsYbDjcytEH5lsxULp1AS0sx8nJfVnjganf3NkVlKhVPIfQ9Zb6jF0atK3mNriXwpicPHvIeyr3sTDA53VgpgH8BvMu1ZCCz7ew/7MPwlE4CQJPNnQj2ZX4SYlEPbVpsvKFZ5TOwhcRoUTQiwwhVjArPEqVvRhMCneMXzDk9lwYphIwrZZOihF32oehMAa1qSAAAAAElFTkSuQmCC");background-size:18px 21px}.fp__btn::after{background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAABGdBTUEAALGPC/xhBQAAANpJREFUKBWVkU8KglAYxJ/u3HuBwmUX8BqepKN4ka4RguDOVYu2QVCrhIJ6/caekqLiGxi+PzPD58PAWrszxmygD84h7hpePFLy1mEQBJamgvcVYXkqZXTR0LwpJWw0z0Ba6bymDcrI4kkp4EvzCNoVztNKfVATwoOiyx/NDup1SVqPQVBbDDeK3txBb9JuHfhNW3HWjZhDX+SGRAgPHkl5f0+kieBxRVieaPD5LGJ4WghLiwehbkBI4HUirF3S+SYrhhQ2f2H16aR5vMSYwbdjNtYXZ0J7cc70BXnFMHIGznzEAAAAAElFTkSuQmCC");background-size:7px 8px;}}';
            var head = document.head || document.getElementsByTagName("head")[0], style = document.createElement("style");
            style.type = "text/css";
            if (style.styleSheet) {
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }
            head.appendChild(style);
        } catch (err) {}
    }
    return {
        constructPickWidget: constructPickWidget,
        constructDragWidget: constructDragWidget,
        constructExportWidget: constructExportWidget,
        buildWidgets: buildWidgets,
        constructWidget: constructWidget
    };
});

"use strict";

(function() {
    filepicker.internal(function() {
        var fp = this;
        fp.util.addOnLoad(fp.cookies.checkThirdParty);
        fp.util.addOnLoad(fp.widgets.buildWidgets);
        fp.util.addOnLoad(fp.responsiveImages.activate);
    });
    delete filepicker.internal;
    delete filepicker.extend;
    var queue = filepicker._queue || [];
    var args;
    var len = queue.length;
    if (len) {
        for (var i = 0; i < len; i++) {
            args = queue[i];
            filepicker[args[0]].apply(filepicker, args[1]);
        }
    }
    if (filepicker._queue) {
        delete filepicker._queue;
    }
})();

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(59);var _reactDom2=_interopRequireDefault(_reactDom);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _CaptionContainerItem=__webpack_require__(1654);var _CaptionContainerItem2=_interopRequireDefault(_CaptionContainerItem);var _CaptionContainer=__webpack_require__(1656);var _CaptionContainer2=_interopRequireDefault(_CaptionContainer);var _library=__webpack_require__(40);var _componentHelpers=__webpack_require__(26);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Button=_library.FormControls.Button;var CaptionContainer=function(_React$Component){(0,_inherits3.default)(CaptionContainer,_React$Component);/**
   * CaptionContainer Component constructor
   * @param  {Object}  props - props object
   * @return {Undefined} Returns nothing
   */function CaptionContainer(props){(0,_classCallCheck3.default)(this,CaptionContainer);var _this=(0,_possibleConstructorReturn3.default)(this,(CaptionContainer.__proto__||(0,_getPrototypeOf2.default)(CaptionContainer)).call(this));_this.state={removalCount:0,bodyHeight:0,footerTop:0,itemHeight:0,windowHeight:0};_this.scrollPosition=null;_this.collectionSize=_lodash2.default.size(props.mediaCollection);_this.mediaType=_lodash2.default.get(props.mediaCollection,'[0].mediaType');_this.mediaUpdates={};_this.bodyRef=null;_this.footerRef=null;_this.itemRef=null;_this.setBodyRef=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'bodyRef',_this);_this.setFooterRef=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'footerRef',_this);_this.setItemRef=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'itemRef',_this);(0,_componentHelpers.bindMethods)(_this,['handleCancel','handleSubmit','handleItemChange','handleOrientationChange']);return _this;}/**
   * Lifecycle method
   * @returns {Undefined} Returns nothing
   */(0,_createClass3.default)(CaptionContainer,[{key:'componentDidMount',value:function componentDidMount(){this.scrollPosition=_lodash2.default.get(this.props,'scrollPosition')||window.pageYOffset;if(this.props.mobileDetails.any){this.handleOrientationChange();}window.addEventListener('orientationchange',this.handleOrientationChange);}/**
   * Lifecycle method
   * @returns {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('orientationchange',this.handleOrientationChange);}/**
   * Sets various styles used for mobile layout
   * @returns {Undefined} Returns nothing
   */},{key:'setStyles',value:function setStyles(){var windowHeight=window.innerHeight;var footerHeight=_lodash2.default.get(this.footerRef,'clientHeight',0);var bodyOffset=_lodash2.default.get(this.bodyRef,'offsetTop',0);var bodyHeight=windowHeight-bodyOffset;var footerTop=windowHeight-footerHeight;var itemHeight=_lodash2.default.get(_reactDom2.default.findDOMNode(this.itemRef),'clientWidth',0);this.setState({bodyHeight:bodyHeight,footerTop:footerTop,itemHeight:itemHeight,windowHeight:windowHeight});}/**
   * Cancels media changes
   * @param  {Object} mediaCollection           Object containing uploaded media
   * @param  {Boolean} isInitialUpload          Is this the initial upload
   * @return {Undefined} Returns nothing
   */},{key:'handleCancel',value:function handleCancel(mediaCollection,isInitialUpload){var collection=isInitialUpload?[]:mediaCollection;this.props.handleMediaCollection(collection,false,this.scrollPosition);}/**
   * Merges collection changes with original, and submits to handler
   * @param  {Object} mediaCollection           Object containing uploaded media
   * @param  {Object} mediaUpdates              Object containing user changes
   * @return {Undefined} Returns nothing
   */},{key:'handleSubmit',value:function handleSubmit(mediaCollection,mediaUpdates){var collection=mediaCollection;if(!_lodash2.default.isEmpty(mediaUpdates)){collection=_lodash2.default.cloneDeep(mediaCollection);_lodash2.default.map(mediaUpdates,function(modifiedItem){var item=_lodash2.default.find(collection,{id:modifiedItem.id});if(item){if(modifiedItem.remove){_lodash2.default.remove(collection,function(obj){return obj.id===modifiedItem.id;});}else{item.caption=modifiedItem.caption;}}});}this.props.handleMediaCollection(collection,false,this.scrollPosition);}/**
   * Sets user changes to media items
   * @param  {Object} mediaUpdates        Object containing user changes
   * @param  {Object} newValues           Object containing possible id, caption and remove values to modify mediaUpdates object
   * @return {Undefined} Returns nothing
   */},{key:'handleItemChange',value:function handleItemChange(mediaUpdates,newValues){var obj=_lodash2.default.get(mediaUpdates,newValues.id);var removalCount=0;if(_lodash2.default.isNil(obj)){obj=mediaUpdates[newValues.id]={};}obj.id=_lodash2.default.get(newValues,'id');obj.caption=_lodash2.default.get(newValues,'caption');obj.remove=_lodash2.default.get(newValues,'remove');_lodash2.default.map(mediaUpdates,function(item){if(item.remove){removalCount++;}});this.setState({removalCount:removalCount});}/**
   * Orientation change event handler
   * @return {Undefined} Returns nothing
   */},{key:'handleOrientationChange',value:function handleOrientationChange(){var _this2=this;setTimeout(function(){return _this2.setStyles();},100);}/**
   * React Component render.
   * @return {JSX} CaptionContainer rendered.
   */},{key:'render',value:function render(){var _this3=this;var _props=this.props,isInitialUpload=_props.isInitialUpload,mediaCollection=_props.mediaCollection;var collectionCount=this.collectionSize-this.state.removalCount;var mediaString=collectionCount===1?this.mediaType:this.mediaType+'s';var _props$mobileDetails=this.props.mobileDetails;_props$mobileDetails=_props$mobileDetails===undefined?{}:_props$mobileDetails;var mobile=_props$mobileDetails.any;return this.collectionSize===0?null:_react2.default.createElement('div',{className:''+_CaptionContainer2.default.CaptionContainer+(mobile?' '+_CaptionContainer2.default.mobile:''),style:mobile?{height:this.state.windowHeight}:null},_react2.default.createElement('div',{className:_CaptionContainer2.default.header},_react2.default.createElement('h2',null,'Edit Media'),_react2.default.createElement('p',null,collectionCount+' '+mediaString)),_react2.default.createElement('div',{className:_CaptionContainer2.default.body,ref:this.setBodyRef,style:mobile?{height:this.state.bodyHeight}:null},mediaCollection.map(function(item,index){return _react2.default.createElement(_CaptionContainerItem2.default,{changeHandler:_lodash2.default.partial(_this3.handleItemChange,_this3.mediaUpdates),height:_this3.state.itemHeight,key:index,media:item,mobile:mobile,ref:_this3.setItemRef});})),_react2.default.createElement('div',{className:_CaptionContainer2.default.footer,ref:this.setFooterRef,style:mobile?{top:this.state.footerTop}:null},_react2.default.createElement(Button,{btnType:'primary',className:_CaptionContainer2.default.cancel,handleClick:_lodash2.default.partial(this.handleCancel,mediaCollection,isInitialUpload)},'Cancel'),_react2.default.createElement(Button,{btnType:'primary',className:_CaptionContainer2.default.submit,disabled:false,handleClick:_lodash2.default.partial(this.handleSubmit,mediaCollection,this.mediaUpdates)},'Save & Continue')));}}]);return CaptionContainer;}(_react2.default.Component);CaptionContainer.propTypes={handleMediaCollection:_react2.default.PropTypes.func,isInitialUpload:_react2.default.PropTypes.bool,mediaCollection:_react2.default.PropTypes.array,mobileDetails:_react2.default.PropTypes.object.isRequired,scrollPosition:_react2.default.PropTypes.number};exports.default=CaptionContainer;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _library=__webpack_require__(40);var _componentHelpers=__webpack_require__(26);var _Svgs=__webpack_require__(36);var _constants=__webpack_require__(41);var _CaptionContainerItem=__webpack_require__(1655);var _CaptionContainerItem2=_interopRequireDefault(_CaptionContainerItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Button=_library.FormControls.Button,TextArea=_library.FormControls.TextArea;var CaptionContainerItem=function(_React$Component){(0,_inherits3.default)(CaptionContainerItem,_React$Component);/**
   * CaptionContainerItem Component constructor
   * @param  {Object}  props - props object
   * @return {Undefined} Returns nothing
   */function CaptionContainerItem(props){(0,_classCallCheck3.default)(this,CaptionContainerItem);var _this=(0,_possibleConstructorReturn3.default)(this,(CaptionContainerItem.__proto__||(0,_getPrototypeOf2.default)(CaptionContainerItem)).call(this,props));_this.state={userCaption:_lodash2.default.get(props,'media.caption')||''};(0,_componentHelpers.bindMethods)(_this,['handleInputChange','handleMarkForDeletion','handleInputInit']);return _this;}/**
   * Updates field size on initialization
   * @param  {documentElement} target   textarea element
   * @return {Undefined} Returns nothing
   */(0,_createClass3.default)(CaptionContainerItem,[{key:'handleInputInit',value:function handleInputInit(target){if(target.value){this.updateFieldSize(target);}}/**
   * Handle an input change
   * @param  {Object} e The Event object
   * @param  {String} key The state key
   * @return {Undefined} Returns nothing
   */},{key:'handleInputChange',value:function handleInputChange(e,key){e.persist();var target=e.target;this.updateFieldSize(target,key);}/**
   * Updates field size
   * @param  {documentElement} target   textarea element
   * @param  {String} key               State key
   * @return {Undefined} Returns nothing
   */},{key:'updateFieldSize',value:function updateFieldSize(target,key){var value=target.value;var stateObj={};stateObj[key]=value;this.setState(stateObj);this.props.changeHandler({id:this.props.media.id,caption:value});// the following is necessary, not a mistake. sets to auto so that it can properly read scrollHeight
target.style.height='auto';target.style.height=target.scrollHeight+'px';}/**
   * Marks item for deletion
   * @return {Undefined} Returns nothing
   */},{key:'handleMarkForDeletion',value:function handleMarkForDeletion(){this.props.changeHandler({id:this.props.media.id,remove:true});this.setState({deleteItem:!this.state.deleteItem});}/**
   * React Component render.
   * @return {JSX} CaptionContainerItem rendered.
   */},{key:'render',value:function render(){var _props=this.props,height=_props.height,media=_props.media,mobile=_props.mobile;var heightStyle=mobile?{height:height+'px'}:{};var caption=this.state.userCaption;var placeholderText=caption?null:'Add caption';return _lodash2.default.isObject(media)&&_lodash2.default.has(media,'url')&&!this.state.deleteItem?_react2.default.createElement('div',{className:''+_CaptionContainerItem2.default.CaptionContainerItem+(mobile?' '+_CaptionContainerItem2.default.mobile:'')},_react2.default.createElement('div',{className:_CaptionContainerItem2.default.imgContainer,style:heightStyle},mobile?null:_react2.default.createElement('div',{className:_CaptionContainerItem2.default.overlayDelete},_react2.default.createElement(Button,{btnType:'primary',className:_CaptionContainerItem2.default.delete,handleClick:this.handleMarkForDeletion},'Delete')),media.mediaType===_constants.MEDIA_TYPES.video?_react2.default.createElement('div',{className:_CaptionContainerItem2.default.mediaDisplay},_react2.default.createElement(_Svgs.VideoUploadIcon,null),_react2.default.createElement('p',null,media.filename)):_react2.default.createElement('img',{src:media.url})),_react2.default.createElement('div',{className:_CaptionContainerItem2.default.captionContainer},_react2.default.createElement(TextArea,{className:_CaptionContainerItem2.default.textArea,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'userCaption'),id:'caption',name:'userCaption',onInit:this.handleInputInit,placeholder:placeholderText,value:this.state.userCaption}),mobile?_react2.default.createElement('div',{className:_CaptionContainerItem2.default.mobileDeleteContainer},_react2.default.createElement(Button,{btnType:'primary',className:_CaptionContainerItem2.default.mobileDelete,handleClick:this.handleMarkForDeletion},_react2.default.createElement('div',null,_react2.default.createElement('span',null,_react2.default.createElement(_Svgs.TrashcanIcon,null)),'Delete'))):null)):null;}}]);return CaptionContainerItem;}(_react2.default.Component);CaptionContainerItem.propTypes={changeHandler:_react2.default.PropTypes.func,height:_react2.default.PropTypes.number,media:_react2.default.PropTypes.object,mobile:_react2.default.PropTypes.bool};exports.default=CaptionContainerItem;

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","CaptionContainerItem":"CaptionContainerItem","imgContainer":"imgContainer","overlayDelete":"overlayDelete","mediaDisplay":"mediaDisplay","captionContainer":"captionContainer","delete":"delete","mobile":"mobile","mobileDeleteContainer":"mobileDeleteContainer","mobileDelete":"mobileDelete"};

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","CaptionContainer":"CaptionContainer","test":"test","header":"header","body":"body","footer":"footer","submit":"submit","cancel":"cancel","mobile":"mobile"};

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ErrorDisplay=__webpack_require__(1658);var _ErrorDisplay2=_interopRequireDefault(_ErrorDisplay);var _Svgs=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ErrorDisplay=function ErrorDisplay(props){var isFallback=props.isFallback;return isFallback?_react2.default.createElement('div',{className:_ErrorDisplay2.default.ErrorDisplay},_react2.default.createElement(_Svgs.ErrorInfoIcon,null),_react2.default.createElement('p',{className:_ErrorDisplay2.default.header},'Oops! Something went wrong.'),_react2.default.createElement('p',null,' ','We are unable to access the Guest Book at this time. Please try again later.')):null;};ErrorDisplay.propTypes={isFallback:_react2.default.PropTypes.bool};exports.default=ErrorDisplay;

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","ErrorDisplay":"ErrorDisplay","header":"header"};

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mutatePersonAlert=mutatePersonAlert;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _mutationTemplates=__webpack_require__(245);var _gatewayFetch=__webpack_require__(178);var _gatewayFetch2=_interopRequireDefault(_gatewayFetch);var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Posts a person alert through the gateway to the person service
 * @method mutatePersonAlert
 * @param  {object}   mutationParams parameters to add to the query template
 * @return {function} returns the function to make the post
 */function mutatePersonAlert(mutationParams){return function(dispatch){dispatch((0,_actions.mutationRequest)());if(!_lodash2.default.isEmpty(mutationParams)){var query=(0,_mutationTemplates.PERSON_ALERT_MUTATION_TEMPLATE)(mutationParams);return(0,_gatewayFetch2.default)(query,'mutation').then(function(data){return dispatch((0,_actions.mutatePersonAlertSuccess)(data));}).catch(function(reason){return dispatch((0,_actions.mutatePersonAlertFailure)(reason));});}dispatch((0,_actions.mutatePersonAlertFailure)('no post parameters present'));};}

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.queryCondolences=queryCondolences;exports.queryGalleryCondolences=queryGalleryCondolences;exports.mutateCondolence=mutateCondolence;exports.resetCondlenceMutationStatus=resetCondlenceMutationStatus;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _queryTemplates=__webpack_require__(243);var _mutationTemplates=__webpack_require__(245);var _gatewayFetch=__webpack_require__(178);var _gatewayFetch2=_interopRequireDefault(_gatewayFetch);var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Fetches additional condolences from graphQL
 * @method queryCondolences
 * @param  {object}   queryParams parameter to add to the query template
 * @return {function} returns the function to make the fetch
 */function queryCondolences(queryParams){return function(dispatch){dispatch((0,_actions.queryRequest)());if(!_lodash2.default.isEmpty(queryParams)){var query=(0,_queryTemplates.CONDOLENCES_QUERY_TEMPATE)(queryParams);return(0,_gatewayFetch2.default)(query,'query').then(function(data){return dispatch((0,_actions.queryCondolencesSuccess)(data));}).catch(function(reason){return dispatch((0,_actions.queryFailure)(reason));});}dispatch((0,_actions.queryFailure)('no fetch parameters present'));};}/**
 * Fetches additional gallery condolences from graphQL
 * @method queryCondolences
 * @param  {object}   queryParams parameter to add to the query template
 * @return {function} returns the function to make the fetch
 */function queryGalleryCondolences(queryParams){return function(dispatch){dispatch((0,_actions.queryRequest)());if(!_lodash2.default.isEmpty(queryParams)){var query=(0,_queryTemplates.GALLERY_QUERY_TEMPATE)(queryParams);return(0,_gatewayFetch2.default)(query,'query').then(function(data){return dispatch((0,_actions.queryGallerySuccess)(data));}).catch(function(reason){return dispatch((0,_actions.queryFailure)(reason));});}dispatch((0,_actions.queryFailure)('no fetch parameters present'));};}/**
 * Posts a condolence through the gateway to the guestbook service
 * @method mutateCondolence
 * @param  {object}   mutationParams parameters to add to the query template
 * @return {function} returns the function to make the post
 */function mutateCondolence(mutationParams){return function(dispatch){dispatch((0,_actions.mutationRequest)());if(!_lodash2.default.isEmpty(mutationParams)){var query=(0,_mutationTemplates.CONDOLENCE_MUTATION_TEMPLATE)(mutationParams);return(0,_gatewayFetch2.default)(query,'mutation').then(function(data){return dispatch((0,_actions.mutateCondolenceSuccess)(data));}).catch(function(reason){return dispatch((0,_actions.mutationFailure)(reason));});}dispatch((0,_actions.mutationFailure)('no post parameters present'));};}/**
 * Resets the condolence mutation status after a mutation attempt
 * @method resetCondlenceMutationStatus
 * @param  {number}   mutationStatus - an entry id if successful, a `0` if failed
 * @return {function} returns the function to reset the mutation status
 */function resetCondlenceMutationStatus(mutationStatus){return function(dispatch){if(_lodash2.default.isNumber(mutationStatus)){dispatch((0,_actions.resetMutationStatus)());}};}

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _StickyGbCta=__webpack_require__(1662);var _StickyGbCta2=_interopRequireDefault(_StickyGbCta);var _isFunction2=__webpack_require__(136);var _isFunction3=_interopRequireDefault(_isFunction2);var _isNil2=__webpack_require__(346);var _isNil3=_interopRequireDefault(_isNil2);var _GAHelpers=__webpack_require__(22);var _componentHelpers=__webpack_require__(26);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var StickyGbCta=function(_React$Component){(0,_inherits3.default)(StickyGbCta,_React$Component);function StickyGbCta(props){(0,_classCallCheck3.default)(this,StickyGbCta);var _this=(0,_possibleConstructorReturn3.default)(this,(StickyGbCta.__proto__||(0,_getPrototypeOf2.default)(StickyGbCta)).call(this,props));_this.state={display:_this.props.display||false};(0,_componentHelpers.bindMethods)(_this,['handleClick','handleScroll','handleModalOpen']);return _this;}(0,_createClass3.default)(StickyGbCta,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.handleScroll);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_isNil3.default)(nextProps.display)&&this.state.display!==nextProps.display){this.setState({display:nextProps.display});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);}/**
   * scroll event handler
   * @return {undefined} returns nothing
   */},{key:'handleScroll',value:function handleScroll(){var position=(0,_isFunction3.default)(this.props.getGuestBookPosition)?this.props.getGuestBookPosition():0;if(position<-350){if(!this.state.display){this.setState({display:true});}}else if(this.state.display){this.setState({display:false});}}/**
   * click event handler
   * @return {undefined} returns nothing
   */},{key:'handleClick',value:function handleClick(){if((0,_isFunction3.default)(this.props.guestBookHandler)){this.props.guestBookHandler();(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'sign_guest_book_stickynav',eventLabel:'onpage'});}}},{key:'render',value:function render(){return!this.props.hasSubmitted&&this.props.isSingleColumn?_react2.default.createElement('div',{className:''+_StickyGbCta2.default.StickyGbCta+(this.state.display?' '+_StickyGbCta2.default.display:''),onClick:this.handleClick},'Sign Guest Book'):null;}}]);return StickyGbCta;}(_react2.default.Component);StickyGbCta.propTypes={display:_react2.default.PropTypes.bool,getGuestBookPosition:_react2.default.PropTypes.func,guestBookHandler:_react2.default.PropTypes.func,hasSubmitted:_react2.default.PropTypes.bool,isSingleColumn:_react2.default.PropTypes.bool};exports.default=StickyGbCta;

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","StickyGbCta":"StickyGbCta","display":"display"};

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Obituary=__webpack_require__(1664);var _Obituary2=_interopRequireDefault(_Obituary);var _SourceGroup=__webpack_require__(1665);var _SourceGroup2=_interopRequireDefault(_SourceGroup);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _library=__webpack_require__(40);var _GAHelpers=__webpack_require__(22);var _personPageType=__webpack_require__(67);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _constants=__webpack_require__(41);var _Svgs=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * The obituary section of the person page
 * @param   {Object}  props Passed in properties
 * @return  {JSX}     Returns the obituary section
 *//* eslint-disable react/no-danger, no-warning-comments *//* TODO: Remove dangerouslySetInnerHTML Calls */var Obituary=function(_React$Component){(0,_inherits3.default)(Obituary,_React$Component);function Obituary(props){(0,_classCallCheck3.default)(this,Obituary);var _this=(0,_possibleConstructorReturn3.default)(this,(Obituary.__proto__||(0,_getPrototypeOf2.default)(Obituary)).call(this,props));_this.state={isExpanded:false};var personPageType=props.personPageType,sources=props.sourceGroup;_this.toggleObitText=_this.toggleObitText.bind(_this);_this.teaserText=_lodash2.default.get(props.textToDisplay,'teaser');_this.fullText=_lodash2.default.get(props.textToDisplay,'full');_this.isSingleTributesUnpaid=false;_this.isLegacySourced=false;_this.sourceCount=_lodash2.default.size(sources);_this.memoriamCount=0;_this.internationalCount=0;_this.renderedObits=_this.getRenderedObits(_lodash2.default.cloneDeep(sources));_this.headerText=_this.getHeaderText(_this.sourceCount,_this.memoriamCount,_this.internationalCount,personPageType);return _this;}/**
   * Returns if module should be in right column
   * @param  {object} layout object of layout definitions
   * @return {string}        return 'right' or null
   */(0,_createClass3.default)(Obituary,[{key:'getLayoutInfo',value:function getLayoutInfo(layout){var hasObituary=_lodash2.default.indexOf(_lodash2.default.get(layout,'map.dual.right',[]),'obituary')!==-1;var isSingleColumn=_lodash2.default.get(layout,'columns','dual')==='single';return{isSingleColumn:isSingleColumn,isRightColumn:!isSingleColumn&&hasObituary?'ObituaryRight':false};}/**
   * Toggles the obit text collapse/expand
   * @method toggleObitText
   * @return {undefind} returns nothing
   */},{key:'toggleObitText',value:function toggleObitText(){this.setState(function(prevState){return{isExpanded:!prevState.isExpanded};});}/**
   * Gets the rendered obits and counts their type
   * @param   {array} sources the list of obituaries, memoriams, or notices
   * @return  {array} returns each source with the read more text
   */},{key:'getRenderedObits',value:function getRenderedObits(sources){var _this2=this;return _lodash2.default.map(sources,function(obit){var obitType=_lodash2.default.get(obit,'obituaryType');if(_this2.sourceCount===1){_this2.isSingleTributesUnpaid=obitType===_constants.OBIT_TYPE_TRIBUTES_UNPAID;_this2.isLegacySourced=obitType===_constants.OBIT_TYPE_LEGACY;}switch(obitType){case _constants.OBIT_TYPE_MEMORIAM:_this2.memoriamCount++;obit.showReadMore=true;obit.readMoreText='Read Memoriam';break;case _constants.OBIT_TYPE_INTERNATIONAL_UNPAID:_this2.internationalCount++;obit.showReadMore=true;obit.readMoreText='Read Funeral Notice';break;case _constants.OBIT_TYPE_INTERNATIONAL_PAID:_this2.internationalCount++;obit.showReadMore=true;obit.readMoreText='Read Notice';break;default:obit.showReadMore=false;obit.readMoreText='Read More';}return obit;});}/**
   * Gets the correct header text
   * @param  {number} sourceCount         the total number of sources
   * @param  {number} memoriamCount       the number of memoriams
   * @param  {number} internationalCount  the number of international notices
   * @param  {boolean} personPageType    the type of person page
   * @return {object} returns the header text for obits and sources
   */},{key:'getHeaderText',value:function getHeaderText(sourceCount,memoriamCount,internationalCount,personPageType){var useSingluar=sourceCount<2;var isPartnerPageType=(0,_personPageType.isFuneralHomePageType)(personPageType);var isBatesville=(0,_personPageType.isBatesvillePageType)(personPageType);var text={obituary:useSingluar?'Obituary':'Obituaries',sourceGroup:isPartnerPageType?'Other Sources':'Read Full Obituary'};var display={international:{obituary:useSingluar?'Notice':'Notices',sourceGroup:isPartnerPageType?'Other Sources':'Read Full Notice'},memoriam:{obituary:useSingluar?'Memoriam':'Memoriams',sourceGroup:isPartnerPageType?'Other Sources':'Read Full Memoriam'}};if(isBatesville){text.sourceGroup='Printed Obituaries';display.international.sourceGroup='Printed Notices';display.memoriam.sourceGroup='Printed Memoriams';}if(sourceCount>0){if(sourceCount===memoriamCount){text=display.memoriam;}else if(sourceCount===internationalCount){text=display.international;}}return text;}/**
   * React Component render.
   * @return {JSX} Obituary rendered.
   */},{key:'render',value:function render(){var _props=this.props,hasPrimaryObit=_props.hasPrimaryObit,flowerClickEvents=_props.flowerClickEvents,flowersLink=_props.flowersLink,funeralHomeAttribution=_props.funeralHomeAttribution,primaryDisplayTextObit=_props.primaryDisplayTextObit,firstName=_props.firstName,parentLayout=_props.parentLayout,personPageType=_props.personPageType,showReadMore=_props.showReadMore,showFlowers=_props.showFlowers;var _getLayoutInfo=this.getLayoutInfo(parentLayout),isRightColumn=_getLayoutInfo.isRightColumn,isSingleColumn=_getLayoutInfo.isSingleColumn;var hasCollapsableText=(isSingleColumn||isRightColumn)&&_lodash2.default.size(this.fullText)>_lodash2.default.size(this.teaserText);var showFlowersLink=!isRightColumn&&!isSingleColumn&&_lodash2.default.isFunction(flowerClickEvents)&&flowersLink&&showFlowers;return hasPrimaryObit?_react2.default.createElement('section',{className:(0,_classnames2.default)(_Obituary2.default.Obituary,_Obituary2.default[isRightColumn])},_react2.default.createElement('div',{className:_Obituary2.default.header},_react2.default.createElement('h2',null,this.headerText.obituary),showFlowersLink?_react2.default.createElement('a',{className:_Obituary2.default.flowersLink,'data-ga-no-auto-tag':true,href:flowersLink,onClick:flowerClickEvents,target:'_blank'},_react2.default.createElement('span',null,_react2.default.createElement(_Svgs.FlowerIcon,null)),'Send Flowers'):null),_react2.default.createElement('div',{className:_Obituary2.default.columns},(0,_personPageType.isForestLawnPageType)(personPageType)&&funeralHomeAttribution&&!isRightColumn?_react2.default.createElement('div',{className:_Obituary2.default.columnLeft},_react2.default.createElement('h2',null,funeralHomeAttribution,' Obituary')):null,isRightColumn&&!isSingleColumn?_react2.default.createElement('div',{className:_Obituary2.default.columnRight},_react2.default.createElement('h2',null,firstName?firstName+'\'s ':'',this.headerText.obituary)):null),(0,_personPageType.isBatesvillePageType)(personPageType)||showReadMore?_react2.default.createElement('div',{className:_Obituary2.default.container},_react2.default.createElement('p',{dangerouslySetInnerHTML:{__html:this.teaserText}}),_react2.default.createElement('a',{className:_Obituary2.default.readMoreButton,'data-ga-no-auto-tag':'true',href:primaryDisplayTextObit.href,onClick:(0,_GAHelpers.gaClickHandler)('bypage_person','readmore_nearobittextbutton_click',primaryDisplayTextObit),target:'_blank'},'Read More')):_react2.default.createElement('div',{className:_Obituary2.default.container},hasCollapsableText?_react2.default.createElement('div',null,_react2.default.createElement(_library.Collapse,{baseHeight:120,'in':this.state.isExpanded},_react2.default.createElement('div',{'aria-hidden':!this.state.isExpanded},_react2.default.createElement('p',{dangerouslySetInnerHTML:{__html:this.fullText}}))),_react2.default.createElement('div',{className:_Obituary2.default.showMore,onClick:this.toggleObitText},this.state.isExpanded?'Show Less':'Show More',' \u203A')):_react2.default.createElement('p',{dangerouslySetInnerHTML:{__html:this.fullText}})),this.sourceCount===0?null:_react2.default.createElement(_SourceGroup2.default,{isLegacySourced:this.isLegacySourced,isSingleTributesUnpaid:this.isSingleTributesUnpaid,position:isRightColumn||'',renderedObits:this.renderedObits,sourceHeaderText:this.headerText.sourceGroup})):null;}}]);return Obituary;}(_react2.default.Component);Obituary.propTypes={firstName:_react2.default.PropTypes.string,flowerClickEvents:_react2.default.PropTypes.func,flowersLink:_react2.default.PropTypes.string,funeralHomeAttribution:_react2.default.PropTypes.string,hasPrimaryObit:_react2.default.PropTypes.bool,parentLayout:_react2.default.PropTypes.object,personPageType:_react2.default.PropTypes.string,primaryDisplayTextObit:_react2.default.PropTypes.object,primaryFuneralHome:_react2.default.PropTypes.object,showFlowers:_react2.default.PropTypes.bool,showReadMore:_react2.default.PropTypes.bool,sourceGroup:_react2.default.PropTypes.array,textToDisplay:_react2.default.PropTypes.object};exports.default=Obituary;

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","Obituary":"Obituary","header":"header","flowersLink":"flowersLink","columns":"columns","columnLeft":"columnLeft","columnRight":"columnRight","container":"container","teaserText":"teaserText","showMore":"showMore","readMoreButton":"readMoreButton","ObituaryRight":"ObituaryRight","column":"column","sourceGroup":"sourceGroup"};

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.filterObits=filterObits;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _SourceGroup=__webpack_require__(625);var _SourceGroup2=_interopRequireDefault(_SourceGroup);var _SourceItem=__webpack_require__(1666);var _SourceItem2=_interopRequireDefault(_SourceItem);var _GAHelpers=__webpack_require__(22);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _constants=__webpack_require__(41);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Remove  tributes unpaid because at this point we have other obits
 * @param  {Array} obits List of obituaries to be rendered
 * @return {Array} A filtered list of obituaries
 */function filterObits(obits){return _lodash2.default.filter(obits,function(obit){return obit.obituaryType!==_constants.OBIT_TYPE_TRIBUTES_UNPAID&&obit.obituaryType!==_constants.OBIT_TYPE_LEGACY&&_lodash2.default.get(obit,'affiliate.active')==='Active';});}/**
 * The services section of the services group on the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns the services group
 */var SourceGroup=function SourceGroup(props){var isLegacySourced=props.isLegacySourced,isSingleTributesUnpaid=props.isSingleTributesUnpaid,position=props.position,renderedObits=props.renderedObits,sourceHeaderText=props.sourceHeaderText;var filteredObits=filterObits(renderedObits);return!isLegacySourced&&_lodash2.default.size(filteredObits)!==0||isSingleTributesUnpaid?_react2.default.createElement('aside',{className:(0,_classnames2.default)(_SourceGroup2.default.SourceGroup,_SourceGroup2.default[position])},_react2.default.createElement('section',null,isSingleTributesUnpaid?_react2.default.createElement('a',{className:_SourceGroup2.default.readFullLink,'data-ga-no-auto-tag':'true',href:_lodash2.default.get(renderedObits,'[0].href'),onClick:(0,_GAHelpers.gaClickHandler)('bypage_person','readmore_fullobitsigngblink_click',_lodash2.default.head(renderedObits))},_react2.default.createElement('h2',null,sourceHeaderText,' \u203A')):_react2.default.createElement('div',{className:_SourceGroup2.default.sourceWrapper},_react2.default.createElement('h2',null,sourceHeaderText),_react2.default.createElement('div',null,filteredObits.map(function(obit,key){return _react2.default.createElement('div',{className:_SourceGroup2.default.sourceItem,key:key},_react2.default.createElement(_SourceItem2.default,{obit:obit}));}))))):null;};SourceGroup.propTypes={isLegacySourced:_react2.default.PropTypes.bool,isSingleTributesUnpaid:_react2.default.PropTypes.bool,position:_react2.default.PropTypes.string,renderedObits:_react2.default.PropTypes.array,sourceHeaderText:_react2.default.PropTypes.string};exports.default=SourceGroup;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getFontSize=getFontSize;exports.getLogoUrl=getLogoUrl;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _SourceGroup=__webpack_require__(625);var _SourceGroup2=_interopRequireDefault(_SourceGroup);var _GAHelpers=__webpack_require__(22);var _urlHelpers=__webpack_require__(28);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conf=(0,_AppConfig2.default)();/**
 * Determines font size based on description length
 * @method getFontSize
 * @param  {String} description The affilate or funeral home name
 * @return {String} The font size for the description display.
 */function getFontSize(description){var sizes=[{minChars:70,fontSize:'0.875rem'},{minChars:60,fontSize:'1rem'},{minChars:40,fontSize:'1.125rem'},{minChars:25,fontSize:'1.375rem'},{minChars:0,fontSize:'1.5rem'}];return _lodash2.default.find(sizes,function(size){return _lodash2.default.size(description)>=size.minChars;}).fontSize;}/**
 * Attempts to get either the affiliate or funeral home logos
 * @method getLogoUrl
 * @param  {String}         affiliateLogo   The full url for the affiliate logo
 * @param  {String}         funeralHomeLogo The URI for the funeral home logo
 * @param  {Number|Boolean} showFuneralHome Funeral home sourceId if truthy otherwise false
 * @return {String}         The fully formed logo url
 */function getLogoUrl(affiliateLogo,funeralHomeLogo,showFuneralHome){// this is a known bad image in UDB
var funeralHome=!funeralHomeLogo||funeralHomeLogo==='/legacy/images/fhlogo/logo.gif'?null:''+(0,_urlHelpers.buildUrl)(conf.environmentalUrl.cacheUrl,funeralHomeLogo);var display={funeralHome:funeralHome,affiliate:affiliateLogo||null};return display[showFuneralHome?'funeralHome':'affiliate'];}/**
 * The services section of the services group on the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns the services group
 */var SourceItem=function SourceItem(props){var obit=props.obit;var _ref=obit||{},affiliate=_ref.affiliate,funeralHome=_ref.funeralHome,funeralHomeId=_ref.funeralHomeId,href=_ref.href,readMoreText=_ref.readMoreText,showReadMore=_ref.showReadMore;var showFuneralHome=funeralHomeId>1&&_lodash2.default.get(funeralHome,'sourceId');var description=showFuneralHome?_lodash2.default.get(funeralHome,'name'):_lodash2.default.get(affiliate,'description');var readMore=readMoreText||'Read More';var logo=getLogoUrl(_lodash2.default.get(affiliate,'logo'),_lodash2.default.get(funeralHome,'logo'),showFuneralHome);return _lodash2.default.isEmpty(obit)?null:_react2.default.createElement('div',null,_react2.default.createElement('a',{href:href,target:'_blank'},_react2.default.createElement('div',{className:_SourceGroup2.default.imageHolder,'data-ga-no-auto-tag':'true',onClick:(0,_GAHelpers.gaClickHandler)('bypage_person','readmore_logoimage_click',obit)},logo?_react2.default.createElement('img',{src:logo}):_react2.default.createElement('span',{style:{fontSize:getFontSize(description)}},description)),_react2.default.createElement('p',{'data-ga-no-auto-tag':'true',onClick:(0,_GAHelpers.gaClickHandler)('bypage_person','readmore_logotext_click',obit)},logo&&!showReadMore?_react2.default.createElement('span',null,description):_react2.default.createElement('span',{className:_SourceGroup2.default.noWrap},readMore,' \u203A'))));};SourceItem.propTypes={obit:_react2.default.PropTypes.object};exports.default=SourceItem;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.MainService=undefined;var _slicedToArray2=__webpack_require__(614);var _slicedToArray3=_interopRequireDefault(_slicedToArray2);var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _MainService=__webpack_require__(1668);var _MainService2=_interopRequireDefault(_MainService);var _formatHelpers=__webpack_require__(55);var _personPageType=__webpack_require__(67);var _urlHelpers=__webpack_require__(28);var _imageChecker=__webpack_require__(615);var _imageChecker2=_interopRequireDefault(_imageChecker);var _Svgs=__webpack_require__(36);var _componentHelpers=__webpack_require__(26);var _AppConfig=__webpack_require__(20);var _AppConfig2=_interopRequireDefault(_AppConfig);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conf=(0,_AppConfig2.default)();/**
 *  MainServices Module
 * @class   MainService
 */var MainService=exports.MainService=function(_React$Component){(0,_inherits3.default)(MainService,_React$Component);/**
   * Constructor
   * @param  {Object}     props props object
   * @return {Undefined}  Returns nothing
   */function MainService(props){(0,_classCallCheck3.default)(this,MainService);var _this=(0,_possibleConstructorReturn3.default)(this,(MainService.__proto__||(0,_getPrototypeOf2.default)(MainService)).call(this,props));var _this$props$serviceGr=_this.props.serviceGroup;_this$props$serviceGr=_this$props$serviceGr===undefined?{}:_this$props$serviceGr;var funeralHomes=_this$props$serviceGr.funeralHomes;var _ref=funeralHomes||[],_ref2=(0,_slicedToArray3.default)(_ref,1),_ref2$=_ref2[0],primaryFuneralHome=_ref2$===undefined?{}:_ref2$;var funeralHomeLogo=primaryFuneralHome.logo;if(funeralHomeLogo){_this.funeralHomeLogo=funeralHomeLogo==='/legacy/images/fhlogo/logo.gif'?null:''+(0,_urlHelpers.buildUrl)(conf.environmentalUrl.cacheUrl,funeralHomeLogo);}_this.state={image:_this.funeralHomeLogo};(0,_componentHelpers.bindMethods)(_this,['handleWindowLoad']);return _this;}/**
   * Lifecycle
   * @returns {Undefined} Returns nothing
   */(0,_createClass3.default)(MainService,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('load',this.handleWindowLoad);}/**
   * Lifecycle
   * @returns {Undefined} Returns nothing
   */},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('load',this.handleWindowLoad);}/**
   * Handles when window is loaded and fires a check on the logo image
   * @return {Undefined} Returns nothing
   */},{key:'handleWindowLoad',value:function handleWindowLoad(){if(this.funeralHomeLogo){if(!(0,_imageChecker2.default)(this.funeralHomeLogo)){this.funeralHomeLogo=null;this.setState({image:false});}}}/**
   * Renders Component
   * @return {JSX} Rendered PersonHero Component
   */},{key:'render',value:function render(){var _props=this.props,flowerClickEvents=_props.flowerClickEvents,flowersLink=_props.flowersLink,personPageType=_props.personPageType,serviceGroup=_props.serviceGroup,showFlowers=_props.showFlowers;var _ref3=serviceGroup||{},church=_ref3.church,funeralHomes=_ref3.funeralHomes;var _ref4=funeralHomes||[],_ref5=(0,_slicedToArray3.default)(_ref4,1),primaryFuneralHome=_ref5[0];var funeralHomePhone=primaryFuneralHome&&primaryFuneralHome.premiumSubscriber&&!_lodash2.default.isEmpty(_lodash2.default.trim(primaryFuneralHome.phone))?(0,_formatHelpers.formatPhoneNumber)(primaryFuneralHome.phone):null;var dataSet=primaryFuneralHome||church;var address=_lodash2.default.pick(dataSet,['address','address1','address2','city','country','postalCode','state']);address.city=(0,_formatHelpers.formatPhrase)(address.city);address=(0,_formatHelpers.formatAddress)(address);var googleAddressLink=(0,_urlHelpers.getMapUrl)(address);var link=_lodash2.default.get(dataSet,'directoryUrl')||googleAddressLink;return _lodash2.default.isEmpty(dataSet)?null:_react2.default.createElement('aside',{className:_MainService2.default.MainService},(0,_personPageType.isFuneralHomePageType)(personPageType)&&this.funeralHomeLogo?_react2.default.createElement('div',null,_react2.default.createElement('a',{className:_MainService2.default.sourceLogo,href:link,target:'_blank'},_react2.default.createElement('figure',null,_react2.default.createElement('img',{alt:'Funeral Home Logo',src:this.funeralHomeLogo})))):null,_react2.default.createElement('a',{className:_MainService2.default.sourceName,href:link,target:'_blank'},_lodash2.default.get(dataSet,'name','')),_react2.default.createElement('a',{className:_MainService2.default.sourceAddress,href:googleAddressLink,target:'_blank'},address),funeralHomePhone?_react2.default.createElement('a',{className:_MainService2.default.sourcePhone,href:'tel:'+funeralHomePhone.replace(/[()\- ]/g,'')},funeralHomePhone):null,flowersLink&&showFlowers?_react2.default.createElement('a',{className:_MainService2.default.flowersLink,'data-ga-no-auto-tag':true,href:flowersLink,onClick:flowerClickEvents,target:'_blank'},_react2.default.createElement('span',null,_react2.default.createElement(_Svgs.FlowerIcon,null)),'Send Flowers \u203A'):null,primaryFuneralHome&&primaryFuneralHome.premiumSubscriber&&primaryFuneralHome.directoryUrl?_react2.default.createElement('div',{className:_MainService2.default.prePlanningPanel},_react2.default.createElement('a',{className:_MainService2.default.sourcePhone,style:{fontWeight:'600'},href:link},'Learn about funeral pre-planning \u203A')):null);}}]);return MainService;}(_react2.default.Component);MainService.propTypes={flowerClickEvents:_react2.default.PropTypes.func,flowersLink:_react2.default.PropTypes.string,personPageType:_react2.default.PropTypes.string,serviceGroup:_react2.default.PropTypes.object,showFlowers:_react2.default.PropTypes.bool};exports.default=MainService;

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","MainService":"MainService","sourceLogo":"sourceLogo","sourceName":"sourceName","sourceAddress":"sourceAddress","sourcePhone":"sourcePhone","flowersLink":"flowersLink","prePlanningPanel":"prePlanningPanel"};

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _ServiceInfo=__webpack_require__(1670);var _ServiceInfo2=_interopRequireDefault(_ServiceInfo);var _formatHelpers=__webpack_require__(55);var _urlHelpers=__webpack_require__(28);var _moment=__webpack_require__(97);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * The MainServices item on the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns a church
 */var ServiceInfo=function ServiceInfo(props){var services=props.serviceGroup.services;return _lodash2.default.isEmpty(services)?null:_react2.default.createElement('aside',{className:_ServiceInfo2.default.ServiceInfo},_react2.default.createElement('h2',{className:_ServiceInfo2.default.header},'Service Information'),_react2.default.createElement('div',{className:_ServiceInfo2.default.itemGroup},services.map(function(originalService,index){var service=_lodash2.default.pick(originalService,['city','address','postalCode','state','isPrivate','isTBD','serviceType','location','startTime','dateUTC','dateTimeDescription']);var isDateFallback=_lodash2.default.isEmpty(service.startTime);var serviceDate=service[isDateFallback?'dateUTC':'startTime'];var date=_moment2.default.utc(serviceDate);var time=date.format('h:mm A');var month=date.format('MMM').toUpperCase();var day=date.format('DD');var year=date.format('YYYY');service.city=(0,_formatHelpers.formatPhrase)(service.city);var itemAddress=(0,_formatHelpers.formatAddress)(service);var hideAddress=_lodash2.default.get(service,'isPrivate',false)||_lodash2.default.get(service,'isTBD',false);return _react2.default.createElement('div',{className:_ServiceInfo2.default.item,key:index},date.isValid()&&year>1900?_react2.default.createElement('div',{className:_ServiceInfo2.default.ServiceLeft},_react2.default.createElement('div',{className:_ServiceInfo2.default.calendar},_react2.default.createElement('div',{className:_ServiceInfo2.default.top},_react2.default.createElement('p',{className:_ServiceInfo2.default.year},year)),_react2.default.createElement('div',{className:_ServiceInfo2.default.bottom},_react2.default.createElement('div',{className:_ServiceInfo2.default.date},_react2.default.createElement('p',{className:_ServiceInfo2.default.month},month),_react2.default.createElement('p',{className:_ServiceInfo2.default.day},day))))):null,_react2.default.createElement('div',{className:_ServiceInfo2.default.ServiceRight},date.isValid()&&!isDateFallback?_react2.default.createElement('p',{className:_ServiceInfo2.default.time},time):null,service.serviceType?_react2.default.createElement('p',{className:_ServiceInfo2.default.type},service.serviceType):null,service.location?_react2.default.createElement('p',{className:_ServiceInfo2.default.location},(0,_formatHelpers.formatPhrase)(service.location)):null,hideAddress?null:_react2.default.createElement('a',{className:_ServiceInfo2.default.address,href:(0,_urlHelpers.getMapUrl)(itemAddress),target:'_blank'},itemAddress),(!date.isValid()||isDateFallback)&&service.dateTimeDescription?_react2.default.createElement('p',{className:_ServiceInfo2.default.description},(0,_formatHelpers.formatPhrase)(service.dateTimeDescription)):null));})));};ServiceInfo.propTypes={serviceGroup:_react2.default.PropTypes.object};exports.default=ServiceInfo;

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","ServiceInfo":"ServiceInfo","header":"header","itemGroup":"itemGroup","item":"item","ServiceLeft":"ServiceLeft","calendar":"calendar","top":"top","year":"year","bottom":"bottom","date":"date","month":"month","day":"day","ServiceRight":"ServiceRight","time":"time","type":"type","location":"location","description":"description","address":"address"};

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _ResourcesBlock=__webpack_require__(1672);var _ResourcesBlock2=_interopRequireDefault(_ResourcesBlock);var _Svgs=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * The ResourcesBlock item on the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns a block of resource links
 *//* eslint-disable global-require */var ResourcesBlock=function ResourcesBlock(props){return _lodash2.default.isEmpty(props.resources)?null:_react2.default.createElement('aside',{className:_ResourcesBlock2.default.ResourcesBlock},_react2.default.createElement('h2',{className:_ResourcesBlock2.default.header},props.title),_react2.default.createElement('div',{className:_ResourcesBlock2.default.itemGroup},props.resources.map(function(resource,index){var img=__webpack_require__(1673)("./"+resource.asset);return _react2.default.createElement('div',{className:_ResourcesBlock2.default.item,key:index},_react2.default.createElement('a',{href:resource.url,target:resource.target},_react2.default.createElement('div',{className:_ResourcesBlock2.default.ResourceLeft},_react2.default.createElement('img',{src:img})),_react2.default.createElement('div',{className:_ResourcesBlock2.default.ResourceRight},_react2.default.createElement('p',{className:_ResourcesBlock2.default.text},resource.text)),_react2.default.createElement('div',{className:_ResourcesBlock2.default.icon},_react2.default.createElement(_Svgs.RightFollowLink,null))));})));};ResourcesBlock.propTypes={resources:_react2.default.PropTypes.array,title:_react2.default.PropTypes.string};exports.default=ResourcesBlock;

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","ResourcesBlock":"ResourcesBlock","header":"header","itemGroup":"itemGroup","item":"item","ResourceLeft":"ResourceLeft","ResourceRight":"ResourceRight","text":"text","icon":"icon"};

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./etiquette.png": 1674,
	"./flgrief.jpg": 1675,
	"./fllocations.jpg": 1676,
	"./flplanning.jpg": 1677,
	"./grief.png": 1678,
	"./obitwriter.png": 1679,
	"./planning.png": 1680
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1673;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/etiquette.e2a9f1c4.png";

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/flgrief.cdafe13f.jpg";

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/fllocations.e87d5553.jpg";

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/flplanning.85a73d2e.jpg";

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/grief.98e34f51.png";

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/obitwriter.dc7e1a83.png";

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/planning.6228f181.png";

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(59);var _reactDom2=_interopRequireDefault(_reactDom);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _GalleryTeaser=__webpack_require__(1682);var _GalleryTeaser2=_interopRequireDefault(_GalleryTeaser);var _Svgs=__webpack_require__(36);var _GAHelpers=__webpack_require__(22);var _componentHelpers=__webpack_require__(26);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var GalleryTeaser=function(_React$Component){(0,_inherits3.default)(GalleryTeaser,_React$Component);function GalleryTeaser(props){(0,_classCallCheck3.default)(this,GalleryTeaser);var _this=(0,_possibleConstructorReturn3.default)(this,(GalleryTeaser.__proto__||(0,_getPrototypeOf2.default)(GalleryTeaser)).call(this,props));_this.state={imageStyles:{height:'auto'}};_this.imgContainer=null;_this.setRefImgContainer=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'imgContainer',_this);(0,_componentHelpers.bindMethods)(_this,['handleResize']);return _this;}(0,_createClass3.default)(GalleryTeaser,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.handleResize);this.handleResize();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);}/**
   * Returns image src
   * @param  {object} item            item object
   * @param  {Boolean} isSingleColumn effects size of image
   * @return {string}                 path to image
   */},{key:'getImageSource',value:function getImageSource(item,isSingleColumn){if(_lodash2.default.get(item,'photo')){var size=isSingleColumn?'150':'97';return item.photo+'x?w='+size+'&h='+size;}if(_lodash2.default.get(item,'video')){return'https://cdn-thumbs.viddler.com/thumbnail_2_'+item.video+'_v1.jpg';}if(_lodash2.default.get(item,'assetsThumbnail')){return __webpack_require__(1683)("./"+item.assetsThumbnail);}return null;}/**
   * Click handler to post condolence/media
   * @param  {function} handler handler function
   * @return {undefined}        returns nothing
   */},{key:'handleEntryClick',value:function handleEntryClick(handler){(0,_GAHelpers.getGATags)({eventCategory:'bypage_person',eventAction:'sign_guest_book_media',eventLabel:'onpage'});handler();}/**
   * resize handler
   * @return {Undefined} returns nothing
   */},{key:'handleResize',value:function handleResize(){var singleColumnHeight=_lodash2.default.get(_reactDom2.default.findDOMNode(this.imgContainer),'clientWidth','auto');var dualColumnHeight=window.innerWidth>=1280?97:73;var newHeight=this.props.isSingleColumn?singleColumnHeight:dualColumnHeight;if(this.state.imageStyles.height!==newHeight){this.setState({imageStyles:{height:newHeight}});}}/**
   * GalleryTeaser JSX
   * @param {object} props default props object
   * @return {JSX}         rendered component
   */},{key:'render',value:function render(){var _this2=this;var _props=this.props,allowGallery=_props.allowGallery,isSingleColumn=_props.isSingleColumn,items=_props.items,openCondolenceEntry=_props.openCondolenceEntry,showGalleryHandler=_props.showGalleryHandler;var outsideMediaCount=_lodash2.default.reduce(items.slice(0,3),function(total,item){return total+(_lodash2.default.get(item,'node.isNonCondolenceMedia',false)?1:0);},0);var count=this.props.count+outsideMediaCount;var filteredItems=_lodash2.default.map(items,function(item){return{assetsThumbnail:_lodash2.default.get(item,'node.video.assetsThumbnail'),id:_lodash2.default.get(item,'node.id'),photo:_lodash2.default.get(item,'node.photo.url'),video:_lodash2.default.get(item,'node.video.id')};});var countOffset=filteredItems.length>=8?count-filteredItems.length+outsideMediaCount:0;var isSuppressed=isSingleColumn&&filteredItems.length===0;return _lodash2.default.isFunction(openCondolenceEntry)&&_lodash2.default.isFunction(showGalleryHandler)&&allowGallery&&!isSuppressed?_react2.default.createElement('aside',{className:_GalleryTeaser2.default.GalleryTeaser},_react2.default.createElement('div',{className:_GalleryTeaser2.default.header},_react2.default.createElement('h2',null,'Gallery'),_lodash2.default.size(filteredItems)===0?null:_react2.default.createElement('div',{className:_GalleryTeaser2.default.cta,onClick:_lodash2.default.partial(this.handleEntryClick,openCondolenceEntry)},'Add a Photo or Video')),_react2.default.createElement('div',{className:_GalleryTeaser2.default.group},_lodash2.default.size(filteredItems)===0?_react2.default.createElement('div',{className:_GalleryTeaser2.default.empty,onClick:_lodash2.default.partial(this.handleEntryClick,openCondolenceEntry)},_react2.default.createElement('div',{className:_GalleryTeaser2.default.TeaserLeft},_react2.default.createElement(_Svgs.GalleryIcon,null)),_react2.default.createElement('div',{className:_GalleryTeaser2.default.TeaserRight},_react2.default.createElement('p',null,_react2.default.createElement(_Svgs.GalleryAddIcon,null),' Add a Photo or Video'))):filteredItems.map(function(item,index){return _react2.default.createElement('figure',{key:index,onClick:_lodash2.default.partial(showGalleryHandler,index),ref:_this2.setRefImgContainer,style:_this2.state.imageStyles},_react2.default.createElement('img',{src:_this2.getImageSource(item,isSingleColumn)}),index===filteredItems.length-1&&countOffset>=1?_react2.default.createElement('figcaption',null,_react2.default.createElement('p',null,'+'+countOffset)):null);}))):null;}}]);return GalleryTeaser;}(_react2.default.Component);/* eslint-disable global-require */GalleryTeaser.propTypes={allowGallery:_react2.default.PropTypes.bool,count:_react2.default.PropTypes.number,isSingleColumn:_react2.default.PropTypes.bool,items:_react2.default.PropTypes.array,openCondolenceEntry:_react2.default.PropTypes.func,showGalleryHandler:_react2.default.PropTypes.func};GalleryTeaser.defaultProps={items:[]};exports.default=GalleryTeaser;

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","GalleryTeaser":"GalleryTeaser","header":"header","cta":"cta","group":"group","empty":"empty","TeaserLeft":"TeaserLeft","TeaserRight":"TeaserRight"};

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./service_video_tn.jpg": 1684,
	"./tribute_video_tn.jpg": 1685
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1683;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/service_video_tn.584765c9.jpg";

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tribute_video_tn.a67a446b.jpg";

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _FlowersCta=__webpack_require__(1687);var _FlowersCta2=_interopRequireDefault(_FlowersCta);var _personPageType=__webpack_require__(67);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * click handler
 * @param  {string} link            flowers url
 * @param  {Function} trackingFunc  tracking function callback
 * @return {undefined}              returns nothing
 *//* eslint-disable global-require */function handleClick(link,trackingFunc){window.open(link,'_blank');if(_lodash2.default.isFunction(trackingFunc)){trackingFunc();}}var FlowersCta=function FlowersCta(props){var flowerClickEvents=props.flowerClickEvents,flowersLink=props.flowersLink,personPageType=props.personPageType,showFlowers=props.showFlowers;var img=__webpack_require__(1688)("./"+(0,_personPageType.getPageTypeFlowersCtaImage)(personPageType));return flowersLink&&showFlowers?_react2.default.createElement('aside',{className:_FlowersCta2.default.FlowersCta,onClick:_lodash2.default.partial(handleClick,flowersLink,flowerClickEvents)},_react2.default.createElement('h2',null,'Show Your Sympathy'),_react2.default.createElement('img',{src:img}),_react2.default.createElement('div',{className:_FlowersCta2.default.link},_react2.default.createElement('p',null,'Send Flowers'))):null;};FlowersCta.propTypes={flowerClickEvents:_react2.default.PropTypes.func,flowersLink:_react2.default.PropTypes.string,personPageType:_react2.default.PropTypes.string,showFlowers:_react2.default.PropTypes.bool};exports.default=FlowersCta;

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","FlowersCta":"FlowersCta","link":"link"};

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./flowers.png": 1689,
	"./forestlawn-flowers.png": 1690
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1688;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/flowers.1041b15f.png";

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/forestlawn-flowers.bf476d68.png";

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Questionnaire=undefined;var _getPrototypeOf=__webpack_require__(2);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(3);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(5);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(6);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(12);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _moment=__webpack_require__(97);var _moment2=_interopRequireDefault(_moment);var _Questionnaire=__webpack_require__(1692);var _Questionnaire2=_interopRequireDefault(_Questionnaire);var _library=__webpack_require__(40);var _formatHelpers=__webpack_require__(55);var _Svgs=__webpack_require__(36);var _componentHelpers=__webpack_require__(26);var _GAHelpers=__webpack_require__(22);var _ugcHelper=__webpack_require__(1693);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _questions=__webpack_require__(1694);var _questions2=_interopRequireDefault(_questions);var _localStorage=__webpack_require__(622);var _localStorage2=_interopRequireDefault(_localStorage);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Button=_library.FormControls.Button,TextInput=_library.FormControls.TextInput;var Questionnaire=exports.Questionnaire=function(_React$Component){(0,_inherits3.default)(Questionnaire,_React$Component);function Questionnaire(props){(0,_classCallCheck3.default)(this,Questionnaire);var _this=(0,_possibleConstructorReturn3.default)(this,(Questionnaire.__proto__||(0,_getPrototypeOf2.default)(Questionnaire)).call(this,props));var person=_lodash2.default.get(props,'personStore.person')||{};var _ref=person.locationDisplay||{},city=_ref.city,state=_ref.state;_this.personId=person.personId;_this.obituaryId=_lodash2.default.get(person,'obitSources.displayText');_this.defaultQuestionId='ugc_did_you_know';_this.currentQuestionId=_this.defaultQuestionId;_this.currentIndex=0;_this.location=_lodash2.default.compact([city,state]).join(', ');_this.name=(0,_formatHelpers.getName)(person.name);_this.cityState='State';_this.questions=(0,_questions2.default)();_this.options=null;_this.state={currentQuestion:_this.getQuestion(),currentStep:0,dayField:'',entryField:'',monthField:'',totalSteps:0,isClosed:false,isFetching:false,isPendingFetch:false,isSubmitDisabled:true,searchStringSuggestion:'',showSuggestion:false,showThankYou:false,showToolTip:false,yearField:''};_this.questionType=_this.state.currentQuestion.type;_this.thankYouWaitTime=3000;_this.locations={city:{id:null,name:null},state:{id:null,name:null,code:null}};_this.isClient=typeof window!=='undefined';_this.isDisabled=_this.isClient?_this.getLocalStorage():false;_this.entryField=null;_this.setRefEntryField=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'entryField',_this);_this.dayField=null;_this.setRefDayField=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'dayField',_this);_this.monthField=null;_this.setRefMonthField=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'monthField',_this);_this.yearField=null;_this.setRefYearField=_lodash2.default.partial(_componentHelpers.setRef,_lodash2.default,'yearField',_this);(0,_componentHelpers.bindMethods)(_this,['checkQuestionType','doCloseModule','fetchSearchResults','getComponentStyles','getQuestion','getTemplatizedQuestionString','handleClick','handleInputChange','handleKeyDown','handleKeyUp','handleShowTooltip','handleSuggestionClick','showNextQuestion','showThankYou','submit','updateSearchResults']);return _this;}(0,_createClass3.default)(Questionnaire,[{key:'componentDidMount',value:function componentDidMount(){if(_lodash2.default.get(this.props,'personStore.person.clearStorage')){this.setLocalStorage(true);this.isDisabled=true;}window.addEventListener('keydown',this.handleKeyDown);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var result=_lodash2.default.get(nextProps,'personStore.locationSearch');this.updateSearchResults(result);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keydown',this.handleKeyDown);}/**
   * updates search result
   * @param  {object} result  result object from solr
   * @return {undefined}      returns nothing
   */},{key:'updateSearchResults',value:function updateSearchResults(result){var _this2=this;var nextState={isFetching:false};if(_lodash2.default.get(result,'totalResults')){var locations={city:{id:_lodash2.default.get(result,'city.id',''),name:_lodash2.default.get(result,'city.name','')},state:{id:_lodash2.default.get(result,'state.id',''),name:_lodash2.default.get(result,'state.name',''),code:_lodash2.default.get(result,'state.code','')}};nextState.searchStringSuggestion=this.getSearchStringSuggestion(locations,this.cityState==='State');var latestSuggestion=nextState.searchStringSuggestion.toLowerCase();var latestValue=this.state.entryField.toLowerCase();nextState.showSuggestion=latestSuggestion.indexOf(latestValue)!==-1&&latestValue!=='';this.locations=locations;}if(this.state.isPendingFetch){nextState.isPendingFetch=false;this.setState(nextState,function(){_this2.fetchSearchResults();});}else{this.setState(nextState);}}/**
   * formats suggestion
   * @param  {object} locations   locations object
   * @param  {Boolean} stateOnly  city vs state flag
   * @return {string}             formatted suggestion
   */},{key:'getSearchStringSuggestion',value:function getSearchStringSuggestion(locations,stateOnly){var isCity=!stateOnly;var locationString=[];var city=locations.city,state=locations.state;var cityName=city.name;var stateName=state.name;var hasSuggestion=true;if(cityName&&!stateOnly){locationString.push(cityName);locationString.push(', ');}if(isCity&&!cityName){hasSuggestion=false;}locationString.push(stateName);return hasSuggestion?locationString.join(''):'';}/**
   * closes module
   * @return {undefined} returns nothing
   */},{key:'doCloseModule',value:function doCloseModule(){this.setState({isClosed:true});}/**
   * shows thank you screen
   * @return {undefined} returns nothing
   */},{key:'showThankYou',value:function showThankYou(){this.setState({showThankYou:true});setTimeout(this.doCloseModule,this.thankYouWaitTime);}/**
   * update currentIndex, moving process forward
   * @return {undefined} returns nothing
   */},{key:'showNextQuestion',value:function showNextQuestion(){var _this3=this;var currentQuestion=this.getQuestion();this.questionType=currentQuestion.type;var _checkQuestionType=this.checkQuestionType(),currentStep=_checkQuestionType.currentStep,totalSteps=_checkQuestionType.totalSteps,searchStringSuggestion=_checkQuestionType.searchStringSuggestion,showSuggestion=_checkQuestionType.showSuggestion;this.currentIndex++;this.setState({currentQuestion:currentQuestion,currentStep:currentStep,totalSteps:totalSteps,entryField:'',searchStringSuggestion:searchStringSuggestion||'',showSuggestion:showSuggestion||false},function(){_this3.focusTextField();});}/**
   * focuses input field
   * @return {undefined} returns nothing
   */},{key:'focusTextField',value:function focusTextField(){var fields=[this.entryField,this.dayField,this.yearField,this.monthField];_lodash2.default.map(fields,function(field){if(field){var textArea=_lodash2.default.get(field,'_textInput',{});if(_lodash2.default.isFunction(textArea.focus)){textArea.focus();}}});}/**
   * checks current question for data dependencies
   * @param  {object} question question object
   * @return {object}          describes dependency and fallback info
   */},{key:'checkDependencies',value:function checkDependencies(question){var _this4=this;var dependencies=_lodash2.default.get(question,'dependencies',{});var requirements=_lodash2.default.get(dependencies,'required');var fallback=_lodash2.default.get(dependencies,'fallback');var hasMetDependencies=true;if(requirements){_lodash2.default.map(requirements.split(','),function(req){if(!_this4[req]){hasMetDependencies=false;}});}return{hasMetDependencies:hasMetDependencies,fallback:fallback};}/**
   * sets current question
   * @param  {string} id  question id
   * @return {object}     current question object
   */},{key:'getQuestion',value:function getQuestion(id){var currentQuestion=_lodash2.default.cloneDeep(_lodash2.default.get(this.questions,''+(id?id:this.currentQuestionId)));var _checkDependencies=this.checkDependencies(currentQuestion),hasMetDependencies=_checkDependencies.hasMetDependencies,fallback=_checkDependencies.fallback;if(hasMetDependencies===true){currentQuestion.question=_lodash2.default.template(currentQuestion.question);currentQuestion.options=_lodash2.default.merge(_lodash2.default.cloneDeep(_ugcHelper.OPTIONS_TEMPLATE),currentQuestion.options);this.options=_lodash2.default.sortBy(_lodash2.default.partition(currentQuestion.options,'position')[0],['position']);this.questionType=currentQuestion.type;return currentQuestion;}this.currentQuestionId=fallback;return this.getQuestion();}/**
   * gets fully formatted question for display
   * @param  {object} question question object
   * @return {string}          templatized question string
   */},{key:'getTemplatizedQuestionString',value:function getTemplatizedQuestionString(question){return question({cityState:this.cityState,location:this.location,name:this.name});}/**
   * gets main styles
   * @return {Object} classes based on conditions
   */},{key:'getComponentStyles',value:function getComponentStyles(){var conditionalClasses={};conditionalClasses[_Questionnaire2.default.isClosed]=this.state.isClosed;conditionalClasses[_Questionnaire2.default.isOpen]=!this.state.isClosed;conditionalClasses[_Questionnaire2.default.thankYou]=this.state.showThankYou;return(0,_classnames2.default)(_Questionnaire2.default.Questionnaire,conditionalClasses);}/**
   * hover handler for tooltip
   * @param  {Boolean} val  to show, or not to show
   * @return {undefined}    returns nothing
   */},{key:'handleShowTooltip',value:function handleShowTooltip(val){if(val!==this.state.showToolTip){this.setState({showToolTip:val});}}/**
   * checks for mulit-stage questions. sets step count and suggestions accordingly
   * @param  {string} action user action string
   * @return {object}        object of new/needed state variables
   */},{key:'checkQuestionType',value:function checkQuestionType(action){var typeRules=_ugcHelper.QUESTION_TYPES[this.questionType];var typeSteps=_lodash2.default.size(_lodash2.default.get(typeRules,'group',[]));var newState={};if(typeSteps&&action!=='close'){var _state=this.state,currentStep=_state.currentStep,totalSteps=_state.totalSteps;if(totalSteps===0){newState.totalSteps=typeSteps;newState.currentStep=0;}else if(currentStep<typeSteps-1){newState.totalSteps=totalSteps;newState.currentStep=currentStep+1;}else{newState.totalSteps=0;newState.currentStep=0;}this.cityState=newState.currentStep===0?'State':'City';newState.searchStringSuggestion=this.getSearchStringSuggestion(this.locations,this.cityState==='State');newState.showSuggestion=newState.searchStringSuggestion||false;}return newState;}/**
   * Click Handler
   * @param  {string} action action descriptor
   * @return {undefined}     returns nothing
   */},{key:'handleClick',value:function handleClick(action){var _this5=this;var eventCategory='bypage_person';var eventLabel='ugc_prompt_'+(this.currentIndex+1);var tracking={eventCategory:eventCategory,eventLabel:eventLabel,eventAction:this.currentQuestionId};var value={yes:{action:this.showNextQuestion,tracking:_lodash2.default.merge({eventValue:1},tracking)},no:{action:this.showNextQuestion,tracking:_lodash2.default.merge({eventValue:1},tracking)},skip:{action:this.showNextQuestion,tracking:_lodash2.default.merge({eventValue:0},tracking)},close:{action:this.doCloseModule,tracking:{eventCategory:eventCategory,eventLabel:eventLabel,eventValue:3}}}[action]||null;if(value){var _checkQuestionType2=this.checkQuestionType(action),currentStep=_checkQuestionType2.currentStep,totalSteps=_checkQuestionType2.totalSteps,searchStringSuggestion=_checkQuestionType2.searchStringSuggestion,showSuggestion=_checkQuestionType2.showSuggestion;if((currentStep||totalSteps)&&(action==='yes'||action==='no')){this.setState({currentStep:currentStep,totalSteps:totalSteps,entryField:'',searchStringSuggestion:searchStringSuggestion||'',showSuggestion:showSuggestion||false,isSubmitDisabled:true},function(){_this5.focusTextField();});}else{(0,_GAHelpers.getGATags)(value.tracking);var options=_lodash2.default.get(this.state,'currentQuestion.options');var nextQuestionId=_lodash2.default.get(options,'globalAction')||_lodash2.default.get(options,action+'.action');this.submit(action==='yes');this.setLocalStorage();if(nextQuestionId){this.currentQuestionId=nextQuestionId;this.setState({totalSteps:0,isSubmitDisabled:true,dayField:'',monthField:'',yearField:''},function(){value.action();});}else{this.showThankYou();}}}}/**
   * fetches solr search results
   * @return {undefined} returns nothing
   */},{key:'fetchSearchResults',value:function fetchSearchResults(){var value=this.state.entryField.replace(/[^a-z ]+/gi,'');if(!this.state.isFetching&&value&&value.length>=2){this.props.queryLocationSearch({location:value,stateId:this.cityState==='State'?'':this.locations.state.id});this.setState({isFetching:true});}else{this.setState({isPendingFetch:true});}}/**
   * checks if submit button should be enabled
   * @param  {string} value value of text field
   * @return {Boolean}      enabled value
   */},{key:'checkEnableSubmit',value:function checkEnableSubmit(value){var disabled=true;if(_lodash2.default.isObject(value)){var dayField=value.dayField,monthField=value.monthField,yearField=value.yearField,fields=value.fields;var fieldsComplete=true;if(dayField.length!==fields.dayField.maxChars){fieldsComplete=false;}if(monthField.length!==fields.monthField.maxChars){fieldsComplete=false;}if(yearField.length!==fields.yearField.maxChars){fieldsComplete=false;}disabled=!fieldsComplete;}else{disabled=!(value&&value.length>=2);}return disabled;}/**
   * submit/validate values
   * @param  {Boolean} value boolean value of validation questions
   * @return {undefined} returns nothing
   */},{key:'submit',value:function submit(value){var answerType=this.questionType;var isDefaultQuestion=this.currentQuestionId===this.defaultQuestionId;var answer=null;if(answerType==='location'){var inputValue=this.state.entryField;var cityName=this.locations.city.name;var id=this.locations.city.id;if(inputValue===cityName){answer=id;}}else if(answerType==='validation'&&!isDefaultQuestion){answer=value;}else if(answerType==='date'){var date=new Date(this.state.yearField,parseInt(this.state.monthField,10)-1,this.state.dayField);if(date.getTime()){answer=(0,_moment2.default)(date).format('YYYY-MM-DD');}}if(answer){this.props.mutatePersonUGC({personId:this.personId,obituaryId:_lodash2.default.head(this.obituaryId),characteristicCode:'pp_'+this.currentQuestionId,answerType:answerType,answer:answer});}}/**
   * sets or resets local storage
   * @param   {Boolean} reset true to reset
   * @return  {undefined}     returns nothing
   */},{key:'setLocalStorage',value:function setLocalStorage(reset){if(reset){_localStorage2.default.clear();}else{_localStorage2.default.set(this.personId,true);}}/**
   * gets local storage value
   * @return {Boolean} value
   */},{key:'getLocalStorage',value:function getLocalStorage(){return _localStorage2.default.get(this.personId)||false;}/**
   * input change handler
   * @param  {event} e      onChange event
   * @param  {String} key   id key
   * @return {undefined}    returns nothing
   */},{key:'handleInputChange',value:function handleInputChange(e,key){var _this6=this;var value=e.target.value;var stateObj={};var fields={dayField:{maxChars:2},monthField:{maxChars:2},yearField:{maxChars:4}};var testValue=null;if(key==='entryField'){stateObj[key]=value;testValue=value;if(!value){stateObj.showSuggestion=false;}}else{var numericValue=value.replace(/[^0-9]+/gi,'');var field=fields[key];if(numericValue!==''&&numericValue.length<=field.maxChars||value===''){stateObj[key]=numericValue;testValue={dayField:this.state.dayField,monthField:this.state.monthField,yearField:this.state.yearField,fields:fields};testValue[key]=numericValue;}}stateObj.isSubmitDisabled=this.checkEnableSubmit(testValue);this.setState(stateObj,function(){if(value&&key==='entryField'){_this6.fetchSearchResults();}});}/**
   * input key up handler
   * @param  {event} e    onKeyUp event
   * @return {undefined}  returns nothing
   */},{key:'handleKeyUp',value:function handleKeyUp(e){if(e.keyCode===13&&this.state.showSuggestion&&this.state.entryField){this.handleSuggestionClick();}}/**
   * keyDown handler for local storage reset
   * @param  {event} e    onKeyDown event
   * @return {undefined}  returns nothing
   */},{key:'handleKeyDown',value:function handleKeyDown(e){var altKey=e.altKey,code=e.code,shiftKey=e.shiftKey;if(altKey&&code==='KeyC'&&shiftKey){this.setLocalStorage(true);window.location.reload(true);}}/**
   * click handler for search suggestion
   * @return {undefined} returns nothing
   */},{key:'handleSuggestionClick',value:function handleSuggestionClick(){var _this7=this;var suggestion=this.state.searchStringSuggestion;var entry=this.cityState==='State'?suggestion:this.locations.city.name;this.setState({entryField:entry,showSuggestion:false,isSubmitDisabled:this.checkEnableSubmit(entry)},function(){_this7.focusTextField();});}/**
   * The Questionnaire component on the person page
   * @param   {Object}  props - passed down props
   * @return  {JSX}     Returns a Questionnaire
   */},{key:'render',value:function render(){var _this8=this;var count=this.state.currentStep+1+' of '+this.state.totalSteps;return this.name&&!this.isDisabled?_react2.default.createElement('aside',{className:this.getComponentStyles()},_react2.default.createElement('div',{className:_Questionnaire2.default.topRightLockup},_react2.default.createElement('div',{className:_Questionnaire2.default.infoIcon,onMouseOut:_lodash2.default.partial(this.handleShowTooltip,false),onMouseOver:_lodash2.default.partial(this.handleShowTooltip,true)},_react2.default.createElement('div',{className:_Questionnaire2.default.toolTip,style:{opacity:this.state.showToolTip?1:0}},_react2.default.createElement('div',{className:_Questionnaire2.default.arrow}),_react2.default.createElement('p',null,'Help us improve this page by providing information about '+this.name+' to make this page more accurate and personalized.')),_react2.default.createElement(_Svgs.InfoIcon,null)),_react2.default.createElement('div',{className:_Questionnaire2.default.close,onClick:_lodash2.default.partial(this.handleClick,'close')},_react2.default.createElement(_Svgs.CloseXIcon,null))),_react2.default.createElement('div',{className:_Questionnaire2.default.content},this.state.showThankYou?_react2.default.createElement('div',{className:_Questionnaire2.default.thankYou},_react2.default.createElement(_Svgs.HeartIcon,null),_react2.default.createElement('p',{className:_Questionnaire2.default.header},'Thank You'),_react2.default.createElement('p',{className:_Questionnaire2.default.body},'Your answers will help make this page more accurate.')):_react2.default.createElement('div',{className:_Questionnaire2.default.question},this.questionType==='location'?_react2.default.createElement('span',{className:_Questionnaire2.default.count},count):null,_react2.default.createElement('p',null,this.getTemplatizedQuestionString(this.state.currentQuestion.question)),this.questionType==='location'?_react2.default.createElement('div',{className:_Questionnaire2.default.location},_react2.default.createElement(TextInput,{handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'entryField'),handleKeyUp:this.handleKeyUp,name:'entryField',placeholder:'Type '+this.cityState+' Name',ref:this.setRefEntryField,type:'text',value:this.state.entryField}),this.state.showSuggestion?_react2.default.createElement('aside',{className:_Questionnaire2.default.suggestedMatch,onClick:this.handleSuggestionClick},_react2.default.createElement('p',null,_react2.default.createElement(_Svgs.UGCSearchIcon,null),this.state.searchStringSuggestion)):null):null,this.questionType==='date'?_react2.default.createElement('div',{className:_Questionnaire2.default.dateBlock},_react2.default.createElement(TextInput,{className:_Questionnaire2.default.month,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'monthField'),name:'monthField',placeholder:'mm',ref:this.setRefMonthField,type:'tel',value:this.state.monthField}),_react2.default.createElement(TextInput,{className:_Questionnaire2.default.day,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'dayField'),id:'day',name:'dayField',placeholder:'dd',ref:this.setRefDayField,type:'tel',value:this.state.dayField}),_react2.default.createElement(TextInput,{className:_Questionnaire2.default.year,handleChange:_lodash2.default.partial(this.handleInputChange,_lodash2.default,'yearField'),id:'year',name:'yearField',placeholder:'yyyy',ref:this.setRefYearField,type:'tel',value:this.state.yearField})):null,_react2.default.createElement('div',{className:_Questionnaire2.default.buttonGroup},this.options.map(function(option,index){return option.label?_react2.default.createElement(Button,{btnType:'primary',className:_Questionnaire2.default.button,disabled:option.label==='Submit'&&_this8.state.isSubmitDisabled,handleClick:_lodash2.default.partial(_this8.handleClick,option.value),key:index},option.label):null;}))))):null;}}]);return Questionnaire;}(_react2.default.Component);/* istanbul ignore next */Questionnaire.propTypes={queryLocationSearch:_react2.default.PropTypes.func,mutatePersonUGC:_react2.default.PropTypes.func,personStore:_react2.default.PropTypes.object};var mapStateToProps=function mapStateToProps(state){return{personStore:_lodash2.default.get(state,'personStore')};};/* istanbul ignore next */var mapDispatchToProps=function mapDispatchToProps(dispatch){return{queryLocationSearch:function queryLocationSearch(searchParams){dispatch((0,_ugcHelper.queryLocationSearch)(searchParams));},mutatePersonUGC:function mutatePersonUGC(mutationParams){dispatch((0,_ugcHelper.mutatePersonUGC)(mutationParams));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps,null,{withRef:true})(Questionnaire);

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","Questionnaire":"Questionnaire","topRightLockup":"topRightLockup","infoIcon":"infoIcon","toolTip":"toolTip","arrow":"arrow","close":"close","thankYou":"thankYou","isOpen":"isOpen","SlideIn":"SlideIn","isClosed":"isClosed","SlideOut":"SlideOut","content":"content","question":"question","count":"count","buttonGroup":"buttonGroup","location":"location","suggestedMatch":"suggestedMatch","dateBlock":"dateBlock","month":"month","day":"day","year":"year","header":"header","body":"body"};

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mutatePersonUGC=exports.queryLocationSearch=exports.QUESTION_TYPES=exports.OPTIONS_TEMPLATE=undefined;var _seedHelperFn=__webpack_require__(623);var _seedHelperFn2=_interopRequireDefault(_seedHelperFn);var _queryTemplates=__webpack_require__(243);var _mutationTemplates=__webpack_require__(245);var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var OPTIONS_TEMPLATE=exports.OPTIONS_TEMPLATE={globalAction:null,yes:{position:2,value:'yes'},no:{position:1,value:'no'},skip:{position:3,value:'skip'}};var QUESTION_TYPES=exports.QUESTION_TYPES={validation:{},location:{group:[{required:'state'},{required:'city'}]}};/**
 * Fetches location information from graphQL
 * @param  {object}   queryParams parameter to add to the query template
 * @return {function} returns the function to make the fetch
 */var queryLocationSearch=exports.queryLocationSearch=(0,_seedHelperFn2.default)(_queryTemplates.LOCATION_SEARCH_TEMPLATE,'query',_actions.queryRequest,_actions.queryLocationSearchSuccess,_actions.queryFailure);/**
 * Posts person's ugc data to graphQL
 * @param  {object}   mutationParams parameter to add to the mutation template
 * @return {function} returns the function to make the fetch
 */var mutatePersonUGC=exports.mutatePersonUGC=(0,_seedHelperFn2.default)(_mutationTemplates.PERSON_UGC_MUTATION_TEMPLATE,'mutation',_actions.queryRequest,_actions.mutatePersonUGCSuccess,_actions.mutatePersonUGCFailure);

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(){return _lodash2.default.merge({ugc_did_you_know:{type:'validation',question:'Did you know <%= name %>?',options:{yes:{label:'Yes',action:'ugc_where_validate'},no:{label:'No'},skip:{label:'Not Sure',action:'ugc_where_validate'}}}},_validation2.default,_dates2.default,_location2.default);};var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _validation=__webpack_require__(1695);var _validation2=_interopRequireDefault(_validation);var _location=__webpack_require__(1696);var _location2=_interopRequireDefault(_location);var _dates=__webpack_require__(1697);var _dates2=_interopRequireDefault(_dates);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports = {
	"ugc_where_validate": {
		"type": "validation",
		"dependencies": {
			"required": "location",
			"fallback": "ugc_where"
		},
		"question": "Were they from <%= location %>?",
		"options": {
			"yes": {
				"label": "Yes",
				"action": "ugc_dob"
			},
			"no": {
				"label": "No",
				"action": "ugc_where"
			},
			"skip": {
				"label": "Not Sure",
				"action": "ugc_dob"
			}
		}
	}
};

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

module.exports = {
	"ugc_where": {
		"type": "location",
		"question": "What <%= cityState %> were they from?",
		"options": {
			"globalAction": "ugc_dob",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	},
	"ugc_location_born": {
		"type": "location",
		"question": "What <%= cityState %> were they born?",
		"options": {
			"globalAction": "ugc_location_hometown",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	},
	"ugc_location_hometown": {
		"type": "location",
		"question": "What <%= cityState %> was their hometown?",
		"options": {
			"globalAction": "ugc_location_college",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	},
	"ugc_location_college": {
		"type": "location",
		"question": "What <%= cityState %> did they attend college?",
		"options": {
			"globalAction": "ugc_location_most_time",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	},
	"ugc_location_most_time": {
		"type": "location",
		"question": "What <%= cityState %> did they spend most of their time?",
		"options": {
			"globalAction": "ugc_location_died",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	},
	"ugc_location_died": {
		"type": "location",
		"question": "What <%= cityState %> did they pass away?",
		"options": {
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	}
};

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

module.exports = {
	"ugc_dob": {
		"type": "date",
		"question": "When were they born?",
		"options": {
			"globalAction": "ugc_dod",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	},
	"ugc_dod": {
		"type": "date",
		"question": "When did they pass away?",
		"options": {
			"globalAction": "ugc_location_born",
			"yes": {
				"position": 2,
				"label": "Submit"
			},
			"skip": {
				"position": 1,
				"label": "Not Sure"
			}
		}
	}
};

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.orderObjectList=orderObjectList;exports.createGetObjectByKey=createGetObjectByKey;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Order ObjectList based on the order provided
 * @param  {Array} objectList Array of Objects
 * @param  {Array} orderArray Array of the order
 * @param  {Function} getObjectByKey Function to pluck out an object from the list
 * @return {Array} Ordered Array of Objects
 */function orderObjectList(objectList,orderArray,getObjectByKey){var orderedObjects=null;if(orderArray&&orderArray.length>0&&_lodash2.default.isFunction(getObjectByKey)){orderedObjects=[];_lodash2.default.each(orderArray,function(orderKey){return orderedObjects.push(getObjectByKey(orderKey,objectList));});}else{orderedObjects=_lodash2.default.cloneDeep(objectList);}return orderedObjects;}/**
 * Get a function that returns back an object from a list based on the passed in key matching the objectKey
 * @param  {String} objKey The object key
 * @return {Function} Returns the function to find the object
 */function createGetObjectByKey(objKey){/**
   * The returned function
   * @param  {String} orderKey The key that needs to be found
   * @param  {Array} objectList The list of objects to filter
   * @return {Object} The found object
   */return function(orderKey,objectList){var retObject=null;if(orderKey&&objectList){var filteredObjectList=objectList.filter(function(obj){return obj[objKey]===orderKey;});retObject=filteredObjectList.length>0?_lodash2.default.cloneDeep(_lodash2.default.head(filteredObjectList)):{};}else{retObject={};}return retObject;};}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(155);var _reduxThunk=__webpack_require__(1700);var _reduxThunk2=_interopRequireDefault(_reduxThunk);var _combinedReducers=__webpack_require__(1701);var _combinedReducers2=_interopRequireDefault(_combinedReducers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var configureStore=function configureStore(){var initialState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var enhancers=[(0,_redux.applyMiddleware)(_reduxThunk2.default)];// If Redux DevTools Extension is installed use it, otherwise use Redux compose
var composeEnhancers=typeof window!=='undefined'&&window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||_redux.compose;var store=(0,_redux.createStore)(_combinedReducers2.default,initialState,composeEnhancers.apply(undefined,enhancers));return store;};/* eslint-disable require-jsdoc */exports.default=configureStore;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(155);var _adStore=__webpack_require__(1702);var _adStore2=_interopRequireDefault(_adStore);var _affiliateStore=__webpack_require__(1703);var _affiliateStore2=_interopRequireDefault(_affiliateStore);var _errorStore=__webpack_require__(1704);var _errorStore2=_interopRequireDefault(_errorStore);var _footerStore=__webpack_require__(1705);var _footerStore2=_interopRequireDefault(_footerStore);var _funeralHomeStore=__webpack_require__(1706);var _funeralHomeStore2=_interopRequireDefault(_funeralHomeStore);var _nearbyFuneralHomesStore=__webpack_require__(1707);var _nearbyFuneralHomesStore2=_interopRequireDefault(_nearbyFuneralHomesStore);var _headerStore=__webpack_require__(1708);var _headerStore2=_interopRequireDefault(_headerStore);var _mobileDetailsStore=__webpack_require__(1709);var _mobileDetailsStore2=_interopRequireDefault(_mobileDetailsStore);var _obituaryStore=__webpack_require__(1710);var _obituaryStore2=_interopRequireDefault(_obituaryStore);var _personStore=__webpack_require__(1711);var _personStore2=_interopRequireDefault(_personStore);var _planningStore=__webpack_require__(1712);var _planningStore2=_interopRequireDefault(_planningStore);var _searchFuneralHomesStore=__webpack_require__(1713);var _searchFuneralHomesStore2=_interopRequireDefault(_searchFuneralHomesStore);var _tabStore=__webpack_require__(1714);var _tabStore2=_interopRequireDefault(_tabStore);var _upcomingServicesStore=__webpack_require__(1715);var _upcomingServicesStore2=_interopRequireDefault(_upcomingServicesStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_redux.combineReducers)({adStore:_adStore2.default,affiliateStore:_affiliateStore2.default,errorStore:_errorStore2.default,footerStore:_footerStore2.default,funeralHomeStore:_funeralHomeStore2.default,nearbyFuneralHomesStore:_nearbyFuneralHomesStore2.default,headerStore:_headerStore2.default,mobileDetailsStore:_mobileDetailsStore2.default,obituaryStore:_obituaryStore2.default,personStore:_personStore2.default,planningStore:_planningStore2.default,searchFuneralHomesStore:_searchFuneralHomesStore2.default,tabIndexStore:_tabStore2.default,upcomingServicesStore:_upcomingServicesStore2.default});

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=adStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Updates the ad store section of the state tree
 * @method  adStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function adStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.AD_SERVICE:return(0,_extends3.default)({},state,action.data);default:return state;}}

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=affiliateStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * @method  affiliateStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function affiliateStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.AFFILIATE_STORE:return(0,_extends3.default)({},action.data);default:return state;}}

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=errorStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Updates the error store section of the state tree
 * @method  errorStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function errorStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.ERROR:return(0,_extends3.default)({},action.data);default:return state;}}

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=footerStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Updates the footer store section of the state tree
 * @method  footerStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function footerStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.FOOTER_STORE:return(0,_extends3.default)({},action.data);default:return state;}}

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=funeralHomeStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Updates the funeral home store section of the state tree
 * TODO: We do not yet know the nature of the funeral home store to
 * support the funeral home profile. It is likely very simple but
 * given the Load More obits on the page we will need to support that in
 * this or a related store.
 * @method  funeralHomeStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function funeralHomeStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.FUNERAL_HOME_STORE:return(0,_extends3.default)({},state,action.data);default:return state;}}/* eslint no-warning-comments:0 */

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=nearbyFuneralHomesStore;var _actions=__webpack_require__(37);/**
 * @method  nearbyFuneralHomesStore
 * @param   {array} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function nearbyFuneralHomesStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _actions.NEARBY_FUNERAL_HOMES_STORE:return action.data;default:return state;}}

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=headerStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Updates the header store section of the state tree
 * @method  headerStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function headerStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.HEADER_STORE:return(0,_extends3.default)({},action.data);default:return state;}}

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=mobileDetailsStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Updates the ad store section of the state tree
 * @method  mobileDetailsStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function mobileDetailsStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.MOBILE_DETAILS:return(0,_extends3.default)({},action.data);default:return state;}}

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.error=exports.showLoadMoreButton=exports.page=exports.people=exports.loading=undefined;var _toConsumableArray2=__webpack_require__(365);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _actions=__webpack_require__(37);var _redux=__webpack_require__(155);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var hasMoreItemsToShow=function hasMoreItemsToShow(requestItemCount,responseItemCount){return requestItemCount<=responseItemCount;};var loading=exports.loading=function loading(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _actions.OBITUARIES_REQUEST:return true;case _actions.OBITUARIES_ERROR:case _actions.OBITUARIES_SUCCESS:return false;default:return state;}};var people=exports.people=function people(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];var peopleWithObituaries=_lodash2.default.get(action,'response.data.funeralHomeObituaries.people')||[];switch(action.type){case _actions.OBITUARIES_SUCCESS:return[].concat((0,_toConsumableArray3.default)(state),(0,_toConsumableArray3.default)(peopleWithObituaries));default:return state;}};var page=exports.page=function page(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var action=arguments[1];switch(action.type){case _actions.OBITUARIES_SUCCESS:return state+1;default:return state;}};var showLoadMoreButton=exports.showLoadMoreButton=function showLoadMoreButton(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var action=arguments[1];switch(action.type){case _actions.OBITUARIES_SUCCESS:var peopleWithObituaries=_lodash2.default.get(action,'response.data.funeralHomeObituaries.people')||[];return hasMoreItemsToShow(action.count,peopleWithObituaries.length);case _actions.OBITUARIES_ERROR:return false;default:return state;}};var error=exports.error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.OBITUARIES_REQUEST:case _actions.OBITUARIES_SUCCESS:return{};case _actions.OBITUARIES_ERROR:return action.error;default:return state;}};exports.default=(0,_redux.combineReducers)({loading:loading,people:people,page:page,showLoadMoreButton:showLoadMoreButton,error:error});

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(365);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _assign=__webpack_require__(220);var _assign2=_interopRequireDefault(_assign);exports.default=personStore;var _lodash=__webpack_require__(8);var _lodash2=_interopRequireDefault(_lodash);var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Updates the person store section of the state tree
 * @method  personStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 *//* eslint-disable no-console*/function personStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{loading:false};var action=arguments[1];if(_lodash2.default.isNil(_lodash2.default.get(action,'type'))){return state;}switch(action.type){/* query reducers */case _actions.QUERY_REQUEST:return(0,_assign2.default)({},state,{loading:true});case _actions.QUERY_FAILURE:console.log('a query failure has occured...',action.reason);return(0,_assign2.default)({},state,{loading:false});case _actions.QUERY_CONDOLENCES_SUCCESS:if(!action.response){return state;}var newCondolencesState=_lodash2.default.cloneDeep(state);var previousCondolences=_lodash2.default.get(newCondolencesState,'person.guestBook.condolences.edges');var newCondolences=_lodash2.default.get(action,'response.data.guestBooks.condolences.edges');var newPageInfo={startCursor:_lodash2.default.get(action,'response.data.guestBooks.condolences.pageInfo.startCursor'),endCursor:_lodash2.default.get(action,'response.data.guestBooks.condolences.pageInfo.endCursor'),hasNextPage:_lodash2.default.get(action,'response.data.guestBooks.condolences.pageInfo.hasNextPage'),hasPreviousPage:_lodash2.default.get(action,'response.data.guestBooks.condolences.pageInfo.hasPreviousPage')};_lodash2.default.set(newCondolencesState,'person.guestBook.condolences.edges',[].concat((0,_toConsumableArray3.default)(previousCondolences),(0,_toConsumableArray3.default)(newCondolences)));_lodash2.default.set(newCondolencesState,'person.guestBook.condolences.pageInfo',newPageInfo);_lodash2.default.set(newCondolencesState,'loading',false);return newCondolencesState;case _actions.QUERY_GALLERY_SUCCESS:if(!action.response){return state;}var newGalleryState=_lodash2.default.cloneDeep(state);var previousGallery=_lodash2.default.get(newGalleryState,'person.guestBookGallery.condolences.edges',[]);var newGallery=_lodash2.default.get(action,'response.data.guestBookGallery.condolences.edges');var previousStartCursor=_lodash2.default.get(newGalleryState,'person.guestBookGallery.condolences.pageInfo.startCursor');var newStartCursor=_lodash2.default.get(action,'response.data.guestBookGallery.condolences.pageInfo.startCursor');if(previousStartCursor!==newStartCursor){var galleryPageInfo={startCursor:newStartCursor,endCursor:_lodash2.default.get(action,'response.data.guestBookGallery.condolences.pageInfo.endCursor'),hasNextPage:_lodash2.default.get(action,'response.data.guestBookGallery.condolences.pageInfo.hasNextPage'),hasPreviousPage:_lodash2.default.get(action,'response.data.guestBookGallery.condolences.pageInfo.hasPreviousPage')};_lodash2.default.set(newGalleryState,'person.guestBookGallery.condolences.edges',[].concat((0,_toConsumableArray3.default)(previousGallery),(0,_toConsumableArray3.default)(newGallery)));_lodash2.default.set(newGalleryState,'person.guestBookGallery.condolences.pageInfo',galleryPageInfo);}_lodash2.default.set(newGalleryState,'loading',false);return newGalleryState;/* mutation reducers */case _actions.MUTATION_REQUEST:return(0,_assign2.default)({},state,{loading:true});case _actions.MUTATION_FAILURE:console.log('a mutation failure has occured...',action.reason);var failureState=_lodash2.default.cloneDeep(state);_lodash2.default.set(failureState,'loading',false);_lodash2.default.set(failureState,'mutationStatus.condolence',0);return failureState;case _actions.RESET_MUTATION_STATUS:var resetState=_lodash2.default.cloneDeep(state);_lodash2.default.set(resetState,'loading',false);_lodash2.default.set(resetState,'mutationStatus.condolence',null);return resetState;case _actions.MUTATE_CONDOLENCE_SUCCESS:if(!action.response){return state;}var newCondolenceState=_lodash2.default.cloneDeep(state);if(_lodash2.default.get(action,'response.data.addCondolence.addCondolenceResponse.entryId')){_lodash2.default.set(newCondolenceState,'mutationStatus.condolence',action.response.data.addCondolence.addCondolenceResponse.entryId);}else{_lodash2.default.set(newCondolenceState,'mutationStatus.condolence',0);}return newCondolenceState;case _actions.MUTATE_PERSON_ALERT_SUCCESS:if(!action.response){return state;}var newAlertState=_lodash2.default.cloneDeep(state);if(_lodash2.default.get(action,'response.data.addPersonAlert.addAlertResponse.alertId')){_lodash2.default.set(newAlertState,'mutationStatus.alert',action.response.data.addPersonAlert.addAlertResponse.alertId);}else{_lodash2.default.set(newAlertState,'mutationStatus.alert',0);}return newAlertState;case _actions.MUTATE_PERSON_ALERT_FAILURE:console.log('a person alert mutation failure has occured...',action.reason);return state;/* istanbul ignore next */// not currently used
case _actions.QUERY_LOCATION_SEARCH_SUCCESS:if(!action.response){return state;}var newLocationSearchState=_lodash2.default.cloneDeep(state);var result=_lodash2.default.get(action,'response.data.locationSearch');_lodash2.default.set(newLocationSearchState,'locationSearch',result);return newLocationSearchState;/* istanbul ignore next */// not currently used
case _actions.MUTATE_PERSON_UGC_SUCCESS:console.log('UCG mutation success',action.response);return state;/* istanbul ignore next */// not currently used
case _actions.MUTATE_PERSON_UGC_FAILURE:console.log('UGC mutation failure...',action.reason);return state;case _actions.MUTATE_LIKES_SUCCESS:if(!action.response){return state;}var newLikeState=_lodash2.default.cloneDeep(state);var id=_lodash2.default.get(action,'response.data.incrementCondolenceLike.incrementCondolenceLikeResponse.condolenceId');var count=_lodash2.default.get(action,'response.data.incrementCondolenceLike.incrementCondolenceLikeResponse.likes');var condolences=_lodash2.default.get(newLikeState,'person.guestBook.condolences.edges',[]);var condolenceIndex=_lodash2.default.findIndex(condolences,function(item){return item.node.condolenceId===id;});if(condolenceIndex!==-1){_lodash2.default.set(newLikeState,'person.guestBook.condolences.edges['+condolenceIndex+'].node.likes',count);}return newLikeState;case _actions.MUTATE_LIKES_FAILURE:return state;case _actions.PERSON_STORE_HYDRATION:return(0,_extends3.default)({},action.data);default:return state;}}

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SET_GUIDE_VERSION=undefined;var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=planningStore;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint no-unused-vars:0 */var SET_GUIDE_VERSION=exports.SET_GUIDE_VERSION='SET_GUIDE_VERSION';/**
 * Updates the planning store section of the state tree
 * @method  planningStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */var initialState={isPlanning:false};/**
 * Updates the planning store section of the state tree
 * @method  planningStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function planningStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'PLANNING_TOKEN_EXISTS':return(0,_extends3.default)({},state,{isPlanning:action.planningExists===true});case SET_GUIDE_VERSION:return(0,_extends3.default)({},state,{guideVersion:action.guideVersion,funeralHomeZipcode:action.funeralHomeZipcode});default:return state;}}

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=searchFuneralHomesStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Updates the funeral homes search store section of the state tree
 * TODO: We do not yet know the nature of the funeral homes store to
 * support faceted search
 * @method  searchFuneralHomesStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function searchFuneralHomesStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.SEARCH_FUNERAL_HOMES:return(0,_extends3.default)({},action.data);default:return state;}}/* eslint no-warning-comments:0 */

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(220);var _assign2=_interopRequireDefault(_assign);exports.default=tabIndexStore;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint no-unused-vars:0 */var initialState={tabIndex:2};/**
 * Updates the tabIndexStore section of the state tree
 * @method  tabIndexStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function tabIndexStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_TAB_INDEX':return(0,_assign2.default)({},state,{tabIndex:action.tab.tabIndex});default:return state;}}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(27);var _extends3=_interopRequireDefault(_extends2);exports.default=upcomingServicesStore;var _actions=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * @method  upcomingServicesStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */function upcomingServicesStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actions.UPCOMING_SERVICES_STORE:return(0,_extends3.default)({},action.data);default:return state;}}

/***/ })
],[632]);


// WEBPACK FOOTER //
// assets/js/app.15af1a3385eece94b6e1.js